import * as React from 'react';
import React__default, { useContext, useState, useRef, useEffect, useReducer, useLayoutEffect, Component, memo, createElement, Fragment, useMemo, forwardRef, createContext, useCallback, isValidElement, cloneElement } from 'react';
import ReactDOM, { render as render$1 } from 'react-dom';
import PropTypes from 'prop-types';

function _typeof$3(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$3 = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof$3 = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$3(obj);
}

function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread$7(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$5(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var _typeof_1 = createCommonjsModule(function (module) {
function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };

    module.exports["default"] = module.exports, module.exports.__esModule = true;
  }

  return _typeof(obj);
}

module.exports = _typeof;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _typeof$2 = unwrapExports(_typeof_1);

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (_typeof$2(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

function _getPrototypeOf$1(o) {
  _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf$1(o);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck$2(this, Logger);

    this.init(concreteLogger, options);
  }

  _createClass$2(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$7({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck$2(this, EventEmitter);

    this.observers = {};
  }

  _createClass$2(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

var ResourceStore = function (_EventEmitter) {
  _inherits$1(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    _classCallCheck$2(this, ResourceStore);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(ResourceStore).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    return _this;
  }

  _createClass$2(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      return getPath(this.data, path);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$7({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$7({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits$1(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck$2(this, Translator);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(Translator).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }

    copy(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized$1(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  _createClass$2(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (_typeof$3(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$7({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var hasDefaultValue = Translator.hasDefaultValue(options);
        var defaultValueSuffix = needsPluralHandling ? this.pluralResolver.getSuffix(lng, options.count) : '';
        var defaultValue = options["defaultValue".concat(defaultValueSuffix)] || options.defaultValue;

        if (!this.isValidLookup(res) && hasDefaultValue) {
          usedDefault = true;
          res = defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var updateMissing = hasDefaultValue && defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$7({}, options, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k, fallbackValue) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? fallbackValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (language) {
                _this2.pluralResolver.getSuffixes(language).forEach(function (suffix) {
                  send([language], key + suffix, options["defaultValue".concat(suffix)] || defaultValue);
                });
              });
            } else {
              send(lngs, key, defaultValue);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$7({}, options, {
          interpolation: _objectSpread$7({}, this.options.interpolation, options.interpolation)
        }));
        var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$7({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$7({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }], [{
    key: "hasDefaultValue",
    value: function hasDefaultValue(options) {
      var prefix = 'defaultValue';

      for (var option in options) {
        if (Object.prototype.hasOwnProperty.call(options, option) && prefix === option.substring(0, prefix.length) && undefined !== options[option]) {
          return true;
        }
      }

      return false;
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck$2(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.supportedLngs || false;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  _createClass$2(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
      return this.isSupportedCode(code);
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'tl', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck$2(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  _createClass$2(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      return this.getSuffixes(code).map(function (suffix) {
        return key + suffix;
      });
    }
  }, {
    key: "getSuffixes",
    value: function getSuffixes(code) {
      var _this = this;

      var rule = this.getRule(code);

      if (!rule) {
        return [];
      }

      return rule.numbers.map(function (number) {
        return _this.getSuffix(code, number);
      });
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        };

        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck$2(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  _createClass$2(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, options);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          value = handleFormat(match[1].trim());

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          str = str.replace(match[0], todo.safeValue(value));
          todo.regex.lastIndex = 0;
          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$7({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$7({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, options);
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove$4(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits$1(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck$2(this, Connector);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(Connector).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  _createClass$2(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove$4(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$7({}, options, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    whitelist: false,
    nonExplicitWhitelist: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof$3(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (_typeof$3(args[2]) === 'object' || _typeof$3(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: false
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.whitelist) {
    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
      options.whitelist = options.whitelist.concat(['cimode']);
    }

    options.supportedLngs = options.whitelist;
  }

  if (options.nonExplicitWhitelist) {
    options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
  }

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function noop$1() {}

var I18n = function (_EventEmitter) {
  _inherits$1(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck$2(this, I18n);

    _this = _possibleConstructorReturn$1(this, _getPrototypeOf$1(I18n).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn$1(_this, _assertThisInitialized$1(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  _createClass$2(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (options.whitelist && !options.supportedLngs) {
        this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
      }

      if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) {
        this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
      }

      this.options = _objectSpread$7({}, get(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop$1;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        var finish = function finish(err, t) {
          if (_this2.isInitialized) _this2.logger.warn('init: i18next is already initialized. You should call init just once!');
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        };

        if (_this2.languages && _this2.options.compatibilityAPI !== 'v1' && !_this2.isInitialized) return finish(null, _this2.t.bind(_this2));

        _this2.changeLanguage(_this2.options.lng, finish);
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop$1;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (_typeof$3(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$7({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;

      var mergedOptions = _objectSpread$7({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$7({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

var objectWithoutPropertiesLoose = createCommonjsModule(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(objectWithoutPropertiesLoose);

var objectWithoutProperties = createCommonjsModule(function (module) {
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _objectWithoutProperties$2 = unwrapExports(objectWithoutProperties);

var defineProperty = createCommonjsModule(function (module) {
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

module.exports = _defineProperty;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _defineProperty$4 = unwrapExports(defineProperty);

/**
 * This file automatically generated from `pre-publish.js`.
 * Do not manually edit.
 */

var voidElements = {
  "area": true,
  "base": true,
  "br": true,
  "col": true,
  "embed": true,
  "hr": true,
  "img": true,
  "input": true,
  "link": true,
  "meta": true,
  "param": true,
  "source": true,
  "track": true,
  "wbr": true
};

var t$1=/\s([^'"/\s><]+?)[\s/>]|([^\s=]+)=\s?(".*?"|'.*?')/g;function n$1(n){var r={type:"tag",name:"",voidElement:!1,attrs:{},children:[]},i=n.match(/<\/?([^\s]+?)[/\s>]/);if(i&&(r.name=i[1],(voidElements[i[1]]||"/"===n.charAt(n.length-2))&&(r.voidElement=!0),r.name.startsWith("!--"))){var s=n.indexOf("--\x3e");return {type:"comment",comment:-1!==s?n.slice(4,s):""}}for(var a=new RegExp(t$1),c=null;null!==(c=a.exec(n));)if(c[0].trim())if(c[1]){var o=c[1].trim(),l=[o,""];o.indexOf("=")>-1&&(l=o.split("=")),r.attrs[l[0]]=l[1],a.lastIndex--;}else c[2]&&(r.attrs[c[2]]=c[3].trim().substring(1,c[3].length-1));return r}var r=/<[a-zA-Z0-9\-\!\/](?:"[^"]*"|'[^']*'|[^'">])*>/g,i$2=/^\s*$/,s$1=Object.create(null);function a$1(e,t){switch(t.type){case"text":return e+t.content;case"tag":return e+="<"+t.name+(t.attrs?function(e){var t=[];for(var n in e)t.push(n+'="'+e[n]+'"');return t.length?" "+t.join(" "):""}(t.attrs):"")+(t.voidElement?"/>":">"),t.voidElement?e:e+t.children.reduce(a$1,"")+"</"+t.name+">";case"comment":return e+"\x3c!--"+t.comment+"--\x3e"}}var c$2={parse:function(e,t){t||(t={}),t.components||(t.components=s$1);var a,c=[],o=[],l=-1,m=!1;if(0!==e.indexOf("<")){var u=e.indexOf("<");c.push({type:"text",content:-1===u?e:e.substring(0,u)});}return e.replace(r,function(r,s){if(m){if(r!=="</"+a.name+">")return;m=!1;}var u,f="/"!==r.charAt(1),h=r.startsWith("\x3c!--"),p=s+r.length,d=e.charAt(p);if(h){var v=n$1(r);return l<0?(c.push(v),c):((u=o[l]).children.push(v),c)}if(f&&(l++,"tag"===(a=n$1(r)).type&&t.components[a.name]&&(a.type="component",m=!0),a.voidElement||m||!d||"<"===d||a.children.push({type:"text",content:e.slice(p,e.indexOf("<",p))}),0===l&&c.push(a),(u=o[l-1])&&u.children.push(a),o[l]=a),(!f||a.voidElement)&&(l>-1&&(a.voidElement||a.name===r.slice(2,-1))&&(l--,a=-1===l?c:o[l]),!m&&"<"!==d&&d)){u=-1===l?c:o[l].children;var x=e.indexOf("<",p),g=e.slice(p,-1===x?void 0:x);i$2.test(g)&&(g=" "),(x>-1&&l+u.length>=0||" "!==g)&&u.push({type:"text",content:g});}}),c},stringify:function(e){return e.reduce(function(e,t){return e+a$1("",t)},"")}};

var classCallCheck = createCommonjsModule(function (module) {
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _classCallCheck$1 = unwrapExports(classCallCheck);

var createClass = createCommonjsModule(function (module) {
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _createClass$1 = unwrapExports(createClass);

function ownKeys$6(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$6(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$6(Object(source), true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$6(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultOptions$1 = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transWrapTextNodes: '',
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true
};
var i18nInstance;
var I18nContext = React__default.createContext();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions$1 = _objectSpread$6(_objectSpread$6({}, defaultOptions$1), options);
}
function getDefaults() {
  return defaultOptions$1;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck$1(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  _createClass$1(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

function warn$1() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn$1.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}
function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

function ownKeys$5(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$5(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$5(Object(source), true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$5(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function hasChildren$1(node, checkLength) {
  if (!node) return false;
  var base = node.props ? node.props.children : node.children;
  if (checkLength) return base.length > 0;
  return !!base;
}

function getChildren(node) {
  if (!node) return [];
  return node && node.children ? node.children : node.props && node.props.children;
}

function hasValidReactChildren(children) {
  if (Object.prototype.toString.call(children) !== '[object Array]') return false;
  return children.every(function (child) {
    return React__default.isValidElement(child);
  });
}

function getAsArray(data) {
  return Array.isArray(data) ? data : [data];
}

function mergeProps(source, target) {
  var newTarget = _objectSpread$5({}, target);

  newTarget.props = Object.assign(source.props, target.props);
  return newTarget;
}

function nodesToString(children, i18nOptions) {
  if (!children) return '';
  var stringNode = '';
  var childrenArray = getAsArray(children);
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  childrenArray.forEach(function (child, childIndex) {
    if (typeof child === 'string') {
      stringNode += "".concat(child);
    } else if (React__default.isValidElement(child)) {
      var childPropsCount = Object.keys(child.props).length;
      var shouldKeepChild = keepArray.indexOf(child.type) > -1;
      var childChildren = child.props.children;

      if (!childChildren && shouldKeepChild && childPropsCount === 0) {
        stringNode += "<".concat(child.type, "/>");
      } else if (!childChildren && (!shouldKeepChild || childPropsCount !== 0)) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (child.props.i18nIsDynamicList) {
        stringNode += "<".concat(childIndex, "></").concat(childIndex, ">");
      } else if (shouldKeepChild && childPropsCount === 1 && typeof childChildren === 'string') {
        stringNode += "<".concat(child.type, ">").concat(childChildren, "</").concat(child.type, ">");
      } else {
        var content = nodesToString(childChildren, i18nOptions);
        stringNode += "<".concat(childIndex, ">").concat(content, "</").concat(childIndex, ">");
      }
    } else if (child === null) {
      warn$1("Trans: the passed in value is invalid - seems you passed in a null child.");
    } else if (_typeof$2(child) === 'object') {
      var format = child.format,
          clone = _objectWithoutProperties$2(child, ["format"]);

      var keys = Object.keys(clone);

      if (keys.length === 1) {
        var value = format ? "".concat(keys[0], ", ").concat(format) : keys[0];
        stringNode += "{{".concat(value, "}}");
      } else {
        warn$1("react-i18next: the passed in object contained more than one variable - the object should look like {{ value, format }} where format is optional.", child);
      }
    } else {
      warn$1("Trans: the passed in value is invalid - seems you passed in a variable like {number} - please pass in variables for interpolation as full objects like {{number}}.", child);
    }
  });
  return stringNode;
}

function renderNodes(children, targetString, i18n, i18nOptions, combinedTOpts) {
  if (targetString === '') return [];
  var keepArray = i18nOptions.transKeepBasicHtmlNodesFor || [];
  var emptyChildrenButNeedsHandling = targetString && new RegExp(keepArray.join('|')).test(targetString);
  if (!children && !emptyChildrenButNeedsHandling) return [targetString];
  var data = {};

  function getData(childs) {
    var childrenArray = getAsArray(childs);
    childrenArray.forEach(function (child) {
      if (typeof child === 'string') return;
      if (hasChildren$1(child)) getData(getChildren(child));else if (_typeof$2(child) === 'object' && !React__default.isValidElement(child)) Object.assign(data, child);
    });
  }

  getData(children);
  var interpolatedString = i18n.services.interpolator.interpolate(targetString, _objectSpread$5(_objectSpread$5({}, data), combinedTOpts), i18n.language);
  var ast = c$2.parse("<0>".concat(interpolatedString, "</0>"));

  function renderInner(child, node, rootReactNode) {
    var childs = getChildren(child);
    var mappedChildren = mapAST(childs, node.children, rootReactNode);
    return hasValidReactChildren(childs) && mappedChildren.length === 0 ? childs : mappedChildren;
  }

  function pushTranslatedJSX(child, inner, mem, i, isVoid) {
    if (child.dummy) child.children = inner;
    mem.push(React__default.cloneElement(child, _objectSpread$5(_objectSpread$5({}, child.props), {}, {
      key: i
    }), isVoid ? undefined : inner));
  }

  function mapAST(reactNode, astNode, rootReactNode) {
    var reactNodes = getAsArray(reactNode);
    var astNodes = getAsArray(astNode);
    return astNodes.reduce(function (mem, node, i) {
      var translationContent = node.children && node.children[0] && node.children[0].content;

      if (node.type === 'tag') {
        var tmp = reactNodes[parseInt(node.name, 10)];
        if (!tmp && rootReactNode.length === 1 && rootReactNode[0][node.name]) tmp = rootReactNode[0][node.name];
        if (!tmp) tmp = {};
        var child = Object.keys(node.attrs).length !== 0 ? mergeProps({
          props: node.attrs
        }, tmp) : tmp;
        var isElement = React__default.isValidElement(child);
        var isValidTranslationWithChildren = isElement && hasChildren$1(node, true) && !node.voidElement;
        var isEmptyTransWithHTML = emptyChildrenButNeedsHandling && _typeof$2(child) === 'object' && child.dummy && !isElement;
        var isKnownComponent = _typeof$2(children) === 'object' && children !== null && Object.hasOwnProperty.call(children, node.name);

        if (typeof child === 'string') {
          mem.push(child);
        } else if (hasChildren$1(child) || isValidTranslationWithChildren) {
            var inner = renderInner(child, node, rootReactNode);
            pushTranslatedJSX(child, inner, mem, i);
          } else if (isEmptyTransWithHTML) {
          var _inner = mapAST(reactNodes, node.children, rootReactNode);

          mem.push(React__default.cloneElement(child, _objectSpread$5(_objectSpread$5({}, child.props), {}, {
            key: i
          }), _inner));
        } else if (Number.isNaN(parseFloat(node.name))) {
          if (isKnownComponent) {
            var _inner2 = renderInner(child, node, rootReactNode);

            pushTranslatedJSX(child, _inner2, mem, i, node.voidElement);
          } else if (i18nOptions.transSupportBasicHtmlNodes && keepArray.indexOf(node.name) > -1) {
            if (node.voidElement) {
              mem.push(React__default.createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }));
            } else {
              var _inner3 = mapAST(reactNodes, node.children, rootReactNode);

              mem.push(React__default.createElement(node.name, {
                key: "".concat(node.name, "-").concat(i)
              }, _inner3));
            }
          } else if (node.voidElement) {
            mem.push("<".concat(node.name, " />"));
          } else {
            var _inner4 = mapAST(reactNodes, node.children, rootReactNode);

            mem.push("<".concat(node.name, ">").concat(_inner4, "</").concat(node.name, ">"));
          }
        } else if (_typeof$2(child) === 'object' && !isElement) {
          var content = node.children[0] ? translationContent : null;
          if (content) mem.push(content);
        } else if (node.children.length === 1 && translationContent) {
          mem.push(React__default.cloneElement(child, _objectSpread$5(_objectSpread$5({}, child.props), {}, {
            key: i
          }), translationContent));
        } else {
          mem.push(React__default.cloneElement(child, _objectSpread$5(_objectSpread$5({}, child.props), {}, {
            key: i
          })));
        }
      } else if (node.type === 'text') {
        var wrapTextNodes = i18nOptions.transWrapTextNodes;

        if (wrapTextNodes) {
          mem.push(React__default.createElement(wrapTextNodes, {
            key: "".concat(node.name, "-").concat(i)
          }, node.content));
        } else {
          mem.push(node.content);
        }
      }

      return mem;
    }, []);
  }

  var result = mapAST([{
    dummy: true,
    children: children
  }], ast, getAsArray(children || []));
  return getChildren(result[0]);
}

function Trans(_ref) {
  var children = _ref.children,
      count = _ref.count,
      parent = _ref.parent,
      i18nKey = _ref.i18nKey,
      _ref$tOptions = _ref.tOptions,
      tOptions = _ref$tOptions === void 0 ? {} : _ref$tOptions,
      values = _ref.values,
      defaults = _ref.defaults,
      components = _ref.components,
      ns = _ref.ns,
      i18nFromProps = _ref.i18n,
      tFromProps = _ref.t,
      additionalProps = _objectWithoutProperties$2(_ref, ["children", "count", "parent", "i18nKey", "tOptions", "values", "defaults", "components", "ns", "i18n", "t"]);

  var _ref2 = useContext(I18nContext) || {},
      i18nFromContext = _ref2.i18n,
      defaultNSFromContext = _ref2.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using i18nextReactModule');
    return children;
  }

  var t = tFromProps || i18n.t.bind(i18n) || function (k) {
    return k;
  };

  var reactI18nextOptions = _objectSpread$5(_objectSpread$5({}, getDefaults()), i18n.options && i18n.options.react);

  var namespaces = ns || t.ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  var defaultValue = defaults || nodesToString(children, reactI18nextOptions) || reactI18nextOptions.transEmptyNodeValue || i18nKey;
  var hashTransKey = reactI18nextOptions.hashTransKey;
  var key = i18nKey || (hashTransKey ? hashTransKey(defaultValue) : defaultValue);
  var interpolationOverride = values ? tOptions.interpolation : {
    interpolation: _objectSpread$5(_objectSpread$5({}, tOptions.interpolation), {}, {
      prefix: '#$?',
      suffix: '?$#'
    })
  };

  var combinedTOpts = _objectSpread$5(_objectSpread$5(_objectSpread$5(_objectSpread$5({}, tOptions), {}, {
    count: count
  }, values), interpolationOverride), {}, {
    defaultValue: defaultValue,
    ns: namespaces
  });

  var translation = key ? t(key, combinedTOpts) : defaultValue;
  var content = renderNodes(components || children, translation, i18n, reactI18nextOptions, combinedTOpts);
  var useAsParent = parent !== undefined ? parent : reactI18nextOptions.defaultTransParent;
  return useAsParent ? React__default.createElement(useAsParent, additionalProps, content) : content;
}

var arrayWithHoles = createCommonjsModule(function (module) {
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

module.exports = _arrayWithHoles;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(arrayWithHoles);

var iterableToArrayLimit = createCommonjsModule(function (module) {
function _iterableToArrayLimit(arr, i) {
  var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]);

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

module.exports = _iterableToArrayLimit;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(iterableToArrayLimit);

var arrayLikeToArray = createCommonjsModule(function (module) {
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

module.exports = _arrayLikeToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(arrayLikeToArray);

var unsupportedIterableToArray = createCommonjsModule(function (module) {
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

module.exports = _unsupportedIterableToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(unsupportedIterableToArray);

var nonIterableRest = createCommonjsModule(function (module) {
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableRest;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(nonIterableRest);

var slicedToArray = createCommonjsModule(function (module) {
function _slicedToArray(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

module.exports = _slicedToArray;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

var _slicedToArray = unwrapExports(slicedToArray);

function ownKeys$4(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$4(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$4(Object(source), true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$4(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = useContext(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  if (i18n.options.react && i18n.options.react.wait !== undefined) warnOnce('It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.');

  var i18nOptions = _objectSpread$4(_objectSpread$4(_objectSpread$4({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0]);
  }

  var _useState = useState(getT),
      _useState2 = _slicedToArray(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var isMounted = useRef(true);
  useEffect(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT);
      });
    }

    function boundReset() {
      if (isMounted.current) setT(getT);
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [i18n, namespaces.join()]);
  var isInitial = useRef(true);
  useEffect(function () {
    if (isMounted.current && !isInitial.current) {
      setT(getT);
    }

    isInitial.current = false;
  }, [i18n]);
  var ret = [t, i18n, ready];
  ret.t = t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}

function ownKeys$3(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$3(Object(source), true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$3(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function withTranslation(ns) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function Extend(WrappedComponent) {
    function I18nextWithTranslation(_ref) {
      var forwardedRef = _ref.forwardedRef,
          rest = _objectWithoutProperties$2(_ref, ["forwardedRef"]);

      var _useTranslation = useTranslation(ns, rest),
          _useTranslation2 = _slicedToArray(_useTranslation, 3),
          t = _useTranslation2[0],
          i18n = _useTranslation2[1],
          ready = _useTranslation2[2];

      var passDownProps = _objectSpread$3(_objectSpread$3({}, rest), {}, {
        t: t,
        i18n: i18n,
        tReady: ready
      });

      if (options.withRef && forwardedRef) {
        passDownProps.ref = forwardedRef;
      } else if (!options.withRef && forwardedRef) {
        passDownProps.forwardedRef = forwardedRef;
      }

      return React__default.createElement(WrappedComponent, passDownProps);
    }

    I18nextWithTranslation.displayName = "withI18nextTranslation(".concat(getDisplayName(WrappedComponent), ")");
    I18nextWithTranslation.WrappedComponent = WrappedComponent;

    var forwardRef = function forwardRef(props, ref) {
      return React__default.createElement(I18nextWithTranslation, Object.assign({}, props, {
        forwardedRef: ref
      }));
    };

    return options.withRef ? React__default.forwardRef(forwardRef) : I18nextWithTranslation;
  };
}

var validation$3 = {
	validEmail: "Email address is not valid.",
	validUsername: "User name is not valid.",
	enterEmail: "Email address is required.",
	enterEmails: "Email addresses are required.",
	enterUsername: "User name is required.",
	enterPassword: "Password is required.",
	confirmPassword: "Confirm password is required.",
	enterFirstName: "First name is required.",
	enterLastName: "Last name is required.",
	enterPhone: "Phone number is required."
};
var buttons$j = {
	account: "My account",
	login: "Login",
	subscribe: "Subscribe"
};
var dashboard$4 = {
	labels: {
		menu: "Pelcro Menu",
		name: "Name",
		email: "Email",
		plan: "Plan",
		description: "Description",
		expiry: "Expiry",
		status: "Status",
		logout: "Logout",
		dashboard: "Dashboard",
		unsubscribe: "Unsubscribe",
		reactivate: "Reactivate",
		renew: "Renew",
		support: "Support",
		account: "Account",
		subscriptions: "Subscriptions",
		updatePaymentSource: "Update",
		updateProfile: "Update",
		updateAddress: "Update",
		redeemGift: "Redeem gift",
		address: "Address",
		paymentSource: "Payment card",
		actions: "Actions",
		expiresOn: "Expires on",
		renewsOn: "Renews on",
		isSureToCancel: "Are you sure you want to cancel your subscription?"
	},
	messages: {
		yourDashboard: "Your Pelcro Dashboard"
	},
	errors: {
		"": ""
	}
};
var select$7 = {
	messages: {
		alreadyHaveAccount: "Already have an account?",
		loginHere: "Login here",
		checkbox: "Check this box to gift this subscription"
	},
	labels: {
		plan: {
			title: "Subscribe to a plan",
			subtitle: "Select one of the plans below and click on next."
		},
		product: {
			title: "Subscribe to a product",
			subtitle: "Select one of the products below and click on next."
		},
		selectProduct: "Select a product",
		selectPlan: "Select a plan",
		startingAt: "Starting at"
	},
	buttons: {
		next: "Next",
		select: "Select",
		back: "Back"
	}
};
var confirm$b = {
	buttons: {
		"continue": "Continue to content"
	},
	labels: {
		title: "Thanks for your order!",
		subtitle: "Your items will be on their way shortly."
	},
	giftSent: "The gift will be sent to",
	successfully: "on the date you specified."
};
var common_en = {
	validation: validation$3,
	buttons: buttons$j,
	dashboard: dashboard$4,
	select: select$7,
	confirm: confirm$b
};

var update$3 = {
	title: "Update your payment information",
	subtitle: "Enter the fields below to update your credit card information",
	required: "Required",
	success: "Your payment information has been updated",
	secure: "You're safe - PCI compliant 128 SSL by"
};
var select$6 = {
	title: "Select a payment method",
	subtitle: "Select one of your saved methods, or pay with a new one",
	expires: "Expires",
	buttons: {
		addPaymentMethod: "Pay with another payment method",
		selectPaymentMethod: "Continue",
		changePaymentMethod: "Change"
	}
};
var create$5 = {
	title: "Add a new payment method",
	subtitle: "Enter the fields below to add your credit card information"
};
var paymentMethod_en = {
	update: update$3,
	select: select$6,
	"delete": {
	title: "Delete payment method",
	subtitle: "Are you sure you want to delete the selected payment method?",
	details: "Payment method details",
	message: "This action is irreversible and will permanently remove the payment method from the system. Please ensure that there are no pending transactions or subscriptions associated with this payment method.",
	buttons: {
		"delete": "Delete payment method",
		back: "Go back"
	},
	options: {
		select: "Select a payment method to be the default",
		add: "Add a new payment method"
	},
	paymentMethodReplaced: "Payment Method Successfully Deleted and Replaced",
	deletedSuccessfully: "Payment Method Successfully Deleted"
},
	create: create$5
};

var title$z = "Enter your email to subscribe to our newsletter";
var updateTitle$3 = "Update newsletter selections";
var subtitle$f = "We may use your email for other marketing communication";
var labels$13 = {
	submit: "Submit",
	firstName: "First name",
	lastName: "Last name",
	email: "Email",
	postalCode: "Postal code",
	required: "required"
};
var messages$17 = {
	alreadyHaveAccount: "Already have an account?",
	success: "Newsletters were successfully updated",
	loginHere: "Login here.",
	createAnAccount: " Create an account by clicking ",
	here: "here"
};
var newsletter_en = {
	title: title$z,
	updateTitle: updateTitle$3,
	subtitle: subtitle$f,
	labels: labels$13,
	messages: messages$17
};

var labels$12 = {
	"continue": "Continue to content"
};
var messages$16 = {
	yourFreeTrial: "Subscription successful!",
	youHaveAccess: "Hope you enjoy the subscription. Please contact us if you have any questions or concerns.",
	clickToLearn: {
		click: "Click",
		here: "here",
		toLearn: "to learn more or contact us at",
		forQuestion: "for any questions."
	},
	giftCreate: {
		title: "Your gift has been sent",
		content: "Your recipient will receive an email with instructions to redeem their gift soon."
	},
	giftRedeem: {
		title: "Congratulations",
		content: "You have successfully redeemed your gift subscription. Enjoy!"
	},
	invoicePayment: {
		title: "Invoice paid successfully",
		content: "Please contact us if you have any questions or concerns."
	}
};
var errors$j = {
	"": ""
};
var success_en = {
	labels: labels$12,
	messages: messages$16,
	errors: errors$j
};

var messages$15 = {
	freeVisits: "Free visits left:",
	subscribeNow: "Subscribe",
	alreadyHaveAccount: "Already have an account?",
	loginHere: "Login here"
};
var errors$i = {
	"": ""
};
var meter_en = {
	messages: messages$15,
	errors: errors$i
};

var messages$14 = {
	youAreSafe: "You're safe - PCI compliant 128 SSL by",
	bankRedirection: "Please hold, redirecting you to your bank.",
	bankAuthenticationSuccess: "Please wait while we process your request."
};
var labels$11 = {
	card: "Enter card number",
	date: "Expiration date",
	CVC: "CVC",
	required: "required",
	submit: "Submit",
	pay: "pay",
	addCode: "Add coupon code",
	hideCode: "Hide",
	codePlaceholder: "Enter your coupon code",
	applyCouponCode: "Apply",
	code: "Coupon code",
	"for": "for",
	interval: "{{count}} {{interval}}",
	interval_plural: "{{count}} {{interval}}",
	tax: "Tax",
	removeCoupon: "REMOVE",
	firstName: "First name",
	lastName: "Last name",
	phone: "Phone",
	freeItems: "Free Items",
	isDefault: "Set as default"
};
var checkoutForm_en = {
	messages: messages$14,
	labels: labels$11
};

var youAreSafe$3 = "You're safe - PCI compliant 128 SSL by";
var cancel$3 = "Cancel your subscription online at anytime.";
var giftSent$3 = "Subscription gift has been sent to";
var successfully$3 = "successfully";
var entitlement$3 = "Some of the content on this page is available with one or more of our plans. <1> Subscribe </1> now to get full page access.";
var recaptcha$3 = "This site is protected by reCAPTCHA and the Google <1>Privacy Policy</1> and <3>Terms of Service</3> apply.";
var invalidInvoice$3 = "Invalid invoice ID, please contact support";
var invalidSubscription$2 = "Invalid subscription ID, please contact support";
var zeroTotalInvoice$3 = "You can't view an invoice of 0$";
var messages_en = {
	youAreSafe: youAreSafe$3,
	cancel: cancel$3,
	giftSent: giftSent$3,
	successfully: successfully$3,
	entitlement: entitlement$3,
	recaptcha: recaptcha$3,
	invalidInvoice: invalidInvoice$3,
	invalidSubscription: invalidSubscription$2,
	zeroTotalInvoice: zeroTotalInvoice$3
};

var labels$10 = {
	email: "Enter email",
	username: "Enter username",
	password: "Enter password",
	required: "required",
	emailPlaceholder: "Email",
	passwordPlaceholder: "Password",
	login: "Login"
};
var messages$13 = {
	loginTo: "Login to your account",
	welcome: "Welcome back, sign in with your existing account.",
	dontHaveAccount: "Don't have an account yet?",
	createAccount: "Create an account.",
	forgotPassword: "Forgot your password?",
	reset: {
		click: "Click",
		here: "here",
		toReset: "to reset it."
	},
	socialLogin: {
		label: "Or continue with"
	}
};
var errors$h = {
	"": ""
};
var login_en = {
	labels: labels$10,
	messages: messages$13,
	errors: errors$h
};

var labels$$ = {
	title: "Verifying Passwordless Link",
	instructions: "You're on your way!\nLet's confirm your email address.\nClick on the verification link we've sent to your email:",
	resend: "Resend email"
};
var messages$12 = {
	resent: "Resent successfully",
	success: "You have logged in successfully"
};
var verifyLinkToken_en = {
	labels: labels$$,
	messages: messages$12
};

var title$y = "Create an account";
var subtitle$e = "Enter your email and password below";
var labels$_ = {
	signUpFacebook: "Sign up with Facebook",
	signUpGoogle: "Sign up with Google",
	signUpEmail: "Sign up with Email",
	password: "Password",
	email: "Email",
	passwordPlaceholder: "Create password",
	emailPlaceholder: "Enter email",
	required: "required",
	firstName: "First name",
	lastName: "Last name",
	phone: "Phone"
};
var messages$11 = {
	alreadyHaveAccount: "Already have an account?",
	createAccount: "Create account",
	loginHere: "login here. ",
	selectPlan: "Select a different plan ",
	here: "here",
	iAgree: {
		iAgree: "I agree to the",
		terms: "Terms of Service",
		and: "and",
		privacy: "Privacy Policy."
	},
	preferDisable: {
		click: "Click",
		here: "here",
		ifPrefer: "if you prefer to disable your Ad blocker."
	},
	socialLogin: {
		label: "Or continue with"
	}
};
var errors$g = {
	"": ""
};
var gift$3 = {
	titles: {
		firstTitle: "Enter the recipient's information below"
	},
	labels: {
		firstName: "First name",
		lastName: "Last name",
		email: "Email",
		startDate: "Gift date",
		giftMessage: "Gift message ({{count}} characters remaining)",
		required: "required",
		firstNamePlaceholder: "First name",
		lastNamePlaceholder: "Last name",
		emailPlaceholder: "Email Address"
	},
	buttons: {
		gift: "gift"
	},
	messages: {
		enterEmail: "Please enter the gift recipient's email.",
		invalidDate: "The gift date needs to be between today and a year from now.",
		giftDateInfo: "The recipient will receive a gift email notification with your message on the date you select in order to redeem the gift.",
		giftMessageInfo: "Leave a message to the recipient and don't forget to sign your name."
	}
};
var redeem$3 = {
	titles: {
		firstTitle: "Redeem your gift",
		secondTitle: "Enter the gift code below"
	},
	labels: {
		code: "Enter gift code",
		codePlaceholder: "Gift code",
		required: "required"
	},
	buttons: {
		redeem: "Redeem gift"
	},
	footer: {
		click: "Click",
		here: "here",
		toAdd: "to add an address"
	},
	messages: {
		enterGiftCode: "Please enter a gift code."
	}
};
var register_en = {
	title: title$y,
	subtitle: subtitle$e,
	labels: labels$_,
	messages: messages$11,
	errors: errors$g,
	gift: gift$3,
	redeem: redeem$3
};

var labels$Z = {
	title: "Want to update your profile?",
	subtitle: "Enter your information below to update your profile",
	email: "Email",
	firstName: "First name",
	lastName: "Last name",
	username: "Username",
	displayname: "Display name",
	phone: "Phone",
	submit: "Submit",
	required: "Required",
	cropperTitle: "Update Profile Picture",
	cropperSubtitle: "Upload a photo, Then adjust as you see fit",
	save: "Upload Photo",
	selectImage: "Upload new photo",
	removeImage: "Remove current photo",
	zoom: "Zoom",
	tin: "Tax Identification Number"
};
var messages$10 = {
	userUpdated: "Thanks! Your profile was updated successfully.",
	pictureRemoved: "Your profile picture was removed successfully.",
	pictureUpdated: "Your profile picture was updated successfully."
};
var userEdit_en = {
	labels: labels$Z,
	messages: messages$10
};

var title$x = "Enter your shipping address";
var titleGifting$3 = "Enter your address";
var selectAddressTitle$3 = "Please select an address";
var selectAddressSubtitle$3 = "Select one of your saved addresses, or add a new one";
var labels$Y = {
	address: "Address",
	code: "Postal Code/Zip",
	city: "City",
	region: "State/Province/Region",
	country: "Country",
	firstName: "First name",
	lastName: "Last name",
	required: "required",
	isDefault: "Set as default"
};
var buttons$i = {
	submit: "Submit",
	selectAddress: "Select address",
	addAddress: "Add new address"
};
var messages$$ = {
	addressUpdated: "The address was successfully updated!",
	subRedeemed: "Your subscription has been redeemed."
};
var address_en = {
	title: title$x,
	titleGifting: titleGifting$3,
	selectAddressTitle: selectAddressTitle$3,
	selectAddressSubtitle: selectAddressSubtitle$3,
	labels: labels$Y,
	buttons: buttons$i,
	messages: messages$$
};

var title$w = "Reset your password";
var subtitle$d = "Enter a new password below";
var email$b = "Email";
var password$7 = "Password";
var confirmPassword$3 = "Confirm password";
var submit$f = "Submit";
var required$f = "Required";
var passwordUpdated$3 = "Password has been updated, please login with the new password";
var passwordReset_en = {
	title: title$w,
	subtitle: subtitle$d,
	email: email$b,
	password: password$7,
	confirmPassword: confirmPassword$3,
	submit: submit$f,
	required: required$f,
	passwordUpdated: passwordUpdated$3
};

var title$v = "Forgot your password?";
var email$a = "Email";
var password$6 = "Password";
var submit$e = "Submit";
var required$e = "Required";
var passwordResetEmailSent$3 = "Password reset instructions have been sent to your email";
var messages$_ = {
	alreadyHaveAccount: "Already have an account?",
	loginHere: "login here."
};
var passwordForgot_en = {
	title: title$v,
	email: email$a,
	password: password$6,
	submit: submit$e,
	required: required$e,
	passwordResetEmailSent: passwordResetEmailSent$3,
	messages: messages$_
};

var title$u = "Change your password";
var currentPassword$3 = "Current password";
var newPassword$3 = "New password";
var confirmNewPassword$3 = "Confirm new password";
var submit$d = "Change password";
var required$d = "Required";
var passwordChanged$3 = "Password has been changed, please login with the new password";
var passwordsNotMatching$3 = "Passwords don't match";
var weakPassword$3 = "Your password must contain at least 6 characters";
var passwordChange_en = {
	title: title$u,
	currentPassword: currentPassword$3,
	newPassword: newPassword$3,
	confirmNewPassword: confirmNewPassword$3,
	submit: submit$d,
	required: required$d,
	passwordChanged: passwordChanged$3,
	passwordsNotMatching: passwordsNotMatching$3,
	weakPassword: weakPassword$3
};

var title$t = "Passwordless Login";
var email$9 = "Enter email";
var submit$c = "Submit";
var required$c = "Required";
var messages$Z = {
	PasswordlessLoginSuccess: "Please check your email and follow the instructions there"
};
var passwordlessRequest_en = {
	title: title$t,
	email: email$9,
	submit: submit$c,
	required: required$c,
	messages: messages$Z
};

var title$s = "Your shopping cart";
var subtitle$c = "Comple your purchase below";
var name$3 = "Name";
var quantity$3 = "Quantity";
var price$3 = "Price";
var actions$4 = "Actions";
var remove$3 = "Remove";
var total$3 = "Total";
var confirm$a = "Checkout";
var empty$3 = "Your cart is empty.";
var removeAll$3 = "Remove all";
var cart_en = {
	title: title$s,
	subtitle: subtitle$c,
	name: name$3,
	quantity: quantity$3,
	price: price$3,
	actions: actions$4,
	remove: remove$3,
	total: total$3,
	confirm: confirm$a,
	empty: empty$3,
	removeAll: removeAll$3
};

var buttons$h = {
	select: "Select",
	added: "Added to cart",
	purchase: "Purchase",
	"continue": "Continue"
};
var messages$Y = {
	orderConfirmed: {
		title: "Order confirmed!",
		body: "Your order has been confirmed and will be shipped within the next few days. You'll shortly receive an email confirmation of this order."
	},
	haveQuestions: "If you have any queries please don't hesitate to contact us!",
	multipleCurrencies: "Your cart currently contains items which are available in different currencies. In order to proceed with the checkout, please make sure that all items have the same currency.",
	currencyMismatch: "The selected item(s) do not match your current default currency ({{currency}}). Please choose item(s) only matching this currency."
};
var labels$X = {
	summary: "Order summary",
	total: "total"
};
var shop_en = {
	buttons: buttons$h,
	messages: messages$Y,
	labels: labels$X
};

var labels$W = {
	cardNumber: "Card number",
	securityCode: "Security Code",
	submit: "Submit",
	months: {
		jan: "January",
		feb: "February",
		mar: "March",
		apr: "April",
		may: "May",
		jun: "June",
		jul: "July",
		aug: "August",
		sep: "September",
		oct: "October",
		nov: "November",
		dec: "December"
	},
	checkout: {
		title: "Payment Information"
	}
};
var messages$X = {
	youAreSafe: "You're safe - PCI compliant 128 SSL by",
	cancel: "Cancel your subscription online at anytime.",
	giftSent: "Subscription gift has been sent to",
	successfully: "successfully",
	sourceCreated: "Payment information has been added",
	sourceUpdated: "Your payment information has been updated",
	cardAuthFailed: "We are unable to authenticate your payment method. Please choose a different payment method and try again.",
	cardAuthNotSupported: "Updating your payment method to one that requires authentication is currently not possible. Please use a different payment method or contact customer service.",
	tryAgainFromInvoice: "We were unable to authenticate your payment, however your subscription was created. Please attempt to pay for the invoice using another payment method from the dashboard."
};
var errors$f = {
	"": ""
};
var payment_en = {
	labels: labels$W,
	messages: messages$X,
	errors: errors$f
};

var labels$V = {
	menu: "Pelcro Menu",
	name: "Name",
	email: "Email",
	plan: "Plan",
	description: "Description",
	expiry: "Expiry",
	status: {
		title: "Status",
		active: "Active",
		inTrial: "In trial",
		endingSoon: "Ending soon",
		scheduled: "Scheduled",
		incomplete: "Incomplete"
	},
	manageMembers: "Manage Members",
	shipments: "Shipments remaining",
	logout: "Logout",
	dashboard: "Dashboard",
	unsubscribe: "Cancel",
	reactivate: "Reactivate",
	renew: "Renew",
	suspend: "Suspend",
	unsuspend: "Unsuspend",
	support: "Support",
	account: "Account",
	purchases: "Purchases",
	subscriptions: "Subscriptions",
	donations: "Donations",
	memberships: "Memberships",
	invoices: "Invoices",
	details: "Details",
	view: "View",
	paid: "Paid",
	open: "Open",
	draft: "Draft",
	scheduled: "Scheduled",
	uncollectible: "Uncollectible",
	"void": "Void",
	pastDue: "Past due",
	updatePaymentSource: "Update",
	profile: "Profile",
	updateProfile: "Edit profile",
	changePassword: "Change password",
	editNewsletters: "Edit newsletters",
	myQRCode: "My QR code",
	shipping: "Shipping",
	billing: "Billing",
	edit: "Edit",
	gifts: "Gifts",
	redeemGift: "Redeem gift",
	address: "Address",
	addresses: "Addresses",
	myProfile: "My profile",
	paymentSource: "Payment cards",
	actions: "Actions",
	expiresOn: "Ends",
	until: "Until",
	startsOn: "Starts",
	startDate: "Start date",
	renewsOn: "Renews",
	canceledOn: "Canceled on",
	recipient: "Recipient",
	addPaymentSource: "Add payment method",
	setDefault: "Set as default",
	addAddress: "Add address",
	editAddress: "Edit address",
	addSubscription: "New Subscription",
	addGift: "New Gift",
	"default": "Default",
	orders: {
		label: "Orders",
		noOrders: "You have not placed any orders",
		total: "Total",
		date: "Date",
		details: "Details",
		itemsAmount: "{{count}} item",
		itemsAmount_plural: "{{count}} items"
	},
	savedItems: {
		label: "Saved & Followed",
		noSavedItems: "You have no saved items",
		categories: "Categories",
		details: "Details",
		removeItem: "Remove"
	},
	subCancellation: {
		goBack: "Go back"
	}
};
var messages$W = {
	noCard: "You don't have a card",
	subCancellation: {
		isSureToCancel: "Are you sure you want to cancel your subscription?",
		loading: "Cancelling your subscription",
		success: "Subscription is successfully cancelled",
		error: "Error while cancelling your subscription"
	},
	subReactivation: {
		success: "Subscription is successfully reactivated",
		error: "Error while reactivating your subscription"
	},
	subUnSuspend: {
		isSureToUnSuspend: "Are you sure you want to unsuspend your subscription?",
		loading: "Unsuspending your subscription",
		success: "Subscription is successfully unsuspended",
		error: "Error while unsuspending your subscription"
	},
	paymentMethodDeletion: {
		isSureToDelete: "Are you sure you want to delete this payment method?",
		loading: "Deleting your payment method",
		success: "Payment method is successfully deleted",
		error: "Error while deleting your payment method",
		nonDeletable: "This payment method can't be deleted"
	}
};
var dashboard_en = {
	labels: labels$V,
	messages: messages$W
};

var messages$V = {
	alreadyHaveAccount: "Already have an account?",
	loginHere: "Login here",
	checkbox: "Check this box to gift this subscription"
};
var labels$U = {
	plan: {
		title: "Subscribe to a plan",
		subtitle: "Select one of the plans below and click on next."
	},
	product: {
		title: "Subscribe to a product",
		subtitle: "Select one of the products below and click on next."
	},
	selectProduct: "Select a product",
	selectPlan: "Select a plan",
	startingAt: "Starting at",
	restrictiveArticles: {
		subscribeTo: "Subscribe to one of the following options to get access to this page",
		or: "Or take a look at some of our other options below"
	}
};
var buttons$g = {
	next: "Next",
	select: "Select",
	back: "Back"
};
var select_en = {
	messages: messages$V,
	labels: labels$U,
	buttons: buttons$g
};

var confirm$9 = {
	labels: {
		confirm: "Confirm",
		close: "Close"
	}
};
var notification_en = {
	confirm: confirm$9
};

var labels$T = {
	title: "Verify your email",
	instructions: "You're on your way!\nLet's confirm your email address.\nClick on the verification link we've sent to your email:",
	resend: "Resend email"
};
var messages$U = {
	resent: "Resent successfully",
	success: "Email verified successfully!"
};
var verifyEmail_en = {
	labels: labels$T,
	messages: messages$U
};

var title$r = "Invoice details";
var labels$S = {
	summary: "Summary",
	total: "Total",
	amountPaid: "Amount paid",
	amountDue: "Amount due",
	creationDate: "Created on:"
};
var buttons$f = {
	download: "Download",
	pay: "Pay now"
};
var invoiceDetails_en = {
	title: title$r,
	labels: labels$S,
	buttons: buttons$f
};

var labels$R = {
	title: "Cancel subscription",
	cancelReason: "Cancellation reason",
	endOn: "End on",
	endImmediately: "End immediately",
	cancel: "Cancel",
	subCancellation: {
		goBack: "Go back"
	}
};
var messages$T = {
	subscriptionEnd: "This subscription is set to expire on",
	cancelWhen: "When would you like to cancel?",
	cancelNow: "Cancel Subscription Now",
	cancelLater: "Cancel at Period End",
	subCancellation: {
		isSureToCancelNow: "Are you sure you want to cancel your subscription immediately?",
		isSureToCancel: "Are you sure you want to cancel your subscription?",
		loading: "Canceling your subscription",
		success: "Subscription is successfully canceled",
		error: "Error while canceling your subscription"
	}
};
var subscriptionCancel_en = {
	labels: labels$R,
	messages: messages$T
};

var labels$Q = {
	inviteMembers: "Invite Members",
	listOfMembers: "List of members",
	invite: "Invite",
	remove: "Remove",
	emails: "Enter emails",
	status: "Status",
	actions: "Actions",
	email: "Email",
	listNote: "Comma-separated list e.g."
};
var subscriptionManageMembers_en = {
	labels: labels$Q
};

var labels$P = {
	title: "Suspend subscription",
	suspensionDate: "Suspension date",
	subCancellation: {
		goBack: "Go back"
	}
};
var messages$S = {
	suspensionEnd: "The suspension is set to expire on",
	suspendNow: "Suspend Subscription Now",
	suspendLater: "Suspend at Period End",
	subCancellation: {
		isSureToSuspendNow: "Are you sure you want to suspend your subscription immediately?",
		isSureToSuspend: "Are you sure you want to suspend your subscription?",
		loading: "Suspending your subscription",
		success: "Subscription is successfully suspended",
		error: "Error while suspending your subscription"
	}
};
var subscriptionSuspend_en = {
	labels: labels$P,
	messages: messages$S
};

var validation$2 = {
	validEmail: "le courriel n’est pas valide",
	validUsername: "Le nom d'utilisateur n'est pas valide.",
	enterEmail: "Un courriel est requis.",
	enterEmails: "Les adresses e-mail sont obligatoires.",
	enterUsername: "Nom d'utilisateur est nécessaire.",
	enterPassword: "Mot de passe requis.",
	confirmPassword: "Confirmer le mot de passe requis.",
	enterFirstName: "Le prénom est requis.",
	enterLastName: "Le nom de famille est requis.",
	enterPhone: "Le numéro de téléphone est requis."
};
var buttons$e = {
	account: "Accès abonné(e)s",
	login: "Se connecter",
	subscribe: "S'abonner"
};
var dashboard$3 = {
	labels: {
		menu: "Menu Pelcro",
		name: "Nom",
		email: "Courriel",
		plan: "Plan",
		description: "Description",
		expiry: "Expiration",
		status: "Statut",
		logout: "Déconnexion",
		dashboard: "Tableau de bord",
		unsubscribe: "Se désabonner",
		reactivate: "Réactiver",
		renew: "Renouveler",
		support: "Soutien",
		account: "Compte",
		subscriptions: "Abonnements",
		updatePaymentSource: "Mettre à jour le mode de paiement",
		updateProfile: "Mettre à jour le profil",
		updateAddress: "Modifier",
		redeemGift: "Échanger un cadeau",
		address: "Adresse",
		paymentSource: "Mode de paiement",
		actions: "Actes",
		expiresOn: "Expire le",
		renewsOn: "Renouvelle le",
		isSureToCancel: "Êtes-vous certain de vouloir annuler votre abonnement ?"
	},
	messages: {
		yourDashboard: "Votre tableau de bord Pelcro"
	},
	errors: {
		"": ""
	}
};
var select$5 = {
	messages: {
		alreadyHaveAccount: "Vous avez déjà un compte ?",
		loginHere: "Connectez-vous ici",
		checkbox: "Cochez cette case pour offrir cet abonnement"
	},
	labels: {
		plan: {
			title: "Abonnez-vous à un plan",
			subtitle: "Sélectionnez l’un des plans ci-dessous et cliquez sur suivant."
		},
		product: {
			title: "Abonnez-vous à un produit",
			subtitle: "Sélectionnez l’un des produits ci-dessous et cliquez sur suivant."
		},
		selectProduct: "Sélectionnez un produit",
		selectPlan: "Sélectionnez un plan",
		starningAt: "À partir de"
	},
	buttons: {
		next: "Prochain",
		select: "Choisir",
		back: "Retour"
	}
};
var confirm$8 = {
	buttons: {
		"continue": "Continuer au contenu"
	},
	labels: {
		title: "Merci pour votre commande !",
		subtitle: "Vos articles seront bientôt en route."
	},
	giftSent: "Le cadeau d’abonnement a été envoyé à",
	successfully: "avec succès."
};
var common_fr = {
	validation: validation$2,
	buttons: buttons$e,
	dashboard: dashboard$3,
	select: select$5,
	confirm: confirm$8
};

var update$2 = {
	title: "Mettre à jour vos informations de paiement",
	subtitle: "Entrez les champs ci-dessous pour mettre à jour les informations de votre carte de crédit",
	required: "Champs obligatoires",
	success: "Vos informations de paiement ont été mises à jour",
	secure: "Vous êtes en sécurité - 128 SSL conforme à la norme PCI"
};
var select$4 = {
	title: "Sélectionnez un mode de paiement",
	subtitle: "Sélectionnez un mode de paiement existant ou choisissez-en un nouveau",
	expires: "Date d'expiration",
	buttons: {
		addPaymentMethod: "Choisir un autre mode de paiement",
		selectPaymentMethod: "Continuer",
		changePaymentMethod: "Modifier"
	}
};
var create$4 = {
	title: "Ajouter un nouveau mode de paiement",
	subtitle: "Saisissez les champs ci-dessous pour ajouter les informations relatives à votre carte de crédit"
};
var paymentMethod_fr = {
	update: update$2,
	select: select$4,
	"delete": {
	title: "Supprimer un mode de paiement",
	subtitle: "Ce mode de paiement peut être associé à des abonnements actifs ou servir de mode de paiement par défaut. Veuillez choisir parmi les options disponibles ci-dessous pour le remplacement.",
	options: {
		select: "Sélectionner un mode de paiement existant",
		add: "Ajouter un nouveau mode de paiement"
	},
	paymentMethodReplaced: "Méthode de paiement supprimée et remplacée avec succès"
},
	create: create$4
};

var title$q = "Entrez votre adresse courriel pour vous abonner à notre infolettre";
var updateTitle$2 = "Mettre à jour son choix d'infolettres";
var subtitle$b = "Nous pouvons utiliser votre adresse courriel pour d’autres communications marketing";
var labels$O = {
	submit: "Lire l’article !",
	firstName: "Prénom",
	lastName: "Nom de famille",
	email: "Adresse courriel",
	postalCode: "Code postal",
	required: "Champs obligatoires"
};
var messages$R = {
	alreadyHaveAccount: "Vous avez déjà un compte ?",
	success: "Votre choix d'infolettres à été mis à jour",
	loginHere: "Connectez-vous ici",
	createAnAccount: " Créez un compte en cliquant ",
	here: "ici"
};
var newsletter_fr = {
	title: title$q,
	updateTitle: updateTitle$2,
	subtitle: subtitle$b,
	labels: labels$O,
	messages: messages$R
};

var labels$N = {
	"continue": "Abonnement réussi !"
};
var messages$Q = {
	yourFreeTrial: "Votre essai gratuit vient de débuter",
	youHaveAccess: "Nous espérons que vous allez apprécier votre abonnement. Veuillez nous contacter si vous avez des questions ou des préoccupations.",
	clickToLearn: {
		click: "cliquez",
		here: "ici",
		toLearn: "pour en savoir plus ou contactez-nous à",
		forQuestion: "pour toute question."
	},
	giftCreate: {
		title: "Votre cadeau a été envoyé",
		content: "Le cadeau d'abonnement a été envoyé avec succès."
	},
	giftRedeem: {
		title: "Félicitations",
		content: "Vous avez validé votre abonnement cadeau. Profitez-en!"
	},
	invoicePayment: {
		title: "Invoice paid successfully",
		content: "Please contact us if you have any questions or concerns."
	}
};
var errors$e = {
	"": ""
};
var success_fr = {
	labels: labels$N,
	messages: messages$Q,
	errors: errors$e
};

var messages$P = {
	freeVisits: "Visites gratuites restantes:",
	subscribeNow: "Abonnez-vous maintenant !",
	alreadyHaveAccount: "Vous avez déjà un compte ?",
	loginHere: "Connectez-vous ici"
};
var errors$d = {
	"": ""
};
var meter_fr = {
	messages: messages$P,
	errors: errors$d
};

var messages$O = {
	youAreSafe: "Vous êtes en sécurité - PCI conforme 128 SSL par",
	bankRedirection: "Veuillez patienter, nous vous redirigeons vers votre banque.",
	bankAuthenticationSuccess: "Veuillez patienter pendant que nous accédons à votre requête."
};
var labels$M = {
	card: "Entrez le numéro de carte",
	date: "Date d’expiration",
	CVC: "CVC",
	required: "Champs obligatoires",
	submit: "Soumettre",
	pay: "Payer",
	addCode: "Ajouter un code promo",
	hideCode: "Cacher",
	codePlaceholder: "Entrez votre code de coupon",
	applyCouponCode: "Appliquer",
	code: "Code promo",
	"for": "pour",
	interval: "{{count}} {{interval}}",
	interval_plural: "{{count}} {{interval}}",
	tax: "Taxe",
	removeCoupon: "RETIRER",
	firstName: "Prénom",
	lastName: "Nom de famille",
	phone: "Téléphoner",
	freeItems: "Articles gratuits",
	isDefault: "Défini comme valeur par défaut"
};
var checkoutForm_fr = {
	messages: messages$O,
	labels: labels$M
};

var youAreSafe$2 = "Vous êtes en sécurité - PCI conforme 128 SSL par";
var cancel$2 = "Annuler votre abonnement en ligne à tout moment.";
var giftSent$2 = "Le cadeau d’abonnement a été envoyé à";
var successfully$2 = "avec succès.";
var entitlement$2 = "Une partie du contenu de cette page est disponible sous un ou plusieurs de nos plans. <1> Abonnez-vous </1> à l'un de nos plans disponibles pour accéder à plus de contenu";
var recaptcha$2 = "Ce site est protégé par reCAPTCHA - les <1>règles de confidentialité</1> Google ainsi que les <3>conditions d'utilisation</3> s'appliquent.";
var invalidInvoice$2 = "Identifiant de facture non valide, veuillez contacter l'assistance";
var invalidSubscription$1 = "ID d'abonnement invalide, veuillez contacter l'assistance";
var zeroTotalInvoice$2 = "You can't view an invoice of 0$";
var messages_fr = {
	youAreSafe: youAreSafe$2,
	cancel: cancel$2,
	giftSent: giftSent$2,
	successfully: successfully$2,
	entitlement: entitlement$2,
	recaptcha: recaptcha$2,
	invalidInvoice: invalidInvoice$2,
	invalidSubscription: invalidSubscription$1,
	zeroTotalInvoice: zeroTotalInvoice$2
};

var labels$L = {
	email: "Entrez votre adresse courriel",
	username: "Saisissez votre nom d'utilisateur",
	password: "Entrez votre mot de passe",
	required: "Champs obligatoires",
	emailPlaceholder: "Adresse courriel",
	passwordPlaceholder: "Mot de passe",
	login: "Connexion"
};
var messages$N = {
	loginTo: "Connectez-vous à votre compte",
	welcome: "Bienvenue, connectez-vous avec votre compte existant.",
	dontHaveAccount: "Vous n’avez pas encore de compte ?",
	createAccount: "Créer un compte",
	forgotPassword: "Mot de passe oublié ?",
	reset: {
		click: "Cliquez",
		here: "ici",
		toReset: "pour le réinitialiser."
	},
	socialLogin: {
		label: "Ou continuer avec"
	}
};
var errors$c = {
	"": ""
};
var login_fr = {
	labels: labels$L,
	messages: messages$N,
	errors: errors$c
};

var labels$K = {
	title: "Confirmez votre courriel",
	instructions: "Confirmez votre courriel.\nVeuillez cliquer sur le lien de vérification, qui vous a été envoyé à:",
	resend: "Renvoyer le courriel"
};
var messages$M = {
	resent: "Renvoyé avec succès",
	success: "Vous vous êtes connecté avec succès"
};
var verifyLinkToken_fr = {
	labels: labels$K,
	messages: messages$M
};

var title$p = "Créer un compte";
var subtitle$a = "Entrez votre courriel et votre mot de passe ci-dessous";
var labels$J = {
	signUpFacebook: "Inscrivez-vous avec Facebook",
	signUpGoogle: "Inscrivez-vous avec Google",
	signUpEmail: "Inscrivez-vous avec votre courriel",
	password: "Créer un mot de passe",
	email: "Courriel",
	passwordPlaceholder: "Mot de passe",
	emailPlaceholder: "Courriel",
	required: "Champs obligatoires",
	firstName: "Prénom",
	lastName: "Nom de famille",
	phone: "Téléphoner"
};
var messages$L = {
	alreadyHaveAccount: "Vous avez déjà un compte?",
	createAccount: "Créer un compte",
	loginHere: "Connectez-vous ici",
	selectPlan: "Sélectionnez un plan",
	here: "ici",
	iAgree: {
		iAgree: "J’accepte",
		terms: "les conditions d’utilisation",
		and: "et",
		privacy: "la politique de confidentialité."
	},
	preferDisable: {
		click: "Cliquez",
		here: "ici",
		ifPrefer: "si vous préférez désactiver votre bloqueur de publicités."
	},
	socialLogin: {
		label: "Ou continuer avec"
	}
};
var errors$b = {
	"": ""
};
var gift$2 = {
	titles: {
		firstTitle: "Offrir cet abonnement",
		secondTitle: "Entrez les informations du destinataire ci-dessous"
	},
	labels: {
		firstName: "Prénom",
		lastName: "Nom de famille",
		email: "Adresse courriel",
		startDate: "Date de début",
		giftMessage: "Message du cadeau ({{count}} caractères restants)",
		required: "Champs obligatoires",
		firstNamePlaceholder: "Prénom",
		lastNamePlaceholder: "Nom de famille",
		emailPlaceholder: "Adresse courriel"
	},
	buttons: {
		gift: "cadeau"
	},
	messages: {
		enterEmail: "Veuillez entrer l’adresse courriel du destinataire du cadeau.",
		invalidDate: "La date du cadeau doit être comprise entre aujourd'hui et un an.",
		giftDateInfo: "Le destinataire recevra un courriel à la date déterminée afin d'activer leur abonnement cadeau.",
		giftMessageInfo: "Laissez un message au destinataire sans oublier de signer votre nom."
	}
};
var redeem$2 = {
	titles: {
		firstTitle: "Échangez votre cadeau",
		secondTitle: "Entrez le code cadeau ci-dessous"
	},
	labels: {
		code: "Entrez le code du cadeau",
		codePlaceholder: "Code cadeau",
		required: "Champs obligatoires"
	},
	buttons: {
		redeem: "Échanger un cadeau"
	},
	footer: {
		click: "Cliquez",
		here: "ici",
		toAdd: "pour ajouter une adresse"
	},
	messages: {
		enterGiftCode: "Veuillez entrer un code cadeau."
	}
};
var register_fr = {
	title: title$p,
	subtitle: subtitle$a,
	labels: labels$J,
	messages: messages$L,
	errors: errors$b,
	gift: gift$2,
	redeem: redeem$2
};

var labels$I = {
	title: "Voulez-vous mettre à jour votre profil ?",
	subtitle: "Entrez vos informations ci-dessous pour mettre à jour votre profil",
	email: "Address courriel",
	firstName: "Prénom",
	lastName: "Nom de famille",
	username: "Nom d'utilisateur",
	displayname: "Afficher un nom",
	phone: "Numéro de téléphone",
	submit: "Soumettre",
	required: "Champs obligatoires",
	cropperTitle: "Mettre à jour la photo de profil",
	cropperSubtitle: "Téléverser une photo et ajustez la à votre goût",
	save: "Téléverser une photo",
	selectImage: "Télécharger une nouvelle photo",
	removeImage: "supprimer la photo actuelle",
	zoom: "Zoom",
	tin: "Numéro d'identification fiscale"
};
var messages$K = {
	userUpdated: "Votre profil a été mis à jour avec succès.",
	pictureRemoved: "Votre photo de profil a été supprimée avec succès.",
	pictureUpdated: "Votre photo de profil a été mise à jour avec succès."
};
var userEdit_fr = {
	labels: labels$I,
	messages: messages$K
};

var title$o = "Entrez votre adresse de livraison";
var titleGifting$2 = "Entrez votre adresse";
var selectAddressTitle$2 = "Veuillez sélectionner une adresse";
var selectAddressSubtitle$2 = "Choisissez l'une de vos adresses ou créez-en une nouvelle";
var labels$H = {
	address: "Adresse",
	code: "Code postal / Zip",
	city: "Ville",
	region: "Province / Région",
	country: "Pays",
	firstName: "Prénom",
	lastName: "Nom de famille",
	required: "Champs obligatoires",
	isDefault: "Définir par défaut"
};
var buttons$d = {
	submit: "Valider",
	selectAddress: "Choisir cette adresse",
	addAddress: "Ajouter une nouvelle adresse"
};
var messages$J = {
	addressUpdated: "Votre adresse a été mise à jour avec succès",
	subRedeemed: "Votre abonnement a bien été activé."
};
var address_fr = {
	title: title$o,
	titleGifting: titleGifting$2,
	selectAddressTitle: selectAddressTitle$2,
	selectAddressSubtitle: selectAddressSubtitle$2,
	labels: labels$H,
	buttons: buttons$d,
	messages: messages$J
};

var title$n = "Réinitialiser votre mot de passe";
var subtitle$9 = "Entrez un nouveau mot de passe ci-dessous";
var email$8 = "Adresse courriel";
var password$5 = "Mot de passe";
var confirmPassword$2 = "Confirmer le mot de passe";
var submit$b = "Soumettre";
var required$b = "Champs obligatoires";
var passwordUpdated$2 = "Votre mot de passe a été mis à jour, veuillez vous connecter avec celui-ci";
var passwordReset_fr = {
	title: title$n,
	subtitle: subtitle$9,
	email: email$8,
	password: password$5,
	confirmPassword: confirmPassword$2,
	submit: submit$b,
	required: required$b,
	passwordUpdated: passwordUpdated$2
};

var title$m = "Mot de passe oublié ?";
var email$7 = "Courriel";
var password$4 = "Mot de passe";
var submit$a = "Soumettre";
var required$a = "Champs obligatoires";
var passwordResetEmailSent$2 = "Un lien pour réinitialiser votre mot de passe vous a été envoyé. Si vous ne le recevez pas, vérifier votre courrier indésirable.";
var messages$I = {
	alreadyHaveAccount: "Vous avez déjà un compte ?",
	loginHere: "Connectez-vous ici"
};
var passwordForgot_fr = {
	title: title$m,
	email: email$7,
	password: password$4,
	submit: submit$a,
	required: required$a,
	passwordResetEmailSent: passwordResetEmailSent$2,
	messages: messages$I
};

var title$l = "Changez votre mot de passe";
var currentPassword$2 = "Mot de passe actuel";
var newPassword$2 = "Nouveau mot de passe";
var confirmNewPassword$2 = "Confirmer le nouveau mot de passe";
var submit$9 = "Changer le mot de passe";
var required$9 = "Champs obligatoires";
var passwordChanged$2 = "Le mot de passe a été modifié, veuillez vous connecter avec le nouveau mot de passe";
var passwordsNotMatching$2 = "Les mots de passe ne correspondent pas";
var weakPassword$2 = "Votre mot de passe doit contenir au moins 6";
var passwordChange_fr = {
	title: title$l,
	currentPassword: currentPassword$2,
	newPassword: newPassword$2,
	confirmNewPassword: confirmNewPassword$2,
	submit: submit$9,
	required: required$9,
	passwordChanged: passwordChanged$2,
	passwordsNotMatching: passwordsNotMatching$2,
	weakPassword: weakPassword$2
};

var title$k = "Connexion sans mot de passe";
var email$6 = "Entrez votre adresse courriel";
var submit$8 = "Soumettre";
var required$8 = "Champs obligatoires";
var messages$H = {
	PasswordlessLoginSuccess: "Vous avez été authentifié avec succès avec la connexion sans mot de passe"
};
var passwordlessRequest_fr = {
	title: title$k,
	email: email$6,
	submit: submit$8,
	required: required$8,
	messages: messages$H
};

var title$j = "Votre panier";
var subtitle$8 = "Terminez votre achat ci-dessous";
var name$2 = "Produit";
var quantity$2 = "Quantité";
var price$2 = "Prix";
var actions$3 = "Actes";
var remove$2 = "Retirer";
var total$2 = "Total";
var confirm$7 = "Passer à la caisse";
var empty$2 = "Votre panier est vide.";
var removeAll$2 = "Vider";
var cart_fr = {
	title: title$j,
	subtitle: subtitle$8,
	name: name$2,
	quantity: quantity$2,
	price: price$2,
	actions: actions$3,
	remove: remove$2,
	total: total$2,
	confirm: confirm$7,
	empty: empty$2,
	removeAll: removeAll$2
};

var buttons$c = {
	select: "Choisir",
	added: "Ajouté au panier",
	purchase: "Acheter",
	"continue": "Continuer au contenu"
};
var messages$G = {
	orderConfirmed: {
		title: "Votre commande est confirmée !",
		body: "Votre commande a été confirmée et vous sera expédiée dans les prochains jours. Vous recevrez un courriel de confirmation sous peu."
	},
	haveQuestions: "N’hésitez pas à nous contacter pour toute question !",
	multipleCurrencies: "Votre panier contient des articles disponibles dans différentes devises. Avant de passer à la caisse, veuillez vous assurer que tous les articles ont la même devise.",
	currencyMismatch: "Les articles sélectionnés ne sont pas compatibles avec la devise associée à votre compte ({{currency}}). Veuillez choisir des articles uniquement offerts dans cette devise."
};
var labels$G = {
	summary: "récapitulatif de commande",
	total: "total"
};
var shop_fr = {
	buttons: buttons$c,
	messages: messages$G,
	labels: labels$G
};

var labels$F = {
	cardNumber: "Numéro de carte",
	securityCode: "Code de sécurité",
	submit: "Soumettre",
	months: {
		jan: "Janvier",
		feb: "Février",
		mar: "Mars",
		apr: "Avril",
		may: "Mai",
		jun: "Juin",
		jul: "Juillet",
		aug: "Août",
		sep: "Septembre",
		oct: "Octobre",
		nov: "Novembre",
		dec: "Décembre"
	},
	checkout: {
		title: "Informations de paiement"
	}
};
var messages$F = {
	youAreSafe: "Vous êtes en sécurité - PCI conforme 128 SSL par",
	cancel: "Annuler votre abonnement en ligne à tout moment.",
	giftSent: "Le cadeau d’abonnement a été envoyé à",
	successfully: "avec succès.",
	sourceCreated: "Les informations de paiement ont été ajoutées",
	sourceUpdated: "Vos informations de paiement ont été mises à jour",
	cardAuthFailed: "Nous ne parvenons pas à authentifier votre mode de paiement. Veuillez choisir un autre mode de paiement et essayer à nouveau.",
	cardAuthNotSupported: "Votre carte ne peut être mise à jour puisqu'elle nécessite une authentification. Veuillez utiliser un autre mode de paiement ou contacter le service client.",
	tryAgainFromInvoice: "Nous n'avons pas pu authentifier votre paiement, mais votre abonnement a été créé. Veuillez essayer de payer la facture en utilisant un autre mode de paiement depuis le tableau de bord."
};
var errors$a = {
	"": ""
};
var payment_fr = {
	labels: labels$F,
	messages: messages$F,
	errors: errors$a
};

var labels$E = {
	menu: "Menu Pelcro",
	name: "Nom",
	email: "Courriel",
	plan: "Plan",
	description: "Description",
	expiry: "Expiration",
	status: {
		title: "Statut",
		active: "Active",
		inTrial: "En essai",
		endingSoon: "Expire bientôt",
		scheduled: "Programmé",
		incomplete: "Incomplet"
	},
	manageMembers: "Gérer les membres",
	shipments: "Expéditions restantes",
	logout: "Déconnexion",
	dashboard: "Tableau de bord",
	unsubscribe: "Se désabonner",
	reactivate: "Réactiver",
	renew: "Renouveler",
	suspend: "Suspendre",
	unsuspend: "Annuler la suspension",
	support: "Soutien",
	account: "Compte",
	purchases: "Achats",
	subscriptions: "Abonnements",
	donations: "Des dons",
	memberships: "Adhésions",
	invoices: "Invoices",
	details: "Details",
	view: "View",
	paid: "Paid",
	open: "open",
	draft: "Draft",
	scheduled: "Scheduled",
	uncollectible: "Uncollectible",
	"void": "Void",
	pastDue: "Past due",
	updatePaymentSource: "Mettre à jour la source de paiement",
	profile: "Profil",
	updateProfile: "Mettre à jour le profil",
	changePassword: "Changer le mot de passe",
	editNewsletters: "Modifier les newsletters",
	myQRCode: "Mon code QR",
	shipping: "Expédition",
	billing: "Facturation",
	edit: "Modifier",
	gifts: "Cadeaux",
	redeemGift: "Échanger un cadeau",
	address: "Adresse",
	addresses: "Adresses",
	myProfile: "Mon profil",
	paymentSource: "Sources de paiement",
	actions: "Actes",
	expiresOn: "Expire le",
	until: "Jusqu'à ce que",
	startsOn: "Débute le",
	startDate: "Date de début",
	renewsOn: "Renouvelle le",
	canceledOn: "Annulé le",
	recipient: "Destinataire",
	addAddress: "Ajoutez l'adresse",
	editAddress: "Modifier l'adresse",
	addSubscription: "Nouvel abonnement",
	addGift: "Ajouter un cadeau",
	"default": "Défaut",
	orders: {
		label: "Commandes",
		noOrders: "Vous n'avez passé aucune commande",
		total: "Total",
		date: "Date",
		details: "Des détails",
		itemsAmount: "{{count}} article",
		itemsAmount_plural: "{{count}} articles"
	},
	savedItems: {
		label: "Enregistré et suivi",
		noSavedItems: "Vous n'avez aucun élément enregistré",
		categories: "Catégories",
		details: "Détails",
		removeItem: "Retirer"
	},
	subCancellation: {
		goBack: "Retourner"
	}
};
var messages$E = {
	noCard: "Vous n’avez pas une carte",
	subCancellation: {
		isSureToCancel: "Êtes-vous certain de vouloir annuler votre abonnement?",
		loading: "Annulation de l'abonnement",
		success: "L'abonnement a été annulé avec succès",
		error: "Une erreur s'est produite lors de l'annulation de l'abonnement"
	},
	subReactivation: {
		success: "L'abonnement a été réactivé avec succès",
		error: "Erreur lors de la réactivation de votre abonnement"
	},
	subUnSuspend: {
		isSureToUnSuspend: "Êtes-vous sûr de vouloir annuler la suspension de votre abonnement ?",
		loading: "Annulation de la suspension de votre abonnement",
		success: "L'abonnement a été suspendu avec succès",
		error: "Erreur lors de l'annulation de la suspension de votre abonnement"
	}
};
var dashboard_fr = {
	labels: labels$E,
	messages: messages$E
};

var messages$D = {
	alreadyHaveAccount: "Vous avez déjà un compte ?",
	loginHere: "Connectez-vous ici",
	checkbox: "Cochez cette case pour offrir cet abonnement"
};
var labels$D = {
	plan: {
		title: "Abonnez-vous à un plan",
		subtitle: "Sélectionnez l’un des plans ci-dessous et cliquez sur suivant."
	},
	product: {
		title: "Abonnez-vous à un produit",
		subtitle: "Sélectionnez l’un des produits ci-dessous et cliquez sur suivant."
	},
	selectProduct: "Sélectionnez un produit",
	selectPlan: "Sélectionnez un plan",
	starningAt: "À partir de",
	restrictiveArticles: {
		subscribeTo: "Abonnez-vous à une des options suivantes pour accéder au contenu de cette page",
		or: "Sinon, jetez un coup d'oeil à d'autres offres ci-dessous"
	}
};
var buttons$b = {
	next: "Prochain",
	select: "Choisir",
	back: "Retour"
};
var select_fr = {
	messages: messages$D,
	labels: labels$D,
	buttons: buttons$b
};

var confirm$6 = {
	labels: {
		confirm: "Confirmer",
		close: "Fermer"
	}
};
var notification_fr = {
	confirm: confirm$6
};

var labels$C = {
	title: "Confirmez votre courriel",
	instructions: "Confirmez votre courriel.\nVeuillez cliquer sur le lien de vérification, qui vous a été envoyé à:",
	resend: "Renvoyer le courriel"
};
var messages$C = {
	resent: "Renvoyé avec succès",
	success: "Adresse courriel vérifiée avec succès"
};
var verifyEmail_fr = {
	labels: labels$C,
	messages: messages$C
};

var title$i = "Détails de la facture";
var labels$B = {
	summary: "Résumé",
	total: "Total",
	amountPaid: "Montant payé",
	amountDue: "Montant dû",
	creationDate: "Créé le:"
};
var buttons$a = {
	download: "Télécharger",
	pay: "Payer"
};
var invoiceDetails_fr = {
	title: title$i,
	labels: labels$B,
	buttons: buttons$a
};

var labels$A = {
	title: "Annuler l'abonnement",
	cancelReason: "Motif d'annulation",
	endOn: "Fin sur",
	endImmediately: "Fin immédiate",
	cancel: "Annuler",
	subCancellation: {
		goBack: "Retourner"
	}
};
var messages$B = {
	subscriptionEnd: "Cet abonnement doit expirer le",
	cancelWhen: "Quand voulez-vous annuler?",
	cancelNow: "Cancel Subscription Now",
	cancelLater: "Annuler l'abonnement maintenant",
	subCancellation: {
		isSureToCancelNow: "Êtes-vous sûr de vouloir résilier votre abonnement immédiatement?",
		isSureToCancel: "Êtes-vous sûr de vouloir résilier votre abonnement?",
		loading: "Annulation de votre abonnement",
		success: "L'abonnement a été annulé avec succès",
		error: "Erreur lors de l'annulation de votre abonnement"
	}
};
var subscriptionCancel_fr = {
	labels: labels$A,
	messages: messages$B
};

var labels$z = {
	inviteMembers: "Inviter des membres",
	listOfMembers: "Liste des membres",
	invite: "Inviter",
	remove: "Retirer",
	emails: "Saisir les e-mails",
	status: "Statut",
	actions: "Actions",
	email: "E-mail",
	listNote: "Liste séparée par des virgules, par ex."
};
var subscriptionManageMembers_fr = {
	labels: labels$z
};

var labels$y = {
	title: "Suspendre l'abonnement",
	suspensionDate: "Date de suspension",
	subCancellation: {
		goBack: "Revenir en arrière"
	}
};
var messages$A = {
	suspensionEnd: "La suspension doit expirer le",
	suspendNow: "Suspendre l'abonnement maintenant",
	suspendLater: "Suspendre à la fin de la période",
	subCancellation: {
		isSureToSuspendNow: "Êtes-vous sûr de vouloir suspendre votre abonnement immédiatement ?",
		isSureToSuspend: "Êtes-vous sûr de vouloir suspendre votre abonnement ?",
		loading: "Suspension de votre abonnement",
		success: "L'abonnement a été suspendu avec succès",
		error: "Erreur lors de la suspension de votre abonnement"
	}
};
var subscriptionSuspend_fr = {
	labels: labels$y,
	messages: messages$A
};

var validation$1 = {
	validEmail: "이메일 주소가 유효하지 않습니다.",
	validUsername: "사용자 이름이 유효하지 않습니다.",
	enterEmail: "이메일 주소는 필수 항목입니다.",
	enterEmails: "이메일 주소가 필요합니다.",
	enterUsername: "사용자 이름이 필요합니다.",
	enterPassword: "비밀번호는 필수 항목입니다.",
	enterFirstName: "이름은 필수 항목입니다.",
	enterLastName: "성은 필수 항목입니다.",
	enterPhone: "전화번호는 필수 항목입니다."
};
var buttons$9 = {
	account: "내 계정",
	login: "로그인",
	subscribe: "구독하다"
};
var dashboard$2 = {
	labels: {
		menu: "Pelcro 메뉴",
		name: "이름",
		email: "이메일",
		plan: "요금제",
		description: "설명",
		expiry: "만료",
		status: "상태",
		logout: "로그아웃",
		dashboard: "대시보드",
		unsubscribe: "멤버십 취소",
		reactivate: "재활성화",
		renew: "갱신",
		support: "지원",
		account: "계정",
		subscriptions: "유료 멤버십",
		updatePaymentSource: "업데이트",
		updateProfile: "업데이트",
		updateAddress: "업데이트",
		redeemGift: "선물 사용",
		address: "주소",
		paymentSource: "결제 카드",
		actions: "조치",
		expiresOn: "만료일:",
		renewsOn: "갱신일:",
		isSureToCancel: "정말로 유료 멤버십을 취소하시겠습니까?"
	},
	messages: {
		yourDashboard: "내 Pelcro 대시보드"
	},
	errors: {
		"": ""
	}
};
var select$3 = {
	messages: {
		alreadyHaveAccount: "이미 계정이 있습니까?",
		loginHere: "여기에서 로그인하세요.",
		checkbox: "이 유료 멤버십을 선물하려면 체크하세요."
	},
	labels: {
		plan: {
			title: "요금제 가입하기",
			subtitle: "아래 요금제 중 하나를 선택하고 다음을 클릭하세요."
		},
		product: {
			title: "상품 가입하기",
			subtitle: "아래 상품 중 하나를 선택하고 다음을 클릭하세요."
		},
		selectProduct: "상품 선택",
		selectPlan: "요금제 선택",
		startingAt: "시작일:"
	},
	buttons: {
		next: "다음",
		select: "선택",
		back: "뒤로"
	}
};
var confirm$5 = {
	buttons: {
		"continue": "콘텐츠로 돌아가기"
	},
	labels: {
		title: "주문해주셔서 감사합니다!",
		subtitle: "주문하신 상품이 곧 배송될 예정입니다."
	},
	giftSent: "귀하의 선물은 ",
	successfully: "님께 선택하신 날짜에 발송될 예정입니다."
};
var common_ko = {
	validation: validation$1,
	buttons: buttons$9,
	dashboard: dashboard$2,
	select: select$3,
	confirm: confirm$5
};

var update$1 = {
	title: "결제 정보 업데이트",
	subtitle: "신용카드 정보를 업데이트하려면 아래 항목을 입력하십시오.",
	required: "필수 항목",
	success: "귀하의 결제 정보가 업데이트되었습니다.",
	secure: "PCI 준수 128비트 SSL 인증서로 보호됩니다. 제공: "
};
var select$2 = {
	title: "결제 수단 선택",
	subtitle: "저장된 결제 수단 중 선택하거나 새로운 수단을 사용하십시오.",
	expires: "만료일:",
	buttons: {
		addPaymentMethod: "다른 결제 수단으로 결제",
		selectPaymentMethod: "계속",
		changePaymentMethod: "변경"
	}
};
var create$3 = {
	title: "새 결제 방법 추가",
	subtitle: "신용카드 정보를 추가하려면 아래 입력란을 입력하세요."
};
var paymentMethod_ko = {
	update: update$1,
	select: select$2,
	"delete": {
	title: "결제 방법 삭제",
	subtitle: "이 결제 방법은 활성 구독과 연결되거나 기본 결제 방법으로 사용될 수 있습니다. 아래에서 사용 가능한 옵션 중에서 선택하여 대체하세요.",
	options: {
		select: "기존 결제 방법 선택",
		add: "새 결제 방법 추가"
	},
	paymentMethodReplaced: "결제 방법 삭제 및 교체 성공"
},
	create: create$3
};

var title$h = "Frieze 뉴스레터를 구독하려면 이메일을 입력하세요.";
var updateTitle$1 = "뉴스레터 선택 업데이트";
var subtitle$7 = "귀하의 이메일은 다른 마케팅 용도로도 사용됩니다.";
var labels$x = {
	submit: "제출",
	firstName: "이름",
	lastName: "성",
	email: "이메일",
	postalCode: "우편번호",
	required: "필수 항목"
};
var messages$z = {
	alreadyHaveAccount: "이미 계정이 있습니까?",
	success: "뉴스레터가 성공적으로 업데이트되었습니다.",
	loginHere: "여기에서 로그인하세요.",
	createAnAccount: " 계정을 만들려면 여기를 ",
	here: "클릭하세요."
};
var newsletter_ko = {
	title: title$h,
	updateTitle: updateTitle$1,
	subtitle: subtitle$7,
	labels: labels$x,
	messages: messages$z
};

var labels$w = {
	"continue": "콘텐츠로 돌아가기"
};
var messages$y = {
	yourFreeTrial: "유료 멤버십에 가입하셨습니다!",
	youHaveAccess: "멤버십 혜택을 즐기시기를 바라며, 질문이나 문의 사항이 있으면 저희에게 연락주십시오.",
	clickToLearn: {
		click: "여기를",
		here: "클릭하여",
		toLearn: "자세히 알아보거나 ",
		forQuestion: "를 통해 당사에 문의주십시오."
	},
	giftCreate: {
		title: "귀하의 선물이 전송되었습니다.",
		content: "선물 사용 방법이 안내된 이메일이 받는 사람에게 전송됩니다."
	},
	giftRedeem: {
		title: "축하합니다!",
		content: "선물받은 유료 멤버십을 성공적으로 사용하셨습니다. 이제 즐겨보세요!"
	},
	invoicePayment: {
		title: "인보이스 지불에 성공했습니다.",
		content: "질문이나 문의 사항이 있으면 저희에게 연락주시기 바랍니다."
	}
};
var errors$9 = {
	"": ""
};
var success_ko = {
	labels: labels$w,
	messages: messages$y,
	errors: errors$9
};

var messages$x = {
	freeVisits: "남은 무료 방문 기간:",
	subscribeNow: "멤버십 가입",
	alreadyHaveAccount: "이미 계정이 있습니까?",
	loginHere: "여기에서 로그인하세요."
};
var errors$8 = {
	"": ""
};
var meter_ko = {
	messages: messages$x,
	errors: errors$8
};

var messages$w = {
	youAreSafe: "PCI 준수 128비트 SSL 인증서로 보호됩니다. 제공: ",
	bankRedirection: "잠시만 기다려 주십시오. 결제 은행으로 연결 중입니다.",
	bankAuthenticationSuccess: "요청을 처리하는 동안 기다려 주십시오."
};
var labels$v = {
	card: "카드 번호 입력",
	date: "만료일",
	CVC: "CVC",
	required: "필수 항목",
	submit: "제출",
	pay: "결제",
	addCode: "쿠폰 코드 추가",
	hideCode: "숨기기",
	codePlaceholder: "쿠폰 코드 입력",
	applyCouponCode: "적용",
	code: "쿠폰 코드",
	"for": "관련",
	interval: "{{count}} {{interval}}",
	interval_plural: "{{count}} {{interval}}",
	tax: "세금",
	removeCoupon: "제거",
	firstName: "이름",
	lastName: "성",
	phone: "핸드폰",
	freeItems: "무료 아이템",
	isDefault: "기본값으로 설정"
};
var checkoutForm_ko = {
	messages: messages$w,
	labels: labels$v
};

var youAreSafe$1 = "PCI 준수 128비트 SSL 인증서로 보호됩니다. 제공: ";
var cancel$1 = "유료 멤버십은 언제든 온라인으로 취소가 가능합니다.";
var giftSent$1 = "유료 멤버십 선물이 ";
var successfully$1 = "님께 성공적으로 전송되었습니다.";
var entitlement$1 = "이 페이지의 일부 콘텐츠는 하나 이상의 요금제 가입 시 이용이 가능합니다. 전체 페이지에 액세스하려면 지금 <1> 멤버십에 가입 </1>하세요.";
var recaptcha$1 = "이 사이트는 reCAPTCHA로 보호되며, Google <1>개인정보 보호정책</1> 및 <3>서비스 약관</3>이 적용됩니다.";
var invalidInvoice$1 = "유효하지 않은 인보이스 ID입니다. 지원팀에 문의하십시오.";
var invalidSubscription = "잘못된 구독 ID입니다. 지원팀에 문의하세요.";
var zeroTotalInvoice$1 = "0$인 인보이스는 열람할 수 없습니다.";
var messages_ko = {
	youAreSafe: youAreSafe$1,
	cancel: cancel$1,
	giftSent: giftSent$1,
	successfully: successfully$1,
	entitlement: entitlement$1,
	recaptcha: recaptcha$1,
	invalidInvoice: invalidInvoice$1,
	invalidSubscription: invalidSubscription,
	zeroTotalInvoice: zeroTotalInvoice$1
};

var labels$u = {
	email: "이메일 입력",
	username: "사용자 이름 입력",
	password: "비밀번호 입력",
	required: "필수 항목",
	emailPlaceholder: "이메일",
	passwordPlaceholder: "비밀번호",
	login: "로그인"
};
var messages$v = {
	loginTo: "귀하의 계정에 로그인",
	welcome: "반갑습니다. 귀하의 기존 계정으로 로그인하세요.",
	dontHaveAccount: "아직 계정이 없으신가요?",
	createAccount: "계정을 만드실 수 있습니다.",
	forgotPassword: "비밀번호를 잊으셨나요?",
	reset: {
		click: "여기를",
		here: "클릭하여",
		toReset: "재설정하십시오."
	},
	socialLogin: {
		label: "다음을 계속 사용: "
	}
};
var errors$7 = {
	"": ""
};
var login_ko = {
	labels: labels$u,
	messages: messages$v,
	errors: errors$7
};

var labels$t = {
	title: "비밀번호 없는 링크 확인",
	instructions: "가는 중입니다!\n이메일 주소를 확인하겠습니다.\n이메일로 전송된 확인 링크를 클릭하세요.",
	resend: "이메일 재전송"
};
var messages$u = {
	resent: "성공적으로 재전송",
	success: "성공적으로 로그인했습니다"
};
var verifyLinkToken_ko = {
	labels: labels$t,
	messages: messages$u
};

var title$g = "계정 만들기";
var subtitle$6 = "아래에 이메일과 비밀번호를 입력하세요.";
var labels$s = {
	signUpFacebook: "Facebook으로 가입하기",
	signUpGoogle: "Google로 가입하기",
	signUpEmail: "이메일로 가입하기",
	password: "비밀번호",
	email: "이메일",
	passwordPlaceholder: "비밀번호 설정",
	emailPlaceholder: "이메일 입력",
	required: "필수 항목",
	firstName: "이름",
	lastName: "성",
	phone: "핸드폰"
};
var messages$t = {
	alreadyHaveAccount: "이미 계정이 있습니까?",
	createAccount: "계정 만들기",
	loginHere: "여기에서 로그인하세요.",
	selectPlan: "다른 요금제를 선택하세요.",
	here: "여기",
	iAgree: {
		iAgree: "본인은",
		terms: "서비스 약관",
		and: "및",
		privacy: "개인정보 보호정책에 동의합니다."
	},
	preferDisable: {
		click: "여기를",
		here: "클릭하여",
		ifPrefer: "광고 차단기를 비활성화하실 수 있습니다."
	},
	socialLogin: {
		label: "다음을 계속 사용: "
	}
};
var errors$6 = {
	"": ""
};
var gift$1 = {
	titles: {
		firstTitle: "아래에 받는 사람 정보를 입력하세요."
	},
	labels: {
		firstName: "이름",
		lastName: "성",
		email: "이메일",
		startDate: "선물 날짜",
		giftMessage: "선물 메시지(남은 글자 수: {{count}})",
		required: "필수 항목",
		firstNamePlaceholder: "이름",
		lastNamePlaceholder: "성",
		emailPlaceholder: "이메일 주소"
	},
	buttons: {
		gift: "선물"
	},
	messages: {
		enterEmail: "선물을 받을 분의 이메일을 입력해주세요.",
		invalidDate: "선물 날짜는 오늘로부터 1년 이내여야 합니다.",
		giftDateInfo: "받는 분이 선물을 사용하실 수 있도록, 선택된 날짜에 귀하의 선물 메시지가 담겨 있는 이메일 알림이 전송됩니다.",
		giftMessageInfo: "받는 분을 위한 선물 메시지와 서명을 남기는 것을 잊지 마시기 바랍니다."
	}
};
var redeem$1 = {
	titles: {
		firstTitle: "선물 사용하기",
		secondTitle: "아래에 선물 코드를 입력하세요."
	},
	labels: {
		code: "선물 코드 입력",
		codePlaceholder: "선물 코드",
		required: "필수 항목"
	},
	buttons: {
		redeem: "선물 사용"
	},
	footer: {
		click: "여기를",
		here: "클릭하여",
		toAdd: "주소를 추가하세요."
	},
	messages: {
		enterGiftCode: "선물 코드를 입력해 주십시오."
	}
};
var register_ko = {
	title: title$g,
	subtitle: subtitle$6,
	labels: labels$s,
	messages: messages$t,
	errors: errors$6,
	gift: gift$1,
	redeem: redeem$1
};

var labels$r = {
	title: "프로파일을 업데이트하시겠습니까?",
	subtitle: "프로필을 업데이트하려면 아래 정보를 입력하세요.",
	email: "이메일",
	firstName: "이름",
	lastName: "성",
	username: "사용자 이름",
	displayname: "이름 표시하기",
	phone: "전화번호",
	submit: "제출",
	required: "필수 항목",
	cropperTitle: "프로필 사진 업데이트",
	cropperSubtitle: "사진을 업로드한 다음 알맞은 크기로 조정하세요.",
	save: "사진 업로드",
	selectImage: "새로운 사진 업로드",
	removeImage: "기존 사진 제거",
	zoom: "확대",
	tin: "세금 식별 번호"
};
var messages$s = {
	userUpdated: "감사합니다! 프로필이 성공적으로 업데이트되었습니다.",
	pictureRemoved: "귀하의 프로필 사진이 제거되었습니다.",
	pictureUpdated: "귀하의 프로필 사진이 업데이트되었습니다."
};
var userEdit_ko = {
	labels: labels$r,
	messages: messages$s
};

var title$f = "배송 주소를 입력하십시오.";
var titleGifting$1 = "주소를 입력하세요";
var selectAddressTitle$1 = "주소를 선택하십시오.";
var selectAddressSubtitle$1 = "저장된 주소에서 선택하거나 새 주소를 추가하십시오.";
var labels$q = {
	address: "주소",
	code: "우편번호",
	city: "도시",
	region: "시/도/지역",
	country: "국가",
	firstName: "이름",
	lastName: "성",
	required: "필수 항목",
	isDefault: "기본값으로 설정"
};
var buttons$8 = {
	submit: "제출",
	selectAddress: "주소 선택",
	addAddress: "새 주소 추가"
};
var messages$r = {
	addressUpdated: "주소가 성공적으로 업데이트되었습니다!",
	subRedeemed: "귀하의 유료 멤버십이 사용되었습니다."
};
var address_ko = {
	title: title$f,
	titleGifting: titleGifting$1,
	selectAddressTitle: selectAddressTitle$1,
	selectAddressSubtitle: selectAddressSubtitle$1,
	labels: labels$q,
	buttons: buttons$8,
	messages: messages$r
};

var title$e = "비밀번호 재설정";
var subtitle$5 = "아래에 새 비밀번호 입력";
var email$5 = "이메일";
var password$3 = "비밀번호";
var confirmPassword$1 = "비밀번호 확인";
var submit$7 = "제출";
var required$7 = "필수 항목";
var passwordUpdated$1 = "비밀번호가 업데이트되었습니다. 새 비밀번호로 로그인하세요.";
var passwordReset_ko = {
	title: title$e,
	subtitle: subtitle$5,
	email: email$5,
	password: password$3,
	confirmPassword: confirmPassword$1,
	submit: submit$7,
	required: required$7,
	passwordUpdated: passwordUpdated$1
};

var title$d = "비밀번호를 잊으셨나요?";
var email$4 = "이메일";
var password$2 = "비밀번호";
var submit$6 = "제출";
var required$6 = "필수 항목";
var passwordResetEmailSent$1 = "비밀번호 재설정 안내가 귀하의 이메일로 발송되었습니다.";
var messages$q = {
	alreadyHaveAccount: "이미 계정이 있습니까?",
	loginHere: "여기에서 로그인하세요."
};
var passwordForgot_ko = {
	title: title$d,
	email: email$4,
	password: password$2,
	submit: submit$6,
	required: required$6,
	passwordResetEmailSent: passwordResetEmailSent$1,
	messages: messages$q
};

var title$c = "비밀번호를 변경합니다.";
var currentPassword$1 = "기존 비밀번호";
var newPassword$1 = "새 비밀번호";
var confirmNewPassword$1 = "새 비밀번호 확인";
var submit$5 = "비밀번호 변경";
var required$5 = "필수 항목";
var passwordChanged$1 = "비밀번호가 변경되었습니다. 새 비밀번호로 로그인하세요.";
var passwordsNotMatching$1 = "비밀번호가 일치하지 않습니다.";
var weakPassword$1 = "비밀번호는 6자 이상이어야 합니다.";
var passwordChange_ko = {
	title: title$c,
	currentPassword: currentPassword$1,
	newPassword: newPassword$1,
	confirmNewPassword: confirmNewPassword$1,
	submit: submit$5,
	required: required$5,
	passwordChanged: passwordChanged$1,
	passwordsNotMatching: passwordsNotMatching$1,
	weakPassword: weakPassword$1
};

var title$b = "비밀번호 없는 로그인";
var email$3 = "이메일 입력";
var submit$4 = "제출";
var required$4 = "필수 항목";
var messages$p = {
	PasswordlessLoginSuccess: "비밀번호 없는 로그인으로 성공적으로 인증되었습니다."
};
var passwordlessRequest_ko = {
	title: title$b,
	email: email$3,
	submit: submit$4,
	required: required$4,
	messages: messages$p
};

var title$a = "귀하의 장바구니";
var subtitle$4 = "아래에서 결제를 진행하세요.";
var name$1 = "이름";
var quantity$1 = "수량";
var price$1 = "가격";
var actions$2 = "조치";
var remove$1 = "제거";
var total$1 = "총계";
var confirm$4 = "체크아웃";
var empty$1 = "장바구니가 비었습니다.";
var removeAll$1 = "모두 제거";
var cart_ko = {
	title: title$a,
	subtitle: subtitle$4,
	name: name$1,
	quantity: quantity$1,
	price: price$1,
	actions: actions$2,
	remove: remove$1,
	total: total$1,
	confirm: confirm$4,
	empty: empty$1,
	removeAll: removeAll$1
};

var buttons$7 = {
	select: "선택",
	added: "장바구니에 추가",
	purchase: "구매",
	"continue": "계속"
};
var messages$o = {
	orderConfirmed: {
		title: "주문이 확인되었습니다!",
		body: "귀하의 주문이 확인되었으며 며칠 안에 배송될 예정입니다. 이 주문의 확인 이메일이 귀하에게 전송됩니다."
	},
	haveQuestions: "질문이 있으면 언제든 저희에게 연락주시기 바랍니다!",
	multipleCurrencies: "장바구니에 다른 통화로만 결제가 가능한 아이템이 있습니다. 결제를 계속 진행하려면 모든 아이템의 결제 통화가 동일한지 확인하십시오.",
	currencyMismatch: "선택하신 아이템(들)이 귀하가 설정한 기본 통화({{currency}})와 일치하지 않습니다. 기본 통화와 일치하는 아이템(들)만 선택하십시오."
};
var labels$p = {
	summary: "주문 요약",
	total: "총계"
};
var shop_ko = {
	buttons: buttons$7,
	messages: messages$o,
	labels: labels$p
};

var labels$o = {
	cardNumber: "카드 번호",
	securityCode: "보안 코드",
	submit: "제출",
	months: {
		jan: "1월",
		feb: "2월",
		mar: "3월",
		apr: "4월",
		may: "5월",
		jun: "6월",
		jul: "7월",
		aug: "8월",
		sep: "9월",
		oct: "10월",
		nov: "11월",
		dec: "12월"
	},
	checkout: {
		title: "결제 정보"
	}
};
var messages$n = {
	youAreSafe: "PCI 준수 128비트 SSL 인증서로 보호됩니다. 제공: ",
	cancel: "유료 멤버십은 언제든 온라인으로 취소가 가능합니다.",
	giftSent: "유료 멤버십 선물이 ",
	successfully: "님께 성공적으로 전송되었습니다.",
	sourceCreated: "결제 정보가 추가되었습니다.",
	sourceUpdated: "귀하의 결제 정보가 업데이트되었습니다.",
	cardAuthFailed: "해당 결제 수단은 인증할 수 없습니다. 다른 결제 수단을 선택하여 다시 시도해보시기 바랍니다.",
	cardAuthNotSupported: "인증이 요구되는 결제 수단으로의 업데이트는 현재 지원되지 않습니다. 다른 결제 수단을 이용하거나 고객센터로 문의하시기 바랍니다.",
	tryAgainFromInvoice: "결제를 인증할 수 없지만 구독이 생성되었습니다. 대시보드에서 다른 결제 수단을 사용하여 인보이스 결제를 시도하세요."
};
var errors$5 = {
	"": ""
};
var payment_ko = {
	labels: labels$o,
	messages: messages$n,
	errors: errors$5
};

var labels$n = {
	menu: "Pelcro 메뉴",
	name: "이름",
	email: "이메일",
	plan: "요금제",
	description: "설명",
	expiry: "만료",
	status: {
		title: "상태",
		active: "활성화",
		inTrial: "체험판 사용",
		endingSoon: "만료 예정",
		scheduled: "예약",
		incomplete: "불완전한"
	},
	manageMembers: "회원 관리",
	shipments: "남은 배송 일정",
	logout: "로그아웃",
	dashboard: "대시보드",
	unsubscribe: "취소",
	reactivate: "재활성화",
	renew: "갱신",
	suspend: "유예하다",
	unsuspend: "일시 중단 해제",
	support: "지원",
	account: "계정",
	purchases: "구매",
	subscriptions: "유료 멤버십",
	donations: "기부",
	memberships: "멤버십",
	invoices: "인보이스",
	details: "세부 정보",
	view: "보기",
	paid: "결제 완료",
	open: "열기",
	draft: "임시 저장",
	scheduled: "예약",
	uncollectible: "사용 불가",
	"void": "무효",
	pastDue: "연체",
	updatePaymentSource: "업데이트",
	profile: "프로필",
	updateProfile: "프로필 편집",
	changePassword: "비밀번호 변경",
	editNewsletters: "뉴스레터 편집",
	myQRCode: "내 QR 코드",
	shipping: "배송",
	billing: "청구",
	edit: "편집",
	gifts: "선물",
	redeemGift: "선물 사용",
	address: "주소",
	addresses: "주소들",
	myProfile: "내 프로필",
	paymentSource: "결제 카드",
	actions: "조치",
	expiresOn: "종료",
	until: "까지",
	startsOn: "시작",
	startDate: "시작일",
	renewsOn: "갱신",
	canceledOn: "취소일",
	recipient: "받는 사람",
	addAddress: "주소 추가",
	addSubscription: "새 유료 멤버십",
	addGift: "새 선물",
	orders: {
		label: "주문",
		noOrders: "주문하신 내역이 없습니다.",
		total: "총계",
		date: "날짜",
		details: "세부 정보",
		itemsAmount: "{{count}} 아이템",
		itemsAmount_plural: "{{count}} 아이템"
	},
	savedItems: {
		label: "저장 및 팔로우 완료",
		noSavedItems: "저장된 아이템이 없습니다.",
		categories: "종류",
		details: "세부 정보",
		removeItem: "제거"
	},
	subCancellation: {
		goBack: "뒤로 가기"
	}
};
var shipments = "남은 배송 일정";
var logout = "로그아웃";
var dashboard$1 = "대시보드";
var unsubscribe = "취소";
var reactivate = "재활성화";
var renew = "갱신";
var support = "지원";
var account = "계정";
var purchases = "구매";
var subscriptions = "유료 멤버십";
var donations = "기부";
var invoices = "인보이스";
var details = "세부 정보";
var view = "보기";
var paid = "결제 완료";
var open = "열기";
var draft = "임시 저장";
var scheduled = "예약";
var uncollectible = "사용 불가";
var pastDue = "연체";
var updatePaymentSource = "업데이트";
var profile = "프로필";
var updateProfile = "프로필 편집";
var changePassword = "비밀번호 변경";
var editNewsletters = "뉴스레터 편집";
var edit = "편집";
var gifts = "선물";
var redeemGift = "선물 사용";
var address = "주소";
var addresses = "주소들";
var myProfile = "내 프로필";
var paymentSource = "결제 카드";
var actions$1 = "조치";
var expiresOn = "종료";
var startsOn = "시작";
var startDate = "시작일";
var renewsOn = "갱신";
var canceledOn = "취소일";
var recipient = "받는 사람";
var addAddress = "주소 추가";
var editAddress = "주소 수정";
var addSubscription = "새 유료 멤버십";
var addGift = "새 선물";
var orders = {
	label: "주문",
	noOrders: "주문하신 내역이 없습니다.",
	total: "총계",
	date: "날짜",
	details: "세부 정보",
	itemsAmount: "{{count}} 아이템",
	itemsAmount_plural: "{{count}} 아이템"
};
var savedItems = {
	label: "저장 및 팔로우 완료",
	noSavedItems: "저장된 아이템이 없습니다.",
	categories: "종류",
	details: "세부 정보",
	removeItem: "제거"
};
var subCancellation = {
	goBack: "뒤로 가기"
};
var messages$m = {
	noCard: "등록된 카드가 없습니다.",
	subCancellation: {
		isSureToCancel: "정말로 유료 멤버십을 취소하시겠습니까?",
		loading: "귀하의 유료 멤버십을 취소합니다.",
		success: "유료 멤버십이 성공적으로 취소되었습니다.",
		error: "유료 멤버십 취소 과정에서 오류가 발생했습니다."
	},
	subReactivation: {
		success: "구독이 성공적으로 재활성화되었습니다.",
		error: "구독을 재활성화하는 동안 오류가 발생했습니다."
	},
	subUnSuspend: {
		isSureToUnSuspend: "구독 일시 중단을 해제하시겠습니까?",
		loading: "구독 일시 중단 해제",
		success: "구독이 성공적으로 일시 중단 해제되었습니다",
		error: "구독 일시 중단을 해제하는 동안 오류가 발생했습니다."
	}
};
var dashboard_ko = {
	labels: labels$n,
	shipments: shipments,
	logout: logout,
	dashboard: dashboard$1,
	unsubscribe: unsubscribe,
	reactivate: reactivate,
	renew: renew,
	support: support,
	account: account,
	purchases: purchases,
	subscriptions: subscriptions,
	donations: donations,
	invoices: invoices,
	details: details,
	view: view,
	paid: paid,
	open: open,
	draft: draft,
	scheduled: scheduled,
	uncollectible: uncollectible,
	"void": "무효",
	pastDue: pastDue,
	updatePaymentSource: updatePaymentSource,
	profile: profile,
	updateProfile: updateProfile,
	changePassword: changePassword,
	editNewsletters: editNewsletters,
	edit: edit,
	gifts: gifts,
	redeemGift: redeemGift,
	address: address,
	addresses: addresses,
	myProfile: myProfile,
	paymentSource: paymentSource,
	actions: actions$1,
	expiresOn: expiresOn,
	startsOn: startsOn,
	startDate: startDate,
	renewsOn: renewsOn,
	canceledOn: canceledOn,
	recipient: recipient,
	addAddress: addAddress,
	editAddress: editAddress,
	addSubscription: addSubscription,
	addGift: addGift,
	"default": "기본",
	orders: orders,
	savedItems: savedItems,
	subCancellation: subCancellation,
	messages: messages$m
};

var messages$l = {
	alreadyHaveAccount: "이미 계정이 있습니까?",
	loginHere: "여기에서 로그인하세요.",
	checkbox: "이 유료 멤버십을 선물하려면 체크하세요."
};
var labels$m = {
	plan: {
		title: "요금제 가입하기",
		subtitle: "아래 요금제 중 하나를 선택하고 다음을 클릭하세요."
	},
	product: {
		title: "상품 가입하기",
		subtitle: "아래 상품 중 하나를 선택하고 다음을 클릭하세요."
	},
	selectProduct: "상품 선택",
	selectPlan: "요금제 선택",
	startingAt: "시작일:",
	restrictiveArticles: {
		subscribeTo: "이 페이지에 액세스하려면 다음 요금제 중 하나에 가입하거나",
		or: "아래에서 다른 상품을 선택해주시기 바랍니다."
	}
};
var buttons$6 = {
	next: "다음",
	select: "선택",
	back: "뒤로"
};
var select_ko = {
	messages: messages$l,
	labels: labels$m,
	buttons: buttons$6
};

var confirm$3 = {
	labels: {
		confirm: "확인",
		close: "닫기"
	}
};
var notification_ko = {
	confirm: confirm$3
};

var labels$l = {
	title: "이메일 주소를 인증하세요.",
	instructions: "거의 완료되었습니다!\n이메일 주소만 인증하면 됩니다.\n다음 이메일 주소로 전송된 인증 링크를 클릭해 주십시오:",
	resend: "이메일 재전송"
};
var messages$k = {
	resent: "재전송 완료",
	success: "이메일 주소가 인증되었습니다!"
};
var verifyEmail_ko = {
	labels: labels$l,
	messages: messages$k
};

var title$9 = "인보이스 세부 정보";
var labels$k = {
	summary: "요약",
	total: "총계",
	amountPaid: "지불된 금액",
	amountDue: "지불액",
	creationDate: "생성일:"
};
var buttons$5 = {
	download: "다운로드",
	pay: "지금 지불"
};
var invoiceDetails_ko = {
	title: title$9,
	labels: labels$k,
	buttons: buttons$5
};

var labels$j = {
	title: "구독 취소",
	cancelReason: "취소 사유",
	endOn: "종료",
	endImmediately: "즉시 종료",
	cancel: "취소",
	subCancellation: {
		goBack: "돌아가기"
	}
};
var messages$j = {
	subscriptionEnd: "이 구독은 다음 날짜에 만료되도록 설정되었습니다.",
	cancelWhen: "언제 취소하시겠습니까?",
	cancelNow: "지금 구독 취소",
	cancelLater: "기간 종료 시 취소",
	subCancellation: {
		isSureToCancelNow: "구독을 즉시 취소하시겠습니까?",
		isSureToCancel: "구독을 취소하시겠습니까?",
		loading: "구독 취소",
		success: "구독이 성공적으로 취소되었습니다.",
		error: "구독 취소 중 오류 발생"
	}
};
var subscriptionCancel_ko = {
	labels: labels$j,
	messages: messages$j
};

var labels$i = {
	inviteMembers: "회원 초대",
	listOfMembers: "구성원 목록",
	invite: "초대",
	remove: "제거하다",
	emails: "이메일 입력",
	status: "상태",
	actions: "행위",
	email: "이메일",
	listNote: "쉼표로 구분된 목록입니다."
};
var subscriptionManageMembers_ko = {
	labels: labels$i
};

var labels$h = {
	title: "구독 중단",
	suspensionDate: "중단 날짜",
	subCancellation: {
		goBack: "돌아가기"
	}
};
var messages$i = {
	suspensionEnd: "일시 중지가 만료되도록 설정되었습니다.",
	suspendNow: "지금 구독 일시 중단",
	suspendLater: "기간 종료 시 일시 중단",
	subCancellation: {
		isSureToSuspendNow: "구독을 즉시 중단하시겠습니까?",
		isSureToSuspend: "구독을 일시 중단하시겠습니까?",
		loading: "구독 일시 중단",
		success: "구독이 성공적으로 일시 중단되었습니다",
		error: "구독을 일시 중단하는 동안 오류가 발생했습니다."
	}
};
var subscriptionSuspend_ko = {
	labels: labels$h,
	messages: messages$i
};

var validation = {
	validEmail: "La dirección de correo no es válida.",
	enterEmail: "La dirección de correo es obligatoria.",
	enterPassword: "La contraseña es obligatoria.",
	confirmPassword: "Confirmar la contraseña es obligatorio.",
	enterFirstName: "El nombre es obligatorio.",
	enterLastName: "El apellido es obligatorio.",
	enterPhone: "El número de teléfono es obligatorio."
};
var buttons$4 = {
	account: "Mi cuenta",
	login: "Iniciar Sesión"
};
var dashboard = {
	labels: {
		menu: "Menú de Pelcro",
		name: "Nombre",
		email: "Correo",
		plan: "Plan",
		description: "Descripción",
		expiry: "Expiración",
		status: "Estado",
		logout: "Cerrar sesión",
		dashboard: "Panel",
		unsubscribe: "Cancelar suscripción",
		reactivate: "Reactivar",
		renew: "Renovar",
		support: "Soporte",
		account: "Cuenta",
		subscriptions: "Suscripciones",
		updatePaymentSource: "Actualización",
		updateProfile: "Actualización",
		updateAddress: "Actualización",
		redeemGift: "Redimir regalo",
		address: "Dirección",
		paymentSource: "Datos de pago",
		actions: "Acciones",
		expiresOn: "Expira el",
		renewsOn: "Se renueva el",
		isSureToCancel: "¿Estás seguro de que quieres cancelar tu suscripción?"
	},
	messages: {
		yourDashboard: "Tu Panel de Pelcro"
	},
	errors: {
		"": ""
	}
};
var select$1 = {
	messages: {
		alreadyHaveAccount: "¿Ya tienes una cuenta?",
		loginHere: "Inicia sesión aquí",
		checkbox: "Marca esta casilla para regalar esta suscripción"
	},
	labels: {
		plan: {
			title: "Suscribirse a un plan",
			subtitle: "Selecciona uno de los planes a continuación y pulsa en siguiente."
		},
		product: {
			title: "Suscribirse a un producto",
			subtitle: "Selecciona uno de los productos a continuación y pulsa en siguiente."
		},
		selectProduct: "Selecciona un producto",
		selectPlan: "Selecciona un plan",
		startingAt: "Inicial el"
	},
	buttons: {
		next: "Siguiente",
		select: "Seleccionar dirección",
		back: "Volver"
	}
};
var confirm$2 = {
	buttons: {
		"continue": "Continuar al contenido"
	},
	labels: {
		title: "¡Gracias por tu orden!",
		subtitle: "Tus artículos estarán en camino en breve."
	},
	giftSent: "El regalo será enviado a",
	successfully: "en la fecha que especificaste."
};
var common_es = {
	validation: validation,
	buttons: buttons$4,
	dashboard: dashboard,
	select: select$1,
	confirm: confirm$2
};

var update = {
	title: "Actualiza tu información de pago",
	subtitle: "Rellena los campos a continuación para actualizar la información de tu tarjeta de crédito",
	required: "Obligatorio",
	success: "Tu información de pago se ha actualizado",
	secure: "Estás seguro - PCI compliance 128 SSL por"
};
var select = {
	title: "Selecciona un método de pago",
	subtitle: "Selecciona uno de tus métodos guardados o paga con uno nuevo",
	expires: "Expira",
	buttons: {
		addPaymentMethod: "Paga con otro método de pago",
		selectPaymentMethod: "Continuar",
		changePaymentMethod: "Cambiar"
	}
};
var create$2 = {
	title: "Añadir un nuevo método de pago",
	subtitle: "Introduzca los campos siguientes para añadir los datos de su tarjeta de crédito"
};
var paymentMethod_es = {
	update: update,
	select: select,
	"delete": {
	title: "Eliminar método de pago",
	subtitle: "Este método de pago podría estar asociado a suscripciones activas o servir como método de pago predeterminado. Elija entre las opciones disponibles a continuación para sustituirlo.",
	options: {
		select: "Seleccione un método de pago existente",
		add: "Añadir un nuevo método de pago"
	},
	paymentMethodReplaced: "Método de pago eliminado y sustituido correctamente"
},
	create: create$2
};

var title$8 = "Ingresa tu correo para suscribirte a nuestro boletín";
var updateTitle = "Actualizar selecciones del boletín";
var subtitle$3 = "Podríamos usar tu dirección de correo para otras comunicaciones de marketing";
var labels$g = {
	submit: "Enviar",
	firstName: "Nombre",
	lastName: "Apellido",
	email: "Correo",
	postalCode: "Código postal",
	required: "obligatorio"
};
var messages$h = {
	alreadyHaveAccount: "¿Ya tienes una cuenta?",
	success: "El boletín se actualizó con éxito",
	loginHere: "Inicia sesión aquí.",
	createAnAccount: " Crea una cuenta pulsando ",
	here: "aquí"
};
var newsletter_es = {
	title: title$8,
	updateTitle: updateTitle,
	subtitle: subtitle$3,
	labels: labels$g,
	messages: messages$h
};

var labels$f = {
	"continue": "Continuar al contenido"
};
var messages$g = {
	yourFreeTrial: "¡Suscripción exitosa!",
	youHaveAccess: "Esperamos que disfrutes de tu suscripción. Por favor, contáctanos si tienes alguna pregunta o inquietud.",
	clickToLearn: {
		click: "Pulsa",
		here: "aquí",
		toLearn: "para saber más o contactarnos",
		forQuestion: "para cualquier pregunta."
	},
	giftCreate: {
		title: "Tu regalo ha sido enviado",
		content: "Tu destinatario pronto recibirá un correo con instrucciones para redimir su regalo."
	},
	giftRedeem: {
		title: "Felicitaciones.",
		content: "Has redimido con éxito tu suscripción de regalo. ¡Que la disfrutes!"
	},
	invoicePayment: {
		title: "Factura pagada con éxito",
		content: "Por favor, contáctanos si tienes alguna pregunta o inquietud."
	}
};
var errors$4 = {
	"": ""
};
var success_es = {
	labels: labels$f,
	messages: messages$g,
	errors: errors$4
};

var messages$f = {
	freeVisits: "Visitas gratuitas restantes:",
	subscribeNow: "Suscribir",
	alreadyHaveAccount: "¿Ya tienes una cuenta?",
	loginHere: "Inicia sesión aquí"
};
var errors$3 = {
	"": ""
};
var meter_es = {
	messages: messages$f,
	errors: errors$3
};

var messages$e = {
	youAreSafe: "Estás seguro - PCI compliance 128 SSL por",
	bankRedirection: "Por favor, espera, estamos redireccionando a tu banco.",
	bankAuthenticationSuccess: "Por favor, espera un momento mientras procesamos tu solicitud."
};
var labels$e = {
	card: "Ingresar número de tarjeta",
	date: "Vencimiento",
	CVC: "CVC",
	required: "obligatorio",
	submit: "Enviar",
	pay: "Pagar",
	addCode: "Agregar un código de cupón",
	hideCode: "Ocultar",
	codePlaceholder: "Ingresa tu código de cupón",
	applyCouponCode: "Aplicar",
	code: "Código de cupón",
	"for": "por",
	interval: "{{count}} {{interval}}",
	interval_plural: "{{count}} {{interval}}",
	tax: "Impuesto",
	removeCoupon: "ELIMINAR",
	firstName: "Nombre",
	lastName: "Apellido",
	phone: "Teléfono",
	freeItems: "Artículos gratis",
	isDefault: "Fijar por defecto"
};
var checkoutForm_es = {
	messages: messages$e,
	labels: labels$e
};

var youAreSafe = "Estás seguro - PCI compliance 128 SSL por";
var cancel = "Cancela tu suscripción en línea en cualquier momento.";
var giftSent = "La suscripción de regalo se ha enviado a";
var successfully = "exitosamente";
var entitlement = "Algunos de los contenidos de está página están disponibles con uno o más de nuestros planes. <1> Suscríbete </1> ahora para obtener acceso completo.";
var recaptcha = "Este sitio está protegido por reCAPTCHA, aplica la <1>Política de Privacidad</1> y los <3>Términos de Servicio</3> de Google.";
var invalidInvoice = "Número de comprobante de pago inválido, por favor contacta a soporte.";
var zeroTotalInvoice = "No puedes ver un comprobante de pago de $0";
var messages_es = {
	youAreSafe: youAreSafe,
	cancel: cancel,
	giftSent: giftSent,
	successfully: successfully,
	entitlement: entitlement,
	recaptcha: recaptcha,
	invalidInvoice: invalidInvoice,
	zeroTotalInvoice: zeroTotalInvoice
};

var labels$d = {
	email: "Ingresar correo",
	password: "Ingresar contraseña",
	required: "obligatorio",
	emailPlaceholder: "Correo",
	passwordPlaceholder: "Contraseña",
	login: "Iniciar Sesión"
};
var messages$d = {
	loginTo: "Inicia sesión en tu cuenta",
	welcome: "Bienvenido de vuelta, inicia sesión con tu cuenta existente.",
	dontHaveAccount: "¿Aún no tienes una cuenta?",
	createAccount: "Crear una cuenta.",
	forgotPassword: "¿Olvidaste tu contraseña?",
	reset: {
		click: "Pulsa",
		here: "aquí",
		toReset: "para restablecerla."
	},
	socialLogin: {
		label: "O continúa con"
	}
};
var errors$2 = {
	"": ""
};
var login_es = {
	labels: labels$d,
	messages: messages$d,
	errors: errors$2
};

var labels$c = {
	title: "Verificando Enlace Sin Contraseña",
	instructions: "¡Ya casi terminas!\nVamos a confirmar tu dirección de correo.\nPulsa el enlace de verificación que hemos enviado a tu correo:",
	resend: "Reenviar correo"
};
var messages$c = {
	resent: "Reenvío exitoso",
	success: "Inicio de sesión exitoso"
};
var verifyLinkToken_es = {
	labels: labels$c,
	messages: messages$c
};

var title$7 = "Crear una cuenta";
var subtitle$2 = "Ingresa tu correo y contraseña a continuación";
var labels$b = {
	signUpFacebook: "Regístrate con Facebook",
	signUpGoogle: "Regístrate con Google",
	signUpEmail: "Regístrate con Correo",
	password: "Contraseña",
	email: "Correo",
	passwordPlaceholder: "Crear contraseña",
	emailPlaceholder: "Ingresar correo",
	required: "obligatorio",
	firstName: "Nombre",
	lastName: "Apellido",
	phone: "Teléfono"
};
var messages$b = {
	alreadyHaveAccount: " ¿Ya tienes una cuenta?",
	createAccount: "Crear cuenta",
	loginHere: "inicia sesión aquí",
	selectPlan: "Selecciona un plan diferente",
	here: "aquí",
	iAgree: {
		iAgree: "Acepto los",
		terms: "Términos del Servicio",
		and: "y la",
		privacy: "Política de Privacidad."
	},
	preferDisable: {
		click: "Pulsa",
		here: "aquí",
		ifPrefer: "si prefieres desactivar tu bloqueador de anuncios."
	},
	socialLogin: {
		label: "O continúa con"
	}
};
var errors$1 = {
	"": ""
};
var gift = {
	titles: {
		firstTitle: "Ingresa la información del destinatario a continuación"
	},
	labels: {
		firstName: "Nombre",
		lastName: "Apellido",
		email: "Correo",
		startDate: "Fecha del regalo",
		giftMessage: "Mensaje del regalo ({{count}} caracteres restantes)",
		required: "obligatorio",
		firstNamePlaceholder: "Nombre",
		lastNamePlaceholder: "Apellido",
		emailPlaceholder: "Correo"
	},
	buttons: {
		gift: "regalo"
	},
	messages: {
		enterEmail: "Por favor, ingresa el correo del destinatario del regalo",
		invalidDate: "La fecha del regalo debe ser entre hoy y un año a partir de ahora.",
		giftDateInfo: "El destinatario recibirá un correo de notificación del regalo con tu mensaje en la fecha que seleccionaste en la orden para redimir el regalo.",
		giftMessageInfo: "Deja un mensaje para el destinatario y no olvides firmar con tu nombre."
	}
};
var redeem = {
	titles: {
		firstTitle: "Redimir tu regalo",
		secondTitle: "Ingresa el código de regalo a continuación"
	},
	labels: {
		code: "Ingresar el código de regalo",
		codePlaceholder: "Código de regalo",
		required: "obligatorio"
	},
	buttons: {
		redeem: "Redimir regalo"
	},
	footer: {
		click: "Pulsa",
		here: "aquí",
		toAdd: "para añadir una dirección"
	},
	messages: {
		enterGiftCode: "Por favor, ingresa un código de regalo"
	}
};
var register_es = {
	title: title$7,
	subtitle: subtitle$2,
	labels: labels$b,
	messages: messages$b,
	errors: errors$1,
	gift: gift,
	redeem: redeem
};

var labels$a = {
	title: "¿Quieres actualizar tu perfil?",
	subtitle: "Ingresa tu información a continuación para actualizar tu perfil",
	email: "Correo",
	firstName: "Nombre",
	lastName: "Apellido",
	username: "Nombre de usuario",
	displayname: "Nombre para mostrar",
	phone: "Teléfono",
	submit: "Enviar",
	required: "Obligatorio",
	cropperTitle: "Actualizar Foto de Perfil",
	cropperSubtitle: "Sube una foto, luego ajústala a tu gusto",
	save: "Subir Foto",
	selectImage: "Subir nueva foto",
	removeImage: "Eliminar foto actual",
	zoom: "Acercar",
	tin: "Número de Identificación Fiscal"
};
var messages$a = {
	userUpdated: "¡Gracias! Tu perfil se actualizó con éxito.",
	pictureRemoved: "Tu foto de perfil se eliminó con éxito.",
	pictureUpdated: "Tu foto de perfil se actualizó con éxito."
};
var userEdit_es = {
	labels: labels$a,
	messages: messages$a
};

var title$6 = "Ingresa tu dirección de envío";
var titleGifting = "Introduce tu dirección";
var selectAddressTitle = "Por favor, selecciona una dirección";
var selectAddressSubtitle = "Selecciona una de tus direcciones guardadas o añade una nueva";
var labels$9 = {
	address: "Dirección",
	code: "Código Postal/Área",
	city: "Ciudad",
	region: "Estado/Provincia/Región",
	country: "País",
	firstName: "Nombre",
	lastName: "Apellido",
	required: "obligatorio",
	isDefault: "Configurar como dirección Principal"
};
var buttons$3 = {
	submit: "Enviar",
	selectAddress: "Seleccionar dirección",
	addAddress: "Añadir nueva dirección"
};
var messages$9 = {
	addressUpdated: "¡La dirección se actualizó con éxito!",
	subRedeemed: "Tu suscripción ha sido redimida."
};
var address_es = {
	title: title$6,
	titleGifting: titleGifting,
	selectAddressTitle: selectAddressTitle,
	selectAddressSubtitle: selectAddressSubtitle,
	labels: labels$9,
	buttons: buttons$3,
	messages: messages$9
};

var title$5 = "Restablecer tu contraseña";
var subtitle$1 = "Ingresa una nueva contraseña a continuación";
var email$2 = "Correo";
var password$1 = "Contraseña";
var confirmPassword = "Confirmar contraseña";
var submit$3 = "Enviar";
var required$3 = "Obligatorio";
var passwordUpdated = "La contraseña ha sido actualizada, por favor inicia sesión con la nueva contraseña";
var passwordReset_es = {
	title: title$5,
	subtitle: subtitle$1,
	email: email$2,
	password: password$1,
	confirmPassword: confirmPassword,
	submit: submit$3,
	required: required$3,
	passwordUpdated: passwordUpdated
};

var title$4 = "¿Olvidaste tu contraseña?";
var email$1 = "Correo";
var password = "Contraseña";
var submit$2 = "Enviar";
var required$2 = "Obligatorio";
var passwordResetEmailSent = "Las instrucciones de restablecimiento de la contraseña se han enviado a tu correo";
var messages$8 = {
	alreadyHaveAccount: "¿Ya tienes una cuenta?",
	loginHere: "Inicia sesión aquí."
};
var passwordForgot_es = {
	title: title$4,
	email: email$1,
	password: password,
	submit: submit$2,
	required: required$2,
	passwordResetEmailSent: passwordResetEmailSent,
	messages: messages$8
};

var title$3 = "Cambiar tu contraseña";
var currentPassword = "Contraseña actual";
var newPassword = "Nueva contraseña";
var confirmNewPassword = "Confirmar nueva contraseña";
var submit$1 = "Cambiar contraseña";
var required$1 = "Obligatorio";
var passwordChanged = "La contraseña ha cambiado, por favor inicia sesión con la nueva contraseña";
var passwordsNotMatching = "Las contraseñas no coinciden";
var weakPassword = "Tu contraseña debe contener al menos 6 caracteres";
var passwordChange_es = {
	title: title$3,
	currentPassword: currentPassword,
	newPassword: newPassword,
	confirmNewPassword: confirmNewPassword,
	submit: submit$1,
	required: required$1,
	passwordChanged: passwordChanged,
	passwordsNotMatching: passwordsNotMatching,
	weakPassword: weakPassword
};

var title$2 = "Acceso sin contraseña";
var email = "Ingresar correo";
var submit = "Enviar";
var required = "obligatorio";
var messages$7 = {
	PasswordlessLoginSuccess: "Por favor, revisa tu correo y sigue las instrucciones que se indican"
};
var passwordlessRequest_es = {
	title: title$2,
	email: email,
	submit: submit,
	required: required,
	messages: messages$7
};

var title$1 = "Tu carrito de compras";
var subtitle = "Completa tu compra a continuación";
var name = "Nombre";
var quantity = "Cantidad";
var price = "Precio";
var actions = "Acciones";
var remove = "Eliminar";
var total = "Total";
var confirm$1 = "Pago";
var empty = "Tu carrito está vacío.";
var removeAll = "Eliminar todo";
var cart_es = {
	title: title$1,
	subtitle: subtitle,
	name: name,
	quantity: quantity,
	price: price,
	actions: actions,
	remove: remove,
	total: total,
	confirm: confirm$1,
	empty: empty,
	removeAll: removeAll
};

var buttons$2 = {
	select: "Seleccionar",
	added: "Añadido al carrito",
	purchase: "Compra",
	"continue": "Continuar"
};
var messages$6 = {
	orderConfirmed: {
		title: "¡Orden confirmada!",
		body: "Tu orden ha sido confirmada y será enviada en los próximos días. En breve recibirás un correo electrónico de confirmación de esta orden."
	},
	haveQuestions: "¡Si tienes alguna pregunta, no dudes en contactarnos!",
	multipleCurrencies: "Tu carrito actualmente contiene artículos que están disponibles en diferentes divisas. Para proceder a la compra, asegúrate de que todos los artículos tengan la misma divisa.",
	currencyMismatch: "El siguiente artículo(s) no coincide con tu divisa predeterminada actual ({{currency}}). Por favor, solo elige artículos que coincidan con esta divisa."
};
var labels$8 = {
	summary: "Resumen de la orden",
	total: "total"
};
var shop_es = {
	buttons: buttons$2,
	messages: messages$6,
	labels: labels$8
};

var labels$7 = {
	cardNumber: "Número de Tarjeta",
	securityCode: "Código de Seguridad",
	submit: "Enviar",
	months: {
		jan: "Enero",
		feb: "Febrero",
		mar: "Marzo",
		apr: "Abril",
		may: "Mayo",
		jun: "Junio",
		jul: "Julio",
		aug: "Agosto",
		sep: "Septiembre",
		oct: "Octubre",
		nov: "Noviembre",
		dec: "Diciembre"
	},
	checkout: {
		title: "Información de Pago"
	}
};
var messages$5 = {
	youAreSafe: "Estás seguro - PCI compliance 128 SSL por",
	cancel: "Cancela tu suscripción en línea en cualquier momento.",
	giftSent: "La suscripción de regalo se ha enviado a",
	successfully: "exitosamente",
	sourceCreated: "Se ha añadido la información de pago",
	sourceUpdated: "Tu información de pago se ha actualizado",
	cardAuthFailed: "No pudimos autenticar tu método de pago. Por favor, elige un método de pago diferente e intenta de nuevo.",
	cardAuthNotSupported: "Actualmente no es posible actualizar tu método de pago a uno que requiere autenticación. Por favor, utiliza un método de pago diferente o contacta a atención al cliente.",
	tryAgainFromInvoice: "No nos fue posible autenticar tu pago, sin embargo, tu suscripción fue creada. Por favor, intenta pagar la factura utilizando otro método de pago desde el panel."
};
var errors = {
	"": ""
};
var payment_es = {
	labels: labels$7,
	messages: messages$5,
	errors: errors
};

var labels$6 = {
	menu: "Menú de Pelcro",
	name: "Nombre",
	email: "Correo",
	plan: "Plan",
	description: "Descripción",
	expiry: "Expiración",
	status: {
		title: "Estado",
		active: "Activa",
		inTrial: "Prueba",
		endingSoon: "Termina pronto",
		scheduled: "Programada",
		incomplete: "Incompleta"
	},
	manageMembers: "Administrar miembros",
	shipments: "Envíos restantes",
	logout: "Cerrar sesión",
	dashboard: "Panel",
	unsubscribe: "Cancelar",
	reactivate: "Reactivar",
	renew: "Renovar",
	suspend: "Suspender",
	unsuspend: "Reanudar",
	support: "Soporte",
	account: "Cuenta",
	purchases: "Compras",
	subscriptions: "Suscripciones",
	donations: "Donaciones",
	memberships: "Membresías",
	invoices: "Comprobantes de pago",
	details: "Detalles",
	view: "Ver",
	paid: "Pagado",
	open: "Abierto",
	draft: "Borrador",
	scheduled: "Programado",
	uncollectible: "No se puede cobrar",
	"void": "Inválido",
	pastDue: "Vencido",
	updatePaymentSource: "Actualización",
	profile: "Perfil",
	updateProfile: "Editar perfil",
	changePassword: "Cambiar contraseña",
	editNewsletters: "Editar boletines",
	myQRCode: "Mi código QR",
	shipping: "Transporte",
	billing: "Facturación",
	edit: "Editar",
	gifts: "Regalos",
	redeemGift: "Redimir regalo",
	address: "Dirección",
	addresses: "Direcciones",
	myProfile: "Mi perfil",
	paymentSource: "Datos de pago",
	actions: "Acciones",
	expiresOn: "Finaliza",
	until: "Hasta que",
	startsOn: "Inicia",
	startDate: "Fecha de inicio",
	renewsOn: "Renovación",
	canceledOn: "Cancelación el",
	recipient: "Destinatario",
	addAddress: "Añadir dirección",
	editAddress: "Editar dirección",
	addSubscription: "Nueva Suscripción",
	addGift: "Nuevo Regalo",
	"default": "Predeterminado",
	orders: {
		label: "Órdenes",
		noOrders: "No has realizado ninguna orden",
		total: "Total",
		date: "Fecha",
		details: "Detalles",
		itemsAmount: "{{count}} artículo",
		itemsAmount_plural: "{{count}} artículos"
	},
	savedItems: {
		label: "Guardado y Siguiendo",
		noSavedItems: "No tienes artículos guardados",
		categories: "Categorías",
		details: "Detalles",
		removeItem: "Eliminar"
	},
	subCancellation: {
		goBack: "Volver"
	}
};
var messages$4 = {
	noCard: "No tienes una tarjeta",
	subCancellation: {
		isSureToCancel: "¿Estás seguro de que quieres cancelar tu suscripción?",
		loading: "Cancelando tu suscripción",
		success: "La suscripción se canceló con éxito",
		error: "Error al cancelar tu suscripción"
	},
	subReactivation: {
		success: "La suscripción se reactivó con éxito",
		error: "Error al reactivar su suscripción"
	},
	subUnSuspend: {
		isSureToUnSuspend: "¿Estás seguro de que quieres reanudar tu suscripción?",
		loading: "Reanudando tu suscripción",
		success: "La suscripción se reanudó con éxito",
		error: "Error al reanudar tu suscripción"
	}
};
var dashboard_es = {
	labels: labels$6,
	messages: messages$4
};

var messages$3 = {
	alreadyHaveAccount: "¿Ya tienes una cuenta?",
	loginHere: "Inicia sesión aquí",
	checkbox: "Marca esta casilla para regalar esta suscripción"
};
var labels$5 = {
	plan: {
		title: "Suscribirse a un plan",
		subtitle: "Selecciona uno de los planes a continuación y pulsa en siguiente."
	},
	product: {
		title: "Suscribirse a un producto",
		subtitle: "Selecciona uno de los productos a continuación y pulsa en siguiente."
	},
	selectProduct: "Selecciona un producto",
	selectPlan: "Selecciona un plan",
	startingAt: "Inicia el",
	restrictiveArticles: {
		subscribeTo: "Suscríbete a una de las siguientes opciones para obtener acceso a esta página",
		or: "O revisa algunas de nuestras otras opciones a continuación"
	}
};
var buttons$1 = {
	next: "Siguiente",
	select: "Seleccionar",
	back: "Volver"
};
var select_es = {
	messages: messages$3,
	labels: labels$5,
	buttons: buttons$1
};

var confirm = {
	labels: {
		confirm: "Confirmar",
		close: "Cerrar"
	}
};
var notification_es = {
	confirm: confirm
};

var labels$4 = {
	title: "Verifica tu correo",
	instructions: "¡Ya casi terminas!\nVamos a confirmar tu dirección de correo.\nPulsa el enlace de verificación que hemos enviado a tu correo:",
	resend: "Reenviar correo"
};
var messages$2 = {
	resent: "Reenvío exitoso",
	success: "¡El correo se verificó con éxito!"
};
var verifyEmail_es = {
	labels: labels$4,
	messages: messages$2
};

var title = "Detalles del comprobante de pago";
var labels$3 = {
	summary: "Resumen",
	total: "Total",
	amountPaid: "Monto pagado",
	amountDue: "Monto adeudado",
	creationDate: "Creado el:"
};
var buttons = {
	download: "Descargar",
	pay: "Pagar ahora"
};
var invoiceDetails_es = {
	title: title,
	labels: labels$3,
	buttons: buttons
};

var labels$2 = {
	title: "Cancelar suscripción",
	cancelReason: "Razón de la cancelación",
	endOn: "Fin de",
	endImmediately: "Fin inmediato",
	cancel: "Cancelar",
	subCancellation: {
		goBack: "Volver"
	}
};
var messages$1 = {
	subscriptionEnd: "Esta suscripción expirará el",
	cancelWhen: "¿Cuándo desea cancelar?",
	cancelNow: "Cancelar Suscripción Ahora",
	cancelLater: "Cancelar al Final del Periodo",
	subCancellation: {
		isSureToCancelNow: "¿Estás seguro de que quieres cancelar tu suscripción de inmediato?",
		isSureToCancel: "¿Estás seguro de que quieres cancelar tu suscripción?",
		loading: "Cancelando tu suscripción",
		success: "La suscripción se canceló con éxito",
		error: "Error al cancelar tu suscripción"
	}
};
var subscriptionCancel_es = {
	labels: labels$2,
	messages: messages$1
};

var labels$1 = {
	inviteMembers: "Invitar miembros",
	listOfMembers: "Lista de miembros",
	invite: "Invitar",
	remove: "quitar",
	emails: "Ingresar correo electrónico",
	status: "Estado",
	actions: "Acciones",
	email: "Correo electrónico",
	listNote: "Lista separada por comas, por ejemplo"
};
var subscriptionManageMembers_es = {
	labels: labels$1
};

var labels = {
	title: "Suspender suscripción",
	suspensionDate: "Fecha de suspensión",
	subCancellation: {
		goBack: "Volver"
	}
};
var messages = {
	suspensionEnd: "La suspensión expirará el",
	suspendNow: "Suspender Suscripción Ahora",
	suspendLater: "Suspender al Final del Periodo",
	subCancellation: {
		isSureToSuspendNow: "¿Estás seguro de que quieres suspender tu suscripción de inmediato?",
		isSureToSuspend: "¿Estás seguro de que quieres suspender tu suscripción?",
		loading: "Suspendiendo tu suscripción",
		success: "La suscripción se suspendió con éxito",
		error: "Erro al suspender tu suscripción"
	}
};
var subscriptionSuspend_es = {
	labels: labels,
	messages: messages
};

function create$1(createState) {
  let state;
  const listeners = new Set();
  const setState = (partial, replace) => {
    const nextState = typeof partial === "function" ? partial(state) : partial;
    if (nextState !== state) {
      const previousState = state;
      state = replace ? nextState : Object.assign({}, state, nextState);
      listeners.forEach((listener) => listener(state, previousState));
    }
  };
  const getState = () => state;
  const subscribeWithSelector = (listener, selector = getState, equalityFn = Object.is) => {
    let currentSlice = selector(state);
    function listenerToAdd() {
      const nextSlice = selector(state);
      if (!equalityFn(currentSlice, nextSlice)) {
        const previousSlice = currentSlice;
        listener(currentSlice = nextSlice, previousSlice);
      }
    }
    listeners.add(listenerToAdd);
    return () => listeners.delete(listenerToAdd);
  };
  const subscribe = (listener, selector, equalityFn) => {
    if (selector || equalityFn) {
      return subscribeWithSelector(listener, selector, equalityFn);
    }
    listeners.add(listener);
    return () => listeners.delete(listener);
  };
  const destroy = () => listeners.clear();
  const api = { setState, getState, subscribe, destroy };
  state = createState(setState, getState, api);
  return api;
}

const isSSR = typeof window === "undefined" || !window.navigator || /ServerSideRendering|^Deno\//.test(window.navigator.userAgent);
const useIsomorphicLayoutEffect = isSSR ? useEffect : useLayoutEffect;
function create(createState) {
  const api = typeof createState === "function" ? create$1(createState) : createState;
  const useStore = (selector = api.getState, equalityFn = Object.is) => {
    const [, forceUpdate] = useReducer((c) => c + 1, 0);
    const state = api.getState();
    const stateRef = useRef(state);
    const selectorRef = useRef(selector);
    const equalityFnRef = useRef(equalityFn);
    const erroredRef = useRef(false);
    const currentSliceRef = useRef();
    if (currentSliceRef.current === void 0) {
      currentSliceRef.current = selector(state);
    }
    let newStateSlice;
    let hasNewStateSlice = false;
    if (stateRef.current !== state || selectorRef.current !== selector || equalityFnRef.current !== equalityFn || erroredRef.current) {
      newStateSlice = selector(state);
      hasNewStateSlice = !equalityFn(currentSliceRef.current, newStateSlice);
    }
    useIsomorphicLayoutEffect(() => {
      if (hasNewStateSlice) {
        currentSliceRef.current = newStateSlice;
      }
      stateRef.current = state;
      selectorRef.current = selector;
      equalityFnRef.current = equalityFn;
      erroredRef.current = false;
    });
    const stateBeforeSubscriptionRef = useRef(state);
    useIsomorphicLayoutEffect(() => {
      const listener = () => {
        try {
          const nextState = api.getState();
          const nextStateSlice = selectorRef.current(nextState);
          if (!equalityFnRef.current(currentSliceRef.current, nextStateSlice)) {
            stateRef.current = nextState;
            currentSliceRef.current = nextStateSlice;
            forceUpdate();
          }
        } catch (error) {
          erroredRef.current = true;
          forceUpdate();
        }
      };
      const unsubscribe = api.subscribe(listener);
      if (api.getState() !== stateBeforeSubscriptionRef.current) {
        listener();
      }
      return unsubscribe;
    }, []);
    return hasNewStateSlice ? newStateSlice : currentSliceRef.current;
  };
  Object.assign(useStore, api);
  useStore[Symbol.iterator] = function* () {
    console.warn("[useStore, api] = create() is deprecated and will be removed in v4");
    yield useStore;
    yield api;
  };
  return useStore;
}

var vanilla = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });

function create(createState) {
  var state;
  var listeners = new Set();

  var setState = function setState(partial, replace) {
    var nextState = typeof partial === 'function' ? partial(state) : partial;

    if (nextState !== state) {
      var _previousState = state;
      state = replace ? nextState : Object.assign({}, state, nextState);
      listeners.forEach(function (listener) {
        return listener(state, _previousState);
      });
    }
  };

  var getState = function getState() {
    return state;
  };

  var subscribeWithSelector = function subscribeWithSelector(listener, selector, equalityFn) {
    if (selector === void 0) {
      selector = getState;
    }

    if (equalityFn === void 0) {
      equalityFn = Object.is;
    }

    var currentSlice = selector(state);

    function listenerToAdd() {
      var nextSlice = selector(state);

      if (!equalityFn(currentSlice, nextSlice)) {
        var _previousSlice = currentSlice;
        listener(currentSlice = nextSlice, _previousSlice);
      }
    }

    listeners.add(listenerToAdd);
    return function () {
      return listeners.delete(listenerToAdd);
    };
  };

  var subscribe = function subscribe(listener, selector, equalityFn) {
    if (selector || equalityFn) {
      return subscribeWithSelector(listener, selector, equalityFn);
    }

    listeners.add(listener);
    return function () {
      return listeners.delete(listener);
    };
  };

  var destroy = function destroy() {
    return listeners.clear();
  };

  var api = {
    setState: setState,
    getState: getState,
    subscribe: subscribe,
    destroy: destroy
  };
  state = createState(setState, getState, api);
  return api;
}

exports.default = create;
});

var createStore = unwrapExports(vanilla);

function c$1(c,r,d){const u={count:0},s=t=>{const o=useRef(u.count);return useEffect(()=>{o.current+=1,o.current===u.count+1&&(o.current-=1,r.setState(t));}),null};if(s.displayName=`((${c})) devtool`,!d){let t=document.getElementById("simple-zustand-devtools");t||(t=document.createElement("div"),t.id="simple-zustand-devtools"),document.body.appendChild(t),d=t;}const m=e=>{e&&(render$1(React__default.createElement(s,Object.assign({},e)),d),u.count+=1);};m(r.getState()),r.subscribe(m);}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;
});

unwrapExports(_extends_1);

var middleware = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });



function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends_1);

var redux = function redux(reducer, initial) {
  return function (set, get, api) {
    api.dispatch = function (action) {
      set(function (state) {
        return reducer(state, action);
      });

      if (api.devtools) {
        api.devtools.send(api.devtools.prefix + action.type, get());
      }

      return action;
    };

    return _extends__default['default']({
      dispatch: api.dispatch
    }, initial);
  };
};
var devtools = function devtools(fn, prefix) {
  return function (set, get, api) {
    var extension;

    try {
      extension = window.__REDUX_DEVTOOLS_EXTENSION__ || window.top.__REDUX_DEVTOOLS_EXTENSION__;
    } catch (_unused) {}

    if (!extension) {
      if (process.env.NODE_ENV === 'development' && typeof window !== 'undefined') {
        console.warn('Please install/enable Redux devtools extension');
      }

      api.devtools = null;
      return fn(set, get, api);
    }

    var namedSet = function namedSet(state, replace, name) {
      set(state, replace);

      if (!api.dispatch) {
        api.devtools.send(api.devtools.prefix + (name || 'action'), get());
      }
    };

    var initialState = fn(namedSet, get, api);

    if (!api.devtools) {
      var savedSetState = api.setState;

      api.setState = function (state, replace) {
        savedSetState(state, replace);
        api.devtools.send(api.devtools.prefix + 'setState', api.getState());
      };

      api.devtools = extension.connect({
        name: prefix
      });
      api.devtools.prefix = prefix ? prefix + " > " : '';
      api.devtools.subscribe(function (message) {
        var _message$payload, _message$payload2;

        if (message.type === 'DISPATCH' && message.state) {
          var ignoreState = message.payload.type === 'JUMP_TO_ACTION' || message.payload.type === 'JUMP_TO_STATE';

          if (!api.dispatch && !ignoreState) {
            api.setState(JSON.parse(message.state));
          } else {
            savedSetState(JSON.parse(message.state));
          }
        } else if (message.type === 'DISPATCH' && ((_message$payload = message.payload) == null ? void 0 : _message$payload.type) === 'COMMIT') {
          api.devtools.init(api.getState());
        } else if (message.type === 'DISPATCH' && ((_message$payload2 = message.payload) == null ? void 0 : _message$payload2.type) === 'IMPORT_STATE') {
          var _message$payload$next, _message$payload$next2;

          var actions = (_message$payload$next = message.payload.nextLiftedState) == null ? void 0 : _message$payload$next.actionsById;
          var computedStates = ((_message$payload$next2 = message.payload.nextLiftedState) == null ? void 0 : _message$payload$next2.computedStates) || [];
          computedStates.forEach(function (_ref, index) {
            var state = _ref.state;
            var action = actions[index] || api.devtools.prefix + 'setState';

            if (index === 0) {
              api.devtools.init(state);
            } else {
              savedSetState(state);
              api.devtools.send(action, api.getState());
            }
          });
        }
      });
      api.devtools.init(initialState);
    }

    return initialState;
  };
};
var combine = function combine(initialState, create) {
  return function (set, get, api) {
    return Object.assign({}, initialState, create(set, get, api));
  };
};

var toThenable = function toThenable(fn) {
  return function (input) {
    try {
      var result = fn(input);

      if (result instanceof Promise) {
        return result;
      }

      return {
        then: function then(onFulfilled) {
          return toThenable(onFulfilled)(result);
        },
        catch: function _catch(_onRejected) {
          return this;
        }
      };
    } catch (e) {
      return {
        then: function then(_onFulfilled) {
          return this;
        },
        catch: function _catch(onRejected) {
          return toThenable(onRejected)(e);
        }
      };
    }
  };
};

var persist = function persist(config, options) {
  return function (set, get, api) {
    var _ref2 = options || {},
        name = _ref2.name,
        _ref2$getStorage = _ref2.getStorage,
        getStorage = _ref2$getStorage === void 0 ? function () {
      return localStorage;
    } : _ref2$getStorage,
        _ref2$serialize = _ref2.serialize,
        serialize = _ref2$serialize === void 0 ? JSON.stringify : _ref2$serialize,
        _ref2$deserialize = _ref2.deserialize,
        deserialize = _ref2$deserialize === void 0 ? JSON.parse : _ref2$deserialize,
        blacklist = _ref2.blacklist,
        whitelist = _ref2.whitelist,
        onRehydrateStorage = _ref2.onRehydrateStorage,
        _ref2$version = _ref2.version,
        version = _ref2$version === void 0 ? 0 : _ref2$version,
        migrate = _ref2.migrate;

    var storage;

    try {
      storage = getStorage();
    } catch (e) {}

    if (!storage) {
      return config(function () {
        console.warn("Persist middleware: unable to update " + name + ", the given storage is currently unavailable.");
        set.apply(void 0, arguments);
      }, get, api);
    }

    var thenableSerialize = toThenable(serialize);

    var setItem = function setItem() {
      var state = _extends__default['default']({}, get());

      if (whitelist) {
        Object.keys(state).forEach(function (key) {
          !whitelist.includes(key) && delete state[key];
        });
      }

      if (blacklist) {
        blacklist.forEach(function (key) {
          return delete state[key];
        });
      }

      var errorInSync;
      var thenable = thenableSerialize({
        state: state,
        version: version
      }).then(function (serializedValue) {
        return storage.setItem(name, serializedValue);
      }).catch(function (e) {
        errorInSync = e;
      });

      if (errorInSync) {
        throw errorInSync;
      }

      return thenable;
    };

    var savedSetState = api.setState;

    api.setState = function (state, replace) {
      savedSetState(state, replace);
      void setItem();
    };

    var stateFromStorageInSync;
    var postRehydrationCallback = (onRehydrateStorage == null ? void 0 : onRehydrateStorage(get())) || undefined;
    toThenable(storage.getItem.bind(storage))(name).then(function (storageValue) {
      if (storageValue) {
        return deserialize(storageValue);
      }
    }).then(function (deserializedStorageValue) {
      if (deserializedStorageValue) {
        if (deserializedStorageValue.version !== version) {
          if (migrate) {
            return migrate(deserializedStorageValue.state, deserializedStorageValue.version);
          }

          console.error("State loaded from storage couldn't be migrated since no migrate function was provided");
        } else {
          stateFromStorageInSync = deserializedStorageValue.state;
          set(deserializedStorageValue.state);
        }
      }
    }).then(function (migratedState) {
      if (migratedState) {
        stateFromStorageInSync = migratedState;
        set(migratedState);
        return setItem();
      }
    }).then(function () {
      postRehydrationCallback == null ? void 0 : postRehydrationCallback(get(), undefined);
    }).catch(function (e) {
      postRehydrationCallback == null ? void 0 : postRehydrationCallback(undefined, e);
    });
    var configResult = config(function () {
      set.apply(void 0, arguments);
      void setItem();
    }, get, api);
    return stateFromStorageInSync ? _extends__default['default']({}, configResult, stateFromStorageInSync) : configResult;
  };
};

exports.combine = combine;
exports.devtools = devtools;
exports.persist = persist;
exports.redux = redux;
});

unwrapExports(middleware);
middleware.combine;
middleware.devtools;
var middleware_3 = middleware.persist;
middleware.redux;

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

// Polyfill
(() => {
  if (typeof window.CustomEvent === "function") return false;
  function CustomEvent(event) {
    let params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      bubbles: false,
      cancelable: false,
      detail: undefined
    };
    const evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  }
  CustomEvent.prototype = window.Event.prototype;
  window.CustomEvent = CustomEvent;
})();

/**
 * Should fire when the cart is opened and expects the cartItems inside the card to be sent
 */
const cartOpened = detail => createCustomEvent("PelcroElementsCartOpened", detail);

/**
 * Should fire when an item added to the cart and expects the added item to be sent
 */
const cartItemAdded = detail => createCustomEvent("PelcroElementsCartItemAdded", detail);

/**
 * Should fire when an item removed from the cart and expects the removed item to be sent
 */
const cartItemRemoved = detail => createCustomEvent("PelcroElementsCartItemRemoved", detail);

/**
 * Check if the browser support custom events
 */
function createCustomEvent(name, detail) {
  try {
    return new CustomEvent(name, {
      detail
    });
  } catch (e) {
    console.warn("Pelcro - Events are not supported in the browser");
  }
}

function warn(s) {
  console.warn('[react-ga]', s);
}

function _typeof$1(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(source, true).forEach(function (key) { _defineProperty$2(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof$1(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty$2(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var NEWTAB = '_blank';
var MIDDLECLICK = 1;

var OutboundLink$1 =
/*#__PURE__*/
function (_Component) {
  _inherits(OutboundLink, _Component);

  function OutboundLink() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, OutboundLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(OutboundLink)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty$2(_assertThisInitialized(_this), "handleClick", function (event) {
      var _this$props = _this.props,
          target = _this$props.target,
          eventLabel = _this$props.eventLabel,
          to = _this$props.to,
          onClick = _this$props.onClick,
          trackerNames = _this$props.trackerNames;
      var eventMeta = {
        label: eventLabel
      };
      var sameTarget = target !== NEWTAB;
      var normalClick = !(event.ctrlKey || event.shiftKey || event.metaKey || event.button === MIDDLECLICK);

      if (sameTarget && normalClick) {
        event.preventDefault();
        OutboundLink.trackLink(eventMeta, function () {
          window.location.href = to;
        }, trackerNames);
      } else {
        OutboundLink.trackLink(eventMeta, function () {}, trackerNames);
      }

      if (onClick) {
        onClick(event);
      }
    });

    return _this;
  }

  _createClass(OutboundLink, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          href = _this$props2.to,
          oldProps = _objectWithoutProperties$1(_this$props2, ["to"]);

      var props = _objectSpread$2({}, oldProps, {
        href: href,
        onClick: this.handleClick
      });

      if (this.props.target === NEWTAB) {
        props.rel = 'noopener noreferrer';
      }

      delete props.eventLabel;
      delete props.trackerNames;
      return React__default.createElement('a', props);
    }
  }]);

  return OutboundLink;
}(Component);

_defineProperty$2(OutboundLink$1, "trackLink", function () {
  warn('ga tracking not enabled');
});

_defineProperty$2(OutboundLink$1, "propTypes", {
  eventLabel: PropTypes.string.isRequired,
  target: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  trackerNames: PropTypes.arrayOf(PropTypes.string)
});

_defineProperty$2(OutboundLink$1, "defaultProps", {
  target: null,
  to: null,
  onClick: null,
  trackerNames: null
});

// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === 'string' && s.indexOf('@') !== -1;
}

// GA strings need to have leading/trailing whitespace trimmed, and not all
// browsers have String.prototoype.trim().
function trim(s) {
  return s.replace(/^\s+|\s+$/g, '');
}

/**
 * To Title Case 2.1 - http://individed.com/code/to-title-case/
 * Copyright 2008-2013 David Gouch. Licensed under the MIT License.
 * https://github.com/gouch/to-title-case
 */
var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return trim(string).replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ':' && (title.charAt(index + match.length) !== '-' || title.charAt(index - 1) === '-') && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }

    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }

    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

var redacted = 'REDACTED (Potential Email Address)';
function format(s, titleCase) {
  if (mightBeEmail(s)) {
    warn('This arg looks like an email address, redacting.');
    return redacted;
  }

  if (titleCase) {
    return toTitleCase(s);
  }

  return s;
}

function removeLeadingSlash(string) {
  if (string.substring(0, 1) === '/') {
    return string.substring(1);
  }

  return string;
}

function loadGA (options) {
  var gaAddress = 'https://www.google-analytics.com/analytics.js';

  if (options && options.gaAddress) {
    gaAddress = options.gaAddress;
  } else if (options && options.debug) {
    gaAddress = 'https://www.google-analytics.com/analytics_debug.js';
  } // https://developers.google.com/analytics/devguides/collection/analyticsjs/

  /* eslint-disable */


  (function (i, s, o, g, r, a, m) {
    i['GoogleAnalyticsObject'] = r;
    i[r] = i[r] || function () {
      (i[r].q = i[r].q || []).push(arguments);
    }, i[r].l = 1 * new Date();
    a = s.createElement(o), m = s.getElementsByTagName(o)[0];
    a.async = 1;
    a.src = g;
    m.parentNode.insertBefore(a, m);
  })(window, document, 'script', gaAddress, 'ga');
  /* eslint-enable */

}

function log(s) {
  console.info('[react-ga]', s);
}

var gaCalls = [];
var TestModeAPI = {
  calls: gaCalls,
  ga: function ga() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    gaCalls.push([].concat(args));
  },
  resetCalls: function resetCalls() {
    gaCalls.length = 0;
  }
};

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var _isNotBrowser = typeof window === 'undefined' || typeof document === 'undefined';

var _debug = false;
var _titleCase = true;
var _testMode = false;
var _alwaysSendToDefaultTracker = true;

var internalGa = function internalGa() {
  var _window;

  if (_testMode) return TestModeAPI.ga.apply(TestModeAPI, arguments);
  if (_isNotBrowser) return false;
  if (!window.ga) return warn('ReactGA.initialize must be called first or GoogleAnalytics should be loaded manually');
  return (_window = window).ga.apply(_window, arguments);
};

function _format(s) {
  return format(s, _titleCase);
}

function _gaCommand(trackerNames) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var command = args[0];

  if (typeof internalGa === 'function') {
    if (typeof command !== 'string') {
      warn('ga command must be a string');
      return;
    }

    if (_alwaysSendToDefaultTracker || !Array.isArray(trackerNames)) internalGa.apply(void 0, args);

    if (Array.isArray(trackerNames)) {
      trackerNames.forEach(function (name) {
        internalGa.apply(void 0, _toConsumableArray(["".concat(name, ".").concat(command)].concat(args.slice(1))));
      });
    }
  }
}

function _initialize(gaTrackingID, options) {
  if (!gaTrackingID) {
    warn('gaTrackingID is required in initialize()');
    return;
  }

  if (options) {
    if (options.debug && options.debug === true) {
      _debug = true;
    }

    if (options.titleCase === false) {
      _titleCase = false;
    }

    if (options.useExistingGa) {
      return;
    }
  }

  if (options && options.gaOptions) {
    internalGa('create', gaTrackingID, options.gaOptions);
  } else {
    internalGa('create', gaTrackingID, 'auto');
  }
}

function initialize(configsOrTrackingId, options) {
  if (options && options.testMode === true) {
    _testMode = true;
  } else {
    if (_isNotBrowser) {
      return false;
    }

    if (!options || options.standardImplementation !== true) loadGA(options);
  }

  _alwaysSendToDefaultTracker = options && typeof options.alwaysSendToDefaultTracker === 'boolean' ? options.alwaysSendToDefaultTracker : true;

  if (Array.isArray(configsOrTrackingId)) {
    configsOrTrackingId.forEach(function (config) {
      if (_typeof(config) !== 'object') {
        warn('All configs must be an object');
        return;
      }

      _initialize(config.trackingId, config);
    });
  } else {
    _initialize(configsOrTrackingId, options);
  }

  return true;
}
/**
 * ga:
 * Returns the original GA object.
 */

function ga() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (args.length > 0) {
    internalGa.apply(void 0, args);

    if (_debug) {
      log('called ga(\'arguments\');');
      log("with arguments: ".concat(JSON.stringify(args)));
    }
  }

  return window.ga;
}
/**
 * set:
 * GA tracker set method
 * @param {Object} fieldsObject - a field/value pair or a group of field/value pairs on the tracker
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function set(fieldsObject, trackerNames) {
  if (!fieldsObject) {
    warn('`fieldsObject` is required in .set()');
    return;
  }

  if (_typeof(fieldsObject) !== 'object') {
    warn('Expected `fieldsObject` arg to be an Object');
    return;
  }

  if (Object.keys(fieldsObject).length === 0) {
    warn('empty `fieldsObject` given to .set()');
  }

  _gaCommand(trackerNames, 'set', fieldsObject);

  if (_debug) {
    log('called ga(\'set\', fieldsObject);');
    log("with fieldsObject: ".concat(JSON.stringify(fieldsObject)));
  }
}
/**
 * send:
 * Clone of the low level `ga.send` method
 * WARNING: No validations will be applied to this
 * @param  {Object} fieldObject - field object for tracking different analytics
 * @param  {Array} trackerNames - trackers to send the command to
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function send(fieldObject, trackerNames) {
  _gaCommand(trackerNames, 'send', fieldObject);

  if (_debug) {
    log('called ga(\'send\', fieldObject);');
    log("with fieldObject: ".concat(JSON.stringify(fieldObject)));
    log("with trackers: ".concat(JSON.stringify(trackerNames)));
  }
}
/**
 * pageview:
 * Basic GA pageview tracking
 * @param  {String} path - the current page page e.g. '/about'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 * @param {String} title - (optional) the page title e. g. 'My Website'
 */

function pageview(rawPath, trackerNames, title) {
  if (!rawPath) {
    warn('path is required in .pageview()');
    return;
  }

  var path = trim(rawPath);

  if (path === '') {
    warn('path cannot be an empty string in .pageview()');
    return;
  }

  var extraFields = {};

  if (title) {
    extraFields.title = title;
  }

  if (typeof ga === 'function') {
    _gaCommand(trackerNames, 'send', _objectSpread$1({
      hitType: 'pageview',
      page: path
    }, extraFields));

    if (_debug) {
      log('called ga(\'send\', \'pageview\', path);');
      var extraLog = '';

      if (title) {
        extraLog = " and title: ".concat(title);
      }

      log("with path: ".concat(path).concat(extraLog));
    }
  }
}
/**
 * modalview:
 * a proxy to basic GA pageview tracking to consistently track
 * modal views that are an equivalent UX to a traditional pageview
 * @param  {String} modalName e.g. 'add-or-edit-club'
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function modalview(rawModalName, trackerNames) {
  if (!rawModalName) {
    warn('modalName is required in .modalview(modalName)');
    return;
  }

  var modalName = removeLeadingSlash(trim(rawModalName));

  if (modalName === '') {
    warn('modalName cannot be an empty string or a single / in .modalview()');
    return;
  }

  if (typeof ga === 'function') {
    var path = "/modal/".concat(modalName);

    _gaCommand(trackerNames, 'send', 'pageview', path);

    if (_debug) {
      log('called ga(\'send\', \'pageview\', path);');
      log("with path: ".concat(path));
    }
  }
}
/**
 * timing:
 * GA timing
 * @param args.category {String} required
 * @param args.variable {String} required
 * @param args.value  {Int}  required
 * @param args.label  {String} required
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function timing() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref.category,
      variable = _ref.variable,
      value = _ref.value,
      label = _ref.label;

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    if (!category || !variable || !value || typeof value !== 'number') {
      warn('args.category, args.variable ' + 'AND args.value are required in timing() ' + 'AND args.value has to be a number');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'timing',
      timingCategory: _format(category),
      timingVar: _format(variable),
      timingValue: value
    };

    if (label) {
      fieldObject.timingLabel = _format(label);
    }

    send(fieldObject, trackerNames);
  }
}
/**
 * event:
 * GA event tracking
 * @param args.category {String} required
 * @param args.action {String} required
 * @param args.label {String} optional
 * @param args.value {Int} optional
 * @param args.nonInteraction {boolean} optional
 * @param args.transport {string} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function event() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      category = _ref2.category,
      action = _ref2.action,
      label = _ref2.label,
      value = _ref2.value,
      nonInteraction = _ref2.nonInteraction,
      transport = _ref2.transport,
      args = _objectWithoutProperties(_ref2, ["category", "action", "label", "value", "nonInteraction", "transport"]);

  var trackerNames = arguments.length > 1 ? arguments[1] : undefined;

  if (typeof ga === 'function') {
    // Simple Validation
    if (!category || !action) {
      warn('args.category AND args.action are required in event()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: _format(category),
      eventAction: _format(action)
    }; // Optional Fields

    if (label) {
      fieldObject.eventLabel = _format(label);
    }

    if (typeof value !== 'undefined') {
      if (typeof value !== 'number') {
        warn('Expected `args.value` arg to be a Number.');
      } else {
        fieldObject.eventValue = value;
      }
    }

    if (typeof nonInteraction !== 'undefined') {
      if (typeof nonInteraction !== 'boolean') {
        warn('`args.nonInteraction` must be a boolean.');
      } else {
        fieldObject.nonInteraction = nonInteraction;
      }
    }

    if (typeof transport !== 'undefined') {
      if (typeof transport !== 'string') {
        warn('`args.transport` must be a string.');
      } else {
        if (['beacon', 'xhr', 'image'].indexOf(transport) === -1) {
          warn('`args.transport` must be either one of these values: `beacon`, `xhr` or `image`');
        }

        fieldObject.transport = transport;
      }
    }

    Object.keys(args).filter(function (key) {
      return key.substr(0, 'dimension'.length) === 'dimension';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    });
    Object.keys(args).filter(function (key) {
      return key.substr(0, 'metric'.length) === 'metric';
    }).forEach(function (key) {
      fieldObject[key] = args[key];
    }); // Send to GA

    send(fieldObject, trackerNames);
  }
}
/**
 * exception:
 * GA exception tracking
 * @param args.description {String} optional
 * @param args.fatal {boolean} optional
 * @param {Array} trackerNames - (optional) a list of extra trackers to run the command on
 */

function exception(_ref3, trackerNames) {
  var description = _ref3.description,
      fatal = _ref3.fatal;

  if (typeof ga === 'function') {
    // Required Fields
    var fieldObject = {
      hitType: 'exception'
    }; // Optional Fields

    if (description) {
      fieldObject.exDescription = _format(description);
    }

    if (typeof fatal !== 'undefined') {
      if (typeof fatal !== 'boolean') {
        warn('`args.fatal` must be a boolean.');
      } else {
        fieldObject.exFatal = fatal;
      }
    } // Send to GA


    send(fieldObject, trackerNames);
  }
}
var plugin = {
  /**
   * require:
   * GA requires a plugin
   * @param name {String} e.g. 'ecommerce' or 'myplugin'
   * @param options {Object} optional e.g {path: '/log', debug: true}
   * @param trackerName {String} optional e.g 'trackerName'
   */
  require: function require(rawName, options, trackerName) {
    if (typeof ga === 'function') {
      // Required Fields
      if (!rawName) {
        warn('`name` is required in .require()');
        return;
      }

      var name = trim(rawName);

      if (name === '') {
        warn('`name` cannot be an empty string in .require()');
        return;
      }

      var requireString = trackerName ? "".concat(trackerName, ".require") : 'require'; // Optional Fields

      if (options) {
        if (_typeof(options) !== 'object') {
          warn('Expected `options` arg to be an Object');
          return;
        }

        if (Object.keys(options).length === 0) {
          warn('Empty `options` given to .require()');
        }

        ga(requireString, name, options);

        if (_debug) {
          log("called ga('require', '".concat(name, "', ").concat(JSON.stringify(options)));
        }
      } else {
        ga(requireString, name);

        if (_debug) {
          log("called ga('require', '".concat(name, "');"));
        }
      }
    }
  },

  /**
   * execute:
   * GA execute action for plugin
   * Takes variable number of arguments
   * @param pluginName {String} e.g. 'ecommerce' or 'myplugin'
   * @param action {String} e.g. 'addItem' or 'myCustomAction'
   * @param actionType {String} optional e.g. 'detail'
   * @param payload {Object} optional e.g { id: '1x5e', name : 'My product to track' }
   */
  execute: function execute(pluginName, action) {
    var payload;
    var actionType;

    if ((arguments.length <= 2 ? 0 : arguments.length - 2) === 1) {
      payload = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      actionType = arguments.length <= 2 ? undefined : arguments[2];
      payload = arguments.length <= 3 ? undefined : arguments[3];
    }

    if (typeof ga === 'function') {
      if (typeof pluginName !== 'string') {
        warn('Expected `pluginName` arg to be a String.');
      } else if (typeof action !== 'string') {
        warn('Expected `action` arg to be a String.');
      } else {
        var command = "".concat(pluginName, ":").concat(action);
        payload = payload || null;

        if (actionType && payload) {
          ga(command, actionType, payload);

          if (_debug) {
            log("called ga('".concat(command, "');"));
            log("actionType: \"".concat(actionType, "\" with payload: ").concat(JSON.stringify(payload)));
          }
        } else if (payload) {
          ga(command, payload);

          if (_debug) {
            log("called ga('".concat(command, "');"));
            log("with payload: ".concat(JSON.stringify(payload)));
          }
        } else {
          ga(command);

          if (_debug) {
            log("called ga('".concat(command, "');"));
          }
        }
      }
    }
  }
};
/**
 * outboundLink:
 * GA outboundLink tracking
 * @param args.label {String} e.g. url, or 'Create an Account'
 * @param {function} hitCallback - Called after processing a hit.
 */

function outboundLink(args, hitCallback, trackerNames) {
  if (typeof hitCallback !== 'function') {
    warn('hitCallback function is required');
    return;
  }

  if (typeof ga === 'function') {
    // Simple Validation
    if (!args || !args.label) {
      warn('args.label is required in outboundLink()');
      return;
    } // Required Fields


    var fieldObject = {
      hitType: 'event',
      eventCategory: 'Outbound',
      eventAction: 'Click',
      eventLabel: _format(args.label)
    };
    var safetyCallbackCalled = false;

    var safetyCallback = function safetyCallback() {
      // This prevents a delayed response from GA
      // causing hitCallback from being fired twice
      safetyCallbackCalled = true;
      hitCallback();
    }; // Using a timeout to ensure the execution of critical application code
    // in the case when the GA server might be down
    // or an ad blocker prevents sending the data
    // register safety net timeout:


    var t = setTimeout(safetyCallback, 250);

    var clearableCallbackForGA = function clearableCallbackForGA() {
      clearTimeout(t);

      if (!safetyCallbackCalled) {
        hitCallback();
      }
    };

    fieldObject.hitCallback = clearableCallbackForGA; // Send to GA

    send(fieldObject, trackerNames);
  } else {
    // if ga is not defined, return the callback so the application
    // continues to work as expected
    setTimeout(hitCallback, 0);
  }
}
var testModeAPI = TestModeAPI;
var core = {
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: TestModeAPI
};

var Defaults = /*#__PURE__*/Object.freeze({
  __proto__: null,
  initialize: initialize,
  ga: ga,
  set: set,
  send: send,
  pageview: pageview,
  modalview: modalview,
  timing: timing,
  event: event,
  exception: exception,
  plugin: plugin,
  outboundLink: outboundLink,
  testModeAPI: testModeAPI,
  'default': core
});

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
OutboundLink$1.origTrackLink = OutboundLink$1.trackLink;
OutboundLink$1.trackLink = outboundLink;
var OutboundLink = OutboundLink$1;
var ReactGA = _objectSpread({}, Defaults, {
  OutboundLink: OutboundLink
});

var gtag_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var gtag = function gtag() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  if (typeof window !== "undefined") {
    var _window;
    if (typeof window.gtag === "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }
    (_window = window).gtag.apply(_window, args);
  }
};
var _default = gtag;
exports["default"] = _default;
});

unwrapExports(gtag_1);

var format_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = format;
var smallWords = /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
function toTitleCase(string) {
  return string.toString().trim().replace(/[A-Za-z0-9\u00C0-\u00FF]+[^\s-]*/g, function (match, index, title) {
    if (index > 0 && index + match.length !== title.length && match.search(smallWords) > -1 && title.charAt(index - 2) !== ":" && (title.charAt(index + match.length) !== "-" || title.charAt(index - 1) === "-") && title.charAt(index - 1).search(/[^\s-]/) < 0) {
      return match.toLowerCase();
    }
    if (match.substr(1).search(/[A-Z]|\../) > -1) {
      return match;
    }
    return match.charAt(0).toUpperCase() + match.substr(1);
  });
}

// See if s could be an email address. We don't want to send personal data like email.
// https://support.google.com/analytics/answer/2795983?hl=en
function mightBeEmail(s) {
  // There's no point trying to validate rfc822 fully, just look for ...@...
  return typeof s === "string" && s.indexOf("@") !== -1;
}
var redacted = "REDACTED (Potential Email Address)";
function redactEmail(string) {
  if (mightBeEmail(string)) {
    console.warn("This arg looks like an email address, redacting.");
    return redacted;
  }
  return string;
}
function format() {
  var s = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var titleCase = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var redactingEmail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var _str = s || "";
  if (titleCase) {
    _str = toTitleCase(s);
  }
  if (redactingEmail) {
    _str = redactEmail(_str);
  }
  return _str;
}
});

unwrapExports(format_1);

var ga4 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.GA4 = void 0;
var _gtag = _interopRequireDefault(gtag_1);
var _format = _interopRequireDefault(format_1);
var _excluded = ["eventCategory", "eventAction", "eventLabel", "eventValue", "hitType"],
  _excluded2 = ["title", "location"],
  _excluded3 = ["page", "hitType"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/*
Links
https://developers.google.com/gtagjs/reference/api
https://developers.google.com/tag-platform/gtagjs/reference
*/
/**
 * @typedef GaOptions
 * @type {Object}
 * @property {boolean} [cookieUpdate=true]
 * @property {number} [cookieExpires=63072000] Default two years
 * @property {string} [cookieDomain="auto"]
 * @property {string} [cookieFlags]
 * @property {string} [userId]
 * @property {string} [clientId]
 * @property {boolean} [anonymizeIp]
 * @property {string} [contentGroup1]
 * @property {string} [contentGroup2]
 * @property {string} [contentGroup3]
 * @property {string} [contentGroup4]
 * @property {string} [contentGroup5]
 * @property {boolean} [allowAdFeatures=true]
 * @property {boolean} [allowAdPersonalizationSignals]
 * @property {boolean} [nonInteraction]
 * @property {string} [page]
 */
/**
 * @typedef UaEventOptions
 * @type {Object}
 * @property {string} action
 * @property {string} category
 * @property {string} [label]
 * @property {number} [value]
 * @property {boolean} [nonInteraction]
 * @property {('beacon'|'xhr'|'image')} [transport]
 */
/**
 * @typedef InitOptions
 * @type {Object}
 * @property {string} trackingId
 * @property {GaOptions|any} [gaOptions]
 * @property {Object} [gtagOptions] New parameter
 */
var GA4 = /*#__PURE__*/function () {
  function GA4() {
    var _this = this;
    _classCallCheck(this, GA4);
    _defineProperty(this, "reset", function () {
      _this.isInitialized = false;
      _this._testMode = false;
      _this._currentMeasurementId;
      _this._hasLoadedGA = false;
      _this._isQueuing = false;
      _this._queueGtag = [];
    });
    _defineProperty(this, "_gtag", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      if (!_this._testMode) {
        if (_this._isQueuing) {
          _this._queueGtag.push(args);
        } else {
          _gtag["default"].apply(void 0, args);
        }
      } else {
        _this._queueGtag.push(args);
      }
    });
    _defineProperty(this, "_loadGA", function (GA_MEASUREMENT_ID, nonce) {
      var gtagUrl = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "https://www.googletagmanager.com/gtag/js";
      if (typeof window === "undefined" || typeof document === "undefined") {
        return;
      }
      if (!_this._hasLoadedGA) {
        // Global Site Tag (gtag.js) - Google Analytics
        var script = document.createElement("script");
        script.async = true;
        script.src = "".concat(gtagUrl, "?id=").concat(GA_MEASUREMENT_ID);
        if (nonce) {
          script.setAttribute("nonce", nonce);
        }
        document.body.appendChild(script);
        window.dataLayer = window.dataLayer || [];
        window.gtag = function gtag() {
          window.dataLayer.push(arguments);
        };
        _this._hasLoadedGA = true;
      }
    });
    _defineProperty(this, "_toGtagOptions", function (gaOptions) {
      if (!gaOptions) {
        return;
      }
      var mapFields = {
        // Old https://developers.google.com/analytics/devguides/collection/analyticsjs/field-reference#cookieUpdate
        // New https://developers.google.com/analytics/devguides/collection/gtagjs/cookies-user-id#cookie_update
        cookieUpdate: "cookie_update",
        cookieExpires: "cookie_expires",
        cookieDomain: "cookie_domain",
        cookieFlags: "cookie_flags",
        // must be in set method?
        userId: "user_id",
        clientId: "client_id",
        anonymizeIp: "anonymize_ip",
        // https://support.google.com/analytics/answer/2853546?hl=en#zippy=%2Cin-this-article
        contentGroup1: "content_group1",
        contentGroup2: "content_group2",
        contentGroup3: "content_group3",
        contentGroup4: "content_group4",
        contentGroup5: "content_group5",
        // https://support.google.com/analytics/answer/9050852?hl=en
        allowAdFeatures: "allow_google_signals",
        allowAdPersonalizationSignals: "allow_ad_personalization_signals",
        nonInteraction: "non_interaction",
        page: "page_path",
        hitCallback: "event_callback"
      };
      var gtagOptions = Object.entries(gaOptions).reduce(function (prev, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        if (mapFields[key]) {
          prev[mapFields[key]] = value;
        } else {
          prev[key] = value;
        }
        return prev;
      }, {});
      return gtagOptions;
    });
    _defineProperty(this, "initialize", function (GA_MEASUREMENT_ID) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (!GA_MEASUREMENT_ID) {
        throw new Error("Require GA_MEASUREMENT_ID");
      }
      var initConfigs = typeof GA_MEASUREMENT_ID === "string" ? [{
        trackingId: GA_MEASUREMENT_ID
      }] : GA_MEASUREMENT_ID;
      _this._currentMeasurementId = initConfigs[0].trackingId;
      var gaOptions = options.gaOptions,
        gtagOptions = options.gtagOptions,
        nonce = options.nonce,
        _options$testMode = options.testMode,
        testMode = _options$testMode === void 0 ? false : _options$testMode,
        gtagUrl = options.gtagUrl;
      _this._testMode = testMode;
      if (!testMode) {
        _this._loadGA(_this._currentMeasurementId, nonce, gtagUrl);
      }
      if (!_this.isInitialized) {
        _this._gtag("js", new Date());
        initConfigs.forEach(function (config) {
          var mergedGtagOptions = _objectSpread(_objectSpread(_objectSpread({}, _this._toGtagOptions(_objectSpread(_objectSpread({}, gaOptions), config.gaOptions))), gtagOptions), config.gtagOptions);
          if (Object.keys(mergedGtagOptions).length) {
            _this._gtag("config", config.trackingId, mergedGtagOptions);
          } else {
            _this._gtag("config", config.trackingId);
          }
        });
      }
      _this.isInitialized = true;
      if (!testMode) {
        var queues = _toConsumableArray(_this._queueGtag);
        _this._queueGtag = [];
        _this._isQueuing = false;
        while (queues.length) {
          var queue = queues.shift();
          _this._gtag.apply(_this, _toConsumableArray(queue));
          if (queue[0] === "get") {
            _this._isQueuing = true;
          }
        }
      }
    });
    _defineProperty(this, "set", function (fieldsObject) {
      if (!fieldsObject) {
        console.warn("`fieldsObject` is required in .set()");
        return;
      }
      if (_typeof(fieldsObject) !== "object") {
        console.warn("Expected `fieldsObject` arg to be an Object");
        return;
      }
      if (Object.keys(fieldsObject).length === 0) {
        console.warn("empty `fieldsObject` given to .set()");
      }
      _this._gaCommand("set", fieldsObject);
    });
    _defineProperty(this, "_gaCommandSendEvent", function (eventCategory, eventAction, eventLabel, eventValue, fieldsObject) {
      _this._gtag("event", eventAction, _objectSpread(_objectSpread({
        event_category: eventCategory,
        event_label: eventLabel,
        value: eventValue
      }, fieldsObject && {
        non_interaction: fieldsObject.nonInteraction
      }), _this._toGtagOptions(fieldsObject)));
    });
    _defineProperty(this, "_gaCommandSendEventParameters", function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      if (typeof args[0] === "string") {
        _this._gaCommandSendEvent.apply(_this, _toConsumableArray(args.slice(1)));
      } else {
        var _args$ = args[0],
          eventCategory = _args$.eventCategory,
          eventAction = _args$.eventAction,
          eventLabel = _args$.eventLabel,
          eventValue = _args$.eventValue;
          _args$.hitType;
          var rest = _objectWithoutProperties(_args$, _excluded);
        _this._gaCommandSendEvent(eventCategory, eventAction, eventLabel, eventValue, rest);
      }
    });
    _defineProperty(this, "_gaCommandSendTiming", function (timingCategory, timingVar, timingValue, timingLabel) {
      _this._gtag("event", "timing_complete", {
        name: timingVar,
        value: timingValue,
        event_category: timingCategory,
        event_label: timingLabel
      });
    });
    _defineProperty(this, "_gaCommandSendPageview", function (page, fieldsObject) {
      if (fieldsObject && Object.keys(fieldsObject).length) {
        var _this$_toGtagOptions = _this._toGtagOptions(fieldsObject),
          title = _this$_toGtagOptions.title,
          location = _this$_toGtagOptions.location,
          rest = _objectWithoutProperties(_this$_toGtagOptions, _excluded2);
        _this._gtag("event", "page_view", _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, page && {
          page_path: page
        }), title && {
          page_title: title
        }), location && {
          page_location: location
        }), rest));
      } else if (page) {
        _this._gtag("event", "page_view", {
          page_path: page
        });
      } else {
        _this._gtag("event", "page_view");
      }
    });
    _defineProperty(this, "_gaCommandSendPageviewParameters", function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }
      if (typeof args[0] === "string") {
        _this._gaCommandSendPageview.apply(_this, _toConsumableArray(args.slice(1)));
      } else {
        var _args$2 = args[0],
          page = _args$2.page;
          _args$2.hitType;
          var rest = _objectWithoutProperties(_args$2, _excluded3);
        _this._gaCommandSendPageview(page, rest);
      }
    });
    _defineProperty(this, "_gaCommandSend", function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }
      var hitType = typeof args[0] === "string" ? args[0] : args[0].hitType;
      switch (hitType) {
        case "event":
          _this._gaCommandSendEventParameters.apply(_this, args);
          break;
        case "pageview":
          _this._gaCommandSendPageviewParameters.apply(_this, args);
          break;
        case "timing":
          _this._gaCommandSendTiming.apply(_this, _toConsumableArray(args.slice(1)));
          break;
        case "screenview":
        case "transaction":
        case "item":
        case "social":
        case "exception":
          console.warn("Unsupported send command: ".concat(hitType));
          break;
        default:
          console.warn("Send command doesn't exist: ".concat(hitType));
      }
    });
    _defineProperty(this, "_gaCommandSet", function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }
      if (typeof args[0] === "string") {
        args[0] = _defineProperty({}, args[0], args[1]);
      }
      _this._gtag("set", _this._toGtagOptions(args[0]));
    });
    _defineProperty(this, "_gaCommand", function (command) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }
      switch (command) {
        case "send":
          _this._gaCommandSend.apply(_this, args);
          break;
        case "set":
          _this._gaCommandSet.apply(_this, args);
          break;
        default:
          console.warn("Command doesn't exist: ".concat(command));
      }
    });
    _defineProperty(this, "ga", function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }
      if (typeof args[0] === "string") {
        _this._gaCommand.apply(_this, args);
      } else {
        var readyCallback = args[0];
        _this._gtag("get", _this._currentMeasurementId, "client_id", function (clientId) {
          _this._isQueuing = false;
          var queues = _this._queueGtag;
          readyCallback({
            get: function get(property) {
              return property === "clientId" ? clientId : property === "trackingId" ? _this._currentMeasurementId : property === "apiVersion" ? "1" : undefined;
            }
          });
          while (queues.length) {
            var queue = queues.shift();
            _this._gtag.apply(_this, _toConsumableArray(queue));
          }
        });
        _this._isQueuing = true;
      }
      return _this.ga;
    });
    _defineProperty(this, "event", function (optionsOrName, params) {
      if (typeof optionsOrName === "string") {
        _this._gtag("event", optionsOrName, _this._toGtagOptions(params));
      } else {
        var action = optionsOrName.action,
          category = optionsOrName.category,
          label = optionsOrName.label,
          value = optionsOrName.value,
          nonInteraction = optionsOrName.nonInteraction,
          transport = optionsOrName.transport;
        if (!category || !action) {
          console.warn("args.category AND args.action are required in event()");
          return;
        }

        // Required Fields
        var fieldObject = {
          hitType: "event",
          eventCategory: (0, _format["default"])(category),
          eventAction: (0, _format["default"])(action)
        };

        // Optional Fields
        if (label) {
          fieldObject.eventLabel = (0, _format["default"])(label);
        }
        if (typeof value !== "undefined") {
          if (typeof value !== "number") {
            console.warn("Expected `args.value` arg to be a Number.");
          } else {
            fieldObject.eventValue = value;
          }
        }
        if (typeof nonInteraction !== "undefined") {
          if (typeof nonInteraction !== "boolean") {
            console.warn("`args.nonInteraction` must be a boolean.");
          } else {
            fieldObject.nonInteraction = nonInteraction;
          }
        }
        if (typeof transport !== "undefined") {
          if (typeof transport !== "string") {
            console.warn("`args.transport` must be a string.");
          } else {
            if (["beacon", "xhr", "image"].indexOf(transport) === -1) {
              console.warn("`args.transport` must be either one of these values: `beacon`, `xhr` or `image`");
            }
            fieldObject.transport = transport;
          }
        }
        _this._gaCommand("send", fieldObject);
      }
    });
    _defineProperty(this, "send", function (fieldObject) {
      _this._gaCommand("send", fieldObject);
    });
    this.reset();
  }
  _createClass(GA4, [{
    key: "gtag",
    value: function gtag() {
      this._gtag.apply(this, arguments);
    }
  }]);
  return GA4;
}();
exports.GA4 = GA4;
var _default = new GA4();
exports["default"] = _default;
});

unwrapExports(ga4);
ga4.GA4;

var dist = createCommonjsModule(function (module, exports) {

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ReactGAImplementation = void 0;
var _ga = _interopRequireWildcard(ga4);
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var ReactGAImplementation = _ga.GA4;
exports.ReactGAImplementation = ReactGAImplementation;
var _default = _ga["default"];
exports["default"] = _default;
});

var ReactGA4 = unwrapExports(dist);
dist.ReactGAImplementation;

class PelcroActions {
  constructor(storeSetter, storeGetter) {
    var _this = this;
    _defineProperty$3(this, "resetState", () => {
      const {
        view,
        cartItems,
        ...otherStateFields
      } = initialState$o;
      this.set(otherStateFields);
    });
    _defineProperty$3(this, "switchView", view => {
      var _window$Pelcro$site$r;
      // view switching guards
      if (userMustVerifyEmail() && !["dashboard", "meter", "login", null].includes(view)) {
        return this.set({
          view: "email-verify"
        });
      }
      if (["login", "register"].includes(view) && this.get().isAuthenticated()) {
        return this.set({
          view: "dashboard"
        });
      }
      if (["dashboard", "password-change"].includes(view) && !this.get().isAuthenticated()) {
        return this.set({
          view: "login"
        });
      }
      if (["passwordless-request"].includes(view) && (this.get().isAuthenticated() || !((_window$Pelcro$site$r = window.Pelcro.site.read()) !== null && _window$Pelcro$site$r !== void 0 && _window$Pelcro$site$r.passwordless_enabled))) {
        return this.set({
          view: null
        });
      }
      this.set({
        view
      });
    });
    _defineProperty$3(this, "resetView", () => {
      const {
        switchView,
        resetState
      } = this.get();
      switchView(null);
      resetState();
    });
    _defineProperty$3(this, "switchToPaymentView", () => {
      const {
        switchView,
        resetView,
        switchToCheckoutForm,
        product,
        order,
        invoice
      } = this.get();
      if (product || order || invoice) {
        // direct user to stripe checkout form when there are no existing cards
        if (!userHasPaymentMethod()) {
          return switchToCheckoutForm();
        }
        return switchView("payment-method-select");
      }
      return resetView();
    });
    _defineProperty$3(this, "switchToCheckoutForm", () => {
      const {
        switchView,
        product,
        subscriptionIdToRenew,
        order,
        invoice
      } = this.get();
      if (product && subscriptionIdToRenew) {
        return switchView("subscription-renew");
      }
      if (product && !subscriptionIdToRenew) {
        return switchView("subscription-create");
      }
      if (order) {
        return switchView("order-create");
      }
      if (invoice) {
        return switchView("invoice-payment");
      }
    });
    _defineProperty$3(this, "switchToAddressView", () => {
      const {
        switchView
      } = this.get();
      if (userHasAddress()) {
        switchView("address-select");
      } else {
        switchView("address-create");
      }
    });
    _defineProperty$3(this, "setProduct", id => {
      const product = window.Pelcro.product.getById(id);
      if (!product) return console.error("invalid product id");
      this.set({
        product
      });
    });
    _defineProperty$3(this, "setPlan", id => {
      const plan = window.Pelcro.plan.getById(id);
      if (!plan) return console.error("invalid plan id");
      this.set({
        plan
      });
    });
    _defineProperty$3(this, "setSubscriptionToCancel", id => {
      var _window$Pelcro$subscr;
      const subscriptions = (_window$Pelcro$subscr = window.Pelcro.subscription.list()) !== null && _window$Pelcro$subscr !== void 0 ? _window$Pelcro$subscr : [];
      const subscriptionToCancel = subscriptions.filter(sub => String(sub.id) === String(id))[0];
      if (!subscriptionToCancel) {
        return console.error("invalid subscription id");
      }
      this.set({
        subscriptionToCancel
      });
    });
    _defineProperty$3(this, "setSubscriptionToSuspend", id => {
      var _window$Pelcro$subscr2;
      const subscriptions = (_window$Pelcro$subscr2 = window.Pelcro.subscription.list()) !== null && _window$Pelcro$subscr2 !== void 0 ? _window$Pelcro$subscr2 : [];
      const subscriptionToSuspend = subscriptions.filter(sub => String(sub.id) === String(id))[0];
      if (!subscriptionToSuspend) {
        return console.error("invalid subscription id");
      }
      this.set({
        subscriptionToSuspend
      });
    });
    _defineProperty$3(this, "setSubscriptionToManageMembers", id => {
      var _window$Pelcro$subscr3, _subscriptionToManage;
      const subscriptions = (_window$Pelcro$subscr3 = window.Pelcro.subscription.list()) !== null && _window$Pelcro$subscr3 !== void 0 ? _window$Pelcro$subscr3 : [];
      const subscriptionToManageMembers = subscriptions.filter(sub => String(sub.id) === String(id))[0];
      if (!subscriptionToManageMembers) {
        return console.error("invalid subscription id");
      }
      if ((subscriptionToManageMembers === null || subscriptionToManageMembers === void 0 ? void 0 : (_subscriptionToManage = subscriptionToManageMembers.plan) === null || _subscriptionToManage === void 0 ? void 0 : _subscriptionToManage.type) !== "membership") {
        return console.error("subscription is not from type membership");
      }
      this.set({
        subscriptionToManageMembers
      });
      return true;
    });
    _defineProperty$3(this, "setInvoice", id => {
      var _window$Pelcro$invoic;
      const invoices = (_window$Pelcro$invoic = window.Pelcro.invoice.list()) !== null && _window$Pelcro$invoic !== void 0 ? _window$Pelcro$invoic : [];
      const invoice = invoices.find(inv => String(inv.id) === String(id));
      if (!invoice) {
        console.error("invalid invoice id");
        return false;
      }
      this.set({
        invoice
      });
      return true;
    });
    _defineProperty$3(this, "setSelectedMembership", id => {
      var _window$Pelcro$user$r, _window$Pelcro$user$r2;
      const memberships = (_window$Pelcro$user$r = (_window$Pelcro$user$r2 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r2 === void 0 ? void 0 : _window$Pelcro$user$r2.memberships) !== null && _window$Pelcro$user$r !== void 0 ? _window$Pelcro$user$r : [];
      const membership = memberships.find(membership => String(membership.id) === String(id));
      if (!membership) {
        console.error("invalid membership id");
        return false;
      }
      this.set({
        selectedMembership: membership
      });
      return true;
    });
    _defineProperty$3(this, "setCouponCode", couponCode => {
      if (!couponCode) return console.error("invalid coupon code");
      this.set({
        couponCode
      });
    });
    _defineProperty$3(this, "logout", function () {
      var _window, _window$Pelcro, _window$Pelcro$uiSett;
      let displayLogin = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      const {
        switchView,
        resetView,
        isAuthenticated
      } = _this.get();
      const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
      // if user is not authenticated function execution is terminated
      if (!isAuthenticated()) {
        return console.warn("You are already logged out.");
      }
      window.Pelcro.user.logout();
      if (enableReactGA4) {
        ReactGA4.event("Logged out", {
          nonInteraction: true
        });
      } else {
        var _ReactGA$event;
        ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
          category: "ACTIONS",
          action: "Logged out",
          nonInteraction: true
        });
      }
      resetView();
      if (displayLogin) {
        switchView("login");
      }
    });
    _defineProperty$3(this, "addToCart", itemSkuId => {
      const itemToAdd = window.Pelcro.ecommerce.products.getBySkuId(Number(itemSkuId));
      if (!itemToAdd) {
        console.error("invalid item SKU id");
        return false;
      }

      // Dispatch PelcroElementsCartItemAdded when an item added successfully to the
      document.dispatchEvent(cartItemAdded(itemToAdd));
      const {
        cartItems
      } = this.get();
      const itemAlreadyExists = cartItems.some(item => item.id === itemToAdd.id);
      if (itemAlreadyExists) {
        // increase quantity of item
        const itemsWithIncreasedQuantity = cartItems.map(item => {
          if (item.id === itemToAdd.id) {
            return {
              ...item,
              quantity: item.quantity + 1
            };
          }
          return item;
        });
        this.set({
          cartItems: itemsWithIncreasedQuantity
        });
        return true;
      }

      // add new item
      const newItemWithQuantity = {
        ...itemToAdd,
        quantity: 1
      };
      this.set(prevState => ({
        cartItems: [...prevState.cartItems, newItemWithQuantity]
      }));
      return true;
    });
    _defineProperty$3(this, "removeFromCart", itemSkuId => {
      const {
        cartItems
      } = this.get();
      const itemToRemoveIdx = cartItems.findIndex(item => item.id === Number(itemSkuId));
      if (itemToRemoveIdx === -1) {
        console.error("invalid item SKU id");
        return false;
      }
      const itemToRemove = cartItems[itemToRemoveIdx];
      if (itemToRemove.quantity > 1) {
        // reduce quantity of item
        const newItems = cartItems.map((item, i) => {
          if (i === itemToRemoveIdx) {
            return {
              ...item,
              quantity: item.quantity - 1
            };
          }
          return item;
        });
        this.set({
          cartItems: newItems
        });
        return true;
      }

      // remove the item
      const newItems = cartItems.filter(item => item !== itemToRemove);
      this.set({
        cartItems: newItems
      });
      return true;
    });
    _defineProperty$3(this, "purchaseItem", itemSkuId => {
      const quickPurchaseItem = window.Pelcro.ecommerce.products.getBySkuId(Number(itemSkuId));
      if (!quickPurchaseItem) {
        console.error("invalid item SKU id");
        return false;
      }
      const skusMatchingUserCurrency = window.Pelcro.ecommerce.products.getSkus();
      const itemMatchesUserCurrency = skusMatchingUserCurrency.some(sku => sku.id === quickPurchaseItem.id);
      if (!itemMatchesUserCurrency) {
        const userCurrency = window.Pelcro.user.read().currency;
        console.error(`SKU currency (${quickPurchaseItem.currency}) doesn't match user account's currency (${userCurrency}). users can only purchase SKUs that match their account's currency`);
        return false;
      }
      const quickPurchaseItemWithQuantity = {
        ...quickPurchaseItem,
        quantity: 1
      };
      this.set({
        order: quickPurchaseItemWithQuantity
      });
      const {
        isAuthenticated,
        switchView,
        switchToAddressView
      } = this.get();
      if (!isAuthenticated()) {
        return switchView("register");
      }
      switchToAddressView();
    });
    _defineProperty$3(this, "setPaymentMethodToEdit", id => {
      window.Pelcro.paymentMethods.getPaymentMethod({
        auth_token: window.Pelcro.user.read().auth_token,
        payment_method_id: id
      }, (err, res) => {
        if (err) {
          return console.error("invalid payment method id");
        }
        if (res) {
          const paymentMethodToEdit = res.data;
          this.set({
            paymentMethodToEdit
          });
        }
      });
    });
    _defineProperty$3(this, "setPaymentMethodToDelete", id => {
      window.Pelcro.paymentMethods.getPaymentMethod({
        auth_token: window.Pelcro.user.read().auth_token,
        payment_method_id: id
      }, (err, res) => {
        if (err) {
          return console.error("invalid payment method id");
        }
        if (res) {
          const paymentMethodToDelete = res.data;
          this.set({
            paymentMethodToDelete
          });
        }
      });
    });
    this.set = storeSetter;
    this.get = storeGetter;
  }

  /**
   * State actions
   */
}

class PelcroCallbacks {
  constructor() {
    _defineProperty$3(this, "whenSiteReady", callback => {
      var _window$Pelcro$site$r;
      if ((_window$Pelcro$site$r = window.Pelcro.site.read()) !== null && _window$Pelcro$site$r !== void 0 && _window$Pelcro$site$r.settings) {
        callback(window.Pelcro.site.read());
      } else {
        window.document.addEventListener("PelcroSiteLoaded", e => {
          callback(window.Pelcro.site.read());
        });
      }
    });
    _defineProperty$3(this, "whenUserReady", (callback, listenerOptions) => {
      var _window$Pelcro$user$r;
      if ((_window$Pelcro$user$r = window.Pelcro.user.read()) !== null && _window$Pelcro$user$r !== void 0 && _window$Pelcro$user$r.id) {
        callback(window.Pelcro.user.read());
      } else {
        window.document.addEventListener("PelcroUserLoaded", e => {
          callback(window.Pelcro.user.read());
        }, listenerOptions);
      }
    });
    _defineProperty$3(this, "whenEcommerceLoaded", callback => {
      var _window$Pelcro$ecomme;
      if ((_window$Pelcro$ecomme = window.Pelcro.ecommerce.products.read()) !== null && _window$Pelcro$ecomme !== void 0 && _window$Pelcro$ecomme.length) {
        callback(window.Pelcro.ecommerce.products.read());
      } else {
        window.document.addEventListener("PelcroEcommerceProductsLoaded", e => {
          callback(window.Pelcro.ecommerce.products.read());
        });
      }
    });
  }
}

const initialState$o = {
  // View
  view: null,
  // Plans
  product: null,
  plan: null,
  isGift: false,
  isRenewingGift: false,
  giftRecipient: null,
  giftCode: "",
  subscriptionIdToRenew: null,
  subscriptionToManageMembers: null,
  // E-commerce
  cartItems: [],
  order: null,
  // null | SKU[] | SKU,

  // invoices
  invoice: null,
  // couponCode
  couponCode: null,
  // memberships
  selectedMembership: null,
  // paymentMethods
  paymentMethodToDelete: null,
  paymentMethodToEdit: null,
  // User
  isAuthenticated: () => window.Pelcro.user.isAuthenticated(),
  selectedPaymentMethodId: null,
  selectedAddressId: null,
  addressIdToEdit: null
};
const createPelcroStore = () => createStore(middleware_3((set, get) => {
  const actions = new PelcroActions(set, get);
  const eventCallbacks = new PelcroCallbacks();
  return {
    // Store setter
    set,
    ...initialState$o,
    // State actions
    ...actions,
    // Callbacks
    ...eventCallbacks
  };
}, {
  name: "pelcro-store",
  whitelist: ["cartItems"]
}));
const createPelcroHook = store => {
  // initiate hook with zustand creator
  const pelcroHook = create(store);

  /**
   * Override internal implementation inside pelcro store
   * @param {function(storeSetter, storeGetter): object} fn
   */
  pelcroHook.override = fn => {
    const partialState = fn(store.setState, store.getState);
    usePelcro.setState(partialState);
  };
  pelcroHook.getStore = pelcroHook.getState;
  return pelcroHook;
};
const pelcroStore = createPelcroStore();
const usePelcro = createPelcroHook(pelcroStore);

/* istanbul ignore next */
if (process.env.NODE_ENV === "development") {
  c$1("Pelcro Store", usePelcro);
}

/**
 * List of zero-decimal currencies.
 * @see https://stripe.com/docs/currencies#zero-decimal
 *
 */
const ZERO_DECIMAL_CURRENCIES = ["BIF", "CLP", "DJF", "GNF", "JPY", "KMF", "KRW", "MGA", "PYG", "RWF", "UGX", "VND", "VUV", "XAF", "XOF", "XPF"];

/**
 * @param {string}
 * @return {boolean}
 */
const isCurrencyZeroDecimal = currency => ZERO_DECIMAL_CURRENCIES.includes(currency.toUpperCase());
const sortCountries = countries => {
  const sortable = [];
  const {
    CA,
    US,
    ...rest
  } = countries;
  for (const abbr in rest) {
    sortable.push([abbr, rest[abbr]]);
  }
  sortable.sort((a, b) => {
    if (a[1] > b[1]) return 1;
    return -1;
  });
  sortable.unshift(["US", US], ["CA", CA]);
  return sortable;
};

/**
 * Recursively filters out null values (null, undefined)
 * @param {object} obj
 * @return {object} filtered object
 * @example
 *  cleanObjectNullValues({one: "not empty", two: null, three: {nested: null}})
 *
 *  {
 *    one: "not empty",
 *    three: {}
 *  }
 */
const cleanObjectNullValues = obj => Object.entries(obj).map(_ref => {
  let [k, v] = _ref;
  return [k, v && typeof v === "object" ? cleanObjectNullValues(v) : v];
}).reduce((a, _ref2) => {
  let [k, v] = _ref2;
  return v == null ? a : (a[k] = v, a);
}, {});

/**
 * get an address using it's id
 * @param {number} id id of the wanted address
 * @return {object?} address with the matching id
 */
const getAddressById = id => {
  var _window$Pelcro$user$r;
  const addresses = (_window$Pelcro$user$r = window.Pelcro.user.read().addresses) !== null && _window$Pelcro$user$r !== void 0 ? _window$Pelcro$user$r : [];
  return addresses.find(address => address.id === Number(id));
};

/**
 * Transforms locale names stored in our backend like
 * "en_US" into the standard accepted in core i18n methods: "en-US"
 * @param {string} localeName
 * @return {string | undefined}
 * @example getCanonicalLocaleFormat("en_US") => "en-US"
 */
const getCanonicalLocaleFormat = localeName => localeName === null || localeName === void 0 ? void 0 : localeName.replace("_", "-");

/**
 * @param {string} localeName
 * @return {string | undefined}
 * @example getLanguageWithoutRegion("en-US") => "en"
 */
const getLanguageWithoutRegion = localeName => {
  var _getCanonicalLocaleFo;
  return (_getCanonicalLocaleFo = getCanonicalLocaleFormat(localeName)) === null || _getCanonicalLocaleFo === void 0 ? void 0 : _getCanonicalLocaleFo.split("-")[0];
};

/**
 * Gets the current page language or fallbacks to site default
 * @return {string | undefined}
 */
const getPageOrDefaultLanguage = () => {
  var _window$Pelcro$helper, _window$Pelcro, _window$Pelcro$site, _window$Pelcro$site$r, _window$Pelcro$site$r2;
  return (_window$Pelcro$helper = window.Pelcro.helpers.getHtmlLanguageAttribute()) !== null && _window$Pelcro$helper !== void 0 ? _window$Pelcro$helper : getLanguageWithoutRegion((_window$Pelcro = window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$site = _window$Pelcro.site) === null || _window$Pelcro$site === void 0 ? void 0 : (_window$Pelcro$site$r = _window$Pelcro$site.read) === null || _window$Pelcro$site$r === void 0 ? void 0 : (_window$Pelcro$site$r2 = _window$Pelcro$site$r.call(_window$Pelcro$site)) === null || _window$Pelcro$site$r2 === void 0 ? void 0 : _window$Pelcro$site$r2.default_locale);
};

/**
 * Returns a formatted price string depending on locale
 * @param {number} amount
 * @param {string} currency
 * @param {string} locale
 * @return {string}
 * @example getFormattedPriceByLocal(10, 'USD', 'en-US') => "$10.00"
 */
const getFormattedPriceByLocal = function (amount) {
  let currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "USD";
  let locale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "en";
  const formatter = new Intl.NumberFormat(getCanonicalLocaleFormat(locale), {
    style: "currency",
    currency
  });
  return isCurrencyZeroDecimal(currency) ? formatter.format(amount) : formatter.format(amount / 100);
};

/** check wether or not the user have any addresses
 * @return {boolean} true if the user have at least one address, false otherwise
 */
const userHasAddress = () => {
  var _window$Pelcro$user$r2, _window$Pelcro$user$r3;
  const addresses = (_window$Pelcro$user$r2 = (_window$Pelcro$user$r3 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r3 === void 0 ? void 0 : _window$Pelcro$user$r3.addresses) !== null && _window$Pelcro$user$r2 !== void 0 ? _window$Pelcro$user$r2 : [];
  return addresses.length > 0;
};
const calcAndFormatItemsTotal = (items, currency) => {
  if (!Array.isArray(items)) return;
  let totalWithoutDividingBy100 = 0;
  for (const item of items) {
    totalWithoutDividingBy100 += parseFloat(item !== null && item !== void 0 && item.price || (item === null || item === void 0 ? void 0 : item.price) === 0 ? isCurrencyZeroDecimal(currency) ? item.price * item.quantity : (item.price * item.quantity).toFixed(2) : isCurrencyZeroDecimal(currency) ? item.amount : item.amount.toFixed(2));
  }
  return getFormattedPriceByLocal(totalWithoutDividingBy100, currency, getPageOrDefaultLanguage());
};

/**
 * returns true if the URL contains a supported view trigger URL
 * @param {string} viewID
 * @return {boolean}
 */
const isValidViewFromURL = viewID => {
  if (["login", "register", "plan-select", "gift-redeem", "password-forgot", "password-reset", "password-change", "passwordless-request", "passwordless-login", "payment-method-update", "user-edit", "newsletter", "address-create", "order-create", "cart", "email-verify", "invoice-details", "manage-members"].includes(viewID) || hasValidNewsletterUpdateUrl()) {
    return true;
  }
  return false;

  /**
   *
   */
  function hasValidNewsletterUpdateUrl() {
    var _window$Pelcro2, _window$Pelcro2$uiSet;
    if (viewID !== "newsletter-update") return false;
    const newsletters = (_window$Pelcro2 = window.Pelcro) === null || _window$Pelcro2 === void 0 ? void 0 : (_window$Pelcro2$uiSet = _window$Pelcro2.uiSettings) === null || _window$Pelcro2$uiSet === void 0 ? void 0 : _window$Pelcro2$uiSet.newsletters;
    const siteHasNewslettersDefined = Array.isArray(newsletters) && newsletters.length > 0;
    if (!siteHasNewslettersDefined) {
      return false;
    }
    const queryParamEmail = window.Pelcro.helpers.getURLParameter("email");
    if (queryParamEmail && window.Pelcro.user.isAuthenticated()) {
      var _window$Pelcro$user$r4;
      if (queryParamEmail !== ((_window$Pelcro$user$r4 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r4 === void 0 ? void 0 : _window$Pelcro$user$r4.email)) {
        console.error("email query parameter and user account email are different, url email query parameter must match user email if user is logged in");
        return false;
      }
    }
    if (!queryParamEmail && !window.Pelcro.user.isAuthenticated()) {
      return false;
    }
    return true;
  }
};

/**
 * Returns the current stable viewID from all old variations
 * @param {string} view
 * @return {string}
 */
const getStableViewID = view => {
  if (view === "select") {
    return "plan-select";
  }
  if (view === "redeem") {
    return "gift-redeem";
  }
  if (view === "address") {
    return "address-create";
  }
  return view;
};
const enableScroll = () => {
  document.body.classList.remove("pelcro-modal-open");
};
const disableScroll = () => {
  if (!document.body.classList.contains("pelcro-modal-open")) {
    document.body.classList.add("pelcro-modal-open");
  }
};
const trackSubscriptionOnGA = () => {
  var _window, _window$Pelcro3, _window$Pelcro3$uiSet, _window$Pelcro$user$r5, _window$Pelcro$user$r6;
  const {
    product,
    plan,
    couponCode
  } = usePelcro.getStore();

  /*   
  getting the latest subscription id from invoices instead of subscriptions
  to handle gifted subs which are not added to subs list
  */
  const {
    invoices
  } = window.Pelcro.user.read();
  const lastSubscriptionId = invoices === null || invoices === void 0 ? void 0 : invoices[invoices.length - 1].subscription_id;
  const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro3 = _window.Pelcro) === null || _window$Pelcro3 === void 0 ? void 0 : (_window$Pelcro3$uiSet = _window$Pelcro3.uiSettings) === null || _window$Pelcro3$uiSet === void 0 ? void 0 : _window$Pelcro3$uiSet.enableReactGA4;
  if (!lastSubscriptionId) {
    return;
  }
  const currencyCode = (_window$Pelcro$user$r5 = (_window$Pelcro$user$r6 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r6 === void 0 ? void 0 : _window$Pelcro$user$r6.currency) !== null && _window$Pelcro$user$r5 !== void 0 ? _window$Pelcro$user$r5 : plan.currency;
  if (enableReactGA4) {
    ReactGA4.event("purchase", {
      transaction_id: lastSubscriptionId,
      affiliation: "Pelcro",
      currency: currencyCode,
      value: plan !== null && plan !== void 0 && plan.amount ? isCurrencyZeroDecimal(currencyCode) ? plan.amount : plan.amount / 100 : 0,
      coupon: couponCode,
      items: [{
        item_id: lastSubscriptionId,
        item_name: product.name,
        item_category: product.description,
        item_variant: plan.nickname,
        price: plan !== null && plan !== void 0 && plan.amount ? isCurrencyZeroDecimal(currencyCode) ? plan.amount : plan.amount / 100 : 0,
        quantity: 1
      }]
    });
    ReactGA4.event("Subscribed", {
      nonInteraction: true
    });
  } else {
    var _ReactGA$set, _ReactGA$plugin, _ReactGA$plugin$execu, _ReactGA$plugin2, _ReactGA$plugin2$exec, _ReactGA$plugin3, _ReactGA$plugin3$exec, _ReactGA$event;
    ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$set = ReactGA.set) === null || _ReactGA$set === void 0 ? void 0 : _ReactGA$set.call(ReactGA, {
      currencyCode: currencyCode
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$plugin = ReactGA.plugin) === null || _ReactGA$plugin === void 0 ? void 0 : (_ReactGA$plugin$execu = _ReactGA$plugin.execute) === null || _ReactGA$plugin$execu === void 0 ? void 0 : _ReactGA$plugin$execu.call(_ReactGA$plugin, "ecommerce", "addTransaction", {
      id: lastSubscriptionId,
      affiliation: "Pelcro",
      revenue: plan !== null && plan !== void 0 && plan.amount ? isCurrencyZeroDecimal(currencyCode) ? plan.amount : plan.amount / 100 : 0,
      coupon: couponCode
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$plugin2 = ReactGA.plugin) === null || _ReactGA$plugin2 === void 0 ? void 0 : (_ReactGA$plugin2$exec = _ReactGA$plugin2.execute) === null || _ReactGA$plugin2$exec === void 0 ? void 0 : _ReactGA$plugin2$exec.call(_ReactGA$plugin2, "ecommerce", "addItem", {
      id: lastSubscriptionId,
      name: product.name,
      category: product.description,
      variant: plan.nickname,
      price: plan !== null && plan !== void 0 && plan.amount ? isCurrencyZeroDecimal(currencyCode) ? plan.amount : plan.amount / 100 : 0,
      quantity: 1
    });
    ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$plugin3 = ReactGA.plugin) === null || _ReactGA$plugin3 === void 0 ? void 0 : (_ReactGA$plugin3$exec = _ReactGA$plugin3.execute) === null || _ReactGA$plugin3$exec === void 0 ? void 0 : _ReactGA$plugin3$exec.call(_ReactGA$plugin3, "ecommerce", "send");
    ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
      category: "ACTIONS",
      action: "Subscribed",
      nonInteraction: true
    });
  }
};

/** check wether or not the user have any existing payment method
 * @return {boolean} true if the user have at least one payment method (source), false otherwise
 */
const userHasPaymentMethod = () => {
  var _window$Pelcro$user$r7, _window$Pelcro$user$r8;
  const sources = (_window$Pelcro$user$r7 = (_window$Pelcro$user$r8 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r8 === void 0 ? void 0 : _window$Pelcro$user$r8.sources) !== null && _window$Pelcro$user$r7 !== void 0 ? _window$Pelcro$user$r7 : [];
  return sources.length > 0;
};

/**
 * @param {Element} elem html element with data-pelcro-entitlements attribute
 * @return {Array<String>} array of entitlements extracted from the data-pelcro-entitlements
 * attribute
 */
const getEntitlementsFromElem = elem => {
  return elem.dataset.pelcroEntitlements.split(",").map(entitlement => entitlement.trim()).filter(entitlement => entitlement);
};
const getPaymentCardIcon$1 = name => {
  const icons = {
    visa: /*#__PURE__*/React__default.createElement("svg", {
      className: "plc-w-16",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 48 48"
    }, /*#__PURE__*/React__default.createElement("path", {
      fill: "#1565C0",
      d: "M15.186 19l-2.626 7.832c0 0-.667-3.313-.733-3.729-1.495-3.411-3.701-3.221-3.701-3.221L10.726 30v-.002h3.161L18.258 19H15.186zM17.689 30L20.56 30 22.296 19 19.389 19zM38.008 19h-3.021l-4.71 11h2.852l.588-1.571h3.596L37.619 30h2.613L38.008 19zM34.513 26.328l1.563-4.157.818 4.157H34.513zM26.369 22.206c0-.606.498-1.057 1.926-1.057.928 0 1.991.674 1.991.674l.466-2.309c0 0-1.358-.515-2.691-.515-3.019 0-4.576 1.444-4.576 3.272 0 3.306 3.979 2.853 3.979 4.551 0 .291-.231.964-1.888.964-1.662 0-2.759-.609-2.759-.609l-.495 2.216c0 0 1.063.606 3.117.606 2.059 0 4.915-1.54 4.915-3.752C30.354 23.586 26.369 23.394 26.369 22.206z"
    }), /*#__PURE__*/React__default.createElement("path", {
      fill: "#FFC107",
      d: "M12.212,24.945l-0.966-4.748c0,0-0.437-1.029-1.573-1.029c-1.136,0-4.44,0-4.44,0S10.894,20.84,12.212,24.945z"
    })),
    mastercard: /*#__PURE__*/React__default.createElement("svg", {
      className: "plc-w-16",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 48 48"
    }, /*#__PURE__*/React__default.createElement("path", {
      fill: "#ff9800",
      d: "M32 10A14 14 0 1 0 32 38A14 14 0 1 0 32 10Z"
    }), /*#__PURE__*/React__default.createElement("path", {
      fill: "#d50000",
      d: "M16 10A14 14 0 1 0 16 38A14 14 0 1 0 16 10Z"
    }), /*#__PURE__*/React__default.createElement("path", {
      fill: "#ff3d00",
      d: "M18,24c0,4.755,2.376,8.95,6,11.48c3.624-2.53,6-6.725,6-11.48s-2.376-8.95-6-11.48 C20.376,15.05,18,19.245,18,24z"
    })),
    "american express": /*#__PURE__*/React__default.createElement("svg", {
      className: "plc-w-16",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 48 48"
    }, /*#__PURE__*/React__default.createElement("path", {
      fill: "#1976D2",
      d: "M45,35c0,2.209-1.791,4-4,4H7c-2.209,0-4-1.791-4-4V13c0-2.209,1.791-4,4-4h34c2.209,0,4,1.791,4,4V35z"
    }), /*#__PURE__*/React__default.createElement("path", {
      fill: "#FFF",
      d: "M22.255 20l-2.113 4.683L18.039 20h-2.695v6.726L12.341 20h-2.274L7 26.981h1.815l.671-1.558h3.432l.682 1.558h3.465v-5.185l2.299 5.185h1.563l2.351-5.095v5.095H25V20H22.255zM10.135 23.915l1.026-2.44 1.066 2.44H10.135zM37.883 23.413L41 20.018h-2.217l-1.994 2.164L34.86 20H28v6.982h6.635l2.092-2.311L38.767 27h2.21L37.883 23.413zM33.728 25.516h-4.011v-1.381h3.838v-1.323h-3.838v-1.308l4.234.012 1.693 1.897L33.728 25.516z"
    })),
    amex: /*#__PURE__*/React__default.createElement("svg", {
      className: "plc-w-16",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 48 48"
    }, /*#__PURE__*/React__default.createElement("path", {
      fill: "#1976D2",
      d: "M45,35c0,2.209-1.791,4-4,4H7c-2.209,0-4-1.791-4-4V13c0-2.209,1.791-4,4-4h34c2.209,0,4,1.791,4,4V35z"
    }), /*#__PURE__*/React__default.createElement("path", {
      fill: "#FFF",
      d: "M22.255 20l-2.113 4.683L18.039 20h-2.695v6.726L12.341 20h-2.274L7 26.981h1.815l.671-1.558h3.432l.682 1.558h3.465v-5.185l2.299 5.185h1.563l2.351-5.095v5.095H25V20H22.255zM10.135 23.915l1.026-2.44 1.066 2.44H10.135zM37.883 23.413L41 20.018h-2.217l-1.994 2.164L34.86 20H28v6.982h6.635l2.092-2.311L38.767 27h2.21L37.883 23.413zM33.728 25.516h-4.011v-1.381h3.838v-1.323h-3.838v-1.308l4.234.012 1.693 1.897L33.728 25.516z"
    }))
  };
  return name ? icons[name.toLowerCase()] : /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "plc-w-16",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, /*#__PURE__*/React__default.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1",
    d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
  }));
};

/**
 * Gets the current date with time set to 0
 * @param {Date} dateObject
 * @return {Date}
 */
function getDateWithoutTime(dateObject) {
  const date = new Date(dateObject.getTime());
  date.setHours(0, 0, 0, 0);
  return date;
}
function userMustVerifyEmail() {
  var _window$Pelcro$site$r3, _window$Pelcro$site$r4, _window$Pelcro$user$r9, _window$Pelcro$user$r10;
  const isEmailVerificationEnabled = (_window$Pelcro$site$r3 = (_window$Pelcro$site$r4 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r4 === void 0 ? void 0 : _window$Pelcro$site$r4.email_verify_enabled) !== null && _window$Pelcro$site$r3 !== void 0 ? _window$Pelcro$site$r3 : false;
  const isUserEmailVerified = (_window$Pelcro$user$r9 = (_window$Pelcro$user$r10 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r10 === void 0 ? void 0 : _window$Pelcro$user$r10.email_confirm) !== null && _window$Pelcro$user$r9 !== void 0 ? _window$Pelcro$user$r9 : false;
  return window.Pelcro.user.isAuthenticated() && isEmailVerificationEnabled && !isUserEmailVerified;
}
function notifyBugsnag(callback, startOptions) {
  if (!window.Bugsnag && !document.querySelector('script[src="https://d2wy8f7a9ursnm.cloudfront.net/v7/bugsnag.min.js"]')) {
    // load bugsnag CDN
    window.Pelcro.helpers.loadSDK("https://d2wy8f7a9ursnm.cloudfront.net/v7/bugsnag.min.js", "bugsnag-cdn");
    document.querySelector('script[src="https://d2wy8f7a9ursnm.cloudfront.net/v7/bugsnag.min.js"]').addEventListener("load", () => {
      var _window$Pelcro$enviro, _window$Pelcro4, _window$Pelcro4$envir, _window$Pelcro5, _window$Pelcro5$envir;
      Bugsnag.start({
        apiKey: (_window$Pelcro$enviro = (_window$Pelcro4 = window.Pelcro) === null || _window$Pelcro4 === void 0 ? void 0 : (_window$Pelcro4$envir = _window$Pelcro4.environment) === null || _window$Pelcro4$envir === void 0 ? void 0 : _window$Pelcro4$envir.bugsnagKey) !== null && _window$Pelcro$enviro !== void 0 ? _window$Pelcro$enviro : "e8f6852b322540e8c25386048b99ab01",
        autoDetectErrors: false,
        releaseStage: (_window$Pelcro5 = window.Pelcro) === null || _window$Pelcro5 === void 0 ? void 0 : (_window$Pelcro5$envir = _window$Pelcro5.environment) === null || _window$Pelcro5$envir === void 0 ? void 0 : _window$Pelcro5$envir.bugsnagReleaseStage,
        redactedKeys: ["security_key", "password", "password_confirmation", "auth_token", "token"],
        ...startOptions
      });
      callback();
    });
    return;
  }
  callback();
}
const refreshUser = () => {
  var _window$Pelcro6, _window$Pelcro6$user, _window$Pelcro6$user$;
  window.Pelcro.user.refresh({
    auth_token: (_window$Pelcro6 = window.Pelcro) === null || _window$Pelcro6 === void 0 ? void 0 : (_window$Pelcro6$user = _window$Pelcro6.user) === null || _window$Pelcro6$user === void 0 ? void 0 : (_window$Pelcro6$user$ = _window$Pelcro6$user.read()) === null || _window$Pelcro6$user$ === void 0 ? void 0 : _window$Pelcro6$user$.auth_token
  }, (err, res) => {
    if (err) {
      console.error(err);
    }
    if (res) {
      return res.data;
    }
  });
};

const resources = {
  en: {
    common: common_en,
    paymentMethod: paymentMethod_en,
    newsletter: newsletter_en,
    success: success_en,
    meter: meter_en,
    checkoutForm: checkoutForm_en,
    messages: messages_en,
    login: login_en,
    verifyLinkToken: verifyLinkToken_en,
    register: register_en,
    userEdit: userEdit_en,
    address: address_en,
    passwordReset: passwordReset_en,
    passwordForgot: passwordForgot_en,
    passwordChange: passwordChange_en,
    passwordlessRequest: passwordlessRequest_en,
    verifyEmail: verifyEmail_en,
    cart: cart_en,
    shop: shop_en,
    payment: payment_en,
    dashboard: dashboard_en,
    select: select_en,
    notification: notification_en,
    invoiceDetails: invoiceDetails_en,
    subscriptionCancel: subscriptionCancel_en,
    subscriptionSuspend: subscriptionSuspend_en,
    subscriptionManageMembers: subscriptionManageMembers_en
  },
  fr: {
    common: common_fr,
    paymentMethod: paymentMethod_fr,
    newsletter: newsletter_fr,
    success: success_fr,
    meter: meter_fr,
    checkoutForm: checkoutForm_fr,
    messages: messages_fr,
    login: login_fr,
    verifyLinkToken: verifyLinkToken_fr,
    register: register_fr,
    userEdit: userEdit_fr,
    address: address_fr,
    passwordReset: passwordReset_fr,
    passwordForgot: passwordForgot_fr,
    passwordChange: passwordChange_fr,
    passwordlessRequest: passwordlessRequest_fr,
    verifyEmail: verifyEmail_fr,
    cart: cart_fr,
    shop: shop_fr,
    payment: payment_fr,
    dashboard: dashboard_fr,
    select: select_fr,
    notification: notification_fr,
    invoiceDetails: invoiceDetails_fr,
    subscriptionCancel: subscriptionCancel_fr,
    subscriptionSuspend: subscriptionSuspend_fr,
    subscriptionManageMembers: subscriptionManageMembers_fr
  },
  ko: {
    common: common_ko,
    paymentMethod: paymentMethod_ko,
    newsletter: newsletter_ko,
    success: success_ko,
    meter: meter_ko,
    checkoutForm: checkoutForm_ko,
    messages: messages_ko,
    login: login_ko,
    verifyLinkToken: verifyLinkToken_ko,
    register: register_ko,
    userEdit: userEdit_ko,
    address: address_ko,
    passwordReset: passwordReset_ko,
    passwordForgot: passwordForgot_ko,
    passwordChange: passwordChange_ko,
    passwordlessRequest: passwordlessRequest_ko,
    verifyEmail: verifyEmail_ko,
    cart: cart_ko,
    shop: shop_ko,
    payment: payment_ko,
    dashboard: dashboard_ko,
    select: select_ko,
    notification: notification_ko,
    invoiceDetails: invoiceDetails_ko,
    subscriptionCancel: subscriptionCancel_ko,
    subscriptionSuspend: subscriptionSuspend_ko,
    subscriptionManageMembers: subscriptionManageMembers_ko
  },
  es: {
    common: common_es,
    paymentMethod: paymentMethod_es,
    newsletter: newsletter_es,
    success: success_es,
    meter: meter_es,
    checkoutForm: checkoutForm_es,
    messages: messages_es,
    login: login_es,
    verifyLinkToken: verifyLinkToken_es,
    register: register_es,
    userEdit: userEdit_es,
    address: address_es,
    passwordReset: passwordReset_es,
    passwordForgot: passwordForgot_es,
    passwordChange: passwordChange_es,
    passwordlessRequest: passwordlessRequest_es,
    verifyEmail: verifyEmail_es,
    cart: cart_es,
    shop: shop_es,
    payment: payment_es,
    dashboard: dashboard_es,
    select: select_es,
    notification: notification_es,
    invoiceDetails: invoiceDetails_es,
    subscriptionCancel: subscriptionCancel_es,
    subscriptionSuspend: subscriptionSuspend_es,
    subscriptionManageMembers: subscriptionManageMembers_es
  }
};

// set UI language to the page language or default to the language in site settings
const locale = getPageOrDefaultLanguage();
i18next.use(initReactI18next) // passes i18n down to react-i18next,
.init({
  resources,
  lng: locale,
  fallbackLng: "en",
  // debug: true,
  interpolation: {
    escapeValue: false // react already safes from xss
  },

  react: {
    bindI18nStore: "added" // the key is 'bindI18nStore' not 'bindStore', the types are wrong
  }
});

const pageLanguageObserver = new MutationObserver(mutationsList => {
  mutationsList.forEach(mutationRecord => {
    if (mutationRecord.attributeName === "lang") {
      i18next.changeLanguage(window.Pelcro.helpers.getHtmlLanguageAttribute());
    }
  });
});
pageLanguageObserver.observe(document.documentElement, {
  attributes: true
});

function _classPrivateFieldGet(receiver, privateMap) {
  var descriptor = privateMap.get(receiver);

  if (!descriptor) {
    throw new TypeError("attempted to get private field on non-instance");
  }

  if (descriptor.get) {
    return descriptor.get.call(receiver);
  }

  return descriptor.value;
}

function _classPrivateFieldInitSpec$2(obj, privateMap, value) { _checkPrivateRedeclaration$2(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration$2(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
var _isAlreadySaved = /*#__PURE__*/new WeakMap();
var _markButtonAsLoading = /*#__PURE__*/new WeakMap();
var _removeLoadingState = /*#__PURE__*/new WeakMap();
var _markButtonAsSaved = /*#__PURE__*/new WeakMap();
var _unmarkSavedButton = /*#__PURE__*/new WeakMap();
var _markAllSavedButtons = /*#__PURE__*/new WeakMap();
var _unmarkAllSavedButtons = /*#__PURE__*/new WeakMap();
var _saveToMetadata = /*#__PURE__*/new WeakMap();
var _removeMetaData = /*#__PURE__*/new WeakMap();
var _onClick = /*#__PURE__*/new WeakMap();
class SaveToMetadataButtonClass {
  constructor() {
    _defineProperty$3(this, "authenticated", () => {
      _classPrivateFieldGet(this, _onClick).call(this, _classPrivateFieldGet(this, _saveToMetadata));
      _classPrivateFieldGet(this, _markAllSavedButtons).call(this);
    });
    _defineProperty$3(this, "unauthenticated", () => {
      const {
        switchView
      } = usePelcro.getStore();
      _classPrivateFieldGet(this, _onClick).call(this, () => switchView("login"));
      _classPrivateFieldGet(this, _unmarkAllSavedButtons).call(this);
    });
    _classPrivateFieldInitSpec$2(this, _isAlreadySaved, {
      writable: true,
      value: button => {
        return button.classList.contains("pelcro-is-active");
      }
    });
    _classPrivateFieldInitSpec$2(this, _markButtonAsLoading, {
      writable: true,
      value: button => {
        button.classList.add("pelcro-is-loading");
        button.disabled = true;
      }
    });
    _classPrivateFieldInitSpec$2(this, _removeLoadingState, {
      writable: true,
      value: button => {
        button.classList.remove("pelcro-is-loading");
        button.disabled = false;
      }
    });
    _classPrivateFieldInitSpec$2(this, _markButtonAsSaved, {
      writable: true,
      value: button => {
        button.classList.add("pelcro-is-active");
        _classPrivateFieldGet(this, _removeLoadingState).call(this, button);
      }
    });
    _classPrivateFieldInitSpec$2(this, _unmarkSavedButton, {
      writable: true,
      value: button => {
        button.classList.remove("pelcro-is-active");
        _classPrivateFieldGet(this, _removeLoadingState).call(this, button);
      }
    });
    _classPrivateFieldInitSpec$2(this, _markAllSavedButtons, {
      writable: true,
      value: () => {
        var _Object$values, _window$Pelcro$user$r;
        const userMetadataArray = (_Object$values = Object.values((_window$Pelcro$user$r = window.Pelcro.user.read().metadata) !== null && _window$Pelcro$user$r !== void 0 ? _window$Pelcro$user$r : {})) === null || _Object$values === void 0 ? void 0 : _Object$values.flat();
        this.saveButtons.forEach(button => {
          const buttonMetadata = button.dataset;
          userMetadataArray === null || userMetadataArray === void 0 ? void 0 : userMetadataArray.forEach(value => {
            if ((value === null || value === void 0 ? void 0 : value.title) === (buttonMetadata === null || buttonMetadata === void 0 ? void 0 : buttonMetadata.title)) {
              _classPrivateFieldGet(this, _markButtonAsSaved).call(this, button);
            }
          });
        });
      }
    });
    _classPrivateFieldInitSpec$2(this, _unmarkAllSavedButtons, {
      writable: true,
      value: () => {
        this.saveButtons.forEach(button => {
          _classPrivateFieldGet(this, _unmarkSavedButton).call(this, button);
        });
      }
    });
    _classPrivateFieldInitSpec$2(this, _saveToMetadata, {
      writable: true,
      value: event => {
        var _window, _window$Pelcro, _window$Pelcro$uiSett, _user$metadata;
        const button = event.currentTarget;
        const user = window.Pelcro.user.read();
        const {
          switchView
        } = usePelcro.getStore();
        const {
          key,
          ...buttonMetadata
        } = button.dataset;
        const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
        if (userMustVerifyEmail()) {
          return switchView("email-verify");
        }
        if (_classPrivateFieldGet(this, _isAlreadySaved).call(this, button)) {
          _classPrivateFieldGet(this, _removeMetaData).call(this, event);
          return;
        }
        let newMetadataValue = [buttonMetadata];
        // if this key already exist in user metadata object, append to it.
        const oldValue = (_user$metadata = user.metadata) === null || _user$metadata === void 0 ? void 0 : _user$metadata[`metadata_saved_${key}`];
        if (oldValue) {
          if (Array.isArray(oldValue)) {
            newMetadataValue = [...oldValue, buttonMetadata];
          } else {
            newMetadataValue = [oldValue, buttonMetadata];
          }
        }
        if (window.Pelcro.user.isAuthenticated()) {
          _classPrivateFieldGet(this, _markButtonAsLoading).call(this, button);
          window.Pelcro.user.saveToMetaData({
            key: `saved_${key}`,
            value: newMetadataValue,
            auth_token: window.Pelcro.user.read().auth_token
          }, (err, resp) => {
            if (err) {
              return _classPrivateFieldGet(this, _removeLoadingState).call(this, button);
            }
            _classPrivateFieldGet(this, _markButtonAsSaved).call(this, button);
            if (enableReactGA4) {
              ReactGA4.event("Save/Follow", {
                event_label: buttonMetadata === null || buttonMetadata === void 0 ? void 0 : buttonMetadata.title
              });
            } else {
              var _ReactGA$event;
              ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
                category: "ACTIONS",
                action: "Save/Follow",
                label: buttonMetadata === null || buttonMetadata === void 0 ? void 0 : buttonMetadata.title
              });
            }
          });
        }
      }
    });
    _classPrivateFieldInitSpec$2(this, _removeMetaData, {
      writable: true,
      value: event => {
        var _window2, _window2$Pelcro, _window2$Pelcro$uiSet;
        const button = event.currentTarget;
        const user = window.Pelcro.user.read();
        const {
          key,
          title
        } = button.dataset;
        const oldValue = user.metadata[`metadata_saved_${key}`];
        const enableReactGA4 = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$Pelcro = _window2.Pelcro) === null || _window2$Pelcro === void 0 ? void 0 : (_window2$Pelcro$uiSet = _window2$Pelcro.uiSettings) === null || _window2$Pelcro$uiSet === void 0 ? void 0 : _window2$Pelcro$uiSet.enableReactGA4;
        const newMetadataValue = oldValue.filter(metadata => !((metadata === null || metadata === void 0 ? void 0 : metadata.title) === title));
        if (window.Pelcro.user.isAuthenticated()) {
          _classPrivateFieldGet(this, _markButtonAsLoading).call(this, button);
          window.Pelcro.user.saveToMetaData({
            key: `saved_${key}`,
            value: newMetadataValue,
            auth_token: window.Pelcro.user.read().auth_token
          }, (err, resp) => {
            if (err) {
              return _classPrivateFieldGet(this, _removeLoadingState).call(this, button);
            }
            _classPrivateFieldGet(this, _unmarkSavedButton).call(this, button);
            if (enableReactGA4) {
              ReactGA4.event("Unsave/Unfollow", {
                event_label: title
              });
            } else {
              var _ReactGA$event2;
              ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event2 = ReactGA.event) === null || _ReactGA$event2 === void 0 ? void 0 : _ReactGA$event2.call(ReactGA, {
                category: "ACTIONS",
                action: "Unsave/Unfollow",
                label: title
              });
            }
          });
        }
      }
    });
    _classPrivateFieldInitSpec$2(this, _onClick, {
      writable: true,
      value: callback => {
        this.saveButtons.forEach(button => {
          button.onclick = callback;
        });
      }
    });
  }
  init() {
    if (window.Pelcro.user.read().metadata) {
      _classPrivateFieldGet(this, _markAllSavedButtons).call(this);
    } else {
      document.addEventListener("PelcroUserLoaded", () => {
        _classPrivateFieldGet(this, _markAllSavedButtons).call(this);
      });
    }
    _classPrivateFieldGet(this, _onClick).call(this, _classPrivateFieldGet(this, _saveToMetadata));
  }

  /**
   * Authenticated callback
   */

  /**
   * Save buttons getter
   * @return {HTMLButtonElement[]} button elements
   */
  get saveButtons() {
    return Array.from(document.getElementsByClassName("pelcro-save-button")).filter(button => button.dataset.key);
  }
}
const saveToMetadataButton = new SaveToMetadataButtonClass();

let e={data:""},t=t=>"object"==typeof window?((t?t.querySelector("#_goober"):window._goober)||Object.assign((t||document.head).appendChild(document.createElement("style")),{innerHTML:" ",id:"_goober"})).firstChild:t||e,l=/(?:([\u0080-\uFFFF\w-%@]+) *:? *([^{;]+?);|([^;}{]*?) *{)|(}\s*)/g,a=/\/\*[^]*?\*\/|  +/g,n=/\n+/g,o=(e,t)=>{let r="",l="",a="";for(let n in e){let c=e[n];"@"==n[0]?"i"==n[1]?r=n+" "+c+";":l+="f"==n[1]?o(c,n):n+"{"+o(c,"k"==n[1]?"":t)+"}":"object"==typeof c?l+=o(c,t?t.replace(/([^,])+/g,e=>n.replace(/(^:.*)|([^,])+/g,t=>/&/.test(t)?t.replace(/&/g,e):e?e+" "+t:t)):n):null!=c&&(n=/^--/.test(n)?n:n.replace(/[A-Z]/g,"-$&").toLowerCase(),a+=o.p?o.p(n,c):n+":"+c+";");}return r+(t&&a?t+"{"+a+"}":a)+l},c={},s=e=>{if("object"==typeof e){let t="";for(let r in e)t+=r+s(e[r]);return t}return e},i$1=(e,t,r,i,p)=>{let u=s(e),d=c[u]||(c[u]=(e=>{let t=0,r=11;for(;t<e.length;)r=101*r+e.charCodeAt(t++)>>>0;return "go"+r})(u));if(!c[d]){let t=u!==e?e:(e=>{let t,r,o=[{}];for(;t=l.exec(e.replace(a,""));)t[4]?o.shift():t[3]?(r=t[3].replace(n," ").trim(),o.unshift(o[0][r]=o[0][r]||{})):o[0][t[1]]=t[2].replace(n," ").trim();return o[0]})(e);c[d]=o(p?{["@keyframes "+d]:t}:t,r?"":"."+d);}let f=r&&c.g?c.g:null;return r&&(c.g=c[d]),((e,t,r,l)=>{l?t.data=t.data.replace(l,e):-1===t.data.indexOf(e)&&(t.data=r?e+t.data:t.data+e);})(c[d],t,i,f),d},p=(e,t,r)=>e.reduce((e,l,a)=>{let n=t[a];if(n&&n.call){let e=n(r),t=e&&e.props&&e.props.className||/^go/.test(e)&&e;n=t?"."+t:e&&"object"==typeof e?e.props?"":o(e,""):!1===e?"":e;}return e+l+(null==n?"":n)},"");function u(e){let r=this||{},l=e.call?e(r.p):e;return i$1(l.unshift?l.raw?p(l,[].slice.call(arguments,1),r.p):l.reduce((e,t)=>Object.assign(e,t&&t.call?t(r.p):t),{}):l,t(r.target),r.g,r.o,r.k)}let d,f,g;u.bind({g:1});let h=u.bind({k:1});function m(e,t,r,l){o.p=t,d=e,f=r,g=l;}function j(e,t){let r=this||{};return function(){let l=arguments;function a(n,o){let c=Object.assign({},n),s=c.className||a.className;r.p=Object.assign({theme:f&&f()},c),r.o=/ *go\d+/.test(s),c.className=u.apply(r,l)+(s?" "+s:""),t&&(c.ref=o);let i=e;return e[0]&&(i=c.as||e,delete c.as),g&&i[0]&&g(c),d(i,c)}return t?t(a):a}}

function _extends$C() {
  _extends$C = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$C.apply(this, arguments);
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var isFunction = function isFunction(valOrFunction) {
  return typeof valOrFunction === 'function';
};

var resolveValue = function resolveValue(valOrFunction, arg) {
  return isFunction(valOrFunction) ? valOrFunction(arg) : valOrFunction;
};

var genId = /*#__PURE__*/function () {
  var count = 0;
  return function () {
    return (++count).toString();
  };
}();
var createRectRef = function createRectRef(onRect) {
  return function (el) {
    if (el) {
      setTimeout(function () {
        var boundingRect = el.getBoundingClientRect();
        onRect(boundingRect);
      });
    }
  };
};
var prefersReducedMotion = /*#__PURE__*/function () {
  // Cache result
  var shouldReduceMotion = undefined;
  return function () {
    if (shouldReduceMotion === undefined) {
      var mediaQuery = matchMedia('(prefers-reduced-motion: reduce)');
      shouldReduceMotion = !mediaQuery || mediaQuery.matches;
    }

    return shouldReduceMotion;
  };
}();

var TOAST_LIMIT = 20;
var ActionType;

(function (ActionType) {
  ActionType[ActionType["ADD_TOAST"] = 0] = "ADD_TOAST";
  ActionType[ActionType["UPDATE_TOAST"] = 1] = "UPDATE_TOAST";
  ActionType[ActionType["UPSERT_TOAST"] = 2] = "UPSERT_TOAST";
  ActionType[ActionType["DISMISS_TOAST"] = 3] = "DISMISS_TOAST";
  ActionType[ActionType["REMOVE_TOAST"] = 4] = "REMOVE_TOAST";
  ActionType[ActionType["START_PAUSE"] = 5] = "START_PAUSE";
  ActionType[ActionType["END_PAUSE"] = 6] = "END_PAUSE";
})(ActionType || (ActionType = {}));

var toastTimeouts = /*#__PURE__*/new Map();

var addToRemoveQueue = function addToRemoveQueue(toastId) {
  if (toastTimeouts.has(toastId)) {
    return;
  }

  var timeout = setTimeout(function () {
    toastTimeouts["delete"](toastId);
    dispatch({
      type: ActionType.REMOVE_TOAST,
      toastId: toastId
    });
  }, 1000);
  toastTimeouts.set(toastId, timeout);
};

var clearFromRemoveQueue = function clearFromRemoveQueue(toastId) {
  var timeout = toastTimeouts.get(toastId);

  if (timeout) {
    clearTimeout(timeout);
  }
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case ActionType.ADD_TOAST:
      return _extends$C({}, state, {
        toasts: [action.toast].concat(state.toasts).slice(0, TOAST_LIMIT)
      });

    case ActionType.UPDATE_TOAST:
      //  ! Side effects !
      if (action.toast.id) {
        clearFromRemoveQueue(action.toast.id);
      }

      return _extends$C({}, state, {
        toasts: state.toasts.map(function (t) {
          return t.id === action.toast.id ? _extends$C({}, t, action.toast) : t;
        })
      });

    case ActionType.UPSERT_TOAST:
      var toast = action.toast;
      return state.toasts.find(function (t) {
        return t.id === toast.id;
      }) ? reducer(state, {
        type: ActionType.UPDATE_TOAST,
        toast: toast
      }) : reducer(state, {
        type: ActionType.ADD_TOAST,
        toast: toast
      });

    case ActionType.DISMISS_TOAST:
      var toastId = action.toastId; // ! Side effects ! - This could be execrated into a dismissToast() action, but I'll keep it here for simplicity

      if (toastId) {
        addToRemoveQueue(toastId);
      } else {
        state.toasts.forEach(function (toast) {
          addToRemoveQueue(toast.id);
        });
      }

      return _extends$C({}, state, {
        toasts: state.toasts.map(function (t) {
          return t.id === toastId || toastId === undefined ? _extends$C({}, t, {
            visible: false
          }) : t;
        })
      });

    case ActionType.REMOVE_TOAST:
      if (action.toastId === undefined) {
        return _extends$C({}, state, {
          toasts: []
        });
      }

      return _extends$C({}, state, {
        toasts: state.toasts.filter(function (t) {
          return t.id !== action.toastId;
        })
      });

    case ActionType.START_PAUSE:
      return _extends$C({}, state, {
        pausedAt: action.time
      });

    case ActionType.END_PAUSE:
      var diff = action.time - (state.pausedAt || 0);
      return _extends$C({}, state, {
        pausedAt: undefined,
        toasts: state.toasts.map(function (t) {
          return _extends$C({}, t, {
            pauseDuration: t.pauseDuration + diff
          });
        })
      });
  }
};
var listeners = [];
var memoryState = {
  toasts: [],
  pausedAt: undefined
};
var dispatch = function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach(function (listener) {
    listener(memoryState);
  });
};
var defaultTimeouts = {
  blank: 4000,
  error: 4000,
  success: 2000,
  loading: Infinity,
  custom: 4000
};
var useStore = function useStore(toastOptions) {
  if (toastOptions === void 0) {
    toastOptions = {};
  }

  var _useState = useState(memoryState),
      state = _useState[0],
      setState = _useState[1];

  useEffect(function () {
    listeners.push(setState);
    return function () {
      var index = listeners.indexOf(setState);

      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, [state]);
  var mergedToasts = state.toasts.map(function (t) {
    var _toastOptions$t$type, _toastOptions, _toastOptions$t$type2;

    return _extends$C({}, toastOptions, toastOptions[t.type], t, {
      duration: t.duration || ((_toastOptions$t$type = toastOptions[t.type]) == null ? void 0 : _toastOptions$t$type.duration) || ((_toastOptions = toastOptions) == null ? void 0 : _toastOptions.duration) || defaultTimeouts[t.type],
      style: _extends$C({}, toastOptions.style, (_toastOptions$t$type2 = toastOptions[t.type]) == null ? void 0 : _toastOptions$t$type2.style, t.style)
    });
  });
  return _extends$C({}, state, {
    toasts: mergedToasts
  });
};

var createToast = function createToast(message, type, opts) {
  if (type === void 0) {
    type = 'blank';
  }

  return _extends$C({
    createdAt: Date.now(),
    visible: true,
    type: type,
    ariaProps: {
      role: 'status',
      'aria-live': 'polite'
    },
    message: message,
    pauseDuration: 0
  }, opts, {
    id: (opts == null ? void 0 : opts.id) || genId()
  });
};

var createHandler = function createHandler(type) {
  return function (message, options) {
    var toast = createToast(message, type, options);
    dispatch({
      type: ActionType.UPSERT_TOAST,
      toast: toast
    });
    return toast.id;
  };
};

var toast = function toast(message, opts) {
  return createHandler('blank')(message, opts);
};

toast.error = /*#__PURE__*/createHandler('error');
toast.success = /*#__PURE__*/createHandler('success');
toast.loading = /*#__PURE__*/createHandler('loading');
toast.custom = /*#__PURE__*/createHandler('custom');

toast.dismiss = function (toastId) {
  dispatch({
    type: ActionType.DISMISS_TOAST,
    toastId: toastId
  });
};

toast.remove = function (toastId) {
  return dispatch({
    type: ActionType.REMOVE_TOAST,
    toastId: toastId
  });
};

toast.promise = function (promise, msgs, opts) {
  var id = toast.loading(msgs.loading, _extends$C({}, opts, opts == null ? void 0 : opts.loading));
  promise.then(function (p) {
    toast.success(resolveValue(msgs.success, p), _extends$C({
      id: id
    }, opts, opts == null ? void 0 : opts.success));
    return p;
  })["catch"](function (e) {
    toast.error(resolveValue(msgs.error, e), _extends$C({
      id: id
    }, opts, opts == null ? void 0 : opts.error));
  });
  return promise;
};

var useToaster = function useToaster(toastOptions) {
  var _useStore = useStore(toastOptions),
      toasts = _useStore.toasts,
      pausedAt = _useStore.pausedAt;

  useEffect(function () {
    if (pausedAt) {
      return;
    }

    var now = Date.now();
    var timeouts = toasts.map(function (t) {
      if (t.duration === Infinity) {
        return;
      }

      var durationLeft = (t.duration || 0) + t.pauseDuration - (now - t.createdAt);

      if (durationLeft < 0) {
        if (t.visible) {
          toast.dismiss(t.id);
        }

        return;
      }

      return setTimeout(function () {
        return toast.dismiss(t.id);
      }, durationLeft);
    });
    return function () {
      timeouts.forEach(function (timeout) {
        return timeout && clearTimeout(timeout);
      });
    };
  }, [toasts, pausedAt]);
  var handlers = useMemo(function () {
    return {
      startPause: function startPause() {
        dispatch({
          type: ActionType.START_PAUSE,
          time: Date.now()
        });
      },
      endPause: function endPause() {
        if (pausedAt) {
          dispatch({
            type: ActionType.END_PAUSE,
            time: Date.now()
          });
        }
      },
      updateHeight: function updateHeight(toastId, height) {
        return dispatch({
          type: ActionType.UPDATE_TOAST,
          toast: {
            id: toastId,
            height: height
          }
        });
      },
      calculateOffset: function calculateOffset(toast, opts) {
        var _relevantToasts$filte;

        var _ref = opts || {},
            _ref$reverseOrder = _ref.reverseOrder,
            reverseOrder = _ref$reverseOrder === void 0 ? false : _ref$reverseOrder,
            _ref$gutter = _ref.gutter,
            gutter = _ref$gutter === void 0 ? 8 : _ref$gutter,
            defaultPosition = _ref.defaultPosition;

        var relevantToasts = toasts.filter(function (t) {
          return (t.position || defaultPosition) === (toast.position || defaultPosition) && t.height;
        });
        var toastIndex = relevantToasts.findIndex(function (t) {
          return t.id === toast.id;
        });
        var toastsBefore = relevantToasts.filter(function (toast, i) {
          return i < toastIndex && toast.visible;
        }).length;

        var offset = (_relevantToasts$filte = relevantToasts.filter(function (t) {
          return t.visible;
        })).slice.apply(_relevantToasts$filte, reverseOrder ? [toastsBefore + 1] : [0, toastsBefore]).reduce(function (acc, t) {
          return acc + (t.height || 0) + gutter;
        }, 0);

        return offset;
      }
    };
  }, [toasts, pausedAt]);
  return {
    toasts: toasts,
    handlers: handlers
  };
};

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n\n  &:after,\n  &:before {\n    content: '';\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 150ms;\n    position: absolute;\n    border-radius: 3px;\n    opacity: 0;\n    background: ", ";\n    bottom: 9px;\n    left: 4px;\n    height: 2px;\n    width: 12px;\n  }\n\n  &:before {\n    animation: ", " 0.15s ease-out forwards;\n    animation-delay: 180ms;\n    transform: rotate(90deg);\n  }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0) rotate(90deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(90deg);\n\topacity: 1;\n}"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0);\n  opacity: 0;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n transform: scale(1) rotate(45deg);\n  opacity: 1;\n}"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var circleAnimation = /*#__PURE__*/h( /*#__PURE__*/_templateObject());
var firstLineAnimation = /*#__PURE__*/h( /*#__PURE__*/_templateObject2());
var secondLineAnimation = /*#__PURE__*/h( /*#__PURE__*/_templateObject3());
var ErrorIcon = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject4(), function (p) {
  return p.primary || '#ff4b4b';
}, circleAnimation, firstLineAnimation, function (p) {
  return p.secondary || '#fff';
}, secondLineAnimation);

function _templateObject2$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 12px;\n  height: 12px;\n  box-sizing: border-box;\n  border: 2px solid;\n  border-radius: 100%;\n  border-color: ", ";\n  border-right-color: ", ";\n  animation: ", " 1s linear infinite;\n"]);

  _templateObject2$1 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$1() {
  var data = _taggedTemplateLiteralLoose(["\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n"]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
var rotate = /*#__PURE__*/h( /*#__PURE__*/_templateObject$1());
var LoaderIcon = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject2$1(), function (p) {
  return p.secondary || '#e0e0e0';
}, function (p) {
  return p.primary || '#616161';
}, rotate);

function _templateObject3$1() {
  var data = _taggedTemplateLiteralLoose(["\n  width: 20px;\n  opacity: 0;\n  height: 20px;\n  border-radius: 10px;\n  background: ", ";\n  position: relative;\n  transform: rotate(45deg);\n\n  animation: ", " 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n  animation-delay: 100ms;\n  &:after {\n    content: '';\n    box-sizing: border-box;\n    animation: ", " 0.2s ease-out forwards;\n    opacity: 0;\n    animation-delay: 200ms;\n    position: absolute;\n    border-right: 2px solid;\n    border-bottom: 2px solid;\n    border-color: ", ";\n    bottom: 6px;\n    left: 6px;\n    height: 10px;\n    width: 6px;\n  }\n"]);

  _templateObject3$1 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$2() {
  var data = _taggedTemplateLiteralLoose(["\n0% {\n\theight: 0;\n\twidth: 0;\n\topacity: 0;\n}\n40% {\n  height: 0;\n\twidth: 6px;\n\topacity: 1;\n}\n100% {\n  opacity: 1;\n  height: 10px;\n}"]);

  _templateObject2$2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$2() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0) rotate(45deg);\n\topacity: 0;\n}\nto {\n  transform: scale(1) rotate(45deg);\n\topacity: 1;\n}"]);

  _templateObject$2 = function _templateObject() {
    return data;
  };

  return data;
}
var circleAnimation$1 = /*#__PURE__*/h( /*#__PURE__*/_templateObject$2());
var checkmarkAnimation = /*#__PURE__*/h( /*#__PURE__*/_templateObject2$2());
var CheckmarkIcon = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject3$1(), function (p) {
  return p.primary || '#61d345';
}, circleAnimation$1, checkmarkAnimation, function (p) {
  return p.secondary || '#fff';
});

function _templateObject4$1() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  transform: scale(0.6);\n  opacity: 0.4;\n  min-width: 20px;\n  animation: ", " 0.3s 0.12s cubic-bezier(0.175, 0.885, 0.32, 1.275)\n    forwards;\n"]);

  _templateObject4$1 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3$2() {
  var data = _taggedTemplateLiteralLoose(["\nfrom {\n  transform: scale(0.6);\n  opacity: 0.4;\n}\nto {\n  transform: scale(1);\n  opacity: 1;\n}"]);

  _templateObject3$2 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2$3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-width: 20px;\n  min-height: 20px;\n"]);

  _templateObject2$3 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$3() {
  var data = _taggedTemplateLiteralLoose(["\n  position: absolute;\n"]);

  _templateObject$3 = function _templateObject() {
    return data;
  };

  return data;
}
var StatusWrapper = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject$3());
var IndicatorWrapper = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject2$3());
var enter = /*#__PURE__*/h( /*#__PURE__*/_templateObject3$2());
var AnimatedIconWrapper = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject4$1(), enter);
var ToastIcon = function ToastIcon(_ref) {
  var toast = _ref.toast;
  var icon = toast.icon,
      type = toast.type,
      iconTheme = toast.iconTheme;

  if (icon !== undefined) {
    if (typeof icon === 'string') {
      return createElement(AnimatedIconWrapper, null, icon);
    } else {
      return icon;
    }
  }

  if (type === 'blank') {
    return null;
  }

  return createElement(IndicatorWrapper, null, createElement(LoaderIcon, Object.assign({}, iconTheme)), type !== 'loading' && createElement(StatusWrapper, null, type === 'error' ? createElement(ErrorIcon, Object.assign({}, iconTheme)) : createElement(CheckmarkIcon, Object.assign({}, iconTheme))));
};

function _templateObject2$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  margin: 4px 10px;\n  color: inherit;\n  flex: 1 1 auto;\n"]);

  _templateObject2$4 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject$4() {
  var data = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  background: #fff;\n  color: #363636;\n  line-height: 1.3;\n  will-change: transform;\n  box-shadow: 0 3px 10px rgba(0, 0, 0, 0.1), 0 3px 3px rgba(0, 0, 0, 0.05);\n  max-width: 350px;\n  pointer-events: auto;\n  padding: 8px 10px;\n  border-radius: 8px;\n"]);

  _templateObject$4 = function _templateObject() {
    return data;
  };

  return data;
}

var enterAnimation = function enterAnimation(factor) {
  return "\n0% {transform: translate3d(0," + factor * -200 + "%,0) scale(.6); opacity:.5;}\n100% {transform: translate3d(0,0,0) scale(1); opacity:1;}\n";
};

var exitAnimation = function exitAnimation(factor) {
  return "\n0% {transform: translate3d(0,0,-1px) scale(1); opacity:1;}\n100% {transform: translate3d(0," + factor * -150 + "%,-1px) scale(.6); opacity:0;}\n";
};

var fadeInAnimation = "0%{opacity:0;} 100%{opacity:1;}";
var fadeOutAnimation = "0%{opacity:1;} 100%{opacity:0;}";
var ToastBarBase = /*#__PURE__*/j('div', forwardRef)( /*#__PURE__*/_templateObject$4());
var Message = /*#__PURE__*/j('div')( /*#__PURE__*/_templateObject2$4());

var getAnimationStyle = function getAnimationStyle(position, visible) {
  var top = position.includes('top');
  var factor = top ? 1 : -1;

  var _ref = prefersReducedMotion() ? [fadeInAnimation, fadeOutAnimation] : [enterAnimation(factor), exitAnimation(factor)],
      enter = _ref[0],
      exit = _ref[1];

  return {
    animation: visible ? h(enter) + " 0.35s cubic-bezier(.21,1.02,.73,1) forwards" : h(exit) + " 0.4s forwards cubic-bezier(.06,.71,.55,1)"
  };
};

var ToastBar = /*#__PURE__*/memo(function (_ref2) {
  var toast = _ref2.toast,
      position = _ref2.position,
      style = _ref2.style,
      children = _ref2.children;
  var animationStyle = toast != null && toast.height ? getAnimationStyle(toast.position || position || 'top-center', toast.visible) : {
    opacity: 0
  };
  var icon = createElement(ToastIcon, {
    toast: toast
  });
  var message = createElement(Message, Object.assign({}, toast.ariaProps), resolveValue(toast.message, toast));
  return createElement(ToastBarBase, {
    className: toast.className,
    style: _extends$C({}, animationStyle, style, toast.style)
  }, typeof children === 'function' ? children({
    icon: icon,
    message: message
  }) : createElement(Fragment, null, icon, message));
});

function _templateObject$5() {
  var data = _taggedTemplateLiteralLoose(["\n  z-index: 9999;\n  > * {\n    pointer-events: auto;\n  }\n"]);

  _templateObject$5 = function _templateObject() {
    return data;
  };

  return data;
}
m(createElement);

var getPositionStyle = function getPositionStyle(position, offset) {
  var top = position.includes('top');
  var verticalStyle = top ? {
    top: 0
  } : {
    bottom: 0
  };
  var horizontalStyle = position.includes('center') ? {
    justifyContent: 'center'
  } : position.includes('right') ? {
    justifyContent: 'flex-end'
  } : {};
  return _extends$C({
    left: 0,
    right: 0,
    display: 'flex',
    position: 'absolute',
    transition: prefersReducedMotion() ? undefined : "all 230ms cubic-bezier(.21,1.02,.73,1)",
    transform: "translateY(" + offset * (top ? 1 : -1) + "px)"
  }, verticalStyle, horizontalStyle);
};

var activeClass = /*#__PURE__*/u( /*#__PURE__*/_templateObject$5());
var DEFAULT_OFFSET = 16;
var Toaster = function Toaster(_ref) {
  var reverseOrder = _ref.reverseOrder,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? 'top-center' : _ref$position,
      toastOptions = _ref.toastOptions,
      gutter = _ref.gutter,
      children = _ref.children,
      containerStyle = _ref.containerStyle,
      containerClassName = _ref.containerClassName;

  var _useToaster = useToaster(toastOptions),
      toasts = _useToaster.toasts,
      handlers = _useToaster.handlers;

  return createElement("div", {
    style: _extends$C({
      position: 'fixed',
      zIndex: 9999,
      top: DEFAULT_OFFSET,
      left: DEFAULT_OFFSET,
      right: DEFAULT_OFFSET,
      bottom: DEFAULT_OFFSET,
      pointerEvents: 'none'
    }, containerStyle),
    className: containerClassName,
    onMouseEnter: handlers.startPause,
    onMouseLeave: handlers.endPause
  }, toasts.map(function (t) {
    var toastPosition = t.position || position;
    var offset = handlers.calculateOffset(t, {
      reverseOrder: reverseOrder,
      gutter: gutter,
      defaultPosition: position
    });
    var positionStyle = getPositionStyle(toastPosition, offset);
    var ref = t.height ? undefined : createRectRef(function (rect) {
      handlers.updateHeight(t.id, rect.height);
    });
    return createElement("div", {
      ref: ref,
      className: t.visible ? activeClass : '',
      key: t.id,
      style: positionStyle
    }, t.type === 'custom' ? resolveValue(t.message, t) : children ? children(t) : createElement(ToastBar, {
      toast: t,
      position: toastPosition
    }));
  }));
};

var _path$z;
function _extends$B() { _extends$B = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$B.apply(this, arguments); }
function SvgCheckSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$B({
    xmlns: "http://www.w3.org/2000/svg",
    className: "h-5 w-5",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path$z || (_path$z = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    clipRule: "evenodd"
  })));
}

var _path$y;
function _extends$A() { _extends$A = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$A.apply(this, arguments); }
function SvgXIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$A({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path$y || (_path$y = /*#__PURE__*/React.createElement("path", {
    fill: "evenodd",
    d: "M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z",
    clipRule: "evenodd"
  })));
}

var _path$x;
function _extends$z() { _extends$z = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$z.apply(this, arguments); }
function SvgXIconSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$z({
    className: "plc-w-4 plc-h-4",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path$x || (_path$x = /*#__PURE__*/React.createElement("path", {
    d: "M94.842 48.408c0 24.852-20.148 44.999-45.002 44.999-24.851 0-44.997-20.146-44.997-44.999 0-24.854 20.146-45 44.997-45 24.853 0 45.002 20.146 45.002 45zM71.073 64.841L54.73 48.497l16.344-16.344-4.979-4.979-16.343 16.345-16.343-16.344-4.799 4.799 16.344 16.344L28.61 64.661l4.979 4.978 16.344-16.344 16.343 16.344 4.797-4.798z"
  })));
}

var _path$w;
function _extends$y() { _extends$y = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$y.apply(this, arguments); }
function SvgExclamation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$y({
    className: "plc-w-4 plc-h-4 plc-mr-1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path$w || (_path$w = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z",
    clipRule: "evenodd"
  })));
}

var _path$v, _path2$4;
function _extends$x() { _extends$x = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$x.apply(this, arguments); }
function SvgSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$x({
    className: "plc-animate-spin",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$v || (_path$v = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fill: "evenodd",
    clipRule: "evenodd",
    d: "M12 19a7 7 0 100-14 7 7 0 000 14zm0 3c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
  })), _path2$4 || (_path2$4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 6.477 6.477 2 12 2v3a7 7 0 00-7 7H2z"
  })));
}

const VARIANTS = {
  SOLID: "solid",
  OUTLINE: "outline",
  ICON: "icon",
  GHOST: "ghost"
};
function Button(_ref) {
  let {
    variant = "solid",
    isLoading,
    icon,
    className = "",
    disabled,
    children,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement("button", Object.assign({
    className: `${getClassName(variant)} ${className}`,
    disabled: disabled || isLoading
  }, otherProps), isLoading && /*#__PURE__*/React__default.createElement(SvgSpinner, {
    className: "pelcro-button-spinner",
    fill: "currentColor",
    "aria-hidden": "true",
    focusable: "false"
  }), !isLoading && icon && /*#__PURE__*/React__default.createElement("div", {
    className: `${variant === "icon" ? "plc-flex plc-items-center plc-justify-center plc-w-full" : "plc-mr-2"} plc-pointer-events-none`
  }, icon), children);
}
const getClassName = variant => {
  switch (variant) {
    case VARIANTS.SOLID:
      return "pelcro-button-solid";
    case VARIANTS.OUTLINE:
      return "pelcro-button-outline";
    case VARIANTS.ICON:
      return "pelcro-button-icon";
    case VARIANTS.GHOST:
      return "pelcro-button-ghost";
  }
};

const Notification = _ref => {
  let {
    children,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Toaster, Object.assign({
    containerClassName: "pelcro-notification-container",
    toastOptions: {
      success: {
        className: "pelcro-notification-success",
        icon: /*#__PURE__*/React__default.createElement(SvgCheckSolid, {
          className: "plc-w-20 plc-h-8"
        }),
        iconTheme: {
          primary: "white",
          secondary: "green"
        }
      },
      error: {
        className: "pelcro-notification-error",
        icon: /*#__PURE__*/React__default.createElement(SvgXIconSolid, {
          className: "plc-w-20 plc-h-8"
        }),
        iconTheme: {
          primary: "white",
          secondary: "red"
        }
      },
      confirm: {
        className: "pelcro-notification-confirm",
        icon: /*#__PURE__*/React__default.createElement(SvgExclamation, {
          className: "plc-w-20 plc-h-8 plc-text-red-500"
        }),
        duration: Infinity,
        hideCloseButton: true
      },
      loading: {
        className: "pelcro-notification-loading",
        icon: /*#__PURE__*/React__default.createElement(SvgSpinner, {
          className: "plc-w-8 plc-h-8 plc-animate-spin"
        }),
        duration: Infinity,
        hideCloseButton: true
      }
    }
  }, otherProps), t => /*#__PURE__*/React__default.createElement(ToastBar, {
    toast: t
  }, _ref2 => {
    let {
      icon,
      message
    } = _ref2;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, icon, message, !t.hideCloseButton && /*#__PURE__*/React__default.createElement(SvgXIcon, {
      className: "plc-w-10 plc-h-5 plc-cursor-pointer",
      onClick: () => toast.dismiss(t.id)
    }));
  }));
};
Notification.viewId = "notification";
toast.warning = (msg, options) => toast(msg, {
  className: "pelcro-notification-warning",
  icon: /*#__PURE__*/React__default.createElement(SvgExclamation, {
    className: "plc-w-24 plc-h-8"
  }),
  iconTheme: {
    primary: "white",
    secondary: "yellow"
  },
  ...options
});
toast.confirm = function (onConfirm, _ref3) {
  let {
    confirmMessage,
    loadingMessage,
    successMessage,
    errorMessage
  } = _ref3;
  let {
    confirmButtonLabel,
    closeButtonLabel,
    ...options
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  const translations = i18next.t("notification:confirm", {
    returnObjects: true
  });
  const id = toast(t => /*#__PURE__*/React__default.createElement("div", {
    className: "plc-space-y-4"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "plc-font-semibold"
  }, confirmMessage), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-space-y-2 sm:plc-space-y-0 sm:plc-space-x-2"
  }, /*#__PURE__*/React__default.createElement(Button, {
    variant: "solid",
    className: "plc-text-xs plc-bg-red-500 hover:plc-bg-red-600",
    onClick: onConfirmClick
  }, confirmButtonLabel !== null && confirmButtonLabel !== void 0 ? confirmButtonLabel : translations.labels.confirm), /*#__PURE__*/React__default.createElement(Button, {
    className: "plc-text-xs",
    variant: "outline",
    onClick: () => toast.dismiss(t.id)
  }, closeButtonLabel !== null && closeButtonLabel !== void 0 ? closeButtonLabel : translations.labels.close))), {
    type: "confirm",
    ...options
  });
  const onConfirmClick = () => {
    onLoading();
    onConfirm(onSuccess, onFailure);
  };
  const onLoading = () => {
    toast.loading(loadingMessage, {
      id,
      ...options
    });
  };
  const onSuccess = successValue => {
    toast.success(resolveValue(successMessage, successValue), {
      id,
      ...options
    });
    setTimeout(() => {
      notify$1.dismiss(id);
    }, 3000);
  };
  const onFailure = errorValue => {
    toast.error(resolveValue(errorMessage, errorValue), {
      id,
      ...options
    });
    setTimeout(() => {
      notify$1.dismiss(id);
    }, 3000);
  };
};
const notify$1 = toast;

const translations = i18next.t("common:buttons", {
  returnObjects: true
});
const init$1 = () => {
  saveToMetadataButton.init();
  const {
    switchView,
    set,
    isAuthenticated,
    switchToAddressView,
    switchToPaymentView,
    whenEcommerceLoaded,
    addToCart,
    purchaseItem,
    setSubscriptionToManageMembers
  } = usePelcro.getStore();
  const pelcroDashboardButtonsByClass = document.getElementsByClassName("pelcro-dashboard-button");
  if (pelcroDashboardButtonsByClass.length !== 0) {
    for (let i = 0; i < pelcroDashboardButtonsByClass.length; i++) {
      pelcroDashboardButtonsByClass[i].addEventListener("click", () => {
        if (isAuthenticated()) {
          switchView("dashboard");
        }
      });
    }
  }
  const pelcroLoginButtonsByClass = document.getElementsByClassName("pelcro-login-button");
  if (pelcroLoginButtonsByClass.length !== 0) {
    for (let i = 0; i < pelcroLoginButtonsByClass.length; i++) {
      pelcroLoginButtonsByClass[i].addEventListener("click", () => {
        if (isAuthenticated()) {
          switchView("dashboard");
        } else {
          switchView("login");
        }
      });
    }
  }
  const pelcroRegisterButton = document.getElementById("pelcro-register-button");
  if (pelcroRegisterButton) {
    pelcroRegisterButton.addEventListener("click", () => switchView("register"));
  }
  const pelcroRegisterButtonsByClass = document.getElementsByClassName("pelcro-register-button");
  if (pelcroRegisterButtonsByClass.length !== 0) {
    for (let j = 0; j < pelcroRegisterButtonsByClass.length; j++) {
      pelcroRegisterButtonsByClass[j].addEventListener("click", () => switchView("register"));
    }
  }
  const pelcroManageMembersButtonsByClass = document.getElementsByClassName("pelcro-manage-members-button");
  if (pelcroManageMembersButtonsByClass.length !== 0) {
    for (let j = 0; j < pelcroManageMembersButtonsByClass.length; j++) {
      if (pelcroManageMembersButtonsByClass[j].dataset && "subscriptionId" in pelcroManageMembersButtonsByClass[j].dataset) {
        pelcroManageMembersButtonsByClass[j].addEventListener("click", e => {
          const subscriptionId = e.target.dataset.subscriptionId;
          const wasSetSuccessfully = setSubscriptionToManageMembers(subscriptionId);
          if (!wasSetSuccessfully) {
            const errorMessage = i18next.t("messages:invalidSubscription", {
              returnObjects: true
            });
            return notify$1.error(errorMessage);
          }
          switchView("manage-members");
        });
      } else {
        const errorMessage = i18next.t("messages:invalidSubscription", {
          returnObjects: true
        });
        return notify$1.error(errorMessage);
      }
    }
  }
  const pelcroUpdateNewslettersButtons = document.getElementsByClassName("pelcro-update-newsletters-button");
  if (pelcroUpdateNewslettersButtons.length !== 0) {
    for (let i = 0; i < pelcroUpdateNewslettersButtons.length; i++) {
      pelcroUpdateNewslettersButtons[i].addEventListener("click", () => {
        switchView("newsletter-update");
      });
    }
  }
  const pelcroCartButtonsByClass = document.getElementsByClassName("pelcro-cart-button");
  if (pelcroCartButtonsByClass.length !== 0) {
    for (let i = 0; i < pelcroCartButtonsByClass.length; i++) {
      pelcroCartButtonsByClass[i].addEventListener("click", () => switchView("cart"));
    }
  }
  const cartButton = document.getElementById("pelcro-cart-button");
  if (cartButton) {
    cartButton.addEventListener("click", () => switchView("cart"));
  }
  const pelcroSubscribeButtonsByClass = document.getElementsByClassName("pelcro-subscribe-button");
  if (pelcroSubscribeButtonsByClass.length !== 0) {
    for (let j = 0; j < pelcroSubscribeButtonsByClass.length; j++) {
      if (pelcroSubscribeButtonsByClass[j].dataset && "productId" in pelcroSubscribeButtonsByClass[j].dataset) {
        pelcroSubscribeButtonsByClass[j].addEventListener("click", e => {
          var _selectedProduct$plan;
          const productsList = window.Pelcro.product.list();
          if (!(productsList !== null && productsList !== void 0 && productsList.length)) return;
          const [productId, planId, isGift] = [e.target.dataset.productId, e.target.dataset.planId, e.target.dataset.isGift];
          const selectedProduct = productsList.find(product => product.id === Number(productId));
          const selectedPlan = selectedProduct === null || selectedProduct === void 0 ? void 0 : (_selectedProduct$plan = selectedProduct.plans) === null || _selectedProduct$plan === void 0 ? void 0 : _selectedProduct$plan.find(plan => plan.id === Number(planId));
          set({
            product: selectedProduct,
            plan: selectedPlan,
            isGift: Boolean(isGift)
          });
          if (!selectedProduct || !selectedPlan) {
            return switchView("plan-select");
          }
          if (!isAuthenticated()) {
            return switchView("register");
          }
          if (isGift) {
            return switchView("gift-create");
          }
          const requiresAddress = Boolean(selectedProduct.address_required);
          if (!requiresAddress) {
            return switchToPaymentView();
          }
          return switchToAddressView();
        });
      } else {
        pelcroSubscribeButtonsByClass[j].addEventListener("click", () => switchView("plan-select"));
      }
    }
  }
  const pelcroOfflineSubButtonsByClass = document.getElementsByClassName("pelcro-offline-subscribe-button");
  if (pelcroOfflineSubButtonsByClass.length !== 0) {
    for (let j = 0; j < pelcroOfflineSubButtonsByClass.length; j++) {
      if (pelcroOfflineSubButtonsByClass[j].dataset && "productId" in pelcroOfflineSubButtonsByClass[j].dataset && "planId" in pelcroOfflineSubButtonsByClass[j].dataset) {
        pelcroOfflineSubButtonsByClass[j].addEventListener("click", e => {
          set({
            product: {
              id: e.target.dataset.productId
            },
            plan: {
              product_id: e.target.dataset.productId,
              id: e.target.dataset.planId
            }
          });
          window.Pelcro.plan.getPlan({
            plan_id: e.target.dataset.planId
          }, (error, response) => {
            if (error) {
              return;
            }
            const {
              plan
            } = response.data;
            set({
              plan,
              product: plan === null || plan === void 0 ? void 0 : plan.product
            });
            if (!isAuthenticated()) {
              return switchView("register");
            }
            const requiresAddress = Boolean(plan.address_required);
            if (!requiresAddress) {
              return switchToPaymentView();
            }
            return switchToAddressView();
          });
        });
      }
    }
  }
  const giftButtonsByClass = document.getElementsByClassName("pelcro-gift-button");
  if (giftButtonsByClass.length !== 0) {
    for (let j = 0; j < giftButtonsByClass.length; j++) {
      giftButtonsByClass[j].addEventListener("click", e => {
        if (e.target.dataset.isGift === "true") {
          set({
            isGift: true
          });
        }
        switchView("plan-select");
      });
    }
  }
  whenEcommerceLoaded(() => {
    const pelcroAddToCartButtonsByClass = document.getElementsByClassName("pelcro-add-to-cart-button");
    if (pelcroAddToCartButtonsByClass.length !== 0) {
      for (let i = 0; i < pelcroAddToCartButtonsByClass.length; i++) {
        pelcroAddToCartButtonsByClass[i].addEventListener("click", e => {
          addToCart(Number(e.target.dataset.skuId));
        });
      }
    }
    const pelcroPurchaseButtonsByClass = document.getElementsByClassName("pelcro-purchase-button");
    if (pelcroPurchaseButtonsByClass.length !== 0) {
      for (let i = 0; i < pelcroPurchaseButtonsByClass.length; i++) {
        pelcroPurchaseButtonsByClass[i].addEventListener("click", e => {
          const itemSkuId = Number(e.target.dataset.skuId);
          const quickPurchaseItem = window.Pelcro.ecommerce.products.getBySkuId(itemSkuId);
          if (!quickPurchaseItem) {
            return console.error("invalid item SKU id");
          }
          const purchaseResult = purchaseItem(itemSkuId);
          const itemDidntMatchUserCurrency = purchaseResult === false;
          if (itemDidntMatchUserCurrency) {
            var _window$Pelcro$user$r;
            const userCurrency = (_window$Pelcro$user$r = window.Pelcro.user.read().currency) === null || _window$Pelcro$user$r === void 0 ? void 0 : _window$Pelcro$user$r.toUpperCase();
            const errorMsg = i18next.t("shop:messages.currencyMismatch", {
              currency: userCurrency
            });
            notify$1.error(errorMsg);
          }
        });
      }
    }
  });
};
const authenticatedButtons = () => {
  saveToMetadataButton.authenticated();
  const pelcroLoginByClass = document.getElementsByClassName("pelcro-login-button");
  if (pelcroLoginByClass) {
    for (let i = 0; i < pelcroLoginByClass.length; i++) {
      if (pelcroLoginByClass.item(i).hasAttribute("data-dashboard-text")) {
        pelcroLoginByClass.item(i).innerHTML = pelcroLoginByClass.item(i).getAttribute("data-dashboard-text");
      } else {
        pelcroLoginByClass.item(i).innerHTML = translations.account;
      }
    }
  }
  const removeHTMLButton = buttonClass => {
    const elements = document.getElementsByClassName(buttonClass);
    while (elements.length > 0) {
      elements[0].parentNode.removeChild(elements[0]);
    }
  };
  removeHTMLButton("pelcro-register-button");
};
const unauthenticatedButtons = () => {
  saveToMetadataButton.unauthenticated();
  const pelcroLoginByClass = document.getElementsByClassName("pelcro-login-button");
  if (pelcroLoginByClass) {
    for (let i = 0; i < pelcroLoginByClass.length; i++) {
      if (pelcroLoginByClass.item(i).hasAttribute("data-login-text")) {
        pelcroLoginByClass.item(i).innerHTML = pelcroLoginByClass.item(i).getAttribute("data-login-text");
      } else {
        pelcroLoginByClass.item(i).innerHTML = translations.login;
      }
    }
  }
};

function Link(_ref) {
  let {
    className = "",
    href = "#",
    isButton = true,
    children,
    ...otherProps
  } = _ref;
  const handleSpaceBar = event => {
    if (event.keyCode === 32) event.target.click();
  };
  return /*#__PURE__*/React__default.createElement("a", Object.assign({
    className: `pelcro-link ${className}`,
    href: href
  }, isButton && {
    role: "button",
    onKeyDown: handleSpaceBar
  }, otherProps), children);
}

const init = () => {
  const {
    switchView,
    set
  } = usePelcro.getStore();
  const entitlementsProtectedElements = document.querySelectorAll("[data-pelcro-entitlements]");
  if (entitlementsProtectedElements.length === 0) {
    return false;
  }
  if (!allElemsHaveSameEntitlements(entitlementsProtectedElements)) {
    console.error("not all elements protected by entitlements have the same entitlements, all elements protected by entitlements must have the exact same data-pelcro-entitlements attribute value");
    return false;
  }
  for (const elem of entitlementsProtectedElements) {
    const entitlements = getEntitlementsFromElem(elem);
    if (entitlements.length === 0) {
      console.error("invalid data-pelcro-entitlements attribute value", elem);
      return false;
    }
    if (window.Pelcro.product.getByEntitlements(entitlements).length === 0) {
      console.warn("user can't subscribe to any plan that has any of the entitlement(s) needed, this is usually unintentional, make sure that the entitlements are spelled correctly, entitlements are case sensitive. make sure that your plans are configured in a way that allows users from all supported countries, using all supported currencies, to have access to your content by subscribing to certain plans that provide the needed entitlement(s)");
    }
    if (shouldBlurContent(entitlements)) {
      // remove all event listeners from the elem by replacing it with a deep clone of itself
      const elemDeepClone = elem.cloneNode(true);
      elem.replaceWith(elemDeepClone);
      disableKeyboardInteractions(elemDeepClone);
      elemDeepClone.setAttribute("style", "filter:blur(3px) !important; pointer-events:none !important; user-select:none !important");
      unblurElemWhenUserSubscribes(elemDeepClone, entitlements);
      unblurElemWhenUserLogsIn(elemDeepClone, entitlements);
      unblurElemWhenUserLogsOut(elemDeepClone, entitlements);
      const NOTIFICATION_ID = "entitlement";
      notify$1( /*#__PURE__*/React__default.createElement("p", null, /*#__PURE__*/React__default.createElement(Trans, {
        i18nKey: "messages:entitlement"
      }, "Some of the content on this page is available with one or more of our plans.", /*#__PURE__*/React__default.createElement(Link, {
        onClick: () => {
          const productId = Number(elem.dataset.productId);
          const planId = Number(elem.dataset.planId);
          const selectedProduct = window.Pelcro.product.getById(productId);
          const selectedPlan = window.Pelcro.plan.getById(planId);
          const hasValidProductAndPlan = Boolean(selectedProduct && selectedPlan);
          if (hasValidProductAndPlan) {
            set({
              product: selectedProduct,
              plan: selectedPlan
            });
          }
          notify$1.dismiss(NOTIFICATION_ID);
          switchView("_plan-select-entitlements");
        }
      }, "Subscribe"), "now to get full page access.")), {
        className: "pelcro-notification-entitlement",
        position: "bottom-right",
        duration: Infinity,
        id: NOTIFICATION_ID
      });
    }
  }
  return true;
};
function allElemsHaveSameEntitlements(elems) {
  const entitlements = getEntitlementsFromElem(elems[0]);
  return Array.from(elems).every(elem => {
    const elemEntitlements = getEntitlementsFromElem(elem);
    if (elemEntitlements.length !== entitlements.length) return false;
    return entitlements.every(ent => elemEntitlements.includes(ent));
  });
}
function disableKeyboardInteractions(elem) {
  elem.addEventListener("keydown", event => {
    // allow tab key navigation to prevent focus trapping
    const TAB_KEY_CODE = 9;
    if (event.keyCode != TAB_KEY_CODE) {
      event.returnValue = false;
      return false;
    }
  }, true);
}
function unblurElemWhenUserSubscribes(elem, entitlements) {
  document.addEventListener("PelcroSubscriptionCreate", event => {
    const {
      isGift
    } = usePelcro.getStore();
    if (isGift) return;
    const latestSub = event.detail.data.subscriptions[event.detail.data.subscriptions.length - 1];
    const shouldUnblurContent = entitlements.some(ent => {
      var _latestSub$plan$entit, _latestSub$plan, _latestSub$plan$entit2;
      return (_latestSub$plan$entit = latestSub === null || latestSub === void 0 ? void 0 : (_latestSub$plan = latestSub.plan) === null || _latestSub$plan === void 0 ? void 0 : (_latestSub$plan$entit2 = _latestSub$plan.entitlements) === null || _latestSub$plan$entit2 === void 0 ? void 0 : _latestSub$plan$entit2.includes(ent)) !== null && _latestSub$plan$entit !== void 0 ? _latestSub$plan$entit : false;
    });
    if (shouldUnblurContent) {
      elem.setAttribute("style", "filter:inherit !important; pointer-events:inherit !important; user-select:inherit !important");
    }
  });
}
function unblurElemWhenUserLogsIn(elem, entitlements) {
  document.addEventListener("PelcroUserLoggedIn", () => {
    if (!shouldBlurContent(entitlements)) {
      elem.setAttribute("style", "filter:inherit !important; pointer-events:inherit !important; user-select:inherit !important");
    }
  });
}
function unblurElemWhenUserLogsOut(elem, entitlements) {
  document.addEventListener("PelcroUserLogout", () => {
    if (shouldBlurContent(entitlements)) {
      elem.setAttribute("style", "filter:blur(3px) !important; pointer-events:none !important; user-select:none !important");
    }
  });
}
function shouldBlurContent(entitlements) {
  return entitlements.every(entitlement => !window.Pelcro.user.isEntitledTo(entitlement));
}

var pure$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, '__esModule', { value: true });

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var V3_URL = 'https://js.stripe.com/v3';
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var findScript = function findScript() {
  var scripts = document.querySelectorAll("script[src^=\"".concat(V3_URL, "\"]"));

  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];

    if (!V3_URL_REGEX.test(script.src)) {
      continue;
    }

    return script;
  }

  return null;
};

var injectScript = function injectScript(params) {
  var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
  var script = document.createElement('script');
  script.src = "".concat(V3_URL).concat(queryString);
  var headOrBody = document.head || document.body;

  if (!headOrBody) {
    throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
  }

  headOrBody.appendChild(script);
  return script;
};

var registerWrapper = function registerWrapper(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }

  stripe._registerWrapper({
    name: 'stripe-js',
    version: "1.21.1",
    startTime: startTime
  });
};

var stripePromise = null;
var loadScript = function loadScript(params) {
  // Ensure that we only attempt to load Stripe.js at most once
  if (stripePromise !== null) {
    return stripePromise;
  }

  stripePromise = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      // Resolve to null when imported server side. This makes the module
      // safe to import in an isomorphic code base.
      resolve(null);
      return;
    }

    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }

    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }

    try {
      var script = findScript();

      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(params);
      }

      script.addEventListener('load', function () {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error('Stripe.js not available'));
        }
      });
      script.addEventListener('error', function () {
        reject(new Error('Failed to load Stripe.js'));
      });
    } catch (error) {
      reject(error);
      return;
    }
  });
  return stripePromise;
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }

  var stripe = maybeStripe.apply(undefined, args);
  registerWrapper(stripe, startTime);
  return stripe;
};
var validateLoadParams = function validateLoadParams(params) {
  var errorMessage = "invalid load parameters; expected object of shape\n\n    {advancedFraudSignals: boolean}\n\nbut received\n\n    ".concat(JSON.stringify(params), "\n");

  if (params === null || _typeof(params) !== 'object') {
    throw new Error(errorMessage);
  }

  if (Object.keys(params).length === 1 && typeof params.advancedFraudSignals === 'boolean') {
    return params;
  }

  throw new Error(errorMessage);
};

var loadParams;
var loadStripeCalled = false;
var loadStripe = function loadStripe() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  loadStripeCalled = true;
  var startTime = Date.now();
  return loadScript(loadParams).then(function (maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};

loadStripe.setLoadParameters = function (params) {
  if (loadStripeCalled) {
    throw new Error('You cannot change load parameters after calling loadStripe');
  }

  loadParams = validateLoadParams(params);
};

exports.loadStripe = loadStripe;
});

unwrapExports(pure$1);
pure$1.loadStripe;

var pure = pure$1;
var pure_1 = pure.loadStripe;

/**
 * Extracts error message from the response error object
 * @param {Object} error Error object
 * @return {string}
 */
const getErrorMessages = error => {
  var _error$error, _error$response, _error$response$data, _error$response3, _error$response3$data, _error$response3$data2, _error$response5, _error$response5$data;
  if (error !== null && error !== void 0 && (_error$error = error.error) !== null && _error$error !== void 0 && _error$error.message) {
    return error.error.message;
  }
  if (error !== null && error !== void 0 && (_error$response = error.response) !== null && _error$response !== void 0 && (_error$response$data = _error$response.data) !== null && _error$response$data !== void 0 && _error$response$data.message) {
    var _error$response2, _error$response2$data;
    return error === null || error === void 0 ? void 0 : (_error$response2 = error.response) === null || _error$response2 === void 0 ? void 0 : (_error$response2$data = _error$response2.data) === null || _error$response2$data === void 0 ? void 0 : _error$response2$data.message;
  }
  if (error !== null && error !== void 0 && (_error$response3 = error.response) !== null && _error$response3 !== void 0 && (_error$response3$data = _error$response3.data) !== null && _error$response3$data !== void 0 && (_error$response3$data2 = _error$response3$data.error) !== null && _error$response3$data2 !== void 0 && _error$response3$data2.message) {
    var _error$response4, _error$response4$data, _error$response4$data2;
    return error === null || error === void 0 ? void 0 : (_error$response4 = error.response) === null || _error$response4 === void 0 ? void 0 : (_error$response4$data = _error$response4.data) === null || _error$response4$data === void 0 ? void 0 : (_error$response4$data2 = _error$response4$data.error) === null || _error$response4$data2 === void 0 ? void 0 : _error$response4$data2.message;
  }
  if (error !== null && error !== void 0 && (_error$response5 = error.response) !== null && _error$response5 !== void 0 && (_error$response5$data = _error$response5.data) !== null && _error$response5$data !== void 0 && _error$response5$data.errors) {
    var _error$response6, _error$response6$data;
    const errorMessages = [];

    // enumerable error (ex: validation errors)
    Object.values(error === null || error === void 0 ? void 0 : (_error$response6 = error.response) === null || _error$response6 === void 0 ? void 0 : (_error$response6$data = _error$response6.data) === null || _error$response6$data === void 0 ? void 0 : _error$response6$data.errors).forEach(_ref => {
      let [errorMessage] = _ref;
      errorMessages.push(errorMessage);
    });

    // convert to multiline string
    return errorMessages.join("\n");
  }
  if (error !== null && error !== void 0 && error.message) {
    return error.message;
  }
};

/**
 * Executes function after a wait time of inactivity
 * @param {function} func
 * @param {number} waitTime
 */
const debounce = (func, waitTime) => {
  let timeout;
  return function executedFunction() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    // The callback function to be executed after
    // the debounce time has elapsed
    const later = () => {
      // null timeout to indicate the debounce ended
      timeout = null;
      func(...args);
    };
    // This will reset the waiting every function execution.
    // This is the step that prevents the function from
    // being executed because it will never reach the
    // inside of the previous setTimeout
    clearTimeout(timeout);

    // Restart the debounce waiting period.
    // setTimeout returns a truthy value (it differs in web vs Node)
    timeout = setTimeout(later, waitTime);
  };
};
function getSiteCardProcessor() {
  var _window$Pelcro$site$r, _window$Pelcro$site$r2, _window$Pelcro$site$r3;
  if ((_window$Pelcro$site$r = window.Pelcro.site.read()) !== null && _window$Pelcro$site$r !== void 0 && _window$Pelcro$site$r.vantiv_gateway_settings) {
    return "vantiv";
  }
  if ((_window$Pelcro$site$r2 = window.Pelcro.site.read()) !== null && _window$Pelcro$site$r2 !== void 0 && _window$Pelcro$site$r2.tap_gateway_settings) {
    return "tap";
  }
  if ((_window$Pelcro$site$r3 = window.Pelcro.site.read()) !== null && _window$Pelcro$site$r3 !== void 0 && _window$Pelcro$site$r3.cybersource_gateway_settings) {
    return "cybersource";
  }
  return "stripe";
}
function getFourDigitYear(lastTwoDigits) {
  // Get the current year
  const currentYear = new Date().getFullYear();

  // Extract the current century (first two digits)
  const currentCentury = Math.floor(currentYear / 100);

  // Combine the century and the provided last two digits
  const fourDigitYear = currentCentury * 100 + lastTwoDigits;
  return fourDigitYear;
}

/**
 * @typedef {Object} OptionsType
 * @property {boolean} loadPaymentSDKs
 * @property {boolean} enableURLTriggers
 * @property {boolean} enableTheme
 * @property {boolean} enablePaywalls
 * @property {boolean} enableGoogleAnalytics
 */

/**
 * Initializes pelcro features based on the options flag object
 * @param {OptionsType} options
 * @returns
 */
const optionsController = options => {
  if (!options) {
    return;
  }
  const optionsMethodsDict = {
    loadPaymentSDKs: loadPaymentSDKs,
    loadAuth0SDK: loadAuth0SDK,
    enableURLTriggers: initViewFromURL,
    enableTheme: applyPelcroTheme,
    enablePaywalls: initPaywalls,
    loadSecuritySDK: initSecuritySdk,
    enableGoogleAnalytics: initGATracking
  };

  // Only execute enabled options
  Object.entries(options).filter(_ref => {
    let [_, value] = _ref;
    return value === true;
  }).forEach(_ref2 => {
    var _optionsMethodsDict$k;
    let [key] = _ref2;
    return (_optionsMethodsDict$k = optionsMethodsDict[key]) === null || _optionsMethodsDict$k === void 0 ? void 0 : _optionsMethodsDict$k.call(optionsMethodsDict);
  });
};
const initPaywalls = () => {
  var _window$Pelcro$site$r;
  const paywallMethods = window.Pelcro.paywall;
  const viewFromURL = getStableViewID(window.Pelcro.helpers.getURLParameter("view"));
  if (((_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.settings) === "subscription") {
    // blur entitlements based content
    const didBlurContent = init();

    // Skip paywall if article is not restricted
    if (isValidViewFromURL(viewFromURL) || !paywallMethods.isArticleRestricted()) {
      return;
    }
    const {
      switchView,
      isAuthenticated
    } = usePelcro.getStore();

    // eslint-disable-next-line no-inner-declarations
    function displayPaywalls() {
      if (paywallMethods !== null && paywallMethods !== void 0 && paywallMethods.displayMeterPaywall()) {
        /* 
          showing both the meter and the entitlements notification doesn't make sense from
          a product prespective + they would take half the screen on mobile devies, so we're
          not showing the meter, and only showing the entitlements notification.
          */
        if (!didBlurContent) {
          switchView("meter");
        }
      } else if (paywallMethods !== null && paywallMethods !== void 0 && paywallMethods.displayNewsletterPaywall()) {
        switchView("newsletter");
      } else if (paywallMethods !== null && paywallMethods !== void 0 && paywallMethods.displayPaywall()) {
        switchView("plan-select");
      }
    }
    if ("id" in Pelcro.user.read() || !isAuthenticated()) {
      displayPaywalls();
    } else {
      addEventListener("PelcroUserLoaded", function () {
        displayPaywalls();
      }, true);
    }
  }
};
const loadPaymentSDKs = () => {
  // Lazy load stripe's SDK
  const {
    whenUserReady
  } = usePelcro.getStore();
  const supportsVantiv = Boolean(window.Pelcro.site.read().vantiv_gateway_settings);
  const supportsTap = Boolean(window.Pelcro.site.read().tap_gateway_settings);
  whenUserReady(() => {
    if (!window.Stripe && !supportsVantiv && !supportsTap) {
      pure_1(window.Pelcro.environment.stripe);
    }
  });
  window.Pelcro.helpers.loadSDK("https://applepay.cdn-apple.com/jsapi/v1/apple-pay-sdk.js", "apple-pay-sdk");

  // Load PayPal SDKs
  const supportsPaypal = Boolean(window.Pelcro.site.read().braintree_tokenization);
  if (supportsPaypal) {
    window.Pelcro.helpers.loadSDK("https://js.braintreegateway.com/web/3.69.0/js/client.min.js", "braintree-sdk");
    window.Pelcro.helpers.loadSDK("https://js.braintreegateway.com/web/3.69.0/js/paypal-checkout.min.js", "braintree-paypal-sdk");
  }

  // Load Vantiv SDKs
  if (supportsVantiv) {
    if (!window.jQuery) {
      window.Pelcro.helpers.loadSDK("https://code.jquery.com/jquery-3.6.0.slim.min.js", "vantiv-jquery-sdk");
    }
    window.Pelcro.helpers.loadSDK("https://ajax.googleapis.com/ajax/libs/jquery/3.6.3/jquery.min.js", "vantiv-jquery-sdk");
    const eProtectApi3PreLiveURL = "https://request.eprotect.vantivprelive.com/eProtect/eProtect-api3.js";
    const eProtectApi3ProductionURL = "https://request.eprotect.vantivcnp.com/eProtect/eProtect-api3.js";
    const eProtectApi3scriptUrlToUse = window.Pelcro.site.read().vantiv_gateway_settings.environment === "production" ? eProtectApi3ProductionURL : eProtectApi3PreLiveURL;
    window.Pelcro.helpers.loadSDK(eProtectApi3scriptUrlToUse, "vantiv-eprotect-api");
    if (!window.EprotectIframeClient) {
      const PRELIVE_URL = "https://request.eprotect.vantivprelive.com/eProtect/js/eProtect-iframe-client.min.js";
      const PRODUCTION_URL = "https://request.eprotect.vantivcnp.com/eProtect/js/eProtect-iframe-client3.min.js";
      const scriptUrlToUse = window.Pelcro.site.read().vantiv_gateway_settings.environment === "production" ? PRODUCTION_URL : PRELIVE_URL;
      window.Pelcro.helpers.loadSDK(scriptUrlToUse, "vantiv-eprotect-sdk");
    }
  }

  // Load Tap SDKs
  if (supportsTap) {
    window.Pelcro.helpers.loadSDK("https://cdnjs.cloudflare.com/ajax/libs/bluebird/3.3.4/bluebird.min.js", "tap-bluebird");
    window.Pelcro.helpers.loadSDK("https://secure.gosell.io/js/sdk/tap.min.js", "tap-sdk");
  }
};
const loadAuth0SDK = () => {
  const auth0Enabled = Boolean(window.Pelcro.site.read().auth0_client_id && window.Pelcro.site.read().auth0_base_url);
  if (auth0Enabled) {
    window.Pelcro.helpers.loadSDK("https://cdn.auth0.com/js/auth0/9.18/auth0.min.js", "auth0-sdk");
  }
};
const initSecuritySdk = () => {
  const {
    whenSiteReady
  } = usePelcro.getStore();
  whenSiteReady(() => {
    var _window$Pelcro$site$r2;
    const securityKey = (_window$Pelcro$site$r2 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r2 === void 0 ? void 0 : _window$Pelcro$site$r2.security_key;
    if (!securityKey) return;
    window.Pelcro.helpers.loadSDK(`https://www.recaptcha.net/recaptcha/enterprise.js?render=${securityKey}`, "pelcro-security-enteprise");
  });
};
const initGATracking = () => {
  var _window, _window$Pelcro, _window$Pelcro$uiSett;
  const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
  if (window.Pelcro.site.read().google_analytics_id) {
    if (enableReactGA4) {
      // Initialize ReactGA4 with your tracking ID
      ReactGA4.initialize(window.Pelcro.site.read().google_analytics_id);
      // Enable e-commerce tracking
      ReactGA4.initialize(window.Pelcro.site.read().google_analytics_id, {
        gaOptions: {
          send_page_view: true,
          ecommerce: {
            enabled: true
          }
        }
      });
    } else {
      var _ReactGA$initialize, _ReactGA$plugin, _ReactGA$plugin$requi;
      ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$initialize = ReactGA.initialize) === null || _ReactGA$initialize === void 0 ? void 0 : _ReactGA$initialize.call(ReactGA, window.Pelcro.site.read().google_analytics_id);
      ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$plugin = ReactGA.plugin) === null || _ReactGA$plugin === void 0 ? void 0 : (_ReactGA$plugin$requi = _ReactGA$plugin.require) === null || _ReactGA$plugin$requi === void 0 ? void 0 : _ReactGA$plugin$requi.call(_ReactGA$plugin, "ecommerce");
    }
  }
};
const dispatchModalDisplayEvents = modalName => {
  var _window2, _window2$Pelcro, _window2$Pelcro$uiSet, _modalName$replace, _modalName$replace2;
  const enableReactGA4 = (_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$Pelcro = _window2.Pelcro) === null || _window2$Pelcro === void 0 ? void 0 : (_window2$Pelcro$uiSet = _window2$Pelcro.uiSettings) === null || _window2$Pelcro$uiSet === void 0 ? void 0 : _window2$Pelcro$uiSet.enableReactGA4;
  const formattedAction = modalName === null || modalName === void 0 ? void 0 : (_modalName$replace = modalName.replace("pelcro-", "")) === null || _modalName$replace === void 0 ? void 0 : _modalName$replace.replaceAll("-", " ");
  if (enableReactGA4) {
    ReactGA4.event(`${formattedAction} viewed`, {
      nonInteraction: true
    });
  } else {
    var _ReactGA$event;
    ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
      category: "VIEWS",
      action: `${formattedAction} viewed`,
      nonInteraction: true
    });
  }
  window.Pelcro.insight.track("Modal Displayed", {
    name: `${modalName === null || modalName === void 0 ? void 0 : (_modalName$replace2 = modalName.replace("pelcro-", "")) === null || _modalName$replace2 === void 0 ? void 0 : _modalName$replace2.replaceAll("-", " ")}`
  });
  const modalDisplayEvent = new CustomEvent("PelcroModalDisplay", {
    detail: {
      modalName
    }
  });
  document.dispatchEvent(modalDisplayEvent);
};
const {
  whenSiteReady,
  whenEcommerceLoaded
} = usePelcro.getStore();
const renderShopView = shopComponent => {
  whenEcommerceLoaded(() => {
    const shopElement = document.getElementById("pelcro-shop");
    if (shopElement) {
      ReactDOM.render( /*#__PURE__*/React__default.createElement("div", {
        className: "pelcro-root"
      }, shopComponent), shopElement);
    }
  });
};

/**
 * Takes site's color config on pelcro and applies it to the UI
 */
const applyPelcroTheme = () => {
  // copied from https://css-tricks.com/converting-color-spaces-in-javascript/#hex-to-hsl
  const hexToHsl = H => {
    // Convert hex to RGB first
    let r = 0;
    let g = 0;
    let b = 0;
    if (H.length == 4) {
      r = "0x" + H[1] + H[1];
      g = "0x" + H[2] + H[2];
      b = "0x" + H[3] + H[3];
    } else if (H.length == 7) {
      r = "0x" + H[1] + H[2];
      g = "0x" + H[3] + H[4];
      b = "0x" + H[5] + H[6];
    }
    // Then to HSL
    r /= 255;
    g /= 255;
    b /= 255;
    const cmin = Math.min(r, g, b);
    const cmax = Math.max(r, g, b);
    const delta = cmax - cmin;
    let h = 0;
    let s = 0;
    let l = 0;
    if (delta == 0) h = 0;else if (cmax == r) h = (g - b) / delta % 6;else if (cmax == g) h = (b - r) / delta + 2;else h = (r - g) / delta + 4;
    h = Math.round(h * 60);
    if (h < 0) h += 360;
    l = (cmax + cmin) / 2;
    s = delta == 0 ? 0 : delta / (1 - Math.abs(2 * l - 1));
    s = +(s * 100).toFixed(1);
    l = +(l * 100).toFixed(1);
    return {
      hue: String(h),
      saturation: `${s}%`,
      lightness: `${l}%`
    };
  };
  whenSiteReady(() => {
    var _window$Pelcro$site$r3, _window$Pelcro$site$r4;
    const primaryColorHex = (_window$Pelcro$site$r3 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r3 === void 0 ? void 0 : (_window$Pelcro$site$r4 = _window$Pelcro$site$r3.design_settings) === null || _window$Pelcro$site$r4 === void 0 ? void 0 : _window$Pelcro$site$r4.primary_color;
    if (!primaryColorHex) {
      return;
    }
    const primaryColorHsl = hexToHsl(primaryColorHex);
    document.documentElement.style.setProperty("--plc-primary-hue", primaryColorHsl.hue);
    document.documentElement.style.setProperty("--plc-primary-saturation", primaryColorHsl.saturation);
    document.documentElement.style.setProperty("--plc-primary-lightness", primaryColorHsl.lightness);
  });
};

/**
 * Initializes a specific modal according to the url 'view' param
 */
const initViewFromURL = () => {
  const view = getStableViewID(window.Pelcro.helpers.getURLParameter("view"));
  const {
    switchView,
    whenSiteReady
  } = usePelcro.getStore();
  if (isValidViewFromURL(view)) {
    whenSiteReady(() => {
      if (view === "plan-select") {
        return initSubscriptionFromURL();
      }
      if (view === "register") {
        const offlinePlanId = window.Pelcro.helpers.getURLParameter("plan_id");
        if (offlinePlanId) {
          return initOfflineSubscriptionFromURL(offlinePlanId);
        }
      }
      if (view === "order-create") {
        return initPurchaseFromUrl();
      }
      if (view === "cart") {
        return initCartFromUrl();
      }
      if (view === "email-verify") {
        return verifyEmailTokenFromUrl();
      }
      if (view === "passwordless-login") {
        return verifyLinkTokenFromUrl();
      }
      if (view === "passwordless-request") {
        return showPasswordlessRequestFromUrl();
      }
      if (view === "invoice-details") {
        return showInvoiceDetailsFromUrl();
      }
      if (view === "manage-members") {
        return showSubscriptionManageMembersFromUrl();
      }
      if (view === "payment-method-update") {
        return showPaymentMethodUpdateFromUrl();
      }
      switchView(view);
    });
  }
};

/**
 * Initializes the subscription flow if 'product_id' & 'plan_id' params exist
 * with valid IDs. Otherwise, switches to the product selection flow
 */
const initSubscriptionFromURL = () => {
  const {
    switchView,
    whenSiteReady,
    set
  } = usePelcro.getStore();
  whenSiteReady(() => {
    var _selectedProduct$plan;
    const productsList = window.Pelcro.product.list();
    if (!(productsList !== null && productsList !== void 0 && productsList.length)) {
      return;
    }
    const [productId, planId, isGiftParam] = [window.Pelcro.helpers.getURLParameter("product_id"), window.Pelcro.helpers.getURLParameter("plan_id"), window.Pelcro.helpers.getURLParameter("is_gift")];
    const isGift = (isGiftParam === null || isGiftParam === void 0 ? void 0 : isGiftParam.toLowerCase()) === "true";
    const selectedProduct = productsList.find(product => product.id === Number(productId));
    const selectedPlan = selectedProduct === null || selectedProduct === void 0 ? void 0 : (_selectedProduct$plan = selectedProduct.plans) === null || _selectedProduct$plan === void 0 ? void 0 : _selectedProduct$plan.find(plan => plan.id === Number(planId));
    set({
      product: selectedProduct,
      plan: selectedPlan,
      isGift
    });
    if (!selectedProduct || !selectedPlan) {
      return switchView("plan-select");
    }
    const {
      isAuthenticated,
      switchToAddressView,
      switchToPaymentView
    } = usePelcro.getStore();
    if (!isAuthenticated()) {
      return switchView("register");
    }
    if (isGift) {
      return switchView("gift-create");
    }
    const requiresAddress = Boolean(selectedProduct.address_required);
    if (!requiresAddress) {
      return switchToPaymentView();
    }
    return switchToAddressView();
  });
};

/**
 * Initializes offline subscription flow if 'plan_id' params exist
 * with valid IDs, Otherwise, ignore the param
 */
const initOfflineSubscriptionFromURL = offlinePlanId => {
  const {
    switchView,
    whenSiteReady,
    isAuthenticated,
    switchToPaymentView,
    switchToAddressView,
    set
  } = usePelcro.getStore();
  whenSiteReady(() => {
    window.Pelcro.plan.getPlan({
      plan_id: offlinePlanId
    }, (error, response) => {
      if (error) {
        return;
      }
      const {
        plan
      } = response.data;
      const isGiftParam = window.Pelcro.helpers.getURLParameter("is_gift");
      const isGift = (isGiftParam === null || isGiftParam === void 0 ? void 0 : isGiftParam.toLowerCase()) === "true";
      set({
        plan,
        product: plan === null || plan === void 0 ? void 0 : plan.product,
        isGift
      });
      if (!isAuthenticated()) {
        return switchView("register");
      }
      if (isGift) {
        return switchView("gift-create");
      }
      const requiresAddress = Boolean(plan.address_required);
      if (!requiresAddress) {
        return switchToPaymentView();
      }
      return switchToAddressView();
    });
  });
};

/**
 * Initializes the e-commerce quick purchase flow if 'sku_id' param exist
 * with valid IDs, Otherwise, ignore the param
 */
const initPurchaseFromUrl = () => {
  const {
    whenEcommerceLoaded,
    purchaseItem
  } = usePelcro.getStore();
  whenEcommerceLoaded(() => {
    const skuId = window.Pelcro.helpers.getURLParameter("sku_id");
    purchaseItem(skuId);
  });
};

/**
 * Initializes the cart if 'sku_id' param exist with valid IDs,
 * Otherwise, ignore the param.
 */
const initCartFromUrl = () => {
  const {
    whenEcommerceLoaded,
    addToCart,
    switchView
  } = usePelcro.getStore();
  whenEcommerceLoaded(() => {
    const skusIdsParam = window.Pelcro.helpers.getURLParameter("sku_id");
    const skusIds = skusIdsParam === null || skusIdsParam === void 0 ? void 0 : skusIdsParam.split(",");
    let hasAddedAnItemSuccessfully = false;
    skusIds === null || skusIds === void 0 ? void 0 : skusIds.forEach(skuId => {
      const didAddItemSuccessfully = addToCart(skuId);
      if (didAddItemSuccessfully) {
        hasAddedAnItemSuccessfully = true;
      }
    });
    if (hasAddedAnItemSuccessfully) switchView("cart");
  });
};
const verifyEmailTokenFromUrl = () => {
  var _window$Pelcro$site$r5, _window$Pelcro$site$r6;
  const {
    whenSiteReady
  } = usePelcro.getStore();
  const translations = i18next.t("verifyEmail:messages", {
    returnObjects: true
  });
  const emailToken = window.Pelcro.helpers.getURLParameter("token");
  const isEmailVerificationEnabled = (_window$Pelcro$site$r5 = (_window$Pelcro$site$r6 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r6 === void 0 ? void 0 : _window$Pelcro$site$r6.email_verify_enabled) !== null && _window$Pelcro$site$r5 !== void 0 ? _window$Pelcro$site$r5 : false;
  if (!emailToken || !isEmailVerificationEnabled) return;
  whenSiteReady(() => {
    window.Pelcro.user.verifyEmailToken({
      token: emailToken
    }, (err, res) => {
      if (err) {
        return notify$1.error(getErrorMessages(err));
      }
      return notify$1.success(translations.success);
    });
  }, {
    once: true
  });
};
const verifyLinkTokenFromUrl = () => {
  var _window$Pelcro$site$r7;
  const {
    whenSiteReady,
    resetView,
    isAuthenticated
  } = usePelcro.getStore();
  const translations = i18next.t("verifyLinkToken:messages", {
    returnObjects: true
  });
  const loginToken = window.Pelcro.helpers.getURLParameter("token");
  const passwordlessEnabled = (_window$Pelcro$site$r7 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r7 === void 0 ? void 0 : _window$Pelcro$site$r7.passwordless_enabled;
  if (isAuthenticated() || !loginToken || !passwordlessEnabled) return;
  whenSiteReady(() => {
    window.Pelcro.user.verifyLoginToken({
      token: loginToken
    }, (err, res) => {
      if (err) {
        return notify$1.error(getErrorMessages(err));
      }
      const {
        auth_token
      } = res.data;
      window.Pelcro.user.refresh({
        auth_token
      }, (err, res) => {
        if (err) {
          return notify$1.error(getErrorMessages(err));
        }
        resetView();
        return notify$1.success(translations.success);
      });
    });
  }, {
    once: true
  });
};
const showPasswordlessRequestFromUrl = () => {
  var _window$Pelcro$site$r8;
  const {
    isAuthenticated
  } = usePelcro.getStore();
  const passwordlessEnabled = (_window$Pelcro$site$r8 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r8 === void 0 ? void 0 : _window$Pelcro$site$r8.passwordless_enabled;
  if (!passwordlessEnabled || isAuthenticated()) return;
  const {
    switchView
  } = usePelcro.getStore();
  return switchView("passwordless-request");
};
const showPaymentMethodUpdateFromUrl = () => {
  const {
    isAuthenticated,
    whenSiteReady,
    whenUserReady,
    switchView
  } = usePelcro.getStore();
  whenSiteReady(() => {
    if (!isAuthenticated()) {
      return switchView("login");
    }
    whenUserReady(() => {
      const supportsVantiv = Boolean(window.Pelcro.site.read().vantiv_gateway_settings);
      const supportsTap = Boolean(window.Pelcro.site.read().tap_gateway_settings);
      if (!window.Stripe && !supportsVantiv && !supportsTap) {
        document.querySelector('script[src="https://js.stripe.com/v3"]').addEventListener("load", () => {
          return switchView("payment-method-update");
        });
        return;
      }

      //vantiv
      if (supportsVantiv) {
        document.querySelector("#vantiv-eprotect-sdk").addEventListener("load", () => {
          return switchView("payment-method-update");
        });
        return;
      }

      //Tap
      if (supportsTap && document.querySelector("#tap-sdk")) {
        return switchView("payment-method-update");
      }
      return switchView("payment-method-update");
    });
  });
};
const showInvoiceDetailsFromUrl = () => {
  const {
    isAuthenticated,
    setInvoice,
    whenUserReady,
    whenSiteReady,
    switchView
  } = usePelcro.getStore();
  whenSiteReady(() => {
    if (!isAuthenticated()) {
      return switchView("login");
    }
    whenUserReady(() => {
      const invoiceId = window.Pelcro.helpers.getURLParameter("id");
      const wasSetSuccessfully = setInvoice(invoiceId);
      if (!wasSetSuccessfully) {
        const errorMessage = i18next.t("messages:invalidInvoice", {
          returnObjects: true
        });
        return notify$1.error(errorMessage);
      }
      const {
        invoice
      } = usePelcro.getStore();
      if (invoice.total === 0) {
        const errorMessage = i18next.t("messages:zeroTotalInvoice", {
          returnObjects: true
        });
        return notify$1.error(errorMessage);
      }
      return switchView("invoice-details");
    });
  });
};
const showSubscriptionManageMembersFromUrl = () => {
  const {
    isAuthenticated,
    setSubscriptionToManageMembers,
    whenUserReady,
    whenSiteReady,
    switchView
  } = usePelcro.getStore();
  whenSiteReady(() => {
    if (!isAuthenticated()) {
      return switchView("login");
    }
    whenUserReady(() => {
      const subscriptionId = window.Pelcro.helpers.getURLParameter("subscription_id");
      const wasSetSuccessfully = setSubscriptionToManageMembers(subscriptionId);
      if (!wasSetSuccessfully) {
        const errorMessage = i18next.t("messages:invalidSubscription", {
          returnObjects: true
        });
        return notify$1.error(errorMessage);
      }
      return switchView("manage-members");
    });
  });
};

const defaultOptions = {
  loadPaymentSDKs: true,
  loadAuth0SDK: true,
  enableURLTriggers: true,
  enableTheme: true,
  enablePaywalls: true,
  loadSecuritySDK: true,
  enableGoogleAnalytics: false
};
const PelcroModalController = _ref => {
  let {
    rootId = "pelcro-app",
    options = defaultOptions,
    children
  } = _ref;
  const {
    view,
    isAuthenticated,
    whenSiteReady
  } = usePelcro();
  React__default.useEffect(() => {
    init$1();
    renderShopView(React__default.Children.map(children, child => child).find(_ref2 => {
      let {
        type
      } = _ref2;
      return (type === null || type === void 0 ? void 0 : type.viewId) === "shop";
    }));
  }, []);

  // default options are overridable by consumer's options
  const mergedOptions = {
    ...defaultOptions,
    ...options
  };
  React__default.useEffect(() => {
    whenSiteReady(() => {
      optionsController(mergedOptions);
    });
  }, [options]);
  React__default.useEffect(() => {
    if (window.Pelcro.user.isAuthenticated()) {
      authenticatedButtons();
    } else {
      unauthenticatedButtons();
    }
  }, [window.Pelcro.user.isAuthenticated()]);
  React__default.useEffect(() => {
    if (view === null || view === "meter") {
      return enableScroll();
    }
    if (view) {
      return disableScroll();
    }
  }, [view]);
  return /*#__PURE__*/React__default.createElement("div", {
    id: rootId,
    className: "pelcro-root"
  }, isAuthenticated() && React__default.Children.map(children, child => child).find(_ref3 => {
    let {
      type
    } = _ref3;
    return (type === null || type === void 0 ? void 0 : type.viewId) === "dashboard-open";
  }), React__default.Children.map(children, child => child).find(_ref4 => {
    let {
      type
    } = _ref4;
    return (type === null || type === void 0 ? void 0 : type.viewId) === "notification";
  }), view === "_plan-select-entitlements" && React__default.Children.map(children, child => child).find(_ref5 => {
    let {
      type
    } = _ref5;
    return (type === null || type === void 0 ? void 0 : type.viewId) === "plan-select";
  }), React__default.Children.map(children, child => child).find(_ref6 => {
    let {
      type
    } = _ref6;
    return (type === null || type === void 0 ? void 0 : type.viewId) === view;
  }));
};

var lib$1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.executeSideEffects = executeSideEffects;
exports.mergeState = mergeState;
exports.default = useCreateReducerWithEffect;
exports.composeReducers = composeReducers;
exports.SideEffect = exports.UpdateWithSideEffect = exports.NoUpdate = exports.Update = exports.NO_UPDATE_SYMBOL = void 0;



// for testing
const NO_UPDATE_SYMBOL = Symbol("NO_UPDATE_SYMBOL");
exports.NO_UPDATE_SYMBOL = NO_UPDATE_SYMBOL;

const Update = state => ({
  state
});

exports.Update = Update;

const NoUpdate = () => NO_UPDATE_SYMBOL;

exports.NoUpdate = NoUpdate;

const UpdateWithSideEffect = (state, sideEffects) => ({
  state,
  sideEffects
});

exports.UpdateWithSideEffect = UpdateWithSideEffect;

const SideEffect = sideEffects => ({
  sideEffects
}); //for testting


exports.SideEffect = SideEffect;

async function executeSideEffects({
  sideEffects,
  state,
  dispatch
}) {
  let cancelFuncs = [];

  if (sideEffects) {
    while (sideEffects.length) {
      const sideEffect = sideEffects.shift();
      const cancel = sideEffect(state, dispatch);

      if (cancel && typeof cancel === "function") {
        cancelFuncs.push(cancel);
      }
    }
  }

  return Promise.resolve(cancelFuncs);
} // for testing


function mergeState(prevState, newState, isUpdate) {
  const existingEffects = isUpdate ? prevState.sideEffects : [];
  const newSideEffects = newState.sideEffects ? [...existingEffects, ...(Array.isArray(newState.sideEffects) ? newState.sideEffects : [newState.sideEffects])] : prevState.sideEffects;
  const hasNewState = typeof newState.hasOwnProperty === 'function' && newState.hasOwnProperty('state');
  let updatedState;

  if (isUpdate) {
    updatedState = hasNewState ? newState.state : prevState.state;
  } else {
    updatedState = newState.state;
  }

  return {
    state: updatedState,
    sideEffects: newSideEffects
  };
}

function finalReducer(reducer) {
  return function (state, action) {
    if (action === NO_UPDATE_SYMBOL) {
      return state;
    }

    let newState = reducer(state.state, action);
    return mergeState(state, newState, true);
  };
}

function useCreateReducerWithEffect(reducer, initialState, init) {
  const memoizedReducer = (0, React__default.useCallback)(finalReducer(reducer), [reducer]);
  const [{
    state,
    sideEffects
  }, dispatch] = (0, React__default.useReducer)(memoizedReducer, {
    state: initialState,
    sideEffects: []
  }, state => {
    let newState;

    if (typeof init === 'function') {
      newState = init(state);
    }

    return typeof newState !== 'undefined' ? mergeState(state, newState, false) : state;
  });
  let cancelFuncs = (0, React__default.useRef)([]);
  (0, React__default.useEffect)(() => {
    if (sideEffects.length) {
      async function asyncEffects() {
        async function runSideEffects() {
          const cancels = await executeSideEffects({
            sideEffects,
            state,
            dispatch
          });
          return cancels;
        }

        const cancels = await runSideEffects();
        cancelFuncs.current = cancels;
      }

      asyncEffects();

      if (cancelFuncs.current.length) {
        cancelFuncs.current.forEach(func => {
          func(state);
          cancelFuncs.current = [];
        });
      }
    }
  }, [sideEffects]); //eslint-disable-line

  return [state, dispatch];
}

function composeReducers(reducers) {
  return (state, action) => {
    let reducerCount = reducers.length;
    let sideEffects = [];
    let noUpdateCount = 0;
    const reducedResult = reducers.reduceRight((prevState, reducer, index) => {
      // This is to handle the asymmetry in the useReducerWithSideFffect API.
      // Whereas regular reducers have a consistent API that is state in, state out
      // useReducerWithSideEffects has state in, state+sideEffects out
      let state;

      if (index === reducerCount - 1) {
        state = prevState;
      } else {
        state = prevState.state;
      }

      const result = reducer(state, action);
      let returnValue; // When we do not have an update, then we increment our no-update counter and
      // return the previous state.

      if (result === NO_UPDATE_SYMBOL) {
        noUpdateCount++;
        returnValue = {
          state
        };
      } else {
        returnValue = result;
      }

      if (result && Array.isArray(result.sideEffects)) {
        sideEffects = sideEffects.concat(result.sideEffects);
      }

      return returnValue;
    }, state);
    const noUpdateOccurred = noUpdateCount === reducerCount;

    if (noUpdateOccurred) {
      return NO_UPDATE_SYMBOL;
    }

    return {
      state: reducedResult && reducedResult.state,
      sideEffects
    };
  };
}
});

var useReducerWithSideEffects = unwrapExports(lib$1);
lib$1.executeSideEffects;
lib$1.mergeState;
lib$1.composeReducers;
var lib_4 = lib$1.SideEffect;
var lib_5 = lib$1.UpdateWithSideEffect;
lib$1.NoUpdate;
var lib_7 = lib$1.Update;
lib$1.NO_UPDATE_SYMBOL;

const SET_EMAIL = "SET_EMAIL";
const SET_USERNAME = "SET_USERNAME";
const SET_PASSWORD = "SET_PASSWORD";
const SET_EMAIL_ERROR = "SET_EMAIL_ERROR";
const SET_USERNAME_ERROR = "SET_USERNAME_ERROR";
const SET_PASSWORD_ERROR = "SET_PASSWORD_ERROR";
const SET_FIRST_NAME_ERROR = "SET_FIRST_NAME_ERROR";
const SET_LAST_NAME_ERROR = "SET_LAST_NAME_ERROR";
const SET_PHONE_ERROR = "SET_PHONE_ERROR";
const SET_TEXT_FIELD = "SET_TEXT_FIELD";
const SET_MONTH = "SET_MONTH";
const SET_YEAR = "SET_YEAR";
const SET_TOKEN = "SET_TOKEN";
const SET_GIFT_CODE = "SET_GIFT_CODE";
const RESET_LOGIN_FORM = "RESET_LOGIN_FORM";
const SET_CONFIRM_PASSWORD_ERROR = "SET_CONFIRM_PASSWORD_ERROR";
const SET_CONFIRM_PASSWORD = "SET_CONFIRM_PASSWORD";
const CONFIRM_PASSWORD_USED = "CONFIRM_PASSWORD_USED";
const DISABLE_SUBMIT = "DISABLE_SUBMIT";
const LOADING = "LOADING";
const SKELETON_LOADER = "SKELETON_LOADER";
const SUBMIT_PAYMENT = "SUBMIT_PAYMENT";
const SUBSCRIBE = "CREATE_SUBSCRIPTION";
const HANDLE_PAYPAL_SUBSCRIPTION = "HANDLE_PAYPAL_SUBSCRIPTION";
const HANDLE_APPLEPAY_SUBSCRIPTION = "HANDLE_APPLEPAY_SUBSCRIPTION";
const DISABLE_COUPON_BUTTON = "DISABLE_COUPON_BUTTON";
const APPLY_COUPON_CODE = "APPLY_COUPON_CODE";
const REMOVE_APPLIED_COUPON = "REMOVE_APPLIED_COUPON";
const SET_PERCENT_OFF = "SET_PERCENT_OFF";
const SET_COUPON = "SET_COUPON";
const SET_COUPON_ERROR = "SET_COUPON_ERROR";
const UPDATE_COUPON_CODE = "UPDATE_COUPON_CODE";
const SHOW_COUPON_FIELD = "SHOW_COUPON_FIELD";
const HANDLE_LOGIN = "HANDLE_LOGIN";
const HANDLE_SOCIAL_LOGIN = "HANDLE_SOCIAL_LOGIN";
const HANDLE_REGISTRATION = "HANDLE_REGISTRATION";
const DISABLE_LOGIN_BUTTON = "DISABLE_LOGIN_BUTTON";
const DISABLE_REGISTRATION_BUTTON = "DISABLE_REGISTRATION_BUTTON";
const HANDLE_USER_UPDATE = "HANDLE_USER_UPDATE";
const DISABLE_USER_UPDATE_BUTTON = "DISABLE_USER_UPDATE_BUTTON";
const SET_FIRST_NAME = "SET_FIRST_NAME";
const SET_LAST_NAME = "SET_LAST_NAME";
const SET_START_DATE = "SET_START_DATE";
const SET_GIFT_MESSAGE = "SET_GIFT_MESSAGE";
const SET_PHONE = "SET_PHONE";
const SET_TIN = "SET_TIN";
const GET_COUNTRIES_SUCCESS = "GET_COUNTRIES_SUCCESS";
const GET_COUNTRIES_FETCH = "GET_COUNTRIES_FETCH";
const GET_STATES_SUCCESS = "GET_STATES_SUCCESS";
const GET_STATES_FETCH = "GET_STATES_FETCH";
const HANDLE_SUBMIT = "HANDLE_SUBMIT";
const SET_UPDATED_PRICE = "SET_UPDATED_PRICE";
const SET_TAX_AMOUNT = "SET_TAX_AMOUNT";
const SET_CAN_MAKE_PAYMENT = "SET_CAN_MAKE_PAYMENT";
const SET_PAYMENT_REQUEST = "SET_PAYMENT_REQUEST";
const INIT_CONTAINER = "INIT_CONTAINER";
const UPDATE_PAYMENT_REQUEST = "UPDATE_PAYMENT_REQUEST";
const SET_DISPLAY_NAME = "SET_DISPLAY_NAME";
const SET_SELECT = "SET_SELECT";
const SET_NEW_PASSWORD = "SET_NEW_PASSWORD";
const SET_CONFIRM_NEW_PASSWORD = "SET_CONFIRM_NEW_PASSWORD";
const VALIDATE_PASSWORD = "VALIDATE_PASSWORD";
const VALIDATE_NEW_PASSWORD = "VALIDATE_NEW_PASSWORD";
const VALIDATE_CONFIRM_NEW_PASSWORD = "VALIDATE_CONFIRM_NEW_PASSWORD";
const VALIDATE_FIELD = "VALIDATE_FIELD";
const RESET_FIELD_ERROR = "RESET_FIELD_ERROR";
const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
const RESET_NEW_PASSWORD_ERROR = "RESET_NEW_PASSWORD_ERROR";
const RESET_CONFIRM_NEW_PASSWORD_ERROR = "RESET_CONFIRM_NEW_PASSWORD_ERROR";
const SHOW_ALERT = "SHOW_ALERT";
const SELECT_ADDRESS = "SELECT_ADDRESS";
const LOAD_ADDRESSES = "LOAD_ADDRESSES";
const SET_CROP = "SET_CROP";
const SET_ZOOM = "SET_ZOOM";
const CHANGE_IMAGE_FILE = "CHANGE_IMAGE_FILE";
const REMOVE_IMAGE = "REMOVE_IMAGE";
const CROP_COMPLETE = "CROP_COMPLETE";
const SET_IMAGE_SRC = "SET_IMAGE_SRC";
const PASSWORD_CHANGE_SUCCESS = "PASSWORD_CHANGE_SUCCESS";
const SELECT_PAYMENT_METHOD = "SELECT_PAYMENT_METHOD";
const LOAD_PAYMENT_METHODS = "LOAD_PAYMENT_METHODS";
const GET_NEWSLETTERS_FETCH = "GET_NEWSLETTERS_FETCH";
const GET_NEWSLETTERS_SUCCESS = "GET_NEWSLETTERS_SUCCESS";
const SWITCH_TO_UPDATE = "SWITCH_TO_UPDATE";
const LINK_TOKEN_VERIFY = "LINK_TOKEN_VERIFY";
const SET_CANCEL_SUBSCRIPTION_REASON = "SET_CANCEL_SUBSCRIPTION_REASON";
const SET_CANCEL_SUBSCRIPTION_OPTION = "SET_CANCEL_SUBSCRIPTION_OPTION";
const HANDLE_CHECKBOX_CHANGE = "HANDLE_CHECKBOX_CHANGE";
const SET_IS_DEFAULT_PAYMENT_METHOD = "SET_IS_DEFAULT_PAYMENT_METHOD";
const SET_PAYMENT_METHODS = "SET_PAYMENT_METHODS";
const SHOW_PAYMENT_METHOD_SELECT = "SHOW_PAYMENT_METHOD_SELECT";
const SET_SUBSCRIPTION_SUSPEND_DATE = "SET_SUBSCRIPTION_SUSPEND_DATE";
const SET_EMAILS = "SET_EMAILS";
const SET_EMAILS_ERROR = "SET_EMAILS_ERROR";
const HANDLE_LIST_MEMBERS = "HANDLE_LIST_MEMBERS";
const HANDLE_INVITE_MEMBERS = "HANDLE_INVITE_MEMBERS";
const HANDLE_REMOVE_MEMBER = "HANDLE_REMOVE_MEMBER";
const UPDATE_INVITE_BUTTON = "UPDATE_INVITE_BUTTON";
const UPDATE_MEMBERS = "UPDATE_MEMBERS";
const UPDATE_REMOVE_MEMBER_ID = "UPDATE_REMOVE_MEMBER_ID";
const UPDATE_CYBERSOURCE_SESSION_ID = "UPDATE_CYBERSOURCE_SESSION_ID";

const initialState$n = {
  email: "",
  username: "",
  password: "",
  emailError: null,
  usernameError: null,
  passwordError: null,
  buttonDisabled: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$n = /*#__PURE__*/createContext(initialState$n);
const {
  Provider: Provider$n
} = store$n;
const LoginContainer = _ref => {
  var _window, _window$Pelcro, _window$Pelcro$uiSett;
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children
  } = _ref;
  const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
  const handleLogin = (_ref2, dispatch) => {
    let {
      email,
      username,
      password
    } = _ref2;
    window.Pelcro.user.login({
      ...(email && {
        email
      }),
      ...(username && {
        username
      }),
      password
    }, (err, res) => {
      dispatch({
        type: DISABLE_LOGIN_BUTTON,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        onSuccess(res);
        if (enableReactGA4) {
          ReactGA4.event("Logged in", {
            nonInteraction: true
          });
        } else {
          var _ReactGA$event;
          ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
            category: "ACTIONS",
            action: "Logged in",
            nonInteraction: true
          });
        }
      }
    });
  };
  const handleSocialLogin = _ref3 => {
    let {
      idpName,
      idpToken,
      email,
      firstName,
      lastName
    } = _ref3;
    dispatch({
      type: DISABLE_LOGIN_BUTTON,
      payload: true
    });
    window.Pelcro.user.idpLogin({
      idp_name: idpName,
      idp_token: idpToken,
      email: email,
      first_name: firstName,
      last_name: lastName
    }, (err, res) => {
      dispatch({
        type: DISABLE_LOGIN_BUTTON,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        onSuccess(res);
      }
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SET_EMAIL:
        return lib_7({
          ...state,
          email: action.payload,
          emailError: null
        });
      case SET_USERNAME:
        return lib_7({
          ...state,
          username: action.payload,
          usernameError: null
        });
      case SET_PASSWORD:
        return lib_7({
          ...state,
          password: action.payload,
          passwordError: null
        });
      case SET_EMAIL_ERROR:
        return lib_7({
          ...state,
          emailError: action.payload,
          email: ""
        });
      case SET_USERNAME_ERROR:
        return lib_7({
          ...state,
          usernameError: action.payload,
          username: ""
        });
      case SET_PASSWORD_ERROR:
        return lib_7({
          ...state,
          passwordError: action.payload,
          password: ""
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case RESET_LOGIN_FORM:
        return initialState$n;
      case DISABLE_LOGIN_BUTTON:
        return lib_7({
          ...state,
          buttonDisabled: action.payload
        });
      case HANDLE_LOGIN:
        return lib_5({
          ...state,
          buttonDisabled: true
        }, (state, dispatch) => handleLogin(state, dispatch));
      case HANDLE_SOCIAL_LOGIN:
        return lib_4(() => handleSocialLogin(action.payload));
      default:
        return state;
    }
  }, initialState$n);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-login-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$n, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => {
    if (child) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        store: store$n,
        key: i
      });
    }
  }) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$n
  })));
};

function Input(_ref) {
  let {
    label = "",
    required,
    id,
    errorId,
    error,
    className = "",
    labelClassName = "",
    errorClassName = "",
    wrapperClassName = "",
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: `pelcro-input-wrapper ${wrapperClassName}`
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: `pelcro-input-label ${labelClassName}`
  }, `${label}${required ? "*" : ""}`), /*#__PURE__*/React__default.createElement("input", Object.assign({
    type: "text",
    id: id,
    className: `pelcro-input-field ${className} ${error ? "pelcro-input-invalid" : ""}`,
    "aria-describedby": errorId,
    "aria-invalid": Boolean(error)
  }, otherProps)), error && /*#__PURE__*/React__default.createElement("p", {
    id: errorId,
    "aria-live": "assertive",
    className: `pelcro-input-error ${errorClassName}`
  }, error));
}

function Email(_ref) {
  let {
    initWithUserEmail = true,
    disableEmailValidation,
    store,
    enableEmailEdit,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("common");
  const {
    dispatch,
    state: {
      email: stateEmail,
      emailError
    }
  } = useContext(store);
  const [email, setEmail] = useState(stateEmail);
  const [finishedTyping, setFinishedTyping] = useState(false);
  const handleInputChange = useCallback(value => {
    setEmail(value);
    if (disableEmailValidation) {
      return dispatch({
        type: SET_EMAIL,
        payload: email
      });
    }
    if (isEmailValid(email)) {
      dispatch({
        type: SET_EMAIL_ERROR,
        payload: null
      });
      return dispatch({
        type: SET_EMAIL,
        payload: email
      });
    }
    if (finishedTyping) {
      if (email !== null && email !== void 0 && email.length) {
        dispatch({
          type: SET_EMAIL_ERROR,
          payload: t("validation.validEmail")
        });
      } else {
        dispatch({
          type: SET_EMAIL_ERROR,
          payload: t("validation.enterEmail")
        });
      }
    }
  }, [dispatch, email, finishedTyping]);
  useEffect(() => {
    if (!enableEmailEdit) {
      loadEmailIntoField();
    }
  }, [enableEmailEdit]);
  useEffect(() => {
    handleInputChange(email);
  }, [finishedTyping, email, handleInputChange]);

  // Initialize email field with user's email
  const loadEmailIntoField = () => {
    handleInputChange(window.Pelcro.user.read().email);
  };
  useEffect(() => {
    if (initWithUserEmail) {
      document.addEventListener("PelcroUserLoaded", () => {
        loadEmailIntoField();
      });
      loadEmailIntoField();
      return () => {
        document.removeEventListener("PelcroUserLoaded", handleInputChange);
      };
    }
  }, []);
  const isEmailValid = email => {
    const re = /[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?/;
    return re.test(email);
  };
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "email",
    error: emailError,
    value: email !== null && email !== void 0 ? email : "",
    onChange: e => handleInputChange(e.target.value),
    onBlur: () => setFinishedTyping(true),
    onFocus: () => setFinishedTyping(false)
  }, otherProps));
}

function UserNameInput(_ref) {
  let {
    initWithUserName = true,
    store,
    enableUsernameEdit,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("common");
  const {
    dispatch,
    state: {
      username: stateUsername,
      usernameError
    }
  } = useContext(store);
  const [username, setUsername] = useState(stateUsername);
  const [finishedTyping, setFinishedTyping] = useState(false);
  const handleInputChange = useCallback(value => {
    setUsername(value);
    if (username !== null && username !== void 0 && username.length) {
      dispatch({
        type: SET_USERNAME,
        payload: username
      });
    } else if (finishedTyping) {
      dispatch({
        type: SET_USERNAME_ERROR,
        payload: t("validation.enterUsername")
      });
    }
  }, [dispatch, username, finishedTyping]);
  useEffect(() => {
    handleInputChange(username);
  }, [finishedTyping, username, handleInputChange]);
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    error: usernameError,
    value: username !== null && username !== void 0 ? username : "",
    onChange: e => handleInputChange(e.target.value),
    onBlur: () => setFinishedTyping(true),
    onFocus: () => setFinishedTyping(false)
  }, otherProps));
}

function Password(_ref) {
  let {
    store,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("common");
  const {
    dispatch,
    state: {
      password: statePassword,
      passwordError
    }
  } = useContext(store);
  const [password, setPassword] = useState(statePassword);
  const [finishedTyping, setFinishedTyping] = useState(false);
  const handleInputChange = useCallback(value => {
    setPassword(value);
    if (password.length) {
      dispatch({
        type: SET_PASSWORD,
        payload: password
      });
    } else if (finishedTyping) {
      dispatch({
        type: SET_PASSWORD_ERROR,
        payload: t("validation.enterPassword")
      });
    }
  }, [dispatch, password, finishedTyping]);
  useEffect(() => {
    handleInputChange(password);
  }, [finishedTyping, password, handleInputChange]);
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "password",
    error: passwordError,
    value: password,
    onChange: e => handleInputChange(e.target.value),
    onBlur: () => setFinishedTyping(true),
    onFocus: () => setFinishedTyping(false)
  }, otherProps));
}

/**
 *
 */
function ConfirmPassword(_ref) {
  let {
    store,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("common");
  const {
    dispatch,
    state: {
      confirmPassword: stateConfirmPassword,
      confirmPasswordError
    }
  } = useContext(store);
  const [password, setPassword] = useState(stateConfirmPassword);
  const [finishedTyping, setFinishedTyping] = useState(false);
  useEffect(() => dispatch({
    type: CONFIRM_PASSWORD_USED,
    payload: true
  }), [dispatch]);
  const handleInputChange = useCallback(value => {
    setPassword(value);
    if (password.length) {
      dispatch({
        type: SET_CONFIRM_PASSWORD,
        payload: password
      });
    } else if (finishedTyping) {
      dispatch({
        type: SET_CONFIRM_PASSWORD_ERROR,
        payload: t("validation.confirmPassword")
      });
    }
  }, [dispatch, password, finishedTyping]);
  useEffect(() => {
    handleInputChange(password);
  }, [finishedTyping, password, handleInputChange]);
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "password",
    error: confirmPasswordError,
    value: password,
    onChange: e => handleInputChange(e.target.value),
    onBlur: () => setFinishedTyping(true),
    onFocus: () => setFinishedTyping(false)
  }, otherProps));
}

const Logout = props => {
  const handleLogout = () => {
    var _window, _window$Pelcro, _window$Pelcro$uiSett;
    window.Pelcro.user.logout();
    const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
    if (enableReactGA4) {
      ReactGA4.event("Logged out", {
        nonInteraction: true
      });
    } else {
      var _ReactGA$event;
      ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
        category: "ACTIONS",
        action: "Logged out",
        nonInteraction: true
      });
    }
  };
  return /*#__PURE__*/React__default.createElement("button", {
    name: "logout",
    className: "pelcro-logout-btn",
    onClick: handleLogout,
    disabled: false
  }, "Logout");
};

const LoginButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    state: {
      emailError,
      passwordError,
      usernameError,
      email,
      password,
      username,
      buttonDisabled
    },
    dispatch
  } = useContext(store$n);
  const {
    t
  } = useTranslation("login");
  const [isDisabled, setDisabled] = useState(true);
  useEffect(() => {
    setDisabled(emailError || passwordError || usernameError || (!email.length || !username.length) && !password.length || buttonDisabled);
  }, [emailError, passwordError, usernameError, email, password, username, buttonDisabled]);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_LOGIN
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: isDisabled,
    isLoading: buttonDisabled
  }, otherProps), name !== null && name !== void 0 ? name : t("labels.login"));
};

var _path$u, _path2$3;
function _extends$w() { _extends$w = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$w.apply(this, arguments); }
function SvgEmailVerify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$w({
    className: "plc-w-6 plc-h-6",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$u || (_path$u = /*#__PURE__*/React.createElement("path", {
    d: "M583.01 231.93a15.008 15.008 0 00-.887-3.875c-.562-1.254-1.129-2.508-1.695-3.762a14.686 14.686 0 00-1.898-1.789c-.438-.437-.653-1.027-1.153-1.414l-56.266-44.164v-52.484a15.555 15.555 0 00-15.554-15.555H434.56l-74.945-58.895a15.547 15.547 0 00-19.227 0l-74.945 58.895h-70.996a15.555 15.555 0 00-15.555 15.555v52.484l-56.266 44.16c-.496.39-.715.996-1.152 1.43v.004a13.37 13.37 0 00-1.898 1.773c-.22.426-.414.86-.59 1.305a14.158 14.158 0 00-1.106 2.457 15.009 15.009 0 00-.886 3.875c0 .48-.329.918-.329 1.398l.004 264.45a15.555 15.555 0 0015.555 15.555h435.55a15.555 15.555 0 0015.555-15.555v-264.45c0-.48-.278-.918-.325-1.398zm-41.176.809l-20.723 14.809v-31.11zm-191.83-150.73l34.223 26.883h-68.445zm-140 57.992h280v124.45c.07 1.593.383 3.168.934 4.664l-140.93 100.66-140.46-100.33c.214-.77.37-1.555.464-2.348zm-31.109 107.55l-20.719-14.81 20.719-16.27zm-31.113 234.67V263.56l193.18 137.99a15.562 15.562 0 0018.078 0l193.18-137.99v218.66z"
  })), _path2$3 || (_path2$3 = /*#__PURE__*/React.createElement("path", {
    d: "M324.33 291.81a15.56 15.56 0 0020.582-.297l85.555-77.777a15.56 15.56 0 00-20.938-23.023l-75.398 68.539-44.023-37.723a15.54 15.54 0 00-11.46-4.106 15.553 15.553 0 00-8.758 27.718z"
  })));
}

const LoginRequestLoginToken = _ref => {
  let {
    name,
    onClick,
    className = "",
    labelClassName = "",
    iconClassName = "",
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("passwordlessRequest");
  return /*#__PURE__*/React__default.createElement("button", {
    onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(),
    className: `plc-flex plc-items-center plc-mt-3 plc-mx-auto plc-justify-center plc-p-3 plc-space-x-3 plc-text-gray-700 plc-border plc-border-gray-200 plc-rounded-3xl hover:plc-bg-gray-200 pelcro-auth0-login ${className}`
  }, /*#__PURE__*/React__default.createElement(SvgEmailVerify, {
    className: `plc-w-6 plc-h-auto" ${iconClassName}`
  }), /*#__PURE__*/React__default.createElement("p", {
    className: `${labelClassName}`
  }, name !== null && name !== void 0 ? name : t("title")));
};

const LoginEmail = props => /*#__PURE__*/React__default.createElement(Email, Object.assign({
  store: store$n
}, props));

const LoginUsername = props => /*#__PURE__*/React__default.createElement(UserNameInput, Object.assign({
  store: store$n
}, props));

const LoginPassword = props => /*#__PURE__*/React__default.createElement(Password, Object.assign({
  store: store$n
}, props));

var _path$t;
function _extends$v() { _extends$v = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$v.apply(this, arguments); }
function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$v({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 20 20"
  }, props), _path$t || (_path$t = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z",
    clipRule: "evenodd"
  })));
}

/**
 *
 */
function Alert(_ref) {
  let {
    type = "error",
    className = "",
    onClose,
    children,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", Object.assign({
    className: `${type === "error" ? "pelcro-alert-error" : "pelcro-alert-success"} ${className}`
  }, otherProps), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-inline-flex plc-items-center"
  }, type === "error" && /*#__PURE__*/React__default.createElement(SvgXIconSolid, {
    className: "pelcro-alert-icon"
  }), type === "success" && /*#__PURE__*/React__default.createElement(SvgCheck, {
    className: "pelcro-alert-icon"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "pelcro-alert-content"
  }, children)), onClose && /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "pelcro-alert-close",
    "aria-label": "close alert",
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(SvgXIcon, null)));
}

const AlertWithContext = _ref => {
  let {
    store,
    ...otherProps
  } = _ref;
  const {
    state: {
      alert
    },
    dispatch
  } = useContext(store);
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, (alert === null || alert === void 0 ? void 0 : alert.content) && /*#__PURE__*/React__default.createElement(Alert, Object.assign({
    type: alert.type,
    onClose: () => dispatch({
      type: SHOW_ALERT,
      payload: {
        type: "error",
        content: ""
      }
    })
  }, otherProps), alert.content));
};

var facebookLoginRenderProps = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t(React__default);}(commonjsGlobal,function(e){return function(e){function t(n){if(o[n])return o[n].exports;var r=o[n]={exports:{},id:n,loaded:!1};return e[n].call(r.exports,r,r.exports,t),r.loaded=!0,r.exports}var o={};return t.m=e,t.c=o,t.p="",t(0)}([function(e,t,o){e.exports=o(4);},function(e,t,o){e.exports=o(6)();},function(t,o){t.exports=e;},function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e,t){return decodeURIComponent(e.replace(new RegExp("^(?:.*[&\\?]"+encodeURIComponent(t).replace(/[\.\+\*]/g,"\\$&")+"(?:\\=([^&]*))?)?.*$","i"),"$1"))};},function(e,t,o){function n(e){return e&&e.__esModule?e:{"default":e}}function r(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function i(e,t){if(!e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return !t||"object"!=typeof t&&"function"!=typeof t?e:t}function s(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function, not "+typeof t);e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}}),t&&(Object.setPrototypeOf?Object.setPrototypeOf(e,t):e.__proto__=t);}Object.defineProperty(t,"__esModule",{value:!0});var a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n]);}return e},c=function(){function e(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}return function(t,o,n){return o&&e(t.prototype,o),n&&e(t,n),t}}(),u=o(2),d=n(u),l=o(1),p=n(l),f=o(5),b=n(f),y=o(3),h=n(y),g=function(){var e=!1;try{e=!!(window.navigator&&window.navigator.standalone||navigator.userAgent.match("CriOS")||navigator.userAgent.match(/mobile/i));}catch(t){}return e},k=function(e){function t(){var e,o,n,s;r(this,t);for(var c=arguments.length,u=Array(c),d=0;d<c;d++)u[d]=arguments[d];return o=n=i(this,(e=t.__proto__||Object.getPrototypeOf(t)).call.apply(e,[this].concat(u))),n.state={isSdkLoaded:!1,isProcessing:!1},n.responseApi=function(e){window.FB.api("/me",{locale:n.props.language,fields:n.props.fields},function(t){a(t,e),n.props.callback(t);});},n.checkLoginState=function(e){n.setStateIfMounted({isProcessing:!1}),e.authResponse?n.responseApi(e.authResponse):n.props.onFailure?n.props.onFailure({status:e.status}):n.props.callback({status:e.status});},n.checkLoginAfterRefresh=function(e){"connected"===e.status?n.checkLoginState(e):window.FB.login(function(e){return n.checkLoginState(e)},!0);},n.click=function(e){if(n.state.isSdkLoaded&&!n.state.isProcessing&&!n.props.isDisabled){n.setState({isProcessing:!0});var t=n.props,o=t.scope,r=t.appId,i=t.onClick,s=t.returnScopes,a=t.responseType,c=t.redirectUri,u=t.disableMobileRedirect,d=t.authType,l=t.state;if("function"!=typeof i||(i(e),!e.defaultPrevented)){var p={client_id:r,redirect_uri:c,state:l,return_scopes:s,scope:o,response_type:a,auth_type:d};if(n.props.isMobile&&!u)window.location.href="https://www.facebook.com/dialog/oauth"+(0, b["default"])(p);else {if(!window.FB)return void(n.props.onFailure&&n.props.onFailure({status:"facebookNotLoaded"}));window.FB.login(n.checkLoginState,{scope:o,return_scopes:s,auth_type:p.auth_type});}}}},s=o,i(n,s)}return s(t,e),c(t,[{key:"componentDidMount",value:function(){if(this._isMounted=!0,document.getElementById("facebook-jssdk"))return void this.sdkLoaded();this.setFbAsyncInit(),this.loadSdkAsynchronously();var e=document.getElementById("fb-root");e||(e=document.createElement("div"),e.id="fb-root",document.body.appendChild(e));}},{key:"componentWillReceiveProps",value:function(e){this.state.isSdkLoaded&&e.autoLoad&&!this.props.autoLoad&&window.FB.getLoginStatus(this.checkLoginAfterRefresh);}},{key:"componentWillUnmount",value:function(){this._isMounted=!1;}},{key:"setStateIfMounted",value:function(e){this._isMounted&&this.setState(e);}},{key:"setFbAsyncInit",value:function(){var e=this,t=this.props,o=t.appId,n=t.xfbml,r=t.cookie,i=t.version,s=t.autoLoad;window.fbAsyncInit=function(){window.FB.init({version:"v"+i,appId:o,xfbml:n,cookie:r}),e.setStateIfMounted({isSdkLoaded:!0}),(s||e.isRedirectedFromFb())&&window.FB.getLoginStatus(e.checkLoginAfterRefresh);};}},{key:"isRedirectedFromFb",value:function(){var e=window.location.search;return (0, h["default"])(e,"code")||(0, h["default"])(e,"granted_scopes")}},{key:"sdkLoaded",value:function(){this.setState({isSdkLoaded:!0});}},{key:"loadSdkAsynchronously",value:function(){var e=this.props.language;!function(t,o,n){var r=t.getElementsByTagName(o)[0],i=r,s=r;t.getElementById(n)||(s=t.createElement(o),s.id=n,s.src="https://connect.facebook.net/"+e+"/sdk.js",i.parentNode.insertBefore(s,i));}(document,"script","facebook-jssdk");}},{key:"render",value:function o(){var o=this.props.render;if(!o)throw new Error("ReactFacebookLogin requires a render prop to render");var e={onClick:this.click,isDisabled:!!this.props.isDisabled,isProcessing:this.state.isProcessing,isSdkLoaded:this.state.isSdkLoaded};return this.props.render(e)}}]),t}(d["default"].Component);k.propTypes={isDisabled:p["default"].bool,callback:p["default"].func.isRequired,appId:p["default"].string.isRequired,xfbml:p["default"].bool,cookie:p["default"].bool,authType:p["default"].string,scope:p["default"].string,state:p["default"].string,responseType:p["default"].string,returnScopes:p["default"].bool,redirectUri:p["default"].string,autoLoad:p["default"].bool,disableMobileRedirect:p["default"].bool,isMobile:p["default"].bool,fields:p["default"].string,version:p["default"].string,language:p["default"].string,onClick:p["default"].func,onFailure:p["default"].func,render:p["default"].func.isRequired},k.defaultProps={redirectUri:"undefined"!=typeof window?window.location.href:"/",scope:"public_profile,email",returnScopes:!1,xfbml:!1,cookie:!1,authType:"",fields:"name",version:"2.3",language:"en_US",disableMobileRedirect:!1,isMobile:g(),onFailure:null,state:"facebookdirect",responseType:"code"},t["default"]=k;},function(e,t){Object.defineProperty(t,"__esModule",{value:!0}),t["default"]=function(e){return "?"+Object.keys(e).map(function(t){return t+"="+encodeURIComponent(e[t])}).join("&")};},function(e,t,o){function n(){}var r=o(7);e.exports=function(){function e(e,t,o,n,i,s){if(s!==r){var a=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw a.name="Invariant Violation",a}}function t(){return e}e.isRequired=e;var o={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t};return o.checkPropTypes=n,o.PropTypes=o,o};},function(e,t){var o="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";e.exports=o;}])});
});

var FacebookLogin = unwrapExports(facebookLoginRenderProps);
facebookLoginRenderProps.FacebookLogin;

const initialState$m = {
  email: "",
  password: "",
  firstName: "",
  lastName: "",
  phone: "",
  emailError: null,
  passwordError: null,
  confirmPassword: "",
  confirmPasswordError: null,
  confirmPasswordUsed: false,
  buttonDisabled: false,
  firstNameError: null,
  lastNameError: null,
  phoneError: null,
  selectFields: {},
  alert: {
    type: "error",
    content: ""
  }
};
const store$m = /*#__PURE__*/createContext(initialState$m);
const {
  Provider: Provider$m
} = store$m;
const RegisterContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    onDisplay = () => {},
    children
  } = _ref;
  useEffect(() => {
    onDisplay();
  }, []);
  const handleRegister = (userData, dispatch) => {
    const filteredData = cleanObjectNullValues(userData);
    const {
      email,
      password,
      firstName,
      lastName,
      phone,
      organization,
      jobTitle,
      selectFields
    } = filteredData;
    if (!hasSecurityTokenEnabled$1()) {
      sendRegisterRequest();
      return;
    }
    window.grecaptcha.enterprise.ready(async () => {
      var _window$Pelcro$site$r;
      const token = await window.grecaptcha.enterprise.execute((_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.security_key, {
        action: "register"
      });
      sendRegisterRequest(token);
    });
    function sendRegisterRequest(securityToken) {
      window.Pelcro.user.register({
        email,
        password,
        first_name: firstName,
        last_name: lastName,
        phone: phone,
        security_token: securityToken,
        metadata: {
          organization,
          jobTitle,
          ...selectFields
        }
      }, (err, res) => {
        dispatch({
          type: DISABLE_REGISTRATION_BUTTON,
          payload: false
        });
        if (err) {
          var _err$response, _err$response$data;
          let {
            registered_on_other_sites,
            ...errors
          } = err === null || err === void 0 ? void 0 : (_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : _err$response$data.errors;
          err.response.data.errors = {
            ...errors
          };
          dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
          onFailure(err);
        } else {
          onSuccess(res);
        }
      });
    }
  };
  const handleSocialLogin = _ref2 => {
    let {
      idpName,
      idpToken,
      email,
      firstName,
      lastName
    } = _ref2;
    dispatch({
      type: DISABLE_REGISTRATION_BUTTON,
      payload: true
    });
    window.Pelcro.user.idpLogin({
      idp_name: idpName,
      idp_token: idpToken,
      email: email,
      first_name: firstName,
      last_name: lastName
    }, (err, res) => {
      dispatch({
        type: DISABLE_REGISTRATION_BUTTON,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        onSuccess(res);
      }
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SET_SELECT:
        return lib_7({
          ...state,
          selectFields: {
            ...state.selectFields,
            ...action.payload
          }
        });
      case SET_EMAIL:
        return lib_7({
          ...state,
          email: action.payload,
          emailError: null
        });
      case SET_PASSWORD:
        return lib_7({
          ...state,
          password: action.payload,
          passwordError: null
        });
      case SET_FIRST_NAME:
        return lib_7({
          ...state,
          firstName: action.payload,
          firstNameError: null
        });
      case SET_LAST_NAME:
        return lib_7({
          ...state,
          lastName: action.payload,
          lastNameError: null
        });
      case SET_PHONE:
        return lib_7({
          ...state,
          phone: action.payload,
          phoneError: null
        });
      case SET_TEXT_FIELD:
        return lib_7({
          ...state,
          ...action.payload
        });
      case SET_CONFIRM_PASSWORD:
        return lib_7({
          ...state,
          confirmPassword: action.payload,
          confirmPasswordError: null
        });
      case SET_EMAIL_ERROR:
        return lib_7({
          ...state,
          emailError: action.payload,
          email: ""
        });
      case SET_PASSWORD_ERROR:
        return lib_7({
          ...state,
          passwordError: action.payload,
          password: ""
        });
      case SET_FIRST_NAME_ERROR:
        return lib_7({
          ...state,
          firstNameError: action.payload,
          firstName: ""
        });
      case SET_LAST_NAME_ERROR:
        return lib_7({
          ...state,
          lastNameError: action.payload,
          lastName: ""
        });
      case SET_PHONE_ERROR:
        return lib_7({
          ...state,
          phoneError: action.payload,
          phone: null
        });
      case SET_CONFIRM_PASSWORD_ERROR:
        return lib_7({
          ...state,
          confirmPasswordError: action.payload,
          confirmPassword: ""
        });
      case CONFIRM_PASSWORD_USED:
        return lib_7({
          ...state,
          confirmPasswordUsed: action.payload
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case RESET_LOGIN_FORM:
        return initialState$m;
      case DISABLE_REGISTRATION_BUTTON:
        return lib_7({
          ...state,
          buttonDisabled: action.payload
        });
      case HANDLE_REGISTRATION:
        return lib_5({
          ...state,
          buttonDisabled: true
        }, (state, dispatch) => handleRegister(state, dispatch));
      case HANDLE_SOCIAL_LOGIN:
        return lib_4(() => handleSocialLogin(action.payload));
      default:
        return state;
    }
  }, initialState$m);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-register-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$m, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => {
    if (child) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        store: store$m,
        key: i
      });
    }
  }) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$m
  })));
};

/**
 * Checks if the current site has security token enabled
 * @return {boolean}
 */
function hasSecurityTokenEnabled$1() {
  var _window$Pelcro$site$r2;
  const hasSecuritySdkLoaded = Boolean((_window$Pelcro$site$r2 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r2 === void 0 ? void 0 : _window$Pelcro$site$r2.security_key);
  return hasSecuritySdkLoaded;
}

var _path$s;
function _extends$u() { _extends$u = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$u.apply(this, arguments); }
function SvgFacebookLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$u({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "88.428 12.828 107.543 207.085"
  }, props), _path$s || (_path$s = /*#__PURE__*/React.createElement("path", {
    d: "M158.232 219.912v-94.461h31.707l4.747-36.813h-36.454V65.134c0-10.658 2.96-17.922 18.245-17.922l19.494-.009V14.278c-3.373-.447-14.944-1.449-28.406-1.449-28.106 0-47.348 17.155-47.348 48.661v27.149H88.428v36.813h31.788v94.461l38.016-.001z",
    fill: "#3c5a9a"
  })));
}

const FacebookLoginButton = _ref => {
  var _window$Pelcro$site$r;
  let {
    label = "Facebook",
    className = "",
    labelClassName = "",
    iconClassName = ""
  } = _ref;
  const facebookLoginEnabled = (_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.facebook_app_id;
  const {
    dispatch: loginDispatch
  } = useContext(store$n);
  const {
    dispatch: registerDispatch
  } = useContext(store$m);
  const onSuccess = facebookUser => {
    loginDispatch === null || loginDispatch === void 0 ? void 0 : loginDispatch({
      type: HANDLE_SOCIAL_LOGIN,
      payload: {
        idpName: "facebook",
        idpToken: facebookUser === null || facebookUser === void 0 ? void 0 : facebookUser.accessToken,
        email: facebookUser === null || facebookUser === void 0 ? void 0 : facebookUser.email,
        firstName: facebookUser === null || facebookUser === void 0 ? void 0 : facebookUser.first_name,
        lastName: facebookUser === null || facebookUser === void 0 ? void 0 : facebookUser.last_name
      }
    });
    registerDispatch === null || registerDispatch === void 0 ? void 0 : registerDispatch({
      type: HANDLE_SOCIAL_LOGIN,
      payload: {
        idpName: "facebook",
        idpToken: facebookUser === null || facebookUser === void 0 ? void 0 : facebookUser.accessToken,
        email: facebookUser === null || facebookUser === void 0 ? void 0 : facebookUser.email,
        firstName: facebookUser === null || facebookUser === void 0 ? void 0 : facebookUser.first_name,
        lastName: facebookUser === null || facebookUser === void 0 ? void 0 : facebookUser.last_name
      }
    });
  };
  const onFailure = error => {
    console.error(error);
  };
  return facebookLoginEnabled ? /*#__PURE__*/React__default.createElement(FacebookLogin, {
    appId: window.Pelcro.site.read().facebook_app_id,
    language: getPageOrDefaultLanguage(),
    fields: "first_name,last_name,email,picture",
    callback: onSuccess,
    onFailure: onFailure,
    render: renderProps => /*#__PURE__*/React__default.createElement("button", {
      onClick: renderProps.onClick,
      className: `plc-flex plc-items-center plc-justify-center plc-p-3 plc-space-x-3 plc-text-gray-700 plc-border plc-border-gray-200 plc-rounded-3xl hover:plc-bg-gray-200 pelcro-facebook-login ${className}`
    }, /*#__PURE__*/React__default.createElement(SvgFacebookLogo, {
      className: `plc-w-3 plc-h-auto pelcro-facebook-login-icon ${iconClassName}`
    }), /*#__PURE__*/React__default.createElement("p", {
      className: `pelcro-facebook-login-label ${labelClassName}`
    }, label))
  }) : null;
};

var googleLogin = createCommonjsModule(function (module, exports) {
!function(e,t){module.exports=t(React__default);}("undefined"!=typeof self?self:commonjsGlobal,(function(e){return o={},t.m=n=[function(t){t.exports=e;},function(e,t,n){e.exports=n(2)();},function(e,t,n){function o(){}function r(){}var i=n(3);r.resetWarningCache=o,e.exports=function(){function e(e,t,n,o,r,a){if(a!==i){var c=Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw c.name="Invariant Violation",c}}function t(){return e}var n={array:e.isRequired=e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:r,resetWarningCache:o};return n.PropTypes=n};},function(e){e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";},function(e,t,n){function o(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e;}finally{try{o||null==c.return||c.return();}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return r(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return "Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?r(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function r(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function i(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e;}finally{try{o||null==c.return||c.return();}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return a(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return "Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?a(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function a(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function c(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e;}finally{try{o||null==c.return||c.return();}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return u(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return "Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?u(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function u(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function l(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(e)){var n=[],o=!0,r=!1,i=void 0;try{for(var a,c=e[Symbol.iterator]();!(o=(a=c.next()).done)&&(n.push(a.value),!t||n.length!==t);o=!0);}catch(e){r=!0,i=e;}finally{try{o||null==c.return||c.return();}finally{if(r)throw i}}return n}}(e,t)||function(e,t){if(e){if("string"==typeof e)return s(e,t);var n=Object.prototype.toString.call(e).slice(8,-1);return "Object"===n&&e.constructor&&(n=e.constructor.name),"Map"===n||"Set"===n?Array.from(n):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?s(e,t):void 0}}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function s(e,t){null!=t&&t<=e.length||(t=e.length);for(var n=0,o=Array(t);n<t;n++)o[n]=e[n];return o}function f(e,t,n,o,r,i){var a=e.getElementsByTagName(t)[0],c=a,u=a;(u=e.createElement(t)).id=n,u.src=o,c&&c.parentNode?c.parentNode.insertBefore(u,c):e.head.appendChild(u),u.onerror=i,u.onload=r;}function d(e,t){var n=e.getElementById(t);n&&n.parentNode.removeChild(n);}function p(e){return b.a.createElement("span",{style:{paddingRight:10,fontWeight:500,paddingLeft:e.icon?0:10,paddingTop:10,paddingBottom:10}},e.children)}function g(e){return b.a.createElement("div",{style:{marginRight:10,background:e.active?"#eee":"#fff",padding:10,borderRadius:2}},b.a.createElement("svg",{width:"18",height:"18",xmlns:"http://www.w3.org/2000/svg"},b.a.createElement("g",{fill:"#000",fillRule:"evenodd"},b.a.createElement("path",{d:"M9 3.48c1.69 0 2.83.73 3.48 1.34l2.54-2.48C13.46.89 11.43 0 9 0 5.48 0 2.44 2.02.96 4.96l2.91 2.26C4.6 5.05 6.62 3.48 9 3.48z",fill:"#EA4335"}),b.a.createElement("path",{d:"M17.64 9.2c0-.74-.06-1.28-.19-1.84H9v3.34h4.96c-.1.83-.64 2.08-1.84 2.92l2.84 2.2c1.7-1.57 2.68-3.88 2.68-6.62z",fill:"#4285F4"}),b.a.createElement("path",{d:"M3.88 10.78A5.54 5.54 0 0 1 3.58 9c0-.62.11-1.22.29-1.78L.96 4.96A9.008 9.008 0 0 0 0 9c0 1.45.35 2.82.96 4.04l2.92-2.26z",fill:"#FBBC05"}),b.a.createElement("path",{d:"M9 18c2.43 0 4.47-.8 5.96-2.18l-2.84-2.2c-.76.53-1.78.9-3.12.9-2.38 0-4.4-1.57-5.12-3.74L.97 13.04C2.45 15.98 5.48 18 9 18z",fill:"#34A853"}),b.a.createElement("path",{fill:"none",d:"M0 0h18v18H0z"}))))}function y(e){var t=i(Object(m.useState)(!1),2),n=t[0],o=t[1],r=i(Object(m.useState)(!1),2),a=r[0],c=r[1],u=e.tag,l=e.type,s=e.className,f=e.disabledStyle,d=e.buttonText,y=e.children,v=e.render,S=e.theme,j=e.icon,O=e.disabled,x=h({onSuccess:e.onSuccess,onAutoLoadFinished:e.onAutoLoadFinished,onRequest:e.onRequest,onFailure:e.onFailure,onScriptLoadFailure:e.onScriptLoadFailure,clientId:e.clientId,cookiePolicy:e.cookiePolicy,loginHint:e.loginHint,hostedDomain:e.hostedDomain,autoLoad:e.autoLoad,isSignedIn:e.isSignedIn,fetchBasicProfile:e.fetchBasicProfile,redirectUri:e.redirectUri,discoveryDocs:e.discoveryDocs,uxMode:e.uxMode,scope:e.scope,accessType:e.accessType,responseType:e.responseType,jsSrc:e.jsSrc,prompt:e.prompt}),I=x.signIn,w=O||!x.loaded;if(v)return v({onClick:I,disabled:w});var k={backgroundColor:"dark"===S?"rgb(66, 133, 244)":"#fff",display:"inline-flex",alignItems:"center",color:"dark"===S?"#fff":"rgba(0, 0, 0, .54)",boxShadow:"0 2px 2px 0 rgba(0, 0, 0, .24), 0 0 1px 0 rgba(0, 0, 0, .24)",padding:0,borderRadius:2,border:"1px solid transparent",fontSize:14,fontWeight:"500",fontFamily:"Roboto, sans-serif"},A={cursor:"pointer",backgroundColor:"dark"===S?"#3367D6":"#eee",color:"dark"===S?"#fff":"rgba(0, 0, 0, .54)",opacity:1},_=w?Object.assign({},k,f):a?Object.assign({},k,A):n?Object.assign({},k,{cursor:"pointer",opacity:.9}):k;return b.a.createElement(u,{onMouseEnter:function(){return o(!0)},onMouseLeave:function(){o(!1),c(!1);},onMouseDown:function(){return c(!0)},onMouseUp:function(){return c(!1)},onClick:I,style:_,type:l,disabled:w,className:s},[j&&b.a.createElement(g,{key:1,active:a}),b.a.createElement(p,{icon:j,key:2},y||d)])}n.r(t),n.d(t,"default",(function(){return S})),n.d(t,"GoogleLogin",(function(){return S})),n.d(t,"GoogleLogout",(function(){return O})),n.d(t,"useGoogleLogin",(function(){return h})),n.d(t,"useGoogleLogout",(function(){return j}));var m=n(0),b=n.n(m),h=(n(1),function(e){function t(e){var t=e.getBasicProfile(),n=e.getAuthResponse(!0);e.googleId=t.getId(),e.tokenObj=n,e.tokenId=n.id_token,e.accessToken=n.access_token,e.profileObj={googleId:t.getId(),imageUrl:t.getImageUrl(),email:t.getEmail(),name:t.getName(),givenName:t.getGivenName(),familyName:t.getFamilyName()},i(e);}function n(e){if(e&&e.preventDefault(),P){var n=window.gapi.auth2.getAuthInstance(),o={prompt:L};p(),"code"===_?n.grantOfflineAccess(o).then((function(e){return i(e)}),(function(e){return l(e)})):n.signIn(o).then((function(e){return t(e)}),(function(e){return l(e)}));}}var r=e.onSuccess,i=void 0===r?function(){}:r,a=e.onAutoLoadFinished,c=void 0===a?function(){}:a,u=e.onFailure,l=void 0===u?function(){}:u,s=e.onRequest,p=void 0===s?function(){}:s,g=e.onScriptLoadFailure,y=e.clientId,b=e.cookiePolicy,h=e.loginHint,v=e.hostedDomain,S=e.autoLoad,j=e.isSignedIn,O=e.fetchBasicProfile,x=e.redirectUri,I=e.discoveryDocs,w=e.uxMode,k=e.scope,A=e.accessType,_=e.responseType,E=e.jsSrc,T=void 0===E?"https://apis.google.com/js/api.js":E,L=e.prompt,M=o(Object(m.useState)(!1),2),P=M[0],C=M[1];return Object(m.useEffect)((function(){var e=!1,n=g||l;return f(document,"script","google-login",T,(function(){var o={client_id:y,cookie_policy:b,login_hint:h,hosted_domain:v,fetch_basic_profile:O,discoveryDocs:I,ux_mode:w,redirect_uri:x,scope:k,access_type:A};"code"===_&&(o.access_type="offline"),window.gapi.load("auth2",(function(){var r=window.gapi.auth2.getAuthInstance();r?r.then((function(){e||(j&&r.isSignedIn.get()?(C(!0),c(!0),t(r.currentUser.get())):(C(!0),c(!1)));}),(function(e){l(e);})):window.gapi.auth2.init(o).then((function(n){if(!e){C(!0);var o=j&&n.isSignedIn.get();c(o),o&&t(n.currentUser.get());}}),(function(e){C(!0),c(!1),n(e);}));}));}),(function(e){n(e);})),function(){e=!0,d(document,"google-login");}}),[]),Object(m.useEffect)((function(){S&&n();}),[P]),{signIn:n,loaded:P}});function v(e){var t=l(Object(m.useState)(!1),2),n=t[0],o=t[1],r=l(Object(m.useState)(!1),2),i=r[0],a=r[1],c=e.tag,u=e.type,s=e.className,f=e.disabledStyle,d=e.buttonText,y=e.children,h=e.render,v=e.theme,S=e.icon,O=e.disabled,x=j({jsSrc:e.jsSrc,onFailure:e.onFailure,onScriptLoadFailure:e.onScriptLoadFailure,clientId:e.clientId,cookiePolicy:e.cookiePolicy,loginHint:e.loginHint,hostedDomain:e.hostedDomain,fetchBasicProfile:e.fetchBasicProfile,discoveryDocs:e.discoveryDocs,uxMode:e.uxMode,redirectUri:e.redirectUri,scope:e.scope,accessType:e.accessType,onLogoutSuccess:e.onLogoutSuccess}),I=x.signOut,w=O||!x.loaded;if(h)return h({onClick:I,disabled:w});var k={backgroundColor:"dark"===v?"rgb(66, 133, 244)":"#fff",display:"inline-flex",alignItems:"center",color:"dark"===v?"#fff":"rgba(0, 0, 0, .54)",boxShadow:"0 2px 2px 0 rgba(0, 0, 0, .24), 0 0 1px 0 rgba(0, 0, 0, .24)",padding:0,borderRadius:2,border:"1px solid transparent",fontSize:14,fontWeight:"500",fontFamily:"Roboto, sans-serif"},A={cursor:"pointer",backgroundColor:"dark"===v?"#3367D6":"#eee",color:"dark"===v?"#fff":"rgba(0, 0, 0, .54)",opacity:1},_=w?Object.assign({},k,f):i?Object.assign({},k,A):n?Object.assign({},k,{cursor:"pointer",opacity:.9}):k;return b.a.createElement(c,{onMouseEnter:function(){return o(!0)},onMouseLeave:function(){o(!1),a(!1);},onMouseDown:function(){return a(!0)},onMouseUp:function(){return a(!1)},onClick:I,style:_,type:u,disabled:w,className:s},[S&&b.a.createElement(g,{key:1,active:i}),b.a.createElement(p,{icon:S,key:2},y||d)])}y.defaultProps={type:"button",tag:"button",buttonText:"Sign in with Google",scope:"profile email",accessType:"online",prompt:"",cookiePolicy:"single_host_origin",fetchBasicProfile:!0,isSignedIn:!1,uxMode:"popup",disabledStyle:{opacity:.6},icon:!0,theme:"light",onRequest:function(){}};var S=y,j=function(e){var t=e.jsSrc,n=void 0===t?"https://apis.google.com/js/api.js":t,o=e.onFailure,r=e.onScriptLoadFailure,i=e.clientId,a=e.cookiePolicy,u=e.loginHint,l=e.hostedDomain,s=e.fetchBasicProfile,p=e.discoveryDocs,g=e.uxMode,y=e.redirectUri,b=e.scope,h=e.accessType,v=e.onLogoutSuccess,S=c(Object(m.useState)(!1),2),j=S[0],O=S[1],x=Object(m.useCallback)((function(){if(window.gapi){var e=window.gapi.auth2.getAuthInstance();null!=e&&e.then((function(){e.signOut().then((function(){e.disconnect(),v();}));}),(function(e){return o(e)}));}}),[v]);return Object(m.useEffect)((function(){var e=r||o;return f(document,"script","google-login",n,(function(){var t={client_id:i,cookie_policy:a,login_hint:u,hosted_domain:l,fetch_basic_profile:s,discoveryDocs:p,ux_mode:g,redirect_uri:y,scope:b,access_type:h};window.gapi.load("auth2",(function(){window.gapi.auth2.getAuthInstance()?O(!0):window.gapi.auth2.init(t).then((function(){return O(!0)}),(function(t){return e(t)}));}));}),(function(t){e(t);})),function(){d(document,"google-login");}}),[]),{signOut:x,loaded:j}};v.defaultProps={type:"button",tag:"button",buttonText:"Logout of Google",disabledStyle:{opacity:.6},icon:!0,theme:"light",jsSrc:"https://apis.google.com/js/api.js"};var O=v;}],t.c=o,t.d=function(e,n,o){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:o});},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var o=Object.create(null);if(t.r(o),Object.defineProperty(o,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var r in e)t.d(o,r,function(t){return e[t]}.bind(null,r));return o},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="",t(t.s=4);function t(e){if(o[e])return o[e].exports;var r=o[e]={i:e,l:!1,exports:{}};return n[e].call(r.exports,r,r.exports,t),r.l=!0,r.exports}var n,o;}));
});

unwrapExports(googleLogin);
var googleLogin_1 = googleLogin.GoogleLogin;

var _path$r, _path2$2, _path3$1, _path4;
function _extends$t() { _extends$t = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$t.apply(this, arguments); }
function SvgGoogleLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$t({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$r || (_path$r = /*#__PURE__*/React.createElement("path", {
    fill: "#4285F4",
    d: "M23.745 12.27c0-.79-.07-1.54-.19-2.27h-11.3v4.51h6.47c-.29 1.48-1.14 2.73-2.4 3.58v3h3.86c2.26-2.09 3.56-5.17 3.56-8.82z"
  })), _path2$2 || (_path2$2 = /*#__PURE__*/React.createElement("path", {
    fill: "#34A853",
    d: "M12.255 24c3.24 0 5.95-1.08 7.93-2.91l-3.86-3c-1.08.72-2.45 1.16-4.07 1.16-3.13 0-5.78-2.11-6.73-4.96h-3.98v3.09C3.515 21.3 7.565 24 12.255 24z"
  })), _path3$1 || (_path3$1 = /*#__PURE__*/React.createElement("path", {
    fill: "#FBBC05",
    d: "M5.525 14.29c-.25-.72-.38-1.49-.38-2.29s.14-1.57.38-2.29V6.62h-3.98a11.86 11.86 0 000 10.76l3.98-3.09z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#EA4335",
    d: "M12.255 4.75c1.77 0 3.35.61 4.6 1.8l3.42-3.42C18.205 1.19 15.495 0 12.255 0c-4.69 0-8.74 2.7-10.71 6.62l3.98 3.09c.95-2.85 3.6-4.96 6.73-4.96z"
  })));
}

var gapi=window.gapi=window.gapi||{};gapi._bs=new Date().getTime();(function(){/*

  Copyright The Closure Library Authors.
  SPDX-License-Identifier: Apache-2.0
 */
 var aa="function"==typeof Object.defineProperties?Object.defineProperty:function(a,b,c){if(a==Array.prototype||a==Object.prototype)return a;a[b]=c.value;return a},da=function(a){a=["object"==typeof globalThis&&globalThis,a,"object"==typeof window&&window,"object"==typeof self&&self,"object"==typeof global&&global];for(var b=0;b<a.length;++b){var c=a[b];if(c&&c.Math==Math)return c}throw Error("Cannot find global object");},ea=da(this),fa=function(a,b){if(b)a:{var c=ea;a=a.split(".");for(var d=0;d<
 a.length-1;d++){var e=a[d];if(!(e in c))break a;c=c[e];}a=a[a.length-1];d=c[a];b=b(d);b!=d&&null!=b&&aa(c,a,{configurable:!0,writable:!0,value:b});}},ha=function(a){var b=0;return function(){return b<a.length?{done:!1,value:a[b++]}:{done:!0}}};
 fa("Symbol",function(a){if(a)return a;var b=function(e,f){this.ba=e;aa(this,"description",{configurable:!0,writable:!0,value:f});};b.prototype.toString=function(){return this.ba};var c=0,d=function(e){if(this instanceof d)throw new TypeError("Symbol is not a constructor");return new b("jscomp_symbol_"+(e||"")+"_"+c++,e)};return d});
 fa("Symbol.iterator",function(a){if(a)return a;a=Symbol("Symbol.iterator");for(var b="Array Int8Array Uint8Array Uint8ClampedArray Int16Array Uint16Array Int32Array Uint32Array Float32Array Float64Array".split(" "),c=0;c<b.length;c++){var d=ea[b[c]];"function"===typeof d&&"function"!=typeof d.prototype[a]&&aa(d.prototype,a,{configurable:!0,writable:!0,value:function(){return ia(ha(this))}});}return a});
 var ia=function(a){a={next:a};a[Symbol.iterator]=function(){return this};return a},ja=function(a,b){a instanceof String&&(a+="");var c=0,d=!1,e={next:function(){if(!d&&c<a.length){var f=c++;return {value:b(f,a[f]),done:!1}}d=!0;return {done:!0,value:void 0}}};e[Symbol.iterator]=function(){return e};return e};fa("Array.prototype.keys",function(a){return a?a:function(){return ja(this,function(b){return b})}});
 var m=this||self,ka=function(a){var b=typeof a;return "object"!=b?b:a?Array.isArray(a)?"array":b:"null"},la=function(a,b,c){return a.call.apply(a.bind,arguments)},ma=function(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var e=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(e,d);return a.apply(b,e)}}return function(){return a.apply(b,arguments)}},na=function(a,b,c){na=Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?
 la:ma;return na.apply(null,arguments)},oa=function(a,b){function c(){}c.prototype=b.prototype;a.ma=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.A=function(d,e,f){for(var g=Array(arguments.length-2),h=2;h<arguments.length;h++)g[h-2]=arguments[h];return b.prototype[e].apply(d,g)};},pa=function(a){return a},qa=function(a){var b=null,c=m.trustedTypes;if(!c||!c.createPolicy)return b;try{b=c.createPolicy(a,{createHTML:pa,createScript:pa,createScriptURL:pa});}catch(d){m.console&&m.console.error(d.message);}return b};function q(a){if(Error.captureStackTrace)Error.captureStackTrace(this,q);else {var b=Error().stack;b&&(this.stack=b);}a&&(this.message=String(a));}oa(q,Error);q.prototype.name="CustomError";var ra=function(a,b){a=a.split("%s");for(var c="",d=a.length-1,e=0;e<d;e++)c+=a[e]+(e<b.length?b[e]:"%s");q.call(this,c+a[d]);};oa(ra,q);ra.prototype.name="AssertionError";
 var sa=function(a,b,c,d){var e="Assertion failed";if(c){e+=": "+c;var f=d;}else a&&(e+=": "+a,f=b);throw new ra(""+e,f||[]);},ta=function(a,b,c){a||sa("",null,b,Array.prototype.slice.call(arguments,2));return a},ua=function(a,b){throw new ra("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));},va=function(a,b,c){"string"!==typeof a&&sa("Expected string but got %s: %s.",[ka(a),a],b,Array.prototype.slice.call(arguments,2));};var xa=function(a,b){a:{try{var c=a&&a.ownerDocument,d=c&&(c.defaultView||c.parentWindow);d=d||m;if(d.Element&&d.Location){var e=d;break a}}catch(g){}e=null;}if(e&&"undefined"!=typeof e[b]&&(!a||!(a instanceof e[b])&&(a instanceof e.Location||a instanceof e.Element))){e=typeof a;if("object"==e&&null!=a||"function"==e)try{var f=a.constructor.displayName||a.constructor.name||Object.prototype.toString.call(a);}catch(g){f="<object could not be stringified>";}else f=void 0===a?"undefined":null===a?"null":
 typeof a;ua("Argument is not a %s (or a non-Element, non-Location mock); got: %s",b,f);}return a};var ya;var t=function(a,b){this.P=a===za&&b||"";this.ca=Aa;};t.prototype.J=!0;t.prototype.H=function(){return this.P};t.prototype.toString=function(){return "Const{"+this.P+"}"};var Ba=function(a){if(a instanceof t&&a.constructor===t&&a.ca===Aa)return a.P;ua("expected object of type Const, got '"+a+"'");return "type_error:Const"},Aa={},za={};var v=function(a,b){this.N=b===Ca?a:"";};v.prototype.J=!0;v.prototype.H=function(){return this.N.toString()};v.prototype.toString=function(){return "SafeUrl{"+this.N+"}"};
 var Da=function(a){if(a instanceof v&&a.constructor===v)return a.N;ua("expected object of type SafeUrl, got '"+a+"' of type "+ka(a));return "type_error:SafeUrl"},Ea=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i,Fa=function(a){if(a instanceof v)return a;a="object"==typeof a&&a.J?a.H():String(a);ta(Ea.test(a),"%s does not match the safe URL pattern",a)||(a="about:invalid#zClosurez");return new v(a,Ca)},Ca={};var w=function(a,b,c){this.M=c===Ga?a:"";};w.prototype.J=!0;w.prototype.H=function(){return this.M.toString()};w.prototype.toString=function(){return "SafeHtml{"+this.M+"}"};var Ha=function(a){if(a instanceof w&&a.constructor===w)return a.M;ua("expected object of type SafeHtml, got '"+a+"' of type "+ka(a));return "type_error:SafeHtml"},Ga={},Ia=new w(m.trustedTypes&&m.trustedTypes.emptyHTML||"",0,Ga);var Ja={MATH:!0,SCRIPT:!0,STYLE:!0,SVG:!0,TEMPLATE:!0},Ka=function(a){var b=!1,c;return function(){b||(c=a(),b=!0);return c}}(function(){if("undefined"===typeof document)return !1;var a=document.createElement("div"),b=document.createElement("div");b.appendChild(document.createElement("div"));a.appendChild(b);if(!a.firstChild)return !1;b=a.firstChild.firstChild;a.innerHTML=Ha(Ia);return !b.parentElement});/*
  gapi.loader.OBJECT_CREATE_TEST_OVERRIDE &&*/
 var x=window,z=document,La=x.location,Ma=function(){},Na=/\[native code\]/,A=function(a,b,c){return a[b]=a[b]||c},Oa=function(a){for(var b=0;b<this.length;b++)if(this[b]===a)return b;return -1},Pa=function(a){a=a.sort();for(var b=[],c=void 0,d=0;d<a.length;d++){var e=a[d];e!=c&&b.push(e);c=e;}return b},Qa=/&/g,Ra=/</g,Sa=/>/g,Ua=/"/g,Va=/'/g,Wa=function(a){return String(a).replace(Qa,"&amp;").replace(Ra,"&lt;").replace(Sa,"&gt;").replace(Ua,"&quot;").replace(Va,"&#39;")},B=function(){var a;if((a=Object.create)&&
 Na.test(a))a=a(null);else {a={};for(var b in a)a[b]=void 0;}return a},C=function(a,b){return Object.prototype.hasOwnProperty.call(a,b)},Xa=function(a){if(Na.test(Object.keys))return Object.keys(a);var b=[],c;for(c in a)C(a,c)&&b.push(c);return b},D=function(a,b){a=a||{};for(var c in a)C(a,c)&&(b[c]=a[c]);},Ya=function(a){return function(){x.setTimeout(a,0);}},E=function(a,b){if(!a)throw Error(b||"");},F=A(x,"gapi",{});var H=function(a,b,c){var d=new RegExp("([#].*&|[#])"+b+"=([^&#]*)","g");b=new RegExp("([?#].*&|[?#])"+b+"=([^&#]*)","g");if(a=a&&(d.exec(a)||b.exec(a)))try{c=decodeURIComponent(a[2]);}catch(e){}return c},Za=new RegExp(/^/.source+/([a-zA-Z][-+.a-zA-Z0-9]*:)?/.source+/(\/\/[^\/?#]*)?/.source+/([^?#]*)?/.source+/(\?([^#]*))?/.source+/(#((#|[^#])*))?/.source+/$/.source),$a=/[\ud800-\udbff][\udc00-\udfff]|[^!-~]/g,ab=new RegExp(/(%([^0-9a-fA-F%]|[0-9a-fA-F]([^0-9a-fA-F%])?)?)*/.source+/%($|[^0-9a-fA-F]|[0-9a-fA-F]($|[^0-9a-fA-F]))/.source,
 "g"),bb=/%([a-f]|[0-9a-fA-F][a-f])/g,cb=/^(https?|ftp|file|chrome-extension):$/i,I=function(a){a=String(a);a=a.replace($a,function(e){try{return encodeURIComponent(e)}catch(f){return encodeURIComponent(e.replace(/^[^%]+$/g,"\ufffd"))}}).replace(ab,function(e){return e.replace(/%/g,"%25")}).replace(bb,function(e){return e.toUpperCase()});a=a.match(Za)||[];var b=B(),c=function(e){return e.replace(/\\/g,"%5C").replace(/\^/g,"%5E").replace(/`/g,"%60").replace(/\{/g,"%7B").replace(/\|/g,"%7C").replace(/\}/g,
 "%7D")},d=!!(a[1]||"").match(cb);b.A=c((a[1]||"")+(a[2]||"")+(a[3]||(a[2]&&d?"/":"")));d=function(e){return c(e.replace(/\?/g,"%3F").replace(/#/g,"%23"))};b.query=a[5]?[d(a[5])]:[];b.g=a[7]?[d(a[7])]:[];return b},db=function(a){return a.A+(0<a.query.length?"?"+a.query.join("&"):"")+(0<a.g.length?"#"+a.g.join("&"):"")},eb=function(a,b){var c=[];if(a)for(var d in a)if(C(a,d)&&null!=a[d]){var e=b?b(a[d]):a[d];c.push(encodeURIComponent(d)+"="+encodeURIComponent(e));}return c},fb=function(a,b,c,d){a=I(a);
 a.query.push.apply(a.query,eb(b,d));a.g.push.apply(a.g,eb(c,d));return db(a)},gb=new RegExp(/\/?\??#?/.source+"("+/[\/?#]/i.source+"|"+/[\uD800-\uDBFF]/i.source+"|"+/%[c-f][0-9a-f](%[89ab][0-9a-f]){0,2}(%[89ab]?)?/i.source+"|"+/%[0-9a-f]?/i.source+")$","i"),hb=function(a,b){var c=I(b);b=c.A;c.query.length&&(b+="?"+c.query.join(""));c.g.length&&(b+="#"+c.g.join(""));var d="";2E3<b.length&&(d=b,b=b.substr(0,2E3),b=b.replace(gb,""),d=d.substr(b.length));var e=a.createElement("div");a=a.createElement("a");
 c=I(b);b=c.A;c.query.length&&(b+="?"+c.query.join(""));c.g.length&&(b+="#"+c.g.join(""));b=new v(b,Ca);xa(a,"HTMLAnchorElement");b=b instanceof v?b:Fa(b);a.href=Da(b);e.appendChild(a);b=e.innerHTML;c=new t(za,"Assignment to self.");va(Ba(c),"must provide justification");ta(!/^[\s\xa0]*$/.test(Ba(c)),"must provide non-empty justification");void 0===ya&&(ya=qa("gapi#html"));b=(c=ya)?c.createHTML(b):b;b=new w(b,null,Ga);if(e.tagName&&Ja[e.tagName.toUpperCase()])throw Error("goog.dom.safe.setInnerHtml cannot be used to set content of "+
 e.tagName+".");if(Ka())for(;e.lastChild;)e.removeChild(e.lastChild);e.innerHTML=Ha(b);b=String(e.firstChild.href);e.parentNode&&e.parentNode.removeChild(e);c=I(b+d);d=c.A;c.query.length&&(d+="?"+c.query.join(""));c.g.length&&(d+="#"+c.g.join(""));return d},ib=/^https?:\/\/[^\/%\\?#\s]+\/[^\s]*$/i;var jb=function(a,b,c,d){if(x[c+"EventListener"])x[c+"EventListener"](a,b,!1);else if(x[d+"tachEvent"])x[d+"tachEvent"]("on"+a,b);},kb=function(){var a=z.readyState;return "complete"===a||"interactive"===a&&-1==navigator.userAgent.indexOf("MSIE")},nb=function(a){var b=lb;if(!kb())try{b();}catch(c){}mb(a);},mb=function(a){if(kb())a();else {var b=!1,c=function(){if(!b)return b=!0,a.apply(this,arguments)};x.addEventListener?(x.addEventListener("load",c,!1),x.addEventListener("DOMContentLoaded",c,!1)):x.attachEvent&&
 (x.attachEvent("onreadystatechange",function(){kb()&&c.apply(this,arguments);}),x.attachEvent("onload",c));}},ob=function(a){for(;a.firstChild;)a.removeChild(a.firstChild);},pb={button:!0,div:!0,span:!0};var K;K=A(x,"___jsl",B());A(K,"I",0);A(K,"hel",10);var qb=function(a){return K.dpo?K.h:H(a,"jsh",K.h)},rb=function(a){var b=A(K,"sws",[]);b.push.apply(b,a);},sb=function(a){return A(K,"watt",B())[a]},tb=function(a){var b=A(K,"PQ",[]);K.PQ=[];var c=b.length;if(0===c)a();else for(var d=0,e=function(){++d===c&&a();},f=0;f<c;f++)b[f](e);},ub=function(a){return A(A(K,"H",B()),a,B())};var vb=A(K,"perf",B()),wb=A(vb,"g",B()),xb=A(vb,"i",B());A(vb,"r",[]);B();B();
 var yb=function(a,b,c){var d=vb.r;"function"===typeof d?d(a,b,c):d.push([a,b,c]);},L=function(a,b,c){wb[a]=!b&&wb[a]||c||(new Date).getTime();yb(a);},Ab=function(a,b,c){b&&0<b.length&&(b=zb(b),c&&0<c.length&&(b+="___"+zb(c)),28<b.length&&(b=b.substr(0,28)+(b.length-28)),c=b,b=A(xb,"_p",B()),A(b,c,B())[a]=(new Date).getTime(),yb(a,"_p",c));},zb=function(a){return a.join("__").replace(/\./g,"_").replace(/\-/g,"_").replace(/,/g,"_")};var Bb=B(),N=[],O=function(a){throw Error("Bad hint"+(a?": "+a:""));};N.push(["jsl",function(a){for(var b in a)if(C(a,b)){var c=a[b];"object"==typeof c?K[b]=A(K,b,[]).concat(c):A(K,b,c);}if(b=a.u)a=A(K,"us",[]),a.push(b),(b=/^https:(.*)$/.exec(b))&&a.push("http:"+b[1]);}]);var Cb=/^(\/[a-zA-Z0-9_\-]+)+$/,Db=[/\/amp\//,/\/amp$/,/^\/amp$/],Eb=/^[a-zA-Z0-9\-_\.,!]+$/,Fb=/^gapi\.loaded_[0-9]+$/,Gb=/^[a-zA-Z0-9,._-]+$/,Kb=function(a,b,c,d){var e=a.split(";"),f=e.shift(),g=Bb[f],h=null;g?h=g(e,b,c,d):O("no hint processor for: "+f);h||O("failed to generate load url");b=h;c=b.match(Hb);(d=b.match(Ib))&&1===d.length&&Jb.test(b)&&c&&1===c.length||O("failed sanity: "+a);return h},Nb=function(a,b,c,d){a=Lb(a);Fb.test(c)||O("invalid_callback");b=Mb(b);d=d&&d.length?Mb(d):null;var e=
 function(f){return encodeURIComponent(f).replace(/%2C/g,",")};return [encodeURIComponent(a.pathPrefix).replace(/%2C/g,",").replace(/%2F/g,"/"),"/k=",e(a.version),"/m=",e(b),d?"/exm="+e(d):"","/rt=j/sv=1/d=1/ed=1",a.S?"/am="+e(a.S):"",a.Z?"/rs="+e(a.Z):"",a.aa?"/t="+e(a.aa):"","/cb=",e(c)].join("")},Lb=function(a){"/"!==a.charAt(0)&&O("relative path");for(var b=a.substring(1).split("/"),c=[];b.length;){a=b.shift();if(!a.length||0==a.indexOf("."))O("empty/relative directory");else if(0<a.indexOf("=")){b.unshift(a);
 break}c.push(a);}a={};for(var d=0,e=b.length;d<e;++d){var f=b[d].split("="),g=decodeURIComponent(f[0]),h=decodeURIComponent(f[1]);2==f.length&&g&&h&&(a[g]=a[g]||h);}b="/"+c.join("/");Cb.test(b)||O("invalid_prefix");c=0;for(d=Db.length;c<d;++c)Db[c].test(b)&&O("invalid_prefix");c=Ob(a,"k",!0);d=Ob(a,"am");e=Ob(a,"rs");a=Ob(a,"t");return {pathPrefix:b,version:c,S:d,Z:e,aa:a}},Mb=function(a){for(var b=[],c=0,d=a.length;c<d;++c){var e=a[c].replace(/\./g,"_").replace(/-/g,"_");Gb.test(e)&&b.push(e);}return b.join(",")},
 Ob=function(a,b,c){a=a[b];!a&&c&&O("missing: "+b);if(a){if(Eb.test(a))return a;O("invalid: "+b);}return null},Jb=/^https?:\/\/[a-z0-9_.-]+\.google(rs)?\.com(:\d+)?\/[a-zA-Z0-9_.,!=\-\/]+$/,Ib=/\/cb=/g,Hb=/\/\//g,Pb=function(){var a=qb(La.href);if(!a)throw Error("Bad hint");return a};Bb.m=function(a,b,c,d){(a=a[0])||O("missing_hint");return "https://apis.google.com"+Nb(a,b,c,d)};var Qb=decodeURI("%73cript"),Rb=/^[-+_0-9\/A-Za-z]+={0,2}$/,Sb=function(a,b){for(var c=[],d=0;d<a.length;++d){var e=a[d];e&&0>Oa.call(b,e)&&c.push(e);}return c},Tb=function(){var a=K.nonce;return void 0!==a?a&&a===String(a)&&a.match(Rb)?a:K.nonce=null:z.querySelector?(a=z.querySelector("script[nonce]"))?(a=a.nonce||a.getAttribute("nonce")||"",a&&a===String(a)&&a.match(Rb)?K.nonce=a:K.nonce=null):null:null},Wb=function(a){if("loading"!=z.readyState)Ub(a);else {var b=Tb(),c="";null!==b&&(c=' nonce="'+
 b+'"');a="<"+Qb+' src="'+encodeURI(a)+'"'+c+"></"+Qb+">";z.write(Vb?Vb.createHTML(a):a);}},Ub=function(a){var b=z.createElement(Qb);b.setAttribute("src",Vb?Vb.createScriptURL(a):a);a=Tb();null!==a&&b.setAttribute("nonce",a);b.async="true";(a=z.getElementsByTagName(Qb)[0])?a.parentNode.insertBefore(b,a):(z.head||z.body||z.documentElement).appendChild(b);},Xb=function(a,b){var c=b&&b._c;if(c)for(var d=0;d<N.length;d++){var e=N[d][0],f=N[d][1];f&&C(c,e)&&f(c[e],a,b);}},Zb=function(a,b,c){Yb(function(){var d=
 b===qb(La.href)?A(F,"_",B()):B();d=A(ub(b),"_",d);a(d);},c);},ac=function(a,b){var c=b||{};"function"==typeof b&&(c={},c.callback=b);Xb(a,c);b=a?a.split(":"):[];var d=c.h||Pb(),e=A(K,"ah",B());if(e["::"]&&b.length){a=[];for(var f=null;f=b.shift();){var g=f.split(".");g=e[f]||e[g[1]&&"ns:"+g[0]||""]||d;var h=a.length&&a[a.length-1]||null,k=h;h&&h.hint==g||(k={hint:g,V:[]},a.push(k));k.V.push(f);}var l=a.length;if(1<l){var n=c.callback;n&&(c.callback=function(){0==--l&&n();});}for(;b=a.shift();)$b(b.V,c,
 b.hint);}else $b(b||[],c,d);},$b=function(a,b,c){a=Pa(a)||[];var d=b.callback,e=b.config,f=b.timeout,g=b.ontimeout,h=b.onerror,k=void 0;"function"==typeof h&&(k=h);var l=null,n=!1;if(f&&!g||!f&&g)throw "Timeout requires both the timeout parameter and ontimeout parameter to be set";h=A(ub(c),"r",[]).sort();var p=A(ub(c),"L",[]).sort(),r=[].concat(h),u=function(M,ba){if(n)return 0;x.clearTimeout(l);p.push.apply(p,y);var ca=((F||{}).config||{}).update;ca?ca(e):e&&A(K,"cu",[]).push(e);if(ba){Ab("me0",M,
 r);try{Zb(ba,c,k);}finally{Ab("me1",M,r);}}return 1};0<f&&(l=x.setTimeout(function(){n=!0;g();},f));var y=Sb(a,p);if(y.length){y=Sb(a,h);var G=A(K,"CP",[]),J=G.length;G[J]=function(M){if(!M)return 0;Ab("ml1",y,r);var ba=function(wa){G[J]=null;u(y,M)&&tb(function(){d&&d();wa();});},ca=function(){var wa=G[J+1];wa&&wa();};0<J&&G[J-1]?G[J]=function(){ba(ca);}:ba(ca);};if(y.length){var Ta="loaded_"+K.I++;F[Ta]=function(M){G[J](M);F[Ta]=null;};a=Kb(c,y,"gapi."+Ta,h);h.push.apply(h,y);Ab("ml0",y,r);b.sync||x.___gapisync?
 Wb(a):Ub(a);}else G[J](Ma);}else u(y)&&d&&d();},Vb=qa("gapi#gapi");var Yb=function(a,b){if(K.hee&&0<K.hel)try{return a()}catch(c){b&&b(c),K.hel--,ac("debug_error",function(){try{window.___jsl.hefn(c);}catch(d){throw c;}});}else try{return a()}catch(c){throw b&&b(c),c;}};F.load=function(a,b){return Yb(function(){return ac(a,b)})};var bc=function(a){var b=window.___jsl=window.___jsl||{};b[a]=b[a]||[];return b[a]},cc=function(a){var b=window.___jsl=window.___jsl||{};b.cfg=!a&&b.cfg||{};return b.cfg},dc=function(a){return "object"===typeof a&&/\[native code\]/.test(a.push)},P=function(a,b,c){if(b&&"object"===typeof b)for(var d in b)!Object.prototype.hasOwnProperty.call(b,d)||c&&"___goc"===d&&"undefined"===typeof b[d]||(a[d]&&b[d]&&"object"===typeof a[d]&&"object"===typeof b[d]&&!dc(a[d])&&!dc(b[d])?P(a[d],b[d]):b[d]&&"object"===
 typeof b[d]?(a[d]=dc(b[d])?[]:{},P(a[d],b[d])):a[d]=b[d]);},ec=function(a){if(a&&!/^\s+$/.test(a)){for(;0==a.charCodeAt(a.length-1);)a=a.substring(0,a.length-1);try{var b=window.JSON.parse(a);}catch(c){}if("object"===typeof b)return b;try{b=(new Function("return ("+a+"\n)"))();}catch(c){}if("object"===typeof b)return b;try{b=(new Function("return ({"+a+"\n})"))();}catch(c){}return "object"===typeof b?b:{}}},fc=function(a,b){var c={___goc:void 0};a.length&&a[a.length-1]&&Object.hasOwnProperty.call(a[a.length-
 1],"___goc")&&"undefined"===typeof a[a.length-1].___goc&&(c=a.pop());P(c,b);a.push(c);},gc=function(a){cc(!0);var b=window.___gcfg,c=bc("cu"),d=window.___gu;b&&b!==d&&(fc(c,b),window.___gu=b);b=bc("cu");var e=document.scripts||document.getElementsByTagName("script")||[];d=[];var f=[];f.push.apply(f,bc("us"));for(var g=0;g<e.length;++g)for(var h=e[g],k=0;k<f.length;++k)h.src&&0==h.src.indexOf(f[k])&&d.push(h);0==d.length&&0<e.length&&e[e.length-1].src&&d.push(e[e.length-1]);for(e=0;e<d.length;++e)d[e].getAttribute("gapi_processed")||
 (d[e].setAttribute("gapi_processed",!0),(f=d[e])?(g=f.nodeType,f=3==g||4==g?f.nodeValue:f.textContent||f.innerText||f.innerHTML||""):f=void 0,(f=ec(f))&&b.push(f));a&&fc(c,a);d=bc("cd");a=0;for(b=d.length;a<b;++a)P(cc(),d[a],!0);d=bc("ci");a=0;for(b=d.length;a<b;++a)P(cc(),d[a],!0);a=0;for(b=c.length;a<b;++a)P(cc(),c[a],!0);},Q=function(a){var b=cc();if(!a)return b;a=a.split("/");for(var c=0,d=a.length;b&&"object"===typeof b&&c<d;++c)b=b[a[c]];return c===a.length&&void 0!==b?b:void 0},hc=function(a,
 b){var c;if("string"===typeof a){var d=c={};a=a.split("/");for(var e=0,f=a.length;e<f-1;++e){var g={};d=d[a[e]]=g;}d[a[e]]=b;}else c=a;gc(c);};var ic=function(){var a=window.__GOOGLEAPIS;a&&(a.googleapis&&!a["googleapis.config"]&&(a["googleapis.config"]=a.googleapis),A(K,"ci",[]).push(a),window.__GOOGLEAPIS=void 0);};var jc={callback:1,clientid:1,cookiepolicy:1,openidrealm:-1,includegrantedscopes:-1,requestvisibleactions:1,scope:1},kc=!1,lc=B(),mc=function(){if(!kc){for(var a=document.getElementsByTagName("meta"),b=0;b<a.length;++b){var c=a[b].name.toLowerCase();if(0==c.lastIndexOf("google-signin-",0)){c=c.substring(14);var d=a[b].content;jc[c]&&d&&(lc[c]=d);}}if(window.self!==window.top){a=document.location.toString();for(var e in jc)0<jc[e]&&(b=H(a,e,""))&&(lc[e]=b);}kc=!0;}e=B();D(lc,e);return e},nc=function(a){return !!(a.clientid&&
 a.scope&&a.callback)};var oc=window.console,pc=function(a){oc&&oc.log&&oc.log(a);};var qc=function(){return !!K.oa},rc=function(){};var R=A(K,"rw",B()),sc=function(a){for(var b in R)a(R[b]);},tc=function(a,b){(a=R[a])&&a.state<b&&(a.state=b);};var vc=/^https?:\/\/(?:\w|[\-\.])+\.google\.(?:\w|[\-:\.])+(?:\/[^\?#]*)?\/u\/(\d)\//,wc=/^https?:\/\/(?:\w|[\-\.])+\.google\.(?:\w|[\-:\.])+(?:\/[^\?#]*)?\/b\/(\d{10,21})\//,xc=function(a){var b=Q("googleapis.config/sessionIndex");"string"===typeof b&&254<b.length&&(b=null);null==b&&(b=window.__X_GOOG_AUTHUSER);"string"===typeof b&&254<b.length&&(b=null);if(null==b){var c=window.google;c&&(b=c.authuser);}"string"===typeof b&&254<b.length&&(b=null);null==b&&(a=a||window.location.href,b=H(a,"authuser")||
 null,null==b&&(b=(b=a.match(vc))?b[1]:null));if(null==b)return null;b=String(b);254<b.length&&(b=null);return b},yc=function(a){var b=Q("googleapis.config/sessionDelegate");"string"===typeof b&&21<b.length&&(b=null);null==b&&(b=(a=(a||window.location.href).match(wc))?a[1]:null);if(null==b)return null;b=String(b);21<b.length&&(b=null);return b};var zc,S,T=void 0,U=function(a){try{return m.JSON.parse.call(m.JSON,a)}catch(b){return !1}},V=function(a){return Object.prototype.toString.call(a)},Ac=V(0),Bc=V(new Date(0)),Cc=V(!0),Dc=V(""),Ec=V({}),Fc=V([]),W=function(a,b){if(b)for(var c=0,d=b.length;c<d;++c)if(a===b[c])throw new TypeError("Converting circular structure to JSON");d=typeof a;if("undefined"!==d){c=Array.prototype.slice.call(b||[],0);c[c.length]=a;b=[];var e=V(a);if(null!=a&&"function"===typeof a.toJSON&&(Object.prototype.hasOwnProperty.call(a,
 "toJSON")||(e!==Fc||a.constructor!==Array&&a.constructor!==Object)&&(e!==Ec||a.constructor!==Array&&a.constructor!==Object)&&e!==Dc&&e!==Ac&&e!==Cc&&e!==Bc))return W(a.toJSON.call(a),c);if(null==a)b[b.length]="null";else if(e===Ac)a=Number(a),isNaN(a)||isNaN(a-a)?a="null":-0===a&&0>1/a&&(a="-0"),b[b.length]=String(a);else if(e===Cc)b[b.length]=String(!!Number(a));else {if(e===Bc)return W(a.toISOString.call(a),c);if(e===Fc&&V(a.length)===Ac){b[b.length]="[";var f=0;for(d=Number(a.length)>>0;f<d;++f)f&&
 (b[b.length]=","),b[b.length]=W(a[f],c)||"null";b[b.length]="]";}else if(e==Dc&&V(a.length)===Ac){b[b.length]='"';f=0;for(c=Number(a.length)>>0;f<c;++f)d=String.prototype.charAt.call(a,f),e=String.prototype.charCodeAt.call(a,f),b[b.length]="\b"===d?"\\b":"\f"===d?"\\f":"\n"===d?"\\n":"\r"===d?"\\r":"\t"===d?"\\t":"\\"===d||'"'===d?"\\"+d:31>=e?"\\u"+(e+65536).toString(16).substr(1):32<=e&&65535>=e?d:"\ufffd";b[b.length]='"';}else if("object"===d){b[b.length]="{";d=0;for(f in a)Object.prototype.hasOwnProperty.call(a,
 f)&&(e=W(a[f],c),void 0!==e&&(d++&&(b[b.length]=","),b[b.length]=W(f),b[b.length]=":",b[b.length]=e));b[b.length]="}";}else return}return b.join("")}},Gc=/[\0-\x07\x0b\x0e-\x1f]/,Hc=/^([^"]*"([^\\"]|\\.)*")*[^"]*"([^"\\]|\\.)*[\0-\x1f]/,Ic=/^([^"]*"([^\\"]|\\.)*")*[^"]*"([^"\\]|\\.)*\\[^\\\/"bfnrtu]/,Jc=/^([^"]*"([^\\"]|\\.)*")*[^"]*"([^"\\]|\\.)*\\u([0-9a-fA-F]{0,3}[^0-9a-fA-F])/,Kc=/"([^\0-\x1f\\"]|\\[\\\/"bfnrt]|\\u[0-9a-fA-F]{4})*"/g,Lc=/-?(0|[1-9][0-9]*)(\.[0-9]+)?([eE][-+]?[0-9]+)?/g,Mc=/[ \t\n\r]+/g,
 Nc=/[^"]:/,Oc=/""/g,Pc=/true|false|null/g,Qc=/00/,Rc=/[\{]([^0\}]|0[^:])/,Sc=/(^|\[)[,:]|[,:](\]|\}|[,:]|$)/,Tc=/[^\[,:][\[\{]/,Uc=/^(\{|\}|\[|\]|,|:|0)+/,Vc=/\u2028/g,Wc=/\u2029/g,Xc=function(a){a=String(a);if(Gc.test(a)||Hc.test(a)||Ic.test(a)||Jc.test(a))return !1;var b=a.replace(Kc,'""');b=b.replace(Lc,"0");b=b.replace(Mc,"");if(Nc.test(b))return !1;b=b.replace(Oc,"0");b=b.replace(Pc,"0");if(Qc.test(b)||Rc.test(b)||Sc.test(b)||Tc.test(b)||!b||(b=b.replace(Uc,"")))return !1;a=a.replace(Vc,"\\u2028").replace(Wc,
 "\\u2029");b=void 0;try{b=T?[U(a)]:eval("(function (var_args) {\n  return Array.prototype.slice.call(arguments, 0);\n})(\n"+a+"\n)");}catch(c){return !1}return b&&1===b.length?b[0]:!1},Yc=function(){var a=((m.document||{}).scripts||[]).length;if((void 0===zc||void 0===T||S!==a)&&-1!==S){zc=T=!1;S=-1;try{try{T=!!m.JSON&&'{"a":[3,true,"1970-01-01T00:00:00.000Z"]}'===m.JSON.stringify.call(m.JSON,{a:[3,!0,new Date(0)],c:function(){}})&&!0===U("true")&&3===U('[{"a":3}]')[0].a;}catch(b){}zc=T&&!U("[00]")&&
 !U('"\u0007"')&&!U('"\\0"')&&!U('"\\v"');}finally{S=a;}}},Zc=function(a){if(-1===S)return !1;Yc();return (zc?U:Xc)(a)},$c=function(a){if(-1!==S)return Yc(),T?m.JSON.stringify.call(m.JSON,a):W(a)},ad=!Date.prototype.toISOString||"function"!==typeof Date.prototype.toISOString||"1970-01-01T00:00:00.000Z"!==(new Date(0)).toISOString(),bd=function(){var a=Date.prototype.getUTCFullYear.call(this);return [0>a?"-"+String(1E6-a).substr(1):9999>=a?String(1E4+a).substr(1):"+"+String(1E6+a).substr(1),"-",String(101+
 Date.prototype.getUTCMonth.call(this)).substr(1),"-",String(100+Date.prototype.getUTCDate.call(this)).substr(1),"T",String(100+Date.prototype.getUTCHours.call(this)).substr(1),":",String(100+Date.prototype.getUTCMinutes.call(this)).substr(1),":",String(100+Date.prototype.getUTCSeconds.call(this)).substr(1),".",String(1E3+Date.prototype.getUTCMilliseconds.call(this)).substr(1),"Z"].join("")};Date.prototype.toISOString=ad?bd:Date.prototype.toISOString;var cd=function(){this.j=-1;};var dd=function(){this.j=64;this.b=[];this.G=[];this.da=[];this.C=[];this.C[0]=128;for(var a=1;a<this.j;++a)this.C[a]=0;this.D=this.o=0;this.reset();};oa(dd,cd);dd.prototype.reset=function(){this.b[0]=1732584193;this.b[1]=4023233417;this.b[2]=2562383102;this.b[3]=271733878;this.b[4]=3285377520;this.D=this.o=0;};
 var ed=function(a,b,c){c||(c=0);var d=a.da;if("string"===typeof b)for(var e=0;16>e;e++)d[e]=b.charCodeAt(c)<<24|b.charCodeAt(c+1)<<16|b.charCodeAt(c+2)<<8|b.charCodeAt(c+3),c+=4;else for(e=0;16>e;e++)d[e]=b[c]<<24|b[c+1]<<16|b[c+2]<<8|b[c+3],c+=4;for(e=16;80>e;e++){var f=d[e-3]^d[e-8]^d[e-14]^d[e-16];d[e]=(f<<1|f>>>31)&4294967295;}b=a.b[0];c=a.b[1];var g=a.b[2],h=a.b[3],k=a.b[4];for(e=0;80>e;e++){if(40>e)if(20>e){f=h^c&(g^h);var l=1518500249;}else f=c^g^h,l=1859775393;else 60>e?(f=c&g|h&(c|g),l=2400959708):
 (f=c^g^h,l=3395469782);f=(b<<5|b>>>27)+f+k+l+d[e]&4294967295;k=h;h=g;g=(c<<30|c>>>2)&4294967295;c=b;b=f;}a.b[0]=a.b[0]+b&4294967295;a.b[1]=a.b[1]+c&4294967295;a.b[2]=a.b[2]+g&4294967295;a.b[3]=a.b[3]+h&4294967295;a.b[4]=a.b[4]+k&4294967295;};
 dd.prototype.update=function(a,b){if(null!=a){void 0===b&&(b=a.length);for(var c=b-this.j,d=0,e=this.G,f=this.o;d<b;){if(0==f)for(;d<=c;)ed(this,a,d),d+=this.j;if("string"===typeof a)for(;d<b;){if(e[f]=a.charCodeAt(d),++f,++d,f==this.j){ed(this,e);f=0;break}}else for(;d<b;)if(e[f]=a[d],++f,++d,f==this.j){ed(this,e);f=0;break}}this.o=f;this.D+=b;}};
 dd.prototype.digest=function(){var a=[],b=8*this.D;56>this.o?this.update(this.C,56-this.o):this.update(this.C,this.j-(this.o-56));for(var c=this.j-1;56<=c;c--)this.G[c]=b&255,b/=256;ed(this,this.G);for(c=b=0;5>c;c++)for(var d=24;0<=d;d-=8)a[b]=this.b[c]>>d&255,++b;return a};var fd=function(){this.O=new dd;};fd.prototype.reset=function(){this.O.reset();};var gd=x.crypto,hd=!1,id=0,jd=0,kd=1,ld=0,md="",nd=function(a){a=a||x.event;var b=a.screenX+a.clientX<<16;b+=a.screenY+a.clientY;b*=(new Date).getTime()%1E6;kd=kd*b%ld;0<id&&++jd==id&&jb("mousemove",nd,"remove","de");},od=function(a){var b=new fd;a=unescape(encodeURIComponent(a));for(var c=[],d=0,e=a.length;d<e;++d)c.push(a.charCodeAt(d));b.O.update(c);b=b.O.digest();a="";for(c=0;c<b.length;c++)a+="0123456789ABCDEF".charAt(Math.floor(b[c]/16))+"0123456789ABCDEF".charAt(b[c]%16);return a};
 hd=!!gd&&"function"==typeof gd.getRandomValues;hd||(ld=1E6*(screen.width*screen.width+screen.height),md=od(z.cookie+"|"+z.location+"|"+(new Date).getTime()+"|"+Math.random()),id=Q("random/maxObserveMousemove")||0,0!=id&&jb("mousemove",nd,"add","at"));var pd=function(){var a=kd;a+=parseInt(md.substr(0,20),16);md=od(md);return a/(ld+Math.pow(16,20))},qd=function(){var a=new x.Uint32Array(1);gd.getRandomValues(a);return Number("0."+a[0])};var rd=function(){var a=K.onl;if(!a){a=B();K.onl=a;var b=B();a.e=function(c){var d=b[c];d&&(delete b[c],d());};a.a=function(c,d){b[c]=d;};a.r=function(c){delete b[c];};}return a},sd=function(a,b){b=b.onload;return "function"===typeof b?(rd().a(a,b),b):null},td=function(a){E(/^\w+$/.test(a),"Unsupported id - "+a);rd();return 'onload="window.___jsl.onl.e(&#34;'+a+'&#34;)"'},ud=function(a){rd().r(a);};var vd={allowtransparency:"true",frameborder:"0",hspace:"0",marginheight:"0",marginwidth:"0",scrolling:"no",style:"",tabindex:"0",vspace:"0",width:"100%"},wd={allowtransparency:!0,onload:!0},xd=0,yd=function(a){E(!a||ib.test(a),"Illegal url for new iframe - "+a);},zd=function(a,b,c,d,e){yd(c.src);var f,g=sd(d,c),h=g?td(d):"";try{document.all&&(f=a.createElement('<iframe frameborder="'+Wa(String(c.frameborder))+'" scrolling="'+Wa(String(c.scrolling))+'" '+h+' name="'+Wa(String(c.name))+'"/>'));}catch(l){}finally{f||
 (f=a.createElement("iframe"),g&&(f.onload=function(){f.onload=null;g.call(this);},ud(d)));}f.setAttribute("ng-non-bindable","");for(var k in c)a=c[k],"style"===k&&"object"===typeof a?D(a,f.style):wd[k]||f.setAttribute(k,String(a));(k=e&&e.beforeNode||null)||e&&e.dontclear||ob(b);b.insertBefore(f,k);f=k?k.previousSibling:b.lastChild;c.allowtransparency&&(f.allowTransparency=!0);return f};var Ad=/^:[\w]+$/,Bd=/:([a-zA-Z_]+):/g,Cd=function(){var a=xc()||"0",b=yc();var c=xc(void 0)||a;var d=yc(void 0),e="";c&&(e+="u/"+encodeURIComponent(String(c))+"/");d&&(e+="b/"+encodeURIComponent(String(d))+"/");c=e||null;(e=(d=!1===Q("isLoggedIn"))?"_/im/":"")&&(c="");var f=Q("iframes/:socialhost:"),g=Q("iframes/:im_socialhost:");return {socialhost:f,ctx_socialhost:d?g:f,session_index:a,session_delegate:b,session_prefix:c,im_prefix:e}},Dd=function(a,b){return Cd()[b]||""},Ed=function(a){return function(b,
 c){return a?Cd()[c]||a[c]||"":Cd()[c]||""}};var Fd=function(a){var b;a.match(/^https?%3A/i)&&(b=decodeURIComponent(a));return hb(document,b?b:a)},Gd=function(a){a=a||"canonical";for(var b=document.getElementsByTagName("link"),c=0,d=b.length;c<d;c++){var e=b[c],f=e.getAttribute("rel");if(f&&f.toLowerCase()==a&&(e=e.getAttribute("href"))&&(e=Fd(e))&&null!=e.match(/^https?:\/\/[\w\-_\.]+/i))return e}return window.location.href};var Hd={se:"0"},Id={post:!0},Jd={style:"position:absolute;top:-10000px;width:450px;margin:0px;border-style:none"},Kd="onPlusOne _ready _close _open _resizeMe _renderstart oncircled drefresh erefresh".split(" "),Ld=A(K,"WI",B()),Md=function(a,b,c){var d;var e={};var f=d=a;"plus"==a&&b.action&&(d=a+"_"+b.action,f=a+"/"+b.action);(d=Q("iframes/"+d+"/url"))||(d=":im_socialhost:/:session_prefix::im_prefix:_/widget/render/"+f+"?usegapi=1");for(var g in Hd)e[g]=g+"/"+(b[g]||Hd[g])+"/";e=hb(z,d.replace(Bd,
 Ed(e)));g="iframes/"+a+"/params/";f={};D(b,f);(d=Q("lang")||Q("gwidget/lang"))&&(f.hl=d);Id[a]||(f.origin=window.location.origin||window.location.protocol+"//"+window.location.host);f.exp=Q(g+"exp");if(g=Q(g+"location"))for(d=0;d<g.length;d++){var h=g[d];f[h]=x.location[h];}switch(a){case "plus":case "follow":g=f.href;d=b.action?void 0:"publisher";g=(g="string"==typeof g?g:void 0)?Fd(g):Gd(d);f.url=g;delete f.href;break;case "plusone":g=(g=b.href)?Fd(g):Gd();f.url=g;g=b.db;d=Q();null==g&&d&&(g=d.db,
 null==g&&(g=d.gwidget&&d.gwidget.db));f.db=g||void 0;g=b.ecp;d=Q();null==g&&d&&(g=d.ecp,null==g&&(g=d.gwidget&&d.gwidget.ecp));f.ecp=g||void 0;delete f.href;break;case "signin":f.url=Gd();}K.ILI&&(f.iloader="1");delete f["data-onload"];delete f.rd;for(var k in Hd)f[k]&&delete f[k];f.gsrc=Q("iframes/:source:");k=Q("inline/css");"undefined"!==typeof k&&0<c&&k>=c&&(f.ic="1");k=/^#|^fr-/;c={};for(var l in f)C(f,l)&&k.test(l)&&(c[l.replace(k,"")]=f[l],delete f[l]);l="q"==Q("iframes/"+a+"/params/si")?f:
 c;k=mc();for(var n in k)!C(k,n)||C(f,n)||C(c,n)||(l[n]=k[n]);n=[].concat(Kd);(l=Q("iframes/"+a+"/methods"))&&"object"===typeof l&&Na.test(l.push)&&(n=n.concat(l));for(var p in b)C(b,p)&&/^on/.test(p)&&("plus"!=a||"onconnect"!=p)&&(n.push(p),delete f[p]);delete f.callback;c._methods=n.join(",");return fb(e,f,c)},Nd=["style","data-gapiscan"],Pd=function(a){for(var b=B(),c=0!=a.nodeName.toLowerCase().indexOf("g:"),d=0,e=a.attributes.length;d<e;d++){var f=a.attributes[d],g=f.name,h=f.value;0<=Oa.call(Nd,
 g)||c&&0!=g.indexOf("data-")||"null"===h||"specified"in f&&!f.specified||(c&&(g=g.substr(5)),b[g.toLowerCase()]=h);}a=a.style;(c=Od(a&&a.height))&&(b.height=String(c));(a=Od(a&&a.width))&&(b.width=String(a));return b},Od=function(a){var b=void 0;"number"===typeof a?b=a:"string"===typeof a&&(b=parseInt(a,10));return b},Rd=function(){var a=K.drw;sc(function(b){if(a!==b.id&&4!=b.state&&"share"!=b.type){var c=b.id,d=b.type,e=b.url;b=b.userParams;var f=z.getElementById(c);if(f){var g=Md(d,b,0);g?(f=f.parentNode,
 e.replace(/#.*/,"").replace(/(\?|&)ic=1/,"")!==g.replace(/#.*/,"").replace(/(\?|&)ic=1/,"")&&(b.dontclear=!0,b.rd=!0,b.ri=!0,b.type=d,Qd(f,b),(d=R[f.lastChild.id])&&(d.oid=c),tc(c,4))):delete R[c];}else delete R[c];}});};var Sd,Td,X,Ud,Vd,Wd=/(?:^|\s)g-((\S)*)(?:$|\s)/,Xd={plusone:!0,autocomplete:!0,profile:!0,signin:!0,signin2:!0};Sd=A(K,"SW",B());Td=A(K,"SA",B());X=A(K,"SM",B());Ud=A(K,"FW",[]);Vd=null;
 var Zd=function(a,b){Yd(void 0,!1,a,b);},Yd=function(a,b,c,d){L("ps0",!0);c=("string"===typeof c?document.getElementById(c):c)||z;var e=z.documentMode;if(c.querySelectorAll&&(!e||8<e)){e=d?[d]:Xa(Sd).concat(Xa(Td)).concat(Xa(X));for(var f=[],g=0;g<e.length;g++){var h=e[g];f.push(".g-"+h,"g\\:"+h);}e=c.querySelectorAll(f.join(","));}else e=c.getElementsByTagName("*");c=B();for(f=0;f<e.length;f++){g=e[f];var k=g;h=d;var l=k.nodeName.toLowerCase(),n=void 0;if(k.getAttribute("data-gapiscan"))h=null;else {var p=
 l.indexOf("g:");0==p?n=l.substr(2):(p=(p=String(k.className||k.getAttribute("class")))&&Wd.exec(p))&&(n=p[1]);h=!n||!(Sd[n]||Td[n]||X[n])||h&&n!==h?null:n;}h&&(Xd[h]||0==g.nodeName.toLowerCase().indexOf("g:")||0!=Xa(Pd(g)).length)&&(g.setAttribute("data-gapiscan",!0),A(c,h,[]).push(g));}if(b)for(var r in c)for(b=c[r],d=0;d<b.length;d++)b[d].setAttribute("data-onload",!0);for(var u in c)Ud.push(u);L("ps1",!0);if((r=Ud.join(":"))||a)try{F.load(r,a);}catch(G){pc(G);return}if($d(Vd||{}))for(var y in c){a=
 c[y];u=0;for(b=a.length;u<b;u++)a[u].removeAttribute("data-gapiscan");ae(y);}else {d=[];for(y in c)for(a=c[y],u=0,b=a.length;u<b;u++)e=a[u],be(y,e,Pd(e),d,b);ce(r,d);}},de=function(a){var b=A(F,a,{});b.go||(b.go=function(c){return Zd(c,a)},b.render=function(c,d){d=d||{};d.type=a;return Qd(c,d)});},ee=function(a){Sd[a]=!0;},fe=function(a){Td[a]=!0;},ge=function(a){X[a]=!0;};var ae=function(a,b){var c=sb(a);b&&c?(c(b),(c=b.iframeNode)&&c.setAttribute("data-gapiattached",!0)):F.load(a,function(){var d=sb(a),e=b&&b.iframeNode,f=b&&b.userParams;e&&d?(d(b),e.setAttribute("data-gapiattached",!0)):(d=F[a].go,"signin2"==a?d(e,f):d(e&&e.parentNode,f));});},$d=function(){return !1},ce=function(){},be=function(a,b,c,d,e,f,g){switch(he(b,a,f)){case 0:a=X[a]?a+"_annotation":a;d={};d.iframeNode=b;d.userParams=c;ae(a,d);break;case 1:if(b.parentNode){for(var h in c){if(f=C(c,h))f=c[h],
 f=!!f&&"object"===typeof f&&(!f.toString||f.toString===Object.prototype.toString||f.toString===Array.prototype.toString);if(f)try{c[h]=$c(c[h]);}catch(y){delete c[h];}}f=!0;c.dontclear&&(f=!1);delete c.dontclear;rc();h=Md(a,c,e);e=g||{};e.allowPost=1;e.attributes=Jd;e.dontclear=!f;g={};g.userParams=c;g.url=h;g.type=a;if(c.rd)var k=b;else k=document.createElement("div"),b.setAttribute("data-gapistub",!0),k.style.cssText="position:absolute;width:450px;left:-10000px;",b.parentNode.insertBefore(k,b);g.siteElement=
 k;k.id||(b=k,A(Ld,a,0),f="___"+a+"_"+Ld[a]++,b.id=f);b=B();b[">type"]=a;D(c,b);f=h;c=k;h=e||{};b=h.attributes||{};E(!(h.allowPost||h.forcePost)||!b.onload,"onload is not supported by post iframe (allowPost or forcePost)");e=b=f;Ad.test(b)&&(e=Q("iframes/"+e.substring(1)+"/url"),E(!!e,"Unknown iframe url config for - "+b));f=hb(z,e.replace(Bd,Dd));b=c.ownerDocument||z;k=0;do e=h.id||["I",xd++,"_",(new Date).getTime()].join("");while(b.getElementById(e)&&5>++k);E(5>k,"Error creating iframe id");k={};
 var l={};b.documentMode&&9>b.documentMode&&(k.hostiemode=b.documentMode);D(h.queryParams||{},k);D(h.fragmentParams||{},l);var n=h.pfname;var p=B();Q("iframes/dropLegacyIdParam")||(p.id=e);p._gfid=e;p.parent=b.location.protocol+"//"+b.location.host;var r=H(b.location.href,"parent");n=n||"";!n&&r&&(r=H(b.location.href,"_gfid","")||H(b.location.href,"id",""),n=H(b.location.href,"pfname",""),n=r?n+"/"+r:"");n||(r=Zc(H(b.location.href,"jcp","")))&&"object"==typeof r&&(n=(n=r.id)?r.pfname+"/"+n:"");p.pfname=
 n;h.connectWithJsonParam&&(r={},r.jcp=$c(p),p=r);r=H(f,"rpctoken")||k.rpctoken||l.rpctoken;r||(r=h.rpctoken||String(Math.round(1E8*(hd?qd():pd()))),p.rpctoken=r);h.rpctoken=r;D(p,h.connectWithQueryParams?k:l);r=b.location.href;p=B();(n=H(r,"_bsh",K.bsh))&&(p._bsh=n);(r=qb(r))&&(p.jsh=r);h.hintInFragment?D(p,l):D(p,k);f=fb(f,k,l,h.paramsSerializer);l=B();D(vd,l);D(h.attributes,l);l.name=l.id=e;l.src=f;h.eurl=f;k=h||{};p=!!k.allowPost;if(k.forcePost||p&&2E3<f.length){k=I(f);l.src="";h.dropDataPostorigin||
 (l["data-postorigin"]=f);f=zd(b,c,l,e);if(-1!=navigator.userAgent.indexOf("WebKit")){var u=f.contentWindow.document;u.open();l=u.createElement("div");p={};r=e+"_inner";p.name=r;p.src="";p.style="display:none";zd(b,l,p,r,h);}l=(h=k.query[0])?h.split("&"):[];h=[];for(p=0;p<l.length;p++)r=l[p].split("=",2),h.push([decodeURIComponent(r[0]),decodeURIComponent(r[1])]);k.query=[];l=db(k);E(ib.test(l),"Invalid URL: "+l);k=b.createElement("form");k.method="POST";k.target=e;k.style.display="none";e=l instanceof
 v?l:Fa(l);xa(k,"HTMLFormElement").action=Da(e);for(e=0;e<h.length;e++)l=b.createElement("input"),l.type="hidden",l.name=h[e][0],l.value=h[e][1],k.appendChild(l);c.appendChild(k);k.submit();k.parentNode.removeChild(k);u&&u.close();u=f;}else u=zd(b,c,l,e,h);g.iframeNode=u;g.id=u.getAttribute("id");u=g.id;c=B();c.id=u;c.userParams=g.userParams;c.url=g.url;c.type=g.type;c.state=1;R[u]=c;u=g;}else u=null;u&&((g=u.id)&&d.push(g),ae(a,u));}},he=function(a,b,c){if(a&&1===a.nodeType&&b){if(c)return 1;if(X[b]){if(pb[a.nodeName.toLowerCase()])return (a=
 a.innerHTML)&&a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")?0:1}else {if(Td[b])return 0;if(Sd[b])return 1}}return null},Qd=function(a,b){var c=b.type;delete b.type;var d=("string"===typeof a?document.getElementById(a):a)||void 0;if(d){a={};for(var e in b)C(b,e)&&(a[e.toLowerCase()]=b[e]);a.rd=1;(b=!!a.ri)&&delete a.ri;e=[];be(c,d,a,e,0,b,void 0);ce(c,e);}else pc("string"==="gapi."+c+".render: missing element "+typeof a?a:"");};A(F,"platform",{}).go=Zd;$d=function(a){for(var b=["_c","jsl","h"],c=0;c<b.length&&a;c++)a=a[b[c]];b=qb(La.href);return !a||0!=a.indexOf("n;")&&0!=b.indexOf("n;")&&a!==b};ce=function(a,b){ie(a,b);};var lb=function(a){Yd(a,!0);},je=function(a,b){b=b||[];for(var c=0;c<b.length;++c)a(b[c]);for(a=0;a<b.length;a++)de(b[a]);};
 N.push(["platform",function(a,b,c){Vd=c;b&&Ud.push(b);je(ee,a);je(fe,c._c.annotation);je(ge,c._c.bimodal);ic();gc();if("explicit"!=Q("parsetags")){rb(a);nc(mc())&&!Q("disableRealtimeCallback")&&rc();if(c&&(a=c.callback)){var d=Ya(a);delete c.callback;}nb(function(){lb(d);});}}]);F._pl=!0;var ke=function(a){a=(a=R[a])?a.oid:void 0;if(a){var b=z.getElementById(a);b&&b.parentNode.removeChild(b);delete R[a];ke(a);}};var le=/^\{h:'/,me=/^!_/,ne="",ie=function(a,b){function c(){jb("message",d,"remove","de");}function d(f){var g=f.data,h=f.origin;if(oe(g,b)){var k=e;e=!1;k&&L("rqe");pe(a,function(){k&&L("rqd");c();for(var l=A(K,"RPMQ",[]),n=0;n<l.length;n++)l[n]({data:g,origin:h});});}}if(0!==b.length){ne=H(La.href,"pfname","");var e=!0;jb("message",d,"add","at");ac(a,c);}},oe=function(a,b){a=String(a);if(le.test(a))return !0;var c=!1;me.test(a)&&(c=!0,a=a.substr(2));if(!/^\{/.test(a))return !1;var d=Zc(a);if(!d)return !1;
 a=d.f;if(d.s&&a&&-1!=Oa.call(b,a)){if("_renderstart"===d.s||d.s===ne+"/"+a+"::_renderstart")if(d=d.a&&d.a[c?0:1],b=z.getElementById(a),tc(a,2),d&&b&&d.width&&d.height){a:{c=b.parentNode;a=d||{};if(qc()){var e=b.id;if(e){d=(d=R[e])?d.state:void 0;if(1===d||4===d)break a;ke(e);}}(d=c.nextSibling)&&d.getAttribute&&d.getAttribute("data-gapistub")&&(c.parentNode.removeChild(d),c.style.cssText="");d=a.width;var f=a.height,g=c.style;g.textIndent="0";g.margin="0";g.padding="0";g.background="transparent";g.borderStyle=
 "none";g.cssFloat="none";g.styleFloat="none";g.lineHeight="normal";g.fontSize="1px";g.verticalAlign="baseline";c=c.style;c.display="inline-block";g=b.style;g.position="static";g.left="0";g.top="0";g.visibility="visible";d&&(c.width=g.width=d+"px");f&&(c.height=g.height=f+"px");a.verticalAlign&&(c.verticalAlign=a.verticalAlign);e&&tc(e,3);}b["data-csi-wdt"]=(new Date).getTime();}return !0}return !1},pe=function(a,b){ac(a,b);};var qe=function(a,b){this.L=a;a=b||{};this.fa=Number(a.maxAge)||0;this.U=a.domain;this.X=a.path;this.ga=!!a.secure;};qe.prototype.read=function(){for(var a=this.L+"=",b=document.cookie.split(/;\s*/),c=0;c<b.length;++c){var d=b[c];if(0==d.indexOf(a))return d.substr(a.length)}};
 qe.prototype.write=function(a,b){if(!re.test(this.L))throw "Invalid cookie name";if(!se.test(a))throw "Invalid cookie value";a=this.L+"="+a;this.U&&(a+=";domain="+this.U);this.X&&(a+=";path="+this.X);b="number"===typeof b?b:this.fa;if(0<=b){var c=new Date;c.setSeconds(c.getSeconds()+b);a+=";expires="+c.toUTCString();}this.ga&&(a+=";secure");document.cookie=a;return !0};qe.prototype.clear=function(){this.write("",0);};var se=/^[-+/_=.:|%&a-zA-Z0-9@]*$/,re=/^[A-Z_][A-Z0-9_]{0,63}$/;
 qe.iterate=function(a){for(var b=document.cookie.split(/;\s*/),c=0;c<b.length;++c){var d=b[c].split("="),e=d.shift();a(e,d.join("="));}};var te=function(a){this.B=a;};te.prototype.read=function(){if(Y.hasOwnProperty(this.B))return Y[this.B]};te.prototype.write=function(a){Y[this.B]=a;return !0};te.prototype.clear=function(){delete Y[this.B];};var Y={};te.iterate=function(a){for(var b in Y)Y.hasOwnProperty(b)&&a(b,Y[b]);};var ue="https:"===window.location.protocol,ve=ue||"http:"===window.location.protocol?qe:te,we=function(a){var b=a.substr(1),c="",d=window.location.hostname;if(""!==b){c=parseInt(b,10);if(isNaN(c))return null;b=d.split(".");if(b.length<c-1)return null;b.length==c-1&&(d="."+d);}else d="";return {i:"S"==a.charAt(0),domain:d,l:c}},xe=function(){var a,b=null;ve.iterate(function(c,d){0===c.indexOf("G_AUTHUSER_")&&(c=we(c.substring(11)),!a||c.i&&!a.i||c.i==a.i&&c.l>a.l)&&(a=c,b=d);});return {ea:a,F:b}};var ye=function(a){if(0!==a.indexOf("GCSC"))return null;var b={W:!1};a=a.substr(4);if(!a)return b;var c=a.charAt(0);a=a.substr(1);var d=a.lastIndexOf("_");if(-1==d)return b;var e=we(a.substr(d+1));if(null==e)return b;a=a.substring(0,d);if("_"!==a.charAt(0))return b;d="E"===c&&e.i;return !d&&("U"!==c||e.i)||d&&!ue?b:{W:!0,i:d,ja:a.substr(1),domain:e.domain,l:e.l}},ze=function(a){if(!a)return [];a=a.split("=");return a[1]?a[1].split("|"):[]},Ae=function(a){a=a.split(":");return {clientId:a[0].split("=")[1],
 ia:ze(a[1]),la:ze(a[2]),ka:ze(a[3])}},Be=function(){var a=xe(),b=a.ea;a=a.F;if(null!==a){var c;ve.iterate(function(f,g){(f=ye(f))&&f.W&&f.i==b.i&&f.l==b.l&&(c=g);});if(c){var d=Ae(c),e=d&&d.ia[Number(a)];d=d&&d.clientId;if(e)return {F:a,ha:e,clientId:d}}}return null};var Z=function(){this.T=Ce;};Z.prototype.$=function(){this.K||(this.v=0,this.K=!0,this.Y());};Z.prototype.Y=function(){this.K&&(this.T()?this.v=this.R:this.v=Math.min(2*(this.v||this.R),120),window.setTimeout(na(this.Y,this),1E3*this.v));};Z.prototype.v=0;Z.prototype.R=2;Z.prototype.T=null;Z.prototype.K=!1;var Ee=null;qc=function(){return K.oa=!0};rc=function(){K.oa=!0;var a=Be();(a=a&&a.F)&&hc("googleapis.config/sessionIndex",a);Ee||(Ee=A(K,"ss",new Z));a=Ee;a.$&&a.$();};
 var Ce=function(){var a=Be(),b=a&&a.ha||null,c=a&&a.clientId;ac("auth",{callback:function(){var d=x.gapi.auth,e={client_id:c,session_state:b};d.checkSessionState(e,function(f){var g=e.session_state,h=Q("isLoggedIn");f=Q("debug/forceIm")?!1:g&&f||!g&&!f;if(h=h!=f)hc("isLoggedIn",f),rc(),Rd(),f||((f=d.signOut)?f():(f=d.setToken)&&f(null));f=mc();var k=Q("savedUserState");g=d._guss(f.cookiepolicy);k=k!=g&&"undefined"!=typeof k;hc("savedUserState",g);(h||k)&&nc(f)&&!Q("disableRealtimeCallback")&&d._pimf(f,
 !0);});}});return !0};L("bs0",!0,window.gapi._bs);L("bs1",!0);delete window.gapi._bs;}).call(undefined);
 gapi.load("",{callback:window["gapi_onload"],_c:{"jsl":{"ci":{"deviceType":"desktop","oauth-flow":{"authUrl":"https://accounts.google.com/o/oauth2/auth","proxyUrl":"https://accounts.google.com/o/oauth2/postmessageRelay","disableOpt":true,"idpIframeUrl":"https://accounts.google.com/o/oauth2/iframe","usegapi":false},"debug":{"reportExceptionRate":0.05,"forceIm":false,"rethrowException":false,"host":"https://apis.google.com"},"enableMultilogin":true,"googleapis.config":{"auth":{"useFirstPartyAuthV2":true}},"isPlusUser":false,"inline":{"css":1},"disableRealtimeCallback":false,"drive_share":{"skipInitCommand":true},"csi":{"rate":0.01},"client":{"cors":false},"isLoggedIn":true,"signInDeprecation":{"rate":0.0},"include_granted_scopes":true,"llang":"pt","iframes":{"youtube":{"params":{"location":["search","hash"]},"url":":socialhost:/:session_prefix:_/widget/render/youtube?usegapi\u003d1","methods":["scroll","openwindow"]},"ytsubscribe":{"url":"https://www.youtube.com/subscribe_embed?usegapi\u003d1"},"plus_circle":{"params":{"url":""},"url":":socialhost:/:session_prefix::se:_/widget/plus/circle?usegapi\u003d1"},"plus_share":{"params":{"url":""},"url":":socialhost:/:session_prefix::se:_/+1/sharebutton?plusShare\u003dtrue\u0026usegapi\u003d1"},"rbr_s":{"params":{"url":""},"url":":socialhost:/:session_prefix::se:_/widget/render/recobarsimplescroller"},":source:":"3p","playemm":{"url":"https://play.google.com/work/embedded/search?usegapi\u003d1\u0026usegapi\u003d1"},"savetoandroidpay":{"url":"https://pay.google.com/gp/v/widget/save"},"blogger":{"params":{"location":["search","hash"]},"url":":socialhost:/:session_prefix:_/widget/render/blogger?usegapi\u003d1","methods":["scroll","openwindow"]},"evwidget":{"params":{"url":""},"url":":socialhost:/:session_prefix:_/events/widget?usegapi\u003d1"},"partnersbadge":{"url":"https://www.gstatic.com/partners/badge/templates/badge.html?usegapi\u003d1"},"dataconnector":{"url":"https://dataconnector.corp.google.com/:session_prefix:ui/widgetview?usegapi\u003d1"},"surveyoptin":{"url":"https://www.google.com/shopping/customerreviews/optin?usegapi\u003d1"},":socialhost:":"https://apis.google.com","shortlists":{"url":""},"hangout":{"url":"https://talkgadget.google.com/:session_prefix:talkgadget/_/widget"},"plus_followers":{"params":{"url":""},"url":":socialhost:/_/im/_/widget/render/plus/followers?usegapi\u003d1"},"post":{"params":{"url":""},"url":":socialhost:/:session_prefix::im_prefix:_/widget/render/post?usegapi\u003d1"},":gplus_url:":"https://plus.google.com","signin":{"params":{"url":""},"url":":socialhost:/:session_prefix:_/widget/render/signin?usegapi\u003d1","methods":["onauth"]},"rbr_i":{"params":{"url":""},"url":":socialhost:/:session_prefix::se:_/widget/render/recobarinvitation"},"share":{"url":":socialhost:/:session_prefix::im_prefix:_/widget/render/share?usegapi\u003d1"},"plusone":{"params":{"count":"","size":"","url":""},"url":":socialhost:/:session_prefix::se:_/+1/fastbutton?usegapi\u003d1"},"comments":{"params":{"location":["search","hash"]},"url":":socialhost:/:session_prefix:_/widget/render/comments?usegapi\u003d1","methods":["scroll","openwindow"]},":im_socialhost:":"https://plus.googleapis.com","backdrop":{"url":"https://clients3.google.com/cast/chromecast/home/widget/backdrop?usegapi\u003d1"},"visibility":{"params":{"url":""},"url":":socialhost:/:session_prefix:_/widget/render/visibility?usegapi\u003d1"},"autocomplete":{"params":{"url":""},"url":":socialhost:/:session_prefix:_/widget/render/autocomplete"},"additnow":{"url":"https://apis.google.com/marketplace/button?usegapi\u003d1","methods":["launchurl"]},":signuphost:":"https://plus.google.com","ratingbadge":{"url":"https://www.google.com/shopping/customerreviews/badge?usegapi\u003d1"},"appcirclepicker":{"url":":socialhost:/:session_prefix:_/widget/render/appcirclepicker"},"follow":{"url":":socialhost:/:session_prefix:_/widget/render/follow?usegapi\u003d1"},"community":{"url":":ctx_socialhost:/:session_prefix::im_prefix:_/widget/render/community?usegapi\u003d1"},"sharetoclassroom":{"url":"https://classroom.google.com/sharewidget?usegapi\u003d1"},"ytshare":{"params":{"url":""},"url":":socialhost:/:session_prefix:_/widget/render/ytshare?usegapi\u003d1"},"plus":{"url":":socialhost:/:session_prefix:_/widget/render/badge?usegapi\u003d1"},"family_creation":{"params":{"url":""},"url":"https://families.google.com/webcreation?usegapi\u003d1\u0026usegapi\u003d1"},"commentcount":{"url":":socialhost:/:session_prefix:_/widget/render/commentcount?usegapi\u003d1"},"configurator":{"url":":socialhost:/:session_prefix:_/plusbuttonconfigurator?usegapi\u003d1"},"zoomableimage":{"url":"https://ssl.gstatic.com/microscope/embed/"},"appfinder":{"url":"https://workspace.google.com/:session_prefix:marketplace/appfinder?usegapi\u003d1"},"savetowallet":{"url":"https://pay.google.com/gp/v/widget/save"},"person":{"url":":socialhost:/:session_prefix:_/widget/render/person?usegapi\u003d1"},"savetodrive":{"url":"https://drive.google.com/savetodrivebutton?usegapi\u003d1","methods":["save"]},"page":{"url":":socialhost:/:session_prefix:_/widget/render/page?usegapi\u003d1"},"card":{"url":":socialhost:/:session_prefix:_/hovercard/card"}}},"h":"m;/_/scs/apps-static/_/js/k\u003doz.gapi.pt_BR.l4Bv_WkVC6g.O/am\u003dwQE/d\u003d1/ct\u003dzgms/rs\u003dAGLTcCOuH5S2uqmF6E8zOW7n3yiqiwhzNQ/m\u003d__features__","u":"https://apis.google.com/js/platform.js","hee":true,"fp":"821a251b140e4add32f87f4a7a08f044a59aa0e9","dpo":false},"platform":["additnow","backdrop","blogger","comments","commentcount","community","donation","family_creation","follow","hangout","health","page","partnersbadge","person","playemm","playreview","plus","plusone","post","ratingbadge","savetoandroidpay","savetodrive","savetowallet","sharetoclassroom","shortlists","signin2","surveyoptin","visibility","youtube","ytsubscribe","zoomableimage"],"fp":"821a251b140e4add32f87f4a7a08f044a59aa0e9","annotation":["interactivepost","recobar","signin2","autocomplete","profile"],"bimodal":["signin","share"]}});

const GoogleLoginButton = _ref => {
  var _window$Pelcro$site$r;
  let {
    label = "Google",
    className = "",
    labelClassName = "",
    iconClassName = ""
  } = _ref;
  const googleClientId = (_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.google_app_id;
  const {
    dispatch: loginDispatch
  } = useContext(store$n);
  const {
    dispatch: registerDispatch
  } = useContext(store$m);
  useEffect(() => {
    gapi.load("client:auth2", () => {
      gapi.auth2.init({
        clientId: googleClientId
      });
    });
  }, []);
  const onSuccess = response => {
    var _response$getAuthResp, _profile$getEmail, _profile$getGivenName, _profile$getFamilyNam, _profile$getEmail2, _profile$getGivenName2, _profile$getFamilyNam2;
    const profile = response.getBasicProfile();
    const accessToken = (_response$getAuthResp = response.getAuthResponse()) === null || _response$getAuthResp === void 0 ? void 0 : _response$getAuthResp.id_token;
    loginDispatch === null || loginDispatch === void 0 ? void 0 : loginDispatch({
      type: HANDLE_SOCIAL_LOGIN,
      payload: {
        idpName: "google",
        idpToken: accessToken,
        email: (_profile$getEmail = profile.getEmail) === null || _profile$getEmail === void 0 ? void 0 : _profile$getEmail.call(profile),
        firstName: (_profile$getGivenName = profile.getGivenName) === null || _profile$getGivenName === void 0 ? void 0 : _profile$getGivenName.call(profile),
        lastName: (_profile$getFamilyNam = profile.getFamilyName) === null || _profile$getFamilyNam === void 0 ? void 0 : _profile$getFamilyNam.call(profile)
      }
    });
    registerDispatch === null || registerDispatch === void 0 ? void 0 : registerDispatch({
      type: HANDLE_SOCIAL_LOGIN,
      payload: {
        idpName: "google",
        idpToken: accessToken,
        email: (_profile$getEmail2 = profile.getEmail) === null || _profile$getEmail2 === void 0 ? void 0 : _profile$getEmail2.call(profile),
        firstName: (_profile$getGivenName2 = profile.getGivenName) === null || _profile$getGivenName2 === void 0 ? void 0 : _profile$getGivenName2.call(profile),
        lastName: (_profile$getFamilyNam2 = profile.getFamilyName) === null || _profile$getFamilyNam2 === void 0 ? void 0 : _profile$getFamilyNam2.call(profile)
      }
    });
  };
  const onFailure = error => {
    console.error(error);
  };
  return googleClientId ? /*#__PURE__*/React__default.createElement(googleLogin_1, {
    clientId: googleClientId,
    onSuccess: onSuccess,
    onFailure: onFailure,
    render: renderProps => /*#__PURE__*/React__default.createElement("button", {
      onClick: renderProps.onClick,
      className: `plc-flex plc-items-center plc-justify-center plc-p-3 plc-space-x-3 plc-text-gray-700 plc-border plc-border-gray-200 plc-rounded-3xl hover:plc-bg-gray-200 pelcro-google-login ${className}`
    }, /*#__PURE__*/React__default.createElement(SvgGoogleLogo, {
      className: `plc-w-6 plc-h-auto pelcro-google-login-icon" ${iconClassName}`
    }), /*#__PURE__*/React__default.createElement("p", {
      className: `pelcro-google-login-label ${labelClassName}`
    }, label))
  }) : null;
};

var _path$q;
function _extends$s() { _extends$s = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$s.apply(this, arguments); }
function SvgAuth0Logo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$s({
    viewBox: "0 0 256 285",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$q || (_path$q = /*#__PURE__*/React.createElement("path", {
    d: "M220.412 0h-92.415l28.562 89.006h92.416l-74.77 53.077 28.57 89.511c48.128-35.06 63.854-88.12 46.208-142.588L220.413 0zM7.018 89.006h92.416L127.997 0H35.589L7.019 89.006c-17.655 54.468-1.92 107.529 46.207 142.588l28.563-89.51-74.77-53.078zm46.208 142.588l74.77 52.97 74.77-52.97-74.77-53.847-74.77 53.847z"
  })));
}

const Auth0LoginButton = _ref => {
  let {
    label = "Auth0",
    className = "",
    labelClassName = "",
    iconClassName = ""
  } = _ref;
  const auth0Enabled = Boolean(window.Pelcro.site.read().auth0_client_id && window.Pelcro.site.read().auth0_base_url);
  const auth0Script = document.querySelector("#auth0-sdk");
  const [auth0Loaded, setAuth0Loaded] = useState(Boolean(window.auth0));
  React__default.useEffect(() => {
    function handleScriptLoaded() {
      setAuth0Loaded(true);
    }
    if (auth0Enabled && !auth0Loaded) {
      auth0Script.addEventListener("load", handleScriptLoaded);
    }
    return () => {
      var _auth0Script$removeEv;
      auth0Script === null || auth0Script === void 0 ? void 0 : (_auth0Script$removeEv = auth0Script.removeEventListener) === null || _auth0Script$removeEv === void 0 ? void 0 : _auth0Script$removeEv.call(auth0Script, "load", handleScriptLoaded);
    };
  }, [auth0Script, auth0Enabled, auth0Loaded]);
  const auth0InstanceRef = React__default.useRef(null);
  React__default.useEffect(() => {
    if (auth0Enabled && auth0Loaded && auth0InstanceRef.current === null) {
      auth0InstanceRef.current = new window.auth0.WebAuth({
        domain: window.Pelcro.site.read().auth0_base_url,
        clientID: window.Pelcro.site.read().auth0_client_id
      });
    }
  }, [auth0Enabled, auth0Loaded]);
  const {
    dispatch: loginDispatch
  } = useContext(store$n);
  const {
    dispatch: registerDispatch
  } = useContext(store$m);
  function handleClick() {
    var _auth0InstanceRef$cur, _auth0InstanceRef$cur2, _auth0InstanceRef$cur3;
    if (!auth0Loaded) {
      return console.error("Auth0 sdk script wasn't loaded, you need to load auth0 sdk before rendering the Auth0LoginButton");
    }
    (_auth0InstanceRef$cur = auth0InstanceRef.current) === null || _auth0InstanceRef$cur === void 0 ? void 0 : (_auth0InstanceRef$cur2 = _auth0InstanceRef$cur.popup) === null || _auth0InstanceRef$cur2 === void 0 ? void 0 : (_auth0InstanceRef$cur3 = _auth0InstanceRef$cur2.authorize) === null || _auth0InstanceRef$cur3 === void 0 ? void 0 : _auth0InstanceRef$cur3.call(_auth0InstanceRef$cur2, {
      responseType: "token id_token",
      owp: true // close popup when finished
    }, function (error, authResult) {
      if (error) {
        return onFailure(error);
      }
      onSuccess(authResult);
    });
  }
  const onSuccess = authResult => {
    var _auth0InstanceRef$cur4, _auth0InstanceRef$cur5, _auth0InstanceRef$cur6;
    const {
      accessToken
    } = authResult;
    (_auth0InstanceRef$cur4 = auth0InstanceRef.current) === null || _auth0InstanceRef$cur4 === void 0 ? void 0 : (_auth0InstanceRef$cur5 = _auth0InstanceRef$cur4.client) === null || _auth0InstanceRef$cur5 === void 0 ? void 0 : (_auth0InstanceRef$cur6 = _auth0InstanceRef$cur5.userInfo) === null || _auth0InstanceRef$cur6 === void 0 ? void 0 : _auth0InstanceRef$cur6.call(_auth0InstanceRef$cur5, accessToken, (error, user) => {
      if (error) {
        return onFailure(error);
      }
      const {
        email,
        first_name,
        last_name,
        given_name,
        family_name
      } = user;
      loginDispatch === null || loginDispatch === void 0 ? void 0 : loginDispatch({
        type: HANDLE_SOCIAL_LOGIN,
        payload: {
          idpName: "auth0",
          idpToken: accessToken,
          ...((first_name || given_name) && {
            firstName: first_name || given_name
          }),
          ...((last_name || family_name) && {
            lastName: last_name || family_name
          }),
          email
        }
      });
      registerDispatch === null || registerDispatch === void 0 ? void 0 : registerDispatch({
        type: HANDLE_SOCIAL_LOGIN,
        payload: {
          idpName: "auth0",
          idpToken: accessToken,
          ...((first_name || given_name) && {
            firstName: first_name || given_name
          }),
          ...((last_name || family_name) && {
            lastName: last_name || family_name
          }),
          email
        }
      });
    });
  };
  const onFailure = error => {
    console.error(error);
  };
  if (auth0Enabled) {
    return /*#__PURE__*/React__default.createElement("button", {
      onClick: handleClick,
      className: `plc-flex plc-items-center plc-justify-center plc-p-3 plc-space-x-3 plc-text-gray-700 plc-border plc-border-gray-200 plc-rounded-3xl hover:plc-bg-gray-200 pelcro-auth0-login ${className}`
    }, /*#__PURE__*/React__default.createElement(SvgAuth0Logo, {
      className: `plc-w-6 plc-h-auto pelcro-auth0-login-icon" ${iconClassName}`
    }), /*#__PURE__*/React__default.createElement("p", {
      className: `pelcro-auth0-login-label ${labelClassName}`
    }, label));
  }
  return null;
};

/**
 *
 */
function LoginView(props) {
  var _window$Pelcro$site$r, _window$Pelcro$site$r2, _window$Pelcro$site$r3, _window$Pelcro$site$r4, _window$Pelcro, _window$Pelcro$uiSett;
  const {
    t
  } = useTranslation("login");
  const socialLoginEnabled = ((_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.facebook_app_id) || ((_window$Pelcro$site$r2 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r2 === void 0 ? void 0 : _window$Pelcro$site$r2.google_app_id) || ((_window$Pelcro$site$r3 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r3 === void 0 ? void 0 : _window$Pelcro$site$r3.auth0_client_id);
  const passwordlessEnabled = (_window$Pelcro$site$r4 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r4 === void 0 ? void 0 : _window$Pelcro$site$r4.passwordless_enabled;
  const enableLoginWithUsername = (_window$Pelcro = window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableLoginWithUsername;
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-login-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-2xl plc-font-semibold plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", null, t("messages.loginTo"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(LoginContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), enableLoginWithUsername ? /*#__PURE__*/React__default.createElement(LoginUsername, {
    id: "pelcro-input-username",
    errorId: "pelcro-input-username-error",
    required: true,
    label: t("labels.username"),
    autoFocus: true
  }) : /*#__PURE__*/React__default.createElement(LoginEmail, {
    id: "pelcro-input-email",
    errorId: "pelcro-input-email-error",
    required: true,
    label: t("labels.email"),
    autoFocus: true
  }), /*#__PURE__*/React__default.createElement(LoginPassword, {
    id: "pelcro-input-password",
    errorId: "pelcro-input-password-error",
    required: true,
    label: t("labels.password")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-flex-row-reverse"
  }, /*#__PURE__*/React__default.createElement(Link, {
    className: "plc-inline-flex plc-items-end plc-text-sm plc-cursor-default plc-h-9",
    id: "pelcro-link-forgot-password",
    onClick: props.onForgotPassword
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "plc-cursor-pointer"
  }, t("messages.forgotPassword")))), /*#__PURE__*/React__default.createElement(LoginButton, {
    role: "submit",
    className: "plc-w-full plc-mt-2",
    name: t("labels.login"),
    id: "pelcro-submit"
  }), socialLoginEnabled && /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mt-5"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-justify-between "
  }, /*#__PURE__*/React__default.createElement("hr", {
    className: "plc-w-full plc-border-gray-300"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "plc-flex-shrink-0 plc-p-2 plc-text-xs plc-text-gray-400 plc-uppercase"
  }, t("messages.socialLogin.label")), /*#__PURE__*/React__default.createElement("hr", {
    className: "plc-w-full plc-border-gray-300"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-justify-center plc-flex-wrap plc-px-5 plc-mt-1 plc-space-x-3"
  }, /*#__PURE__*/React__default.createElement(GoogleLoginButton, null), /*#__PURE__*/React__default.createElement(FacebookLoginButton, null), /*#__PURE__*/React__default.createElement(Auth0LoginButton, null))), passwordlessEnabled && /*#__PURE__*/React__default.createElement(LoginRequestLoginToken, {
    onClick: props.onPasswordlessRequest
  }))));
}

var _path$p, _path2$1, _path3;
function _extends$r() { _extends$r = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$r.apply(this, arguments); }
function SvgPelcroAuthorship(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$r({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -80.652 497.072 179.991"
  }, props), _path$p || (_path$p = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4a4a4a",
    d: "M487.89 42.299c0 13.158-10.671 23.829-23.829 23.829H37.074c-13.162 0-23.832-10.671-23.832-23.829v-63.552c0-13.158 10.67-23.831 23.832-23.831H464.06c13.158 0 23.829 10.672 23.829 23.831l.001 63.552z"
  })), _path2$1 || (_path2$1 = /*#__PURE__*/React.createElement("path", {
    d: "M46.875-5.564h7.294c.88 0 1.805.102 2.77.307s1.844.55 2.643 1.05 1.455 1.186 1.967 2.057.768 1.96.768 3.274c0 1.144-.207 2.132-.626 2.964s-.979 1.519-1.68 2.055-1.515.935-2.428 1.196c-.921.263-1.877.394-2.88.394h-5.468v12.009h-2.36V-5.564zm2.359 11.153h5.363a8.35 8.35 0 001.966-.232c.644-.155 1.216-.405 1.715-.751s.905-.805 1.219-1.377c.308-.572.464-1.273.464-2.107 0-.811-.163-1.501-.485-2.074s-.737-1.044-1.25-1.411-1.101-.638-1.769-.805a8.16 8.16 0 00-2.001-.252h-5.218l-.004 9.01zm16.625 5.897c0-1.262.212-2.423.642-3.484a8.39 8.39 0 011.787-2.755 7.967 7.967 0 012.754-1.803c1.073-.43 2.241-.642 3.502-.642s2.425.212 3.485.642a8.25 8.25 0 012.751 1.803c.775.771 1.378 1.692 1.805 2.755s.645 2.222.645 3.484-.217 2.428-.645 3.484-1.028 1.979-1.805 2.756a8.17 8.17 0 01-2.751 1.805c-1.061.428-2.223.641-3.485.641s-2.432-.213-3.502-.641c-1.073-.436-1.989-1.034-2.754-1.805-.762-.777-1.357-1.696-1.787-2.756s-.642-2.217-.642-3.484zm2.144 0c0 .932.148 1.809.447 2.631a6.18 6.18 0 001.306 2.146c.572.605 1.263 1.089 2.073 1.446s1.716.536 2.717.536 1.905-.179 2.717-.536 1.501-.84 2.071-1.446 1.007-1.324 1.305-2.146a7.66 7.66 0 00.446-2.631c0-.926-.149-1.803-.446-2.625s-.734-1.537-1.305-2.147-1.265-1.089-2.071-1.446c-.812-.36-1.717-.538-2.717-.538s-1.906.178-2.717.538-1.501.837-2.073 1.446a6.15 6.15 0 00-1.306 2.147 7.66 7.66 0 00-.447 2.625zm17.694-8.257h2.362l4.003 13.833h.071l4.612-13.833h2.039l4.896 13.833h.072l3.897-13.833h2.145l-4.859 16.514h-2.218L97.781 6.229h-.07L93.1 19.743h-2.214L85.697 3.229zm42.076 13.408c-.834 1.261-1.865 2.165-3.093 2.715s-2.582.825-4.058.825c-1.264 0-2.408-.217-3.431-.644a7.78 7.78 0 01-2.647-1.807c-.739-.777-1.305-1.695-1.7-2.751s-.59-2.234-.59-3.521c0-1.237.204-2.384.609-3.432s.978-1.962 1.715-2.734a8.06 8.06 0 012.61-1.825c.999-.437 2.108-.66 3.323-.66 1.266 0 2.377.223 3.342.66.965.444 1.775 1.026 2.431 1.754a7.4 7.4 0 011.483 2.483c.336.929.502 1.871.502 2.824v1.5h-13.871c0 .453.093 1.033.271 1.732.177.704.504 1.389.981 2.058s1.113 1.236 1.912 1.718c.798.475 1.829.712 3.094.712 1.095 0 2.158-.259 3.181-.787s1.808-1.238 2.358-2.146l1.578 1.326zm-1.645-6.543a4.84 4.84 0 00-.448-2.072 5.46 5.46 0 00-1.214-1.697 5.813 5.813 0 00-1.822-1.166 5.87 5.87 0 00-2.233-.429c-1.168 0-2.138.239-2.914.717s-1.389 1.021-1.84 1.644-.775 1.222-.967 1.802-.285.986-.285 1.197l11.723.004zm6.933-2.218l-.035-1.126-.052-1.336-.055-1.272-.035-.914h2.146l.053 1.787c.01.574.043.943.089 1.111.548-.979 1.249-1.777 2.108-2.396s1.907-.928 3.148-.928c.212 0 .423.016.624.055l.626.121-.249 2.111a2.53 2.53 0 00-.821-.146c-.93 0-1.734.146-2.414.448s-1.238.708-1.68 1.232-.768 1.137-.983 1.842-.321 1.46-.321 2.271v9.006h-2.146l-.003-11.866zm25.845 8.761c-.836 1.261-1.866 2.165-3.092 2.715s-2.58.825-4.059.825c-1.265 0-2.407-.217-3.431-.644a7.7 7.7 0 01-2.646-1.807 7.95 7.95 0 01-1.698-2.751c-.394-1.059-.59-2.234-.59-3.521 0-1.237.2-2.384.608-3.432s.978-1.962 1.717-2.734 1.609-1.383 2.609-1.825c.999-.437 2.107-.66 3.322-.66 1.264 0 2.376.223 3.344.66.963.444 1.773 1.026 2.429 1.754a7.49 7.49 0 011.485 2.483 8.34 8.34 0 01.498 2.824v1.5h-13.869c0 .453.089 1.033.268 1.732.178.704.506 1.389.983 2.058s1.111 1.236 1.91 1.718c.8.475 1.829.712 3.092.712 1.096 0 2.158-.259 3.183-.787s1.81-1.238 2.361-2.146l1.576 1.326zm-1.643-6.543c0-.739-.147-1.432-.447-2.072a5.58 5.58 0 00-1.215-1.697 5.875 5.875 0 00-4.054-1.595c-1.171 0-2.139.239-2.914.717s-1.387 1.021-1.84 1.644-.776 1.222-.968 1.802-.288.986-.288 1.197l11.727.004zm21.38 6.756h-.073a5.427 5.427 0 01-1.249 1.48 7.44 7.44 0 01-1.627 1.04 8.182 8.182 0 01-1.84.604 9.2 9.2 0 01-1.894.199c-1.264 0-2.432-.213-3.506-.641-1.071-.436-1.988-1.034-2.751-1.805-.76-.777-1.358-1.696-1.786-2.756s-.642-2.219-.642-3.484.212-2.423.642-3.484 1.026-1.979 1.786-2.755 1.68-1.378 2.751-1.803c1.074-.43 2.242-.642 3.506-.642.618 0 1.251.065 1.894.196a8.34 8.34 0 011.84.606 7.65 7.65 0 011.627 1.038 5.58 5.58 0 011.249 1.484h.073V-7.278h2.143v27.023h-2.143V16.85zm.211-5.364c0-.926-.177-1.803-.536-2.625a6.7 6.7 0 00-1.467-2.147c-.617-.609-1.344-1.089-2.181-1.446s-1.738-.538-2.714-.538c-1.002 0-1.908.178-2.717.538s-1.504.837-2.076 1.446a6.16 6.16 0 00-1.305 2.147 7.65 7.65 0 00-.446 2.625 7.66 7.66 0 00.446 2.631c.298.822.734 1.537 1.305 2.146s1.266 1.089 2.076 1.446 1.715.536 2.717.536c.976 0 1.88-.179 2.714-.536s1.563-.84 2.181-1.446 1.109-1.324 1.467-2.146a6.5 6.5 0 00.536-2.631zm16.015-18.764h2.146V6.126h.068a5.64 5.64 0 011.255-1.484 7.606 7.606 0 011.626-1.038 8.22 8.22 0 011.84-.606 9.56 9.56 0 011.895-.196c1.263 0 2.422.212 3.486.642s1.976 1.032 2.75 1.803a8.18 8.18 0 011.806 2.755c.43 1.061.645 2.222.645 3.484s-.217 2.428-.645 3.484a8.28 8.28 0 01-1.806 2.756c-.773.777-1.691 1.376-2.75 1.805s-2.224.641-3.486.641a9.194 9.194 0 01-1.895-.199c-.644-.13-1.256-.332-1.84-.604s-1.128-.618-1.626-1.04a5.56 5.56 0 01-1.255-1.48h-.068v2.893h-2.146v-27.02zm1.932 18.764c0 .932.177 1.809.538 2.631a6.7 6.7 0 001.464 2.146 7.018 7.018 0 002.182 1.446 6.85 6.85 0 002.715.536c1.003 0 1.907-.179 2.718-.536s1.501-.84 2.071-1.446a6.12 6.12 0 001.306-2.146 7.636 7.636 0 00.447-2.631c0-.926-.148-1.803-.447-2.625s-.733-1.537-1.306-2.147-1.263-1.089-2.071-1.446-1.715-.538-2.718-.538c-.978 0-1.879.178-2.715.538a6.96 6.96 0 00-2.182 1.446 6.725 6.725 0 00-1.464 2.147 6.46 6.46 0 00-.538 2.625zm25.023 13.37c-.405 1.073-.966 1.921-1.681 2.541s-1.668.93-2.858.93a6.71 6.71 0 01-1.072-.093 8.006 8.006 0 01-1.035-.233l.21-2 .951.264a3.64 3.64 0 00.982.127c.379 0 .72-.082 1.017-.251a2.61 2.61 0 00.771-.64c.212-.262.396-.55.554-.881a9.86 9.86 0 00.409-.974l1.504-3.827-6.722-16.59h2.394l5.473 13.907 5.325-13.907h2.289l-8.511 21.627z",
    fill: "#4a4a4a"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M286.638-13.196a1.37 1.37 0 00-.193-.016h-23.102c-.679 0-1.227.574-1.227 1.281V8.757l-.065 1.768.065 1.768v.033a1.67 1.67 0 00.019.251c1.043 12.146 11.231 21.684 23.65 21.684 13.106 0 23.734-10.627 23.734-23.736a23.74 23.74 0 00-22.881-23.721zm6.04 40.957h-2.92V-2.211H287.1v29.984h-2.705V8.958c-1.064-.079-3.329-.868-3.329-.868-2.471-.462-4.353-2.985-4.353-6.025 0-2.973 1.804-5.451 4.183-5.99.145-.292 2.472-.422 3.499-.466v-.021h8.28l.003 32.174zm26.896 3.183V-7.805h13.507c4.715 0 8.079.79 10.096 2.37s3.022 4.219 3.022 7.919c0 4.189-1.347 7.449-4.041 9.779-2.701 2.329-6.473 3.496-11.327 3.496h-3.35v15.186h-7.907v-.001zm7.901-20.5h1.575c2.756 0 4.933-.643 6.534-1.926 1.595-1.281 2.394-3.021 2.394-5.22 0-3.86-2.452-5.787-7.357-5.787h-3.139l-.007 12.933zM370.8 29.971c-3.684 1.087-7.172 1.628-10.47 1.628-4.801 0-8.59-1.362-11.361-4.087-2.778-2.725-4.167-6.446-4.167-11.157 0-4.449 1.274-8.031 3.81-10.747s5.896-4.071 10.069-4.071c4.202 0 7.276 1.328 9.212 3.982s2.903 6.849 2.903 12.595h-17.83c.528 5.48 3.541 8.22 9.033 8.22 2.6 0 5.539-.6 8.797-1.81v5.446h.004zM352.869 13.74h10.315c0-4.903-1.579-7.357-4.739-7.357-3.211 0-5.068 2.453-5.576 7.357zm21.39 17.204v-41.343h7.748v41.343h-7.748zm34.241-.63c-3.209.855-6.185 1.284-8.923 1.284-4.593 0-8.22-1.351-10.881-4.044-2.664-2.701-3.995-6.368-3.995-11.011 0-4.696 1.373-8.369 4.115-11.021 2.734-2.655 6.526-3.982 11.364-3.982 2.33 0 5.036.375 8.086 1.127v5.601c-3.171-1.028-5.714-1.544-7.617-1.544-2.322 0-4.188.89-5.603 2.671s-2.118 4.143-2.118 7.093c0 3.021.764 5.443 2.286 7.259 1.531 1.811 3.567 2.723 6.118 2.723 2.318 0 4.709-.51 7.173-1.521v5.367h-.005zm2.108.63V2.194h7.751v5.419c2.004-4.049 5.059-6.073 9.16-6.073.49 0 .97.051 1.44.158V8.61c-1.1-.401-2.12-.599-3.062-.599-3.09 0-5.604 1.56-7.538 4.684v18.25h-7.751v-.001zm32.258.655c-4.486 0-8.056-1.356-10.696-4.072s-3.967-6.368-3.967-10.959c0-4.644 1.329-8.308 3.99-10.994s6.278-4.034 10.857-4.034c4.586 0 8.214 1.344 10.873 4.034s3.997 6.336 3.997 10.943c0 4.711-1.336 8.404-4.01 11.072-2.668 2.673-6.353 4.01-11.044 4.01zm.124-4.845c4.459 0 6.678-3.411 6.678-10.237 0-3.125-.59-5.596-1.765-7.41s-2.802-2.724-4.858-2.724c-2.044 0-3.652.909-4.83 2.724s-1.766 4.304-1.766 7.461c0 3.124.582 5.607 1.754 7.435 1.17 1.837 2.768 2.751 4.787 2.751z",
    fill: "#4c4c4c"
  })));
}

const Authorship = () => {
  return /*#__PURE__*/React__default.createElement("a", {
    href: `https://www.pelcro.com/?utm_source=${window.location.hostname}&utm_medium=direct&utm_campaign=powered_by_pelcro`,
    rel: "noopener noreferrer nofollow",
    target: "_blank"
  }, /*#__PURE__*/React__default.createElement(SvgPelcroAuthorship, {
    className: "plc-h-12 pelcro-authorship"
  }));
};

/**
 *
 */
function Modal(_ref) {
  var _window$Pelcro, _window$Pelcro$site$r;
  let {
    id,
    onDisplay,
    className = "",
    hideCloseButton = !window.Pelcro.paywall.displayCloseButton(),
    children,
    ...props
  } = _ref;
  const resetView = usePelcro(state => state.resetView);
  useEffect(() => {
    onDisplay === null || onDisplay === void 0 ? void 0 : onDisplay();
    dispatchModalDisplayEvents(id);
  }, []);
  const onClose = () => {
    var _props$onClose;
    props === null || props === void 0 ? void 0 : (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
    resetView();
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "pelcro-modal-overlay"
  }, /*#__PURE__*/React__default.createElement("div", Object.assign({
    className: `pelcro-modal ${className}`,
    role: "dialog",
    "aria-modal": "true",
    id: id
  }, props), /*#__PURE__*/React__default.createElement("div", {
    className: "pelcro-modal-content"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pelcro-modal-header"
  }, !hideCloseButton && /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "pelcro-modal-close",
    "aria-label": "close modal",
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement(SvgXIcon, {
    className: "plc-fill-current"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-justify-center plc-w-full"
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "business logo",
    className: `plc-max-h-14 plc-mt-2 pelcro-modal-logo ${(_window$Pelcro = window.Pelcro) !== null && _window$Pelcro !== void 0 && _window$Pelcro._showModalHeader ? "" : "plc-hidden"}`,
    src: (_window$Pelcro$site$r = window.Pelcro.site.read().logo) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.url
  }))), children.find(_ref2 => {
    let {
      type
    } = _ref2;
    return type === ModalBody;
  }), children.find(_ref3 => {
    let {
      type
    } = _ref3;
    return type === ModalFooter;
  }))));
}
const ModalBody = _ref4 => {
  let {
    children
  } = _ref4;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "pelcro-modal-body"
  }, children);
};
const ModalFooter = _ref5 => {
  let {
    children
  } = _ref5;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "pelcro-modal-footer"
  }, children);
};

/**
 *
 */
function LoginModal(_ref) {
  let {
    onDisplay,
    onClose,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation("login");
  const {
    switchView,
    resetView,
    product,
    plan,
    order,
    switchToAddressView,
    switchToPaymentView,
    giftCode,
    isGift
  } = usePelcro();
  const onSuccess = res => {
    var _props$onSuccess;
    (_props$onSuccess = props.onSuccess) === null || _props$onSuccess === void 0 ? void 0 : _props$onSuccess.call(props, res);
    handleAfterLoginLogic();
  };
  const handleAfterLoginLogic = () => {
    if (window.Pelcro.paywall.isArticleRestricted()) {
      initPaywalls();
    }
    if (!product && !order && !giftCode) {
      // If product and plan are not selected
      return resetView();
    }

    // If this is a redeem gift
    if (giftCode) {
      return switchView("gift-redeem");
      // return switchToAddressView();
    }

    // Check if the subscription is meant as a gift (if so, gather recipients info)
    if (isGift) {
      return switchView("gift-create");
    }
    if (order) {
      return switchToAddressView();
    }
    if (product && plan) {
      if (product.address_required) {
        return switchToAddressView();
      } else {
        return switchToPaymentView();
      }
    }
    if (product && !plan) {
      return switchView("plan-select");
    }
    const viewFromURL = getStableViewID(window.Pelcro.helpers.getURLParameter("view"));
    const viewsURLs = ["invoice-details", "gift-redeem", "plan-select", "payment-method-update"];
    if (viewsURLs.includes(viewFromURL)) {
      return initViewFromURL();
    }
    return resetView();
  };
  const onCreateAccountClick = () => {
    switchView("plan-select");
  };
  const onForgotPassword = () => {
    switchView("password-forgot");
  };
  const onPasswordlessRequest = () => {
    switchView("passwordless-request");
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-login-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(LoginView, Object.assign({
    onForgotPassword: onForgotPassword
  }, props, {
    onSuccess: onSuccess,
    onPasswordlessRequest: onPasswordlessRequest
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement("div", null, t("messages.dontHaveAccount") + " ", /*#__PURE__*/React__default.createElement(Link, {
    id: "pelcro-link-create-account",
    onClick: onCreateAccountClick
  }, t("messages.createAccount"))), /*#__PURE__*/React__default.createElement(Authorship, null)));
}
LoginModal.viewId = "login";

const RegisterEmail = props => /*#__PURE__*/React__default.createElement(Email, Object.assign({
  store: store$m
}, props));

const RegisterPassword = props => /*#__PURE__*/React__default.createElement(Password, Object.assign({
  store: store$m
}, props));

const RegisterButton = _ref => {
  var _window$Pelcro$site$r;
  let {
    name,
    onClick,
    className,
    ...otherProps
  } = _ref;
  const {
    state: {
      emailError,
      passwordError,
      email,
      password,
      buttonDisabled
    },
    dispatch
  } = useContext(store$m);
  const {
    t
  } = useTranslation("register");
  const [isDisabled, setDisabled] = useState(true);
  useEffect(() => {
    setDisabled(buttonDisabled || emailError || passwordError || !email.length || !password.length);
  }, [buttonDisabled, emailError, passwordError, email, password]);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_REGISTRATION
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: isDisabled,
    isLoading: buttonDisabled,
    className: `${className} g-recaptcha`,
    "data-action": "register",
    "data-sitekey": (_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.security_key
  }, otherProps), name !== null && name !== void 0 ? name : t("messages.createAccount"));
};

function FirstName(_ref) {
  let {
    initWithUserFirstName = true,
    store,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("common");
  const {
    dispatch,
    state: {
      firstName: stateFirstName,
      firstNameError
    }
  } = useContext(store);
  const [firstName, setFirstName] = useState(stateFirstName);
  const [finishedTyping, setFinishedTyping] = useState(false);
  const handleInputChange = useCallback(value => {
    setFirstName(value);
    if (finishedTyping) {
      if (firstName !== null && firstName !== void 0 && firstName.length) {
        dispatch({
          type: SET_FIRST_NAME,
          payload: firstName
        });
      } else {
        if (otherProps.required) {
          dispatch({
            type: SET_FIRST_NAME_ERROR,
            payload: t("validation.enterFirstName")
          });
        } else {
          dispatch({
            type: SET_FIRST_NAME,
            payload: firstName
          });
        }
      }
    }
  }, [dispatch, firstName, finishedTyping]);
  useEffect(() => {
    handleInputChange(firstName);
  }, [finishedTyping, firstName, handleInputChange]);

  // Initialize first name field with user's first name
  const loadFirstNameIntoField = () => {
    handleInputChange(window.Pelcro.user.read().first_name);
    dispatch({
      type: SET_FIRST_NAME,
      payload: window.Pelcro.user.read().first_name
    });
  };
  useEffect(() => {
    if (initWithUserFirstName) {
      document.addEventListener("PelcroUserLoaded", () => {
        loadFirstNameIntoField();
      });
      loadFirstNameIntoField();
      return () => {
        document.removeEventListener("PelcroUserLoaded", handleInputChange);
      };
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    error: firstNameError,
    value: firstName,
    onChange: e => handleInputChange(e.target.value),
    onBlur: () => setFinishedTyping(true),
    onFocus: () => setFinishedTyping(false)
  }, otherProps));
}

const RegisterFirstName = props => /*#__PURE__*/React__default.createElement(FirstName, Object.assign({
  store: store$m
}, props));

function LastName(_ref) {
  let {
    initWithUserLastName = true,
    store,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("common");
  const {
    dispatch,
    state: {
      lastName: stateLastName,
      lastNameError
    }
  } = useContext(store);
  const [lastName, setLastName] = useState(stateLastName);
  const [finishedTyping, setFinishedTyping] = useState(false);
  const handleInputChange = useCallback(value => {
    setLastName(value);
    if (finishedTyping) {
      if (lastName !== null && lastName !== void 0 && lastName.length) {
        dispatch({
          type: SET_LAST_NAME,
          payload: lastName
        });
      } else {
        if (otherProps.required) {
          dispatch({
            type: SET_LAST_NAME_ERROR,
            payload: t("validation.enterLastName")
          });
        } else {
          dispatch({
            type: SET_LAST_NAME,
            payload: lastName
          });
        }
      }
    }
  }, [dispatch, lastName, finishedTyping]);
  useEffect(() => {
    handleInputChange(lastName);
  }, [finishedTyping, lastName, handleInputChange]);

  // Initialize last name field with user's last name
  const loadLastNameIntoField = () => {
    handleInputChange(window.Pelcro.user.read().last_name);
    dispatch({
      type: SET_LAST_NAME,
      payload: window.Pelcro.user.read().last_name
    });
  };
  useEffect(() => {
    if (initWithUserLastName) {
      document.addEventListener("PelcroUserLoaded", () => {
        loadLastNameIntoField();
      });
      loadLastNameIntoField();
      return () => {
        document.removeEventListener("PelcroUserLoaded", handleInputChange);
      };
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    error: lastNameError,
    value: lastName,
    onChange: e => handleInputChange(e.target.value),
    onBlur: () => setFinishedTyping(true),
    onFocus: () => setFinishedTyping(false)
  }, otherProps));
}

const RegisterLastName = props => /*#__PURE__*/React__default.createElement(LastName, Object.assign({
  store: store$m
}, props));

function Phone(_ref) {
  let {
    initWithUserPhone = true,
    store,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("common");
  const {
    dispatch,
    state: {
      phone: statePhone,
      phoneError
    }
  } = useContext(store);
  const [phone, setPhone] = useState(statePhone);
  const [finishedTyping, setFinishedTyping] = useState(false);
  const handleInputChange = useCallback(value => {
    setPhone(value);
    if (finishedTyping) {
      if (phone !== null && phone !== void 0 && phone.length) {
        dispatch({
          type: SET_PHONE,
          payload: phone
        });
      } else {
        if (otherProps.required) {
          dispatch({
            type: SET_PHONE_ERROR,
            payload: t("validation.enterPhone")
          });
        } else {
          dispatch({
            type: SET_PHONE,
            payload: phone
          });
        }
      }
    }
  }, [dispatch, phone, finishedTyping]);
  useEffect(() => {
    handleInputChange(phone);
  }, [finishedTyping, phone, handleInputChange]);

  // Initialize phone field with user's phone
  const loadPhoneIntoField = () => {
    handleInputChange(window.Pelcro.user.read().phone);
    dispatch({
      type: SET_PHONE,
      payload: window.Pelcro.user.read().phone
    });
  };
  useEffect(() => {
    if (initWithUserPhone) {
      document.addEventListener("PelcroUserLoaded", () => {
        loadPhoneIntoField();
      });
      loadPhoneIntoField();
      return () => {
        document.removeEventListener("PelcroUserLoaded", handleInputChange);
      };
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "tel",
    error: phoneError,
    value: phone,
    onChange: e => handleInputChange(e.target.value),
    onBlur: () => setFinishedTyping(true),
    onFocus: () => setFinishedTyping(false)
  }, otherProps));
}

/**
 *
 */
function RegisterView(props) {
  var _product$paywall$regi, _product$paywall, _product$paywall$regi2, _product$paywall2, _window$Pelcro$site$r, _window$Pelcro$site$r2, _window$Pelcro$site$r3, _window$Pelcro, _window$Pelcro$uiSett;
  const {
    t
  } = useTranslation("register");
  const {
    product
  } = usePelcro();
  const title = (_product$paywall$regi = product === null || product === void 0 ? void 0 : (_product$paywall = product.paywall) === null || _product$paywall === void 0 ? void 0 : _product$paywall.register_title) !== null && _product$paywall$regi !== void 0 ? _product$paywall$regi : t("title");
  const subtitle = (_product$paywall$regi2 = product === null || product === void 0 ? void 0 : (_product$paywall2 = product.paywall) === null || _product$paywall2 === void 0 ? void 0 : _product$paywall2.register_subtitle) !== null && _product$paywall$regi2 !== void 0 ? _product$paywall$regi2 : t("subtitle");
  const socialLoginEnabled = ((_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.facebook_app_id) || ((_window$Pelcro$site$r2 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r2 === void 0 ? void 0 : _window$Pelcro$site$r2.google_app_id) || ((_window$Pelcro$site$r3 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r3 === void 0 ? void 0 : _window$Pelcro$site$r3.auth0_client_id);
  const showNameFields = (_window$Pelcro = window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableNameFieldsInRegister;
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-register-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, title), /*#__PURE__*/React__default.createElement("p", null, subtitle)), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(RegisterContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), showNameFields && /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start"
  }, /*#__PURE__*/React__default.createElement(RegisterFirstName, {
    id: "pelcro-input-first-name",
    label: t("labels.firstName"),
    errorId: "pelcro-input-firstName-error"
  }), /*#__PURE__*/React__default.createElement(RegisterLastName, {
    wrapperClassName: "plc-ml-3",
    id: "pelcro-input-last-name",
    label: t("labels.lastName"),
    errorId: "pelcro-input-lastName-error"
  })), /*#__PURE__*/React__default.createElement(RegisterEmail, {
    id: "pelcro-input-email",
    errorId: "pelcro-input-email-error",
    label: t("labels.email"),
    required: true,
    autoFocus: true
  }), /*#__PURE__*/React__default.createElement(RegisterPassword, {
    id: "pelcro-input-password",
    errorId: "pelcro-input-password-error",
    label: t("labels.password"),
    required: true
  }), /*#__PURE__*/React__default.createElement(RegisterButton, {
    role: "submit",
    className: "plc-w-full plc-mt-2",
    id: "pelcro-submit",
    name: t("messages.createAccount")
  }), hasSecurityTokenEnabled() && /*#__PURE__*/React__default.createElement("p", {
    className: "plc-text-sm plc-text-gray-500 plc-mt-1"
  }, /*#__PURE__*/React__default.createElement(Trans, {
    i18nKey: "messages:recaptcha"
  }, "This site is protected by reCAPTCHA and the Google", /*#__PURE__*/React__default.createElement(Link, {
    href: "https://policies.google.com/privacy",
    className: "plc-text-sm plc-text-gray-500"
  }, "Privacy Policy"), "and", /*#__PURE__*/React__default.createElement(Link, {
    href: "https://policies.google.com/terms",
    className: "plc-text-sm plc-text-gray-500"
  }, "Terms of Service"), "apply.")), socialLoginEnabled && /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mt-5"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-justify-between "
  }, /*#__PURE__*/React__default.createElement("hr", {
    className: "plc-w-full plc-border-gray-300"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "plc-flex-shrink-0 plc-p-2 plc-text-xs plc-text-gray-400 plc-uppercase"
  }, t("messages.socialLogin.label")), /*#__PURE__*/React__default.createElement("hr", {
    className: "plc-w-full plc-border-gray-300"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-justify-center plc-px-5 plc-mt-1 plc-space-x-3"
  }, /*#__PURE__*/React__default.createElement(GoogleLoginButton, null), /*#__PURE__*/React__default.createElement(FacebookLoginButton, null), /*#__PURE__*/React__default.createElement(Auth0LoginButton, null))))));
}

/**
 * Checks if the current site has security token enabled
 * @return {boolean}
 */
function hasSecurityTokenEnabled() {
  var _window$Pelcro$site, _window$Pelcro$site$r4;
  return Boolean((_window$Pelcro$site = window.Pelcro.site) === null || _window$Pelcro$site === void 0 ? void 0 : (_window$Pelcro$site$r4 = _window$Pelcro$site.read()) === null || _window$Pelcro$site$r4 === void 0 ? void 0 : _window$Pelcro$site$r4.security_key);
}

const Loader = props => /*#__PURE__*/React__default.createElement("div", {
  className: `pelcro-loader-wrapper ${props.className}`
}, /*#__PURE__*/React__default.createElement("svg", {
  width: props.width,
  height: props.height,
  viewBox: "0 0 120 30",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  "aria-label": props.label
}, /*#__PURE__*/React__default.createElement("circle", {
  cx: "15",
  cy: "15",
  r: props.radius + 6
}, /*#__PURE__*/React__default.createElement("animate", {
  attributeName: "r",
  from: "15",
  to: "15",
  begin: "0s",
  dur: "0.8s",
  values: "15;9;15",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React__default.createElement("animate", {
  attributeName: "fillOpacity",
  from: "1",
  to: "1",
  begin: "0s",
  dur: "0.8s",
  values: "1;.5;1",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React__default.createElement("circle", {
  cx: "60",
  cy: "15",
  r: props.radius,
  attributeName: "fillOpacity",
  from: "1",
  to: "0.3"
}, /*#__PURE__*/React__default.createElement("animate", {
  attributeName: "r",
  from: "9",
  to: "9",
  begin: "0s",
  dur: "0.8s",
  values: "9;15;9",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React__default.createElement("animate", {
  attributeName: "fillOpacity",
  from: "0.5",
  to: "0.5",
  begin: "0s",
  dur: "0.8s",
  values: ".5;1;.5",
  calcMode: "linear",
  repeatCount: "indefinite"
})), /*#__PURE__*/React__default.createElement("circle", {
  cx: "105",
  cy: "15",
  r: props.radius + 6
}, /*#__PURE__*/React__default.createElement("animate", {
  attributeName: "r",
  from: "15",
  to: "15",
  begin: "0s",
  dur: "0.8s",
  values: "15;9;15",
  calcMode: "linear",
  repeatCount: "indefinite"
}), /*#__PURE__*/React__default.createElement("animate", {
  attributeName: "fillOpacity",
  from: "1",
  to: "1",
  begin: "0s",
  dur: "0.8s",
  values: "1;.5;1",
  calcMode: "linear",
  repeatCount: "indefinite"
}))));
Loader.defaultProps = {
  height: 50,
  width: 35,
  color: "#32aea1",
  label: "Loading data..",
  radius: 9
};

function TextInput(_ref) {
  var _window$Pelcro$user$r, _window$Pelcro$user$r2;
  let {
    store,
    fieldName,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state
  } = useContext(store);
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        [fieldName]: value
      }
    });
  };
  if (state.loading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    value: state[fieldName],
    defaultValue: (_window$Pelcro$user$r = window.Pelcro.user.read()) === null || _window$Pelcro$user$r === void 0 ? void 0 : (_window$Pelcro$user$r2 = _window$Pelcro$user$r.metadata) === null || _window$Pelcro$user$r2 === void 0 ? void 0 : _window$Pelcro$user$r2[fieldName],
    onChange: e => handleInputChange(e.target.value)
  }, otherProps));
}

const RegisterTextInput = props => {
  return /*#__PURE__*/React__default.createElement(TextInput, Object.assign({}, props, {
    store: store$m
  }));
};

const RegisterJobTitle = props => {
  return /*#__PURE__*/React__default.createElement(RegisterTextInput, Object.assign({
    fieldName: "jobTitle"
  }, props));
};

const RegisterCompany = props => {
  return /*#__PURE__*/React__default.createElement(RegisterTextInput, Object.assign({
    fieldName: "organization"
  }, props));
};

/**
 *
 */
function RegisterModal(props) {
  var _window, _window$Pelcro, _window$Pelcro$uiSett;
  const {
    t
  } = useTranslation("register");
  const {
    switchView,
    resetView,
    switchToAddressView,
    switchToPaymentView,
    product,
    plan,
    order,
    giftCode,
    isGift
  } = usePelcro();
  const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
  const onSuccess = res => {
    var _props$onSuccess;
    (_props$onSuccess = props.onSuccess) === null || _props$onSuccess === void 0 ? void 0 : _props$onSuccess.call(props, res);
    handleAfterRegistrationLogic();
  };
  const handleAfterRegistrationLogic = () => {
    var _window$Pelcro$site$r, _window$Pelcro$site$r2;
    if (enableReactGA4) {
      ReactGA4.event("Registered", {
        nonInteraction: true
      });
    } else {
      var _ReactGA$event;
      ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
        category: "ACTIONS",
        action: "Registered",
        nonInteraction: true
      });
    }
    const isEmailVerificationEnabled = (_window$Pelcro$site$r = (_window$Pelcro$site$r2 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r2 === void 0 ? void 0 : _window$Pelcro$site$r2.email_verify_enabled) !== null && _window$Pelcro$site$r !== void 0 ? _window$Pelcro$site$r : false;
    if (isEmailVerificationEnabled) {
      return switchView("email-verify");
    }
    if (!product && !order && !giftCode) {
      // If product and plan are not selected
      return resetView();
    }

    // If this is a redeem gift
    if (giftCode) {
      return switchView("gift-redeem");
      // return switchToAddressView();
    }

    // Check if the subscription is meant as a gift (if so, gather recipients info)
    if (isGift) {
      return switchView("gift-create");
    }
    if (order) {
      return switchToAddressView();
    }
    if (product && plan) {
      if (product.address_required) {
        return switchToAddressView();
      } else {
        return switchToPaymentView();
      }
    }
    if (product && !plan) {
      return switchView("plan-select");
    }
    return resetView();
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-register-modal",
    onDisplay: props === null || props === void 0 ? void 0 : props.onDisplay,
    onClose: props === null || props === void 0 ? void 0 : props.onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(RegisterView, Object.assign({}, props, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement("p", null, t("messages.alreadyHaveAccount") + " ", /*#__PURE__*/React__default.createElement(Link, {
    onClick: () => switchView("login")
  }, t("messages.loginHere"))), /*#__PURE__*/React__default.createElement(Authorship, null)));
}
RegisterModal.viewId = "register";

function Checkbox(_ref) {
  let {
    className = "",
    labelClassName = "",
    id,
    children,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center"
  }, /*#__PURE__*/React__default.createElement("input", Object.assign({
    type: "checkbox",
    id: id,
    className: `pelcro-checkbox ${className}`
  }, otherProps)), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: `pelcro-checkbox-label ${labelClassName}`
  }, children));
}

function Radio(_ref) {
  let {
    className = "",
    labelClassName = "",
    id,
    children,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center"
  }, /*#__PURE__*/React__default.createElement("input", Object.assign({
    type: "radio",
    id: id,
    className: `pelcro-radio ${className}`
  }, otherProps)), /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: `pelcro-radio-label ${labelClassName}`
  }, children));
}

/**
 *
 */
function SelectModalWithHook(props) {
  React__default.useEffect(() => {
    var _props$onDisplay;
    (_props$onDisplay = props.onDisplay) === null || _props$onDisplay === void 0 ? void 0 : _props$onDisplay.call(props);
  }, []);
  const {
    isGift,
    plan,
    product,
    isRenewingGift,
    switchView,
    resetView,
    view,
    set
  } = usePelcro();
  const entitlementsProtectedElements = document.querySelectorAll("[data-pelcro-entitlements]");
  const entitlements = entitlementsProtectedElements.length > 0 ? getEntitlementsFromElem(entitlementsProtectedElements[0]) : null;
  return /*#__PURE__*/React__default.createElement(SelectModalWithTrans, {
    isGift: isGift,
    disableGifting: isRenewingGift,
    plan: plan,
    product: product,
    onClose: () => {
      var _props$onClose;
      (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
      resetView();
    },
    setProductAndPlan: (product, plan, isGift) => set({
      product,
      plan,
      isGift
    }),
    setView: switchView,
    matchingEntitlements: view === "_plan-select-entitlements" ? entitlements : null
  });
}
function productsWithMatchedTaggedFirst() {
  var _window$Pelcro$produc;
  const allProducts = (_window$Pelcro$produc = window.Pelcro.product.list()) !== null && _window$Pelcro$produc !== void 0 ? _window$Pelcro$produc : [];
  const productsThatMatchArticleTag = window.Pelcro.product.getByMatchingPageTags();
  const allProductsMinusMatched = allProducts.filter(product => !productsThatMatchArticleTag.some(matchedProduct => matchedProduct.id === product.id));
  return [productsThatMatchArticleTag, allProductsMinusMatched];
}
function productMatchPageLanguage(product) {
  if (!product) {
    return false;
  }
  if (product.language === null) {
    return true;
  }
  const siteLanguage = window.Pelcro.helpers.getHtmlLanguageAttribute();
  return product.language === siteLanguage;
}
SelectModalWithHook.viewId = "plan-select";
class SelectModal extends Component {
  constructor(props) {
    var _window, _window$Pelcro11, _window$Pelcro11$uiSe;
    super(props);
    _defineProperty$3(this, "componentDidMount", () => {
      if (this.props.product) {
        const {
          product
        } = this.props;
        const planList = product.plans;
        this.setState({
          product,
          planList,
          mode: "plan"
        });
      }
      if (this.props.plan) {
        const {
          plan
        } = this.props;
        this.setState({
          plan,
          disabled: false
        });
      }
      if (this.state.productList.length === 1) {
        this.setState({
          product: this.state.productList[0],
          planList: this.state.productList[0].plans,
          mode: "plan"
        });
      }
      if (this.state.productList.length === 0 && !window.Pelcro.user.isAuthenticated()) {
        this.props.setView("register");
      }
      document.addEventListener("keydown", this.handleSubmit);
      if (!document.querySelector("#pelcro-selection-view") || !document.querySelector(".pelcro-select-product-wrapper")) {
        var _window$Pelcro, _window$Pelcro$user, _window$Pelcro2, _window$Pelcro2$user, _window$Pelcro3, _window$Pelcro3$user, _window$Pelcro4, _window$Pelcro4$site;
        const userCurrency = (_window$Pelcro = window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$user = _window$Pelcro.user) === null || _window$Pelcro$user === void 0 ? void 0 : _window$Pelcro$user.read().currency;
        const userCountry = (_window$Pelcro2 = window.Pelcro) === null || _window$Pelcro2 === void 0 ? void 0 : (_window$Pelcro2$user = _window$Pelcro2.user) === null || _window$Pelcro2$user === void 0 ? void 0 : _window$Pelcro2$user.location.countryCode;
        const userLanguage = (_window$Pelcro3 = window.Pelcro) === null || _window$Pelcro3 === void 0 ? void 0 : (_window$Pelcro3$user = _window$Pelcro3.user) === null || _window$Pelcro3$user === void 0 ? void 0 : _window$Pelcro3$user.read().language;
        const productsMatchingUserCurrency = (_window$Pelcro4 = window.Pelcro) === null || _window$Pelcro4 === void 0 ? void 0 : (_window$Pelcro4$site = _window$Pelcro4.site) === null || _window$Pelcro4$site === void 0 ? void 0 : _window$Pelcro4$site.read().products.filter(product => {
          const filteredPlans = product.plans.filter(plan => plan.currency === userCurrency || !userCurrency);
          if (filteredPlans.length) return filteredPlans;
        });
        const productsMatchingUserCountry = productsMatchingUserCurrency.filter(product => {
          const filteredPlans = product.plans.filter(plan => {
            var _plan$countries;
            return plan.countries && ((_plan$countries = plan.countries) === null || _plan$countries === void 0 ? void 0 : _plan$countries.includes(userCountry)) || !plan.countries || !plan.countries.length;
          });
          if (filteredPlans.length) return filteredPlans;
        });
        notifyBugsnag(() => {
          Bugsnag.notify("SelectModal - No data viewed", event => {
            var _window$Pelcro5, _window$Pelcro5$site, _window$Pelcro6, _window$Pelcro6$user, _window$Pelcro7, _window$Pelcro7$uiSet, _window$Pelcro8, _this$props, _window$Pelcro9, _window$Pelcro9$helpe, _window$Pelcro10, _window$Pelcro10$site;
            event.addMetadata("MetaData", {
              site: (_window$Pelcro5 = window.Pelcro) === null || _window$Pelcro5 === void 0 ? void 0 : (_window$Pelcro5$site = _window$Pelcro5.site) === null || _window$Pelcro5$site === void 0 ? void 0 : _window$Pelcro5$site.read(),
              user: (_window$Pelcro6 = window.Pelcro) === null || _window$Pelcro6 === void 0 ? void 0 : (_window$Pelcro6$user = _window$Pelcro6.user) === null || _window$Pelcro6$user === void 0 ? void 0 : _window$Pelcro6$user.read(),
              uiVersion: (_window$Pelcro7 = window.Pelcro) === null || _window$Pelcro7 === void 0 ? void 0 : (_window$Pelcro7$uiSet = _window$Pelcro7.uiSettings) === null || _window$Pelcro7$uiSet === void 0 ? void 0 : _window$Pelcro7$uiSet.uiVersion,
              environment: (_window$Pelcro8 = window.Pelcro) === null || _window$Pelcro8 === void 0 ? void 0 : _window$Pelcro8.environment,
              matchingEntitlementsProps: (_this$props = this.props) === null || _this$props === void 0 ? void 0 : _this$props.matchingEntitlements,
              productListState: this.state.productList,
              methods: {
                productsWithMatchedTaggedFirst: productsWithMatchedTaggedFirst(),
                pelcroSDKProductsListMethod: window.Pelcro.product.list(),
                pelcroSDKGetByEntitlements: this.props.matchingEntitlements ? window.Pelcro.product.getByEntitlements(this.props.matchingEntitlements) : null
              },
              userCurrency: userCurrency,
              userCountry: userCountry,
              userLanguage: userLanguage,
              siteLanguage: (_window$Pelcro9 = window.Pelcro) === null || _window$Pelcro9 === void 0 ? void 0 : (_window$Pelcro9$helpe = _window$Pelcro9.helpers) === null || _window$Pelcro9$helpe === void 0 ? void 0 : _window$Pelcro9$helpe.getHtmlLanguageAttribute(),
              products: (_window$Pelcro10 = window.Pelcro) === null || _window$Pelcro10 === void 0 ? void 0 : (_window$Pelcro10$site = _window$Pelcro10.site) === null || _window$Pelcro10$site === void 0 ? void 0 : _window$Pelcro10$site.read().products.length,
              currency_matching_filter: `${productsMatchingUserCurrency.length} Products Passed`,
              country_matching_filter: `${productsMatchingUserCountry.length} Products Passed`,
              language_matching_filter: `${productsMatchingUserCountry.filter(productMatchPageLanguage).length} Products Passed`
            });
          });
        });
        console.log("bugsnag Triggered");
      }
    });
    _defineProperty$3(this, "componentWillUnmount", () => {
      document.removeEventListener("keydown", this.handleSubmit);
    });
    _defineProperty$3(this, "handleSubmit", e => {
      if (e.key === "Enter" && !this.state.disabled) this.submitOption();
    });
    _defineProperty$3(this, "onProductChange", e => {
      const product = window.Pelcro.product.list()[e.target.selectedIndex];
      this.setState({
        product: product,
        plan: product.plans[0]
      });
    });
    _defineProperty$3(this, "onPlanChange", e => {
      this.setState({
        plan: this.state.product.plans[e.target.selectedIndex]
      });
    });
    _defineProperty$3(this, "onIsGiftChange", e => {
      this.setState({
        isGift: e.target.checked
      });
    });
    _defineProperty$3(this, "countStartPrice", arr => {
      let startingPlan = arr[0];
      for (const plan of arr) {
        if (plan.amount < startingPlan.amount) {
          startingPlan = plan;
        }
      }
      return `${startingPlan.amount_formatted}/${startingPlan.interval_count > 1 ? `${startingPlan.interval_count} ${startingPlan.interval_translated}` : `${startingPlan.interval_translated}`}`;
    });
    _defineProperty$3(this, "renderOneProduct", (product, index, options) => {
      const isPlanMode = Boolean(this.state.mode === "plan");
      const productButtonLabel = isPlanMode ? this.locale("buttons.back") : this.locale("buttons.select");
      const productButtonCallback = isPlanMode ? this.goBack : this.selectProduct;
      return /*#__PURE__*/React__default.createElement("div", {
        key: product.id,
        className: `plc-flex plc-items-start plc-p-2 plc-mt-4 plc-space-x-3 plc-text-gray-900 plc-border-solid plc-rounded plc-border-primary-500 pelcro-select-product-wrapper ${options !== null && options !== void 0 && options.emphasize ? "plc-border-2" : "plc-border"}`
      }, product.image && /*#__PURE__*/React__default.createElement("img", {
        alt: `image of ${product.name}`,
        src: product.image,
        className: "plc-object-contain plc-w-1/4 pelcro-select-product-image"
      }), /*#__PURE__*/React__default.createElement("div", {
        className: `plc-flex plc-flex-wrap ${product.image ? "plc-w-3/4" : "plc-w-full"}`
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "plc-w-full pelcro-select-product-header"
      }, /*#__PURE__*/React__default.createElement("p", {
        className: "plc-font-bold pelcro-select-product-title"
      }, product.name), /*#__PURE__*/React__default.createElement("p", {
        className: "plc-text-xs pelcro-select-product-description"
      }, product.description)), /*#__PURE__*/React__default.createElement("div", {
        className: "plc-flex plc-items-end plc-w-full plc-mt-3"
      }, product.plans && /*#__PURE__*/React__default.createElement("p", {
        className: "plc-w-1/2 plc-text-xs pelcro-select-product-cost"
      }, this.locale("labels.startingAt"), " ", this.countStartPrice(product.plans)), /*#__PURE__*/React__default.createElement(Button, Object.assign({
        onClick: productButtonCallback,
        "data-key": product.id,
        id: "pelcro-select-product-back-button",
        className: `plc-ml-auto plc-text-xs ${options !== null && options !== void 0 && options.emphasize ? "plc-bg-primary-700" : ""}`
      }, index === 0 && {
        autoFocus: true
      }), productButtonLabel))));
    });
    _defineProperty$3(this, "renderProducts", () => {
      const userDidSelectProduct = Boolean(this.state.mode === "plan");
      const productsToShow = userDidSelectProduct ? [this.state.product] : this.state.productList;
      return productsToShow.map((product, index) => {
        return this.renderOneProduct(product, index);
      });
    });
    _defineProperty$3(this, "renderMatchingProductsFirst", () => {
      const isPlanMode = Boolean(this.state.mode === "plan");
      if (isPlanMode) {
        return this.renderOneProduct(this.state.product);
      }
      const [productsThatMatchArticleTag, allProductsMinusMatched] = productsWithMatchedTaggedFirst();

      // Render normal products if there are no available matching products
      if (!(productsThatMatchArticleTag !== null && productsThatMatchArticleTag !== void 0 && productsThatMatchArticleTag.length)) {
        return this.renderProducts();
      }
      return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h3", {
        className: "plc-text-sm plc-font-semibold"
      }, this.locale("labels.restrictiveArticles.subscribeTo")), productsThatMatchArticleTag.map((product, index) => this.renderOneProduct(product, index, {
        emphasize: true
      })), (allProductsMinusMatched === null || allProductsMinusMatched === void 0 ? void 0 : allProductsMinusMatched.length) > 0 && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("hr", {
        className: "plc-my-4"
      }), /*#__PURE__*/React__default.createElement("h3", {
        className: "plc-text-sm plc-font-semibold"
      }, this.locale("labels.restrictiveArticles.or")), allProductsMinusMatched.map((product, index) => this.renderOneProduct(product, index))));
    });
    _defineProperty$3(this, "renderPlans", () => {
      return this.state.planList.map(plan => {
        const isChecked = this.state.plan.id === plan.id ? true : false;
        return /*#__PURE__*/React__default.createElement("div", {
          key: plan.id,
          className: "plc-p-2 plc-mx-3 plc-mt-2 plc-text-gray-900 plc-border plc-border-gray-400 plc-border-solid plc-rounded pelcro-select-plan-wrapper"
        }, /*#__PURE__*/React__default.createElement(Radio, {
          className: "plc-self-start pelcro-select-plan-radio",
          labelClassName: "plc-cursor-pointer plc-w-full",
          id: `pelcro-select-plan-${plan.id}`,
          name: "plan",
          checked: isChecked,
          "data-key": plan.id,
          onChange: this.selectPlan
        }, /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("p", {
          className: "plc-font-bold pelcro-select-plan-title"
        }, plan.nickname), /*#__PURE__*/React__default.createElement("p", {
          className: "plc-text-xs pelcro-select-plan-description"
        }, plan.description)), /*#__PURE__*/React__default.createElement("p", {
          className: "plc-mt-3 plc-font-bold pelcro-select-plan-price"
        }, plan.amount_formatted)));
      });
    });
    _defineProperty$3(this, "selectProduct", e => {
      const id = e.target.dataset.key;
      for (const product of this.state.productList) {
        if (+product.id === +id) {
          var _this$state$plan;
          this.setState({
            product: product
          });
          this.setState({
            planList: product.plans
          });
          this.setState({
            mode: "plan"
          });
          const isSelectedPlanPartOfThisProduct = ((_this$state$plan = this.state.plan) === null || _this$state$plan === void 0 ? void 0 : _this$state$plan.product_id) === Number(product.id);
          if (isSelectedPlanPartOfThisProduct) {
            this.setState({
              disabled: false
            });
          }
        }
      }
    });
    _defineProperty$3(this, "selectPlan", e => {
      const id = e.target.dataset.key;
      for (const plan of this.state.planList) {
        if (+plan.id === +id) {
          plan.isCheked = true;
          this.setState({
            plan: plan
          });
          this.setState({
            disabled: false
          });
        } else {
          plan.isCheked = false;
        }
      }
    });
    _defineProperty$3(this, "goBack", () => {
      this.setState({
        disabled: true
      });
      this.setState({
        mode: "product"
      });
    });
    _defineProperty$3(this, "submitOption", () => {
      this.props.setProductAndPlan(this.state.product, this.state.plan, this.state.isGift);
      const {
        product,
        isGift
      } = this.state;
      const {
        setView
      } = this.props;
      const isAuthenticated = window.Pelcro.user.isAuthenticated();
      const {
        switchToAddressView,
        switchToPaymentView
      } = usePelcro.getStore();
      if (!isAuthenticated) {
        return setView("register");
      }
      if (isGift) {
        return setView("gift-create");
      }
      if (product.address_required) {
        return switchToAddressView();
      }
      return switchToPaymentView();
    });
    _defineProperty$3(this, "displayLoginView", () => {
      this.props.setView("login");
    });
    this.state = {
      product: {},
      plan: {},
      isGift: props.isGift,
      disabled: true,
      mode: "product",
      productList: props.matchingEntitlements ? window.Pelcro.product.getByEntitlements(props.matchingEntitlements) : window.Pelcro.product.list()
    };
    this.product = this.props.product || window.Pelcro.paywall.getProduct();
    this.locale = this.props.t;
    this.closeButton = window.Pelcro.paywall.displayCloseButton();
    this.enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro11 = _window.Pelcro) === null || _window$Pelcro11 === void 0 ? void 0 : (_window$Pelcro11$uiSe = _window$Pelcro11.uiSettings) === null || _window$Pelcro11$uiSe === void 0 ? void 0 : _window$Pelcro11$uiSe.enableReactGA4;
  }
  render() {
    var _window$Pelcro$produc2, _window$Pelcro$produc3, _window$Pelcro$site$r;
    const {
      disableGifting
    } = this.props;
    if (this.state.mode === "product") {
      if (this.enableReactGA4) {
        ReactGA4.event("Product Modal Viewed", {
          nonInteraction: true
        });
      } else {
        var _ReactGA$event;
        ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
          category: "VIEWS",
          action: "Product Modal Viewed",
          nonInteraction: true
        });
      }
    } else if (this.state.mode === "plan") {
      if (this.enableReactGA4) {
        ReactGA4.event("Plan Modal Viewed", {
          nonInteraction: true
        });
      } else {
        var _ReactGA$event2;
        ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event2 = ReactGA.event) === null || _ReactGA$event2 === void 0 ? void 0 : _ReactGA$event2.call(ReactGA, {
          category: "VIEWS",
          action: "Plan Modal Viewed",
          nonInteraction: true
        });
      }
    }
    return /*#__PURE__*/React__default.createElement(Modal, {
      hideCloseButton: !this.closeButton,
      onClose: this.props.onClose,
      id: "pelcro-selection-modal"
    }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement("div", {
      id: "pelcro-selection-view"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
    }, /*#__PURE__*/React__default.createElement("h4", {
      className: "plc-text-2xl plc-font-semibold"
    }, this.product && this.product.paywall.select_title || ((_window$Pelcro$produc2 = window.Pelcro.product.list()[0]) === null || _window$Pelcro$produc2 === void 0 ? void 0 : _window$Pelcro$produc2.paywall.select_title)), /*#__PURE__*/React__default.createElement("p", null, this.product && this.product.paywall.select_subtitle || ((_window$Pelcro$produc3 = window.Pelcro.product.list()[0]) === null || _window$Pelcro$produc3 === void 0 ? void 0 : _window$Pelcro$produc3.paywall.select_subtitle))), /*#__PURE__*/React__default.createElement("div", {
      className: "pelcro-select-products-wrapper"
    }, (_window$Pelcro$site$r = window.Pelcro.site.read()) !== null && _window$Pelcro$site$r !== void 0 && _window$Pelcro$site$r.restrictive_paywall_metatags_enabled ? this.renderMatchingProductsFirst() : this.renderProducts()), this.state.mode === "plan" && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-overflow-y-scroll plc-max-h-72 pelcro-select-plans-wrapper"
    }, this.renderPlans()), !disableGifting && /*#__PURE__*/React__default.createElement("div", {
      className: "plc-flex plc-justify-center plc-mt-2"
    }, /*#__PURE__*/React__default.createElement(Checkbox, {
      onChange: this.onIsGiftChange,
      checked: this.state.isGift,
      id: "pelcro-input-is-gift"
    }, this.locale("messages.checkbox"))), /*#__PURE__*/React__default.createElement(Button, {
      disabled: this.state.disabled,
      onClick: this.submitOption,
      id: "pelcro-submit",
      className: "plc-w-full plc-mt-2"
    }, this.locale("buttons.next"))))), /*#__PURE__*/React__default.createElement(ModalFooter, null, !window.Pelcro.user.isAuthenticated() && /*#__PURE__*/React__default.createElement("p", null, this.locale("messages.alreadyHaveAccount") + " ", /*#__PURE__*/React__default.createElement(Link, {
      id: "pelcro-link-login",
      onClick: this.displayLoginView
    }, this.locale("messages.loginHere"))), /*#__PURE__*/React__default.createElement(Authorship, null)));
  }
}
const SelectModalWithTrans = withTranslation("select")(SelectModal);

var Provider_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.providerContextTypes = undefined;



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// TODO(jez) 'sync' and 'async' are bad tag names.
// TODO(jez) What if redux also uses this.context.tag?
var providerContextTypes = exports.providerContextTypes = {
  tag: _propTypes2.default.string.isRequired,
  stripe: _propTypes2.default.object,
  addStripeLoadListener: _propTypes2.default.func
};

var getOrCreateStripe = function getOrCreateStripe(apiKey, options) {
  /**
   * Note that this is not meant to be a generic memoization solution.
   * This is specifically a solution for `StripeProvider`s being initialized
   * and destroyed regularly (with the same set of props) when users only
   * use `StripeProvider` for the subtree that contains their checkout form.
   */
  window.Stripe.__cachedInstances = window.Stripe.__cachedInstances || {};
  var cacheKey = 'key=' + apiKey + ' options=' + JSON.stringify(options);

  var stripe = window.Stripe.__cachedInstances[cacheKey] || window.Stripe(apiKey, options);
  window.Stripe.__cachedInstances[cacheKey] = stripe;

  return stripe;
};

var ensureStripeShape = function ensureStripeShape(stripe) {
  if (stripe && stripe.elements && stripe.createSource && stripe.createToken && stripe.createPaymentMethod && stripe.handleCardPayment) {
    return stripe;
  } else {
    throw new Error("Please pass a valid Stripe object to StripeProvider. You can obtain a Stripe object by calling 'Stripe(...)' with your publishable key.");
  }
};

var Provider = function (_React$Component) {
  _inherits(Provider, _React$Component);

  // on the other hand: childContextTypes is *required* to use context.
  function Provider(props) {
    _classCallCheck(this, Provider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    if (_this.props.apiKey && _this.props.stripe) {
      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider, not both.");
    } else if (_this.props.apiKey) {
      if (!window.Stripe) {
        throw new Error("Please load Stripe.js (https://js.stripe.com/v3/) on this page to use react-stripe-elements. If Stripe.js isn't available yet (it's loading asynchronously, or you're using server-side rendering), see https://github.com/stripe/react-stripe-elements#advanced-integrations");
      } else {
        var _this$props = _this.props,
            _apiKey = _this$props.apiKey;
            _this$props.children;
            var options = _objectWithoutProperties(_this$props, ['apiKey', 'children']);

        var _stripe = getOrCreateStripe(_apiKey, options);
        _this._meta = { tag: 'sync', stripe: _stripe };
        _this._register();
      }
    } else if (_this.props.stripe) {
      // If we already have a stripe instance (in the constructor), we can behave synchronously.
      var _stripe2 = ensureStripeShape(_this.props.stripe);
      _this._meta = { tag: 'sync', stripe: _stripe2 };
      _this._register();
    } else if (_this.props.stripe === null) {
      _this._meta = {
        tag: 'async',
        stripe: null
      };
    } else {
      throw new Error("Please pass either 'apiKey' or 'stripe' to StripeProvider. If you're using 'stripe' but don't have a Stripe instance yet, pass 'null' explicitly.");
    }

    _this._didWarn = false;
    _this._didWakeUpListeners = false;
    _this._listeners = [];
    return _this;
  }
  // Even though we're using flow, also use PropTypes so we can take advantage of developer warnings.


  Provider.prototype.getChildContext = function getChildContext() {
    var _this2 = this;

    // getChildContext is run after the constructor, so we WILL have access to
    // the initial state.
    //
    // However, context doesn't update in respnse to state changes like you
    // might expect: context is pulled by the child, not pushed by the parent.
    if (this._meta.tag === 'sync') {
      return {
        tag: 'sync',
        stripe: this._meta.stripe
      };
    } else {
      return {
        tag: 'async',
        addStripeLoadListener: function addStripeLoadListener(fn) {
          if (_this2._meta.stripe) {
            fn(_this2._meta.stripe);
          } else {
            _this2._listeners.push(fn);
          }
        }
      };
    }
  };

  Provider.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var apiKeyChanged = this.props.apiKey && prevProps.apiKey && this.props.apiKey !== prevProps.apiKey;

    var stripeInstanceChanged = this.props.stripe && prevProps.stripe && this.props.stripe !== prevProps.stripe;
    if (!this._didWarn && (apiKeyChanged || stripeInstanceChanged) && window.console && window.console.error) {
      this._didWarn = true;
      // eslint-disable-next-line no-console
      console.error('StripeProvider does not support changing the apiKey parameter.');
      return;
    }

    if (!this._didWakeUpListeners && this.props.stripe) {
      // Wake up the listeners if we've finally been given a StripeShape
      this._didWakeUpListeners = true;
      var _stripe3 = ensureStripeShape(this.props.stripe);
      this._meta.stripe = _stripe3;
      this._register();
      this._listeners.forEach(function (fn) {
        fn(_stripe3);
      });
    }
  };

  Provider.prototype._register = function _register() {
    var stripe = this._meta.stripe;


    if (!stripe || !stripe._registerWrapper) {
      return;
    }

    stripe._registerWrapper({
      name: 'react-stripe-elements',
      version: '6.1.2' 
    });
  };

  Provider.prototype.render = function render() {
    return _react2.default.Children.only(this.props.children);
  };

  return Provider;
}(_react2.default.Component);

Provider.propTypes = {
  apiKey: _propTypes2.default.string,
  // PropTypes.object is the only way we can accept a Stripe instance
  // eslint-disable-next-line react/forbid-prop-types
  stripe: _propTypes2.default.object,
  children: _propTypes2.default.node
};
Provider.childContextTypes = providerContextTypes;
Provider.defaultProps = {
  apiKey: undefined,
  stripe: undefined,
  children: null
};
exports.default = Provider;
});

unwrapExports(Provider_1);
Provider_1.providerContextTypes;

var Elements_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.elementContextTypes = exports.injectContextTypes = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var injectContextTypes = exports.injectContextTypes = {
  getRegisteredElements: _propTypes2.default.func.isRequired,
  elements: _propTypes2.default.object
};

var elementContextTypes = exports.elementContextTypes = {
  addElementsLoadListener: _propTypes2.default.func.isRequired,
  registerElement: _propTypes2.default.func.isRequired,
  unregisterElement: _propTypes2.default.func.isRequired
};

var Elements = function (_React$Component) {
  _inherits(Elements, _React$Component);

  function Elements(props, context) {
    _classCallCheck(this, Elements);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this._elements = null;

    _this.handleRegisterElement = function (element, impliedTokenType, impliedSourceType, impliedPaymentMethodType) {
      _this.setState(function (prevState) {
        return {
          registeredElements: [].concat(_toConsumableArray(prevState.registeredElements), [_extends({
            element: element
          }, impliedTokenType ? { impliedTokenType: impliedTokenType } : {}, impliedSourceType ? { impliedSourceType: impliedSourceType } : {}, impliedPaymentMethodType ? { impliedPaymentMethodType: impliedPaymentMethodType } : {})])
        };
      });
    };

    _this.handleUnregisterElement = function (el) {
      _this.setState(function (prevState) {
        return {
          registeredElements: prevState.registeredElements.filter(function (_ref) {
            var element = _ref.element;
            return element !== el;
          })
        };
      });
    };

    var _this$props = _this.props;
        _this$props.children;
        var options = _objectWithoutProperties(_this$props, ['children']);

    if (_this.context.tag === 'sync') {
      _this._elements = _this.context.stripe.elements(options);
    }

    _this.state = {
      registeredElements: []
    };
    return _this;
  }

  Elements.prototype.getChildContext = function getChildContext() {
    var _this2 = this;

    return {
      addElementsLoadListener: function addElementsLoadListener(fn) {
        // Return the existing elements instance if we already have one.
        if (_this2.context.tag === 'sync') {
          // This is impossible, but we need to make flow happy.
          if (!_this2._elements) {
            throw new Error('Expected elements to be instantiated but it was not.');
          }

          fn(_this2._elements);
        } else {
          _this2.context.addStripeLoadListener(function (stripe) {
            if (_this2._elements) {
              fn(_this2._elements);
            } else {
              var _props = _this2.props;
                  _props.children;
                  var options = _objectWithoutProperties(_props, ['children']);

              _this2._elements = stripe.elements(options);
              fn(_this2._elements);
            }
          });
        }
      },
      registerElement: this.handleRegisterElement,
      unregisterElement: this.handleUnregisterElement,
      getRegisteredElements: function getRegisteredElements() {
        return _this2.state.registeredElements;
      },
      elements: this._elements
    };
  };

  Elements.prototype.render = function render() {
    return _react2.default.Children.only(this.props.children);
  };

  return Elements;
}(_react2.default.Component);

Elements.childContextTypes = _extends({}, injectContextTypes, elementContextTypes);
Elements.contextTypes = Provider_1.providerContextTypes;
Elements.defaultProps = {
  children: null
};
exports.default = Elements;
});

unwrapExports(Elements_1);
Elements_1.elementContextTypes;
Elements_1.injectContextTypes;

var inject_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



var _react2 = _interopRequireDefault(React__default);





function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// react-redux does a bunch of stuff with pure components / checking if it needs to re-render.
// not sure if we need to do the same.
var inject = function inject(WrappedComponent) {
  var _class, _temp;

  var componentOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _componentOptions$wit = componentOptions.withRef,
      withRef = _componentOptions$wit === undefined ? false : _componentOptions$wit;


  return _temp = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props, context) {
      _classCallCheck(this, _class);

      if (!context || !context.getRegisteredElements) {
        throw new Error('It looks like you are trying to inject Stripe context outside of an Elements context.\nPlease be sure the component that calls createSource or createToken is within an <Elements> component.');
      }

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.parseElementOrData = function (elementOrOptions) {
        return elementOrOptions && (typeof elementOrOptions === 'undefined' ? 'undefined' : _typeof(elementOrOptions)) === 'object' && elementOrOptions._frame && _typeof(elementOrOptions._frame) === 'object' && elementOrOptions._frame.id && typeof elementOrOptions._frame.id === 'string' && typeof elementOrOptions._componentName === 'string' ? { type: 'element', element: elementOrOptions } : { type: 'data', data: elementOrOptions };
      };

      _this.findElement = function (filterBy, specifiedType) {
        var allElements = _this.context.getRegisteredElements();
        var filteredElements = allElements.filter(function (e) {
          return e[filterBy];
        });
        var matchingElements = specifiedType === 'auto' ? filteredElements : filteredElements.filter(function (e) {
          return e[filterBy] === specifiedType;
        });

        if (matchingElements.length === 1) {
          return matchingElements[0].element;
        } else if (matchingElements.length > 1) {
          throw new Error('You did not specify the type of Source, Token, or PaymentMethod to create.\n        We could not infer which Element you want to use for this operation.');
        } else {
          return null;
        }
      };

      _this.requireElement = function (filterBy, specifiedType) {
        var element = _this.findElement(filterBy, specifiedType);
        if (element) {
          return element;
        } else {
          throw new Error('You did not specify the type of Source, Token, or PaymentMethod to create.\n        We could not infer which Element you want to use for this operation.');
        }
      };

      _this.wrappedCreateToken = function (stripe) {
        return function () {
          var tokenTypeOrOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

          if (tokenTypeOrOptions && (typeof tokenTypeOrOptions === 'undefined' ? 'undefined' : _typeof(tokenTypeOrOptions)) === 'object') {
            // First argument is options; infer the Element and tokenize
            var opts = tokenTypeOrOptions;

            var tokenType = opts.type,
                rest = _objectWithoutProperties(opts, ['type']);

            var specifiedType = typeof tokenType === 'string' ? tokenType : 'auto';
            // Since only options were passed in, a corresponding Element must exist
            // for the tokenization to succeed -- thus we call requireElement.
            var element = _this.requireElement('impliedTokenType', specifiedType);
            return stripe.createToken(element, rest);
          } else if (typeof tokenTypeOrOptions === 'string') {
            // First argument is token type; tokenize with token type and options
            var _tokenType = tokenTypeOrOptions;
            return stripe.createToken(_tokenType, options);
          } else {
            // If a bad value was passed in for options, throw an error.
            throw new Error('Invalid options passed to createToken. Expected an object, got ' + (typeof tokenTypeOrOptions === 'undefined' ? 'undefined' : _typeof(tokenTypeOrOptions)) + '.');
          }
        };
      };

      _this.wrappedCreateSource = function (stripe) {
        return function () {
          var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          if (options && (typeof options === 'undefined' ? 'undefined' : _typeof(options)) === 'object') {
            if (typeof options.type !== 'string') {
              throw new Error('Invalid Source type passed to createSource. Expected string, got ' + _typeof(options.type) + '.');
            }

            var element = _this.findElement('impliedSourceType', options.type);
            if (element) {
              // If an Element exists for the source type, use that to create the
              // corresponding source.
              //
              // NOTE: this prevents users from independently creating sources of
              // type `foo` if an Element that can create `foo` sources exists in
              // the current <Elements /> context.
              return stripe.createSource(element, options);
            } else {
              // If no Element exists for the source type, directly create a source.
              return stripe.createSource(options);
            }
          } else {
            // If a bad value was passed in for options, throw an error.
            throw new Error('Invalid options passed to createSource. Expected an object, got ' + (typeof options === 'undefined' ? 'undefined' : _typeof(options)) + '.');
          }
        };
      };

      _this.wrappedCreatePaymentMethod = function (stripe) {
        return function (paymentMethodType, elementOrData, maybeData) {
          if (paymentMethodType && (typeof paymentMethodType === 'undefined' ? 'undefined' : _typeof(paymentMethodType)) === 'object') {
            return stripe.createPaymentMethod(paymentMethodType);
          }

          if (!paymentMethodType || typeof paymentMethodType !== 'string') {
            throw new Error('Invalid PaymentMethod type passed to createPaymentMethod. Expected a string, got ' + (typeof paymentMethodType === 'undefined' ? 'undefined' : _typeof(paymentMethodType)) + '.');
          }

          var elementOrDataResult = _this.parseElementOrData(elementOrData);

          // Second argument is Element; use passed in Element
          if (elementOrDataResult.type === 'element') {
            var _element = elementOrDataResult.element;

            if (maybeData) {
              return stripe.createPaymentMethod(paymentMethodType, _element, maybeData);
            } else {
              return stripe.createPaymentMethod(paymentMethodType, _element);
            }
          }

          // Second argument is data or undefined; infer the Element
          var data = elementOrDataResult.data;

          var element = _this.findElement('impliedPaymentMethodType', paymentMethodType);

          if (element) {
            return data ? stripe.createPaymentMethod(paymentMethodType, element, data) : stripe.createPaymentMethod(paymentMethodType, element);
          }

          if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
            return stripe.createPaymentMethod(paymentMethodType, data);
          } else if (!data) {
            throw new Error('Could not find an Element that can be used to create a PaymentMethod of type: ' + paymentMethodType + '.');
          } else {
            // If a bad value was passed in for data, throw an error.
            throw new Error('Invalid data passed to createPaymentMethod. Expected an object, got ' + (typeof data === 'undefined' ? 'undefined' : _typeof(data)) + '.');
          }
        };
      };

      _this.wrappedHandleCardX = function (stripe, method) {
        return function (clientSecret, elementOrData, maybeData) {
          if (!clientSecret || typeof clientSecret !== 'string') {
            // If a bad value was passed in for clientSecret, throw an error.
            throw new Error('Invalid PaymentIntent client secret passed to handleCardPayment. Expected string, got ' + (typeof clientSecret === 'undefined' ? 'undefined' : _typeof(clientSecret)) + '.');
          }

          var elementOrDataResult = _this.parseElementOrData(elementOrData);

          // Second argument is Element; handle with element
          if (elementOrDataResult.type === 'element') {
            var _element2 = elementOrDataResult.element;

            if (maybeData) {
              return stripe[method](clientSecret, _element2, maybeData);
            } else {
              return stripe[method](clientSecret, _element2);
            }
          }

          // Second argument is data or undefined; see if we can find a mounted Element
          // that can create card PaymentMethods
          var data = elementOrDataResult.data;

          var element = _this.findElement('impliedPaymentMethodType', 'card');

          if (element) {
            // If an Element exists that can create card PaymentMethods use it. Otherwise
            // assume that we must be calling with data only.
            //
            // NOTE: this prevents users from using handleCard* with an existing
            // Source or PaymentMethod if an Element that can create card PaymentMethods
            // exists in the current <Elements /> context.
            if (data) {
              return stripe[method](clientSecret, element, data);
            } else {
              return stripe[method](clientSecret, element);
            }
          } else if (data) {
            // if no element exists call handleCard* directly (with data)
            return stripe[method](clientSecret, data);
          } else {
            // if no element exists call handleCard* directly (with only the clientSecret)
            return stripe[method](clientSecret);
          }
        };
      };

      if (_this.context.tag === 'sync') {
        _this.state = {
          stripe: _this.stripeProps(_this.context.stripe)
        };
      } else {
        _this.state = {
          stripe: null
        };
      }
      return _this;
    }

    _class.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      if (this.context.tag === 'async') {
        this.context.addStripeLoadListener(function (stripe) {
          _this2.setState({
            stripe: _this2.stripeProps(stripe)
          });
        });
      }
    };

    _class.prototype.getWrappedInstance = function getWrappedInstance() {
      if (!withRef) {
        throw new Error('To access the wrapped instance, the `{withRef: true}` option must be set when calling `injectStripe()`');
      }
      return this.wrappedInstance;
    };

    _class.prototype.stripeProps = function stripeProps(stripe) {
      return _extends({}, stripe, {
        // These are the only functions that take elements.
        createToken: this.wrappedCreateToken(stripe),
        createSource: this.wrappedCreateSource(stripe),
        createPaymentMethod: this.wrappedCreatePaymentMethod(stripe),
        handleCardPayment: this.wrappedHandleCardX(stripe, 'handleCardPayment'),
        handleCardSetup: this.wrappedHandleCardX(stripe, 'handleCardSetup')
      });
    };

    // Finds an Element by the specified type, if one exists.
    // Throws if multiple Elements match.


    // Require that exactly one Element is found for the specified type.
    // Throws if no Element is found.


    // Wraps createToken in order to infer the Element that is being tokenized.


    // Wraps createSource in order to infer the Element that is being used for
    // source creation.


    // Wraps createPaymentMethod in order to infer the Element that is being
    // used for PaymentMethod creation.


    _class.prototype.render = function render() {
      var _this3 = this;

      return _react2.default.createElement(WrappedComponent, _extends({}, this.props, {
        stripe: this.state.stripe,
        elements: this.context.elements,
        ref: withRef ? function (c) {
          _this3.wrappedInstance = c;
        } : null
      }));
    };

    return _class;
  }(_react2.default.Component), _class.contextTypes = _extends({}, Provider_1.providerContextTypes, Elements_1.injectContextTypes), _class.displayName = 'InjectStripe(' + (WrappedComponent.displayName || WrappedComponent.name || 'Component') + ')', _temp;
};

exports.default = inject;
});

unwrapExports(inject_1);

var isEqual_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var PLAIN_OBJECT_STR = '[object Object]';

var isEqual = function isEqual(left, right) {
  if ((typeof left === 'undefined' ? 'undefined' : _typeof(left)) !== 'object' || (typeof right === 'undefined' ? 'undefined' : _typeof(right)) !== 'object') {
    return left === right;
  }

  if (left === null || right === null) return left === right;

  var leftArray = Array.isArray(left);
  var rightArray = Array.isArray(right);

  if (leftArray !== rightArray) return false;

  var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
  var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;

  if (leftPlainObject !== rightPlainObject) return false;

  if (!leftPlainObject && !leftArray) return false;

  var leftKeys = Object.keys(left);
  var rightKeys = Object.keys(right);

  if (leftKeys.length !== rightKeys.length) return false;

  var keySet = {};
  for (var i = 0; i < leftKeys.length; i += 1) {
    keySet[leftKeys[i]] = true;
  }
  for (var _i = 0; _i < rightKeys.length; _i += 1) {
    keySet[rightKeys[_i]] = true;
  }
  var allKeys = Object.keys(keySet);
  if (allKeys.length !== leftKeys.length) {
    return false;
  }

  var l = left;
  var r = right;
  var pred = function pred(key) {
    return isEqual(l[key], r[key]);
  };

  return allKeys.every(pred);
};

exports.default = isEqual;
});

unwrapExports(isEqual_1);

var Element_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _isEqual2 = _interopRequireDefault(isEqual_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var noop = function noop() {};

var _extractOptions = function _extractOptions(props) {
  props.id;
      props.className;
      props.onChange;
      props.onFocus;
      props.onBlur;
      props.onReady;
      var options = _objectWithoutProperties(props, ['id', 'className', 'onChange', 'onFocus', 'onBlur', 'onReady']);

  return options;
};

var capitalized = function capitalized(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

var Element = function Element(type) {
  var _class, _temp;

  var hocOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return _temp = _class = function (_React$Component) {
    _inherits(_class, _React$Component);

    function _class(props, context) {
      _classCallCheck(this, _class);

      var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

      _this.handleRef = function (ref) {
        _this._ref = ref;
      };

      _this._element = null;

      var options = _extractOptions(_this.props);
      // We keep track of the extracted options on this._options to avoid re-rendering.
      // (We would unnecessarily re-render if we were tracking them with state.)
      _this._options = options;
      return _this;
    }

    _class.prototype.componentDidMount = function componentDidMount() {
      var _this2 = this;

      this.context.addElementsLoadListener(function (elements) {
        if (!_this2._ref) {
          return;
        }

        var element = elements.create(type, _this2._options);
        _this2._element = element;

        _this2._setupEventListeners(element);

        element.mount(_this2._ref);

        // Register Element for automatic token / source / paymentMethod creation
        _this2.context.registerElement(element, hocOptions.impliedTokenType, hocOptions.impliedSourceType, hocOptions.impliedPaymentMethodType);
      });
    };

    _class.prototype.componentDidUpdate = function componentDidUpdate() {
      var options = _extractOptions(this.props);
      if (Object.keys(options).length !== 0 && !(0, _isEqual2.default)(options, this._options)) {
        this._options = options;
        if (this._element) {
          this._element.update(options);
        }
      }
    };

    _class.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this._element) {
        var element = this._element;
        element.destroy();
        this.context.unregisterElement(element);
      }
    };

    _class.prototype._setupEventListeners = function _setupEventListeners(element) {
      var _this3 = this;

      element.on('ready', function () {
        _this3.props.onReady(_this3._element);
      });

      element.on('change', function (change) {
        _this3.props.onChange(change);
      });

      element.on('blur', function () {
        var _props;

        return (_props = _this3.props).onBlur.apply(_props, arguments);
      });
      element.on('focus', function () {
        var _props2;

        return (_props2 = _this3.props).onFocus.apply(_props2, arguments);
      });
    };

    _class.prototype.render = function render() {
      return _react2.default.createElement('div', {
        id: this.props.id,
        className: this.props.className,
        ref: this.handleRef
      });
    };

    return _class;
  }(_react2.default.Component), _class.propTypes = {
    id: _propTypes2.default.string,
    className: _propTypes2.default.string,
    onChange: _propTypes2.default.func,
    onBlur: _propTypes2.default.func,
    onFocus: _propTypes2.default.func,
    onReady: _propTypes2.default.func
  }, _class.defaultProps = {
    id: undefined,
    className: undefined,
    onChange: noop,
    onBlur: noop,
    onFocus: noop,
    onReady: noop
  }, _class.contextTypes = Elements_1.elementContextTypes, _class.displayName = capitalized(type) + 'Element', _temp;
};

exports.default = Element;
});

unwrapExports(Element_1);

var shallowEqual_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var shallowEqual = function shallowEqual(a, b) {
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  return keysA.length === keysB.length && keysA.every(function (key) {
    return b.hasOwnProperty(key) && b[key] === a[key];
  });
};

exports.default = shallowEqual;
});

unwrapExports(shallowEqual_1);

var PaymentRequestButtonElement_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _react2 = _interopRequireDefault(React__default);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _shallowEqual2 = _interopRequireDefault(shallowEqual_1);



function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var noop = function noop() {};

var _extractOptions = function _extractOptions(props) {
  props.id;
      props.className;
      props.onBlur;
      props.onClick;
      props.onFocus;
      props.onReady;
      props.paymentRequest;
      var options = _objectWithoutProperties(props, ['id', 'className', 'onBlur', 'onClick', 'onFocus', 'onReady', 'paymentRequest']);

  return options;
};

var PaymentRequestButtonElement = function (_React$Component) {
  _inherits(PaymentRequestButtonElement, _React$Component);

  function PaymentRequestButtonElement(props, context) {
    _classCallCheck(this, PaymentRequestButtonElement);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleRef = function (ref) {
      _this._ref = ref;
    };

    var options = _extractOptions(props);
    // We keep track of the extracted options on this._options to avoid re-rendering.
    // (We would unnecessarily re-render if we were tracking them with state.)
    _this._options = options;
    return _this;
  }

  PaymentRequestButtonElement.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this.context.addElementsLoadListener(function (elements) {
      _this2._element = elements.create('paymentRequestButton', _extends({
        paymentRequest: _this2.props.paymentRequest
      }, _this2._options));
      _this2._element.on('ready', function () {
        _this2.props.onReady(_this2._element);
      });
      _this2._element.on('focus', function () {
        var _props;

        return (_props = _this2.props).onFocus.apply(_props, arguments);
      });
      _this2._element.on('click', function () {
        var _props2;

        return (_props2 = _this2.props).onClick.apply(_props2, arguments);
      });
      _this2._element.on('blur', function () {
        var _props3;

        return (_props3 = _this2.props).onBlur.apply(_props3, arguments);
      });
      _this2._element.mount(_this2._ref);
    });
  };

  PaymentRequestButtonElement.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.paymentRequest !== prevProps.paymentRequest) {
      console.warn('Unsupported prop change: paymentRequest is not a customizable property.');
    }
    var options = _extractOptions(this.props);
    if (Object.keys(options).length !== 0 && !(0, _shallowEqual2.default)(options, this._options)) {
      this._options = options;
      this._element.update(options);
    }
  };

  PaymentRequestButtonElement.prototype.componentWillUnmount = function componentWillUnmount() {
    this._element.destroy();
  };

  PaymentRequestButtonElement.prototype.render = function render() {
    return _react2.default.createElement('div', {
      id: this.props.id,
      className: this.props.className,
      ref: this.handleRef
    });
  };

  return PaymentRequestButtonElement;
}(_react2.default.Component);

PaymentRequestButtonElement.propTypes = {
  id: _propTypes2.default.string,
  className: _propTypes2.default.string,
  onBlur: _propTypes2.default.func,
  onClick: _propTypes2.default.func,
  onFocus: _propTypes2.default.func,
  onReady: _propTypes2.default.func,
  paymentRequest: _propTypes2.default.shape({
    canMakePayment: _propTypes2.default.func.isRequired,
    on: _propTypes2.default.func.isRequired,
    show: _propTypes2.default.func.isRequired
  }).isRequired
};
PaymentRequestButtonElement.defaultProps = {
  id: undefined,
  className: undefined,
  onBlur: noop,
  onClick: noop,
  onFocus: noop,
  onReady: noop
};
PaymentRequestButtonElement.contextTypes = Elements_1.elementContextTypes;
exports.default = PaymentRequestButtonElement;
});

unwrapExports(PaymentRequestButtonElement_1);

var es = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuBankAccountElement = exports.FpxBankElement = exports.IdealBankElement = exports.IbanElement = exports.PaymentRequestButtonElement = exports.CardCVCElement = exports.CardCvcElement = exports.CardExpiryElement = exports.CardNumberElement = exports.CardElement = exports.Elements = exports.injectStripe = exports.StripeProvider = undefined;



var _Provider2 = _interopRequireDefault(Provider_1);



var _inject2 = _interopRequireDefault(inject_1);



var _Elements2 = _interopRequireDefault(Elements_1);



var _Element2 = _interopRequireDefault(Element_1);



var _PaymentRequestButtonElement2 = _interopRequireDefault(PaymentRequestButtonElement_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Define Elements, and register their implied token / source types for
// automatic token / source creation.

// Card
var CardElement = (0, _Element2.default)('card', {
  impliedTokenType: 'card',
  impliedSourceType: 'card',
  impliedPaymentMethodType: 'card'
});

// Split Fields
// Note: we only register the CardNumberElement for split fields so that we have
// a unique Element to infer when calling `wrappedCreateToken` or `wrappedCreateSource`.

var CardNumberElement = (0, _Element2.default)('cardNumber', {
  impliedTokenType: 'card',
  impliedSourceType: 'card',
  impliedPaymentMethodType: 'card'
});
var CardExpiryElement = (0, _Element2.default)('cardExpiry');
var CardCvcElement = (0, _Element2.default)('cardCvc');
var CardCVCElement = CardCvcElement; // deprecated in favor of CardCvcElement which better matches Elements API

// IBAN
var IbanElement = (0, _Element2.default)('iban', {
  impliedTokenType: 'bank_account',
  impliedSourceType: 'sepa_debit'
});

// iDEAL Bank
var IdealBankElement = (0, _Element2.default)('idealBank', { impliedSourceType: 'ideal' });

// fpx Bank
var FpxBankElement = (0, _Element2.default)('fpxBank');

// auBankAccount
// Requires beta access. Contact Stripe support for more information:
// https://support.stripe.com
var AuBankAccountElement = (0, _Element2.default)('auBankAccount');

exports.StripeProvider = _Provider2.default;
exports.injectStripe = _inject2.default;
exports.Elements = _Elements2.default;
exports.CardElement = CardElement;
exports.CardNumberElement = CardNumberElement;
exports.CardExpiryElement = CardExpiryElement;
exports.CardCvcElement = CardCvcElement;
exports.CardCVCElement = CardCVCElement;
exports.PaymentRequestButtonElement = _PaymentRequestButtonElement2.default;
exports.IbanElement = IbanElement;
exports.IdealBankElement = IdealBankElement;
exports.FpxBankElement = FpxBankElement;
exports.AuBankAccountElement = AuBankAccountElement;
});

unwrapExports(es);
es.AuBankAccountElement;
es.FpxBankElement;
es.IdealBankElement;
es.IbanElement;
var es_5 = es.PaymentRequestButtonElement;
var es_6 = es.CardCVCElement;
es.CardCvcElement;
var es_8 = es.CardExpiryElement;
var es_9 = es.CardNumberElement;
es.CardElement;
var es_11 = es.Elements;
var es_12 = es.injectStripe;
var es_13 = es.StripeProvider;

function _classPrivateFieldInitSpec$1(obj, privateMap, value) { _checkPrivateRedeclaration$1(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration$1(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }
/**
 * @TODO: All payment related business logic should end up moving
 * to this service, and out of react components.
 */

/**
 * Enum for payment types
 * @readonly
 * @enum {string}
 */
const PAYMENT_TYPES = {
  CREATE_SUBSCRIPTION: "CREATE_SUBSCRIPTION",
  CREATE_GIFTED_SUBSCRIPTION: "CREATE_GIFTED_SUBSCRIPTION",
  RENEW_SUBSCRIPTION: "RENEW_SUBSCRIPTION",
  RENEW_GIFTED_SUBSCRIPTION: "RENEW_GIFTED_SUBSCRIPTION",
  PURCHASE_ECOMMERCE_ORDER: "PURCHASE_ECOMMERCE_ORDER",
  PAY_INVOICE: "PAY_INVOICE"
};
var _isPaymentGatewayInvalid = /*#__PURE__*/new WeakMap();
var _generateUserError = /*#__PURE__*/new WeakMap();
class Payment {
  /**
   * @param {(StripeGateway|PaypalGateway|VantivGateway|TapGateway|CybersourceGateway)} paymentGateway
   */
  constructor(paymentGateway) {
    _defineProperty$3(this, "execute", (options, callback) => {
      if (!this.paymentGateway) {
        callback(_classPrivateFieldGet(this, _generateUserError).call(this), null);
        return console.error("No payment gateway provided");
      }
      if (!options.type) {
        callback(_classPrivateFieldGet(this, _generateUserError).call(this), null);
        return console.error("No payment type provided");
      }

      // delegate execution to paymentgateway
      return this.paymentGateway.execute(options, callback);
    });
    _classPrivateFieldInitSpec$1(this, _isPaymentGatewayInvalid, {
      writable: true,
      value: gateway => {
        return gateway && !(gateway instanceof StripeGateway || gateway instanceof PaypalGateway || gateway instanceof VantivGateway || gateway instanceof TapGateway || gateway instanceof CybersourceGateway);
      }
    });
    _classPrivateFieldInitSpec$1(this, _generateUserError, {
      writable: true,
      value: () => {
        return {
          error: new Error("An error has occured in the payment service, please try again later")
        };
      }
    });
    if (_classPrivateFieldGet(this, _isPaymentGatewayInvalid).call(this, paymentGateway)) {
      this.paymentGateway = null;
      console.error("Incompatible payment gateway");
    } else {
      this.paymentGateway = paymentGateway;
    }
  }

  /**
   * @typedef paymentOptions
   * @property {PAYMENT_TYPES} type
   * @property {string} token
   * @property {object} plan
   * @property {object} [product]
   * @property {object} [couponCode]
   * @property {object} [giftRecipient]
   * @property {number} [subscriptionIdToRenew]
   * @property {number} [quantity]
   * @property {string} addressId
   * @property {number} invoiceId
   * @property {boolean} isExistingSource
   * @property {Array} items
   */

  /**
   * @callback executeCallback
   * @param  {object} error error object
   * @param  {object} response response object
   * @return {void}
   */

  /**
   * Payment execution method
   * @param {paymentOptions} options payment options
   * @param {executeCallback} callback
   * @return {void}
   */
}

const PAYMENT_GATEWAYS_ENUM = {
  stripe: "stripe",
  paypal: "braintree",
  vantiv: "vantiv",
  tap: "tap",
  cybersource: "cybersource"
};

/**
 * Payment Strategies
 */

/**
 * Stripe gateway strategy
 */
var _paymentGateway = /*#__PURE__*/new WeakMap();
var _createSubscription = /*#__PURE__*/new WeakMap();
var _createGiftedSubscription = /*#__PURE__*/new WeakMap();
var _renewSubscription = /*#__PURE__*/new WeakMap();
var _renewGiftedSubscription = /*#__PURE__*/new WeakMap();
var _purchaseEcommerceOrder = /*#__PURE__*/new WeakMap();
var _payInvoice = /*#__PURE__*/new WeakMap();
class StripeGateway {
  constructor() {
    _classPrivateFieldInitSpec$1(this, _paymentGateway, {
      writable: true,
      value: PAYMENT_GATEWAYS_ENUM["stripe"]
    });
    _defineProperty$3(this, "execute", (options, callback) => {
      const types = PAYMENT_TYPES;
      switch (options.type) {
        case types.CREATE_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _createSubscription).call(this, options, callback);
        case types.RENEW_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _renewSubscription).call(this, options, callback);
        case types.CREATE_GIFTED_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _createGiftedSubscription).call(this, options, callback);
        case types.RENEW_GIFTED_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _renewGiftedSubscription).call(this, options, callback);
        case types.PURCHASE_ECOMMERCE_ORDER:
          return _classPrivateFieldGet(this, _purchaseEcommerceOrder).call(this, options, callback);
        case types.PAY_INVOICE:
          return _classPrivateFieldGet(this, _payInvoice).call(this, options, callback);
        default:
          console.error("Unsupported payment method: Stripe Gateway");
      }
    });
    _classPrivateFieldInitSpec$1(this, _createSubscription, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          plan,
          couponCode,
          product,
          quantity = 1,
          addressId
        } = options;
        window.Pelcro.subscription.create({
          quantity,
          gateway_token: token,
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway),
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          address_id: product.address_required ? addressId : null
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _createGiftedSubscription, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          plan,
          couponCode,
          product,
          giftRecipient,
          quantity = 1,
          addressId
        } = options;
        window.Pelcro.subscription.create({
          quantity,
          gateway_token: token,
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway),
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          gift_recipient_email: giftRecipient.email,
          gift_recipient_first_name: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.firstName,
          gift_recipient_last_name: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.lastName,
          gift_start_date: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.startDate,
          gift_message: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.giftMessage,
          address_id: product.address_required ? addressId : null
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _renewSubscription, {
      writable: true,
      value: (options, callback) => {
        const {
          subscriptionIdToRenew,
          token,
          plan,
          couponCode,
          product,
          addressId
        } = options;
        window.Pelcro.subscription.renew({
          stripe_token: token,
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          coupon_code: couponCode,
          subscription_id: subscriptionIdToRenew,
          address_id: product.address_required ? addressId : null
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _renewGiftedSubscription, {
      writable: true,
      value: (options, callback) => {
        const {
          subscriptionIdToRenew,
          token,
          product,
          plan,
          couponCode,
          addressId
        } = options;
        window.Pelcro.subscription.renewGift({
          stripe_token: token,
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          subscription_id: subscriptionIdToRenew,
          address_id: product.address_required ? addressId : null
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _purchaseEcommerceOrder, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          items,
          couponCode,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway),
          gateway_token: token
        };
        window.Pelcro.ecommerce.order.create({
          items,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          ...params,
          ...(addressId && {
            address_id: addressId
          })
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _payInvoice, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          invoiceId
        } = options;
        const params = options.isExistingSource ? {
          source_id: token,
          invoice_id: invoiceId
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway),
          gateway_token: token,
          invoice_id: invoiceId
        };
        window.Pelcro.invoice.pay(params, (err, res) => {
          callback(err, res);
        });
      }
    });
  }
}

/**
 * Paypal gateway strategy
 */
var _paymentGateway2 = /*#__PURE__*/new WeakMap();
var _createSubscription2 = /*#__PURE__*/new WeakMap();
var _createGiftedSubscription2 = /*#__PURE__*/new WeakMap();
var _payInvoice2 = /*#__PURE__*/new WeakMap();
class PaypalGateway {
  constructor() {
    _classPrivateFieldInitSpec$1(this, _paymentGateway2, {
      writable: true,
      value: PAYMENT_GATEWAYS_ENUM["paypal"]
    });
    _defineProperty$3(this, "execute", (options, callback) => {
      const types = PAYMENT_TYPES;
      switch (options.type) {
        case types.CREATE_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _createSubscription2).call(this, options, callback);
        case types.CREATE_GIFTED_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _createGiftedSubscription2).call(this, options, callback);
        case types.PAY_INVOICE:
          return _classPrivateFieldGet(this, _payInvoice2).call(this, options, callback);
        default:
          console.error("Unsupported subscriptiion method: PayPal Gateway");
      }
    });
    _classPrivateFieldInitSpec$1(this, _createSubscription2, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          plan,
          couponCode,
          product,
          quantity = 1,
          addressId
        } = options;
        window.Pelcro.subscription.create({
          quantity,
          gateway_token: token,
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway2),
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          coupon_code: couponCode,
          address_id: product.address_required ? addressId : null
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _createGiftedSubscription2, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          plan,
          couponCode,
          product,
          giftRecipient,
          quantity = 1,
          addressId
        } = options;
        window.Pelcro.subscription.create({
          quantity,
          gateway_token: token,
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway2),
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          gift_recipient_email: giftRecipient.email,
          gift_recipient_first_name: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.firstName,
          gift_recipient_last_name: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.lastName,
          gift_start_date: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.startDate,
          gift_message: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.giftMessage,
          address_id: product.address_required ? addressId : null
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _payInvoice2, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          invoiceId
        } = options;
        window.Pelcro.invoice.pay({
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway2),
          gateway_token: token,
          invoice_id: invoiceId
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
  }
}
var _paymentGateway3 = /*#__PURE__*/new WeakMap();
var _createSubscription3 = /*#__PURE__*/new WeakMap();
var _renewSubscription2 = /*#__PURE__*/new WeakMap();
var _createGiftedSubscription3 = /*#__PURE__*/new WeakMap();
var _renewGiftedSubscription2 = /*#__PURE__*/new WeakMap();
var _purchaseEcommerceOrder2 = /*#__PURE__*/new WeakMap();
var _payInvoice3 = /*#__PURE__*/new WeakMap();
class VantivGateway {
  constructor() {
    _classPrivateFieldInitSpec$1(this, _paymentGateway3, {
      writable: true,
      value: PAYMENT_GATEWAYS_ENUM["vantiv"]
    });
    _defineProperty$3(this, "execute", (options, callback) => {
      const types = PAYMENT_TYPES;
      switch (options.type) {
        case types.CREATE_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _createSubscription3).call(this, options, callback);
        case types.RENEW_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _renewSubscription2).call(this, options, callback);
        case types.CREATE_GIFTED_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _createGiftedSubscription3).call(this, options, callback);
        case types.RENEW_GIFTED_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _renewGiftedSubscription2).call(this, options, callback);
        case types.PURCHASE_ECOMMERCE_ORDER:
          return _classPrivateFieldGet(this, _purchaseEcommerceOrder2).call(this, options, callback);
        case types.PAY_INVOICE:
          return _classPrivateFieldGet(this, _payInvoice3).call(this, options, callback);
        default:
          console.error("Unsupported payment method: vantiv Gateway");
      }
    });
    _classPrivateFieldInitSpec$1(this, _createSubscription3, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          plan,
          couponCode,
          product,
          quantity = 1,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway3),
          gateway_token: token
        };
        window.Pelcro.subscription.create({
          quantity,
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          coupon_code: couponCode,
          address_id: product.address_required ? addressId : null,
          ...params
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _renewSubscription2, {
      writable: true,
      value: (options, callback) => {
        const {
          subscriptionIdToRenew,
          token,
          plan,
          couponCode,
          product,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway3),
          gateway_token: token
        };
        window.Pelcro.subscription.renew({
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          subscription_id: subscriptionIdToRenew,
          address_id: product.address_required ? addressId : null,
          ...params
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _createGiftedSubscription3, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          plan,
          couponCode,
          product,
          giftRecipient,
          quantity = 1,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway3),
          gateway_token: token
        };
        window.Pelcro.subscription.create({
          quantity,
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          gift_recipient_email: giftRecipient.email,
          gift_recipient_first_name: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.firstName,
          gift_recipient_last_name: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.lastName,
          gift_start_date: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.startDate,
          gift_message: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.giftMessage,
          address_id: product.address_required ? addressId : null,
          ...params
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _renewGiftedSubscription2, {
      writable: true,
      value: (options, callback) => {
        const {
          subscriptionIdToRenew,
          token,
          product,
          plan,
          couponCode,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway3),
          gateway_token: token
        };
        window.Pelcro.subscription.renewGift({
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          subscription_id: subscriptionIdToRenew,
          address_id: product.address_required ? addressId : null,
          ...params
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _purchaseEcommerceOrder2, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          items,
          couponCode,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway3),
          gateway_token: token
        };
        window.Pelcro.ecommerce.order.create({
          items,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          ...params,
          ...(addressId && {
            address_id: addressId
          })
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _payInvoice3, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          invoiceId
        } = options;
        const params = options.isExistingSource ? {
          source_id: token,
          invoice_id: invoiceId
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway3),
          gateway_token: token,
          invoice_id: invoiceId
        };
        window.Pelcro.invoice.pay(params, (err, res) => {
          callback(err, res);
        });
      }
    });
  }
}
var _paymentGateway4 = /*#__PURE__*/new WeakMap();
var _createSubscription4 = /*#__PURE__*/new WeakMap();
var _renewSubscription3 = /*#__PURE__*/new WeakMap();
var _createGiftedSubscription4 = /*#__PURE__*/new WeakMap();
var _renewGiftedSubscription3 = /*#__PURE__*/new WeakMap();
var _purchaseEcommerceOrder3 = /*#__PURE__*/new WeakMap();
var _payInvoice4 = /*#__PURE__*/new WeakMap();
class TapGateway {
  constructor() {
    _classPrivateFieldInitSpec$1(this, _paymentGateway4, {
      writable: true,
      value: PAYMENT_GATEWAYS_ENUM["tap"]
    });
    _defineProperty$3(this, "execute", (options, callback) => {
      const types = PAYMENT_TYPES;
      switch (options.type) {
        case types.CREATE_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _createSubscription4).call(this, options, callback);
        case types.RENEW_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _renewSubscription3).call(this, options, callback);
        case types.CREATE_GIFTED_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _createGiftedSubscription4).call(this, options, callback);
        case types.RENEW_GIFTED_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _renewGiftedSubscription3).call(this, options, callback);
        case types.PURCHASE_ECOMMERCE_ORDER:
          return _classPrivateFieldGet(this, _purchaseEcommerceOrder3).call(this, options, callback);
        case types.PAY_INVOICE:
          return _classPrivateFieldGet(this, _payInvoice4).call(this, options, callback);
        default:
          console.error("Unsupported payment method: tap Gateway");
      }
    });
    _classPrivateFieldInitSpec$1(this, _createSubscription4, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          plan,
          couponCode,
          product,
          quantity = 1,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway4),
          gateway_token: token
        };
        window.Pelcro.subscription.create({
          quantity,
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          coupon_code: couponCode,
          address_id: product.address_required ? addressId : null,
          ...params
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _renewSubscription3, {
      writable: true,
      value: (options, callback) => {
        const {
          subscriptionIdToRenew,
          token,
          plan,
          couponCode,
          product,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway4),
          gateway_token: token
        };
        window.Pelcro.subscription.renew({
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          subscription_id: subscriptionIdToRenew,
          address_id: product.address_required ? addressId : null,
          ...params
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _createGiftedSubscription4, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          plan,
          couponCode,
          product,
          giftRecipient,
          quantity = 1,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway4),
          gateway_token: token
        };
        window.Pelcro.subscription.create({
          quantity,
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          gift_recipient_email: giftRecipient.email,
          gift_recipient_first_name: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.firstName,
          gift_recipient_last_name: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.lastName,
          gift_start_date: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.startDate,
          gift_message: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.giftMessage,
          address_id: product.address_required ? addressId : null,
          ...params
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _renewGiftedSubscription3, {
      writable: true,
      value: (options, callback) => {
        const {
          subscriptionIdToRenew,
          token,
          product,
          plan,
          couponCode,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway4),
          gateway_token: token
        };
        window.Pelcro.subscription.renewGift({
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          subscription_id: subscriptionIdToRenew,
          address_id: product.address_required ? addressId : null,
          ...params
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _purchaseEcommerceOrder3, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          items,
          couponCode,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway4),
          gateway_token: token
        };
        window.Pelcro.ecommerce.order.create({
          items,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          ...params,
          ...(addressId && {
            address_id: addressId
          })
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _payInvoice4, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          invoiceId
        } = options;
        const params = options.isExistingSource ? {
          source_id: token,
          invoice_id: invoiceId
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway4),
          gateway_token: token,
          invoice_id: invoiceId
        };
        window.Pelcro.invoice.pay(params, (err, res) => {
          callback(err, res);
        });
      }
    });
  }
}

/**
 * Cybersource gateway strategy
 */
var _paymentGateway5 = /*#__PURE__*/new WeakMap();
var _createSubscription5 = /*#__PURE__*/new WeakMap();
var _renewSubscription4 = /*#__PURE__*/new WeakMap();
var _createGiftedSubscription5 = /*#__PURE__*/new WeakMap();
var _renewGiftedSubscription4 = /*#__PURE__*/new WeakMap();
var _purchaseEcommerceOrder4 = /*#__PURE__*/new WeakMap();
var _payInvoice5 = /*#__PURE__*/new WeakMap();
class CybersourceGateway {
  constructor() {
    _classPrivateFieldInitSpec$1(this, _paymentGateway5, {
      writable: true,
      value: PAYMENT_GATEWAYS_ENUM["cybersource"]
    });
    _defineProperty$3(this, "execute", (options, callback) => {
      const types = PAYMENT_TYPES;
      switch (options.type) {
        case types.CREATE_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _createSubscription5).call(this, options, callback);
        case types.RENEW_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _renewSubscription4).call(this, options, callback);
        case types.CREATE_GIFTED_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _createGiftedSubscription5).call(this, options, callback);
        case types.RENEW_GIFTED_SUBSCRIPTION:
          return _classPrivateFieldGet(this, _renewGiftedSubscription4).call(this, options, callback);
        case types.PURCHASE_ECOMMERCE_ORDER:
          return _classPrivateFieldGet(this, _purchaseEcommerceOrder4).call(this, options, callback);
        case types.PAY_INVOICE:
          return _classPrivateFieldGet(this, _payInvoice5).call(this, options, callback);
        default:
          console.error("Unsupported payment method: cybersource Gateway");
      }
    });
    _classPrivateFieldInitSpec$1(this, _createSubscription5, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          plan,
          couponCode,
          product,
          quantity = 1,
          addressId,
          isExistingSource,
          fingerprint_session_id
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway5),
          gateway_token: token
        };
        window.Pelcro.subscription.create({
          quantity,
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          coupon_code: couponCode,
          address_id: product.address_required ? addressId : null,
          fingerprint_session_id: fingerprint_session_id,
          ...params
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _renewSubscription4, {
      writable: true,
      value: (options, callback) => {
        const {
          subscriptionIdToRenew,
          token,
          plan,
          couponCode,
          product,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway5),
          gateway_token: token
        };
        window.Pelcro.subscription.renew({
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          subscription_id: subscriptionIdToRenew,
          address_id: product.address_required ? addressId : null,
          ...params
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _createGiftedSubscription5, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          plan,
          couponCode,
          product,
          giftRecipient,
          quantity = 1,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway5),
          gateway_token: token
        };
        window.Pelcro.subscription.create({
          quantity,
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          gift_recipient_email: giftRecipient.email,
          gift_recipient_first_name: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.firstName,
          gift_recipient_last_name: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.lastName,
          gift_start_date: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.startDate,
          gift_message: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.giftMessage,
          address_id: product.address_required ? addressId : null,
          ...params
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _renewGiftedSubscription4, {
      writable: true,
      value: (options, callback) => {
        const {
          subscriptionIdToRenew,
          token,
          product,
          plan,
          couponCode,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway5),
          gateway_token: token
        };
        window.Pelcro.subscription.renewGift({
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          coupon_code: couponCode,
          subscription_id: subscriptionIdToRenew,
          address_id: product.address_required ? addressId : null,
          ...params
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _purchaseEcommerceOrder4, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          items,
          couponCode,
          addressId,
          isExistingSource
        } = options;
        const params = isExistingSource ? {
          source_id: token
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway5),
          gateway_token: token
        };
        window.Pelcro.ecommerce.order.create({
          items,
          coupon_code: couponCode,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          ...params,
          ...(addressId && {
            address_id: addressId
          })
        }, (err, res) => {
          callback(err, res);
        });
      }
    });
    _classPrivateFieldInitSpec$1(this, _payInvoice5, {
      writable: true,
      value: (options, callback) => {
        const {
          token,
          invoiceId
        } = options;
        const params = options.isExistingSource ? {
          source_id: token,
          invoice_id: invoiceId
        } : {
          payment_gateway: _classPrivateFieldGet(this, _paymentGateway5),
          gateway_token: token,
          invoice_id: invoiceId
        };
        window.Pelcro.invoice.pay(params, (err, res) => {
          callback(err, res);
        });
      }
    });
  }
}

/**
 * @typedef {Object} PaymentStateType
 * @property {boolean} disableSubmit
 * @property {boolean} isLoading
 * @property {boolean} disableCouponButton
 * @property {object} couponObject
 * @property {string} couponCode
 * @property {string} couponError
 * @property {boolean} enableCouponField
 * @property {string} percentOff
 * @property {unknown} canMakePayment
 * @property {unknown} paymentRequest
 * @property {number} updatedPrice
 * @property {number} taxAmount
 * @property {object} currentPlan
 * @property {object} alert
 */

/** @type {PaymentStateType} */
const initialState$l = {
  disableSubmit: false,
  isLoading: false,
  disableCouponButton: false,
  couponObject: null,
  couponCode: "",
  couponError: "",
  enableCouponField: false,
  percentOff: "",
  canMakePayment: false,
  paymentRequest: null,
  updatedPrice: null,
  taxAmount: null,
  currentPlan: null,
  firstName: "",
  lastName: "",
  phone: "",
  firstNameError: null,
  lastNameError: null,
  phoneError: null,
  month: "",
  year: "",
  cyberSourceSessionId: null,
  isDefault: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$l = /*#__PURE__*/createContext(initialState$l);
const {
  Provider: Provider$l
} = store$l;
const PaymentMethodContainerWithoutStripe = _ref => {
  var _props$product, _props$plan, _props$subscriptionId, _props$selectedAddres, _props$giftRecipient, _props$isGift, _props$isRenewingGift, _props$invoice, _window$Pelcro, _window$Pelcro$uiSett;
  let {
    style,
    className = "",
    children,
    stripe,
    type,
    onSuccess = () => {},
    onGiftRenewalSuccess = () => {},
    onFailure = () => {},
    ...props
  } = _ref;
  const [vantivPaymentRequest, setVantivPaymentRequest] = useState(null);
  const [updatedCouponCode, setUpdatedCouponCode] = useState("");
  const {
    t
  } = useTranslation("payment");
  const pelcroStore = usePelcro();
  const {
    set,
    order,
    selectedPaymentMethodId,
    couponCode,
    paymentMethodToEdit,
    paymentMethodToDelete
  } = usePelcro();
  const {
    whenUserReady
  } = usePelcro.getStore();
  const product = (_props$product = props.product) !== null && _props$product !== void 0 ? _props$product : pelcroStore.product;
  const plan = (_props$plan = props.plan) !== null && _props$plan !== void 0 ? _props$plan : pelcroStore.plan;
  const subscriptionIdToRenew = (_props$subscriptionId = props.subscriptionIdToRenew) !== null && _props$subscriptionId !== void 0 ? _props$subscriptionId : pelcroStore.subscriptionIdToRenew;
  const selectedAddressId = (_props$selectedAddres = props.selectedAddressId) !== null && _props$selectedAddres !== void 0 ? _props$selectedAddres : pelcroStore.selectedAddressId;
  const giftRecipient = (_props$giftRecipient = props.giftRecipient) !== null && _props$giftRecipient !== void 0 ? _props$giftRecipient : pelcroStore.giftRecipient;
  const isGift = (_props$isGift = props.isGift) !== null && _props$isGift !== void 0 ? _props$isGift : pelcroStore.isGift;
  const isRenewingGift = (_props$isRenewingGift = props.isRenewingGift) !== null && _props$isRenewingGift !== void 0 ? _props$isRenewingGift : pelcroStore.isRenewingGift;
  const invoice = (_props$invoice = props.invoice) !== null && _props$invoice !== void 0 ? _props$invoice : pelcroStore.invoice;
  const skipPayment = (_window$Pelcro = window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.skipPaymentForFreePlans;
  const cardProcessor = getSiteCardProcessor();
  useEffect(() => {
    if (window.Pelcro.coupon.getFromUrl()) {
      dispatch({
        type: UPDATE_COUPON_CODE,
        payload: window.Pelcro.coupon.getFromUrl()
      });
    } else if (couponCode) {
      dispatch({
        type: UPDATE_COUPON_CODE,
        payload: couponCode
      });
    }
    dispatch({
      type: INIT_CONTAINER
    });
    updateTotalAmountWithTax();
  }, []);

  /* ====== Start Cybersource integration ======== */
  const cybersourceErrorHandle = err => {
    var _err$details, _err$details$response, _err$details$response2;
    if ((err === null || err === void 0 ? void 0 : (_err$details = err.details) === null || _err$details === void 0 ? void 0 : (_err$details$response = _err$details.responseStatus) === null || _err$details$response === void 0 ? void 0 : (_err$details$response2 = _err$details$response.details) === null || _err$details$response2 === void 0 ? void 0 : _err$details$response2.length) > 0) {
      var _err$details2, _err$details2$respons;
      const errorMessages = [];

      // enumerable error (ex: validation errors)
      Object.values(err === null || err === void 0 ? void 0 : (_err$details2 = err.details) === null || _err$details2 === void 0 ? void 0 : (_err$details2$respons = _err$details2.responseStatus) === null || _err$details2$respons === void 0 ? void 0 : _err$details2$respons.details).forEach(_ref2 => {
        let {
          message
        } = _ref2;
        errorMessages.push(message);
      });

      // convert to multiline string
      return errorMessages.join("\n");
    } else {
      var _err$details3;
      return getErrorMessages(err === null || err === void 0 ? void 0 : (_err$details3 = err.details) === null || _err$details3 === void 0 ? void 0 : _err$details3.responseStatus);
    }
  };
  const submitUsingCybersource = (state, dispatch) => {
    var _cybersourceInstanceR;
    console.log("State", state);
    const isUsingExistingPaymentMethod = Boolean(selectedPaymentMethodId);
    if (isUsingExistingPaymentMethod) {
      // no need to create a new source using cybersrce
      return handleCybersourcePayment(null, state);
    }
    if (!cybersourceInstanceRef.current) {
      return console.error("Cybersource sdk script wasn't loaded, you need to load Cybersource sdk before rendering the Cybersource payment flow");
    }
    let options = {
      cardExpirationMonth: state.month,
      cardExpirationYear: state.year
    };
    (_cybersourceInstanceR = cybersourceInstanceRef.current) === null || _cybersourceInstanceR === void 0 ? void 0 : _cybersourceInstanceR.createToken(options, function (err, response) {
      if (err) {
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
        dispatch({
          type: LOADING,
          payload: false
        });
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: cybersourceErrorHandle(err)
          }
        });
      }
      handleCybersourcePayment(response.token, state);
    });
  };
  function handleCybersourcePayment(paymentRequest, state) {
    const isUsingExistingPaymentMethod = Boolean(selectedPaymentMethodId);
    if (type === "createPayment") {
      handleCybersourceSubscription();
    } else if (type === "orderCreate") {
      purchase(new CybersourceGateway(), isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest, state, dispatch);
    } else if (type === "invoicePayment") {
      payInvoice(new CybersourceGateway(), isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest);
    } else if (type === "createPaymentSource" || type === "updatePaymentSource") {
      createNewCybersourceCard();
    }
    function createNewCybersourceCard() {
      window.Pelcro.source.create({
        auth_token: window.Pelcro.user.read().auth_token,
        token: paymentRequest,
        gateway: "cybersource"
      }, (err, res) => {
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
        dispatch({
          type: LOADING,
          payload: false
        });
        toggleAuthenticationSuccessPendingView(false);
        if (err) {
          onFailure(err);
          return dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
        }
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("messages.sourceUpdated")
          }
        });
        onSuccess(res);
      } //
      );
    }

    function handleCybersourceSubscription() {
      const payment = new Payment(new CybersourceGateway());
      const createSubscription = !isGift && !subscriptionIdToRenew;
      const renewSubscription = !isGift && subscriptionIdToRenew;
      const giftSubscriprition = isGift && !subscriptionIdToRenew;
      const renewGift = isRenewingGift;
      const {
        couponCode
      } = state;
      if (renewGift) {
        return payment.execute({
          type: PAYMENT_TYPES.RENEW_GIFTED_SUBSCRIPTION,
          token: isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest,
          plan,
          couponCode,
          product,
          isExistingSource: isUsingExistingPaymentMethod,
          subscriptionIdToRenew,
          addressId: selectedAddressId
        }, (err, res) => {
          if (err) {
            return handlePaymentError(err);
          }
          onSuccess(res);
        });
      } else if (giftSubscriprition) {
        return payment.execute({
          type: PAYMENT_TYPES.CREATE_GIFTED_SUBSCRIPTION,
          token: isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest,
          quantity: plan.quantity,
          plan,
          couponCode,
          product,
          isExistingSource: isUsingExistingPaymentMethod,
          giftRecipient,
          addressId: selectedAddressId
        }, (err, res) => {
          if (err) {
            return handlePaymentError(err);
          }
          onSuccess(res);
        });
      } else if (renewSubscription) {
        return payment.execute({
          type: PAYMENT_TYPES.RENEW_SUBSCRIPTION,
          token: isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest,
          quantity: plan.quantity,
          plan,
          couponCode,
          product,
          isExistingSource: isUsingExistingPaymentMethod,
          subscriptionIdToRenew,
          addressId: selectedAddressId
        }, (err, res) => {
          if (err) {
            return handlePaymentError(err);
          }
          onSuccess(res);
        });
      } else if (createSubscription) {
        return payment.execute({
          type: PAYMENT_TYPES.CREATE_SUBSCRIPTION,
          token: isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest,
          quantity: plan.quantity,
          plan,
          couponCode,
          product,
          isExistingSource: isUsingExistingPaymentMethod,
          addressId: selectedAddressId,
          fingerprint_session_id: state.cyberSourceSessionId
        }, (err, res) => {
          if (err) {
            return handlePaymentError(err);
          }
          onSuccess(res);
        });
      }
    }
  }
  const tokenizeCard = (error, microformInstance) => {
    if (error) {
      return;
    }
    cybersourceInstanceRef.current = microformInstance;
  };
  const appendCybersourceFingerprintScripts = () => {
    var _window$Pelcro$site$r, _window$Pelcro$site$r2, _window$Pelcro$site$r3, _window$Pelcro$site$r4;
    const uniqueId = crypto.randomUUID();
    const sessionID = ((_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : (_window$Pelcro$site$r2 = _window$Pelcro$site$r.cybersource_gateway_settings) === null || _window$Pelcro$site$r2 === void 0 ? void 0 : _window$Pelcro$site$r2.merchant_id) + uniqueId;
    const orgID = (_window$Pelcro$site$r3 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r3 === void 0 ? void 0 : (_window$Pelcro$site$r4 = _window$Pelcro$site$r3.cybersource_gateway_settings) === null || _window$Pelcro$site$r4 === void 0 ? void 0 : _window$Pelcro$site$r4.org_id;
    const fingerPrintScript = document.querySelector(`script[src="https://h.online-metrix.net/fp/tags.js?org_id=${orgID}&session_id=${sessionID}"]`);
    const fingerPringIframe = document.querySelector(`iframe[src="https://h.online-metrix.net/fp/tags?org_id=${orgID}&session_id=${sessionID}"]`);
    if (!fingerPrintScript && !fingerPringIframe) {
      window.Pelcro.helpers.loadSDK(`https://h.online-metrix.net/fp/tags.js?org_id=${orgID}&session_id=${sessionID}`, "cybersource-fingerprint-script");
      const body = document.getElementsByTagName("body")[0];
      const noscript = document.createElement("noscript");
      const iframe = document.createElement("iframe");
      iframe.style.cssText = "width: 100px; height: 100px; border: 0; position:absolute; top: -5000px;";
      iframe.src = `https://h.online-metrix.net/fp/tags?org_id=${orgID}&session_id=${sessionID}`;
      noscript.appendChild(iframe);
      body.insertBefore(noscript, body.firstChild);
      dispatch({
        type: UPDATE_CYBERSOURCE_SESSION_ID,
        payload: uniqueId
      });
    }
  };
  const initCybersourceScript = () => {
    // jwk api call
    window.Pelcro.payment.getJWK({
      auth_token: window.Pelcro.user.read().auth_token,
      site_id: window.Pelcro.siteid
    }, (err, res) => {
      if (err) {
        onFailure(err);
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
        dispatch({
          type: LOADING,
          payload: false
        });
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
      }
      const {
        key: jwk
      } = res;
      // SETUP MICROFORM
      FLEX.microform({
        keyId: jwk.kid,
        keystore: jwk,
        container: "#cybersourceCardNumber",
        placeholder: "Card Number",
        styles: {
          input: {
            "font-size": "14px",
            "font-family": "helvetica, tahoma, calibri, sans-serif",
            color: "#555"
          },
          ":focus": {
            color: "blue"
          },
          ":disabled": {
            cursor: "not-allowed"
          },
          valid: {
            color: "#3c763d"
          },
          invalid: {
            color: "#a94442"
          }
        }
      }, tokenizeCard);
    });
  };

  /* ====== End Cybersource integration ======== */

  /* ====== Start Tap integration ======== */
  const submitUsingTap = state => {
    var _ref3, _ref4, _ref5, _state$updatedPrice;
    const isUsingExistingPaymentMethod = Boolean(selectedPaymentMethodId);
    if (isUsingExistingPaymentMethod) {
      // no need to create a new source using tap
      return handleTapPayment(null, state);
    }
    if (!tapInstanceRef.current) {
      return console.error("Tap sdk script wasn't loaded, you need to load tap sdk before rendering the tap payment flow");
    }
    const getOrderItemsTotal = () => {
      if (!order) {
        return null;
      }
      const isQuickPurchase = !Array.isArray(order);
      if (isQuickPurchase) {
        return order.price * order.quantity;
      }
      if (order.length === 0) {
        return null;
      }
      return order.reduce((total, item) => {
        return total + item.price * item.quantity;
      }, 0);
    };
    const totalAmount = (_ref3 = (_ref4 = (_ref5 = (_state$updatedPrice = state === null || state === void 0 ? void 0 : state.updatedPrice) !== null && _state$updatedPrice !== void 0 ? _state$updatedPrice : plan === null || plan === void 0 ? void 0 : plan.amount) !== null && _ref5 !== void 0 ? _ref5 : invoice === null || invoice === void 0 ? void 0 : invoice.amount_remaining) !== null && _ref4 !== void 0 ? _ref4 : getOrderItemsTotal()) !== null && _ref3 !== void 0 ? _ref3 : 10;
    tapInstanceRef.current.createToken(tapInstanceCard.current).then(function (result) {
      if (result.error) {
        // Inform the user if there was an error
        onFailure(result.error);
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
        dispatch({
          type: LOADING,
          payload: false
        });
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(result.error)
          }
        });
      } else {
        window.Pelcro.payment.verify({
          auth_token: window.Pelcro.user.read().auth_token,
          first_name: window.Pelcro.user.read().first_name || state.firstName,
          last_name: window.Pelcro.user.read().last_name || state.lastName,
          phone: window.Pelcro.user.read().phone || state.phone,
          site_id: window.Pelcro.siteid,
          amount: totalAmount,
          currency: (plan === null || plan === void 0 ? void 0 : plan.currency) || (invoice === null || invoice === void 0 ? void 0 : invoice.currency) || window.Pelcro.site.read().default_currency,
          tap_token: result.id,
          funding: result.card.funding,
          redirect_url: `${window.Pelcro.environment.domain}/webhook/tap/callback/3dsecure?auth_token=${window.Pelcro.user.read().auth_token}&type=verify_card&site_id=${window.Pelcro.siteid}`
        }, (err, res) => {
          if (err) {
            // Inform the user if there was an error
            onFailure(err);
            dispatch({
              type: DISABLE_SUBMIT,
              payload: false
            });
            dispatch({
              type: LOADING,
              payload: false
            });
            return dispatch({
              type: SHOW_ALERT,
              payload: {
                type: "error",
                content: getErrorMessages(err)
              }
            });
          } else {
            toggleAuthenticationPendingView(true, res);
            const listenFor3DSecureCompletionMessage = () => {
              const retrieveSourceInfoFromIframe = event => {
                const {
                  data
                } = event;
                if (data.message === "3DS-authentication-complete") {
                  const tapID = data.tapID;
                  toggleAuthenticationPendingView(false);
                  toggleAuthenticationSuccessPendingView(true);
                  window.removeEventListener("message", retrieveSourceInfoFromIframe);
                  dispatch({
                    type: SHOW_ALERT,
                    payload: {
                      type: "error",
                      content: null
                    }
                  });
                  handleTapPayment(tapID, state);
                }
              };

              // listen to injected iframe for authentication complete message
              window.addEventListener("message", retrieveSourceInfoFromIframe);
            };
            listenFor3DSecureCompletionMessage();
          }
        });
      }
    });
  };
  function handleTapPayment(paymentRequest, state) {
    const isUsingExistingPaymentMethod = Boolean(selectedPaymentMethodId);
    if (type === "createPayment") {
      handleTapSubscription();
    } else if (type === "orderCreate") {
      purchase(new TapGateway(), isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest, state, dispatch);
    } else if (type === "invoicePayment") {
      payInvoice(new TapGateway(), isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest);
    } else if (type === "createPaymentSource" || type === "updatePaymentSource") {
      createNewTapCard();
    }
    function createNewTapCard() {
      window.Pelcro.source.create({
        auth_token: window.Pelcro.user.read().auth_token,
        token: paymentRequest,
        gateway: "tap"
      }, (err, res) => {
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
        dispatch({
          type: LOADING,
          payload: false
        });
        toggleAuthenticationSuccessPendingView(false);
        if (err) {
          onFailure(err);
          return dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
        }
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("messages.sourceUpdated")
          }
        });
        onSuccess(res);
      } //
      );
    }

    function handleTapSubscription() {
      const payment = new Payment(new TapGateway());
      const createSubscription = !isGift && !subscriptionIdToRenew;
      const renewSubscription = !isGift && subscriptionIdToRenew;
      const giftSubscriprition = isGift && !subscriptionIdToRenew;
      const renewGift = isRenewingGift;
      const {
        couponCode
      } = state;
      if (renewGift) {
        return payment.execute({
          type: PAYMENT_TYPES.RENEW_GIFTED_SUBSCRIPTION,
          token: isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest,
          plan,
          couponCode,
          product,
          isExistingSource: isUsingExistingPaymentMethod,
          subscriptionIdToRenew,
          addressId: selectedAddressId
        }, (err, res) => {
          if (err) {
            return handlePaymentError(err);
          }
          onSuccess(res);
        });
      } else if (giftSubscriprition) {
        return payment.execute({
          type: PAYMENT_TYPES.CREATE_GIFTED_SUBSCRIPTION,
          token: isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest,
          quantity: plan.quantity,
          plan,
          couponCode,
          product,
          isExistingSource: isUsingExistingPaymentMethod,
          giftRecipient,
          addressId: selectedAddressId
        }, (err, res) => {
          if (err) {
            return handlePaymentError(err);
          }
          onSuccess(res);
        });
      } else if (renewSubscription) {
        return payment.execute({
          type: PAYMENT_TYPES.RENEW_SUBSCRIPTION,
          token: isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest,
          quantity: plan.quantity,
          plan,
          couponCode,
          product,
          isExistingSource: isUsingExistingPaymentMethod,
          subscriptionIdToRenew,
          addressId: selectedAddressId
        }, (err, res) => {
          if (err) {
            return handlePaymentError(err);
          }
          onSuccess(res);
        });
      } else if (createSubscription) {
        return payment.execute({
          type: PAYMENT_TYPES.CREATE_SUBSCRIPTION,
          token: isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest,
          quantity: plan.quantity,
          plan,
          couponCode,
          product,
          isExistingSource: isUsingExistingPaymentMethod,
          addressId: selectedAddressId
        }, (err, res) => {
          if (err) {
            return handlePaymentError(err);
          }
          onSuccess(res);
        });
      }
    }
  }
  const initTapScript = () => {
    var _window$Pelcro$site$r5;
    const tapKey = window.Tapjsli((_window$Pelcro$site$r5 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r5 === void 0 ? void 0 : _window$Pelcro$site$r5.tap_gateway_settings.publishable_key);
    let elements = tapKey.elements({});
    let style = {
      base: {
        color: "#535353",
        lineHeight: "18px",
        fontFamily: "sans-serif",
        fontSmoothing: "antialiased",
        fontSize: "16px",
        "::placeholder": {
          color: "rgba(0, 0, 0, 0.26)",
          fontSize: "15px"
        }
      },
      invalid: {
        color: "red"
      }
    };

    // input labels/placeholders
    let labels = {
      cardNumber: "Card Number",
      expirationDate: "MM/YY",
      cvv: "CVV",
      cardHolder: "Card Holder Name"
    };

    // payment options
    let paymentOptions = {
      labels: labels,
      TextDirection: "ltr"
    };

    // create element, pass style and payment options
    let card = elements.create("card", {
      style: style
    }, paymentOptions);

    // mount element
    card.mount("#tapPaymentIframe");

    // card change event listener
    card.addEventListener("change", function (event) {
      // If needed
    });
    tapInstanceRef.current = tapKey;
    tapInstanceCard.current = card;
  };
  /* ====== End Tap integration ======== */

  const submitUsingVantiv = state => {
    const isUsingExistingPaymentMethod = Boolean(selectedPaymentMethodId);
    if (isUsingExistingPaymentMethod) {
      // no need to create a new source using vantiv
      return handleVantivPayment(null, state.couponCode);
    }
    if (!vantivInstanceRef.current) {
      return console.error("Vantiv sdk script wasn't loaded, you need to load vantiv sdk before rendering the vantiv payment flow");
    }
    const orderId = `pelcro-${new Date().getTime()}`;
    /*     
    calls handleVantivPayment to either handle a payment or update a source by simply creating a new source 
    */
    vantivInstanceRef.current.getPaypageRegistrationId({
      id: orderId,
      orderId: orderId
    });
  };
  function handleVantivPayment(paymentRequest, couponCode) {
    if (paymentRequest) {
      const SUCCESS_STATUS = "870";
      if (paymentRequest.response !== SUCCESS_STATUS) {
        switch (paymentRequest.response) {
          case "871":
            return handlePaymentError({
              error: new Error("Invalid account number")
            });
          default:
            return handlePaymentError({
              error: new Error(paymentRequest.message)
            });
        }
      }
    }
    const isUsingExistingPaymentMethod = Boolean(selectedPaymentMethodId);
    if (type === "createPayment") {
      handleVantivSubscription();
    } else if (type === "orderCreate") {
      purchase(new VantivGateway(), isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest, state, dispatch);
    } else if (type === "invoicePayment") {
      payInvoice(new VantivGateway(), isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest);
    } else if (type === "createPaymentSource") {
      createNewVantivCard();
    } else if (type === "updatePaymentSource") {
      updateVantivCard();
    } else if (type === "deletePaymentSource") {
      replaceVantivCard();
    }
    function createNewVantivCard() {
      window.Pelcro.paymentMethods.create({
        auth_token: window.Pelcro.user.read().auth_token,
        token: paymentRequest,
        gateway: "vantiv"
      }, (err, res) => {
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
        dispatch({
          type: LOADING,
          payload: false
        });
        if (err) {
          onFailure(err);
          return dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
        }
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("messages.sourceCreated")
          }
        });
        refreshUser();
        onSuccess(res);
      });
    }
    function replaceVantivCard() {
      const {
        id: paymentMethodId
      } = paymentMethodToDelete;
      window.Pelcro.paymentMethods.create({
        auth_token: window.Pelcro.user.read().auth_token,
        token: paymentRequest,
        gateway: "vantiv"
      }, (err, res) => {
        if (err) {
          dispatch({
            type: DISABLE_SUBMIT,
            payload: false
          });
          dispatch({
            type: LOADING,
            payload: false
          });
          onFailure(err);
          return dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
        }
        if (res) {
          setTimeout(() => {
            window.Pelcro.paymentMethods.deletePaymentMethod({
              auth_token: window.Pelcro.user.read().auth_token,
              payment_method_id: paymentMethodId
            }, (err, res) => {
              dispatch({
                type: DISABLE_SUBMIT,
                payload: false
              });
              dispatch({
                type: LOADING,
                payload: false
              });
              if (err) {
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(err);
                return dispatch({
                  type: SHOW_ALERT,
                  payload: {
                    type: "error",
                    content: getErrorMessages(err)
                  }
                });
              }
              refreshUser();
              onSuccess(res);
            });
          }, 2000);
        }
      });
    }
    function updateVantivCard() {
      const {
        id: paymentMethodId
      } = paymentMethodToEdit;
      const {
        paypageRegistrationId,
        bin,
        type,
        firstSix,
        lastFour,
        expMonth,
        expYear
      } = paymentRequest;
      const {
        isDefault
      } = state;
      const fourDigitExpYear = getFourDigitYear(Number(expYear)).toString();
      window.Pelcro.paymentMethods.update({
        auth_token: window.Pelcro.user.read().auth_token,
        payment_method_id: paymentMethodId,
        gateway: "vantiv",
        paypageRegistrationId: paypageRegistrationId,
        bin: bin,
        type: type,
        firstSix: firstSix,
        lastFour: lastFour,
        exp_month: expMonth,
        exp_year: fourDigitExpYear,
        is_default: isDefault
      }, (err, res) => {
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
        dispatch({
          type: LOADING,
          payload: false
        });
        if (err) {
          onFailure(err);
          return dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
        }
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("messages.sourceUpdated")
          }
        });
        refreshUser();
        onSuccess(res);
      });
    }
    function handleVantivSubscription() {
      const payment = new Payment(new VantivGateway());
      const createSubscription = !isGift && !subscriptionIdToRenew;
      const renewSubscription = !isGift && subscriptionIdToRenew;
      const giftSubscriprition = isGift && !subscriptionIdToRenew;
      const renewGift = isRenewingGift;
      if (renewGift) {
        return payment.execute({
          type: PAYMENT_TYPES.RENEW_GIFTED_SUBSCRIPTION,
          token: isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest,
          plan,
          couponCode,
          product,
          isExistingSource: isUsingExistingPaymentMethod,
          subscriptionIdToRenew,
          addressId: selectedAddressId
        }, (err, res) => {
          if (err) {
            return handlePaymentError(err);
          }
          onSuccess(res);
        });
      } else if (giftSubscriprition) {
        return payment.execute({
          type: PAYMENT_TYPES.CREATE_GIFTED_SUBSCRIPTION,
          token: isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest,
          quantity: plan.quantity,
          plan,
          couponCode,
          product,
          isExistingSource: isUsingExistingPaymentMethod,
          giftRecipient,
          addressId: selectedAddressId
        }, (err, res) => {
          if (err) {
            return handlePaymentError(err);
          }
          onSuccess(res);
        });
      } else if (renewSubscription) {
        return payment.execute({
          type: PAYMENT_TYPES.RENEW_SUBSCRIPTION,
          token: isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest,
          quantity: plan.quantity,
          plan,
          couponCode,
          product,
          isExistingSource: isUsingExistingPaymentMethod,
          subscriptionIdToRenew,
          addressId: selectedAddressId
        }, (err, res) => {
          if (err) {
            return handlePaymentError(err);
          }
          onSuccess(res);
        });
      } else if (createSubscription) {
        return payment.execute({
          type: PAYMENT_TYPES.CREATE_SUBSCRIPTION,
          token: isUsingExistingPaymentMethod ? selectedPaymentMethodId : paymentRequest,
          quantity: plan.quantity,
          plan,
          couponCode,
          product,
          isExistingSource: isUsingExistingPaymentMethod,
          addressId: selectedAddressId
        }, (err, res) => {
          if (err) {
            return handlePaymentError(err);
          }
          onSuccess(res);
        });
      }
    }
  }
  const vantivInstanceRef = React__default.useRef(null);
  const tapInstanceRef = React__default.useRef(null);
  const tapInstanceCard = React__default.useRef(null);
  const cybersourceInstanceRef = React__default.useRef(null);
  useEffect(() => {
    if (skipPayment && ((plan === null || plan === void 0 ? void 0 : plan.amount) === 0 || props !== null && props !== void 0 && props.freeOrders)) return;
    if (cardProcessor === "vantiv" && !selectedPaymentMethodId) {
      var _window$Pelcro$site$r6, _window$Pelcro$site$r7;
      const payPageId = (_window$Pelcro$site$r6 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r6 === void 0 ? void 0 : _window$Pelcro$site$r6.vantiv_gateway_settings.pay_page_id;
      const reportGroup = (_window$Pelcro$site$r7 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r7 === void 0 ? void 0 : _window$Pelcro$site$r7.vantiv_gateway_settings.report_group;
      vantivInstanceRef.current = new window.EprotectIframeClient({
        paypageId: payPageId,
        reportGroup: reportGroup,
        style: "enhancedStyle5",
        height: "245",
        timeout: 50000,
        div: "eProtectiframe",
        callback: paymentRequest => setVantivPaymentRequest(paymentRequest),
        showCvv: true,
        numYears: 8,
        placeholderText: {
          cvv: "CVV",
          accountNumber: "1234 1234 1234 1234"
        },
        enhancedUxFeatures: {
          inlineFieldValidations: true,
          expDateValidation: true,
          numericInputsOnly: true
        }
      });
    }
  }, [selectedPaymentMethodId]);

  // Trigger the handleVantivPayment method when a vantivPaymentRequest is present
  useEffect(() => {
    if (vantivPaymentRequest) {
      handleVantivPayment(vantivPaymentRequest, updatedCouponCode);
    }
  }, [vantivPaymentRequest]);
  useEffect(() => {
    whenUserReady(() => {
      if (skipPayment && ((plan === null || plan === void 0 ? void 0 : plan.amount) === 0 || props !== null && props !== void 0 && props.freeOrders)) return;
      if (cardProcessor === "tap" && !window.Tapjsli) {
        window.Pelcro.helpers.loadSDK("https://cdnjs.cloudflare.com/ajax/libs/bluebird/3.3.4/bluebird.min.js", "tap-bluebird");
        window.Pelcro.helpers.loadSDK("https://secure.gosell.io/js/sdk/tap.min.js", "tap-sdk");
        document.querySelector('script[src="https://secure.gosell.io/js/sdk/tap.min.js"]').addEventListener("load", () => {
          initTapScript();
        });
      }
      if (cardProcessor === "tap" && !selectedPaymentMethodId && window.Tapjsli) {
        initTapScript();
      }
      if (cardProcessor === "cybersource" && !selectedPaymentMethodId && !window.FLEX) {
        window.Pelcro.helpers.loadSDK("https://flex.cybersource.com/cybersource/assets/microform/0.4/flex-microform.min.js", "cybersource-cdn");
        document.querySelector('script[src="https://flex.cybersource.com/cybersource/assets/microform/0.4/flex-microform.min.js"]').addEventListener("load", () => {
          initCybersourceScript();
        });
      }
      if (cardProcessor === "cybersource" && !selectedPaymentMethodId && window.FLEX) {
        initCybersourceScript();
      }
      if (cardProcessor === "cybersource") {
        appendCybersourceFingerprintScripts();
      }
    });
  }, [selectedPaymentMethodId]);
  const initPaymentRequest = (state, dispatch) => {
    if (skipPayment && ((plan === null || plan === void 0 ? void 0 : plan.amount) === 0 || props !== null && props !== void 0 && props.freeOrders)) return;
    try {
      const paymentRequest = stripe.paymentRequest({
        country: window.Pelcro.user.location.countryCode || "US",
        currency: plan.currency,
        total: {
          label: plan.nickname || plan.description,
          amount: state.updatedPrice || plan.amount
        }
      });

      // When Google pay / Apple pay source created
      paymentRequest.on("source", _ref6 => {
        var _source$card;
        let {
          complete,
          source,
          ...data
        } = _ref6;
        dispatch({
          type: DISABLE_COUPON_BUTTON,
          payload: true
        });
        dispatch({
          type: DISABLE_SUBMIT,
          payload: true
        });
        dispatch({
          type: LOADING,
          payload: true
        });
        complete("success");
        if ((source === null || source === void 0 ? void 0 : (_source$card = source.card) === null || _source$card === void 0 ? void 0 : _source$card.three_d_secure) === "required") {
          return generate3DSecureSource(source).then(_ref7 => {
            let {
              source,
              error
            } = _ref7;
            if (error) {
              return handlePaymentError(error);
            }
            toggleAuthenticationPendingView(true, source);
          });
        }
        dispatch({
          type: SUBSCRIBE,
          payload: source
        });
      });
      paymentRequest.canMakePayment().then(result => {
        dispatch({
          type: SET_CAN_MAKE_PAYMENT,
          payload: !!result
        });
      });
      dispatch({
        type: SET_PAYMENT_REQUEST,
        payload: paymentRequest
      });
    } catch {
      console.log("Google Pay/Apple pay isn't available/supported in this country");
    }
  };

  /**
   * Updates the total amount after adding taxes only if site taxes are enabled
   */
  const updateTotalAmountWithTax = () => {
    var _window$Pelcro$site$r8;
    if (skipPayment && ((plan === null || plan === void 0 ? void 0 : plan.amount) === 0 || props !== null && props !== void 0 && props.freeOrders)) return;
    const taxesEnabled = (_window$Pelcro$site$r8 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r8 === void 0 ? void 0 : _window$Pelcro$site$r8.taxes_enabled;
    if (taxesEnabled && type === "createPayment") {
      dispatch({
        type: DISABLE_SUBMIT,
        payload: true
      });
      resolveTaxCalculation().then(res => {
        if (res) {
          dispatch({
            type: SET_TAX_AMOUNT,
            payload: res.taxAmount
          });
          dispatch({
            type: SET_UPDATED_PRICE,
            payload: res.totalAmountWithTax
          });
          dispatch({
            type: UPDATE_PAYMENT_REQUEST
          });
        }
      }).catch(error => {
        handlePaymentError(error);
      }).finally(() => {
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
      });
    }
  };
  const onApplyCouponCode = (state, dispatch) => {
    const {
      couponCode
    } = state;
    const handleCouponResponse = (err, res) => {
      var _res$data$coupon;
      dispatch({
        type: DISABLE_COUPON_BUTTON,
        payload: false
      });
      if (err) {
        onFailure(err);

        // reset the coupon code in local state
        setUpdatedCouponCode("");
        dispatch({
          type: SET_COUPON_ERROR,
          payload: getErrorMessages(err)
        });

        // remove current coupon
        dispatch({
          type: SET_COUPON,
          payload: null
        });
        dispatch({
          type: SET_PERCENT_OFF,
          payload: ""
        });
        dispatch({
          type: SET_UPDATED_PRICE,
          payload: null
        });
        dispatch({
          type: SET_TAX_AMOUNT,
          payload: null
        });
        const {
          currentPlan
        } = state;
        if (currentPlan) {
          var _currentPlan$quantity;
          const quantity = (_currentPlan$quantity = currentPlan.quantity) !== null && _currentPlan$quantity !== void 0 ? _currentPlan$quantity : 1;
          const price = currentPlan.amount;
          dispatch({
            type: SET_UPDATED_PRICE,
            // set original plan price
            payload: price * quantity
          });
          dispatch({
            type: UPDATE_PAYMENT_REQUEST
          });

          // update the new amount with taxes if site has taxes enabled
          updateTotalAmountWithTax();
        }
        return;
      }
      dispatch({
        type: SET_COUPON_ERROR,
        payload: ""
      });
      dispatch({
        type: SHOW_ALERT,
        payload: {
          type: "error",
          content: ""
        }
      });
      dispatch({
        type: SET_COUPON,
        payload: res.data.coupon
      });

      // set the coupon code in local state to be able to use with Vantiv
      setUpdatedCouponCode(res.data.coupon.code);
      dispatch({
        type: SET_PERCENT_OFF,
        payload: `${(_res$data$coupon = res.data.coupon) === null || _res$data$coupon === void 0 ? void 0 : _res$data$coupon.percent_off}%`
      });
      dispatch({
        type: SET_TAX_AMOUNT,
        payload: res.data.taxes
      });
      dispatch({
        type: SET_UPDATED_PRICE,
        payload: res.data.total
      });
      dispatch({
        type: UPDATE_PAYMENT_REQUEST
      });
    };
    if ((couponCode === null || couponCode === void 0 ? void 0 : couponCode.trim()) === "") {
      dispatch({
        type: SET_COUPON,
        payload: null
      });
      dispatch({
        type: SET_PERCENT_OFF,
        payload: ""
      });
      dispatch({
        type: SET_UPDATED_PRICE,
        payload: null
      });
      dispatch({
        type: SET_TAX_AMOUNT,
        payload: null
      });
      dispatch({
        type: UPDATE_PAYMENT_REQUEST
      });
      updateTotalAmountWithTax();
    }
    if (couponCode !== null && couponCode !== void 0 && couponCode.trim()) {
      dispatch({
        type: DISABLE_COUPON_BUTTON,
        payload: true
      });
      if (type === "createPayment") {
        window.Pelcro.order.create({
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          coupon_code: couponCode,
          address_id: selectedAddressId
        }, handleCouponResponse);
      } else if (type === "orderCreate") {
        const isQuickPurchase = !Array.isArray(order);
        const mappedOrderItems = isQuickPurchase ? [{
          sku_id: order.id,
          quantity: order.quantity
        }] : order.map(item => ({
          sku_id: item.id,
          quantity: item.quantity
        }));
        window.Pelcro.ecommerce.order.createSummary({
          items: mappedOrderItems,
          coupon_code: couponCode
        }, handleCouponResponse);
      }
    }
  };
  const debouncedApplyCouponCode = useRef(debounce(onApplyCouponCode, 1000)).current;
  const removeAppliedCoupon = state => {
    state.couponCode = "";

    // reset the coupon code in local state
    setUpdatedCouponCode("");
    dispatch({
      type: SET_COUPON_ERROR,
      payload: ""
    });
    dispatch({
      type: SHOW_COUPON_FIELD,
      payload: false
    });
    dispatch({
      type: SET_COUPON,
      payload: null
    });
    dispatch({
      type: SET_PERCENT_OFF,
      payload: ""
    });
    dispatch({
      type: SET_UPDATED_PRICE,
      payload: null
    });
    dispatch({
      type: SET_TAX_AMOUNT,
      payload: null
    });
    const {
      currentPlan
    } = state;
    if (currentPlan) {
      var _currentPlan$quantity2;
      const quantity = (_currentPlan$quantity2 = currentPlan.quantity) !== null && _currentPlan$quantity2 !== void 0 ? _currentPlan$quantity2 : 1;
      const price = currentPlan.amount;
      dispatch({
        type: SET_UPDATED_PRICE,
        // set original plan price
        payload: price * quantity
      });
      dispatch({
        type: UPDATE_PAYMENT_REQUEST
      });

      // update the new amount with taxes if site has taxes enabled
      updateTotalAmountWithTax();
    }
  };

  /**
   * Attempt to confirm a Stripe card payment via it's PaymentIntent.
   * Only trigger method if PaymentIntent status is `requires_action`.
   *
   * @see https://stripe.com/docs/payments/intents#intent-statuses
   *
   * @param response
   * @param error
   * @returns {*}
   */
  const confirmStripeCardPayment = function (response, error) {
    let isSubCreate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (response) {
      var _response$data;
      const paymentIntent = (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.payment_intent;
      if ((paymentIntent === null || paymentIntent === void 0 ? void 0 : paymentIntent.status) === "requires_action" && paymentIntent !== null && paymentIntent !== void 0 && paymentIntent.client_secret) {
        stripe.confirmCardPayment(paymentIntent.client_secret).then(res => {
          if (!isSubCreate) {
            dispatch({
              type: DISABLE_SUBMIT,
              payload: false
            });
          }
          dispatch({
            type: LOADING,
            payload: false
          });
          if (res.error) {
            onFailure(res.error);
            return dispatch({
              type: SHOW_ALERT,
              payload: {
                type: "error",
                content: isSubCreate ? t("messages.tryAgainFromInvoice") : getErrorMessages(res.error)
              }
            });
          }
          onSuccess(res);
        });
      } else if ((paymentIntent === null || paymentIntent === void 0 ? void 0 : paymentIntent.status) === "requires_payment_method" && paymentIntent !== null && paymentIntent !== void 0 && paymentIntent.client_secret) {
        if (!isSubCreate) {
          dispatch({
            type: DISABLE_SUBMIT,
            payload: false
          });
        }
        dispatch({
          type: LOADING,
          payload: false
        });
        onFailure(error);
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: isSubCreate ? t("messages.tryAgainFromInvoice") : t("messages.cardAuthFailed")
          }
        });
      } else {
        onSuccess(response);
      }
    } else {
      dispatch({
        type: DISABLE_SUBMIT,
        payload: false
      });
      dispatch({
        type: LOADING,
        payload: false
      });
      if (error) {
        onFailure(error);
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(error)
          }
        });
      }
      onSuccess(response);
    }
  };
  const confirmStripeIntentSetup = (response, flow, paymentMethodId) => {
    var _response$data2;
    const setupIntent = (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.setup_intent;
    if ((setupIntent === null || setupIntent === void 0 ? void 0 : setupIntent.status) === "requires_action" && setupIntent !== null && setupIntent !== void 0 && setupIntent.client_secret) {
      var _response$data3, _response$data3$sourc;
      stripe.confirmCardSetup(setupIntent.client_secret, {
        payment_method: (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : (_response$data3$sourc = _response$data3.source) === null || _response$data3$sourc === void 0 ? void 0 : _response$data3$sourc.object_id
      }).then(res => {
        var _response$data4;
        if (res.error) {
          dispatch({
            type: DISABLE_SUBMIT,
            payload: false
          });
          dispatch({
            type: LOADING,
            payload: false
          });
          onFailure(res.error);
          return dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(res.error)
            }
          });
        }
        if (flow === "subCreate") {
          dispatch({
            type: DISABLE_SUBMIT,
            payload: false
          });
          dispatch({
            type: LOADING,
            payload: false
          });
          refreshUser();
          onSuccess(res);
          return;
        }
        if (flow === "create") {
          dispatch({
            type: LOADING,
            payload: false
          });
          dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "success",
              content: t("messages.sourceCreated")
            }
          });
          refreshUser();
          onSuccess(res);
          return;
        }
        if (flow === "update") {
          dispatch({
            type: DISABLE_SUBMIT,
            payload: false
          });
          dispatch({
            type: LOADING,
            payload: false
          });
          dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "success",
              content: t("messages.sourceUpdated")
            }
          });
          refreshUser();
          onSuccess(res);
          return;
        }
        if (flow === "replace") {
          setTimeout(() => {
            window.Pelcro.paymentMethods.deletePaymentMethod({
              auth_token: window.Pelcro.user.read().auth_token,
              payment_method_id: paymentMethodId
            }, (err, res) => {
              dispatch({
                type: DISABLE_SUBMIT,
                payload: false
              });
              dispatch({
                type: LOADING,
                payload: false
              });
              if (err) {
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(err);
                return dispatch({
                  type: SHOW_ALERT,
                  payload: {
                    type: "error",
                    content: getErrorMessages(err)
                  }
                });
              }
              refreshUser();
              onSuccess(res);
            });
          }, 2000);
          return;
        }
        return handlePayment(response === null || response === void 0 ? void 0 : (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.source);
      });
    } else {
      onSuccess(response);
    }
  };
  const subscribe = (stripeSource, state, dispatch) => {
    const {
      couponCode
    } = state;
    if (!subscriptionIdToRenew) {
      window.Pelcro.subscription.create({
        source_id: stripeSource !== null && stripeSource !== void 0 && stripeSource.isExistingSource ? stripeSource === null || stripeSource === void 0 ? void 0 : stripeSource.id : undefined,
        stripe_token: !(stripeSource !== null && stripeSource !== void 0 && stripeSource.isExistingSource) ? stripeSource === null || stripeSource === void 0 ? void 0 : stripeSource.id : undefined,
        auth_token: window.Pelcro.user.read().auth_token,
        plan_id: plan.id,
        campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
        quantity: plan.quantity,
        coupon_code: couponCode,
        gift_recipient_email: giftRecipient ? giftRecipient.email : null,
        gift_recipient_first_name: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.firstName,
        gift_recipient_last_name: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.lastName,
        gift_start_date: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.startDate,
        gift_message: giftRecipient === null || giftRecipient === void 0 ? void 0 : giftRecipient.giftMessage,
        address_id: product.address_required ? selectedAddressId : null
      }, (err, res) => {
        var _res$data;
        if (res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && _res$data.setup_intent) {
          return confirmStripeIntentSetup(res, "subCreate");
        }
        confirmStripeCardPayment(res, err, true);
      });
    } else {
      if (isRenewingGift) {
        window.Pelcro.subscription.renewGift({
          source_id: stripeSource !== null && stripeSource !== void 0 && stripeSource.isExistingSource ? stripeSource === null || stripeSource === void 0 ? void 0 : stripeSource.id : undefined,
          stripe_token: !(stripeSource !== null && stripeSource !== void 0 && stripeSource.isExistingSource) ? stripeSource === null || stripeSource === void 0 ? void 0 : stripeSource.id : undefined,
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          quantity: plan.quantity,
          coupon_code: couponCode,
          subscription_id: subscriptionIdToRenew,
          address_id: product.address_required ? selectedAddressId : null
        }, (err, res) => {
          dispatch({
            type: DISABLE_SUBMIT,
            payload: false
          });
          dispatch({
            type: LOADING,
            payload: false
          });
          if (err) {
            onFailure(err);
            return dispatch({
              type: SHOW_ALERT,
              payload: {
                type: "error",
                content: getErrorMessages(err)
              }
            });
          }
          onGiftRenewalSuccess(res);
        });
      } else {
        window.Pelcro.subscription.renew({
          source_id: stripeSource !== null && stripeSource !== void 0 && stripeSource.isExistingSource ? stripeSource === null || stripeSource === void 0 ? void 0 : stripeSource.id : undefined,
          stripe_token: !(stripeSource !== null && stripeSource !== void 0 && stripeSource.isExistingSource) ? stripeSource === null || stripeSource === void 0 ? void 0 : stripeSource.id : undefined,
          auth_token: window.Pelcro.user.read().auth_token,
          plan_id: plan.id,
          campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
          coupon_code: couponCode,
          subscription_id: subscriptionIdToRenew,
          address_id: product.address_required ? selectedAddressId : null
        }, (err, res) => {
          dispatch({
            type: DISABLE_SUBMIT,
            payload: false
          });
          dispatch({
            type: LOADING,
            payload: false
          });
          if (err) {
            onFailure(err);
            return dispatch({
              type: SHOW_ALERT,
              payload: {
                type: "error",
                content: getErrorMessages(err)
              }
            });
          }
          onSuccess(res);
        });
      }
    }

    // Prevent the form from being submitted:
    return false;
  };

  /**
   * Handles subscriptions from PayPal gateway
   * @param {PaymentStateType} state
   * @param {string} paypalNonce
   * @return {void}
   */
  const handlePaypalSubscription = (state, paypalNonce) => {
    const payment = new Payment(new PaypalGateway());
    const {
      couponCode
    } = state;

    /**
     * @TODO: Add flags for types instead of testing by properties
     */

    if (giftRecipient) {
      return payment.execute({
        type: PAYMENT_TYPES.CREATE_GIFTED_SUBSCRIPTION,
        token: paypalNonce,
        quantity: plan.quantity,
        plan,
        couponCode,
        product,
        giftRecipient,
        addressId: selectedAddressId
      }, (err, res) => {
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
        dispatch({
          type: LOADING,
          payload: false
        });
        if (err) {
          onFailure(err);
          return dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
        }
        onSuccess(res);
      });
    }
    return payment.execute({
      type: PAYMENT_TYPES.CREATE_SUBSCRIPTION,
      token: paypalNonce,
      quantity: plan.quantity,
      plan,
      couponCode,
      product,
      addressId: selectedAddressId
    }, (err, res) => {
      dispatch({
        type: DISABLE_SUBMIT,
        payload: false
      });
      dispatch({
        type: LOADING,
        payload: false
      });
      if (err) {
        onFailure(err);
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
      }
      onSuccess(res);
    });
  };
  const purchase = (gatewayService, gatewayToken, state, dispatch) => {
    const isQuickPurchase = !Array.isArray(order);
    const mappedOrderItems = isQuickPurchase ? [{
      sku_id: order.id,
      quantity: order.quantity
    }] : order.map(item => ({
      sku_id: item.id,
      quantity: item.quantity
    }));
    const {
      couponCode
    } = state;
    const payment = new Payment(gatewayService);
    payment.execute({
      type: PAYMENT_TYPES.PURCHASE_ECOMMERCE_ORDER,
      token: gatewayToken,
      isExistingSource: Boolean(selectedPaymentMethodId),
      items: mappedOrderItems,
      addressId: selectedAddressId,
      couponCode
    }, (err, orderResponse) => {
      var _window$Pelcro2, _window$Pelcro2$user, _window$Pelcro2$user$;
      if (err) {
        toggleAuthenticationSuccessPendingView(false);
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
        dispatch({
          type: LOADING,
          payload: false
        });
        onFailure(err);
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
      }
      if (isQuickPurchase) {
        set({
          order: null
        });
      } else {
        set({
          order: null,
          cartItems: []
        });
      }
      window.Pelcro.user.refresh({
        auth_token: (_window$Pelcro2 = window.Pelcro) === null || _window$Pelcro2 === void 0 ? void 0 : (_window$Pelcro2$user = _window$Pelcro2.user) === null || _window$Pelcro2$user === void 0 ? void 0 : (_window$Pelcro2$user$ = _window$Pelcro2$user.read()) === null || _window$Pelcro2$user$ === void 0 ? void 0 : _window$Pelcro2$user$.auth_token
      }, (err, res) => {
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
        dispatch({
          type: LOADING,
          payload: false
        });
        toggleAuthenticationSuccessPendingView(false);
        if (err) {
          onFailure(err);
          return dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
        }
        onSuccess(orderResponse);
      });
    });
  };
  const payInvoice = (gatewayService, gatewayToken, dispatch) => {
    const payment = new Payment(gatewayService);
    return payment.execute({
      type: PAYMENT_TYPES.PAY_INVOICE,
      token: gatewayToken,
      isExistingSource: Boolean(selectedPaymentMethodId),
      invoiceId: invoice.id
    }, (err, res) => {
      confirmStripeCardPayment(res, err);
    });
  };
  const createPaymentSource = (state, dispatch) => {
    return stripe.createSource({
      type: "card"
    }).then(_ref8 => {
      let {
        source,
        error
      } = _ref8;
      if (error) {
        return handlePaymentError(error);
      }

      // We don't support source creation for 3D secure yet
      // if (source?.card?.three_d_secure === "required") {
      //   return handlePaymentError({
      //     error: {
      //       message: t("messages.cardAuthNotSupported")
      //     }
      //   });
      // }

      window.Pelcro.paymentMethods.create({
        auth_token: window.Pelcro.user.read().auth_token,
        token: source.id
      }, (err, res) => {
        var _res$data2, _res$data2$setup_inte, _res$data3, _res$data3$setup_inte;
        if (err) {
          dispatch({
            type: DISABLE_SUBMIT,
            payload: false
          });
          dispatch({
            type: LOADING,
            payload: false
          });
          onFailure(err);
          return dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
        }
        if (((_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$setup_inte = _res$data2.setup_intent) === null || _res$data2$setup_inte === void 0 ? void 0 : _res$data2$setup_inte.status) === "requires_action" || ((_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : (_res$data3$setup_inte = _res$data3.setup_intent) === null || _res$data3$setup_inte === void 0 ? void 0 : _res$data3$setup_inte.status) === "requires_confirmation") {
          confirmStripeIntentSetup(res, "create");
        } else {
          dispatch({
            type: LOADING,
            payload: false
          });
          dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "success",
              content: t("messages.sourceCreated")
            }
          });
          refreshUser();
          onSuccess(res);
        }
      });
    });
  };
  const updatePaymentSource = (state, dispatch) => {
    const {
      isDefault,
      month,
      year
    } = state;
    const {
      id: paymentMethodId
    } = paymentMethodToEdit;
    window.Pelcro.paymentMethods.update({
      auth_token: window.Pelcro.user.read().auth_token,
      payment_method_id: paymentMethodId,
      gateway: "stripe",
      exp_month: month,
      exp_year: year,
      is_default: isDefault
    }, (err, res) => {
      var _res$data4, _res$data4$setup_inte, _res$data5, _res$data5$setup_inte;
      dispatch({
        type: DISABLE_SUBMIT,
        payload: false
      });
      dispatch({
        type: LOADING,
        payload: false
      });
      if (err) {
        onFailure(err);
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
      }
      if (((_res$data4 = res.data) === null || _res$data4 === void 0 ? void 0 : (_res$data4$setup_inte = _res$data4.setup_intent) === null || _res$data4$setup_inte === void 0 ? void 0 : _res$data4$setup_inte.status) === "requires_action" || ((_res$data5 = res.data) === null || _res$data5 === void 0 ? void 0 : (_res$data5$setup_inte = _res$data5.setup_intent) === null || _res$data5$setup_inte === void 0 ? void 0 : _res$data5$setup_inte.status) === "requires_confirmation") {
        confirmStripeIntentSetup(res, "update");
      } else {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("messages.sourceUpdated")
          }
        });
        refreshUser();
        onSuccess(res);
      }
    });
  };
  const replacePaymentSource = (state, dispatch) => {
    const {
      id: paymentMethodId
    } = paymentMethodToDelete;
    return stripe.createSource({
      type: "card"
    }).then(_ref9 => {
      let {
        source,
        error
      } = _ref9;
      if (error) {
        return handlePaymentError(error);
      }

      // We don't support source creation for 3D secure yet
      // if (source?.card?.three_d_secure === "required") {
      //   return handlePaymentError({
      //     error: {
      //       message: t("messages.cardAuthNotSupported")
      //     }
      //   });
      // }

      window.Pelcro.paymentMethods.create({
        auth_token: window.Pelcro.user.read().auth_token,
        token: source.id
      }, (err, res) => {
        var _res$data6, _res$data6$setup_inte, _res$data7, _res$data7$setup_inte;
        if (err) {
          onFailure(err);
          return dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
        }
        if (((_res$data6 = res.data) === null || _res$data6 === void 0 ? void 0 : (_res$data6$setup_inte = _res$data6.setup_intent) === null || _res$data6$setup_inte === void 0 ? void 0 : _res$data6$setup_inte.status) === "requires_action" || ((_res$data7 = res.data) === null || _res$data7 === void 0 ? void 0 : (_res$data7$setup_inte = _res$data7.setup_intent) === null || _res$data7$setup_inte === void 0 ? void 0 : _res$data7$setup_inte.status) === "requires_confirmation") {
          confirmStripeIntentSetup(res, "replace", paymentMethodId);
        } else {
          setTimeout(() => {
            window.Pelcro.paymentMethods.deletePaymentMethod({
              auth_token: window.Pelcro.user.read().auth_token,
              payment_method_id: paymentMethodId
            }, (err, res) => {
              dispatch({
                type: DISABLE_SUBMIT,
                payload: false
              });
              dispatch({
                type: LOADING,
                payload: false
              });
              if (err) {
                onFailure === null || onFailure === void 0 ? void 0 : onFailure(err);
                return dispatch({
                  type: SHOW_ALERT,
                  payload: {
                    type: "error",
                    content: getErrorMessages(err)
                  }
                });
              }
              refreshUser();
              onSuccess(res);
            });
          }, 2000);
        }
      });
    });
  };
  const updatePaymentRequest = state => {
    var _state$paymentRequest;
    state === null || state === void 0 ? void 0 : (_state$paymentRequest = state.paymentRequest) === null || _state$paymentRequest === void 0 ? void 0 : _state$paymentRequest.update({
      total: {
        label: plan.nickname || plan.description,
        amount: state.updatedPrice
      }
    });
  };
  const submitPayment = (state, dispatch) => {
    if (skipPayment && props !== null && props !== void 0 && props.freeOrders) {
      const isQuickPurchase = !Array.isArray(order);
      const mappedOrderItems = isQuickPurchase ? [{
        sku_id: order.id,
        quantity: order.quantity
      }] : order.map(item => ({
        sku_id: item.id,
        quantity: item.quantity
      }));
      window.Pelcro.ecommerce.order.create({
        items: mappedOrderItems,
        campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
        ...(selectedAddressId && {
          address_id: selectedAddressId
        })
      }, (err, res) => {
        if (err) {
          return handlePaymentError(err);
        }
        return onSuccess(res);
      });
      return;
    }
    stripe.createSource({
      type: "card"
    }).then(_ref10 => {
      var _ref11, _ref12, _state$updatedPrice2;
      let {
        source,
        error
      } = _ref10;
      if (error) {
        return handlePaymentError(error);
      }
      const getOrderItemsTotal = () => {
        if (!order) {
          return null;
        }
        const isQuickPurchase = !Array.isArray(order);
        if (isQuickPurchase) {
          return order.price * order.quantity;
        }
        if (order.length === 0) {
          return null;
        }
        return order.reduce((total, item) => {
          return total + item.price * item.quantity;
        }, 0);
      };
      (_ref11 = (_ref12 = (_state$updatedPrice2 = state === null || state === void 0 ? void 0 : state.updatedPrice) !== null && _state$updatedPrice2 !== void 0 ? _state$updatedPrice2 : plan === null || plan === void 0 ? void 0 : plan.amount) !== null && _ref12 !== void 0 ? _ref12 : invoice === null || invoice === void 0 ? void 0 : invoice.amount_remaining) !== null && _ref11 !== void 0 ? _ref11 : getOrderItemsTotal();
      return handlePayment(source);
    }).catch(error => {
      return handlePaymentError(error);
    });
  };

  /**
   * Resolves with the total & tax amount incase taxes enabled by site
   * @return {Promise}
   */
  const resolveTaxCalculation = () => {
    var _window$Pelcro$site$r9;
    if (type === "invoicePayment") {
      return new Promise(resolve => resolve());
    }
    const taxesEnabled = (_window$Pelcro$site$r9 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r9 === void 0 ? void 0 : _window$Pelcro$site$r9.taxes_enabled;
    return new Promise((resolve, reject) => {
      // resolve early if taxes isn't enabled
      if (!taxesEnabled) {
        return resolve(null);
      }
      window.Pelcro.order.create({
        auth_token: window.Pelcro.user.read().auth_token,
        plan_id: plan.id,
        campaign_key: window.Pelcro.helpers.getURLParameter("campaign_key"),
        coupon_code: state === null || state === void 0 ? void 0 : state.couponCode,
        address_id: selectedAddressId
      }, (error, res) => {
        var _res$data8, _res$data9;
        if (error) {
          return reject(error);
        }
        const taxAmount = (_res$data8 = res.data) === null || _res$data8 === void 0 ? void 0 : _res$data8.taxes;
        const totalAmountWithTax = (_res$data9 = res.data) === null || _res$data9 === void 0 ? void 0 : _res$data9.total;
        resolve({
          totalAmountWithTax,
          taxAmount
        });
      });
    });
  };

  /**
   * Resolves with a generated stripe 3DSecure source
   * @param {Object} source stripe's source object
   * @param {number | null} totalAmount total amount with taxes added incase taxes enabled
   * @return {Promise}
   */
  const generate3DSecureSource = (source, totalAmount) => {
    const listenFor3DSecureCompletionMessage = () => {
      const retrieveSourceInfoFromIframe = event => {
        const {
          data
        } = event;
        if (data.message === "3DS-authentication-complete") {
          toggleAuthenticationPendingView(false);
          retrieveSource(data.sourceId, data.clientSecret, handlePayment);
          window.removeEventListener("message", retrieveSourceInfoFromIframe);
        }
      };

      // listen to injected iframe for authentication complete message
      window.addEventListener("message", retrieveSourceInfoFromIframe);
    };
    listenFor3DSecureCompletionMessage();
    return stripe.createSource({
      type: "three_d_secure",
      amount: totalAmount,
      currency: (plan === null || plan === void 0 ? void 0 : plan.currency) || (invoice === null || invoice === void 0 ? void 0 : invoice.currency) || window.Pelcro.site.read().default_currency,
      three_d_secure: {
        card: source === null || source === void 0 ? void 0 : source.id
      },
      redirect: {
        return_url: `${window.Pelcro.environment.domain}/webhook/stripe/callback/3dsecure?auth_token=${window.Pelcro.user.read().auth_token}`
      }
    });
  };
  const handlePayment = stripeSource => {
    if (stripeSource && type === "createPayment") {
      subscribe(stripeSource, state, dispatch);
    } else if (stripeSource && type === "orderCreate") {
      purchase(new StripeGateway(), stripeSource.id, state, dispatch);
    } else if (stripeSource && type === "invoicePayment") {
      payInvoice(new StripeGateway(), stripeSource.id);
    }
  };
  const handlePaymentError = error => {
    var _getErrorMessages;
    toggleAuthenticationSuccessPendingView(false);
    if (error.type === "validation_error" &&
    // Subscription creation & renewal
    type === "createPayment") {
      var _state$couponObject;
      const {
        updatedPrice
      } = state;
      // When price is 0, we allow submitting without card info
      if (updatedPrice === 0 && ((_state$couponObject = state.couponObject) === null || _state$couponObject === void 0 ? void 0 : _state$couponObject.duration) === "forever") {
        return subscribe({}, state, dispatch);
      }
    }
    onFailure(error);
    dispatch({
      type: SHOW_ALERT,
      payload: {
        type: "error",
        content: (_getErrorMessages = getErrorMessages(error)) !== null && _getErrorMessages !== void 0 ? _getErrorMessages : error === null || error === void 0 ? void 0 : error.message
      }
    });
    dispatch({
      type: DISABLE_SUBMIT,
      payload: false
    });
    dispatch({
      type: LOADING,
      payload: false
    });
  };
  const retrieveSource = async (sourceId, clientSecret, paymentHandler) => {
    try {
      const {
        source
      } = await stripe.retrieveSource({
        id: sourceId,
        client_secret: clientSecret
      });
      if ((source === null || source === void 0 ? void 0 : source.status) === "failed") {
        return handlePaymentError({
          error: {
            message: t("messages.cardAuthFailed")
          }
        });
      }
      if ((source === null || source === void 0 ? void 0 : source.status) === "chargeable") {
        paymentHandler(source);
      }
    } catch (error) {
      handlePaymentError(error);
    }
  };
  const toggleAuthenticationPendingView = (show, source) => {
    const cardAuthContainer = document.querySelector(".card-authentication-container");
    if (show) {
      injectCardAuthenticationIframe(source);
      cardAuthContainer === null || cardAuthContainer === void 0 ? void 0 : cardAuthContainer.classList.remove("plc-hidden");
      cardAuthContainer === null || cardAuthContainer === void 0 ? void 0 : cardAuthContainer.classList.add("plc-flex");
    } else {
      cardAuthContainer === null || cardAuthContainer === void 0 ? void 0 : cardAuthContainer.classList.add("plc-hidden");
      cardAuthContainer === null || cardAuthContainer === void 0 ? void 0 : cardAuthContainer.classList.remove("plc-flex");
    }
  };
  const toggleAuthenticationSuccessPendingView = show => {
    const cardAuthContainer = document.querySelector(".card-authentication-success-container");
    if (show) {
      cardAuthContainer === null || cardAuthContainer === void 0 ? void 0 : cardAuthContainer.classList.remove("plc-hidden");
      cardAuthContainer === null || cardAuthContainer === void 0 ? void 0 : cardAuthContainer.classList.add("plc-flex");
    } else {
      cardAuthContainer === null || cardAuthContainer === void 0 ? void 0 : cardAuthContainer.classList.add("plc-hidden");
      cardAuthContainer === null || cardAuthContainer === void 0 ? void 0 : cardAuthContainer.classList.remove("plc-flex");
    }
  };
  const injectCardAuthenticationIframe = source => {
    var _source$redirect;
    const cardAuthContainer = document.querySelector(".card-authentication-container");
    const iframe = document.createElement("iframe");
    iframe.src = source !== null && source !== void 0 && (_source$redirect = source.redirect) !== null && _source$redirect !== void 0 && _source$redirect.url ? source.redirect.url : source.threeDSecure_url;
    iframe.style = "position: absolute; width: 100%; height: 100%; left: 0; top: 0; bottom: 0; z-index: 10;";
    cardAuthContainer === null || cardAuthContainer === void 0 ? void 0 : cardAuthContainer.appendChild(iframe);
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case DISABLE_SUBMIT:
        return lib_7({
          ...state,
          disableSubmit: action.payload
        });
      case LOADING:
        return lib_7({
          ...state,
          isLoading: action.payload
        });
      case SHOW_COUPON_FIELD:
        return lib_7({
          ...state,
          enableCouponField: action.payload
        });
      case DISABLE_COUPON_BUTTON:
        return lib_7({
          ...state,
          disableCouponButton: action.payload
        });
      case SUBSCRIBE:
        return lib_4((state, dispatch) => subscribe(action.payload, state, dispatch));
      case INIT_CONTAINER:
        return lib_5({
          ...state,
          currentPlan: plan
        }, (state, dispatch) => initPaymentRequest(state, dispatch));
      case UPDATE_PAYMENT_REQUEST:
        return lib_5(state, (state, dispatch) => updatePaymentRequest(state));
      case SUBMIT_PAYMENT:
        return lib_5({
          ...state,
          disableSubmit: true,
          isLoading: true
        }, (state, dispatch) => {
          if (skipPayment && props !== null && props !== void 0 && props.freeOrders) {
            return submitPayment(state);
          }
          if (getSiteCardProcessor() === "vantiv") {
            return submitUsingVantiv(state);
          }
          if (getSiteCardProcessor() === "tap") {
            return submitUsingTap(state);
          }
          if (getSiteCardProcessor() === "cybersource") {
            return submitUsingCybersource(state, dispatch);
          }
          if (selectedPaymentMethodId) {
            // pay with selected method (source) if exists already
            return handlePayment({
              id: selectedPaymentMethodId,
              isExistingSource: true
            });
          }
          if (type === "createPaymentSource") {
            return createPaymentSource(state, dispatch);
          }
          if (type === "updatePaymentSource") {
            return updatePaymentSource(state, dispatch);
          }
          if (type === "deletePaymentSource") {
            return replacePaymentSource(state, dispatch);
          }
          submitPayment(state);
        });
      case HANDLE_PAYPAL_SUBSCRIPTION:
        return lib_5(state, (state, dispatch) => {
          if (type === "invoicePayment") {
            payInvoice(new PaypalGateway(), action.payload);
          } else {
            handlePaypalSubscription(state, action.payload);
          }
        });
      case HANDLE_APPLEPAY_SUBSCRIPTION:
        return lib_5(state, (state, dispatch) => {
          setVantivPaymentRequest(action.payload);
        });
      case SET_UPDATED_PRICE:
        return lib_7({
          ...state,
          updatedPrice: action.payload
        });
      case SET_TAX_AMOUNT:
        return lib_7({
          ...state,
          taxAmount: action.payload
        });
      case SET_CAN_MAKE_PAYMENT:
        return lib_7({
          ...state,
          canMakePayment: action.payload
        });
      case SET_PAYMENT_REQUEST:
        return lib_7({
          ...state,
          paymentRequest: action.payload
        });
      case APPLY_COUPON_CODE:
        return lib_5({
          ...state,
          disableCouponButton: true
        }, (state, dispatch) => onApplyCouponCode(state, dispatch));
      case REMOVE_APPLIED_COUPON:
        return lib_5(state, () => removeAppliedCoupon(state));
      case SET_COUPON:
        return lib_7({
          ...state,
          couponObject: action.payload
        });
      case SET_COUPON_ERROR:
        return lib_7({
          ...state,
          couponError: action.payload
        });
      case UPDATE_COUPON_CODE:
        return lib_5({
          ...state,
          couponCode: action.payload
        }, (state, dispatch) => debouncedApplyCouponCode(state, dispatch));
      case SET_PERCENT_OFF:
        return lib_7({
          ...state,
          percentOff: action.payload
        });
      case SET_MONTH:
        return lib_7({
          ...state,
          month: action.payload
        });
      case SET_YEAR:
        return lib_7({
          ...state,
          year: action.payload
        });
      case SET_FIRST_NAME:
        return lib_7({
          ...state,
          firstName: action.payload,
          firstNameError: null
        });
      case SET_LAST_NAME:
        return lib_7({
          ...state,
          lastName: action.payload,
          lastNameError: null
        });
      case SET_PHONE:
        return lib_7({
          ...state,
          phone: action.payload,
          phoneError: null
        });
      case SET_FIRST_NAME_ERROR:
        return lib_7({
          ...state,
          firstNameError: action.payload,
          firstName: ""
        });
      case SET_LAST_NAME_ERROR:
        return lib_7({
          ...state,
          lastNameError: action.payload,
          lastName: ""
        });
      case SET_PHONE_ERROR:
        return lib_7({
          ...state,
          phoneError: action.payload,
          phone: null
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case UPDATE_CYBERSOURCE_SESSION_ID:
        return lib_7({
          ...state,
          cyberSourceSessionId: action.payload
        });
      case HANDLE_CHECKBOX_CHANGE:
        return lib_7({
          ...state,
          ...action.payload
        });
      case SET_IS_DEFAULT_PAYMENT_METHOD:
        return lib_7({
          ...state,
          ...action.payload
        });
      default:
        return state;
    }
  }, initialState$l);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-payment-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$l, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => {
    if (child) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        store: store$l,
        key: i
      });
    }
  }) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$l
  })));
};
const UnwrappedForm = es_12(PaymentMethodContainerWithoutStripe);
const PaymentMethodContainer = props => {
  const [isStripeLoaded, setIsStripeLoaded] = useState(Boolean(window.Stripe));
  const {
    whenUserReady
  } = usePelcro.getStore();
  const cardProcessor = getSiteCardProcessor();
  useEffect(() => {
    whenUserReady(() => {
      if (!window.Stripe && cardProcessor === "stripe") {
        document.querySelector('script[src="https://js.stripe.com/v3"]').addEventListener("load", () => {
          setIsStripeLoaded(true);
        });
      }
    });
  }, []);
  if (isStripeLoaded) {
    return /*#__PURE__*/React__default.createElement(es_13, {
      apiKey: window.Pelcro.environment.stripe,
      stripeAccount: window.Pelcro.site.read().account_id,
      locale: getPageOrDefaultLanguage()
    }, /*#__PURE__*/React__default.createElement(es_11, null, /*#__PURE__*/React__default.createElement(UnwrappedForm, Object.assign({
      store: store$l
    }, props))));
  } else if (cardProcessor !== "stripe") {
    return /*#__PURE__*/React__default.createElement(PaymentMethodContainerWithoutStripe, Object.assign({
      store: store$l
    }, props));
  }
  return null;
};

function Select(_ref) {
  let {
    label = "",
    required,
    id,
    errorId,
    error = "",
    className = "",
    labelClassName = "",
    errorClassName = "",
    wrapperClassName = "",
    children,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: `pelcro-input-wrapper ${wrapperClassName}`
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: `pelcro-input-label ${labelClassName}`
  }, `${label}${required ? "*" : ""}`), /*#__PURE__*/React__default.createElement("select", Object.assign({
    id: id,
    className: `pelcro-input-field ${className} ${error ? "pelcro-input-invalid" : ""}`,
    "aria-describedby": errorId,
    "aria-invalid": Boolean(error)
  }, otherProps), children), error && /*#__PURE__*/React__default.createElement("p", {
    id: errorId,
    "aria-live": "assertive",
    className: `pelcro-input-error ${errorClassName}`
  }, error));
}

function MonthSelect(_ref) {
  let {
    placeholder,
    store,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      month
    }
  } = useContext(store);
  const get2digits = num => num < 10 ? "0" + num.toString() : num.toString();
  const createMonthsItems = useMemo(() => {
    return [...Array.from({
      length: 12
    }, (_, i) => i + 1)].map(i => {
      return /*#__PURE__*/React__default.createElement("option", {
        key: i,
        value: get2digits(i)
      }, get2digits(i));
    });
  }, []);
  const handleInputChange = value => {
    dispatch({
      type: SET_MONTH,
      payload: value
    });
  };
  return /*#__PURE__*/React__default.createElement(Select, Object.assign({
    value: month,
    onChange: e => handleInputChange(e.target.value)
  }, otherProps), /*#__PURE__*/React__default.createElement("option", {
    value: "",
    disabled: true,
    selected: true
  }, placeholder), createMonthsItems);
}

function YearSelect(_ref) {
  let {
    placeholder,
    store,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      year
    }
  } = useContext(store);
  const createYearsItems = useMemo(() => {
    return Array.from({
      length: 10
    }, (_, i) => i + new Date().getFullYear()).map(i => {
      return /*#__PURE__*/React__default.createElement("option", {
        key: i,
        value: i
      }, i);
    });
  }, []);
  const handleInputChange = value => {
    dispatch({
      type: SET_YEAR,
      payload: value
    });
  };
  return /*#__PURE__*/React__default.createElement(Select, Object.assign({
    value: year,
    onChange: e => handleInputChange(e.target.value)
  }, otherProps), /*#__PURE__*/React__default.createElement("option", {
    value: "",
    disabled: true,
    selected: true
  }, placeholder), createYearsItems);
}

const StripeInputStyle = {
  base: "plc-w-full plc-p-3 plc-border plc-border-gray-300 plc-appearance-none plc-outline-none plc-rounded-sm plc-bg-gray-50 pelcro-input-input",
  focus: "plc-ring-2 plc-ring-primary-400",
  invalid: "plc-ring-2 plc-ring-red-400 pelcro-input-invalid"
};
const PelcroCardNumber = props => {
  const {
    t
  } = useTranslation("checkoutForm");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "pelcro-input-card-number"
  }, t("labels.card"), " *"), /*#__PURE__*/React__default.createElement(es_9, Object.assign({
    id: "pelcro-input-card-number",
    classes: StripeInputStyle
  }, props)));
};
const PelcroCardCVC = props => {
  const {
    t
  } = useTranslation("checkoutForm");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "pelcro-input-cvc-number"
  }, t("labels.CVC"), " *"), /*#__PURE__*/React__default.createElement(es_6, Object.assign({
    id: "pelcro-input-cvc-number",
    classes: StripeInputStyle
  }, props)));
};
const PelcroCardExpiry = props => {
  const {
    t
  } = useTranslation("checkoutForm");
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "pelcro-input-expiry-date"
  }, t("labels.date"), " *"), /*#__PURE__*/React__default.createElement(es_8, Object.assign({
    id: "pelcro-input-expiry-date",
    classes: StripeInputStyle
  }, props)));
};
const PelcroPaymentRequestButton = props => {
  const {
    state: {
      canMakePayment,
      paymentRequest,
      currentPlan,
      updatedPrice
    }
  } = useContext(store$l);
  const updatePaymentRequest = () => {
    // Make sure payment request is up to date, eg. user added a coupon code.
    paymentRequest === null || paymentRequest === void 0 ? void 0 : paymentRequest.update({
      total: {
        label: (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.nickname) || (currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.description),
        amount: updatedPrice !== null && updatedPrice !== void 0 ? updatedPrice : currentPlan === null || currentPlan === void 0 ? void 0 : currentPlan.amount
      }
    });
  };
  if (canMakePayment) {
    return /*#__PURE__*/React__default.createElement(es_5, Object.assign({
      className: "StripeElement stripe-payment-request-btn",
      onClick: updatePaymentRequest,
      paymentRequest: paymentRequest,
      style: {
        paymentRequestButton: {
          theme: "dark",
          height: "40px"
        }
      }
    }, props));
  }
  return null;
};
const CheckoutForm = _ref => {
  let {
    type
  } = _ref;
  const {
    selectedPaymentMethodId,
    paymentMethodToEdit
  } = usePelcro();
  const cardProcessor = getSiteCardProcessor();
  if (selectedPaymentMethodId) {
    return null;
  }
  if (cardProcessor === "vantiv") {
    return /*#__PURE__*/React__default.createElement("div", {
      id: "eProtectiframe"
    });
  }
  if (cardProcessor === "tap") {
    return /*#__PURE__*/React__default.createElement("div", {
      id: "tapPaymentIframe"
    });
  }
  if (cardProcessor === "cybersource") {
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
      id: "cybersourceCardNumber",
      className: "pelcro-input-field plc-h-12"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-flex plc-items-end plc-justify-between plc-my-2"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-w-6/12 plc-pr-4"
    }, /*#__PURE__*/React__default.createElement(MonthSelect, {
      store: store$l,
      placeholder: "Exp Month *"
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-w-6/12"
    }, /*#__PURE__*/React__default.createElement(YearSelect, {
      store: store$l,
      placeholder: "Exp Year *"
    }))));
  }
  if (cardProcessor === "stripe") {
    if (type === "updatePaymentSource") {
      var _paymentMethodToEdit$;
      return /*#__PURE__*/React__default.createElement("div", null, paymentMethodToEdit ? /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Input, {
        className: "plc-tracking-widest plc-flex-grow plc-text-center",
        value: `•••• •••• •••• ${paymentMethodToEdit === null || paymentMethodToEdit === void 0 ? void 0 : (_paymentMethodToEdit$ = paymentMethodToEdit.properties) === null || _paymentMethodToEdit$ === void 0 ? void 0 : _paymentMethodToEdit$.last4}`,
        disabled: true
      })) : /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(Input, {
        className: "plc-bg-gray-300 plc-animate-pulse"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "plc-flex plc-items-end plc-justify-between plc-my-2"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "plc-w-6/12 plc-pr-4"
      }, /*#__PURE__*/React__default.createElement(MonthSelect, {
        store: store$l,
        placeholder: "Exp Month *"
      })), /*#__PURE__*/React__default.createElement("div", {
        className: "plc-w-6/12"
      }, /*#__PURE__*/React__default.createElement(YearSelect, {
        store: store$l,
        placeholder: "Exp Year *"
      }))));
    }
    return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(PelcroCardNumber, {
      autoFocus: true
    }), /*#__PURE__*/React__default.createElement("img", {
      alt: "credit_cards",
      className: "plc-w-auto plc-h-4 plc-mt-2",
      src: "https://js.pelcro.com/ui/plugin/main/images/credit_cards.png"
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-flex plc-items-end plc-justify-between plc-my-2"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-w-6/12 plc-pr-4"
    }, /*#__PURE__*/React__default.createElement(PelcroCardExpiry, null)), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-w-6/12 plc-pl-4"
    }, /*#__PURE__*/React__default.createElement(PelcroCardCVC, null))));
  }
  return null;
};

const DiscountedPrice = props => {
  var _window$Pelcro$site, _window$Pelcro$site$r, _order$currency, _order$, _plan$quantity;
  const {
    t
  } = useTranslation("checkoutForm");
  const {
    dispatch,
    state: {
      updatedPrice,
      taxAmount,
      percentOff
    }
  } = useContext(store$l);
  const {
    order,
    plan
  } = usePelcro();
  const isTaxInclusive = (_window$Pelcro$site = window.Pelcro.site) === null || _window$Pelcro$site === void 0 ? void 0 : (_window$Pelcro$site$r = _window$Pelcro$site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.tax_inclusive;
  const ecommOrderCurrency = (_order$currency = order === null || order === void 0 ? void 0 : order.currency) !== null && _order$currency !== void 0 ? _order$currency : order === null || order === void 0 ? void 0 : (_order$ = order[0]) === null || _order$ === void 0 ? void 0 : _order$.currency;
  const planQuantity = (_plan$quantity = plan === null || plan === void 0 ? void 0 : plan.quantity) !== null && _plan$quantity !== void 0 ? _plan$quantity : 1;
  const discountedPriceWithoutTax = isTaxInclusive ? updatedPrice : updatedPrice - taxAmount;
  const priceFormatted = getFormattedPriceByLocal(order ? updatedPrice : discountedPriceWithoutTax * planQuantity, ecommOrderCurrency !== null && ecommOrderCurrency !== void 0 ? ecommOrderCurrency : plan === null || plan === void 0 ? void 0 : plan.currency, getPageOrDefaultLanguage());
  const onCouponRemove = () => {
    dispatch({
      type: REMOVE_APPLIED_COUPON
    });
  };
  if (percentOff) {
    return /*#__PURE__*/React__default.createElement("div", Object.assign({
      className: "plc-flex plc-items-center plc-justify-center plc-mt-2 pelcro-discount"
    }, props), "(-", percentOff, ")", /*#__PURE__*/React__default.createElement("span", {
      className: "plc-ml-1 plc-font-bold pelcro-discounted-price"
    }, priceFormatted), /*#__PURE__*/React__default.createElement(Button, {
      variant: "ghost",
      className: "plc-ml-2 plc-text-red-500 focus:plc-ring-red-500 pelcro-dashboard-sub-cancel-button",
      onClick: onCouponRemove
    }, "\u2715 ", t("labels.removeCoupon")));
  }
  return "";
};

const SubmitPaymentMethod = _ref => {
  var _plan$quantity, _window$Pelcro$site$r, _window$Pelcro$site$r2;
  let {
    onClick,
    ...otherProps
  } = _ref;
  const {
    plan,
    selectedPaymentMethodId
  } = usePelcro();
  const {
    t
  } = useTranslation("checkoutForm");
  const {
    dispatch,
    state: {
      firstNameError,
      lastNameError,
      phoneError,
      firstName,
      lastName,
      phone,
      disableSubmit,
      isLoading,
      updatedPrice,
      month,
      year
    }
  } = useContext(store$l);
  const planQuantity = (_plan$quantity = plan === null || plan === void 0 ? void 0 : plan.quantity) !== null && _plan$quantity !== void 0 ? _plan$quantity : 1;
  const price = updatedPrice !== null && updatedPrice !== void 0 ? updatedPrice : plan === null || plan === void 0 ? void 0 : plan.amount;
  const priceFormatted = getFormattedPriceByLocal(price * planQuantity, plan === null || plan === void 0 ? void 0 : plan.currency, getPageOrDefaultLanguage());
  const supportsTap = Boolean((_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.tap_gateway_settings);
  const supportsCybersource = Boolean((_window$Pelcro$site$r2 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r2 === void 0 ? void 0 : _window$Pelcro$site$r2.cybersource_gateway_settings);
  const isUserFirstName = Boolean(window.Pelcro.user.read().first_name);
  const isUserLastName = Boolean(window.Pelcro.user.read().last_name);
  const isUserPhone = Boolean(window.Pelcro.user.read().phone);
  const [isDisabled, setDisabled] = useState(true);
  useEffect(() => {
    if (supportsTap && isUserFirstName && isUserLastName && isUserPhone) {
      setDisabled(disableSubmit);
    } else {
      setDisabled(disableSubmit || supportsTap && firstNameError || supportsTap && lastNameError || supportsTap && phoneError || supportsTap && !(firstName !== null && firstName !== void 0 && firstName.length) || supportsTap && !(lastName !== null && lastName !== void 0 && lastName.length) || supportsTap && !(phone !== null && phone !== void 0 && phone.length) || supportsCybersource && !selectedPaymentMethodId && !(month !== null && month !== void 0 && month.length) || supportsCybersource && !selectedPaymentMethodId && !(year !== null && year !== void 0 && year.length));
    }
  }, [disableSubmit, firstNameError, lastNameError, phoneError, firstName, lastName, phone, month, year]);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    role: "submit",
    className: "plc-w-full plc-py-3",
    variant: "solid",
    isLoading: isLoading,
    onClick: () => {
      dispatch({
        type: SUBMIT_PAYMENT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: isDisabled
  }, otherProps), plan ? /*#__PURE__*/React__default.createElement("span", {
    className: "plc-capitalize "
  }, t("labels.pay"), " ", priceFormatted && priceFormatted) : t("labels.submit"));
};

var _path$o;
function _extends$q() { _extends$q = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$q.apply(this, arguments); }
function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$q({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$o || (_path$o = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10 19l-7-7m0 0l7-7m-7 7h18"
  })));
}

const ApplyCouponButton = _ref => {
  let {
    children,
    onClick,
    ...otherProps
  } = _ref;
  const {
    state: {
      couponCode,
      disableCouponButton
    },
    dispatch
  } = useContext(store$l);
  const {
    t
  } = useTranslation("checkoutForm");
  const onApplyCouponCode = () => {
    dispatch({
      type: APPLY_COUPON_CODE
    });
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    className: "plc-h-12 plc-ml-4",
    variant: "solid",
    "aria-label": t("labels.applyCouponCode"),
    icon: /*#__PURE__*/React__default.createElement(SvgArrowLeft, {
      className: "plc-w-5 plc-h-5 plc-transform plc-rotate-180"
    }),
    onClick: onApplyCouponCode,
    disabled: !couponCode || disableCouponButton
  }, otherProps), children);
};

const CouponCodeField = props => {
  const {
    t
  } = useTranslation("checkoutForm");
  const {
    dispatch,
    state: {
      couponCode,
      couponError
    }
  } = useContext(store$l);
  const onCouponCodeChange = e => {
    dispatch({
      type: UPDATE_COUPON_CODE,
      payload: e.target.value
    });
    if (couponError) {
      dispatch({
        type: SET_COUPON_ERROR,
        payload: ""
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    className: "plc-h-12",
    wrapperClassName: "plc-mb-6",
    errorClassName: "plc-h-12 sm:plc-h-8",
    error: couponError,
    "aria-label": t("labels.code"),
    value: couponCode,
    onChange: onCouponCodeChange,
    type: "text",
    id: "pelcro-input-coupon_code"
  }, props));
};

var _path$n;
function _extends$p() { _extends$p = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$p.apply(this, arguments); }
function SvgTicket(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$p({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$n || (_path$n = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"
  })));
}

const CouponCode = _ref => {
  let {
    onClick,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      enableCouponField
    }
  } = useContext(store$l);
  const {
    t
  } = useTranslation("checkoutForm");
  const showCouponField = () => {
    dispatch({
      type: SHOW_COUPON_FIELD,
      payload: !enableCouponField
    });
    onClick === null || onClick === void 0 ? void 0 : onClick();
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mt-4 plc-mb-6"
  }, /*#__PURE__*/React__default.createElement(Button, Object.assign({
    className: "plc-mb-2 plc-text-base plc-text-gray-500",
    variant: "ghost",
    icon: /*#__PURE__*/React__default.createElement(SvgTicket, {
      className: "plc-w-5 plc-h-5 plc-mr-2"
    }),
    onClick: showCouponField
  }, otherProps), !enableCouponField ? t("labels.addCode") : t("labels.hideCode")), enableCouponField && /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-w-full plc-mt-2 pelcro-apply-coupon-wrapper"
  }, /*#__PURE__*/React__default.createElement(CouponCodeField, null), /*#__PURE__*/React__default.createElement(ApplyCouponButton, null)));
};

function _classPrivateFieldInitSpec(obj, privateMap, value) { _checkPrivateRedeclaration(obj, privateMap); privateMap.set(obj, value); }
function _checkPrivateRedeclaration(obj, privateCollection) { if (privateCollection.has(obj)) { throw new TypeError("Cannot initialize the same private elements twice on an object"); } }

/**
 * @typedef {Object} paypalConstructorOptions
 * @property {string} [buttonElementID=pelcro-paypal-button] element for paypal button to mount on
 * @property {boolean} [enableShippingAddress=true] enable using user shipping address
 * @property {boolean} [shippingAddressEditable=true] enable user to edit address
 * @property {string} [displayName] merchant display name,  default is client's site name
 * @property {string} [locale] flow locale, default is client's default locale
 * @property {string} [billingAgreementDescription] agreement paragraph shown to user, max 255 chars
 * @property {object} [style] button style
 */
var _createPayment = /*#__PURE__*/new WeakMap();
var _onPaymentApprove = /*#__PURE__*/new WeakMap();
var _onPaymentCancel = /*#__PURE__*/new WeakMap();
var _onPaymentError = /*#__PURE__*/new WeakMap();
var _computePaymentOptions = /*#__PURE__*/new WeakMap();
var _getFormattedAmount = /*#__PURE__*/new WeakMap();
class PaypalClient {
  /**
   * @static
   * @return {boolean}
   */

  /**
   * Paypal client constructor
   * @param {paypalConstructorOptions} paypalClientConfig
   */
  constructor(paypalClientConfig) {
    _defineProperty$3(this, "build", async () => {
      if (!this.isPaypalEnabled) {
        console.error("Braintree/Paypal integration is currently not enabled on this site's config");
        return;
      }

      // initialize braintree/paypal clients
      const braintreeClient = await window.braintree.client.create({
        authorization: this.braintreeToken
      });
      const paypalCheckoutInstance = await window.braintree.paypalCheckout.create({
        client: braintreeClient
      });
      const paypalClient = await paypalCheckoutInstance.loadPayPalSDK({
        vault: true,
        intent: "tokenize"
      });
      this.client = paypalClient;
    });
    _defineProperty$3(this, "createPayment", options => {
      var _this$config$locale, _this$config$style;
      if (!this.client) {
        return console.error("No PayPal instance found, initialize an instance using PaypalClient.build method");
      }
      if (!options.product) {
        return console.error("No product/plan selected, pass selected product/plan to PaypalClient.createPayment method");
      }
      if (options.product.currency !== window.Pelcro.site.read().braintree_currency) {
        return console.error("The product's currency doesnt match the braintree/paypal configuration");
      }
      this.siteInfo = window.Pelcro.site.read();
      this.product = options.product;
      this.amount = options.amount;
      const defaultButtonStyle = {
        layout: "vertical",
        color: "gold",
        shape: "rect",
        label: "paypal"
      };
      this.paypalButton = window.paypal.Buttons({
        fundingSource: window.paypal.FUNDING.PAYPAL,
        // button locale
        locale: (_this$config$locale = this.config.locale) !== null && _this$config$locale !== void 0 ? _this$config$locale : getPageOrDefaultLanguage(),
        // button style
        style: (_this$config$style = this.config.style) !== null && _this$config$style !== void 0 ? _this$config$style : defaultButtonStyle,
        // create payment handler
        createBillingAgreement: () => _classPrivateFieldGet(this, _createPayment).call(this, options.address),
        // paypal button click callback
        onClick: () => {
          var _options$onButtonClic;
          options === null || options === void 0 ? void 0 : (_options$onButtonClic = options.onButtonClick) === null || _options$onButtonClic === void 0 ? void 0 : _options$onButtonClic.call(options);
        },
        // payment approved callback
        onApprove: data => {
          _classPrivateFieldGet(this, _onPaymentApprove).call(this, data, options === null || options === void 0 ? void 0 : options.onPaymentApprove);
        },
        // payment canceled callback
        onCancel: data => {
          var _options$onPaymentCan;
          _classPrivateFieldGet(this, _onPaymentCancel).call(this, data);
          options === null || options === void 0 ? void 0 : (_options$onPaymentCan = options.onPaymentCancel) === null || _options$onPaymentCan === void 0 ? void 0 : _options$onPaymentCan.call(options, data);
        },
        // payment error callback
        onError: error => {
          var _options$onPaymentErr;
          _classPrivateFieldGet(this, _onPaymentError).call(this, error);
          options === null || options === void 0 ? void 0 : (_options$onPaymentErr = options.onPaymentError) === null || _options$onPaymentErr === void 0 ? void 0 : _options$onPaymentErr.call(options, error);
        }
      });
    });
    _defineProperty$3(this, "render", () => {
      var _this$config$buttonEl;
      if (!this.paypalButton) {
        return console.error("No payment request, create a payment before rendering the button using PaypalClient.createPayment method");
      }
      this.paypalButton.render(`#${(_this$config$buttonEl = this.config.buttonElementID) !== null && _this$config$buttonEl !== void 0 ? _this$config$buttonEl : "pelcro-paypal-button"}`);
    });
    _classPrivateFieldInitSpec(this, _createPayment, {
      writable: true,
      value: address => {
        return this.client.createPayment(_classPrivateFieldGet(this, _computePaymentOptions).call(this, address));
      }
    });
    _classPrivateFieldInitSpec(this, _onPaymentApprove, {
      writable: true,
      value: (data, callback) => {
        return this.client.tokenizePayment(data).then(payload => {
          callback === null || callback === void 0 ? void 0 : callback(payload);
        });
      }
    });
    _classPrivateFieldInitSpec(this, _onPaymentCancel, {
      writable: true,
      value: data => {
        console.log("PayPal payment cancelled", JSON.stringify(data, 0, 2));
      }
    });
    _classPrivateFieldInitSpec(this, _onPaymentError, {
      writable: true,
      value: error => {
        console.error("PayPal error", error);
      }
    });
    _classPrivateFieldInitSpec(this, _computePaymentOptions, {
      writable: true,
      value: address => {
        var _this$config$billingA, _this$config$enableSh, _this$config$displayN, _this$config$locale2;
        const billingWording = _classPrivateFieldGet(this, _getFormattedAmount).call(this);
        return {
          flow: "vault",
          billingAgreementDescription: (_this$config$billingA = this.config.billingAgreementDescription) !== null && _this$config$billingA !== void 0 ? _this$config$billingA : `${this.product.nickname} - ${billingWording}`,
          enableShippingAddress: (_this$config$enableSh = this.config.enableShippingAddress) !== null && _this$config$enableSh !== void 0 ? _this$config$enableSh : true,
          shippingAddressOverride: this.config.enableShippingAddress ? {
            recipientName: address.first_name + address.last_name,
            line1: address.line1,
            line2: address.line2,
            city: address.city,
            countryCode: address.country,
            postalCode: address.postal_code,
            state: address.state,
            phone: address.phone
          } : undefined,
          shippingAddressEditable: this.config.shippingAddressEditable,
          displayName: (_this$config$displayN = this.config.displayName) !== null && _this$config$displayN !== void 0 ? _this$config$displayN : this.siteInfo.name,
          locale: (_this$config$locale2 = this.config.locale) !== null && _this$config$locale2 !== void 0 ? _this$config$locale2 : getPageOrDefaultLanguage()
        };
      }
    });
    _classPrivateFieldInitSpec(this, _getFormattedAmount, {
      writable: true,
      value: () => {
        const totalAmount = (this.product.quantity || 1) * this.amount;
        const priceFormatted = getFormattedPriceByLocal(totalAmount, this.product.currency, getPageOrDefaultLanguage());
        const autoRenewed = this.product.auto_renew;
        const {
          interval,
          intervalCount
        } = this.product;
        const formattedInterval = intervalCount > 1 ? `${intervalCount} ${interval}s` : `${interval}`;
        if (autoRenewed) {
          return `${priceFormatted} per ${formattedInterval}`;
        }
        return priceFormatted;
      }
    });
    this.client = null;
    this.paypalButton = null;
    this.product = null;
    this.amount = null;
    this.config = paypalClientConfig;
    this.braintreeToken = window.Pelcro.site.read().braintree_tokenization;
    this.isPaypalEnabled = PaypalClient.isPaypalEnabled();
  }

  /**
   * Builds PayPal checkout instance
   */
}
_defineProperty$3(PaypalClient, "isPaypalEnabled", () => Boolean(window.Pelcro.site.read().braintree_tokenization));

/**
 * PaypalSubscribeButton component
 * @param {PaypalSubscribeButton.propTypes} props
 * @return {JSX}
 */
const PaypalSubscribeButton = props => {
  const {
    dispatch,
    state
  } = useContext(store$l);
  const {
    product,
    plan,
    invoice,
    selectedAddressId
  } = usePelcro();
  useEffect(() => {
    var _ref, _ref2, _state$updatedPrice, _props$plan, _props$selectedAddres;
    // sometimes, price is updated. eg. Coupon codes.
    const updatedPrice = (_ref = (_ref2 = (_state$updatedPrice = state.updatedPrice) !== null && _state$updatedPrice !== void 0 ? _state$updatedPrice : (_props$plan = props.plan) === null || _props$plan === void 0 ? void 0 : _props$plan.amount) !== null && _ref2 !== void 0 ? _ref2 : plan === null || plan === void 0 ? void 0 : plan.amount) !== null && _ref !== void 0 ? _ref : invoice.amount_remaining;
    const selectedAddress = getAddressById((_props$selectedAddres = props.selectedAddressId) !== null && _props$selectedAddres !== void 0 ? _props$selectedAddres : selectedAddressId);

    // initialize paypal client, then render paypal button.
    const initializePaypal = async () => {
      var _props$buttonElementI, _props$product$addres, _props$product;
      const paypalCheckoutInstance = new PaypalClient({
        buttonElementID: (_props$buttonElementI = props.buttonElementID) !== null && _props$buttonElementI !== void 0 ? _props$buttonElementI : "pelcro-paypal-button",
        style: props.buttonStyle,
        enableShippingAddress: (_props$product$addres = (_props$product = props.product) === null || _props$product === void 0 ? void 0 : _props$product.address_required) !== null && _props$product$addres !== void 0 ? _props$product$addres : product === null || product === void 0 ? void 0 : product.address_required,
        shippingAddressEditable: props.makeAddressEditable,
        displayName: props.merchantDisplayName,
        locale: props.locale,
        billingAgreementDescription: props.billingDescription
      });
      const getProduct = () => {
        if (invoice) {
          invoice.plan = null;
          if (invoice.plan) {
            return invoice.plan;
          } else {
            // standalone invoices dont have a plan
            return {
              currency: invoice.currency,
              nickname: `invoice #${invoice.id}`
            };
          }
        } else if (props.plan) {
          return props.plan;
        } else {
          return plan;
        }
      };

      // Await building paypal instance
      await paypalCheckoutInstance.build();
      // Create paypal payment
      paypalCheckoutInstance.createPayment({
        product: getProduct(),
        amount: updatedPrice,
        address: invoice ? null : selectedAddress,
        onButtonClick: () => {
          dispatch({
            type: DISABLE_SUBMIT,
            payload: true
          });
        },
        onPaymentApprove: _ref3 => {
          let {
            nonce
          } = _ref3;
          dispatch({
            type: HANDLE_PAYPAL_SUBSCRIPTION,
            payload: nonce
          });
          dispatch({
            type: LOADING,
            payload: true
          });
        },
        onPaymentCancel: () => {
          dispatch({
            type: LOADING,
            payload: false
          });
          dispatch({
            type: DISABLE_SUBMIT,
            payload: false
          });
        }
      });

      // Render paypal button
      paypalCheckoutInstance.render();
    };
    if (PaypalClient.isPaypalEnabled()) {
      initializePaypal();
    }
  }, [state.updatedPrice]);
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-paypal-button"
  });
};

const BankRedirection = () => {
  const {
    t
  } = useTranslation("checkoutForm");
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-absolute plc-inset-0 plc-flex-col plc-items-center plc-justify-center plc-hidden plc-text-lg plc-bg-white plc-z-max plc-text-primary-500 card-authentication-container"
  }, t("messages.bankRedirection"), /*#__PURE__*/React__default.createElement(SvgSpinner, {
    className: "plc-w-10 plc-h-10 plc-mt-5 plc-animate-spin"
  }));
};

const BankAuthenticationSuccess = () => {
  const {
    t
  } = useTranslation("checkoutForm");
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-absolute plc-inset-0 plc-flex-col plc-items-center plc-justify-center plc-hidden plc-text-lg plc-bg-white plc-z-max plc-text-primary-500 card-authentication-success-container"
  }, t("messages.bankAuthenticationSuccess"), /*#__PURE__*/React__default.createElement(SvgSpinner, {
    className: "plc-w-10 plc-h-10 plc-mt-5 plc-animate-spin"
  }));
};

var _path$m;
function _extends$o() { _extends$o = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$o.apply(this, arguments); }
function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$o({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path$m || (_path$m = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z",
    clipRule: "evenodd"
  })));
}

const SelectedPaymentMethod = () => {
  var _window$Pelcro$user$r, _window$Pelcro$user$r2, _window$Pelcro$user$r3, _paymentMethod$proper, _paymentMethod$proper2, _paymentMethod$proper3, _paymentMethod$proper4;
  const {
    t
  } = useTranslation("paymentMethod");
  const {
    state: {
      isLoading
    }
  } = useContext(store$l);
  const {
    switchView,
    selectedPaymentMethodId
  } = usePelcro();
  const paymentMethod = (_window$Pelcro$user$r = window.Pelcro.user.read()) === null || _window$Pelcro$user$r === void 0 ? void 0 : (_window$Pelcro$user$r2 = _window$Pelcro$user$r.sources) === null || _window$Pelcro$user$r2 === void 0 ? void 0 : (_window$Pelcro$user$r3 = _window$Pelcro$user$r2.find) === null || _window$Pelcro$user$r3 === void 0 ? void 0 : _window$Pelcro$user$r3.call(_window$Pelcro$user$r2, source => {
    return source.id == selectedPaymentMethodId;
  });
  return selectedPaymentMethodId && /*#__PURE__*/React__default.createElement("div", {
    key: paymentMethod.id,
    className: "plc-px-2 plc-my-2 plc-text-gray-900 plc-rounded plc-shadow-md plc-ring-2 plc-ring-primary-400 pelcro-payment-method-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-px-1",
    id: `pelcro-payment-method-select-${paymentMethod.id}`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-justify-between plc-w-full"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-space-x-2"
  }, getPaymentCardIcon$1((_paymentMethod$proper = paymentMethod.properties) === null || _paymentMethod$proper === void 0 ? void 0 : _paymentMethod$proper.brand), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-flex-col plc-text-lg pelcro-payment-method-details"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "plc-font-semibold"
  }, "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ", (_paymentMethod$proper2 = paymentMethod.properties) === null || _paymentMethod$proper2 === void 0 ? void 0 : _paymentMethod$proper2.last4), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-text-sm plc-text-gray-500"
  }, t("select.expires"), " ", (_paymentMethod$proper3 = paymentMethod.properties) === null || _paymentMethod$proper3 === void 0 ? void 0 : _paymentMethod$proper3.exp_month, "/", (_paymentMethod$proper4 = paymentMethod.properties) === null || _paymentMethod$proper4 === void 0 ? void 0 : _paymentMethod$proper4.exp_year))), /*#__PURE__*/React__default.createElement(Button, {
    onClick: () => switchView("payment-method-select"),
    disabled: isLoading,
    variant: "ghost",
    className: "plc-text-primary-500"
  }, t("select.buttons.changePaymentMethod")))));
};

const TaxAmount = () => {
  var _plan$quantity, _window$Pelcro$site, _window$Pelcro$site$r;
  const {
    t
  } = useTranslation("checkoutForm");
  const {
    state: {
      taxAmount
    }
  } = useContext(store$l);
  const {
    plan
  } = usePelcro();
  const planQuantity = (_plan$quantity = plan === null || plan === void 0 ? void 0 : plan.quantity) !== null && _plan$quantity !== void 0 ? _plan$quantity : 1;
  const priceFormatted = getFormattedPriceByLocal(taxAmount * planQuantity, plan === null || plan === void 0 ? void 0 : plan.currency, getPageOrDefaultLanguage());
  const isTaxInclusive = (_window$Pelcro$site = window.Pelcro.site) === null || _window$Pelcro$site === void 0 ? void 0 : (_window$Pelcro$site$r = _window$Pelcro$site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.tax_inclusive;
  if (taxAmount) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "plc-text-center pelcro-tax-amount"
    }, isTaxInclusive && "(", isTaxInclusive ? `Includes ${t("labels.tax")}` : `+ ${t("labels.tax")}`, " ", /*#__PURE__*/React__default.createElement("span", {
      className: "plc-font-bold"
    }, priceFormatted), isTaxInclusive && ")");
  }
  return null;
};

const IncludeFirstName = props => /*#__PURE__*/React__default.createElement(FirstName, Object.assign({
  store: store$l
}, props));

const IncludeLastName = props => /*#__PURE__*/React__default.createElement(LastName, Object.assign({
  store: store$l
}, props));

const IncludePhone = props => /*#__PURE__*/React__default.createElement(Phone, Object.assign({
  store: store$l
}, props));

const SubscriptionCreateFreePlanButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    state: {
      disableSubmit
    },
    dispatch
  } = useContext(store$l);
  const {
    t
  } = useTranslation("common");
  const [isDisabled, setDisabled] = useState(true);
  useEffect(() => {
    setDisabled(disableSubmit);
  }, [disableSubmit]);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    className: "plc-w-full",
    onClick: () => {
      dispatch({
        type: DISABLE_SUBMIT,
        payload: true
      });
      dispatch({
        type: SUBSCRIBE
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: isDisabled,
    isLoading: disableSubmit
  }, otherProps), t("buttons.subscribe"));
};

const OrderCreateFreeButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    state: {
      disableSubmit
    },
    dispatch
  } = useContext(store$l);
  const {
    t
  } = useTranslation("checkoutForm");
  const [isDisabled, setDisabled] = useState(true);
  useEffect(() => {
    setDisabled(disableSubmit);
  }, [disableSubmit]);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    className: "plc-w-full",
    onClick: () => {
      dispatch({
        type: DISABLE_SUBMIT,
        payload: true
      });
      dispatch({
        type: SUBMIT_PAYMENT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: isDisabled,
    isLoading: disableSubmit
  }, otherProps), t("labels.submit"));
};

/**
 * ApplePayButton component
 * @return {JSX}
 */
const ApplePayButton = _ref => {
  var _window$Pelcro$site$r;
  let {
    onClick,
    props,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state
  } = useContext(store$l);
  const {
    plan,
    invoice,
    order
  } = usePelcro();
  const {
    pay_page_id: payPageId,
    report_group: reportGroup,
    apple_pay_merchant_id: ApplePayMerchantId,
    apple_pay_enabled: ApplePayEnabled
  } = (_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.vantiv_gateway_settings;
  const getOrderInfo = () => {
    if (!order) {
      return {
        price: null,
        currency: null,
        label: null
      };
    }
    const isQuickPurchase = !Array.isArray(order);
    if (isQuickPurchase) {
      return {
        price: order.price * order.quantity,
        currency: order.currency,
        label: order.name
      };
    }
    if (order.length === 0) {
      return {
        price: null,
        currency: null,
        label: null
      };
    }
    const price = order.reduce((total, item) => total + item.price * item.quantity, 0);
    return {
      price,
      currency: order[0].currency,
      label: "Order"
    };
  };
  const orderPrice = getOrderInfo().price;
  const orderCurrency = getOrderInfo().currency;
  const orderLabel = getOrderInfo().label;
  useEffect(() => {
    if (window.ApplePaySession) {
      // Indicates whether the device supports Apple Pay and whether the user has an active card in Wallet.
      // eslint-disable-next-line no-undef
      const promise = ApplePaySession.canMakePaymentsWithActiveCard(ApplePayMerchantId);
      promise.then(function (canMakePayments) {
        if (canMakePayments && ApplePayEnabled) {
          // Display Apple Pay Buttons here…
          const pelcroApplyPayButton = document.getElementById("pelcro-apple-pay-button");
          if (pelcroApplyPayButton) {
            pelcroApplyPayButton.style.display = "block";
          }
          console.log("ApplePay canMakePayments function: ", canMakePayments);
        }
      });
    } else {
      console.error("ApplePay is not available on this browser");
    }
  }, []);
  useEffect(() => {
    function onApplePayButtonClicked() {
      var _ref2, _ref3, _ref4, _ref5, _state$updatedPrice, _props$plan, _window, _window$Pelcro, _window$Pelcro$user, _window$Pelcro$user$l;
      // eslint-disable-next-line no-undef
      if (!ApplePaySession) {
        return;
      }
      const updatedPrice = (_ref2 = (_ref3 = (_ref4 = (_ref5 = (_state$updatedPrice = state.updatedPrice) !== null && _state$updatedPrice !== void 0 ? _state$updatedPrice : props === null || props === void 0 ? void 0 : (_props$plan = props.plan) === null || _props$plan === void 0 ? void 0 : _props$plan.amount) !== null && _ref5 !== void 0 ? _ref5 : plan === null || plan === void 0 ? void 0 : plan.amount) !== null && _ref4 !== void 0 ? _ref4 : orderPrice) !== null && _ref3 !== void 0 ? _ref3 : invoice === null || invoice === void 0 ? void 0 : invoice.amount_remaining) !== null && _ref2 !== void 0 ? _ref2 : null;
      const getCurrencyCode = () => {
        if (plan) {
          return plan === null || plan === void 0 ? void 0 : plan.currency.toUpperCase();
        } else if (order) {
          return orderCurrency.toUpperCase();
        } else if (invoice) {
          return invoice === null || invoice === void 0 ? void 0 : invoice.currency.toUpperCase();
        }
      };
      dispatch({
        type: DISABLE_SUBMIT,
        payload: true
      });

      // Define ApplePayPaymentRequest
      // @see https://developer.apple.com/documentation/apple_pay_on_the_web/apple_pay_js_api/creating_an_apple_pay_session
      const ApplePayPaymentRequest = {
        countryCode: ((_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$user = _window$Pelcro.user) === null || _window$Pelcro$user === void 0 ? void 0 : (_window$Pelcro$user$l = _window$Pelcro$user.location) === null || _window$Pelcro$user$l === void 0 ? void 0 : _window$Pelcro$user$l.countryCode) || "US",
        currencyCode: getCurrencyCode(),
        merchantCapabilities: ["supports3DS"],
        supportedNetworks: ["visa", "masterCard", "amex", "discover"],
        total: {
          label: (plan === null || plan === void 0 ? void 0 : plan.nickname) || orderLabel || `invoice #${invoice === null || invoice === void 0 ? void 0 : invoice.id}`,
          type: "final",
          amount: (updatedPrice / 100).toFixed(2)
        }
      };

      // Create ApplePaySession
      // @todo - Clarify supported version parameter
      // @odo - Apple Pay demo uses version 6 (https://applepaydemo.apple.com/)
      const session = new ApplePaySession(3, ApplePayPaymentRequest); // eslint-disable-line no-undef

      // @todo - Detect whether web browser supports a particular Apple Pay version.
      // @see https://developer.apple.com/documentation/apple_pay_on_the_web/applepaysession/1778014-supportsversion

      session.onvalidatemerchant = async event => {
        const {
          validationURL
        } = event;
        // Call your own server to request a new merchant session.
        window.Pelcro.payment.startSession({
          auth_token: window.Pelcro.user.read().auth_token,
          site_id: window.Pelcro.siteid,
          validation_url: validationURL
        }, (err, res) => {
          if (err) {
            // Handle any errors during merchant validation
            session.abort();
            return dispatch({
              type: SHOW_ALERT,
              payload: {
                type: "error",
                content: getErrorMessages(err)
              }
            });
          }
          // Complete merchant validation with the merchant session object
          const merchantSession = res;
          session.completeMerchantValidation(merchantSession);
        });
      };
      session.onpaymentmethodselected = event => {
        // Define ApplePayPaymentMethodUpdate based on the selected payment method.
        // No updates or errors are needed, pass an empty object.
        const newTotal = {
          label: (plan === null || plan === void 0 ? void 0 : plan.nickname) || orderLabel || `invoice #${invoice === null || invoice === void 0 ? void 0 : invoice.id}`,
          type: "final",
          amount: (updatedPrice / 100).toFixed(2)
        };
        const newLineItems = [{
          label: (plan === null || plan === void 0 ? void 0 : plan.nickname) || orderLabel || `invoice #${invoice === null || invoice === void 0 ? void 0 : invoice.id}`,
          type: "final",
          amount: (updatedPrice / 100).toFixed(2)
        }];
        session.completePaymentMethodSelection(newTotal, newLineItems);
      };

      // TODO: Check if onshippingmethodselected it should be implemented
      // session.onshippingmethodselected = (event) => {
      //   // Define ApplePayShippingMethodUpdate based on the selected shipping method.
      //   // No updates or errors are needed, pass an empty object.
      //   const newTotal = {
      //     label: plan?.nickname || orderLabel || `invoice #${invoice?.id}`,
      //     type: "final",
      //     amount: (updatedPrice / 100).toFixed(2)
      //   };

      //   const newLineItems = [
      //     {
      //       label: plan?.nickname || orderLabel || `invoice #${invoice?.id}`,
      //       type: "final",
      //       amount: (updatedPrice / 100).toFixed(2)
      //     }
      //   ];

      //   session.completeShippingMethodSelection(newTotal, newLineItems);
      // };

      // TODO: Check if onshippingcontactselected it should be implemented
      // session.onshippingcontactselected = (event) => {
      //   // Define ApplePayShippingContactUpdate based on the selected shipping contact.
      //   const update = {};
      //   session.completeShippingContactSelection(update);
      // };

      session.onpaymentauthorized = event => {
        // Define ApplePayPaymentAuthorizationResult
        const result = {
          status: ApplePaySession.STATUS_SUCCESS // eslint-disable-line no-undef
        };

        const {
          paymentData
        } = event.payment.token;
        const {
          data,
          signature,
          version
        } = paymentData;
        const {
          ephemeralPublicKey,
          publicKeyHash,
          transactionId
        } = paymentData.header;
        const applePayToken = {
          data: data,
          signature: signature,
          version: version,
          header: {
            ephemeralPublicKey: ephemeralPublicKey,
            publicKeyHash: publicKeyHash,
            transactionId: transactionId
          }
        };
        const orderId = `pelcro-${new Date().getTime()}`;
        const eProtectRequestPreLiveURL = "https://request.eprotect.vantivprelive.com";
        const eProtectRequestProductionURL = "https://request.eprotect.vantivcnp.com";
        const eProtectRequestUrlToUse = window.Pelcro.site.read().vantiv_gateway_settings.environment === "production" ? eProtectRequestProductionURL : eProtectRequestPreLiveURL;
        const eProtectRequest = {
          paypageId: payPageId,
          reportGroup: reportGroup,
          orderId: orderId,
          id: orderId,
          applepay: applePayToken,
          url: eProtectRequestUrlToUse
        };

        // successCallback function to handle the response from WorldPay.
        function successCallback(vantivResponse) {
          const {
            expDate
          } = vantivResponse;
          const expMonth = expDate.substring(0, 2);
          const expYear = expDate.substring(2);
          const vantivPaymentRequest = {
            ...vantivResponse,
            expMonth: expMonth,
            expYear: expYear,
            applePay: true
          };

          // Process the registrationId or continue with further payment processing.
          dispatch({
            type: HANDLE_APPLEPAY_SUBSCRIPTION,
            payload: vantivPaymentRequest
          });
          dispatch({
            type: LOADING,
            payload: true
          });
          session.completePayment(result);
        }

        // errorCallback function to handle any errors that may occur during the tokenization process.
        function errorCallback(error) {
          console.error("Error retrieving Registration ID:", error);
          // Handle error appropriately.
        }
        // errorCallback function to handle any errors that may occur during the tokenization process.
        function timeoutCallback() {
          console.error("eProtect Timeout");
          // Handle error appropriately.
        }

        // eslint-disable-next-line no-undef
        new eProtect().sendToEprotect(eProtectRequest, {}, successCallback, errorCallback, timeoutCallback, 15000);
      };

      // TODO: Check if oncouponcodechanged it should be implemented
      // session.oncouponcodechanged = (event) => {
      //   // Define ApplePayCouponCodeUpdate
      //   const newTotal = calculateNewTotal(event.couponCode);
      //   const newLineItems = calculateNewLineItems(event.couponCode);
      //   const newShippingMethods = calculateNewShippingMethods(
      //     event.couponCode
      //   );
      //   const errors = calculateErrors(event.couponCode);

      //   session.completeCouponCodeChange({
      //     newTotal: newTotal,
      //     newLineItems: newLineItems,
      //     newShippingMethods: newShippingMethods,
      //     errors: errors
      //   });
      // };

      session.oncancel = event => {
        // Payment cancelled by WebKit
        dispatch({
          type: LOADING,
          payload: false
        });
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
      };
      session.begin();
    }
    const pelcroApplyPayButton = document.getElementById("pelcro-apple-pay-button");
    if (pelcroApplyPayButton) {
      pelcroApplyPayButton.addEventListener("click", onApplePayButtonClicked);
    }
    return () => {
      if (pelcroApplyPayButton) {
        pelcroApplyPayButton.removeEventListener("click", onApplePayButtonClicked);
      }
    };
  }, [state.updatedPrice]);
  return /*#__PURE__*/React__default.createElement("apple-pay-button", {
    id: "pelcro-apple-pay-button",
    style: {
      display: "none"
    },
    buttonstyle: "black",
    type: "plain",
    locale: "en-US"
  });
};

function PaymentMethodUpdateSetDefault(props) {
  const {
    dispatch,
    state: {
      isDefault
    }
  } = useContext(store$l);
  const {
    paymentMethodToEdit
  } = usePelcro();
  useEffect(() => {
    if (paymentMethodToEdit !== null && paymentMethodToEdit !== void 0 && paymentMethodToEdit.is_default) {
      dispatch({
        type: SET_IS_DEFAULT_PAYMENT_METHOD,
        payload: {
          isDefault: true
        }
      });
    }
  }, [paymentMethodToEdit]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleCheckboxChange = e => {
    dispatch({
      type: HANDLE_CHECKBOX_CHANGE,
      payload: {
        isDefault: e.target.checked
      }
    });
  };
  return /*#__PURE__*/React__default.createElement(Checkbox, {
    onChange: e => handleCheckboxChange(e),
    id: props.id,
    checked: isDefault,
    disabled: paymentMethodToEdit === null || paymentMethodToEdit === void 0 ? void 0 : paymentMethodToEdit.is_default
  }, props.label);
}

/**
 *
 */
function PaymentMethodView(_ref) {
  var _window$Pelcro$site$r, _window$Pelcro$site$r2, _window$Pelcro$site$r3, _calcAndFormatItemsTo, _order$;
  let {
    onSuccess,
    onGiftRenewalSuccess,
    onFailure,
    type,
    showCoupon,
    showExternalPaymentMethods,
    showSubscriptionButton,
    showOrderButton,
    showApplePayButton,
    order
  } = _ref;
  const {
    t
  } = useTranslation("checkoutForm");
  const cardProcessor = getSiteCardProcessor();
  const supportsVantiv = Boolean((_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.vantiv_gateway_settings);
  const supportsTap = Boolean((_window$Pelcro$site$r2 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r2 === void 0 ? void 0 : _window$Pelcro$site$r2.tap_gateway_settings);
  const supportsCybersource = Boolean((_window$Pelcro$site$r3 = window.Pelcro.site.read()) === null || _window$Pelcro$site$r3 === void 0 ? void 0 : _window$Pelcro$site$r3.cybersource_gateway_settings);
  const isUserFirstName = Boolean(window.Pelcro.user.read().first_name);
  const isUserLastName = Boolean(window.Pelcro.user.read().last_name);
  const isUserPhone = Boolean(window.Pelcro.user.read().phone);
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-flex-col plc-items-center plc-mt-4 sm:plc-px-8 pelcro-payment-block"
  }, order && /*#__PURE__*/React__default.createElement("div", {
    className: "plc-w-full plc-p-2 plc-mb-4 plc-font-semibold plc-text-center plc-text-gray-900 plc-bg-gray-100 plc-border plc-border-gray-200"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "plc-text-gray-600"
  }, !Array.isArray(order) ? /*#__PURE__*/React__default.createElement("span", {
    className: "plc-tracking-wider plc-uppercase"
  }, order === null || order === void 0 ? void 0 : order.name) : /*#__PURE__*/React__default.createElement("span", {
    className: "plc-tracking-wider plc-uppercase"
  }, t("labels.freeItems")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
    className: "plc-text-xl plc-font-semibold plc-text-primary-600"
  }, (_calcAndFormatItemsTo = calcAndFormatItemsTotal(order, (_order$ = order[0]) === null || _order$ === void 0 ? void 0 : _order$.currency)) !== null && _calcAndFormatItemsTo !== void 0 ? _calcAndFormatItemsTo : getFormattedPriceByLocal(order === null || order === void 0 ? void 0 : order.price, order === null || order === void 0 ? void 0 : order.currency, getPageOrDefaultLanguage())))), cardProcessor === "stripe" && !showSubscriptionButton && !showOrderButton && /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-w-full plc-px-4 plc-py-2 plc-text-center plc-text-green-600 plc-border plc-border-green-400 plc-rounded plc-bg-green-50"
  }, /*#__PURE__*/React__default.createElement(SvgLock, {
    className: "plc-w-5 plc-h-5 plc-mr-1"
  }), /*#__PURE__*/React__default.createElement("span", null, t("messages.youAreSafe"), /*#__PURE__*/React__default.createElement(Link, {
    className: "plc-ml-1",
    target: "_blank",
    href: "https://www.stripe.com/us/customers",
    isButton: false
  }, "Stripe"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-w-full plc-mt-2 plc-font-semibold plc-text-gray-600 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(PaymentMethodContainer, {
    type: type,
    onSuccess: onSuccess,
    onGiftRenewalSuccess: onGiftRenewalSuccess,
    onFailure: onFailure,
    freeOrders: showOrderButton
  }, /*#__PURE__*/React__default.createElement(AlertWithContext, {
    className: "plc-mb-2"
  }), showSubscriptionButton && /*#__PURE__*/React__default.createElement(SubscriptionCreateFreePlanButton, null), showOrderButton && /*#__PURE__*/React__default.createElement(OrderCreateFreeButton, null), !showSubscriptionButton && !showOrderButton && /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(BankRedirection, null), /*#__PURE__*/React__default.createElement(BankAuthenticationSuccess, null), /*#__PURE__*/React__default.createElement(SelectedPaymentMethod, null), supportsTap && (!isUserFirstName || !isUserLastName || !isUserPhone) && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start"
  }, /*#__PURE__*/React__default.createElement(IncludeFirstName, {
    id: "pelcro-input-first-name",
    label: t("labels.firstName"),
    errorId: "pelcro-input-firstName-error",
    required: true
  }), /*#__PURE__*/React__default.createElement(IncludeLastName, {
    wrapperClassName: "plc-ml-3",
    id: "pelcro-input-last-name",
    label: t("labels.lastName"),
    errorId: "pelcro-input-lastName-error",
    required: true
  })), /*#__PURE__*/React__default.createElement(IncludePhone, {
    id: "pelcro-input-phone",
    errorId: "pelcro-input-phone-error",
    label: t("labels.phone"),
    required: true
  })), /*#__PURE__*/React__default.createElement(CheckoutForm, {
    type: type
  }), showCoupon && /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-2"
  }, /*#__PURE__*/React__default.createElement(CouponCode, null), /*#__PURE__*/React__default.createElement(DiscountedPrice, null)), /*#__PURE__*/React__default.createElement(TaxAmount, null), type === "updatePaymentSource" && /*#__PURE__*/React__default.createElement(PaymentMethodUpdateSetDefault, {
    id: "pelcro-input-is-default",
    label: t("labels.isDefault")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-grid plc-mt-4 plc-gap-y-2"
  }, /*#__PURE__*/React__default.createElement(SubmitPaymentMethod, null), showExternalPaymentMethods && !supportsVantiv && !supportsCybersource && !supportsTap ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PelcroPaymentRequestButton, null), /*#__PURE__*/React__default.createElement(PaypalSubscribeButton, null)) : showExternalPaymentMethods && supportsVantiv ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(PaypalSubscribeButton, null)) : null, showApplePayButton && supportsVantiv ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ApplePayButton, null)) : null)))));
}

const SubscriptionRenewView = _ref => {
  var _window$Pelcro, _window$Pelcro$uiSett, _product$paywall$subs, _product$paywall, _window$Pelcro$paywal, _product$paywall$subs2, _product$paywall2, _window$Pelcro$paywal2;
  let {
    onSuccess = () => {},
    onGiftRenewalSuccess = () => {},
    onFailure = () => {}
  } = _ref;
  const {
    t
  } = useTranslation("checkoutForm");
  const {
    product,
    plan
  } = usePelcro();
  const skipPayment = (_window$Pelcro = window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.skipPaymentForFreePlans;
  const showSubscriptionButton = skipPayment && (plan === null || plan === void 0 ? void 0 : plan.amount) === 0;
  const getPricingText = plan => {
    const autoRenewed = plan.auto_renew;
    const {
      interval_translated,
      interval_count
    } = plan;
    const intervalText = t("labels.interval", {
      interval: interval_translated,
      count: interval_count
    });
    return /*#__PURE__*/React__default.createElement("p", {
      className: "plc-text-gray-600"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "plc-tracking-wider plc-uppercase"
    }, plan.nickname), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
      className: "plc-text-xl plc-font-semibold plc-text-primary-600"
    }, plan.amount_formatted, " "), /*#__PURE__*/React__default.createElement("span", {
      className: "plc-font-thin"
    }, autoRenewed ? "/" : t("labels.for"), " ", intervalText));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-subscription-renew-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold "
  }, (_product$paywall$subs = product === null || product === void 0 ? void 0 : (_product$paywall = product.paywall) === null || _product$paywall === void 0 ? void 0 : _product$paywall.subscribe_title) !== null && _product$paywall$subs !== void 0 ? _product$paywall$subs : (_window$Pelcro$paywal = window.Pelcro.paywall.read()) === null || _window$Pelcro$paywal === void 0 ? void 0 : _window$Pelcro$paywal.subscribe_title), " ", /*#__PURE__*/React__default.createElement("p", null, (_product$paywall$subs2 = product === null || product === void 0 ? void 0 : (_product$paywall2 = product.paywall) === null || _product$paywall2 === void 0 ? void 0 : _product$paywall2.subscribe_subtitle) !== null && _product$paywall$subs2 !== void 0 ? _product$paywall$subs2 : (_window$Pelcro$paywal2 = window.Pelcro.paywall.read()) === null || _window$Pelcro$paywal2 === void 0 ? void 0 : _window$Pelcro$paywal2.subscribe_subtitle), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-w-full plc-p-2 plc-mt-2 plc-font-semibold plc-text-center plc-text-gray-900 plc-bg-gray-100 plc-border plc-border-gray-200"
  }, plan && getPricingText(plan))), /*#__PURE__*/React__default.createElement(PaymentMethodView, {
    type: "createPayment",
    showCoupon: true,
    showExternalPaymentMethods: false,
    showApplePayButton: true,
    onSuccess: onSuccess,
    onGiftRenewalSuccess: onGiftRenewalSuccess,
    onFailure: onFailure,
    showSubscriptionButton: showSubscriptionButton
  }));
};

/**
 *
 */
function SubscriptionRenewModal(_ref) {
  var _window, _window$Pelcro, _window$Pelcro$uiSett;
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  const {
    switchView
  } = usePelcro();
  const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
  const onSuccess = res => {
    var _otherProps$onSuccess;
    (_otherProps$onSuccess = otherProps.onSuccess) === null || _otherProps$onSuccess === void 0 ? void 0 : _otherProps$onSuccess.call(otherProps, res);
    if (enableReactGA4) {
      ReactGA4.event("Renewed", {
        nonInteraction: true
      });
    } else {
      var _ReactGA$event;
      ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
        category: "ACTIONS",
        action: "Renewed",
        nonInteraction: true
      });
    }
    return switchView("subscription-success");
  };
  const onGiftRenewalSuccess = () => {
    var _otherProps$onGiftRen;
    (_otherProps$onGiftRen = otherProps.onGiftRenewalSuccess) === null || _otherProps$onGiftRen === void 0 ? void 0 : _otherProps$onGiftRen.call(otherProps);
    if (enableReactGA4) {
      ReactGA4.event("Renewed Gift", {
        nonInteraction: true
      });
    } else {
      var _ReactGA$event2;
      ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event2 = ReactGA.event) === null || _ReactGA$event2 === void 0 ? void 0 : _ReactGA$event2.call(ReactGA, {
        category: "ACTIONS",
        action: "Renewed Gift",
        nonInteraction: true
      });
    }
    return switchView("subscription-success");
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-subscription-renew-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(SubscriptionRenewView, Object.assign({}, otherProps, {
    onSuccess: onSuccess,
    onGiftRenewalSuccess: onGiftRenewalSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
}
SubscriptionRenewModal.viewId = "subscription-renew";

const initialState$k = {
  cancelationReason: "",
  cancelationOption: ""
};
const store$k = /*#__PURE__*/createContext(initialState$k);
const {
  Provider: Provider$k
} = store$k;
const SubscriptionCancelContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children,
    ...props
  } = _ref;
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SET_CANCEL_SUBSCRIPTION_REASON:
        return lib_7({
          ...state,
          cancelationReason: action.payload
        });
      case SET_CANCEL_SUBSCRIPTION_OPTION:
        return lib_7({
          ...state,
          cancelationOption: action.payload
        });
      default:
        return state;
    }
  }, initialState$k);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-subscription-cancel-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$k, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$k,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$k
  })));
};

var _path$l;
function _extends$n() { _extends$n = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$n.apply(this, arguments); }
function SvgInfoCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$n({
    xmlns: "http://www.w3.org/2000/svg",
    className: "plc-w-5 plc-h-5",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$l || (_path$l = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  })));
}

/**
 *
 */
const Tooltip = _ref => {
  let {
    value,
    className
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: `plc-flex pelcro-tooltip-container plc-text-gray-600 ${className}`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "pelcro-tooltip-icon"
  }, /*#__PURE__*/React__default.createElement(SvgInfoCircle, null)), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-p-1 plc--mt-8 plc-text-sm plc-bg-gray-100 plc-border plc-rounded-md plc-shadow-lg pelcro-tooltip"
  }, value));
};

/**
 *
 */
function TextArea(_ref) {
  let {
    label = "",
    tooltipText,
    required,
    id,
    errorId,
    error,
    className = "",
    labelClassName = "",
    errorClassName = "",
    wrapperClassName = "",
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: `pelcro-input-wrapper ${wrapperClassName}`
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: `pelcro-input-label plc-flex plc-items-center ${labelClassName}`
  }, `${label}${required ? "*" : ""}`, tooltipText && /*#__PURE__*/React__default.createElement(Tooltip, {
    value: tooltipText,
    className: "plc-ml-1"
  })), /*#__PURE__*/React__default.createElement("textarea", Object.assign({
    type: "text",
    id: id,
    className: `pelcro-input-field ${className} ${error ? "pelcro-input-invalid" : ""}`,
    "aria-describedby": errorId,
    "aria-invalid": Boolean(error)
  }, otherProps)), error && /*#__PURE__*/React__default.createElement("p", {
    id: errorId,
    "aria-live": "assertive",
    className: `pelcro-input-error ${errorClassName}`
  }, error));
}

const SubscriptionCancelReason = props => {
  const {
    t
  } = useTranslation("subscriptionCancel");
  const {
    dispatch
  } = useContext(store$k);
  const handleOnTextAreaBlur = e => {
    dispatch({
      type: SET_CANCEL_SUBSCRIPTION_REASON,
      payload: e.target.value.trim()
    });
  };
  return /*#__PURE__*/React__default.createElement(TextArea, Object.assign({
    label: t("labels.cancelReason"),
    onBlur: e => handleOnTextAreaBlur(e)
  }, props));
};

var _switch;
function _extends$m() { _extends$m = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$m.apply(this, arguments); }
function SvgSubscription(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$m({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 125",
    fill: "currentColor"
  }, props), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5273.1 2400.1v-2c0-2.8-5-4-9.7-4s-9.7 1.3-9.7 4v2c0 1.8.7 3.6 2 4.9l5 4.9c.3.3.4.6.4 1v6.4c0 .4.2.7.6.8l2.9.9c.5.1 1-.2 1-.8v-7.2c0-.4.2-.7.4-1l5.1-5c1.3-1.3 2-3.1 2-4.9zm-9.7-.1c-4.8 0-7.4-1.3-7.5-1.8.1-.5 2.7-1.8 7.5-1.8s7.3 1.3 7.5 1.8c-.2.5-2.7 1.8-7.5 1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5268.4 2410.3c-.6 0-1 .4-1 1s.4 1 1 1h4.3c.6 0 1-.4 1-1s-.4-1-1-1h-4.3zM5272.7 2413.7h-4.3c-.6 0-1 .4-1 1s.4 1 1 1h4.3c.6 0 1-.4 1-1s-.4-1-1-1zM5272.7 2417h-4.3c-.6 0-1 .4-1 1s.4 1 1 1h4.3c.6 0 1-.4 1-1 0-.5-.4-1-1-1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.4 58.6c0-4.4-3.6-7.9-8-7.9-1.3 0-2.5.3-3.6.9-1.4-2.5-4-4-6.9-4-1.3 0-2.5.3-3.6.9-1.4-2.5-4-4-6.9-4-.9 0-1.8.1-2.6.4v-4.6h6c4.8 0 8.6-3.9 8.6-8.7V11.2c0-4.8-3.9-8.7-8.6-8.7H18.2c-4.8 0-8.6 3.9-8.6 8.7v20.3c0 4.8 3.9 8.7 8.6 8.7h24.6V64l-3.3-3.3c-2.7-2.7-7-3.1-10.2-1-1.9 1.3-3.1 3.3-3.5 5.5-.3 2.2.3 4.5 1.8 6.3L42 88.9c4.5 5.5 11.2 8.6 18.2 8.6h9c5.6 0 10.9-2.2 14.9-6.2s6.2-9.3 6.2-14.9l.1-17.8zm-21 33.5h-9c-5.5 0-10.6-2.4-14.1-6.6L31.9 68.1c-.5-.6-.7-1.3-.6-2.1.1-.8.5-1.4 1.1-1.8.4-.3 1-.5 1.5-.5.7 0 1.4.3 1.9.8l5.8 5.8c1.1 1.1 2.8 1.4 4.3.8 1.5-.6 2.4-2 2.4-3.6V30.1c0-1.4 1.2-2.6 2.6-2.6.7 0 1.3.3 1.8.8s.8 1.1.8 1.8v25.7c0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.7-1.2 2.7-2.7v-3.5c0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6V59c0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.7-1.2 2.7-2.7v-3.5c0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6v6.7c0 1.5 1.2 2.7 2.7 2.7 1.5 0 2.7-1.2 2.7-2.7v-3.5c0-1.4 1.2-2.6 2.6-2.6 1.4 0 2.6 1.2 2.6 2.6v17.8c0 4.2-1.6 8.1-4.6 11.1-3.2 2.9-7.2 4.5-11.3 4.5zM18.2 34.2c-1.5 0-2.6-1.2-2.6-2.7V11.2c0-1.5 1.2-2.7 2.6-2.7h46.5c1.5 0 2.6 1.2 2.6 2.7v20.3c0 1.5-1.2 2.7-2.6 2.7h-6v-4c0-2.1-.8-4.1-2.3-5.6-1.5-1.5-3.5-2.3-5.6-2.3-4.4 0-7.9 3.6-7.9 8v4H18.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5 15.5L30 21.4l-1.9-2.1c-1-1.1-2.7-1.2-3.8-.1-1.1 1-1.2 2.7-.1 3.8l3.9 4.2c.5.6 1.2.9 2 .9s1.5-.3 2-.9l7.5-8c1-1.1 1-2.8-.1-3.8s-3-1-4 .1z"
  }))))));
}

const SubscriptionCancelButton = _ref => {
  let {
    subscription,
    onClick,
    className
  } = _ref;
  const {
    switchView
  } = usePelcro();
  const {
    state: {
      cancelationReason,
      cancelationOption
    }
  } = useContext(store$k);
  const {
    t
  } = useTranslation("subscriptionCancel");
  const cancelSubscription = (payload, onSuccess, onFailure) => {
    var _window, _window$Pelcro, _window$Pelcro$uiSett;
    const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
    window.Pelcro.subscription.cancel({
      auth_token: window.Pelcro.user.read().auth_token,
      subscription_id: payload.subscription_id,
      mode: payload.mode,
      ...(payload.reason && {
        reason: payload.reason
      })
    }, (err, res) => {
      if (err) {
        return onFailure === null || onFailure === void 0 ? void 0 : onFailure(err);
      }
      if (enableReactGA4) {
        ReactGA4.event("Canceled", {
          nonInteraction: true
        });
      } else {
        var _ReactGA$event;
        ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
          category: "ACTIONS",
          action: "Canceled",
          nonInteraction: true
        });
      }
      onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(res);
    });
  };
  const handleCancelClick = () => {
    const payload = {
      subscription_id: subscription.id,
      mode: cancelationOption,
      ...(cancelationReason && {
        reason: cancelationReason
      })
    };
    onClick === null || onClick === void 0 ? void 0 : onClick();

    // Close the modal
    switchView(null);

    // Show confirmation alert after closing the modal
    notify$1.confirm((onSuccess, onFailure) => {
      cancelSubscription(payload, onSuccess, onFailure);
    }, {
      confirmMessage: cancelationOption === "now" ? t("messages.subCancellation.isSureToCancelNow") : t("messages.subCancellation.isSureToCancel"),
      loadingMessage: t("messages.subCancellation.loading"),
      successMessage: t("messages.subCancellation.success"),
      errorMessage: t("messages.subCancellation.error")
    }, {
      closeButtonLabel: t("labels.subCancellation.goBack")
    });
  };
  return /*#__PURE__*/React__default.createElement(Button, {
    onClick: handleCancelClick,
    className: `${className}`,
    disabled: !cancelationOption
  }, t("labels.cancel"));
};

// New cancellation option modal
const SubscriptionCancelOptions = _ref => {
  var _subscription$schedul;
  let {
    subscription,
    hasPhases,
    onClick,
    className
  } = _ref;
  const {
    state: {
      cancelationOption
    },
    dispatch
  } = useContext(store$k);
  const {
    t
  } = useTranslation("subscriptionCancel");
  const phases = subscription === null || subscription === void 0 ? void 0 : (_subscription$schedul = subscription.schedule) === null || _subscription$schedul === void 0 ? void 0 : _subscription$schedul.phases;
  const lastPhase = !phases ? [] : phases[(phases === null || phases === void 0 ? void 0 : phases.length) - 1];
  const handleOptionSelect = event => {
    dispatch({
      type: SET_CANCEL_SUBSCRIPTION_OPTION,
      payload: event.target.value
    });
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-text-left plc-mr-auto plc-mb-6"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "plc-mb-3"
  }, t("messages.cancelWhen")), subscription.cancel_at_period_end === 0 && hasPhases && /*#__PURE__*/React__default.createElement(Radio, {
    onChange: handleOptionSelect,
    checked: cancelationOption === "period_end",
    value: "period_end"
  }, t("labels.endOn"), " ", new Date(Number(`${lastPhase === null || lastPhase === void 0 ? void 0 : lastPhase.end_date}000`)).toLocaleDateString("en-CA", {
    year: "numeric",
    month: "short",
    day: "numeric"
  })), subscription.cancel_at_period_end === 0 && /*#__PURE__*/React__default.createElement(Radio, {
    onChange: handleOptionSelect,
    checked: cancelationOption === "current_period_end",
    value: "current_period_end"
  }, t("labels.endOn"), " ", new Date(subscription === null || subscription === void 0 ? void 0 : subscription.current_period_end).toLocaleDateString("en-CA", {
    year: "numeric",
    month: "short",
    day: "numeric"
  })), /*#__PURE__*/React__default.createElement(Radio, {
    onChange: handleOptionSelect,
    checked: cancelationOption === "now",
    value: "now"
  }, t("labels.endImmediately")));
};

const SubscriptionCancelView = props => {
  var _subscriptionToCancel7, _subscriptionToCancel8;
  const {
    subscriptionToCancel,
    switchView
  } = usePelcro();
  const {
    t
  } = useTranslation("subscriptionCancel");
  const getPhases = () => {
    var _subscriptionToCancel, _subscriptionToCancel2, _subscriptionToCancel3, _subscriptionToCancel4, _subscriptionToCancel5, _subscriptionToCancel6;
    if (!subscriptionToCancel.schedule) return [];
    const currentPhaseStartDate = subscriptionToCancel === null || subscriptionToCancel === void 0 ? void 0 : (_subscriptionToCancel = subscriptionToCancel.schedule) === null || _subscriptionToCancel === void 0 ? void 0 : (_subscriptionToCancel2 = _subscriptionToCancel.current_phase) === null || _subscriptionToCancel2 === void 0 ? void 0 : _subscriptionToCancel2.start_date;
    const currentPhase = subscriptionToCancel === null || subscriptionToCancel === void 0 ? void 0 : (_subscriptionToCancel3 = subscriptionToCancel.schedule) === null || _subscriptionToCancel3 === void 0 ? void 0 : (_subscriptionToCancel4 = _subscriptionToCancel3.phases) === null || _subscriptionToCancel4 === void 0 ? void 0 : _subscriptionToCancel4.find(phase => {
      return (phase === null || phase === void 0 ? void 0 : phase.start_date) === currentPhaseStartDate;
    });
    const futurePhases = subscriptionToCancel === null || subscriptionToCancel === void 0 ? void 0 : (_subscriptionToCancel5 = subscriptionToCancel.schedule) === null || _subscriptionToCancel5 === void 0 ? void 0 : (_subscriptionToCancel6 = _subscriptionToCancel5.phases) === null || _subscriptionToCancel6 === void 0 ? void 0 : _subscriptionToCancel6.filter(phase => {
      return (phase === null || phase === void 0 ? void 0 : phase.start_date) > currentPhaseStartDate;
    });
    return [currentPhase, ...futurePhases];
  };
  const hasPhases = getPhases().length > 0;
  const phases = subscriptionToCancel === null || subscriptionToCancel === void 0 ? void 0 : (_subscriptionToCancel7 = subscriptionToCancel.schedule) === null || _subscriptionToCancel7 === void 0 ? void 0 : _subscriptionToCancel7.phases;
  const lastPhase = !phases ? [] : phases[(phases === null || phases === void 0 ? void 0 : phases.length) - 1];
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-subscription-cancel-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("labels.title"), /*#__PURE__*/React__default.createElement("span", {
    className: "plc-text-gray-400 plc-text-base plc-block"
  }, "(", subscriptionToCancel === null || subscriptionToCancel === void 0 ? void 0 : (_subscriptionToCancel8 = subscriptionToCancel.plan) === null || _subscriptionToCancel8 === void 0 ? void 0 : _subscriptionToCancel8.nickname, ")"))), /*#__PURE__*/React__default.createElement(SubscriptionCancelContainer, props, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-flex-col plc-items-center plc-justify-center plc-mt-4"
  }, /*#__PURE__*/React__default.createElement(SvgSubscription, {
    className: "plc-w-32 plc-h-32"
  }), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-mb-3 plc-text-gray-900 plc-text-left plc-mr-auto plc-whitespace-pre-line"
  }, t("messages.subscriptionEnd"), " ", hasPhases ? new Date(Number(`${lastPhase === null || lastPhase === void 0 ? void 0 : lastPhase.end_date}000`)).toLocaleDateString("en-CA", {
    year: "numeric",
    month: "short",
    day: "numeric"
  }) : new Date(subscriptionToCancel === null || subscriptionToCancel === void 0 ? void 0 : subscriptionToCancel.current_period_end).toLocaleDateString("en-CA", {
    year: "numeric",
    month: "short",
    day: "numeric"
  }), "."), /*#__PURE__*/React__default.createElement(SubscriptionCancelOptions, {
    subscription: subscriptionToCancel,
    hasPhases: hasPhases
  }), /*#__PURE__*/React__default.createElement(SubscriptionCancelReason, null), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-space-x-0 plc-space-y-3 md:plc-space-x-3 md:plc-space-y-0 plc-w-full plc-flex plc-flex-col md:plc-flex-row plc-items-center plc-justify-center"
  }, /*#__PURE__*/React__default.createElement(SubscriptionCancelButton, {
    className: "plc-w-3/4 md:plc-w-2/5",
    subscription: subscriptionToCancel
  }), /*#__PURE__*/React__default.createElement(Button, {
    variant: "outline",
    className: "plc-w-3/4 md:plc-w-2/5",
    onClick: () => {
      switchView("dashboard");
    }
  }, t("labels.subCancellation.goBack"))))));
};

const SubscriptionCancelModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Modal, {
    onDisplay: onDisplay,
    onClose: onClose,
    id: "pelcro-subscription-cancel-modal"
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(SubscriptionCancelView, otherProps)), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
SubscriptionCancelModal.viewId = "subscription-cancel";

const initialState$j = {
  suspendDate: null,
  buttonDisabled: false
};
const store$j = /*#__PURE__*/createContext(initialState$j);
const {
  Provider: Provider$j
} = store$j;
const SubscriptionSuspendContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children,
    ...props
  } = _ref;
  useTranslation("SubscriptionSuspend");
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SET_SUBSCRIPTION_SUSPEND_DATE:
        return lib_7({
          ...state,
          suspendDate: action.payload
        });
      case DISABLE_SUBMIT:
        return lib_7({
          ...state,
          buttonDisabled: action.payload
        });
      default:
        return state;
    }
  }, initialState$j);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-subscription-suspend-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$j, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$j,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$j
  })));
};

function DatePicker(_ref) {
  let {
    label = "",
    tooltipText,
    required,
    id,
    errorId,
    error,
    className = "",
    labelClassName = "",
    errorClassName = "",
    wrapperClassName = "",
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", {
    className: `pelcro-input-wrapper ${wrapperClassName}`
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: id,
    className: `pelcro-input-label plc-flex plc-items-center ${labelClassName}`
  }, `${label}${required ? "*" : ""}`, tooltipText && /*#__PURE__*/React__default.createElement(Tooltip, {
    value: tooltipText,
    className: "plc-ml-1"
  })), /*#__PURE__*/React__default.createElement("input", Object.assign({
    type: "date",
    id: id,
    className: `pelcro-input-field ${className} ${error ? "pelcro-input-invalid" : ""}`,
    "aria-describedby": errorId,
    "aria-invalid": Boolean(error)
  }, otherProps)), error && /*#__PURE__*/React__default.createElement("p", {
    id: errorId,
    "aria-live": "assertive",
    className: `pelcro-input-error ${errorClassName}`
  }, error));
}

const nowDate$1 = new Date();
const dayFromNowDateISO = new Date(new Date().setDate(nowDate$1.getDate() + 1)).toISOString().substr(0, 10);
const SubscriptionSuspendDate = props => {
  var _props$subscription, _state$suspendDate;
  const {
    t
  } = useTranslation("subscriptionSuspend");
  const {
    dispatch,
    state
  } = useContext(store$j);
  const handleInputChange = value => {
    if (value) {
      dispatch({
        type: DISABLE_SUBMIT,
        payload: false
      });
      dispatch({
        type: SET_SUBSCRIPTION_SUSPEND_DATE,
        payload: value
      });
    }
  };
  useEffect(() => {
    handleInputChange(dayFromNowDateISO);
  }, []);
  return /*#__PURE__*/React__default.createElement(DatePicker, Object.assign({
    label: t("labels.suspensionDate"),
    min: dayFromNowDateISO,
    max: new Date(props === null || props === void 0 ? void 0 : (_props$subscription = props.subscription) === null || _props$subscription === void 0 ? void 0 : _props$subscription.current_period_end).toISOString().substr(0, 10),
    value: (_state$suspendDate = state.suspendDate) !== null && _state$suspendDate !== void 0 ? _state$suspendDate : dayFromNowDateISO,
    onChange: e => handleInputChange(e.target.value),
    onKeyDown: e => e.preventDefault()
  }, props));
};

const SubscriptionSuspendButton = _ref => {
  var _window, _window$Pelcro, _window$Pelcro$uiSett;
  let {
    subscription,
    onClick,
    className
  } = _ref;
  const {
    switchView
  } = usePelcro();
  const {
    state: {
      suspendDate,
      buttonDisabled
    },
    dispatch
  } = useContext(store$j);
  const {
    t
  } = useTranslation("subscriptionSuspend");
  const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
  const suspendSubscription = (payload, onSuccess, onFailure) => {
    window.Pelcro.subscription.update({
      auth_token: window.Pelcro.user.read().auth_token,
      subscription_id: payload.subscription_id,
      suspend: 1,
      shipments_suspended_until: suspendDate
    }, (err, res) => {
      if (err) {
        return onFailure === null || onFailure === void 0 ? void 0 : onFailure(err);
      }
      if (enableReactGA4) {
        ReactGA4.event("Suspended", {
          nonInteraction: true
        });
      } else {
        var _ReactGA$event;
        ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
          category: "ACTIONS",
          action: "Suspended",
          nonInteraction: true
        });
      }
      onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(res);
    });
  };
  const handleClick = () => {
    const payload = {
      subscription_id: subscription.id
    };
    onClick === null || onClick === void 0 ? void 0 : onClick();

    // Close the modal
    switchView(null);

    // Show confirmation alert after closing the modal
    notify$1.confirm((onSuccess, onFailure) => {
      suspendSubscription(payload, onSuccess, onFailure);
    }, {
      confirmMessage: t("messages.subCancellation.isSureToSuspendNow"),
      loadingMessage: t("messages.subCancellation.loading"),
      successMessage: t("messages.subCancellation.success"),
      errorMessage: t("messages.subCancellation.error")
    }, {
      closeButtonLabel: t("labels.subCancellation.goBack")
    });
  };
  return /*#__PURE__*/React__default.createElement(Button, {
    onClick: handleClick,
    className: `${className}`,
    disabled: buttonDisabled
  }, t("messages.suspendNow"));
};

const SubscriptionSuspendView = props => {
  const {
    subscriptionToSuspend
  } = usePelcro();
  const {
    t
  } = useTranslation("subscriptionSuspend");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-subscription-suspend-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("labels.title"), /*#__PURE__*/React__default.createElement("span", {
    className: "plc-text-gray-400 plc-text-base plc-block"
  }, "(", subscriptionToSuspend.plan.nickname, ")"))), /*#__PURE__*/React__default.createElement(SubscriptionSuspendContainer, props, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-flex-col plc-items-center plc-justify-center plc-mt-4"
  }, /*#__PURE__*/React__default.createElement(SvgSubscription, {
    className: "plc-w-32 plc-h-32"
  }), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-mb-3 plc-text-gray-900 plc-text-center plc-whitespace-pre-line"
  }, t("messages.suspensionEnd"), "."), /*#__PURE__*/React__default.createElement(SubscriptionSuspendDate, {
    subscription: subscriptionToSuspend
  }), /*#__PURE__*/React__default.createElement(SubscriptionSuspendButton, {
    className: "plc-mb-2",
    subscription: subscriptionToSuspend
  }))));
};

function SubscriptionSuspendModal(_ref) {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Modal, {
    onDisplay: onDisplay,
    onClose: onClose,
    id: "pelcro-subscription-suspend-modal"
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(SubscriptionSuspendView, otherProps)), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
}
SubscriptionSuspendModal.viewId = "subscription-suspend";

var _path$k;
function _extends$l() { _extends$l = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$l.apply(this, arguments); }
function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$l({
    className: "plc-w-6 plc-h-6 plc-mr-2",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$k || (_path$k = /*#__PURE__*/React.createElement("path", {
    d: "M20 12v10H4V12M2 7h20v5H2zM12 22V7M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"
  })));
}

const PaymentSuccessView = _ref => {
  let {
    onClose
  } = _ref;
  const {
    t
  } = useTranslation("success");
  const {
    successTitle,
    successContent,
    successIcon
  } = getSuccessContent(t);
  if (successTitle && successContent) {
    return /*#__PURE__*/React__default.createElement("div", {
      className: "plc-flex plc-flex-col plc-items-center"
    }, successIcon, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-text-center plc-text-gray-900"
    }, /*#__PURE__*/React__default.createElement("h4", {
      className: "plc-mb-4 plc-text-3xl"
    }, successTitle), /*#__PURE__*/React__default.createElement("p", null, successContent)), /*#__PURE__*/React__default.createElement(Button, {
      className: "plc-mt-6",
      onClick: onClose,
      autoFocus: true
    }, t("continue")));
  }
  return null;
};
const getCurrentFlow = () => {
  const {
    product,
    giftRecipient,
    giftCode,
    invoice
  } = usePelcro.getStore();
  if (invoice) {
    return "invoicePayment";
  } else if (giftRecipient) {
    return "giftCreate";
  } else if (giftCode) {
    return "giftRedeem";
  } else if (product) {
    return "subscriptionSuccess";
  }
};
const getSuccessContent = i18n => {
  var _product$paywall, _product$paywall2;
  const flow = getCurrentFlow();
  const {
    product
  } = usePelcro.getStore();
  const wordingDictionary = {
    subscriptionSuccess: {
      successIcon: /*#__PURE__*/React__default.createElement(SvgCheckSolid, {
        className: "plc-w-32 plc-my-4 plc-text-green-500"
      }),
      successTitle: product === null || product === void 0 ? void 0 : (_product$paywall = product.paywall) === null || _product$paywall === void 0 ? void 0 : _product$paywall.success_title,
      successContent: product === null || product === void 0 ? void 0 : (_product$paywall2 = product.paywall) === null || _product$paywall2 === void 0 ? void 0 : _product$paywall2.success_content
    },
    giftCreate: {
      successIcon: /*#__PURE__*/React__default.createElement(SvgGift, {
        className: "plc-w-32 plc-my-4 plc-text-gray-500"
      }),
      successTitle: i18n("messages.giftCreate.title"),
      successContent: i18n("messages.giftCreate.content")
    },
    giftRedeem: {
      successIcon: /*#__PURE__*/React__default.createElement(SvgCheckSolid, {
        className: "plc-w-32 plc-my-4 plc-text-green-500"
      }),
      successTitle: i18n("messages.giftRedeem.title"),
      successContent: i18n("messages.giftRedeem.content")
    },
    invoicePayment: {
      successIcon: /*#__PURE__*/React__default.createElement(SvgCheckSolid, {
        className: "plc-w-32 plc-my-4 plc-text-green-500"
      }),
      successTitle: i18n("messages.invoicePayment.title"),
      successContent: i18n("messages.invoicePayment.content")
    }
  };
  return wordingDictionary[flow];
};

/**
 *
 */
function PaymentSuccessModal(_ref) {
  let {
    onDisplay,
    ...props
  } = _ref;
  const {
    resetView
  } = usePelcro();
  const onClose = () => {
    var _props$onClose;
    (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
    return resetView();
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-subscription-success-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(PaymentSuccessView, {
    onClose: onClose
  })), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
}
PaymentSuccessModal.viewId = "subscription-success";

/**
 *
 */
function NewsletterWithHook(props) {
  React__default.useEffect(() => {
    var _props$onDisplay;
    (_props$onDisplay = props.onDisplay) === null || _props$onDisplay === void 0 ? void 0 : _props$onDisplay.call(props);
  }, []);
  const {
    switchView,
    resetView,
    product
  } = usePelcro();
  return /*#__PURE__*/React__default.createElement(NewsLetter, {
    onClose: () => {
      var _props$onClose;
      (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
      resetView();
    },
    onSuccess: props.onSuccess,
    onFailure: props.onFailure,
    setView: switchView,
    product: product
  });
}
NewsletterWithHook.viewId = "newsletter";
class DefaultNewsLetter extends Component {
  constructor(props) {
    var _this$props$product, _this$props$product$p, _this$props$product2, _this$props$product2$;
    super(props);
    _defineProperty$3(this, "componentDidMount", () => {
      document.addEventListener("keydown", this.handleSubmit);
    });
    _defineProperty$3(this, "componentWillUnmount", () => {
      document.removeEventListener("keydown", this.handleSubmit);
    });
    _defineProperty$3(this, "handleSubmit", e => {
      if (e.key === "Enter" && !this.state.disableSubmit) this.submitNewsletter();
    });
    _defineProperty$3(this, "displayLoginView", () => {
      this.props.setView("login");
    });
    _defineProperty$3(this, "displaySelectView", () => {
      this.props.setView("plan-select");
    });
    _defineProperty$3(this, "submitNewsletter", () => {
      this.setState({
        disableSubmit: true
      });
      window.Pelcro.newsletter.create({
        first_name: this.state.firstName,
        last_name: this.state.lastName,
        email: this.state.email,
        postal_code: this.state.postalCode,
        source: "web",
        lists: "default",
        consent_url: window.location.href,
        consent_text: this.subtitle,
        consent_type: "explicit"
      }, (err, res) => {
        var _this$props$onSuccess, _this$props2;
        this.setState({
          disableSubmit: false
        });
        if (err) {
          var _this$props$onFailure, _this$props;
          (_this$props$onFailure = (_this$props = this.props).onFailure) === null || _this$props$onFailure === void 0 ? void 0 : _this$props$onFailure.call(_this$props, err);
          return this.setState({
            alert: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
        }
        (_this$props$onSuccess = (_this$props2 = this.props).onSuccess) === null || _this$props$onSuccess === void 0 ? void 0 : _this$props$onSuccess.call(_this$props2, res);
        try {
          this.postSubmit();
        } catch {
          this.props.setView("meter");
        }
      });
    });
    _defineProperty$3(this, "postSubmit", () => {
      window.Pelcro.paywall.setNewsletterExtraVisits(true);
      this.props.setView("meter");
    });
    _defineProperty$3(this, "onEmailChange", event => {
      this.setState({
        email: event.target.value
      });
    });
    _defineProperty$3(this, "onFirstNameChange", event => {
      this.setState({
        firstName: event.target.value
      });
    });
    _defineProperty$3(this, "onLastNameChange", event => {
      this.setState({
        lastName: event.target.value
      });
    });
    _defineProperty$3(this, "onPostalCodeChange", event => {
      this.setState({
        postalCode: event.target.value
      });
    });
    this.state = {
      disableSubmit: false,
      email: "",
      firstName: "",
      lastName: "",
      postalCode: "",
      alert: {
        type: "error",
        content: ""
      }
    };
    this.product = this.props.product || window.Pelcro.paywall.getProduct();
    this.closeButton = window.Pelcro.paywall.displayCloseButton();
    const {
      t
    } = this.props;
    this.title = this.props.product ? (_this$props$product = this.props.product) === null || _this$props$product === void 0 ? void 0 : (_this$props$product$p = _this$props$product.paywall) === null || _this$props$product$p === void 0 ? void 0 : _this$props$product$p.newsletter_title : t("title");
    this.subtitle = this.props.product ? (_this$props$product2 = this.props.product) === null || _this$props$product2 === void 0 ? void 0 : (_this$props$product2$ = _this$props$product2.paywall) === null || _this$props$product2$ === void 0 ? void 0 : _this$props$product2$.newsletter_subtitle : t("subtitle");
  }
  render() {
    const {
      t
    } = this.props;
    return /*#__PURE__*/React__default.createElement(Modal, {
      hideCloseButton: !this.closeButton,
      onClose: this.props.onClose,
      id: "pelcro-newsletter-modal"
    }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement("div", {
      id: "pelcro-newsletter-view"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
    }, /*#__PURE__*/React__default.createElement("h4", {
      className: "plc-text-2xl plc-font-semibold"
    }, this.title), /*#__PURE__*/React__default.createElement("p", null, this.subtitle)), /*#__PURE__*/React__default.createElement("form", {
      action: "javascript:void(0);",
      className: "plc-mt-2 pelcro-form"
    }, this.state.alert.content && /*#__PURE__*/React__default.createElement(Alert, {
      type: this.state.alert.type
    }, this.state.alert.content), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-flex plc-items-start"
    }, /*#__PURE__*/React__default.createElement(Input, {
      value: this.state.first_name,
      onChange: this.onFirstNameChange,
      autoComplete: "first-name",
      id: "pelcro-input-first-name",
      label: t("labels.firstName"),
      autoFocus: true
    }), /*#__PURE__*/React__default.createElement(Input, {
      wrapperClassName: "plc-ml-3",
      value: this.state.last_name,
      onChange: this.onLastNameChange,
      autoComplete: "last-name",
      id: "pelcro-input-last-name",
      label: t("labels.lastName")
    })), /*#__PURE__*/React__default.createElement(Input, {
      id: "pelcro-input-email",
      errorId: "pelcro-input-email-error",
      onChange: this.onEmailChange,
      type: "email",
      label: t("labels.email"),
      required: true
    }), /*#__PURE__*/React__default.createElement(Input, {
      value: this.state.postal_code,
      onChange: this.onPostalCodeChange,
      autoComplete: "postal-code",
      id: "pelcro-input-postal-code",
      errorId: "pelcro-input-postal-code-error",
      label: t("labels.postalCode")
    }), /*#__PURE__*/React__default.createElement("p", {
      className: "plc-text-gray-900 pelcro-footnote"
    }, "* ", t("labels.required")), /*#__PURE__*/React__default.createElement(Button, {
      role: "submit",
      className: "plc-w-full plc-mt-2",
      id: "pelcro-submit",
      onClick: this.submitNewsletter,
      disabled: this.state.disableSubmit,
      isLoading: this.state.disableSubmit
    }, t("labels.submit"))))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement("p", null, t("messages.alreadyHaveAccount") + " ", /*#__PURE__*/React__default.createElement(Link, {
      onClick: this.displayLoginView
    }, t("messages.loginHere"))), /*#__PURE__*/React__default.createElement("p", null, t("messages.createAnAccount"), /*#__PURE__*/React__default.createElement(Link, {
      onClick: this.displaySelectView
    }, t("messages.here"))), /*#__PURE__*/React__default.createElement(Authorship, null)));
  }
}
const NewsLetter = withTranslation("newsletter")(DefaultNewsLetter);

const initialState$i = {
  didSubToNewslettersBefore: false,
  newsletters: [],
  isListLoading: true,
  isSubmitting: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$i = /*#__PURE__*/createContext(initialState$i);
const {
  Provider: Provider$i
} = store$i;
const NewsletterUpdateContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children
  } = _ref;
  const [t] = useTranslation("newsletter");
  const handleSubmit = (_ref2, dispatch) => {
    var _window$Pelcro$user$r, _window$Pelcro$user$r2;
    let {
      newsletters,
      didSubToNewslettersBefore
    } = _ref2;
    const callback = (err, res) => {
      dispatch({
        type: LOADING,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        if (!didSubToNewslettersBefore) {
          dispatch({
            type: SWITCH_TO_UPDATE
          });
        }
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("messages.success")
          }
        });
        onSuccess(res);
      }
    };
    const requestData = {
      email: (_window$Pelcro$user$r = (_window$Pelcro$user$r2 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r2 === void 0 ? void 0 : _window$Pelcro$user$r2.email) !== null && _window$Pelcro$user$r !== void 0 ? _window$Pelcro$user$r : window.Pelcro.helpers.getURLParameter("email"),
      source: "web",
      lists: newsletters.filter(newsletter => newsletter.selected).map(newsletter => newsletter.id).join(",")
    };
    if (didSubToNewslettersBefore) {
      window.Pelcro.newsletter.update(requestData, callback);
    } else {
      window.Pelcro.newsletter.create(requestData, callback);
    }
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case GET_NEWSLETTERS_FETCH:
        return lib_7({
          ...state,
          isListLoading: true
        });
      case GET_NEWSLETTERS_SUCCESS:
        return lib_7({
          ...state,
          newsletters: action.payload.newsletters,
          didSubToNewslettersBefore: action.payload.didSubToNewslettersBefore,
          isListLoading: false
        });
      case SET_SELECT:
        return lib_7({
          ...state,
          newsletters: state.newsletters.map(newsletter => {
            if (newsletter.id === action.payload) {
              return {
                ...newsletter,
                selected: !newsletter.selected
              };
            }
            return newsletter;
          })
        });
      case SWITCH_TO_UPDATE:
        return lib_7({
          ...state,
          didSubToNewslettersBefore: true
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case LOADING:
        return lib_7({
          ...state,
          isSubmitting: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          isSubmitting: true
        }, (state, dispatch) => handleSubmit(state, dispatch));
      default:
        return state;
    }
  }, initialState$i);
  useEffect(() => {
    const getUserNewsletters = () => {
      var _window$Pelcro$user$r3, _window$Pelcro$user$r4;
      dispatch({
        type: GET_NEWSLETTERS_FETCH
      });
      const email = (_window$Pelcro$user$r3 = (_window$Pelcro$user$r4 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r4 === void 0 ? void 0 : _window$Pelcro$user$r4.email) !== null && _window$Pelcro$user$r3 !== void 0 ? _window$Pelcro$user$r3 : window.Pelcro.helpers.getURLParameter("email");
      window.Pelcro.newsletter.getByEmail(email, (err, res) => {
        var _window$Pelcro$uiSett, _window$Pelcro, _window$Pelcro$uiSett2, _res$data$lists$split, _res$data$lists;
        if (err) {
          return dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
        }
        const newsletters = (_window$Pelcro$uiSett = (_window$Pelcro = window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett2 = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett2 === void 0 ? void 0 : _window$Pelcro$uiSett2.newsletters) !== null && _window$Pelcro$uiSett !== void 0 ? _window$Pelcro$uiSett : [];
        const selectedNewsletters = (_res$data$lists$split = (_res$data$lists = res.data.lists) === null || _res$data$lists === void 0 ? void 0 : _res$data$lists.split(",")) !== null && _res$data$lists$split !== void 0 ? _res$data$lists$split : [];
        const allNewslettersWithSelectedField = newsletters.map(newsletter => ({
          ...newsletter,
          id: String(newsletter.id),
          selected: selectedNewsletters.includes(String(newsletter.id))
        }));
        dispatch({
          type: GET_NEWSLETTERS_SUCCESS,
          payload: {
            newsletters: allNewslettersWithSelectedField,
            didSubToNewslettersBefore: Boolean(res.data.email)
          }
        });
      });
    };
    getUserNewsletters();
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-newsletter-update-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$i, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => {
    if (child) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        store: store$i,
        key: i
      });
    }
  }) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$i
  })));
};

const NewsletterUpdateButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      isSubmitting,
      isListLoading
    }
  } = useContext(store$i);
  const {
    t
  } = useTranslation("newsletter");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: isListLoading,
    isLoading: isSubmitting
  }, otherProps), name !== null && name !== void 0 ? name : t("labels.submit"));
};

const NewsletterUpdateList = () => {
  const handleSelectNewsletter = event => {
    dispatch({
      type: SET_SELECT,
      payload: event.target.value
    });
  };
  const {
    dispatch,
    state: {
      newsletters,
      isListLoading
    }
  } = useContext(store$i);
  if (isListLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, {
      width: 60,
      height: 100
    });
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-max-h-80 plc-overflow-y-auto pelcro-newsletters-wrapper"
  }, newsletters.map(newsletter => /*#__PURE__*/React__default.createElement("div", {
    key: newsletter.id,
    className: "plc-p-2 plc-mx-3 plc-mt-2 plc-border plc-border-gray-400 plc-border-solid plc-rounded plc-text-gray-900 pelcro-newsletter-wrapper"
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    className: "pelcro-select-newsletter-checkbox",
    labelClassName: "plc-cursor-pointer plc-w-full",
    id: `pelcro-newsletter-update-${newsletter.id}`,
    checked: newsletter.selected,
    value: newsletter.id,
    onChange: handleSelectNewsletter
  }, newsletter.label))));
};

const NewsletterUpdateView = props => {
  const {
    t
  } = useTranslation("newsletter");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-newsletter-update-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("updateTitle"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(NewsletterUpdateContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement(NewsletterUpdateList, null), /*#__PURE__*/React__default.createElement(NewsletterUpdateButton, {
    role: "submit",
    className: "plc-mt-4 plc-w-full",
    name: t("labels.submit"),
    id: "pelcro-submit"
  }))));
};

const NewsletterUpdateModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-newsletter-update-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(NewsletterUpdateView, otherProps)), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
NewsletterUpdateModal.viewId = "newsletter-update";

const MeterView = () => {
  var _paywallProduct$paywa, _paywallProduct$paywa2;
  const {
    t
  } = useTranslation("meter");
  const {
    switchView,
    product,
    isAuthenticated
  } = usePelcro();
  const paywallProduct = product !== null && product !== void 0 ? product : window.Pelcro.paywall.getProduct();
  const visitsLeft = window.Pelcro.paywall.freeVisitsLeft();
  const title = `${paywallProduct === null || paywallProduct === void 0 ? void 0 : (_paywallProduct$paywa = paywallProduct.paywall) === null || _paywallProduct$paywa === void 0 ? void 0 : _paywallProduct$paywa.meter_title}: ${visitsLeft}`;
  const subtitle = paywallProduct === null || paywallProduct === void 0 ? void 0 : (_paywallProduct$paywa2 = paywallProduct.paywall) === null || _paywallProduct$paywa2 === void 0 ? void 0 : _paywallProduct$paywa2.meter_subtitle;
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-mb-2 plc-text-2xl plc-font-semibold plc-text-gray-600"
  }, title), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-text-sm plc-text-gray-600"
  }, subtitle, " ", /*#__PURE__*/React__default.createElement(Link, {
    className: "plc-ml-1",
    onClick: () => switchView("plan-select")
  }, t("messages.subscribeNow")), !isAuthenticated() && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", null, t("messages.alreadyHaveAccount") + " ", /*#__PURE__*/React__default.createElement(Link, {
    className: "plc-ml-1",
    onClick: () => switchView("login")
  }, t("messages.loginHere"))))));
};

// Meter view.
const MeterModal = props => {
  const {
    resetView
  } = usePelcro();
  useEffect(() => {
    var _props$onDisplay;
    (_props$onDisplay = props.onDisplay) === null || _props$onDisplay === void 0 ? void 0 : _props$onDisplay.call(props);
  }, []);
  const onClose = () => {
    var _props$onClose;
    (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
    resetView();
  };
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-view-meter-modal",
    className: "plc-fixed plc-bottom-0 plc-right-0 plc-w-full plc-p-4 plc-bg-white plc-border-t-4 plc-rounded plc-shadow-md motion-safe:plc-animate-slideInBottom sm:plc-m-4 sm:plc-max-w-md plc-z-max plc-border-primary-500"
  }, /*#__PURE__*/React__default.createElement("button", {
    type: "button",
    className: "plc-absolute plc-top-0 plc-text-2xl plc-text-gray-500 hover:plc-text-black focus:plc-text-black plc-right-1 plc-border-0 plc-bg-transparent hover:plc-bg-transparent focus:plc-bg-transparent pelcro-close-btn",
    "aria-label": "Close",
    onClick: onClose
  }, /*#__PURE__*/React__default.createElement("span", null, "\xD7")), /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement(MeterView, props)));
};
MeterModal.viewId = "meter";

const SubscriptionCreateView = _ref => {
  var _window$Pelcro, _window$Pelcro$uiSett, _product$paywall$subs, _product$paywall, _window$Pelcro$paywal, _product$paywall$subs2, _product$paywall2, _window$Pelcro$paywal2;
  let {
    onSuccess = () => {},
    onFailure = () => {}
  } = _ref;
  const {
    t
  } = useTranslation("checkoutForm");
  const {
    product,
    plan
  } = usePelcro();
  const skipPayment = (_window$Pelcro = window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.skipPaymentForFreePlans;
  const showSubscriptionButton = skipPayment && (plan === null || plan === void 0 ? void 0 : plan.amount) === 0;
  const getPricingText = plan => {
    var _plan$quantity;
    const autoRenewed = plan.auto_renew;
    const {
      interval_translated,
      interval_count
    } = plan;
    const intervalText = t("labels.interval", {
      interval: interval_translated,
      count: interval_count
    });
    const priceFormatted = getFormattedPriceByLocal((plan === null || plan === void 0 ? void 0 : plan.amount) * ((_plan$quantity = plan === null || plan === void 0 ? void 0 : plan.quantity) !== null && _plan$quantity !== void 0 ? _plan$quantity : 1), plan === null || plan === void 0 ? void 0 : plan.currency, getPageOrDefaultLanguage());
    return /*#__PURE__*/React__default.createElement("p", {
      className: "plc-text-gray-600"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "plc-tracking-wider plc-uppercase"
    }, plan.nickname), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
      className: "plc-text-xl plc-font-semibold plc-text-primary-600"
    }, priceFormatted, " "), /*#__PURE__*/React__default.createElement("span", {
      className: "plc-font-thin"
    }, autoRenewed ? "/" : t("labels.for"), " ", intervalText));
  };
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-subscription-create-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-flex-col plc-items-center plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper sm:plc-px-8"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold "
  }, (_product$paywall$subs = product === null || product === void 0 ? void 0 : (_product$paywall = product.paywall) === null || _product$paywall === void 0 ? void 0 : _product$paywall.subscribe_title) !== null && _product$paywall$subs !== void 0 ? _product$paywall$subs : (_window$Pelcro$paywal = window.Pelcro.paywall.read()) === null || _window$Pelcro$paywal === void 0 ? void 0 : _window$Pelcro$paywal.subscribe_title), " ", /*#__PURE__*/React__default.createElement("p", null, (_product$paywall$subs2 = product === null || product === void 0 ? void 0 : (_product$paywall2 = product.paywall) === null || _product$paywall2 === void 0 ? void 0 : _product$paywall2.subscribe_subtitle) !== null && _product$paywall$subs2 !== void 0 ? _product$paywall$subs2 : (_window$Pelcro$paywal2 = window.Pelcro.paywall.read()) === null || _window$Pelcro$paywal2 === void 0 ? void 0 : _window$Pelcro$paywal2.subscribe_subtitle), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-w-full plc-p-2 plc-mt-2 plc-font-semibold plc-text-center plc-text-gray-900 plc-bg-gray-100 plc-border plc-border-gray-200"
  }, plan && getPricingText(plan))), /*#__PURE__*/React__default.createElement(PaymentMethodView, {
    type: "createPayment",
    showCoupon: true,
    showExternalPaymentMethods: true,
    showApplePayButton: true,
    onSuccess: onSuccess,
    onFailure: onFailure,
    showSubscriptionButton: showSubscriptionButton
  }));
};

/**
 *
 */
function SubscriptionCreateModal(_ref) {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  useTranslation("common");
  const {
    switchView
  } = usePelcro();
  const onSuccess = res => {
    var _otherProps$onSuccess;
    (_otherProps$onSuccess = otherProps.onSuccess) === null || _otherProps$onSuccess === void 0 ? void 0 : _otherProps$onSuccess.call(otherProps, res);
    trackSubscriptionOnGA();
    return switchView("subscription-success");
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-subscription-create-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(SubscriptionCreateView, Object.assign({}, otherProps, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
}
SubscriptionCreateModal.viewId = "subscription-create";

const initialState$h = {
  emails: "",
  emailsError: null,
  buttonDisabled: false,
  removeMemberId: null,
  members: [],
  loading: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$h = /*#__PURE__*/createContext(initialState$h);
const {
  Provider: Provider$h
} = store$h;
const SubscriptionManageMembersContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children
  } = _ref;
  const {
    subscriptionToManageMembers
  } = usePelcro();
  const subscription_id = subscriptionToManageMembers === null || subscriptionToManageMembers === void 0 ? void 0 : subscriptionToManageMembers.id;
  const handleListMembers = (_ref2, dispatch) => {
    var _window$Pelcro, _window$Pelcro$user, _window$Pelcro$user$r;
    window.Pelcro.subscription.listMembers({
      auth_token: (_window$Pelcro = window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$user = _window$Pelcro.user) === null || _window$Pelcro$user === void 0 ? void 0 : (_window$Pelcro$user$r = _window$Pelcro$user.read()) === null || _window$Pelcro$user$r === void 0 ? void 0 : _window$Pelcro$user$r.auth_token,
      subscription_id
    }, (err, res) => {
      dispatch({
        type: UPDATE_INVITE_BUTTON,
        payload: false
      });
      dispatch({
        type: LOADING,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        dispatch({
          type: UPDATE_MEMBERS,
          payload: res.data
        });
        onSuccess(res);
      }
    });
  };
  const handleInviteMembers = (_ref3, dispatch) => {
    var _window$Pelcro2, _window$Pelcro2$user, _window$Pelcro2$user$;
    let {
      emails
    } = _ref3;
    const emailsArr = emails.split(",");
    window.Pelcro.subscription.inviteMembers({
      auth_token: (_window$Pelcro2 = window.Pelcro) === null || _window$Pelcro2 === void 0 ? void 0 : (_window$Pelcro2$user = _window$Pelcro2.user) === null || _window$Pelcro2$user === void 0 ? void 0 : (_window$Pelcro2$user$ = _window$Pelcro2$user.read()) === null || _window$Pelcro2$user$ === void 0 ? void 0 : _window$Pelcro2$user$.auth_token,
      subscription_id,
      emails: emailsArr
    }, (err, res) => {
      dispatch({
        type: UPDATE_INVITE_BUTTON,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        dispatch({
          type: HANDLE_LIST_MEMBERS
        });
        onSuccess(res);
      }
    });
  };
  const handleRemoveMember = (_ref4, dispatch) => {
    var _window$Pelcro3, _window$Pelcro3$user, _window$Pelcro3$user$;
    let {
      removeMemberId
    } = _ref4;
    window.Pelcro.subscription.removeMember({
      auth_token: (_window$Pelcro3 = window.Pelcro) === null || _window$Pelcro3 === void 0 ? void 0 : (_window$Pelcro3$user = _window$Pelcro3.user) === null || _window$Pelcro3$user === void 0 ? void 0 : (_window$Pelcro3$user$ = _window$Pelcro3$user.read()) === null || _window$Pelcro3$user$ === void 0 ? void 0 : _window$Pelcro3$user$.auth_token,
      subscription_id,
      id: removeMemberId
    }, (err, res) => {
      dispatch({
        type: UPDATE_REMOVE_MEMBER_ID,
        payload: null
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        dispatch({
          type: HANDLE_LIST_MEMBERS
        });
        onSuccess(res);
      }
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SET_EMAILS:
        return lib_7({
          ...state,
          emails: action.payload,
          emailsError: null
        });
      case SET_EMAILS_ERROR:
        return lib_7({
          ...state,
          emailsError: action.payload,
          emails: ""
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case LOADING:
        return lib_7({
          ...state,
          loading: action.payload
        });
      case UPDATE_MEMBERS:
        return lib_7({
          ...state,
          members: action.payload
        });
      case UPDATE_REMOVE_MEMBER_ID:
        return lib_7({
          ...state,
          removeMemberId: action.payload
        });
      case UPDATE_INVITE_BUTTON:
        return lib_7({
          ...state,
          buttonDisabled: action.payload
        });
      case HANDLE_LIST_MEMBERS:
        return lib_5({
          ...state,
          loading: true
        }, (state, dispatch) => handleListMembers(state, dispatch));
      case HANDLE_INVITE_MEMBERS:
        return lib_5({
          ...state,
          buttonDisabled: true
        }, (state, dispatch) => handleInviteMembers(state, dispatch));
      case HANDLE_REMOVE_MEMBER:
        return lib_5({
          ...state
        }, (state, dispatch) => handleRemoveMember(state, dispatch));
      default:
        return state;
    }
  }, initialState$h);
  useEffect(() => {
    dispatch({
      type: HANDLE_LIST_MEMBERS
    });
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-manage-members-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$h, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => {
    if (child) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        store: store$h,
        key: i
      });
    }
  }) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$h
  })));
};

const SubscriptionManageMembersButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    state: {
      emailsError,
      emails,
      buttonDisabled
    },
    dispatch
  } = useContext(store$h);
  const {
    t
  } = useTranslation("subscriptionManageMembers");
  const [isDisabled, setDisabled] = useState(true);
  useEffect(() => {
    setDisabled(emailsError || !emails.length || buttonDisabled);
  }, [emailsError, emails, buttonDisabled]);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_INVITE_MEMBERS
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: isDisabled,
    isLoading: buttonDisabled
  }, otherProps), name !== null && name !== void 0 ? name : t("labels.invite"));
};

function SubscriptionManageMembersEmails(props) {
  const {
    t
  } = useTranslation("common");
  const {
    dispatch,
    state: {
      emails: stateEmails,
      emailsError
    }
  } = useContext(store$h);
  const [emails, setEmails] = useState(stateEmails);
  const [finishedTyping, setFinishedTyping] = useState(false);
  const handleInputChange = useCallback(value => {
    setEmails(value);
    if (emails.length) {
      dispatch({
        type: SET_EMAILS,
        payload: emails
      });
    } else if (finishedTyping) {
      dispatch({
        type: SET_EMAILS_ERROR,
        payload: t("validation.enterEmails")
      });
    }
  }, [dispatch, emails, finishedTyping]);
  useEffect(() => {
    handleInputChange(emails);
  }, [finishedTyping, emails, handleInputChange]);
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    error: emailsError,
    value: emails,
    onChange: e => handleInputChange(e.target.value),
    onBlur: () => setFinishedTyping(true),
    onFocus: () => setFinishedTyping(false)
  }, props));
}

var _path$j;
function _extends$k() { _extends$k = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$k.apply(this, arguments); }
function SvgCheckMark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$k({
    className: "plc-w-4 plc-h-4 plc-mr-1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path$j || (_path$j = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z",
    clipRule: "evenodd"
  })));
}

function SubscriptionManageMembersList(props) {
  const {
    t
  } = useTranslation("subscriptionManageMembers");
  const {
    dispatch,
    state: {
      members,
      removeMemberId,
      loading
    }
  } = useContext(store$h);
  const getMemberStatus = useCallback(sub => {
    if (sub.status === "pending") {
      return {
        title: sub.status,
        content: sub.status,
        textColor: "plc-text-yellow-500",
        bgColor: "plc-bg-yellow-100",
        icon: /*#__PURE__*/React__default.createElement(SvgExclamation, null)
      };
    }
    return {
      title: sub.status,
      content: sub.status,
      textColor: "plc-text-green-700",
      bgColor: "plc-bg-green-100",
      icon: /*#__PURE__*/React__default.createElement(SvgCheckMark, null)
    };
  }, []);
  const showMemberData = useCallback(member => {
    var _member$customer, _member$customer2, _member$customer3, _member$customer4;
    let data;
    if ((member === null || member === void 0 ? void 0 : member.status) !== "active") {
      data = member === null || member === void 0 ? void 0 : member.invitation_email;
      return data;
    }
    data = (member === null || member === void 0 ? void 0 : (_member$customer = member.customer) === null || _member$customer === void 0 ? void 0 : _member$customer.email) || (member === null || member === void 0 ? void 0 : (_member$customer2 = member.customer) === null || _member$customer2 === void 0 ? void 0 : _member$customer2.first_name) + " " + (member === null || member === void 0 ? void 0 : (_member$customer3 = member.customer) === null || _member$customer3 === void 0 ? void 0 : _member$customer3.last_name) || (member === null || member === void 0 ? void 0 : (_member$customer4 = member.customer) === null || _member$customer4 === void 0 ? void 0 : _member$customer4.username) || "-----";
    return data;
  }, []);
  if (loading) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-animate-pulse"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-bg-gray-200 plc-h-6 plc-m-0.5 plc-rounded"
    }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-animate-pulse"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-bg-gray-200 plc-h-6 plc-m-0.5 plc-rounded"
    }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-animate-pulse"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-bg-gray-200 plc-h-6 plc-m-0.5 plc-rounded"
    })))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-animate-pulse"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-bg-gray-200 plc-h-6 plc-m-0.5 plc-rounded"
    }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-animate-pulse"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-bg-gray-200 plc-h-6 plc-m-0.5 plc-rounded"
    }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-animate-pulse"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-bg-gray-200 plc-h-6 plc-m-0.5 plc-rounded"
    })))));
  }
  const onRemoveClick = id => {
    dispatch({
      type: UPDATE_REMOVE_MEMBER_ID,
      payload: id
    });
    dispatch({
      type: HANDLE_REMOVE_MEMBER
    });
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, members === null || members === void 0 ? void 0 : members.map(member => /*#__PURE__*/React__default.createElement("tr", {
    key: member.id,
    className: `plc-w-full plc-align-middle plc-cursor-pointer accordion-header hover:plc-bg-gray-50 plc-text-center`
  }, /*#__PURE__*/React__default.createElement("td", {
    className: "plc-truncate plc-text-left",
    title: showMemberData(member)
  }, /*#__PURE__*/React__default.createElement("span", {
    className: "plc-font-semibold plc-text-gray-500"
  }, showMemberData(member))), /*#__PURE__*/React__default.createElement("td", {
    className: "plc-py-2"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: `plc-inline-flex plc-p-1 plc-text-xs plc-font-semibold ${getMemberStatus(member).bgColor} plc-uppercase ${getMemberStatus(member).textColor} plc-rounded-lg`
  }, getMemberStatus(member).icon, getMemberStatus(member).title)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Button, {
    variant: "ghost",
    className: "plc-text-red-500 focus:plc-ring-red-500 pelcro-dashboard-sub-cancel-button",
    icon: /*#__PURE__*/React__default.createElement(SvgXIconSolid, null),
    onClick: () => onRemoveClick(member.id),
    disabled: member.id === removeMemberId,
    isLoading: member.id === removeMemberId,
    "data-key": member.id
  }, t("labels.remove"))))));
}

/**
 *
 */
function SubscriptionManageMembersView(props) {
  const {
    t
  } = useTranslation("subscriptionManageMembers");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-login-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-font-semibold plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl"
  }, t("labels.inviteMembers")), /*#__PURE__*/React__default.createElement("p", null, t("labels.listNote"), " 'john@example.com,jane@example.com'")), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(SubscriptionManageMembersContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement(SubscriptionManageMembersEmails, {
    id: "pelcro-input-email",
    errorId: "pelcro-input-emails-error",
    required: true,
    label: t("labels.emails")
  }), /*#__PURE__*/React__default.createElement(SubscriptionManageMembersButton, {
    role: "submit",
    className: "plc-w-full",
    id: "pelcro-submit"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mt-1"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-justify-between "
  }, /*#__PURE__*/React__default.createElement("hr", {
    className: "plc-w-full plc-border-gray-300"
  }), /*#__PURE__*/React__default.createElement("span", {
    className: "plc-flex-shrink-0 plc-p-2 plc-text-xs plc-text-gray-400 plc-uppercase"
  }, t("labels.listOfMembers")), /*#__PURE__*/React__default.createElement("hr", {
    className: "plc-w-full plc-border-gray-300"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-max-h-48 plc-overflow-x-hidden plc-overflow-y-auto"
  }, /*#__PURE__*/React__default.createElement("table", {
    className: "plc-w-full plc-table-fixed plc-text-center plc-p-2 plc-m-1"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "plc-text-xs plc-font-semibold plc-tracking-wider plc-text-gray-400 plc-uppercase "
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-6/12"
  }, t("labels.email")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-3/12 "
  }, t("labels.status")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-3/12 "
  }, t("labels.actions")))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement(SubscriptionManageMembersList, null))))))));
}

/**
 *
 */
function SubscriptionManageMembersModal(_ref) {
  let {
    onDisplay,
    onClose,
    ...props
  } = _ref;
  const onSuccess = res => {
    var _props$onSuccess;
    (_props$onSuccess = props.onSuccess) === null || _props$onSuccess === void 0 ? void 0 : _props$onSuccess.call(props, res);
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-manage-members-modal",
    onDisplay: onDisplay,
    onClose: onClose,
    className: "plc-max-w-xl"
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(SubscriptionManageMembersView, Object.assign({}, props, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
}
SubscriptionManageMembersModal.viewId = "manage-members";

var _window$Pelcro$user$r, _window$Pelcro$user$r2, _window$Pelcro$user$r3, _window$Pelcro$user$r4, _window$Pelcro$user$r5, _window$Pelcro$user$r6, _window$Pelcro$user$r7;
const initialState$g = {
  email: (_window$Pelcro$user$r = window.Pelcro.user.read()) === null || _window$Pelcro$user$r === void 0 ? void 0 : _window$Pelcro$user$r.email,
  emailError: null,
  firstName: (_window$Pelcro$user$r2 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r2 === void 0 ? void 0 : _window$Pelcro$user$r2.first_name,
  firstNameError: null,
  lastName: (_window$Pelcro$user$r3 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r3 === void 0 ? void 0 : _window$Pelcro$user$r3.last_name,
  lastNameError: null,
  username: (_window$Pelcro$user$r4 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r4 === void 0 ? void 0 : _window$Pelcro$user$r4.username,
  usernameError: null,
  displayName: (_window$Pelcro$user$r5 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r5 === void 0 ? void 0 : _window$Pelcro$user$r5.display_name,
  phone: (_window$Pelcro$user$r6 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r6 === void 0 ? void 0 : _window$Pelcro$user$r6.phone,
  phoneError: null,
  tin: (_window$Pelcro$user$r7 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r7 === void 0 ? void 0 : _window$Pelcro$user$r7.tin,
  buttonDisabled: false,
  textFields: {},
  alert: {
    type: "error",
    content: ""
  }
};
const store$g = /*#__PURE__*/createContext(initialState$g);
const {
  Provider: Provider$g
} = store$g;
const UserUpdateContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children
  } = _ref;
  const {
    t
  } = useTranslation("userEdit");
  useEffect(() => {
    document.addEventListener("PelcroUserLoaded", () => {
      loadUserDataIntoFields();
    });
    loadUserDataIntoFields();
  }, []);
  const loadUserDataIntoFields = () => {
    var _window$Pelcro$user$r8, _window$Pelcro$user$r9, _window$Pelcro$user$r10, _window$Pelcro$user$r11, _window$Pelcro$user$r12, _window$Pelcro$user$r13, _window$Pelcro$user$r14;
    const fields = [{
      type: SET_EMAIL,
      payload: (_window$Pelcro$user$r8 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r8 === void 0 ? void 0 : _window$Pelcro$user$r8.email
    }, {
      type: SET_FIRST_NAME,
      payload: (_window$Pelcro$user$r9 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r9 === void 0 ? void 0 : _window$Pelcro$user$r9.first_name
    }, {
      type: SET_LAST_NAME,
      payload: (_window$Pelcro$user$r10 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r10 === void 0 ? void 0 : _window$Pelcro$user$r10.last_name
    }, {
      type: SET_USERNAME,
      payload: (_window$Pelcro$user$r11 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r11 === void 0 ? void 0 : _window$Pelcro$user$r11.username
    }, {
      type: SET_DISPLAY_NAME,
      payload: (_window$Pelcro$user$r12 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r12 === void 0 ? void 0 : _window$Pelcro$user$r12.display_name
    }, {
      type: SET_PHONE,
      payload: (_window$Pelcro$user$r13 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r13 === void 0 ? void 0 : _window$Pelcro$user$r13.phone
    }, {
      type: SET_TIN,
      payload: (_window$Pelcro$user$r14 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r14 === void 0 ? void 0 : _window$Pelcro$user$r14.tin
    }];
    fields.filter(field => Boolean(field.payload)).forEach(field => {
      dispatch(field);
    });
  };
  const handleUpdateUser = (_ref2, dispatch) => {
    let {
      email,
      firstName,
      lastName,
      username,
      phone,
      tin,
      textFields,
      displayName
    } = _ref2;
    window.Pelcro.user.update({
      auth_token: window.Pelcro.user.read().auth_token,
      email: email,
      first_name: firstName,
      last_name: lastName,
      ...(username && {
        username
      }),
      display_name: displayName,
      phone: phone,
      tin: tin,
      metadata: {
        updated: "updated",
        ...textFields
      }
    }, (err, res) => {
      dispatch({
        type: DISABLE_USER_UPDATE_BUTTON,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("messages.userUpdated")
          }
        });
        onSuccess(res);
      }
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SET_TEXT_FIELD:
        return lib_7({
          ...state,
          textFields: {
            ...state.textFields,
            ...action.payload
          }
        });
      case SET_EMAIL:
        return lib_7({
          ...state,
          email: action.payload,
          emailError: null
        });
      case SET_EMAIL_ERROR:
        return lib_7({
          ...state,
          emailError: action.payload,
          email: ""
        });
      case SET_FIRST_NAME:
        return lib_7({
          ...state,
          firstName: action.payload,
          firstNameError: null
        });
      case SET_FIRST_NAME_ERROR:
        return lib_7({
          ...state,
          firstNameError: action.payload,
          firstName: ""
        });
      case SET_DISPLAY_NAME:
        return lib_7({
          ...state,
          displayName: action.payload
        });
      case SET_LAST_NAME:
        return lib_7({
          ...state,
          lastName: action.payload,
          lastNameError: null
        });
      case SET_LAST_NAME_ERROR:
        return lib_7({
          ...state,
          lastNameError: action.payload,
          lastName: ""
        });
      case SET_USERNAME:
        return lib_7({
          ...state,
          username: action.payload,
          usernameError: null
        });
      case SET_USERNAME_ERROR:
        return lib_7({
          ...state,
          usernameError: action.payload,
          username: ""
        });
      case SET_PHONE:
        return lib_7({
          ...state,
          phone: action.payload,
          phoneError: null
        });
      case SET_TIN:
        return lib_7({
          ...state,
          tin: action.payload
        });
      case SET_PHONE_ERROR:
        return lib_7({
          ...state,
          phoneError: action.payload,
          phone: ""
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case DISABLE_USER_UPDATE_BUTTON:
        return lib_7({
          ...state,
          buttonDisabled: action.payload
        });
      case HANDLE_USER_UPDATE:
        return lib_5({
          ...state,
          buttonDisabled: true
        }, (state, dispatch) => handleUpdateUser(state, dispatch));
      default:
        return state;
    }
  }, initialState$g);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-user-update-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$g, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => {
    if (child) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        store: store$g,
        key: i
      });
    }
  }) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$g
  })));
};

var _path$i;
function _extends$j() { _extends$j = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$j.apply(this, arguments); }
function SvgEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$j({
    className: "plc-w-6 plc-h-6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path$i || (_path$i = /*#__PURE__*/React.createElement("path", {
    d: "M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zm-2.207 2.207L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"
  })));
}

const UserUpdateEmail = props => {
  const {
    dispatch,
    state: {
      email,
      emailError
    }
  } = useContext(store$g);
  const [enableEmailEdit, setEnableEmailEdit] = useState(false);
  const {
    t
  } = useTranslation("userEdit");
  const handleEnableEmailEdit = () => {
    if (enableEmailEdit) {
      dispatch({
        type: SET_EMAIL,
        payload: email
      });
      dispatch({
        type: SET_EMAIL_ERROR,
        payload: null
      });
      setEnableEmailEdit(false);
    } else {
      setEnableEmailEdit(true);
    }
  };
  return /*#__PURE__*/React__default.createElement("div", null, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start plc-relative"
  }, /*#__PURE__*/React__default.createElement(Email, Object.assign({
    disabled: !enableEmailEdit,
    store: store$g,
    label: t("labels.email"),
    enableEmailEdit: enableEmailEdit
  }, props)), /*#__PURE__*/React__default.createElement(Button, {
    variant: "icon",
    className: "plc-absolute  plc-rounded-none plc-text-gray-500 plc-w-10 plc-h-10 plc-top-7 plc-right-0 hover:plc-text-gray-900 hover:plc-bg-transparent focus:plc-ring-0 focus:plc-shadow-none",
    icon: enableEmailEdit ? /*#__PURE__*/React__default.createElement(SvgXIcon, {
      className: "plc-w-6"
    }) : /*#__PURE__*/React__default.createElement(SvgEdit, null),
    id: "pelcro-user-update-picture-button",
    onClick: handleEnableEmailEdit
  })));
};

const UserUpdateButton = _ref => {
  var _window$Pelcro$site$r;
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    state: {
      buttonDisabled,
      email,
      firstName,
      lastName,
      phone,
      emailError,
      firstNameError,
      lastNameError,
      phoneError
    },
    dispatch
  } = useContext(store$g);
  const supportsTap = Boolean((_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.tap_gateway_settings);
  const {
    t
  } = useTranslation("userEdit");
  const [isDisabled, setDisabled] = useState(true);
  useEffect(() => {
    setDisabled(buttonDisabled || emailError || !(email !== null && email !== void 0 && email.length) || supportsTap && firstNameError || supportsTap && lastNameError || supportsTap && phoneError || supportsTap && !(firstName !== null && firstName !== void 0 && firstName.length) || supportsTap && !(lastName !== null && lastName !== void 0 && lastName.length) || supportsTap && !(phone !== null && phone !== void 0 && phone.length));
  }, [email, firstName, lastName, phone, buttonDisabled, emailError, firstNameError, lastNameError, phoneError]);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_USER_UPDATE
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: isDisabled,
    isLoading: buttonDisabled && !emailError
  }, otherProps), name !== null && name !== void 0 ? name : t("labels.submit"));
};

function UpdateUserNameInput(_ref) {
  let {
    initWithUserName = true,
    store,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("common");
  const {
    dispatch,
    state: {
      username: stateUsername,
      usernameError
    }
  } = useContext(store);
  const [username, setUsername] = useState(stateUsername);
  const [finishedTyping, setFinishedTyping] = useState(false);
  const handleInputChange = useCallback(value => {
    setUsername(value);
    if (finishedTyping) {
      if (username !== null && username !== void 0 && username.length) {
        dispatch({
          type: SET_USERNAME,
          payload: username
        });
      } else {
        if (otherProps.required) {
          dispatch({
            type: SET_USERNAME_ERROR,
            payload: t("validation.enterUsername")
          });
        } else {
          dispatch({
            type: SET_USERNAME,
            payload: username
          });
        }
      }
    }
  }, [dispatch, username, finishedTyping]);
  useEffect(() => {
    handleInputChange(username);
  }, [finishedTyping, username, handleInputChange]);

  // Initialize username field with user's username
  const loadFirstNameIntoField = () => {
    handleInputChange(window.Pelcro.user.read().username);
    dispatch({
      type: SET_USERNAME,
      payload: window.Pelcro.user.read().username
    });
  };
  useEffect(() => {
    if (initWithUserName) {
      document.addEventListener("PelcroUserLoaded", () => {
        loadFirstNameIntoField();
      });
      loadFirstNameIntoField();
      return () => {
        document.removeEventListener("PelcroUserLoaded", handleInputChange);
      };
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    error: usernameError,
    value: username,
    onChange: e => handleInputChange(e.target.value),
    onBlur: () => setFinishedTyping(true),
    onFocus: () => setFinishedTyping(false)
  }, otherProps));
}

const UserUpdateUsername = props => /*#__PURE__*/React__default.createElement(UpdateUserNameInput, Object.assign({
  store: store$g
}, props));

const UserUpdateFirstName = props => /*#__PURE__*/React__default.createElement(FirstName, Object.assign({
  store: store$g
}, props));

const UserUpdateLastName = props => /*#__PURE__*/React__default.createElement(LastName, Object.assign({
  store: store$g
}, props));

const UserUpdatePhone = props => /*#__PURE__*/React__default.createElement(Phone, Object.assign({
  store: store$g
}, props));

var userSolidIcon = "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20class%3D%22plc-h-5%20plc-w-5%22%20viewBox%3D%220%200%2020%2020%22%20fill%3D%22white%22%3E%20%20%3Cpath%20transform%3D%22translate%280%2C2%29%22%20fill-rule%3D%22evenodd%22%20d%3D%22M10%209a3%203%200%20100-6%203%203%200%20000%206zm-7%209a7%207%200%201114%200H3z%22%20clip-rule%3D%22evenodd%22%20%2F%3E%3C%2Fsvg%3E";

const UserUpdateProfilePic = _ref => {
  var _window$Pelcro$user$r;
  let {
    onClick,
    ...otherProps
  } = _ref;
  const profilePicture = (_window$Pelcro$user$r = window.Pelcro.user.read().profile_photo) !== null && _window$Pelcro$user$r !== void 0 ? _window$Pelcro$user$r : userSolidIcon;
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-justify-center"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-relative"
  }, /*#__PURE__*/React__default.createElement("img", Object.assign({
    className: "plc-border-white plc-border-2 plc-border-solid plc-rounded-full plc-mr-2 sm:plc-ml-2 plc-w-36 plc-h-36 plc-bg-gray-300 plc-cursor-pointer pelcro-user-update-picture",
    src: profilePicture,
    alt: "profile picture",
    onClick: onClick
  }, otherProps)), /*#__PURE__*/React__default.createElement(Button, {
    variant: "icon",
    className: "plc-absolute plc-bg-gray-500 plc-text-white plc-w-10 plc-h-10 plc-top-24 plc-right-2 hover:plc-bg-gray-600 hover:plc-text-white",
    icon: /*#__PURE__*/React__default.createElement(SvgEdit, null),
    id: "pelcro-user-update-picture-button",
    onClick: onClick
  })));
};

function Tin(_ref) {
  let {
    initWithUserTin = true,
    store,
    ...otherProps
  } = _ref;
  useTranslation("common");
  const {
    dispatch,
    state: {
      tin: stateTin
    }
  } = useContext(store);
  const [tin, setTin] = useState(stateTin);
  const [finishedTyping, setFinishedTyping] = useState(false);
  const handleInputChange = useCallback(value => {
    setTin(value);
    if (finishedTyping) {
      dispatch({
        type: SET_TIN,
        payload: tin
      });
    }
  }, [dispatch, tin, finishedTyping]);
  useEffect(() => {
    handleInputChange(tin);
  }, [finishedTyping, tin, handleInputChange]);

  // Initialize tin field with user's tin (Tax Identification Number)
  const loadTinIntoField = () => {
    handleInputChange(window.Pelcro.user.read().tin);
    dispatch({
      type: SET_TIN,
      payload: window.Pelcro.user.read().tin
    });
  };
  useEffect(() => {
    if (initWithUserTin) {
      document.addEventListener("PelcroUserLoaded", () => {
        loadTinIntoField();
      });
      loadTinIntoField();
      return () => {
        document.removeEventListener("PelcroUserLoaded", handleInputChange);
      };
    }
  }, []);
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    value: tin,
    onChange: e => handleInputChange(e.target.value),
    onBlur: () => setFinishedTyping(true),
    onFocus: () => setFinishedTyping(false)
  }, otherProps));
}

const UserUpdateTin = props => /*#__PURE__*/React__default.createElement(Tin, Object.assign({
  store: store$g
}, props));

function DisplayName(_ref) {
  let {
    store,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state
  } = useContext(store);
  const handleInputChange = value => {
    dispatch({
      type: SET_DISPLAY_NAME,
      payload: value
    });
  };
  if (state.loading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    value: state.displayName || null,
    onChange: e => handleInputChange(e.target.value)
  }, otherProps));
}

const UserUpdateDisplayName = props => /*#__PURE__*/React__default.createElement(DisplayName, Object.assign({
  store: store$g
}, props));

const UserUpdateView = props => {
  var _window$Pelcro$site$r, _window$Pelcro, _window$Pelcro$uiSett;
  const {
    t
  } = useTranslation("userEdit");
  const supportsTap = Boolean((_window$Pelcro$site$r = window.Pelcro.site.read()) === null || _window$Pelcro$site$r === void 0 ? void 0 : _window$Pelcro$site$r.tap_gateway_settings);
  const showUsernameInput = (_window$Pelcro = window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableLoginWithUsername;
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-user-update-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("labels.title")), /*#__PURE__*/React__default.createElement("p", null, t("labels.subtitle"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(UserUpdateContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement(UserUpdateProfilePic, {
    onClick: props.onPictureClick
  }), /*#__PURE__*/React__default.createElement(UserUpdateEmail, null), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start"
  }, /*#__PURE__*/React__default.createElement(UserUpdateFirstName, {
    autoComplete: "first-name",
    id: "pelcro-input-first-name",
    errorId: "pelcro-input-first-name-error",
    label: t("labels.firstName"),
    autoFocus: true,
    required: supportsTap ? true : false
  }), /*#__PURE__*/React__default.createElement(UserUpdateLastName, {
    wrapperClassName: "plc-ml-3",
    autoComplete: "last-name",
    id: "pelcro-input-last-name",
    errorId: "pelcro-input-last-name-error",
    label: t("labels.lastName"),
    required: supportsTap ? true : false
  })), /*#__PURE__*/React__default.createElement(UserUpdateDisplayName, {
    id: "pelcro-input-display-name",
    autoComplete: "display-name",
    errorId: "pelcro-input-display-name-error",
    label: t("labels.displayname")
  }), showUsernameInput && /*#__PURE__*/React__default.createElement(UserUpdateUsername, {
    id: "pelcro-input-user-name",
    autoComplete: "user-name",
    errorId: "pelcro-input-user-name-error",
    label: t("labels.username")
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start"
  }, /*#__PURE__*/React__default.createElement(UserUpdatePhone, {
    id: "pelcro-input-phone",
    errorId: "pelcro-input-phone-error",
    label: t("labels.phone"),
    required: supportsTap ? true : false
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start"
  }, /*#__PURE__*/React__default.createElement(UserUpdateTin, {
    id: "pelcro-input-tin",
    label: t("labels.tin")
  })), /*#__PURE__*/React__default.createElement(UserUpdateButton, {
    role: "submit",
    className: "plc-w-full plc-mt-2",
    name: t("labels.submit"),
    id: "pelcro-submit"
  }))));
};

/**
 *
 */
function UserUpdateModal(_ref) {
  let {
    onClose,
    onDisplay,
    ...otherProps
  } = _ref;
  const {
    switchView
  } = usePelcro();
  const onPictureClick = () => {
    switchView("profile-picture");
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-user-update-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(UserUpdateView, Object.assign({
    onPictureClick: onPictureClick
  }, otherProps))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
}
UserUpdateModal.viewId = "user-edit";

const UserUpdateTextInput = props => {
  return /*#__PURE__*/React__default.createElement(TextInput, Object.assign({}, props, {
    store: store$g
  }));
};

const initialState$f = {
  isSubmitting: false,
  firstName: "",
  firstNameError: "",
  lastName: "",
  lastNameError: "",
  line1: "",
  line1Error: "",
  city: "",
  cityError: "",
  state: "",
  stateError: "",
  isStateLoading: false,
  country: "",
  countryError: "",
  isCountryLoading: false,
  postalCode: "",
  postalCodeError: "",
  states: [],
  countries: [],
  isDefault: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$f = /*#__PURE__*/createContext(initialState$f);
const {
  Provider: Provider$f
} = store$f;
const getNewlyCreatedAddress = addresses => addresses[addresses.length - 1];
const AddressCreateContainer = _ref => {
  var _props$giftCode, _ref2, _props$subscriptionId;
  let {
    style,
    className = "",
    type = "shipping",
    onGiftRedemptionSuccess = () => {},
    onMembershipAdressUpdateSuccess = () => {},
    onSuccess = () => {},
    onFailure = () => {},
    children,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation("address");
  const {
    giftCode: giftCodeFromStore,
    subscriptionIdToRenew: subscriptionIdToRenewFromStore,
    product,
    order,
    set,
    selectedMembership
  } = usePelcro();
  const giftCode = (_props$giftCode = props.giftCode) !== null && _props$giftCode !== void 0 ? _props$giftCode : giftCodeFromStore;
  const subscriptionIdToRenew = (_ref2 = (_props$subscriptionId = props.subscriptionIdToRenew) !== null && _props$subscriptionId !== void 0 ? _props$subscriptionId : subscriptionIdToRenewFromStore) !== null && _ref2 !== void 0 ? _ref2 : undefined;
  useEffect(() => {
    const getCountries = () => {
      dispatch({
        type: GET_COUNTRIES_FETCH
      });
      window.Pelcro.geolocation.getCountryList((error, response) => {
        if (error) {
          dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: error.message
            }
          });
        } else if (response) {
          dispatch({
            type: GET_COUNTRIES_SUCCESS,
            payload: sortCountries(response.countries)
          });
          preSelectUserCountry();
        }
      });
    };
    const preSelectUserCountry = () => {
      dispatch({
        type: SET_TEXT_FIELD,
        payload: {
          country: window.Pelcro.user.location.countryCode
        }
      });
    };
    getCountries();
  }, []);
  const submitAddress = (_ref3, dispatch) => {
    let {
      firstName,
      lastName,
      line1,
      line2,
      city,
      state,
      country,
      postalCode,
      isDefault
    } = _ref3;
    window.Pelcro.address.create({
      auth_token: window.Pelcro.user.read().auth_token,
      type: type,
      first_name: firstName,
      last_name: lastName,
      line1: line1,
      line2: line2,
      city: city,
      state: state,
      country: country,
      postal_code: postalCode,
      is_default: isDefault
    }, (err, res) => {
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
        return dispatch({
          type: LOADING,
          payload: false
        });
      }
      const newAddressId = String(getNewlyCreatedAddress(res.data.addresses).id);
      if (selectedMembership) {
        dispatch({
          type: LOADING,
          payload: true
        });
        return window.Pelcro.membership.update({
          auth_token: window.Pelcro.user.read().auth_token,
          address_id: newAddressId,
          membership_id: selectedMembership.id
        }, (err, res) => {
          dispatch({
            type: LOADING,
            payload: false
          });
          if (err) {
            dispatch({
              type: SHOW_ALERT,
              payload: {
                type: "error",
                content: getErrorMessages(err)
              }
            });
            return onFailure(err);
          }
          notify$1.success(t("messages.addressUpdated"));
          return onMembershipAdressUpdateSuccess(res);
        });
      }
      if (product || order) {
        set({
          selectedAddressId: newAddressId
        });
      }
      if (!giftCode) {
        dispatch({
          type: LOADING,
          payload: false
        });
        return onSuccess(newAddressId);
      }
      if (giftCode) {
        window.Pelcro.subscription.redeemGift({
          auth_token: window.Pelcro.user.read().auth_token,
          gift_code: giftCode,
          address_id: newAddressId,
          // redeem gift as a future phase of an existing subscription
          subscription_id: subscriptionIdToRenew
        }, (err, res) => {
          dispatch({
            type: LOADING,
            payload: false
          });
          if (err) {
            dispatch({
              type: SHOW_ALERT,
              payload: {
                type: "error",
                content: getErrorMessages(err)
              }
            });
            return onFailure(err);
          }
          return onGiftRedemptionSuccess(res);
        });
      }
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case GET_COUNTRIES_FETCH:
        return lib_7({
          ...state,
          isCountryLoading: true
        });
      case GET_COUNTRIES_SUCCESS:
        return lib_7({
          ...state,
          countries: action.payload,
          isCountryLoading: false
        });
      case GET_STATES_FETCH:
        return lib_7({
          ...state,
          isStateLoading: true
        });
      case GET_STATES_SUCCESS:
        {
          const stateKeys = Object.keys(action.payload.states);
          return lib_7({
            ...state,
            states: action.payload,
            state: stateKeys === null || stateKeys === void 0 ? void 0 : stateKeys[0],
            isStateLoading: false
          });
        }
      case SET_TEXT_FIELD:
        return lib_7({
          ...state,
          ...action.payload
        });
      case HANDLE_CHECKBOX_CHANGE:
        return lib_7({
          ...state,
          ...action.payload
        });
      case VALIDATE_FIELD:
        return lib_7({
          ...state,
          [`${action.payload}Error`]: state[action.payload] ? "" : t("labels.required")
        });
      case RESET_FIELD_ERROR:
        return lib_7({
          ...state,
          [action.payload]: ""
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case LOADING:
        return lib_7({
          ...state,
          isSubmitting: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          isSubmitting: true
        }, (state, dispatch) => submitAddress(state, dispatch));
      default:
        return state;
    }
  }, initialState$f);
  useEffect(() => {
    const getStates = () => {
      dispatch({
        type: GET_STATES_FETCH
      });
      window.Pelcro.geolocation.getStatesForCountry(state.country, (error, response) => {
        if (error) {
          dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: error.message
            }
          });
        } else if (response) {
          dispatch({
            type: GET_STATES_SUCCESS,
            payload: response
          });
        }
      });
    };
    if (state.country) {
      getStates();
    }
  }, [state.country]);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-address-create-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$f, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$f,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$f
  })));
};

function AddressCreateFirstName(props) {
  const {
    dispatch,
    state: {
      firstName,
      firstNameError
    }
  } = useContext(store$f);
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        firstName: value
      }
    });
  };
  const handleFocus = () => {
    dispatch({
      type: RESET_FIELD_ERROR,
      payload: "firstNameError"
    });
  };
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    autoComplete: "given-name",
    value: firstName,
    error: firstNameError,
    onChange: e => handleInputChange(e.target.value)
    // onBlur={handleBlur}
    ,
    onFocus: handleFocus
  }, props));
}

function AddressCreateLastName(props) {
  const {
    dispatch,
    state: {
      lastName,
      lastNameError
    }
  } = useContext(store$f);
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        lastName: value
      }
    });
  };
  const handleFocus = () => {
    dispatch({
      type: RESET_FIELD_ERROR,
      payload: "lastNameError"
    });
  };
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    autoComplete: "family-name",
    value: lastName,
    error: lastNameError,
    onChange: e => handleInputChange(e.target.value),
    onFocus: handleFocus
  }, props));
}

function AddressCreateLine1(props) {
  const {
    dispatch,
    state: {
      line1,
      line1Error
    }
  } = useContext(store$f);
  const handleBlur = () => {
    return dispatch({
      type: VALIDATE_FIELD,
      payload: "line1"
    });
  };
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        line1: value
      }
    });
  };
  const handleFocus = () => {
    dispatch({
      type: RESET_FIELD_ERROR,
      payload: "line1Error"
    });
  };
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    autoComplete: "street-address",
    value: line1,
    error: line1Error,
    onChange: e => handleInputChange(e.target.value),
    onBlur: handleBlur,
    onFocus: handleFocus
  }, props));
}

function AddressCreateCity(props) {
  const {
    dispatch,
    state: {
      city,
      cityError
    }
  } = useContext(store$f);
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        city: value
      }
    });
  };
  const handleFocus = () => {
    dispatch({
      type: RESET_FIELD_ERROR,
      payload: "cityError"
    });
  };
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    autoComplete: "address-level2",
    value: city,
    error: cityError,
    onChange: e => handleInputChange(e.target.value),
    onFocus: handleFocus
  }, props));
}

function AddressCreatePostalCode(props) {
  const {
    dispatch,
    state: {
      postalCode,
      postalCodeError
    }
  } = useContext(store$f);
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        postalCode: value
      }
    });
  };
  const handleFocus = () => {
    dispatch({
      type: RESET_FIELD_ERROR,
      payload: "postalCodeError"
    });
  };
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    autoComplete: "postal-code",
    value: postalCode,
    error: postalCodeError,
    onChange: e => handleInputChange(e.target.value),
    onFocus: handleFocus
  }, props));
}

const AddressCreateSubmit = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      isSubmitting
    }
  } = useContext(store$f);
  const {
    t
  } = useTranslation("address");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    isLoading: isSubmitting
  }, otherProps), name !== null && name !== void 0 ? name : t("buttons.submit"));
};

function CountrySelect(_ref) {
  let {
    placeholder,
    store,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      country,
      countryError,
      countries,
      isCountryLoading
    }
  } = useContext(store);
  const createCountryItems = () => {
    if (countries.length) {
      return countries.map(_ref2 => {
        let [abbr, country] = _ref2;
        return /*#__PURE__*/React__default.createElement("option", {
          key: abbr,
          value: abbr
        }, country);
      });
    }
  };
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        country: value
      }
    });
  };
  const handleBlur = () => {
    return dispatch({
      type: VALIDATE_FIELD,
      payload: "country"
    });
  };
  const handleFocus = () => {
    dispatch({
      type: RESET_FIELD_ERROR,
      payload: "countryError"
    });
  };
  if (isCountryLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Select, Object.assign({
    className: "plc-pr-8",
    value: country,
    error: countryError,
    onChange: e => handleInputChange(e.target.value),
    onBlur: handleBlur,
    onFocus: handleFocus,
    autoComplete: "country"
  }, otherProps), /*#__PURE__*/React__default.createElement("option", {
    value: "",
    disabled: true,
    selected: true
  }, placeholder), createCountryItems());
}

const AddressCreateCountrySelect = props => /*#__PURE__*/React__default.createElement(CountrySelect, Object.assign({
  store: store$f
}, props));

function StateSelect(_ref) {
  let {
    placeholder = "",
    store,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      country,
      state,
      stateError,
      states,
      isStateLoading
    }
  } = useContext(store);
  const createStateItems = () => {
    const items = [];
    if (states.selected_country === country) {
      if (Array.isArray(states.states)) {
        for (const state in states.states) {
          const tmp = states.states[state];
          items.push( /*#__PURE__*/React__default.createElement("option", {
            key: tmp.code,
            value: tmp.code
          }, tmp.name));
        }
        return items;
      } else {
        for (const key in states.states) {
          items.push( /*#__PURE__*/React__default.createElement("option", {
            key: key,
            value: key
          }, states.states[key]));
        }
        return items;
      }
    }
  };
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        state: value
      }
    });
  };
  const handleBlur = () => {
    if (otherProps.required) {
      return dispatch({
        type: VALIDATE_FIELD,
        payload: "state"
      });
    }
  };
  const handleFocus = () => {
    dispatch({
      type: RESET_FIELD_ERROR,
      payload: "stateError"
    });
  };
  if (isStateLoading || !createStateItems() && country) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Select, Object.assign({
    className: "plc-pr-8",
    value: state,
    error: stateError,
    onChange: e => handleInputChange(e.target.value),
    onBlur: handleBlur,
    onFocus: handleFocus,
    autoComplete: "address-level1"
  }, otherProps), /*#__PURE__*/React__default.createElement("option", {
    value: "",
    selected: true
  }, placeholder), createStateItems());
}

const AddressCreateStateSelect = props => /*#__PURE__*/React__default.createElement(StateSelect, Object.assign({
  store: store$f
}, props));

const AddressCreateSetDefault = props => {
  const {
    dispatch,
    state
  } = useContext(store$f);
  const handleCheckboxChange = e => {
    dispatch({
      type: HANDLE_CHECKBOX_CHANGE,
      payload: {
        isDefault: e.target.checked
      }
    });
  };
  return /*#__PURE__*/React__default.createElement(Checkbox, {
    onChange: e => handleCheckboxChange(e),
    id: props.id
  }, props.label);
};

const AddressCreateView = props => {
  const {
    t
  } = useTranslation("address");
  const {
    giftRecipient
  } = usePelcro();
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-address-create-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-2xl plc-font-semibold plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", null, giftRecipient ? t("titleGifting") : t("title"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(AddressCreateContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-space-x-3 plc-items-start"
  }, /*#__PURE__*/React__default.createElement(AddressCreateFirstName, {
    id: "pelcro-input-first-name",
    errorId: "pelcro-input-first-name-error",
    label: t("labels.firstName"),
    autoFocus: true
  }), /*#__PURE__*/React__default.createElement(AddressCreateLastName, {
    id: "pelcro-input-last-name",
    errorId: "pelcro-input-last-name-error",
    label: t("labels.lastName")
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start"
  }, /*#__PURE__*/React__default.createElement(AddressCreateLine1, {
    id: "pelcro-input-line1",
    errorId: "pelcro-input-line1-error",
    required: true,
    label: t("labels.address")
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-space-x-3 plc-items-start"
  }, /*#__PURE__*/React__default.createElement(AddressCreatePostalCode, {
    id: "pelcro-input-postal-code",
    errorId: "pelcro-input-postal-code-error",
    label: t("labels.code")
  }), /*#__PURE__*/React__default.createElement(AddressCreateCity, {
    id: "pelcro-input-city",
    errorId: "pelcro-input-city-error",
    label: t("labels.city")
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-space-x-3 plc-items-start"
  }, /*#__PURE__*/React__default.createElement(AddressCreateCountrySelect, {
    id: "pelcro-input-country",
    errorId: "pelcro-input-country-error",
    label: t("labels.country"),
    required: true
  }), /*#__PURE__*/React__default.createElement(AddressCreateStateSelect, {
    label: t("labels.region"),
    id: "pelcro-input-state",
    errorId: "pelcro-input-state-error"
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-space-x-3 plc-items-start plc-mb-3"
  }, /*#__PURE__*/React__default.createElement(AddressCreateSetDefault, {
    id: "pelcro-input-is-default",
    label: t("labels.isDefault")
  })), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-text-gray-900 pelcro-footnote"
  }, "* ", t("labels.required")), /*#__PURE__*/React__default.createElement(AddressCreateSubmit, {
    role: "submit",
    className: "plc-mt-2 plc-w-full",
    name: t("buttons.submit"),
    id: "pelcro-submit"
  }))));
};

const AddressCreateModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  const {
    switchView,
    switchToPaymentView,
    resetView
  } = usePelcro();
  const onSuccess = newAddressId => {
    var _otherProps$onSuccess;
    (_otherProps$onSuccess = otherProps.onSuccess) === null || _otherProps$onSuccess === void 0 ? void 0 : _otherProps$onSuccess.call(otherProps, newAddressId);
    switchToPaymentView();
  };
  const onGiftRedemptionSuccess = () => {
    var _otherProps$onGiftRed;
    (_otherProps$onGiftRed = otherProps.onGiftRedemptionSuccess) === null || _otherProps$onGiftRed === void 0 ? void 0 : _otherProps$onGiftRed.call(otherProps);
    switchView("subscription-success");
  };

  // FIXME: implement me
  const onMembershipAdressUpdateSuccess = () => {
    var _otherProps$onMembers;
    (_otherProps$onMembers = otherProps.onMembershipAdressUpdateSuccess) === null || _otherProps$onMembers === void 0 ? void 0 : _otherProps$onMembers.call(otherProps);
    resetView();
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-address-create-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(AddressCreateView, Object.assign({}, otherProps, {
    onSuccess: onSuccess,
    onGiftRedemptionSuccess: onGiftRedemptionSuccess,
    onMembershipAdressUpdateSuccess: onMembershipAdressUpdateSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
AddressCreateModal.viewId = "address-create";

const AddressCreateTextInput = props => {
  return /*#__PURE__*/React__default.createElement(TextInput, Object.assign({}, props, {
    store: store$f
  }));
};

const AddressCreateLine2 = props => {
  return /*#__PURE__*/React__default.createElement(TextInput, Object.assign({
    fieldName: "line2",
    store: store$f
  }, props));
};

const initialState$e = {
  isSubmitting: false,
  firstName: "",
  firstNameError: "",
  lastName: "",
  lastNameError: "",
  line1: "",
  line1Error: "",
  city: "",
  cityError: "",
  state: "",
  stateError: "",
  isStateLoading: "",
  country: "",
  countryError: "",
  isCountryLoading: false,
  postalCode: "",
  postalCodeError: "",
  states: [],
  countries: [],
  isDefault: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$e = /*#__PURE__*/createContext(initialState$e);
const {
  Provider: Provider$e
} = store$e;
const AddressUpdateContainer = _ref => {
  var _props$addressId, _window, _window$Pelcro, _window$Pelcro$uiSett;
  let {
    style,
    className = "",
    type = "shipping",
    onSuccess = () => {},
    onFailure = () => {},
    children,
    ...props
  } = _ref;
  const {
    addressIdToEdit
  } = usePelcro();
  const addressId = (_props$addressId = props === null || props === void 0 ? void 0 : props.addressId) !== null && _props$addressId !== void 0 ? _props$addressId : addressIdToEdit;
  const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
  const [t] = useTranslation("address");
  useEffect(() => {
    const getCountries = () => {
      dispatch({
        type: GET_COUNTRIES_FETCH
      });
      window.Pelcro.geolocation.getCountryList((error, response) => {
        if (error) {
          dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: error.message
            }
          });
        } else if (response) {
          dispatch({
            type: GET_COUNTRIES_SUCCESS,
            payload: sortCountries(response.countries)
          });
        }
      });
    };
    getAddressData();
    getCountries();
  }, []);
  const getAddressData = () => {
    const addresses = window.Pelcro.address.list();
    for (const address in addresses) {
      const thisAddress = addresses[address];
      if (+thisAddress.id === +addressId) {
        const newState = {
          ...initialState$e,
          firstName: thisAddress.first_name,
          lastName: thisAddress.last_name,
          line1: thisAddress.line1,
          line2: thisAddress.line2,
          city: thisAddress.city,
          state: thisAddress.state,
          country: thisAddress.country,
          postalCode: thisAddress.postal_code,
          isDefault: thisAddress.is_default
        };
        dispatch({
          type: SET_TEXT_FIELD,
          payload: newState
        });
      }
    }
  };
  const submitAddress = (_ref2, dispatch) => {
    let {
      firstName,
      lastName,
      line1,
      line2,
      city,
      state,
      country,
      postalCode,
      isDefault
    } = _ref2;
    window.Pelcro.address.update({
      address_id: addressId,
      auth_token: window.Pelcro.user.read().auth_token,
      type: type,
      first_name: firstName,
      last_name: lastName,
      line1: line1,
      line2: line2,
      city: city,
      state: state,
      country: country,
      postal_code: postalCode,
      is_default: isDefault
    }, (err, res) => {
      dispatch({
        type: LOADING,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("messages.addressUpdated")
          }
        });
        onSuccess(res);
        if (enableReactGA4) {
          ReactGA4.event("Updated address", {
            nonInteraction: true
          });
        } else {
          var _ReactGA$event;
          ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
            category: "ACTIONS",
            action: "Updated address",
            nonInteraction: true
          });
        }
      }
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case GET_COUNTRIES_FETCH:
        return lib_7({
          ...state,
          isCountryLoading: true
        });
      case GET_COUNTRIES_SUCCESS:
        return lib_7({
          ...state,
          countries: action.payload,
          isCountryLoading: false
        });
      case GET_STATES_FETCH:
        return lib_7({
          ...state,
          isStateLoading: true
        });
      case GET_STATES_SUCCESS:
        {
          var _stateKeys$includes;
          const stateKeys = Object.keys(action.payload.states);
          const isSelectedStatePartOfCountry = stateKeys === null || stateKeys === void 0 ? void 0 : (_stateKeys$includes = stateKeys.includes) === null || _stateKeys$includes === void 0 ? void 0 : _stateKeys$includes.call(stateKeys, state.state);
          return lib_7({
            ...state,
            states: action.payload,
            isStateLoading: false,
            ...(!isSelectedStatePartOfCountry && {
              state: stateKeys === null || stateKeys === void 0 ? void 0 : stateKeys[0]
            })
          });
        }
      case SET_TEXT_FIELD:
        return lib_7({
          ...state,
          ...action.payload
        });
      case HANDLE_CHECKBOX_CHANGE:
        return lib_7({
          ...state,
          ...action.payload
        });
      case VALIDATE_FIELD:
        return lib_7({
          ...state,
          [`${action.payload}Error`]: state[action.payload] ? "" : t("labels.required")
        });
      case RESET_FIELD_ERROR:
        return lib_7({
          ...state,
          [action.payload]: ""
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case LOADING:
        return lib_7({
          ...state,
          isSubmitting: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          isSubmitting: true
        }, (state, dispatch) => submitAddress(state, dispatch));
      default:
        return state;
    }
  }, initialState$e);
  useEffect(() => {
    const getStates = () => {
      dispatch({
        type: GET_STATES_FETCH
      });
      window.Pelcro.geolocation.getStatesForCountry(state.country, (error, response) => {
        if (error) {
          dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: error.message
            }
          });
        } else if (response) {
          dispatch({
            type: GET_STATES_SUCCESS,
            payload: response
          });
        }
      });
    };
    if (state.country) {
      getStates();
    }
  }, [state.country]);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-address-update-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$e, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$e,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$e
  })));
};

const AddressUpdateCountrySelect = props => /*#__PURE__*/React__default.createElement(CountrySelect, Object.assign({
  store: store$e
}, props));

function AddressUpdateFirstName(props) {
  const {
    dispatch,
    state: {
      firstName,
      firstNameError
    }
  } = useContext(store$e);
  const handleBlur = () => {
    return dispatch({
      type: VALIDATE_FIELD,
      payload: "firstName"
    });
  };
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        firstName: value
      }
    });
  };
  const handleFocus = () => {
    dispatch({
      type: RESET_FIELD_ERROR,
      payload: "firstNameError"
    });
  };
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    autoComplete: "given-name",
    value: firstName,
    error: firstNameError,
    onChange: e => handleInputChange(e.target.value),
    onBlur: handleBlur,
    onFocus: handleFocus
  }, props));
}

function AddressUpdateLastName(props) {
  const {
    dispatch,
    state: {
      lastName,
      lastNameError
    }
  } = useContext(store$e);
  const handleBlur = () => {
    return dispatch({
      type: VALIDATE_FIELD,
      payload: "lastName"
    });
  };
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        lastName: value
      }
    });
  };
  const handleFocus = () => {
    dispatch({
      type: RESET_FIELD_ERROR,
      payload: "lastNameError"
    });
  };
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    autoComplete: "family-name",
    value: lastName,
    error: lastNameError,
    onChange: e => handleInputChange(e.target.value),
    onBlur: handleBlur,
    onFocus: handleFocus
  }, props));
}

function AddressUpdateLine1(props) {
  const {
    dispatch,
    state: {
      line1,
      line1Error
    }
  } = useContext(store$e);
  const handleBlur = () => {
    return dispatch({
      type: VALIDATE_FIELD,
      payload: "line1"
    });
  };
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        line1: value
      }
    });
  };
  const handleFocus = () => {
    dispatch({
      type: RESET_FIELD_ERROR,
      payload: "line1Error"
    });
  };
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    autoComplete: "street-address",
    value: line1,
    error: line1Error,
    onChange: e => handleInputChange(e.target.value),
    onBlur: handleBlur,
    onFocus: handleFocus
  }, props));
}

const AddressUpdateLine2 = props => {
  return /*#__PURE__*/React__default.createElement(TextInput, Object.assign({
    fieldName: "line2"
  }, props, {
    store: store$e
  }));
};

function AddressUpdateCity(props) {
  const {
    dispatch,
    state: {
      city,
      cityError
    }
  } = useContext(store$e);
  const handleBlur = () => {
    return dispatch({
      type: VALIDATE_FIELD,
      payload: "city"
    });
  };
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        city: value
      }
    });
  };
  const handleFocus = () => {
    dispatch({
      type: RESET_FIELD_ERROR,
      payload: "cityError"
    });
  };
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    autoComplete: "address-level2",
    value: city,
    error: cityError,
    onChange: e => handleInputChange(e.target.value),
    onBlur: handleBlur,
    onFocus: handleFocus
  }, props));
}

function AddressUpdatePostalCode(props) {
  const {
    dispatch,
    state: {
      postalCode,
      postalCodeError
    }
  } = useContext(store$e);
  const handleBlur = () => {
    return dispatch({
      type: VALIDATE_FIELD,
      payload: "postalCode"
    });
  };
  const handleInputChange = value => {
    dispatch({
      type: SET_TEXT_FIELD,
      payload: {
        postalCode: value
      }
    });
  };
  const handleFocus = () => {
    dispatch({
      type: RESET_FIELD_ERROR,
      payload: "postalCodeError"
    });
  };
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    autoComplete: "postal-code",
    value: postalCode,
    error: postalCodeError,
    onChange: e => handleInputChange(e.target.value),
    onBlur: handleBlur,
    onFocus: handleFocus
  }, props));
}

const AddressUpdateSubmit = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      isSubmitting
    }
  } = useContext(store$e);
  const {
    t
  } = useTranslation("address");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    isLoading: isSubmitting
  }, otherProps), name !== null && name !== void 0 ? name : t("buttons.submit"));
};

const AddressUpdateStateSelect = props => /*#__PURE__*/React__default.createElement(StateSelect, Object.assign({
  store: store$e
}, props));

function AddressUpdateSetDefault(props) {
  const {
    dispatch,
    state: {
      isDefault
    }
  } = useContext(store$e);
  const handleCheckboxChange = e => {
    dispatch({
      type: HANDLE_CHECKBOX_CHANGE,
      payload: {
        isDefault: e.target.checked
      }
    });
  };
  return /*#__PURE__*/React__default.createElement(Checkbox, {
    onChange: e => handleCheckboxChange(e),
    id: props.id,
    checked: isDefault
  }, props.label);
}

const AddressUpdateView = props => {
  const {
    t
  } = useTranslation("address");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-address-update-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-2xl plc-font-semibold plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", null, t("title"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(AddressUpdateContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-space-x-3 plc-items-start"
  }, /*#__PURE__*/React__default.createElement(AddressUpdateFirstName, {
    id: "pelcro-input-first-name",
    errorId: "pelcro-input-first-name-error",
    label: t("labels.firstName"),
    required: true,
    autoFocus: true
  }), /*#__PURE__*/React__default.createElement(AddressUpdateLastName, {
    id: "pelcro-input-last-name",
    errorId: "pelcro-input-last-name-error",
    label: t("labels.lastName"),
    required: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start"
  }, /*#__PURE__*/React__default.createElement(AddressUpdateLine1, {
    id: "pelcro-input-line1",
    errorId: "pelcro-input-line1-error",
    label: t("labels.address"),
    required: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-space-x-3 plc-items-start"
  }, /*#__PURE__*/React__default.createElement(AddressUpdatePostalCode, {
    id: "pelcro-input-postal_code",
    errorId: "pelcro-input-postal-code-error",
    label: t("labels.code"),
    required: true
  }), /*#__PURE__*/React__default.createElement(AddressUpdateCity, {
    id: "pelcro-input-city",
    errorId: "pelcro-input-city-error",
    label: t("labels.city"),
    required: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-space-x-3 plc-items-start"
  }, /*#__PURE__*/React__default.createElement(AddressUpdateCountrySelect, {
    id: "pelcro-input-country",
    errorId: "pelcro-input-country-error",
    label: t("labels.country"),
    required: true
  }), /*#__PURE__*/React__default.createElement(AddressUpdateStateSelect, {
    id: "pelcro-input-state",
    errorId: "pelcro-input-state-error",
    label: t("labels.region"),
    required: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-space-x-3 plc-items-start plc-mb-3"
  }, /*#__PURE__*/React__default.createElement(AddressUpdateSetDefault, {
    id: "pelcro-input-is-default",
    label: t("labels.isDefault")
  })), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-text-gray-900 pelcro-footnote"
  }, "* ", t("labels.required")), /*#__PURE__*/React__default.createElement(AddressUpdateSubmit, {
    role: "submit",
    className: "plc-mt-2 plc-w-full",
    name: t("buttons.submit"),
    id: "pelcro-submit"
  }))));
};

const AddressUpdateModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-address-update-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(AddressUpdateView, otherProps)), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
AddressUpdateModal.viewId = "address-edit";

const AddressUpdateTextInput = props => {
  return /*#__PURE__*/React__default.createElement(TextInput, Object.assign({}, props, {
    store: store$e
  }));
};

const SubscriptionCreateContainer = props => {
  return /*#__PURE__*/React__default.createElement(PaymentMethodContainer, Object.assign({
    type: "createPayment",
    className: "pelcro-subscription-create-container"
  }, props));
};

const SubscriptionRenewContainer = props => {
  return /*#__PURE__*/React__default.createElement(PaymentMethodContainer, Object.assign({
    type: "createPayment",
    className: "pelcro-subscription-renew-container",
    "pelcro-subscription-create-": true
  }, props));
};

const PaymentCreateContainer = props => {
  return /*#__PURE__*/React__default.createElement(PaymentMethodContainer, Object.assign({
    type: "paymentCreate",
    className: "pelcro-payment-create-container"
  }, props));
};

const PaymentCreateView = props => {
  return /*#__PURE__*/React__default.createElement(PaymentMethodView, Object.assign({
    type: "createPayment"
  }, props));
};

const PaymentMethodUpdateContainer = props => {
  return /*#__PURE__*/React__default.createElement(PaymentMethodContainer, Object.assign({
    type: "updatePaymentSource",
    className: "pelcro-payment-update-container"
  }, props));
};

/**
 *
 */
function PaymentMethodUpdateView(props) {
  const [t] = useTranslation("paymentMethod");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-payment-method-update-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-2 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold "
  }, t("update.title")), /*#__PURE__*/React__default.createElement("p", null, t("update.subtitle"))), /*#__PURE__*/React__default.createElement(PaymentMethodView, {
    type: "updatePaymentSource",
    showCoupon: false,
    showExternalPaymentMethods: false,
    showApplePayButton: false,
    onDisplay: props.onDisplay,
    onFailure: props.onFailure,
    onSuccess: props.onSuccess
  }));
}

const PaymentMethodUpdateModal = props => {
  var _window, _window$Pelcro, _window$Pelcro$uiSett;
  const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
  const onSuccess = res => {
    var _props$onSuccess;
    (_props$onSuccess = props.onSuccess) === null || _props$onSuccess === void 0 ? void 0 : _props$onSuccess.call(props, res);
    if (enableReactGA4) {
      ReactGA4.event("Updated payment card", {
        nonInteraction: true
      });
    } else {
      var _ReactGA$event;
      ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
        category: "ACTIONS",
        action: "Updated payment card",
        nonInteraction: true
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-payment-method-update-modal",
    onDisplay: props.onDisplay,
    onClose: props.onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(PaymentMethodUpdateView, Object.assign({}, props, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
PaymentMethodUpdateModal.viewId = "payment-method-update";

const initialState$d = {
  email: "",
  password: "",
  passwordError: null,
  confirmPassword: "",
  confirmPasswordError: null,
  token: "",
  buttonDisabled: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$d = /*#__PURE__*/createContext(initialState$d);
const {
  Provider: Provider$d
} = store$d;
const PasswordResetContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children
  } = _ref;
  const {
    t
  } = useTranslation("passwordReset");
  const handleSubmit = (_ref2, dispatch) => {
    let {
      email,
      password,
      confirmPassword,
      token
    } = _ref2;
    window.Pelcro.password.reset({
      email,
      password,
      password_confirmation: confirmPassword,
      token,
      referer: window.location.origin
    }, (err, res) => {
      dispatch({
        type: DISABLE_SUBMIT,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("passwordUpdated")
          }
        });
        onSuccess(res);
      }
    });
  };
  useEffect(() => {
    dispatch({
      type: SET_EMAIL,
      payload: window.Pelcro.helpers.getURLParameter("email")
    });
    initialState$d.email = window.Pelcro.helpers.getURLParameter("email");
    dispatch({
      type: SET_TOKEN,
      payload: window.Pelcro.helpers.getURLParameter("token")
    });
  }, []);
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SET_EMAIL:
        return lib_7({
          ...state,
          email: action.payload
        });
      case SET_PASSWORD:
        return lib_7({
          ...state,
          password: action.payload,
          passwordError: null
        });
      case SET_CONFIRM_PASSWORD:
        return lib_7({
          ...state,
          confirmPassword: action.payload,
          confirmPasswordError: null
        });
      case SET_PASSWORD_ERROR:
        return lib_7({
          ...state,
          passwordError: action.payload,
          password: ""
        });
      case SET_CONFIRM_PASSWORD_ERROR:
        return lib_7({
          ...state,
          confirmPasswordError: action.payload,
          confirmPassword: ""
        });
      case SET_TOKEN:
        return lib_7({
          ...state,
          token: action.payload
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case DISABLE_SUBMIT:
        return lib_7({
          ...state,
          buttonDisabled: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          buttonDisabled: true
        }, (state, dispatch) => handleSubmit(state, dispatch));
      default:
        return state;
    }
  }, initialState$d);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-password-reset-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$d, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$d,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$d
  })));
};

const PasswordResetPassword = props => /*#__PURE__*/React__default.createElement(Password, Object.assign({
  store: store$d
}, props));

const PasswordResetButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    state: {
      buttonDisabled
    },
    dispatch
  } = useContext(store$d);
  const {
    t
  } = useTranslation("passwordReset");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: buttonDisabled,
    isLoading: buttonDisabled
  }, otherProps), name !== null && name !== void 0 ? name : t("submit"));
};

const PasswordResetEmail = props => /*#__PURE__*/React__default.createElement(Email, Object.assign({
  store: store$d
}, props, {
  value: window.Pelcro.helpers.getURLParameter("email"),
  disabled: true
}));

const PasswordResetConfirmPassword = props => /*#__PURE__*/React__default.createElement(ConfirmPassword, Object.assign({
  store: store$d
}, props));

const PasswordResetView = props => {
  const {
    t
  } = useTranslation("passwordReset");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-password-reset-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("title")), /*#__PURE__*/React__default.createElement("p", null, t("subtitle"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(PasswordResetContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement(PasswordResetEmail, {
    id: "pelcro-input-email",
    errorId: "pelcro-input-email-error",
    required: true,
    label: t("email")
  }), /*#__PURE__*/React__default.createElement(PasswordResetPassword, {
    id: "pelcro-input-password",
    errorId: "pelcro-input-password-error",
    required: true,
    label: t("password")
  }), /*#__PURE__*/React__default.createElement(PasswordResetConfirmPassword, {
    id: "pelcro-input-confirm-password",
    errorId: "pelcro-input-confirm-password-error",
    required: true,
    label: t("confirmPassword")
  }), /*#__PURE__*/React__default.createElement(PasswordResetButton, {
    role: "submit",
    className: "plc-mt-2 plc-w-full",
    name: t("submit"),
    id: "pelcro-submit"
  }))));
};

const PasswordResetModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Modal, {
    onDisplay: onDisplay,
    onClose: onClose,
    id: "pelcro-password-reset-modal"
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(PasswordResetView, otherProps)), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
PasswordResetModal.viewId = "password-reset";

const initialState$c = {
  email: "",
  emailError: null,
  buttonDisabled: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$c = /*#__PURE__*/createContext(initialState$c);
const {
  Provider: Provider$c
} = store$c;
const PasswordForgotContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children
  } = _ref;
  const {
    t
  } = useTranslation("passwordForgot");
  const handleSubmit = (_ref2, dispatch) => {
    let {
      email
    } = _ref2;
    window.Pelcro.password.forgot({
      email,
      referer: window.location.origin
    }, (err, res) => {
      dispatch({
        type: DISABLE_SUBMIT,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("passwordResetEmailSent")
          }
        });
        onSuccess(res);
      }
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SET_EMAIL:
        return lib_7({
          ...state,
          email: action.payload,
          emailError: null
        });
      case SET_EMAIL_ERROR:
        return lib_7({
          ...state,
          emailError: action.payload,
          email: ""
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case DISABLE_SUBMIT:
        return lib_7({
          ...state,
          buttonDisabled: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          buttonDisabled: true
        }, (state, dispatch) => handleSubmit(state, dispatch));
      default:
        return state;
    }
  }, initialState$c);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-password-forgot-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$c, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$c,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$c
  })));
};

const PasswordForgotButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    state: {
      buttonDisabled,
      email,
      emailError
    },
    dispatch
  } = useContext(store$c);
  const {
    t
  } = useTranslation("passwordForgot");
  const [isDisabled, setDisabled] = useState(true);
  useEffect(() => {
    setDisabled(emailError || !email.length || buttonDisabled);
  }, [emailError, email, buttonDisabled]);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: isDisabled,
    isLoading: buttonDisabled
  }, otherProps), name !== null && name !== void 0 ? name : t("submit"));
};

const PasswordForgotEmail = props => /*#__PURE__*/React__default.createElement(Email, Object.assign({
  store: store$c
}, props));

const PasswordForgotView = props => {
  const {
    t
  } = useTranslation("passwordForgot");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-password-forgot-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("title"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(PasswordForgotContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement(PasswordForgotEmail, {
    id: "pelcro-input-email",
    required: true,
    label: t("email")
  }), /*#__PURE__*/React__default.createElement(PasswordForgotButton, {
    role: "submit",
    className: "plc-mt-2 plc-w-full",
    name: t("submit"),
    id: "pelcro-submit"
  }))));
};

const PasswordForgotModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("passwordForgot");
  const {
    switchView
  } = usePelcro();
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-password-forgot-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(PasswordForgotView, otherProps)), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement("div", null, t("messages.alreadyHaveAccount") + " ", /*#__PURE__*/React__default.createElement(Link, {
    id: "pelcro-link-login",
    onClick: () => switchView("login")
  }, t("messages.loginHere"))), /*#__PURE__*/React__default.createElement(Authorship, null)));
};
PasswordForgotModal.viewId = "password-forgot";

const initialState$b = {
  email: "",
  emailError: null,
  buttonDisabled: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$b = /*#__PURE__*/createContext(initialState$b);
const {
  Provider: Provider$b
} = store$b;
const PasswordlessRequestContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children
  } = _ref;
  const {
    t
  } = useTranslation("passwordlessRequest");
  const handleSubmit = (_ref2, dispatch) => {
    let {
      email
    } = _ref2;
    window.Pelcro.user.requestLoginToken({
      email
    }, (err, res) => {
      dispatch({
        type: DISABLE_SUBMIT,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("messages.PasswordlessLoginSuccess")
          }
        });
        onSuccess(res);
      }
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SET_EMAIL:
        return lib_7({
          ...state,
          email: action.payload,
          emailError: null
        });
      case SET_EMAIL_ERROR:
        return lib_7({
          ...state,
          emailError: action.payload,
          email: ""
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case DISABLE_SUBMIT:
        return lib_7({
          ...state,
          buttonDisabled: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          buttonDisabled: true
        }, (state, dispatch) => handleSubmit(state, dispatch));
      default:
        return state;
    }
  }, initialState$b);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-password-forgot-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$b, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$b,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$b
  })));
};

const PasswordlessRequestViewButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    state: {
      buttonDisabled,
      email,
      emailError
    },
    dispatch
  } = useContext(store$b);
  const {
    t
  } = useTranslation("passwordlessRequest");
  const [isDisabled, setDisabled] = useState(true);
  useEffect(() => {
    setDisabled(emailError || !email.length || buttonDisabled);
  }, [emailError, email, buttonDisabled]);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: isDisabled,
    isLoading: buttonDisabled
  }, otherProps), name !== null && name !== void 0 ? name : t("submit"));
};

const PasswordlessRequestEmail = props => /*#__PURE__*/React__default.createElement(Email, Object.assign({
  store: store$b
}, props));

const PasswordlessRequestView = props => {
  const {
    t
  } = useTranslation("passwordlessRequest");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-password-forgot-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("title"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(PasswordlessRequestContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement(PasswordlessRequestEmail, {
    id: "pelcro-input-email",
    required: true,
    label: t("email")
  }), /*#__PURE__*/React__default.createElement(PasswordlessRequestViewButton, {
    role: "submit",
    className: "plc-mt-2 plc-w-full",
    name: t("submit"),
    id: "pelcro-submit"
  }))));
};

const PasswordlessRequestModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-password-forgot-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(PasswordlessRequestView, otherProps)), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
PasswordlessRequestModal.viewId = "passwordless-request";

const initialState$a = {
  currentPassword: "",
  newPassword: "",
  confirmNewPassword: "",
  currentPasswordError: "",
  newPasswordError: "",
  confirmNewPasswordError: "",
  isSubmitting: false,
  passwordChanged: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$a = /*#__PURE__*/createContext(initialState$a);
const {
  Provider: Provider$a
} = store$a;
const PasswordChangeContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children
  } = _ref;
  const {
    t
  } = useTranslation("passwordChange");
  const handleSubmit = (_ref2, dispatch) => {
    let {
      currentPassword,
      newPassword,
      confirmNewPassword
    } = _ref2;
    window.Pelcro.password.update({
      old_password: currentPassword,
      new_password: newPassword,
      confirm_new_password: confirmNewPassword
    }, (err, res) => {
      dispatch({
        type: DISABLE_SUBMIT,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("passwordChanged")
          }
        });
        dispatch({
          type: PASSWORD_CHANGE_SUCCESS
        });
        onSuccess(res);
      }
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SET_PASSWORD:
        return lib_7({
          ...state,
          currentPassword: action.payload
        });
      case SET_NEW_PASSWORD:
        return lib_7({
          ...state,
          newPassword: action.payload
        });
      case SET_CONFIRM_NEW_PASSWORD:
        return lib_7({
          ...state,
          confirmNewPassword: action.payload
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case VALIDATE_PASSWORD:
        if (!state.currentPassword.length) {
          return lib_7({
            ...state,
            currentPasswordError: t("required")
          });
        }
        return lib_7({
          ...state,
          currentPasswordError: ""
        });
      case VALIDATE_NEW_PASSWORD:
        if (!state.newPassword.length) {
          return lib_7({
            ...state,
            newPasswordError: t("required")
          });
        }
        if (state.newPassword.length < 6) {
          return lib_7({
            ...state,
            newPasswordError: t("weakPassword")
          });
        }
        return lib_7({
          ...state,
          newPasswordError: ""
        });
      case VALIDATE_CONFIRM_NEW_PASSWORD:
        if (!state.confirmNewPassword.length) {
          return lib_7({
            ...state,
            confirmNewPasswordError: t("required")
          });
        }
        if (state.confirmNewPassword !== state.newPassword) {
          return lib_7({
            ...state,
            confirmNewPasswordError: t("passwordsNotMatching")
          });
        }
        return lib_7({
          ...state,
          confirmNewPasswordError: ""
        });
      case RESET_PASSWORD_ERROR:
        return lib_7({
          ...state,
          currentPasswordError: ""
        });
      case RESET_NEW_PASSWORD_ERROR:
        return lib_7({
          ...state,
          newPasswordError: ""
        });
      case RESET_CONFIRM_NEW_PASSWORD_ERROR:
        return lib_7({
          ...state,
          confirmNewPasswordError: ""
        });
      case DISABLE_SUBMIT:
        return lib_7({
          ...state,
          isSubmitting: action.payload
        });
      case PASSWORD_CHANGE_SUCCESS:
        return lib_7({
          ...state,
          passwordChanged: true
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          isSubmitting: true
        }, (state, dispatch) => handleSubmit(state, dispatch));
      default:
        return state;
    }
  }, initialState$a);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-password-change-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$a, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$a,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$a
  })));
};

function PasswordChangeCurrentPassword(props) {
  const {
    dispatch,
    state: {
      currentPassword,
      currentPasswordError
    }
  } = useContext(store$a);
  const handleBlur = useCallback(() => {
    return dispatch({
      type: VALIDATE_PASSWORD
    });
  }, [dispatch]);
  const handleInputChange = useCallback(value => {
    dispatch({
      type: SET_PASSWORD,
      payload: value
    });
  }, [dispatch]);
  const handleFocus = useCallback(() => {
    dispatch({
      type: RESET_PASSWORD_ERROR
    });
  }, [dispatch]);
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "password",
    value: currentPassword,
    error: currentPasswordError,
    onChange: e => handleInputChange(e.target.value),
    onBlur: handleBlur,
    onFocus: handleFocus
  }, props));
}

function PasswordChangeNewPassword(props) {
  const {
    dispatch,
    state: {
      newPassword,
      newPasswordError
    }
  } = useContext(store$a);
  const handleBlur = useCallback(() => {
    return dispatch({
      type: VALIDATE_NEW_PASSWORD
    });
  }, [dispatch]);
  const handleInputChange = useCallback(value => {
    dispatch({
      type: SET_NEW_PASSWORD,
      payload: value
    });
  }, [dispatch]);
  const handleFocus = useCallback(() => {
    dispatch({
      type: RESET_NEW_PASSWORD_ERROR
    });
  }, [dispatch]);
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "password",
    value: newPassword,
    error: newPasswordError,
    onChange: e => handleInputChange(e.target.value),
    onBlur: handleBlur,
    onFocus: handleFocus
  }, props));
}

function PasswordChangeConfirmNewPassword(props) {
  const {
    dispatch,
    state: {
      confirmNewPassword,
      confirmNewPasswordError
    }
  } = useContext(store$a);
  const handleBlur = useCallback(() => {
    return dispatch({
      type: VALIDATE_CONFIRM_NEW_PASSWORD
    });
  }, [dispatch]);
  const handleInputChange = useCallback(value => {
    dispatch({
      type: SET_CONFIRM_NEW_PASSWORD,
      payload: value
    });
  }, [dispatch]);
  const handleFocus = useCallback(() => {
    dispatch({
      type: RESET_CONFIRM_NEW_PASSWORD_ERROR
    });
  }, [dispatch]);
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "password",
    value: confirmNewPassword,
    error: confirmNewPasswordError,
    onChange: e => handleInputChange(e.target.value),
    onBlur: handleBlur,
    onFocus: handleFocus
  }, props));
}

const PasswordChangeButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    state: {
      isSubmitting,
      passwordChanged,
      currentPasswordError,
      newPasswordError,
      confirmNewPasswordError
    },
    dispatch
  } = useContext(store$a);
  const {
    t
  } = useTranslation("passwordChange");
  const hasInvalidField = currentPasswordError || newPasswordError || confirmNewPasswordError;
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: hasInvalidField || passwordChanged,
    isLoading: isSubmitting
  }, otherProps), name !== null && name !== void 0 ? name : t("submit"));
};

const PasswordChangeView = props => {
  const {
    t
  } = useTranslation("passwordChange");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-password-change-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("title"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(PasswordChangeContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement(PasswordChangeCurrentPassword, {
    id: "pelcro-input-password",
    errorId: "pelcro-input-password-error",
    label: t("currentPassword"),
    required: true
  }), /*#__PURE__*/React__default.createElement(PasswordChangeNewPassword, {
    id: "pelcro-input-new-password",
    errorId: "pelcro-input-new-password-error",
    label: t("newPassword"),
    required: true
  }), /*#__PURE__*/React__default.createElement(PasswordChangeConfirmNewPassword, {
    id: "pelcro-input-confirm-password",
    errorId: "pelcro-input-confirm-password-error",
    label: t("confirmNewPassword"),
    required: true
  }), /*#__PURE__*/React__default.createElement(PasswordChangeButton, {
    role: "submit",
    className: "plc-mt-2 plc-w-full",
    name: t("submit"),
    id: "pelcro-submit"
  }))));
};

const PasswordChangeModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-password-change-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(PasswordChangeView, otherProps)), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
PasswordChangeModal.viewId = "password-change";

const initialState$9 = {
  buttonDisabled: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$9 = /*#__PURE__*/createContext(initialState$9);
const {
  Provider: Provider$9
} = store$9;
const CartContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children
  } = _ref;
  const {
    cartItems,
    set
  } = usePelcro();
  const {
    t
  } = useTranslation("shop");
  useEffect(() => {
    dispatch({
      type: DISABLE_SUBMIT,
      payload: false
    });
    dispatch({
      type: SHOW_ALERT,
      payload: {
        type: "error",
        content: ""
      }
    });
    if (cartItems.length === 0) return;
    const itemsCurrencies = new Set(cartItems.map(item => item.currency));
    const cartHasMultipleCurrencies = itemsCurrencies.size > 1;
    if (cartHasMultipleCurrencies) {
      dispatch({
        type: DISABLE_SUBMIT,
        payload: true
      });
      dispatch({
        type: SHOW_ALERT,
        payload: {
          type: "error",
          content: t("messages.multipleCurrencies")
        }
      });
    } else {
      const userCurrency = window.Pelcro.user.read().currency;
      const itemsCurrency = cartItems[0].currency;
      if (userCurrency && userCurrency !== itemsCurrency) {
        dispatch({
          type: DISABLE_SUBMIT,
          payload: true
        });
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: t("messages.currencyMismatch", {
              currency: userCurrency.toUpperCase()
            })
          }
        });
      }
    }
  }, [cartItems]);
  const submit = (state, dispatch) => {
    set({
      order: [...cartItems]
    });
    onSuccess(cartItems);
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case DISABLE_SUBMIT:
        return lib_7({
          ...state,
          buttonDisabled: action.payload
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_4((state, dispatch) => submit());
      default:
        return state;
    }
  }, initialState$9);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-cart-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$9, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$9,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$9
  })));
};

const CartRemoveItemButton = _ref => {
  let {
    children,
    itemId,
    onClick,
    ...otherProps
  } = _ref;
  const {
    removeFromCart
  } = usePelcro();
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    variant: "icon",
    "data-key": itemId,
    icon: /*#__PURE__*/React__default.createElement(SvgXIcon, {
      "aria-hidden": "true",
      focusable: "false",
      height: "20",
      width: "20"
    }),
    className: "plc-bg-transparent plc-w-9 plc-h-9 plc-p-2",
    onClick: () => {
      removeFromCart(itemId);
      onClick === null || onClick === void 0 ? void 0 : onClick();
    }
  }, otherProps), children);
};

const CartSubmit = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    state: {
      buttonDisabled
    },
    dispatch
  } = useContext(store$9);
  const {
    t
  } = useTranslation("cart");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({}, otherProps, {
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: buttonDisabled
  }), name !== null && name !== void 0 ? name : t("confirm"));
};

function Badge(_ref) {
  let {
    className = "",
    badgeClassName = "",
    content,
    children,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement("div", Object.assign({
    className: `pelcro-badge-wrapper ${className}`
  }, otherProps), children, content && /*#__PURE__*/React__default.createElement("span", {
    className: `pelcro-badge ${badgeClassName}`
  }, content));
}

const CartTotalPrice = () => {
  const {
    state: {
      alert
    }
  } = useContext(store$9);
  const {
    cartItems
  } = usePelcro();
  const totalPriceCurrency = cartItems[0].currency;
  const {
    t
  } = useTranslation("cart");
  if (!alert.content) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", {
      className: "plc-mr-1 pelcro-cart-total-text"
    }, t("total"), ":"), /*#__PURE__*/React__default.createElement("p", {
      className: "pelcro-cart-total"
    }, calcAndFormatItemsTotal(cartItems, totalPriceCurrency)));
  }
  return null;
};

const CartView = props => {
  const {
    cartItems
  } = usePelcro();
  const {
    t
  } = useTranslation("cart");
  useEffect(() => {
    document.dispatchEvent(cartOpened(cartItems));
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-cart-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-2xl plc-font-semibold plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", null, t("title"))), cartItems.length ? /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form plc-text-gray-900"
  }, /*#__PURE__*/React__default.createElement(CartContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement("div", {
    className: "pelcro-cart-wrapper"
  }, cartItems.map(item => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: item.id,
      id: `pelcro-cart-product-${item.id}`,
      className: "plc-flex plc-items-center plc-pt-2 plc-mt-2 plc-border-t plc-border-gray-400 plc-min-h-12 plc-justify-evenly pelcro-cart-product-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-w-1/4 pelcro-cart-image-wrapper"
    }, item.image && /*#__PURE__*/React__default.createElement(Badge, {
      content: item.quantity
    }, /*#__PURE__*/React__default.createElement("img", {
      className: "plc-w-20 plc-h-20 pelcro-cart-product-image",
      alt: `image of ${item.name}`,
      src: item.image
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-w-2/5 plc-break-words pelcro-cart-product-name"
    }, item.name), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-w-1/5 plc-text-center pelcro-cart-product-price"
    }, calcAndFormatItemsTotal([item], item.currency)), /*#__PURE__*/React__default.createElement(CartRemoveItemButton, {
      itemId: item.id,
      id: `pelcro-remove-product-${item.id}`,
      "aria-label": "remove item from cart",
      onClick: () => document.dispatchEvent(cartItemRemoved(item))
    }));
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-justify-end plc-pt-2 plc-mt-2 plc-font-bold plc-border-t plc-border-gray-400 pelcro-cart-total-wrapper"
  }, /*#__PURE__*/React__default.createElement(CartTotalPrice, null)), /*#__PURE__*/React__default.createElement(CartSubmit, {
    role: "submit",
    className: "plc-w-full plc-mt-2",
    id: "pelcro-submit",
    name: t("confirm"),
    autoFocus: true
  }))) : /*#__PURE__*/React__default.createElement("p", {
    className: "plc-mt-4 plc-text-center pelcro-cart-empty"
  }, t("empty")));
};

const CartModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  const {
    switchView,
    switchToAddressView,
    isAuthenticated
  } = usePelcro();
  const onSuccess = items => {
    var _otherProps$onSuccess;
    (_otherProps$onSuccess = otherProps.onSuccess) === null || _otherProps$onSuccess === void 0 ? void 0 : _otherProps$onSuccess.call(otherProps, items);
    if (!isAuthenticated()) {
      return switchView("register");
    }
    switchToAddressView();
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-cart-modal",
    onDisplay: onDisplay,
    onClose: onClose,
    hideCloseButton: false
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(CartView, Object.assign({}, otherProps, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
CartModal.viewId = "cart";

const ShopSelectProductButton = _ref => {
  let {
    itemId,
    onClick,
    ...otherProps
  } = _ref;
  const {
    addToCart
  } = usePelcro();
  const {
    t
  } = useTranslation("shop");
  const [disabled, setDisabled] = useState(false);
  const [textContent, setTextContent] = useState(t("buttons.select"));
  const handleClick = () => {
    setDisabled(true);
    setTextContent(t("buttons.added"));
    addToCart(itemId);
    onClick === null || onClick === void 0 ? void 0 : onClick();
    setTimeout(() => {
      setDisabled(false);
      setTextContent(t("buttons.select"));
    }, 1000);
  };
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    "data-sku-id": itemId,
    id: `pelcro-shop-select-${itemId}`,
    onClick: handleClick,
    disabled: disabled
  }, otherProps), textContent);
};

const ShopPurchaseButton = _ref => {
  let {
    itemId,
    ...otherProps
  } = _ref;
  const {
    purchaseItem
  } = usePelcro();
  const {
    t
  } = useTranslation("shop");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({}, otherProps, {
    "data-sku-id": itemId,
    id: `pelcro-shop-purchase-${itemId}`,
    onClick: () => purchaseItem(itemId)
  }), t("buttons.purchase"));
};

const ShopView = () => {
  const skus = window.Pelcro.ecommerce.products.getSkus();
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-shop-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-grid plc-justify-center plc-rounded plc-justify-items-center plc-gap-y-5 plc-gap-x-3 pelcro-shop-products"
  }, skus.map(item => {
    return /*#__PURE__*/React__default.createElement("div", {
      key: item.id,
      className: "plc-flex plc-flex-col plc-items-center plc-p-2 plc-m-3 plc-border plc-border-gray-400 plc-border-solid plc-rounded-md plc-w-max pelcro-shop-product-wrapper"
    }, item.image && /*#__PURE__*/React__default.createElement("img", {
      className: "pelcro-shop-product-image",
      alt: `image of ${item.name}`,
      src: item.image
    }), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-flex plc-flex-col plc-items-center plc-mt-auto pelcro-shop-product-info-wrapper"
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "plc-font-bold pelcro-shop-product-name"
    }, item.name), /*#__PURE__*/React__default.createElement("p", {
      className: "plc-font-bold pelcro-shop-product-description"
    }, item.description), /*#__PURE__*/React__default.createElement(ShopSelectProductButton, {
      itemId: item.id,
      className: "plc-mt-2"
    }), /*#__PURE__*/React__default.createElement(ShopPurchaseButton, {
      itemId: item.id,
      className: "plc-mt-2 pelcro-purchase-button"
    })));
  })));
};
ShopView.viewId = "shop";

const OrderCreateSubmitButton = props => {
  return /*#__PURE__*/React__default.createElement(SubmitPaymentMethod, props);
};

const OrderCreateContainer = props => /*#__PURE__*/React__default.createElement(PaymentMethodContainer, Object.assign({
  type: "orderCreate",
  className: "pelcro-order-create-container"
}, props));

const OrderCreateView = props => {
  var _window$Pelcro, _window$Pelcro$uiSett;
  const {
    t
  } = useTranslation("payment");
  const {
    order
  } = usePelcro();
  const skipPayment = (_window$Pelcro = window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.skipPaymentForFreePlans;
  const showOrderButton = skipPayment && ((order === null || order === void 0 ? void 0 : order.price) === 0 || (order === null || order === void 0 ? void 0 : order.length) > 0 && order.every(item => (item === null || item === void 0 ? void 0 : item.price) === 0));
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-order-create-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-2xl plc-font-semibold plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", null, t("labels.checkout.title"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(PaymentMethodView, Object.assign({
    type: "orderCreate",
    showCoupon: true,
    showExternalPaymentMethods: false,
    showApplePayButton: true,
    showOrderButton: showOrderButton,
    order: order
  }, props))));
};

const OrderCreateModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  const {
    switchView
  } = usePelcro();
  const onSuccess = () => {
    var _otherProps$onSuccess;
    (_otherProps$onSuccess = otherProps.onSuccess) === null || _otherProps$onSuccess === void 0 ? void 0 : _otherProps$onSuccess.call(otherProps);
    return switchView("order-confirm");
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-order-create-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(OrderCreateView, Object.assign({}, otherProps, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
OrderCreateModal.viewId = "order-create";

const OrderConfirmModal = props => {
  var _latestOrder$coupon;
  const userOrders = window.Pelcro.user.read().orders;
  const latestOrder = userOrders === null || userOrders === void 0 ? void 0 : userOrders[userOrders.length - 1];
  const latestOrderDiscount = latestOrder === null || latestOrder === void 0 ? void 0 : (_latestOrder$coupon = latestOrder.coupon) === null || _latestOrder$coupon === void 0 ? void 0 : _latestOrder$coupon.percent_off;
  const {
    t
  } = useTranslation("shop");
  const {
    resetView
  } = usePelcro();
  const onClose = () => {
    var _props$onClose;
    props === null || props === void 0 ? void 0 : (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
    resetView();
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-order-confirm-modal",
    className: "plc-border-t-8 plc-border-primary-500",
    onClose: props.onClose,
    onDisplay: props.onDisplay
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-order-confirm-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-flex-col plc-items-center"
  }, /*#__PURE__*/React__default.createElement(SvgCheckSolid, {
    className: "plc-w-32 plc-my-4 plc-text-green-500"
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-text-center plc-text-gray-900"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-mb-4 plc-text-3xl"
  }, t("messages.orderConfirmed.title")), /*#__PURE__*/React__default.createElement("p", null, t("messages.orderConfirmed.body")), /*#__PURE__*/React__default.createElement("p", null, t("messages.haveQuestions")))), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mt-5 pelcro-order-summary-wrapper"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "plc-font-bold pelcro-order-summary-title"
  }, t("labels.summary")), latestOrder === null || latestOrder === void 0 ? void 0 : latestOrder.items.map(item => {
    const itemImage = window.Pelcro.ecommerce.products.getBySkuId(item.product_sku_id).image;
    return /*#__PURE__*/React__default.createElement("div", {
      key: item.product_sku_id,
      id: `pelcro-summary-product-${item.product_sku_id}`,
      className: "plc-flex plc-items-center plc-pt-2 plc-mt-2 plc-border-t plc-border-gray-400 plc-min-h-12 plc-justify-evenly pelcro-summary-product-wrapper"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-w-1/4 pelcro-summary-image-wrapper"
    }, itemImage && /*#__PURE__*/React__default.createElement(Badge, {
      content: item.quantity
    }, /*#__PURE__*/React__default.createElement("img", {
      className: "plc-object-contain plc-w-20 plc-h-20 pelcro-summary-product-image",
      alt: `image of ${item.product_sku_name}`,
      src: itemImage
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-w-1/2 plc-break-words pelcro-summary-product-name"
    }, item.product_sku_name), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-w-1/5 plc-text-center pelcro-summary-product-price"
    }, calcAndFormatItemsTotal([item], latestOrder === null || latestOrder === void 0 ? void 0 : latestOrder.currency)));
  }), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-justify-end plc-pt-2 plc-mt-2 plc-font-bold plc-border-t plc-border-gray-400 pelcro-summary-total-wrapper"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "plc-mr-1 pelcro-summary-total-text"
  }, t("labels.total")), /*#__PURE__*/React__default.createElement("p", {
    className: "pelcro-summary-total"
  }, latestOrderDiscount && `(-${latestOrderDiscount}%) `, getFormattedPriceByLocal(latestOrder === null || latestOrder === void 0 ? void 0 : latestOrder.amount, latestOrder === null || latestOrder === void 0 ? void 0 : latestOrder.currency, getPageOrDefaultLanguage())))), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-justify-center plc-mt-6"
  }, /*#__PURE__*/React__default.createElement(Button, {
    id: "pelcro-submit",
    onClick: onClose,
    autoFocus: true
  }, t("buttons.continue"))))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
OrderConfirmModal.viewId = "order-confirm";

const initialState$8 = {
  email: "",
  firstName: "",
  lastName: "",
  startDate: null,
  giftMessage: "",
  buttonDisabled: true,
  alert: {
    type: "error",
    content: ""
  }
};
const store$8 = /*#__PURE__*/createContext(initialState$8);
const {
  Provider: Provider$8
} = store$8;
const GiftCreateContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children
  } = _ref;
  const {
    t
  } = useTranslation("register");
  const {
    set
  } = usePelcro();
  const handleSubmit = (state, dispatch) => {
    const giftRecipient = {
      email: state.email,
      firstName: state.firstName,
      lastName: state.lastName,
      startDate: state.startDate,
      giftMessage: state.giftMessage
    };
    if (!giftRecipient.email) {
      dispatch({
        type: SHOW_ALERT,
        payload: {
          type: "error",
          content: t("gift.messages.enterEmail")
        }
      });
      return onFailure();
    }
    if (giftRecipient.startDate) {
      const nowDate = getDateWithoutTime(new Date());
      const yearFromNowDate = getDateWithoutTime(new Date(new Date().setFullYear(nowDate.getFullYear() + 1)));
      const submittedDate = getDateWithoutTime(new Date(giftRecipient.startDate));
      if (submittedDate < nowDate || submittedDate > yearFromNowDate) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: t("gift.messages.invalidDate")
          }
        });
        return onFailure();
      }
    }
    set({
      giftRecipient
    });
    return onSuccess(giftRecipient);
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SET_EMAIL:
        return lib_7({
          ...state,
          email: action.payload
        });
      case SET_FIRST_NAME:
        return lib_7({
          ...state,
          firstName: action.payload
        });
      case SET_LAST_NAME:
        return lib_7({
          ...state,
          lastName: action.payload
        });
      case SET_START_DATE:
        return lib_7({
          ...state,
          startDate: action.payload
        });
      case SET_GIFT_MESSAGE:
        return lib_7({
          ...state,
          giftMessage: action.payload
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case DISABLE_SUBMIT:
        return lib_7({
          ...state,
          buttonDisabled: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          buttonDisabled: true
        }, (state, dispatch) => handleSubmit(state, dispatch));
      default:
        return state;
    }
  }, initialState$8);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-gift-create-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$8, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$8,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$8
  })));
};

const GiftCreateSubmitButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      disableSubmit
    }
  } = useContext(store$8);
  const {
    t
  } = useTranslation("register");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: disableSubmit
  }, otherProps), name !== null && name !== void 0 ? name : t("gift.buttons.gift"));
};

const GiftCreateEmail = props => /*#__PURE__*/React__default.createElement(Email, Object.assign({
  initWithUserEmail: false,
  store: store$8
}, props));

const GiftCreateFirstName = props => /*#__PURE__*/React__default.createElement(FirstName, Object.assign({
  initWithUserFirstName: false,
  store: store$8
}, props));

const GiftCreateLastName = props => /*#__PURE__*/React__default.createElement(LastName, Object.assign({
  initWithUserLastName: false,
  store: store$8
}, props));

const nowDate = new Date();
const nowDateISO = nowDate.toISOString().substr(0, 10);
const yearFromNowDateISO = new Date(new Date().setFullYear(nowDate.getFullYear() + 1)).toISOString().substr(0, 10);
const GiftCreateStartDate = props => {
  var _state$startDate;
  const {
    t
  } = useTranslation("register");
  const {
    dispatch,
    state
  } = useContext(store$8);
  const handleInputChange = value => {
    dispatch({
      type: SET_START_DATE,
      payload: value
    });
  };
  if (state.loading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(DatePicker, Object.assign({
    min: nowDateISO,
    max: yearFromNowDateISO,
    value: (_state$startDate = state.startDate) !== null && _state$startDate !== void 0 ? _state$startDate : nowDateISO,
    onChange: e => handleInputChange(e.target.value),
    tooltipText: t("gift.messages.giftDateInfo")
  }, props));
};

/**
 *
 */
function GiftCreateMessage(props) {
  var _ref, _state$giftMessage;
  const {
    t
  } = useTranslation("register");
  const {
    dispatch,
    state
  } = useContext(store$8);
  const MAX_CHARS_COUNT = 200;
  const remainingCharsCount = (_ref = MAX_CHARS_COUNT - ((_state$giftMessage = state.giftMessage) === null || _state$giftMessage === void 0 ? void 0 : _state$giftMessage.length)) !== null && _ref !== void 0 ? _ref : 0;
  const handleInputChange = value => {
    dispatch({
      type: SET_GIFT_MESSAGE,
      payload: value
    });
  };
  if (state.loading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(TextArea, Object.assign({
    onChange: e => handleInputChange(e.target.value),
    value: state.giftMessage,
    maxLength: "200",
    rows: 3,
    label: t("gift.labels.giftMessage", {
      count: remainingCharsCount
    }),
    tooltipText: t("gift.messages.giftMessageInfo")
  }, props));
}

const GiftCreateView = props => {
  const {
    t
  } = useTranslation("register");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-gift-create-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-2xl plc-font-semibold plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", null, t("gift.titles.firstTitle"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(GiftCreateContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start"
  }, /*#__PURE__*/React__default.createElement(GiftCreateEmail, {
    id: "pelcro-input-email",
    errorId: "pelcro-input-email-error",
    autoComplete: "off",
    label: t("gift.labels.email"),
    required: true,
    autoFocus: true
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start"
  }, /*#__PURE__*/React__default.createElement(GiftCreateFirstName, {
    autoComplete: "first-name",
    id: "pelcro-input-first-name",
    errorId: "pelcro-input-first-name-error",
    label: t("gift.labels.firstName")
  }), /*#__PURE__*/React__default.createElement(GiftCreateLastName, {
    wrapperClassName: "plc-ml-3",
    autoComplete: "last-name",
    id: "pelcro-input-last-name",
    errorId: "pelcro-input-last-name-error",
    label: t("gift.labels.lastName")
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start"
  }, /*#__PURE__*/React__default.createElement(GiftCreateStartDate, {
    autoComplete: "start-date",
    id: "pelcro-input-start-date",
    errorId: "pelcro-input-start-date-error",
    label: t("gift.labels.startDate")
  })), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start"
  }, /*#__PURE__*/React__default.createElement(GiftCreateMessage, {
    autoComplete: "gift-message",
    id: "pelcro-input-gift-message",
    errorId: "pelcro-input-gift-message-error"
  })), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-text-gray-900 pelcro-footnote"
  }, "* ", t("gift.labels.required")), /*#__PURE__*/React__default.createElement(GiftCreateSubmitButton, {
    role: "submit",
    className: "plc-w-full plc-mt-2",
    name: t("gift.buttons.gift"),
    id: "pelcro-submit"
  }))));
};

const GiftCreateModal = _ref => {
  let {
    onDisplay,
    onClose,
    hideHeaderLogo,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("register");
  const {
    switchView,
    switchToAddressView,
    switchToPaymentView,
    product
  } = usePelcro();
  const onSuccess = giftRecipient => {
    var _otherProps$onSuccess;
    (_otherProps$onSuccess = otherProps.onSuccess) === null || _otherProps$onSuccess === void 0 ? void 0 : _otherProps$onSuccess.call(otherProps, giftRecipient);
    if (product.address_required) {
      switchToAddressView();
    } else {
      switchToPaymentView();
    }
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-gift-create-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(GiftCreateView, Object.assign({}, otherProps, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement("p", null, t("messages.selectPlan") + " ", /*#__PURE__*/React__default.createElement(Link, {
    id: "pelcro-link-select-plan",
    onClick: () => switchView("plan-select")
  }, t("messages.here"))), /*#__PURE__*/React__default.createElement(Authorship, null)));
};
GiftCreateModal.viewId = "gift-create";

const initialState$7 = {
  isSubmitting: false,
  giftCode: "",
  buttonDisabled: true,
  alert: {
    type: "error",
    content: ""
  }
};
const store$7 = /*#__PURE__*/createContext(initialState$7);
const {
  Provider: Provider$7
} = store$7;
const GiftRedeemContainer = _ref => {
  var _ref2, _props$subscriptionId;
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    onDisplay = () => {},
    children,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation("register");
  const {
    set
  } = usePelcro();
  const {
    switchView,
    switchToAddressView,
    isAuthenticated,
    subscriptionIdToRenew: subscriptionIdToRenewFromStore
  } = usePelcro();
  const subscriptionIdToRenew = (_ref2 = (_props$subscriptionId = props.subscriptionIdToRenew) !== null && _props$subscriptionId !== void 0 ? _props$subscriptionId : subscriptionIdToRenewFromStore) !== null && _ref2 !== void 0 ? _ref2 : undefined;
  useEffect(() => {
    onDisplay();
  }, []);
  const handleRedeem = (_ref3, dispatch) => {
    let {
      giftCode
    } = _ref3;
    if (!giftCode) {
      dispatch({
        type: SHOW_ALERT,
        payload: {
          type: "error",
          content: t("redeem.messages.enterGiftCode")
        }
      });
      onFailure();
    } else {
      set({
        giftCode
      });
      if (!isAuthenticated()) {
        switchView("register");
      } else {
        window.Pelcro.subscription.redeemGift({
          auth_token: window.Pelcro.user.read().auth_token,
          gift_code: giftCode,
          // redeem gift as a future phase of an existing subscription
          subscription_id: subscriptionIdToRenew
        }, (err, res) => {
          dispatch({
            type: LOADING,
            payload: false
          });
          if (err) {
            var _err$response, _err$response$data, _err$response$data$er;
            dispatch({
              type: SHOW_ALERT,
              payload: {
                type: "error",
                content: getErrorMessages(err)
              }
            });
            if ((_err$response = err.response) !== null && _err$response !== void 0 && (_err$response$data = _err$response.data) !== null && _err$response$data !== void 0 && (_err$response$data$er = _err$response$data.errors) !== null && _err$response$data$er !== void 0 && _err$response$data$er.address_id) {
              switchToAddressView();
            } else {
              return onFailure(err);
            }
          } else {
            return onSuccess(giftCode);
          }
        });
      }
    }
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SET_GIFT_CODE:
        return lib_7({
          ...state,
          giftCode: action.payload
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case DISABLE_SUBMIT:
        return lib_7({
          ...state,
          buttonDisabled: action.payload
        });
      case LOADING:
        return lib_7({
          ...state,
          isSubmitting: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          isSubmitting: true,
          buttonDisabled: true
        }, (state, dispatch) => handleRedeem(state, dispatch));
      default:
        return state;
    }
  }, initialState$7);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-gift-redeem-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$7, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$7,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$7
  })));
};

function GiftCode(_ref) {
  let {
    store,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state
  } = useContext(store);
  const handleInputChange = value => {
    dispatch({
      type: SET_GIFT_CODE,
      payload: value
    });
  };
  useEffect(() => {
    const giftCode = window.Pelcro.helpers.getURLParameter("gift_code") ? window.Pelcro.helpers.getURLParameter("gift_code") : "";
    handleInputChange(giftCode);
  }, []);
  if (state.loading) {
    return /*#__PURE__*/React__default.createElement(Loader, null);
  }
  return /*#__PURE__*/React__default.createElement(Input, Object.assign({
    type: "text",
    value: state.giftCode || null,
    onChange: e => handleInputChange(e.target.value)
  }, otherProps));
}

const GiftRedeemCode = props => /*#__PURE__*/React__default.createElement(GiftCode, Object.assign({
  store: store$7
}, props));

const GiftRedeemSubmitButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      disableSubmit,
      isSubmitting
    }
  } = useContext(store$7);
  const {
    t
  } = useTranslation("register");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: disableSubmit,
    isLoading: isSubmitting
  }, otherProps), name !== null && name !== void 0 ? name : t("redeem.buttons.redeem"));
};

const GiftRedeemView = props => {
  const {
    t
  } = useTranslation("register");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-gift-redeem-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("redeem.titles.firstTitle")), /*#__PURE__*/React__default.createElement("p", null, t("redeem.titles.secondTitle"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(GiftRedeemContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-start"
  }, /*#__PURE__*/React__default.createElement(GiftRedeemCode, {
    id: "pelcro-input-gift-code",
    errorId: "pelcro-input-gift-code-error",
    label: t("redeem.labels.code"),
    required: true,
    autoFocus: true
  })), /*#__PURE__*/React__default.createElement(GiftRedeemSubmitButton, {
    role: "submit",
    className: "plc-mt-2 plc-w-full",
    id: "pelcro-submit",
    name: t("redeem.buttons.redeem")
  }))));
};

const GiftRedeemModal = _ref => {
  let {
    onClose,
    onDisplay,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("register");
  const {
    switchView,
    switchToAddressView,
    isAuthenticated
  } = usePelcro();
  const onSuccess = giftCode => {
    var _otherProps$onSuccess;
    (_otherProps$onSuccess = otherProps.onSuccess) === null || _otherProps$onSuccess === void 0 ? void 0 : _otherProps$onSuccess.call(otherProps, giftCode);
    switchView("subscription-success");
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-gift-redeem-modal",
    onClose: onClose,
    onDisplay: onDisplay
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(GiftRedeemView, Object.assign({}, otherProps, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, isAuthenticated() && /*#__PURE__*/React__default.createElement("p", null, t("redeem.footer.click"), " ", /*#__PURE__*/React__default.createElement(Link, {
    id: "pelcro-link-redeem",
    onClick: switchToAddressView
  }, t("redeem.footer.here")), " ", t("redeem.footer.toAdd")), /*#__PURE__*/React__default.createElement(Authorship, null)));
};
GiftRedeemModal.viewId = "gift-redeem";

const getDefaultAddress = addresses => {
  return addresses.find(address => address.is_default) || false;
};
const moveDefaultAddressToStart = addresses => {
  const defaultAddress = getDefaultAddress(addresses);
  const addressesWithoutDefault = addresses.filter(address => !address.is_default);
  return [defaultAddress, ...addressesWithoutDefault];
};
const initialState$6 = {
  addresses: [],
  selectedAddressId: null,
  isSubmitting: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$6 = /*#__PURE__*/createContext(initialState$6);
const {
  Provider: Provider$6
} = store$6;
const AddressSelectContainer = _ref => {
  var _props$giftCode, _ref2, _props$subscriptionId;
  let {
    style,
    className = "",
    onGiftRedemptionSuccess = () => {},
    onMembershipAdressUpdateSuccess = () => {},
    onSuccess = () => {},
    onFailure = () => {},
    children,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation("address");
  const {
    switchView,
    giftCode: giftCodeFromStore,
    subscriptionIdToRenew: subscriptionIdToRenewFromStore,
    set,
    selectedMembership
  } = usePelcro();
  const giftCode = (_props$giftCode = props.giftCode) !== null && _props$giftCode !== void 0 ? _props$giftCode : giftCodeFromStore;
  const subscriptionIdToRenew = (_ref2 = (_props$subscriptionId = props.subscriptionIdToRenew) !== null && _props$subscriptionId !== void 0 ? _props$subscriptionId : subscriptionIdToRenewFromStore) !== null && _ref2 !== void 0 ? _ref2 : undefined;
  const submitAddress = (_ref3, dispatch) => {
    let {
      selectedAddressId
    } = _ref3;
    set({
      selectedAddressId
    });
    if (selectedMembership) {
      dispatch({
        type: LOADING,
        payload: true
      });
      return window.Pelcro.membership.update({
        auth_token: window.Pelcro.user.read().auth_token,
        address_id: selectedAddressId,
        membership_id: selectedMembership.id
      }, (err, res) => {
        dispatch({
          type: LOADING,
          payload: false
        });
        if (err) {
          dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
          return onFailure(err);
        }
        notify$1.success(t("messages.addressUpdated"));
        return onMembershipAdressUpdateSuccess(res);
      });
    }
    if (giftCode) {
      dispatch({
        type: LOADING,
        payload: true
      });
      return window.Pelcro.subscription.redeemGift({
        auth_token: window.Pelcro.user.read().auth_token,
        gift_code: giftCode,
        address_id: selectedAddressId,
        // redeem gift as a future phase of an existing subscription
        subscription_id: subscriptionIdToRenew
      }, (err, res) => {
        dispatch({
          type: LOADING,
          payload: false
        });
        if (err) {
          dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
          return onFailure(err);
        }
        return onGiftRedemptionSuccess(res);
      });
    }
    onSuccess(selectedAddressId);
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SELECT_ADDRESS:
        return lib_7({
          ...state,
          selectedAddressId: action.payload
        });
      case LOAD_ADDRESSES:
        if (!getDefaultAddress) {
          return switchView("address-select");
        } else {
          var _selectedMembership$a;
          return lib_7({
            ...state,
            addresses: moveDefaultAddressToStart(action.payload),
            selectedAddressId: String((_selectedMembership$a = selectedMembership === null || selectedMembership === void 0 ? void 0 : selectedMembership.address_id) !== null && _selectedMembership$a !== void 0 ? _selectedMembership$a : getDefaultAddress(action.payload).id)
          });
        }
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case LOADING:
        return lib_7({
          ...state,
          isSubmitting: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          isSubmitting: true
        }, (state, dispatch) => submitAddress(state, dispatch));
      default:
        return state;
    }
  }, initialState$6);
  useEffect(() => {
    var _window$Pelcro$user$r;
    dispatch({
      type: LOAD_ADDRESSES,
      payload: (_window$Pelcro$user$r = window.Pelcro.user.read().addresses) !== null && _window$Pelcro$user$r !== void 0 ? _window$Pelcro$user$r : []
    });
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-address-select-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$6, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$6,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$6
  })));
};

const AddressSelectList = () => {
  const {
    dispatch,
    state: {
      addresses,
      selectedAddressId
    }
  } = useContext(store$6);
  const handleAddressSelect = event => {
    dispatch({
      type: SELECT_ADDRESS,
      payload: event.target.value
    });
  };
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-overflow-y-scroll plc-max-h-80 pelcro-addresses-select-wrapper"
  }, addresses.map(address => address.type === "shipping" && /*#__PURE__*/React__default.createElement("div", {
    key: address.id,
    className: "plc-p-2 plc-mx-3 plc-mt-2 plc-border plc-border-gray-400 plc-border-solid plc-rounded plc-text-gray-900 pelcro-address-wrapper"
  }, /*#__PURE__*/React__default.createElement(Radio, {
    className: "plc-self-start pelcro-select-address-radio",
    labelClassName: "plc-cursor-pointer plc-w-full",
    id: `pelcro-address-select-${address.id}`,
    name: "address",
    checked: selectedAddressId === String(address.id),
    value: address.id,
    onChange: handleAddressSelect
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "pelcro-address-name"
  }, address.first_name, " ", address.last_name), /*#__PURE__*/React__default.createElement("p", {
    className: "pelcro-address-company"
  }, address.company), /*#__PURE__*/React__default.createElement("p", {
    className: "pelcro-address-line1"
  }, address.line1), /*#__PURE__*/React__default.createElement("p", {
    className: "pelcro-address-country"
  }, address.city, ", ", address.state_name, " ", address.postal_code, ", ", address.country_name)))));
};

const AddressSelectSubmit = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      selectedAddressId,
      isSubmitting
    }
  } = useContext(store$6);
  const {
    t
  } = useTranslation("address");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: selectedAddressId === "undefined" || selectedAddressId === null || !selectedAddressId,
    isLoading: isSubmitting
  }, otherProps), name !== null && name !== void 0 ? name : t("buttons.submit"));
};

const AddressSelectView = props => {
  const {
    t
  } = useTranslation("address");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-address-select-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("selectAddressTitle")), /*#__PURE__*/React__default.createElement("p", null, t("selectAddressSubtitle"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(AddressSelectContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement(AddressSelectList, null), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-justify-center plc-mt-4"
  }, /*#__PURE__*/React__default.createElement(Link, {
    id: "pelcro-add-address",
    onClick: props.onAddNewAddress
  }, t("buttons.addAddress"))), /*#__PURE__*/React__default.createElement(AddressSelectSubmit, {
    role: "submit",
    className: "plc-mt-4 plc-w-full",
    name: t("buttons.selectAddress"),
    id: "pelcro-submit"
  }))));
};

const AddressSelectModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  const {
    switchView,
    switchToPaymentView,
    resetView
  } = usePelcro();
  const onSuccess = selectedAddressId => {
    var _otherProps$onSuccess;
    (_otherProps$onSuccess = otherProps.onSuccess) === null || _otherProps$onSuccess === void 0 ? void 0 : _otherProps$onSuccess.call(otherProps, selectedAddressId);
    switchToPaymentView();
  };
  const onGiftRedemptionSuccess = () => {
    var _otherProps$onGiftRed;
    (_otherProps$onGiftRed = otherProps.onGiftRedemptionSuccess) === null || _otherProps$onGiftRed === void 0 ? void 0 : _otherProps$onGiftRed.call(otherProps);
    switchView("subscription-success");
  };
  const onAddNewAddress = () => {
    switchView("address-create");
  };

  // FIXME: implement me
  const onMembershipAdressUpdateSuccess = () => {
    var _otherProps$onMembers;
    (_otherProps$onMembers = otherProps.onMembershipAdressUpdateSuccess) === null || _otherProps$onMembers === void 0 ? void 0 : _otherProps$onMembers.call(otherProps);
    resetView();
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    onDisplay: onDisplay,
    onClose: onClose,
    id: "pelcro-address-select-modal"
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(AddressSelectView, Object.assign({
    onAddNewAddress: onAddNewAddress
  }, otherProps, {
    onSuccess: onSuccess,
    onGiftRedemptionSuccess: onGiftRedemptionSuccess,
    onMembershipAdressUpdateSuccess: onMembershipAdressUpdateSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
AddressSelectModal.viewId = "address-select";

const moveDefaultPaymentMethodToStart = paymentMethods => {
  const defaultPaymentMethod = getDefaultPaymentMethod(paymentMethods);
  const paymentMethodsWithoutDefault = paymentMethods.filter(paymentMethod => paymentMethod.id !== defaultPaymentMethod.id);
  if (defaultPaymentMethod.status !== "chargeable") {
    return paymentMethodsWithoutDefault;
  }
  return [defaultPaymentMethod, ...paymentMethodsWithoutDefault];
};
const getDefaultPaymentMethod = paymentMethods => {
  const defaultPaymentMethod = paymentMethods.find(paymentMethod => paymentMethod.is_default);
  return defaultPaymentMethod;
};
const initialState$5 = {
  paymentMethods: [],
  selectedPaymentMethodId: null,
  skeletonLoader: true,
  isSubmitting: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$5 = /*#__PURE__*/createContext(initialState$5);
const {
  Provider: Provider$5
} = store$5;
const PaymentMethodSelectContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    children
  } = _ref;
  const {
    set,
    selectedPaymentMethodId: selectedPaymentMethodIdFromStore
  } = usePelcro();
  const submitPaymentMethod = _ref2 => {
    let {
      selectedPaymentMethodId
    } = _ref2;
    set({
      selectedPaymentMethodId
    });
    return onSuccess(selectedPaymentMethodId);
  };
  const getInitialSelectedMethodId = paymentMethods => {
    if (selectedPaymentMethodIdFromStore) {
      return selectedPaymentMethodIdFromStore;
    }
    const defaultMethod = getDefaultPaymentMethod(paymentMethods);
    if (defaultMethod && defaultMethod.status === "chargeable") {
      return String(defaultMethod.id);
    }
    return null;
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SELECT_PAYMENT_METHOD:
        return lib_7({
          ...state,
          selectedPaymentMethodId: action.payload
        });
      case LOAD_PAYMENT_METHODS:
        return lib_7({
          ...state,
          paymentMethods: moveDefaultPaymentMethodToStart(action.payload),
          selectedPaymentMethodId: getInitialSelectedMethodId(action.payload)
        });
      case SKELETON_LOADER:
        return lib_7({
          ...state,
          skeletonLoader: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          isSubmitting: true
        }, (state, dispatch) => submitPaymentMethod(state));
      default:
        return state;
    }
  }, initialState$5);
  useEffect(() => {
    window.Pelcro.paymentMethods.list({
      auth_token: window.Pelcro.user.read().auth_token
    }, (err, res) => {
      if (err) {
        return console.error(err);
      }
      if (res) {
        var _res$data;
        dispatch({
          type: LOAD_PAYMENT_METHODS,
          payload: (_res$data = res.data) !== null && _res$data !== void 0 ? _res$data : []
        });
        dispatch({
          type: SKELETON_LOADER,
          payload: false
        });
      }
    });
  }, []);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-payment-select-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$5, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$5,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$5
  })));
};

const PaymentMethodSelectList = () => {
  const {
    t
  } = useTranslation("paymentMethod");
  const {
    dispatch,
    state: {
      paymentMethods,
      selectedPaymentMethodId,
      skeletonLoader
    }
  } = useContext(store$5);
  const handlePaymentMethodSelect = event => {
    dispatch({
      type: SELECT_PAYMENT_METHOD,
      payload: event.target.value
    });
  };
  return /*#__PURE__*/React__default.createElement("div", null, skeletonLoader ? /*#__PURE__*/React__default.createElement("div", {
    className: "plc-w-full plc-h-20 plc-bg-gray-300 plc-rounded-md plc-animate-pulse"
  }) : /*#__PURE__*/React__default.createElement("div", {
    className: "plc-px-3 plc-py-2 plc-space-y-4 plc-overflow-y-scroll plc-max-h-80 pelcro-payment-method-select-wrapper"
  }, paymentMethods.map(paymentMethod => {
    var _paymentMethod$proper, _paymentMethod$proper2, _paymentMethod$proper3, _paymentMethod$proper4;
    const isSelected = selectedPaymentMethodId === String(paymentMethod.id);
    return /*#__PURE__*/React__default.createElement("div", {
      key: paymentMethod.id,
      className: `plc-p-2 plc-pl-4 plc-shadow-md plc-text-gray-900 plc-rounded pelcro-payment-method-wrapper ${isSelected ? "plc-ring-2 plc-ring-primary-400" : "plc-ring-1 plc-ring-gray-200"}`
    }, /*#__PURE__*/React__default.createElement(Radio, {
      className: "plc-flex plc-items-center pelcro-select-payment-method-radio",
      labelClassName: "plc-flex plc-items-center plc-space-x-2 plc-cursor-pointer plc-w-full",
      id: `pelcro-payment-method-select-${paymentMethod.id}`,
      name: "paymentMethod",
      checked: isSelected,
      value: paymentMethod.id,
      onChange: handlePaymentMethodSelect
    }, getPaymentCardIcon$1((_paymentMethod$proper = paymentMethod.properties) === null || _paymentMethod$proper === void 0 ? void 0 : _paymentMethod$proper.brand), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-flex plc-flex-col plc-text-lg pelcro-payment-method-details"
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "plc-font-semibold"
    }, "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022 ", (_paymentMethod$proper2 = paymentMethod.properties) === null || _paymentMethod$proper2 === void 0 ? void 0 : _paymentMethod$proper2.last4), /*#__PURE__*/React__default.createElement("p", {
      className: "plc-text-sm plc-text-gray-500"
    }, t("select.expires"), " ", (_paymentMethod$proper3 = paymentMethod.properties) === null || _paymentMethod$proper3 === void 0 ? void 0 : _paymentMethod$proper3.exp_month, "/", (_paymentMethod$proper4 = paymentMethod.properties) === null || _paymentMethod$proper4 === void 0 ? void 0 : _paymentMethod$proper4.exp_year))));
  })));
};

const PaymentMethodSelectSubmit = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("paymentMethod");
  const {
    dispatch,
    state: {
      selectedPaymentMethodId,
      isSubmitting
    }
  } = useContext(store$5);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: !selectedPaymentMethodId,
    isLoading: isSubmitting
  }, otherProps), name !== null && name !== void 0 ? name : t("select.buttons.selectPaymentMethod"));
};

const PaymentMethodSelectView = props => {
  const {
    t
  } = useTranslation("paymentMethod");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-payment-method-select-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-space-y-2 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("select.title")), /*#__PURE__*/React__default.createElement("p", null, t("select.subtitle"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(PaymentMethodSelectContainer, props, /*#__PURE__*/React__default.createElement(PaymentMethodSelectList, null), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-justify-center plc-mt-4"
  }, /*#__PURE__*/React__default.createElement(Link, {
    id: "pelcro-add-payment-method",
    onClick: props.onAddNewPaymentMethod
  }, t("select.buttons.addPaymentMethod"))), /*#__PURE__*/React__default.createElement(PaymentMethodSelectSubmit, {
    role: "submit",
    className: "plc-w-full plc-mt-4",
    id: "pelcro-submit"
  }))));
};

const PaymentMethodSelectModal = _ref => {
  var _window$Pelcro, _window$Pelcro$uiSett;
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  const {
    switchToCheckoutForm,
    set,
    plan,
    order
  } = usePelcro();
  const skipPayment = (_window$Pelcro = window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.skipPaymentForFreePlans;
  useEffect(() => {
    if (skipPayment && ((plan === null || plan === void 0 ? void 0 : plan.amount) === 0 || (order === null || order === void 0 ? void 0 : order.price) === 0)) {
      switchToCheckoutForm();
    }
  }, []);
  const onSuccess = selectedPaymentMethodId => {
    var _otherProps$onSuccess;
    (_otherProps$onSuccess = otherProps.onSuccess) === null || _otherProps$onSuccess === void 0 ? void 0 : _otherProps$onSuccess.call(otherProps, selectedPaymentMethodId);
    switchToCheckoutForm();
  };
  const onAddNewPaymentMethod = () => {
    set({
      selectedPaymentMethodId: null
    });
    switchToCheckoutForm();
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    onDisplay: onDisplay,
    onClose: onClose,
    id: "pelcro-payment-method-select-modal"
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(PaymentMethodSelectView, Object.assign({
    onAddNewPaymentMethod: onAddNewPaymentMethod
  }, otherProps, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
PaymentMethodSelectModal.viewId = "payment-method-select";

const initialState$4 = {
  paymentMethods: [],
  selectedPaymentMethodId: null,
  isSubmitting: false,
  disableSubmit: true,
  isLoading: false,
  skeletonLoader: true,
  showPaymentMethodSelect: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$4 = /*#__PURE__*/createContext(initialState$4);
const {
  Provider: Provider$4
} = store$4;
const PaymentMethodDeleteContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children
  } = _ref;
  const {
    paymentMethodToDelete
  } = usePelcro();
  useEffect(() => {
    window.Pelcro.paymentMethods.list({
      auth_token: window.Pelcro.user.read().auth_token
    }, (err, res) => {
      if (err) {
        return console.error(err);
      }
      if (res) {
        dispatch({
          type: SET_PAYMENT_METHODS,
          payload: res.data
        });
        dispatch({
          type: SKELETON_LOADER,
          payload: false
        });
        if (res.data.length !== 1 && paymentMethodToDelete.is_default && paymentMethodToDelete.deletable) {
          dispatch({
            type: SHOW_PAYMENT_METHOD_SELECT,
            payload: true
          });
        }
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
      }
    });
  }, [paymentMethodToDelete]); // eslint-disable-line react-hooks/exhaustive-deps

  const setDefaultPaymentMethod = () => {
    const {
      selectedPaymentMethodId: paymentMethodId
    } = state;
    window.Pelcro.paymentMethods.update({
      auth_token: window.Pelcro.user.read().auth_token,
      payment_method_id: paymentMethodId,
      is_default: true
    }, (err, res) => {
      if (err) {
        dispatch({
          type: DISABLE_SUBMIT,
          payload: false
        });
        dispatch({
          type: LOADING,
          payload: false
        });
        console.log(err);
        onFailure(err);
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
      }
      setTimeout(() => {
        deletePaymentMethod();
      }, 2000);
    });
  };
  const deletePaymentMethod = () => {
    const {
      id: paymentMethodId
    } = paymentMethodToDelete;
    window.Pelcro.paymentMethods.deletePaymentMethod({
      auth_token: window.Pelcro.user.read().auth_token,
      payment_method_id: paymentMethodId
    }, (err, res) => {
      dispatch({
        type: DISABLE_SUBMIT,
        payload: false
      });
      dispatch({
        type: LOADING,
        payload: false
      });
      if (err) {
        onFailure === null || onFailure === void 0 ? void 0 : onFailure(err);
        return dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
      }
      onSuccess(res);
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SELECT_PAYMENT_METHOD:
        return lib_7({
          ...state,
          selectedPaymentMethodId: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          disableSubmit: true,
          isLoading: true
        }, (state, dispatch) => {
          if (state.showPaymentMethodSelect) {
            setDefaultPaymentMethod();
          } else {
            deletePaymentMethod();
          }
        });
      case SET_PAYMENT_METHODS:
        return lib_7({
          ...state,
          paymentMethods: action.payload
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case DISABLE_SUBMIT:
        return lib_7({
          ...state,
          disableSubmit: action.payload
        });
      case LOADING:
        return lib_7({
          ...state,
          isLoading: action.payload
        });
      case SKELETON_LOADER:
        return lib_7({
          ...state,
          skeletonLoader: action.payload
        });
      case SHOW_PAYMENT_METHOD_SELECT:
        return lib_7({
          ...state,
          showPaymentMethodSelect: action.payload
        });
      default:
        return state;
    }
  }, initialState$4);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-payment-method-delete-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$4, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$4,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$4
  })));
};

const PaymentMethodDeleteList = props => {
  const {
    t
  } = useTranslation("paymentMethod");
  const {
    dispatch,
    state: {
      selectedPaymentMethodId,
      paymentMethods,
      skeletonLoader,
      showPaymentMethodSelect
    }
  } = useContext(store$4);
  const {
    paymentMethodToDelete
  } = usePelcro();
  const createPaymentMethodItems = () => {
    if (paymentMethods.length) {
      return paymentMethods.filter(paymentMethod => (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id) !== (paymentMethodToDelete === null || paymentMethodToDelete === void 0 ? void 0 : paymentMethodToDelete.id)).map(paymentMethod => /*#__PURE__*/React__default.createElement("option", {
        key: paymentMethod.id,
        value: paymentMethod.id
      }, paymentMethod.properties.brand, " -", " ", paymentMethod.properties.last4, " -", " ", paymentMethod.properties.exp_month, " /", paymentMethod.properties.exp_year));
    }
  };
  const handlePaymentMethodSelect = event => {
    dispatch({
      type: SELECT_PAYMENT_METHOD,
      payload: event.target.value
    });
  };
  if (showPaymentMethodSelect) {
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, skeletonLoader ? /*#__PURE__*/React__default.createElement("div", {
      className: "plc-w-full plc-h-8 plc-bg-gray-300 plc-rounded-md plc-animate-pulse"
    }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, paymentMethods && /*#__PURE__*/React__default.createElement("div", {
      className: "plc-mt-4"
    }, /*#__PURE__*/React__default.createElement(Select, {
      label: t("delete.options.select"),
      name: "default-payment-method",
      onChange: handlePaymentMethodSelect,
      value: selectedPaymentMethodId
    }, /*#__PURE__*/React__default.createElement("option", {
      value: "",
      disabled: true,
      selected: true
    }), createPaymentMethodItems()))));
  } else {
    return null;
  }
};

const PaymentMethodDetails = () => {
  var _paymentMethodToDelet, _paymentMethodToDelet2, _paymentMethodToDelet3, _paymentMethodToDelet4;
  const {
    state: {
      skeletonLoader
    }
  } = useContext(store$4);
  const {
    t
  } = useTranslation("paymentMethod");
  const {
    paymentMethodToDelete
  } = usePelcro();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-text-left plc-mr-auto plc-mb-6"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-mb-2"
  }, t("delete.details")), skeletonLoader ? /*#__PURE__*/React__default.createElement("div", {
    className: "plc-w-full plc-h-16 plc-bg-gray-300 plc-rounded-md plc-animate-pulse"
  }) : /*#__PURE__*/React__default.createElement(React__default.Fragment, null, paymentMethodToDelete && /*#__PURE__*/React__default.createElement("div", {
    key: paymentMethodToDelete === null || paymentMethodToDelete === void 0 ? void 0 : paymentMethodToDelete.id,
    className: `plc-p-2 plc-pl-4 plc-shadow-md_dark plc-text-gray-900 plc-rounded pelcro-payment-method-wrapper`
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-space-x-2 plc-w-full pelcro-select-payment-method-radio",
    id: `pelcro-payment-method-select-${paymentMethodToDelete === null || paymentMethodToDelete === void 0 ? void 0 : paymentMethodToDelete.id}`,
    name: "paymentMethod"
  }, getPaymentCardIcon$1((_paymentMethodToDelet = paymentMethodToDelete.properties) === null || _paymentMethodToDelet === void 0 ? void 0 : _paymentMethodToDelet.brand), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-flex-col plc-text-lg pelcro-payment-method-details"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "plc-font-semibold"
  }, "\u2022\u2022\u2022\u2022 \u2022\u2022\u2022\u2022", " ", (_paymentMethodToDelet2 = paymentMethodToDelete.properties) === null || _paymentMethodToDelet2 === void 0 ? void 0 : _paymentMethodToDelet2.last4), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-text-sm plc-text-gray-500"
  }, t("select.expires"), " ", (_paymentMethodToDelet3 = paymentMethodToDelete.properties) === null || _paymentMethodToDelet3 === void 0 ? void 0 : _paymentMethodToDelet3.exp_month, "/", (_paymentMethodToDelet4 = paymentMethodToDelete.properties) === null || _paymentMethodToDelet4 === void 0 ? void 0 : _paymentMethodToDelet4.exp_year))))));
};

const PaymentMethodDeleteSubmit = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("paymentMethod");
  const {
    dispatch,
    state: {
      isLoading,
      disableSubmit,
      showPaymentMethodSelect,
      selectedPaymentMethodId
    }
  } = useContext(store$4);
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    disabled: showPaymentMethodSelect ? !selectedPaymentMethodId : disableSubmit,
    isLoading: isLoading,
    className: "plc-w-full"
  }, otherProps), name !== null && name !== void 0 ? name : t("delete.buttons.delete"));
};

const PaymentMethodDeleteBack = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("paymentMethod");
  const {
    switchView
  } = usePelcro();
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    variant: "outline",
    onClick: () => {
      switchView("dashboard");
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    className: "plc-w-full"
  }, otherProps), name !== null && name !== void 0 ? name : t("delete.buttons.back"));
};

function PaymentMethodDeleteView(props) {
  const {
    t
  } = useTranslation("paymentMethod");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-payment-method-delete-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold plc-mb-2"
  }, t("delete.title")), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-text-sm"
  }, t("delete.subtitle"))), /*#__PURE__*/React__default.createElement(PaymentMethodDeleteContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement(PaymentMethodDetails, null), /*#__PURE__*/React__default.createElement(PaymentMethodDeleteList, null), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-text-sm plc-text-justify"
  }, t("delete.message")), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-space-x-0 plc-space-y-3 plc-w-full plc-flex plc-flex-col plc-items-center plc-justify-center plc-mt-4"
  }, /*#__PURE__*/React__default.createElement(PaymentMethodDeleteSubmit, null), /*#__PURE__*/React__default.createElement(PaymentMethodDeleteBack, null))));
}

const PaymentMethodDeleteModal = props => {
  var _window, _window$Pelcro, _window$Pelcro$uiSett;
  const {
    t
  } = useTranslation("paymentMethod");
  const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
  const {
    resetView
  } = usePelcro();
  const onSuccess = res => {
    var _props$onSuccess;
    (_props$onSuccess = props.onSuccess) === null || _props$onSuccess === void 0 ? void 0 : _props$onSuccess.call(props, res);
    if (enableReactGA4) {
      ReactGA4.event("Delete payment card", {
        nonInteraction: true
      });
    } else {
      var _ReactGA$event;
      ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
        category: "ACTIONS",
        action: "Delete payment card",
        nonInteraction: true
      });
    }
    notify$1.success(t("delete.deletedSuccessfully"));
    resetView();
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-payment-method-delete-modal",
    onDisplay: props.onDisplay,
    onClose: props.onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(PaymentMethodDeleteView, Object.assign({}, props, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
PaymentMethodDeleteModal.viewId = "payment-method-delete";

const PaymentMethodCreateContainer = props => {
  return /*#__PURE__*/React__default.createElement(PaymentMethodContainer, Object.assign({
    type: "createPaymentSource",
    className: "pelcro-payment-create-container"
  }, props));
};

/**
 *
 */
function PaymentMethodCreateView(props) {
  const [t] = useTranslation("paymentMethod");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-payment-method-create-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-2 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold "
  }, t("create.title")), /*#__PURE__*/React__default.createElement("p", null, t("create.subtitle"))), /*#__PURE__*/React__default.createElement(PaymentMethodView, {
    type: "createPaymentSource",
    showCoupon: false,
    showExternalPaymentMethods: false,
    showApplePayButton: false,
    onDisplay: props.onDisplay,
    onFailure: props.onFailure,
    onSuccess: props.onSuccess
  }));
}

const PaymentMethodCreateModal = props => {
  var _window, _window$Pelcro, _window$Pelcro$uiSett;
  const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
  const onSuccess = res => {
    var _props$onSuccess;
    (_props$onSuccess = props.onSuccess) === null || _props$onSuccess === void 0 ? void 0 : _props$onSuccess.call(props, res);
    if (enableReactGA4) {
      ReactGA4.event("Created payment card", {
        nonInteraction: true
      });
    } else {
      var _ReactGA$event;
      ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
        category: "ACTIONS",
        action: "Created payment card",
        nonInteraction: true
      });
    }
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-payment-method-create-modal",
    onDisplay: props.onDisplay,
    onClose: props.onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(PaymentMethodCreateView, Object.assign({}, props, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
PaymentMethodCreateModal.viewId = "payment-method-create";

function _extends$i() {
  _extends$i = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$i.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      return function () {
        if (i >= o.length) return {
          done: true
        };
        return {
          done: false,
          value: o[i++]
        };
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  it = o[Symbol.iterator]();
  return it.next.bind(it);
}

var useIsoMorphicEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;

// didn't take care of the Suspense case. To fix this we used the approach the @reach-ui/auto-id
// uses.
//
// Credits: https://github.com/reach/reach-ui/blob/develop/packages/auto-id/src/index.tsx

var state = {
  serverHandoffComplete: false
};
var id = 0;

function generateId() {
  return ++id;
}

function useId() {
  var _useState = useState(state.serverHandoffComplete ? generateId : null),
      id = _useState[0],
      setId = _useState[1];

  useIsoMorphicEffect(function () {
    if (id === null) setId(generateId());
  }, [id]);
  useEffect(function () {
    if (state.serverHandoffComplete === false) state.serverHandoffComplete = true;
  }, []);
  return id != null ? '' + id : undefined;
}

function useIsInitialRender() {
  var initial = useRef(true);
  useEffect(function () {
    initial.current = false;
  }, []);
  return initial.current;
}

function match(value, lookup) {
  if (value in lookup) {
    var returnValue = lookup[value];

    for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
      args[_key - 2] = arguments[_key];
    }

    return typeof returnValue === 'function' ? returnValue.apply(void 0, args) : returnValue;
  }

  var error = new Error("Tried to handle \"" + value + "\" but there is no handler defined. Only defined handlers are: " + Object.keys(lookup).map(function (key) {
    return "\"" + key + "\"";
  }).join(', ') + ".");
  if (Error.captureStackTrace) Error.captureStackTrace(error, match);
  throw error;
}

function useIsMounted() {
  var mounted = useRef(true);
  useEffect(function () {
    return function () {
      mounted.current = false;
    };
  }, []);
  return mounted;
}

var Features;

(function (Features) {
  /** No features at all */
  Features[Features["None"] = 0] = "None";
  /**
   * When used, this will allow us to use one of the render strategies.
   *
   * **The render strategies are:**
   *    - **Unmount**   _(Will unmount the component.)_
   *    - **Hidden**    _(Will hide the component using the [hidden] attribute.)_
   */

  Features[Features["RenderStrategy"] = 1] = "RenderStrategy";
  /**
   * When used, this will allow the user of our component to be in control. This can be used when
   * you want to transition based on some state.
   */

  Features[Features["Static"] = 2] = "Static";
})(Features || (Features = {}));

var RenderStrategy;

(function (RenderStrategy) {
  RenderStrategy[RenderStrategy["Unmount"] = 0] = "Unmount";
  RenderStrategy[RenderStrategy["Hidden"] = 1] = "Hidden";
})(RenderStrategy || (RenderStrategy = {}));

function render(props, propsBag, defaultTag, features, visible) {
  if (visible === void 0) {
    visible = true;
  }

  // Visible always render
  if (visible) return _render(props, propsBag, defaultTag);
  var featureFlags = features != null ? features : Features.None;

  if (featureFlags & Features.Static) {
    var _props$static = props["static"],
        isStatic = _props$static === void 0 ? false : _props$static,
        rest = _objectWithoutPropertiesLoose(props, ["static"]); // When the `static` prop is passed as `true`, then the user is in control, thus we don't care about anything else


    if (isStatic) return _render(rest, propsBag, defaultTag);
  }

  if (featureFlags & Features.RenderStrategy) {
    var _match;

    var _props$unmount = props.unmount,
        unmount = _props$unmount === void 0 ? true : _props$unmount,
        _rest = _objectWithoutPropertiesLoose(props, ["unmount"]);

    var strategy = unmount ? RenderStrategy.Unmount : RenderStrategy.Hidden;
    return match(strategy, (_match = {}, _match[RenderStrategy.Unmount] = function () {
      return null;
    }, _match[RenderStrategy.Hidden] = function () {
      return _render(_extends$i({}, _rest, {
        hidden: true,
        style: {
          display: 'none'
        }
      }), propsBag, defaultTag);
    }, _match));
  } // No features enabled, just render


  return _render(props, propsBag, defaultTag);
}

function _render(props, bag, tag) {
  var _ref;

  var _omit = omit(props, ['unmount', 'static']),
      _omit$as = _omit.as,
      Component = _omit$as === void 0 ? tag : _omit$as,
      children = _omit.children,
      _omit$refName = _omit.refName,
      refName = _omit$refName === void 0 ? 'ref' : _omit$refName,
      passThroughProps = _objectWithoutPropertiesLoose(_omit, ["as", "children", "refName"]); // This allows us to use `<HeadlessUIComponent as={MyComopnent} refName="innerRef" />`


  var refRelatedProps = props.ref !== undefined ? (_ref = {}, _ref[refName] = props.ref, _ref) : {};
  var resolvedChildren = typeof children === 'function' ? children(bag) : children;

  if (Component === Fragment) {
    if (Object.keys(passThroughProps).length > 0) {
      if (Array.isArray(resolvedChildren) && resolvedChildren.length > 1) {
        var err = new Error('You should only render 1 child');
        if (Error.captureStackTrace) Error.captureStackTrace(err, _render);
        throw err;
      }

      if (!isValidElement(resolvedChildren)) {
        var _err = new Error("You should render an element as a child. Did you forget the as=\"...\" prop?");

        if (Error.captureStackTrace) Error.captureStackTrace(_err, _render);
        throw _err;
      }

      return cloneElement(resolvedChildren, Object.assign({}, // Filter out undefined values so that they don't override the existing values
      mergeEventFunctions(compact(omit(passThroughProps, ['ref'])), resolvedChildren.props, ['onClick']), refRelatedProps));
    }
  }

  return createElement(Component, Object.assign({}, omit(passThroughProps, ['ref']), Component !== Fragment && refRelatedProps), resolvedChildren);
}
/**
 * We can use this function for the following useCase:
 *
 * <Menu.Item> <button onClick={console.log} /> </Menu.Item>
 *
 * Our `Menu.Item` will have an internal `onClick`, if you passthrough an `onClick` to the actual
 * `Menu.Item` component we will call it correctly. However, when we have an `onClick` on the actual
 * first child, that one should _also_ be called (but before this implementation, it was just
 * overriding the `onClick`). But it is only when we *render* that we have access to the existing
 * props of this component.
 *
 * It's a bit hacky, and not that clean, but it is something internal and we have tests to rely on
 * so that we can refactor this later (if needed).
 */


function mergeEventFunctions(passThroughProps, existingProps, functionsToMerge) {
  var clone = Object.assign({}, passThroughProps);

  var _loop = function _loop() {
    var func = _step.value;

    if (passThroughProps[func] !== undefined && existingProps[func] !== undefined) {
      var _Object$assign;

      Object.assign(clone, (_Object$assign = {}, _Object$assign[func] = function (event) {
        // Props we control
        if (!event.defaultPrevented) passThroughProps[func](event); // Existing props on the component

        if (!event.defaultPrevented) existingProps[func](event);
      }, _Object$assign));
    }
  };

  for (var _iterator = _createForOfIteratorHelperLoose(functionsToMerge), _step; !(_step = _iterator()).done;) {
    _loop();
  }

  return clone;
}

function compact(object) {
  var clone = Object.assign({}, object);

  for (var key in clone) {
    if (clone[key] === undefined) delete clone[key];
  }

  return clone;
}

function omit(object, keysToOmit) {
  if (keysToOmit === void 0) {
    keysToOmit = [];
  }

  var clone = Object.assign({}, object);

  for (var _iterator2 = _createForOfIteratorHelperLoose(keysToOmit), _step2; !(_step2 = _iterator2()).done;) {
    var key = _step2.value;
    if (key in clone) delete clone[key];
  }

  return clone;
}

function once(cb) {
  var state = {
    called: false
  };
  return function () {
    if (state.called) return;
    state.called = true;
    return cb.apply(void 0, arguments);
  };
}

function disposables() {
  var disposables = [];
  var api = {
    requestAnimationFrame: function (_requestAnimationFrame) {
      function requestAnimationFrame() {
        return _requestAnimationFrame.apply(this, arguments);
      }

      requestAnimationFrame.toString = function () {
        return _requestAnimationFrame.toString();
      };

      return requestAnimationFrame;
    }(function () {
      var raf = requestAnimationFrame.apply(void 0, arguments);
      api.add(function () {
        return cancelAnimationFrame(raf);
      });
    }),
    nextFrame: function nextFrame() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      api.requestAnimationFrame(function () {
        api.requestAnimationFrame.apply(api, args);
      });
    },
    setTimeout: function (_setTimeout) {
      function setTimeout() {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function () {
      var timer = setTimeout.apply(void 0, arguments);
      api.add(function () {
        return clearTimeout(timer);
      });
    }),
    add: function add(cb) {
      disposables.push(cb);
    },
    dispose: function dispose() {
      for (var _iterator = _createForOfIteratorHelperLoose(disposables.splice(0)), _step; !(_step = _iterator()).done;) {
        var dispose = _step.value;
        dispose();
      }
    }
  };
  return api;
}

function addClasses(node) {
  var _node$classList;

  for (var _len = arguments.length, classes = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    classes[_key - 1] = arguments[_key];
  }

  node && classes.length > 0 && (_node$classList = node.classList).add.apply(_node$classList, classes);
}

function removeClasses(node) {
  var _node$classList2;

  for (var _len2 = arguments.length, classes = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    classes[_key2 - 1] = arguments[_key2];
  }

  node && classes.length > 0 && (_node$classList2 = node.classList).remove.apply(_node$classList2, classes);
}

var Reason;

(function (Reason) {
  Reason["Finished"] = "finished";
  Reason["Cancelled"] = "cancelled";
})(Reason || (Reason = {}));

function waitForTransition(node, done) {
  var d = disposables();
  if (!node) return d.dispose; // Safari returns a comma separated list of values, so let's sort them and take the highest value.

  var _getComputedStyle = getComputedStyle(node),
      transitionDuration = _getComputedStyle.transitionDuration,
      transitionDelay = _getComputedStyle.transitionDelay;

  var _map = [transitionDuration, transitionDelay].map(function (value) {
    var _value$split$filter$m = value.split(',') // Remove falseys we can't work with
    .filter(Boolean) // Values are returned as `0.3s` or `75ms`
    .map(function (v) {
      return v.includes('ms') ? parseFloat(v) : parseFloat(v) * 1000;
    }).sort(function (a, z) {
      return z - a;
    }),
        _value$split$filter$m2 = _value$split$filter$m[0],
        resolvedValue = _value$split$filter$m2 === void 0 ? 0 : _value$split$filter$m2;

    return resolvedValue;
  }),
      durationMs = _map[0],
      delaysMs = _map[1]; // Waiting for the transition to end. We could use the `transitionend` event, however when no
  // actual transition/duration is defined then the `transitionend` event is not fired.
  //
  // TODO: Downside is, when you slow down transitions via devtools this timeout is still using the
  // full 100% speed instead of the 25% or 10%.


  if (durationMs !== 0) {
    d.setTimeout(function () {
      done(Reason.Finished);
    }, durationMs + delaysMs);
  } else {
    // No transition is happening, so we should cleanup already. Otherwise we have to wait until we
    // get disposed.
    done(Reason.Finished);
  } // If we get disposed before the timeout runs we should cleanup anyway


  d.add(function () {
    return done(Reason.Cancelled);
  });
  return d.dispose;
}

function transition(node, base, from, to, done) {
  var d = disposables();

  var _done = done !== undefined ? once(done) : function () {};

  addClasses.apply(void 0, [node].concat(base, from));
  d.nextFrame(function () {
    removeClasses.apply(void 0, [node].concat(from));
    addClasses.apply(void 0, [node].concat(to));
    d.add(waitForTransition(node, function (reason) {
      removeClasses.apply(void 0, [node].concat(to, base));
      return _done(reason);
    }));
  }); // Once we get disposed, we should ensure that we cleanup after ourselves. In case of an unmount,
  // the node itself will be nullified and will be a no-op. In case of a full transition the classes
  // are already removed which is also a no-op. However if you go from enter -> leave mid-transition
  // then we have some leftovers that should be cleaned.

  d.add(function () {
    return removeClasses.apply(void 0, [node].concat(base, from, to));
  }); // When we get disposed early, than we should also call the done method but switch the reason.

  d.add(function () {
    return _done(Reason.Cancelled);
  });
  return d.dispose;
}

function useSplitClasses(classes) {
  if (classes === void 0) {
    classes = '';
  }

  return useMemo(function () {
    return classes.split(' ').filter(function (className) {
      return className.trim().length > 1;
    });
  }, [classes]);
}

var TransitionContext = /*#__PURE__*/createContext(null);
TransitionContext.displayName = 'TransitionContext';
var TreeStates;

(function (TreeStates) {
  TreeStates["Visible"] = "visible";
  TreeStates["Hidden"] = "hidden";
})(TreeStates || (TreeStates = {}));

function useTransitionContext() {
  var context = useContext(TransitionContext);

  if (context === null) {
    throw new Error('A <Transition.Child /> is used but it is missing a parent <Transition />.');
  }

  return context;
}

function useParentNesting() {
  var context = useContext(NestingContext);

  if (context === null) {
    throw new Error('A <Transition.Child /> is used but it is missing a parent <Transition />.');
  }

  return context;
}

var NestingContext = /*#__PURE__*/createContext(null);
NestingContext.displayName = 'NestingContext';

function hasChildren(bag) {
  if ('children' in bag) return hasChildren(bag.children);
  return bag.current.filter(function (_ref) {
    var state = _ref.state;
    return state === TreeStates.Visible;
  }).length > 0;
}

function useNesting(done) {
  var doneRef = useRef(done);
  var transitionableChildren = useRef([]);
  var mounted = useIsMounted();
  useEffect(function () {
    doneRef.current = done;
  }, [done]);
  var unregister = useCallback(function (childId, strategy) {
    var _match;

    if (strategy === void 0) {
      strategy = RenderStrategy.Hidden;
    }

    var idx = transitionableChildren.current.findIndex(function (_ref2) {
      var id = _ref2.id;
      return id === childId;
    });
    if (idx === -1) return;
    match(strategy, (_match = {}, _match[RenderStrategy.Unmount] = function () {
      transitionableChildren.current.splice(idx, 1);
    }, _match[RenderStrategy.Hidden] = function () {
      transitionableChildren.current[idx].state = TreeStates.Hidden;
    }, _match));

    if (!hasChildren(transitionableChildren) && mounted.current) {
      doneRef.current == null ? void 0 : doneRef.current();
    }
  }, [doneRef, mounted, transitionableChildren]);
  var register = useCallback(function (childId) {
    var child = transitionableChildren.current.find(function (_ref3) {
      var id = _ref3.id;
      return id === childId;
    });

    if (!child) {
      transitionableChildren.current.push({
        id: childId,
        state: TreeStates.Visible
      });
    } else if (child.state !== TreeStates.Visible) {
      child.state = TreeStates.Visible;
    }

    return function () {
      return unregister(childId, RenderStrategy.Unmount);
    };
  }, [transitionableChildren, unregister]);
  return useMemo(function () {
    return {
      children: transitionableChildren,
      register: register,
      unregister: unregister
    };
  }, [register, unregister, transitionableChildren]);
}

function noop() {}

var eventNames = ['beforeEnter', 'afterEnter', 'beforeLeave', 'afterLeave'];

function ensureEventHooksExist(events) {
  return eventNames.reduce(function (all, eventName) {
    all[eventName] = events[eventName] || noop;
    return all;
  }, {});
}

function useEvents(events) {
  var eventsRef = useRef(ensureEventHooksExist(events));
  useEffect(function () {
    eventsRef.current = ensureEventHooksExist(events);
  }, [events]);
  return eventsRef;
} // ---


var DEFAULT_TRANSITION_CHILD_TAG = 'div';
var TransitionChildRenderFeatures = Features.RenderStrategy;

function TransitionChild(props) {
  var beforeEnter = props.beforeEnter,
      afterEnter = props.afterEnter,
      beforeLeave = props.beforeLeave,
      afterLeave = props.afterLeave,
      enter = props.enter,
      enterFrom = props.enterFrom,
      enterTo = props.enterTo,
      leave = props.leave,
      leaveFrom = props.leaveFrom,
      leaveTo = props.leaveTo,
      rest = _objectWithoutPropertiesLoose(props, ["beforeEnter", "afterEnter", "beforeLeave", "afterLeave", "enter", "enterFrom", "enterTo", "leave", "leaveFrom", "leaveTo"]);

  var container = useRef(null);

  var _useState = useState(TreeStates.Visible),
      state = _useState[0],
      setState = _useState[1];

  var strategy = rest.unmount ? RenderStrategy.Unmount : RenderStrategy.Hidden;

  var _useTransitionContext = useTransitionContext(),
      show = _useTransitionContext.show,
      appear = _useTransitionContext.appear;

  var _useParentNesting = useParentNesting(),
      register = _useParentNesting.register,
      unregister = _useParentNesting.unregister;

  var initial = useIsInitialRender();
  var id = useId();
  var isTransitioning = useRef(false);
  var nesting = useNesting(function () {
    // When all children have been unmounted we can only hide ourselves if and only if we are not
    // transitioning ourserlves. Otherwise we would unmount before the transitions are finished.
    if (!isTransitioning.current) {
      setState(TreeStates.Hidden);
      unregister(id);
      events.current.afterLeave();
    }
  });
  useIsoMorphicEffect(function () {
    if (!id) return;
    return register(id);
  }, [register, id]);
  useIsoMorphicEffect(function () {
    var _match2;

    // If we are in another mode than the Hidden mode then ignore
    if (strategy !== RenderStrategy.Hidden) return;
    if (!id) return; // Make sure that we are visible

    if (show && state !== TreeStates.Visible) {
      setState(TreeStates.Visible);
      return;
    }

    match(state, (_match2 = {}, _match2[TreeStates.Hidden] = function () {
      return unregister(id);
    }, _match2[TreeStates.Visible] = function () {
      return register(id);
    }, _match2));
  }, [state, id, register, unregister, show, strategy]);
  var enterClasses = useSplitClasses(enter);
  var enterFromClasses = useSplitClasses(enterFrom);
  var enterToClasses = useSplitClasses(enterTo);
  var leaveClasses = useSplitClasses(leave);
  var leaveFromClasses = useSplitClasses(leaveFrom);
  var leaveToClasses = useSplitClasses(leaveTo);
  var events = useEvents({
    beforeEnter: beforeEnter,
    afterEnter: afterEnter,
    beforeLeave: beforeLeave,
    afterLeave: afterLeave
  });
  useEffect(function () {
    if (state === TreeStates.Visible && container.current === null) {
      throw new Error('Did you forget to passthrough the `ref` to the actual DOM node?');
    }
  }, [container, state]); // Skipping initial transition

  var skip = initial && !appear;
  useIsoMorphicEffect(function () {
    var node = container.current;
    if (!node) return;
    if (skip) return;
    isTransitioning.current = true;
    if (show) events.current.beforeEnter();
    if (!show) events.current.beforeLeave();
    return show ? transition(node, enterClasses, enterFromClasses, enterToClasses, function (reason) {
      isTransitioning.current = false;
      if (reason === Reason.Finished) events.current.afterEnter();
    }) : transition(node, leaveClasses, leaveFromClasses, leaveToClasses, function (reason) {
      isTransitioning.current = false;
      if (reason !== Reason.Finished) return; // When we don't have children anymore we can safely unregister from the parent and hide
      // ourselves.

      if (!hasChildren(nesting)) {
        setState(TreeStates.Hidden);
        unregister(id);
        events.current.afterLeave();
      }
    });
  }, [events, id, isTransitioning, unregister, nesting, container, skip, show, enterClasses, enterFromClasses, enterToClasses, leaveClasses, leaveFromClasses, leaveToClasses]);
  var propsBag = {};
  var propsWeControl = {
    ref: container
  };
  var passthroughProps = rest;
  return React__default.createElement(NestingContext.Provider, {
    value: nesting
  }, render(_extends$i({}, passthroughProps, propsWeControl), propsBag, DEFAULT_TRANSITION_CHILD_TAG, TransitionChildRenderFeatures, state === TreeStates.Visible));
}

function Transition(props) {
  // @ts-expect-error
  var show = props.show,
      _props$appear = props.appear,
      appear = _props$appear === void 0 ? false : _props$appear,
      unmount = props.unmount,
      passthroughProps = _objectWithoutPropertiesLoose(props, ["show", "appear", "unmount"]);

  if (![true, false].includes(show)) {
    throw new Error('A <Transition /> is used but it is missing a `show={true | false}` prop.');
  }

  var _useState2 = useState(show ? TreeStates.Visible : TreeStates.Hidden),
      state = _useState2[0],
      setState = _useState2[1];

  var nestingBag = useNesting(function () {
    setState(TreeStates.Hidden);
  });
  var initial = useIsInitialRender();
  var transitionBag = useMemo(function () {
    return {
      show: show,
      appear: appear || !initial
    };
  }, [show, appear, initial]);
  useEffect(function () {
    if (show) {
      setState(TreeStates.Visible);
    } else if (!hasChildren(nestingBag)) {
      setState(TreeStates.Hidden);
    }
  }, [show, nestingBag]);
  var sharedProps = {
    unmount: unmount
  };
  var propsBag = {};
  return React__default.createElement(NestingContext.Provider, {
    value: nestingBag
  }, React__default.createElement(TransitionContext.Provider, {
    value: transitionBag
  }, render(_extends$i({}, sharedProps, {
    as: Fragment,
    children: React__default.createElement(TransitionChild, Object.assign({}, sharedProps, passthroughProps))
  }), propsBag, Fragment, TransitionChildRenderFeatures, state === TreeStates.Visible)));
}
Transition.Child = TransitionChild;

// TODO: This must already exist somewhere, right? 🤔
// Ref: https://www.w3.org/TR/uievents-key/#named-key-attribute-values
var Keys;

(function (Keys) {
  Keys["Space"] = " ";
  Keys["Enter"] = "Enter";
  Keys["Escape"] = "Escape";
  Keys["Backspace"] = "Backspace";
  Keys["ArrowUp"] = "ArrowUp";
  Keys["ArrowDown"] = "ArrowDown";
  Keys["Home"] = "Home";
  Keys["End"] = "End";
  Keys["PageUp"] = "PageUp";
  Keys["PageDown"] = "PageDown";
  Keys["Tab"] = "Tab";
})(Keys || (Keys = {}));

function assertNever(x) {
  throw new Error('Unexpected object: ' + x);
}

var Focus;

(function (Focus) {
  /** Focus the first non-disabled item. */
  Focus[Focus["First"] = 0] = "First";
  /** Focus the previous non-disabled item. */

  Focus[Focus["Previous"] = 1] = "Previous";
  /** Focus the next non-disabled item. */

  Focus[Focus["Next"] = 2] = "Next";
  /** Focus the last non-disabled item. */

  Focus[Focus["Last"] = 3] = "Last";
  /** Focus a specific item based on the `id` of the item. */

  Focus[Focus["Specific"] = 4] = "Specific";
  /** Focus no items at all. */

  Focus[Focus["Nothing"] = 5] = "Nothing";
})(Focus || (Focus = {}));

function calculateActiveIndex(action, resolvers) {
  var items = resolvers.resolveItems();
  if (items.length <= 0) return null;
  var currentActiveIndex = resolvers.resolveActiveIndex();
  var activeIndex = currentActiveIndex != null ? currentActiveIndex : -1;

  var nextActiveIndex = function () {
    switch (action.focus) {
      case Focus.First:
        return items.findIndex(function (item) {
          return !resolvers.resolveDisabled(item);
        });

      case Focus.Previous:
        {
          var idx = items.slice().reverse().findIndex(function (item, idx, all) {
            if (activeIndex !== -1 && all.length - idx - 1 >= activeIndex) return false;
            return !resolvers.resolveDisabled(item);
          });
          if (idx === -1) return idx;
          return items.length - 1 - idx;
        }

      case Focus.Next:
        return items.findIndex(function (item, idx) {
          if (idx <= activeIndex) return false;
          return !resolvers.resolveDisabled(item);
        });

      case Focus.Last:
        {
          var _idx = items.slice().reverse().findIndex(function (item) {
            return !resolvers.resolveDisabled(item);
          });

          if (_idx === -1) return _idx;
          return items.length - 1 - _idx;
        }

      case Focus.Specific:
        return items.findIndex(function (item) {
          return resolvers.resolveId(item) === action.id;
        });

      case Focus.Nothing:
        return null;

      default:
        assertNever(action);
    }
  }();

  return nextActiveIndex === -1 ? currentActiveIndex : nextActiveIndex;
}

var _reducers;
var MenuStates;

(function (MenuStates) {
  MenuStates[MenuStates["Open"] = 0] = "Open";
  MenuStates[MenuStates["Closed"] = 1] = "Closed";
})(MenuStates || (MenuStates = {}));

var ActionTypes;

(function (ActionTypes) {
  ActionTypes[ActionTypes["OpenMenu"] = 0] = "OpenMenu";
  ActionTypes[ActionTypes["CloseMenu"] = 1] = "CloseMenu";
  ActionTypes[ActionTypes["GoToItem"] = 2] = "GoToItem";
  ActionTypes[ActionTypes["Search"] = 3] = "Search";
  ActionTypes[ActionTypes["ClearSearch"] = 4] = "ClearSearch";
  ActionTypes[ActionTypes["RegisterItem"] = 5] = "RegisterItem";
  ActionTypes[ActionTypes["UnregisterItem"] = 6] = "UnregisterItem";
})(ActionTypes || (ActionTypes = {}));

(_reducers = {}, _reducers[ActionTypes.CloseMenu] = function (state) {
  return _extends$i({}, state, {
    activeItemIndex: null,
    menuState: MenuStates.Closed
  });
}, _reducers[ActionTypes.OpenMenu] = function (state) {
  return _extends$i({}, state, {
    menuState: MenuStates.Open
  });
}, _reducers[ActionTypes.GoToItem] = function (state, action) {
  var activeItemIndex = calculateActiveIndex(action, {
    resolveItems: function resolveItems() {
      return state.items;
    },
    resolveActiveIndex: function resolveActiveIndex() {
      return state.activeItemIndex;
    },
    resolveId: function resolveId(item) {
      return item.id;
    },
    resolveDisabled: function resolveDisabled(item) {
      return item.dataRef.current.disabled;
    }
  });
  if (state.searchQuery === '' && state.activeItemIndex === activeItemIndex) return state;
  return _extends$i({}, state, {
    searchQuery: '',
    activeItemIndex: activeItemIndex
  });
}, _reducers[ActionTypes.Search] = function (state, action) {
  var searchQuery = state.searchQuery + action.value;
  var match = state.items.findIndex(function (item) {
    var _item$dataRef$current;

    return ((_item$dataRef$current = item.dataRef.current.textValue) == null ? void 0 : _item$dataRef$current.startsWith(searchQuery)) && !item.dataRef.current.disabled;
  });
  if (match === -1 || match === state.activeItemIndex) return _extends$i({}, state, {
    searchQuery: searchQuery
  });
  return _extends$i({}, state, {
    searchQuery: searchQuery,
    activeItemIndex: match
  });
}, _reducers[ActionTypes.ClearSearch] = function (state) {
  return _extends$i({}, state, {
    searchQuery: ''
  });
}, _reducers[ActionTypes.RegisterItem] = function (state, action) {
  return _extends$i({}, state, {
    items: [].concat(state.items, [{
      id: action.id,
      dataRef: action.dataRef
    }])
  });
}, _reducers[ActionTypes.UnregisterItem] = function (state, action) {
  var nextItems = state.items.slice();
  var currentActiveItem = state.activeItemIndex !== null ? nextItems[state.activeItemIndex] : null;
  var idx = nextItems.findIndex(function (a) {
    return a.id === action.id;
  });
  if (idx !== -1) nextItems.splice(idx, 1);
  return _extends$i({}, state, {
    items: nextItems,
    activeItemIndex: function () {
      if (idx === state.activeItemIndex) return null;
      if (currentActiveItem === null) return null; // If we removed the item before the actual active index, then it would be out of sync. To
      // fix this, we will find the correct (new) index position.

      return nextItems.indexOf(currentActiveItem);
    }()
  });
}, _reducers);
var MenuContext = /*#__PURE__*/createContext(null);
MenuContext.displayName = 'MenuContext';
Features.RenderStrategy | Features.Static;

var _reducers$1;
var ListboxStates;

(function (ListboxStates) {
  ListboxStates[ListboxStates["Open"] = 0] = "Open";
  ListboxStates[ListboxStates["Closed"] = 1] = "Closed";
})(ListboxStates || (ListboxStates = {}));

var ActionTypes$1;

(function (ActionTypes) {
  ActionTypes[ActionTypes["OpenListbox"] = 0] = "OpenListbox";
  ActionTypes[ActionTypes["CloseListbox"] = 1] = "CloseListbox";
  ActionTypes[ActionTypes["SetDisabled"] = 2] = "SetDisabled";
  ActionTypes[ActionTypes["GoToOption"] = 3] = "GoToOption";
  ActionTypes[ActionTypes["Search"] = 4] = "Search";
  ActionTypes[ActionTypes["ClearSearch"] = 5] = "ClearSearch";
  ActionTypes[ActionTypes["RegisterOption"] = 6] = "RegisterOption";
  ActionTypes[ActionTypes["UnregisterOption"] = 7] = "UnregisterOption";
})(ActionTypes$1 || (ActionTypes$1 = {}));

(_reducers$1 = {}, _reducers$1[ActionTypes$1.CloseListbox] = function (state) {
  if (state.disabled) return state;
  if (state.listboxState === ListboxStates.Closed) return state;
  return _extends$i({}, state, {
    activeOptionIndex: null,
    listboxState: ListboxStates.Closed
  });
}, _reducers$1[ActionTypes$1.OpenListbox] = function (state) {
  if (state.disabled) return state;
  if (state.listboxState === ListboxStates.Open) return state;
  return _extends$i({}, state, {
    listboxState: ListboxStates.Open
  });
}, _reducers$1[ActionTypes$1.SetDisabled] = function (state, action) {
  if (state.disabled === action.disabled) return state;
  return _extends$i({}, state, {
    disabled: action.disabled
  });
}, _reducers$1[ActionTypes$1.GoToOption] = function (state, action) {
  if (state.disabled) return state;
  if (state.listboxState === ListboxStates.Closed) return state;
  var activeOptionIndex = calculateActiveIndex(action, {
    resolveItems: function resolveItems() {
      return state.options;
    },
    resolveActiveIndex: function resolveActiveIndex() {
      return state.activeOptionIndex;
    },
    resolveId: function resolveId(item) {
      return item.id;
    },
    resolveDisabled: function resolveDisabled(item) {
      return item.dataRef.current.disabled;
    }
  });
  if (state.searchQuery === '' && state.activeOptionIndex === activeOptionIndex) return state;
  return _extends$i({}, state, {
    searchQuery: '',
    activeOptionIndex: activeOptionIndex
  });
}, _reducers$1[ActionTypes$1.Search] = function (state, action) {
  if (state.disabled) return state;
  if (state.listboxState === ListboxStates.Closed) return state;
  var searchQuery = state.searchQuery + action.value;
  var match = state.options.findIndex(function (option) {
    var _option$dataRef$curre;

    return !option.dataRef.current.disabled && ((_option$dataRef$curre = option.dataRef.current.textValue) == null ? void 0 : _option$dataRef$curre.startsWith(searchQuery));
  });
  if (match === -1 || match === state.activeOptionIndex) return _extends$i({}, state, {
    searchQuery: searchQuery
  });
  return _extends$i({}, state, {
    searchQuery: searchQuery,
    activeOptionIndex: match
  });
}, _reducers$1[ActionTypes$1.ClearSearch] = function (state) {
  if (state.disabled) return state;
  if (state.listboxState === ListboxStates.Closed) return state;
  if (state.searchQuery === '') return state;
  return _extends$i({}, state, {
    searchQuery: ''
  });
}, _reducers$1[ActionTypes$1.RegisterOption] = function (state, action) {
  return _extends$i({}, state, {
    options: [].concat(state.options, [{
      id: action.id,
      dataRef: action.dataRef
    }])
  });
}, _reducers$1[ActionTypes$1.UnregisterOption] = function (state, action) {
  var nextOptions = state.options.slice();
  var currentActiveOption = state.activeOptionIndex !== null ? nextOptions[state.activeOptionIndex] : null;
  var idx = nextOptions.findIndex(function (a) {
    return a.id === action.id;
  });
  if (idx !== -1) nextOptions.splice(idx, 1);
  return _extends$i({}, state, {
    options: nextOptions,
    activeOptionIndex: function () {
      if (idx === state.activeOptionIndex) return null;
      if (currentActiveOption === null) return null; // If we removed the option before the actual active index, then it would be out of sync. To
      // fix this, we will find the correct (new) index position.

      return nextOptions.indexOf(currentActiveOption);
    }()
  });
}, _reducers$1);
var ListboxContext = /*#__PURE__*/createContext(null);
ListboxContext.displayName = 'ListboxContext';
Features.RenderStrategy | Features.Static;

var GroupContext = /*#__PURE__*/createContext(null);
GroupContext.displayName = 'GroupContext';

const getPaymentCardIcon = name => {
  var _icons$name$toLowerCa;
  const icons = {
    visa: /*#__PURE__*/React__default.createElement("svg", {
      className: "plc-w-12",
      fill: "#ffffff",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 50 50"
    }, /*#__PURE__*/React__default.createElement("path", {
      d: "M 5 7 C 2.25 7 0 9.25 0 12 L 0 38 C 0 40.75 2.25 43 5 43 L 45 43 C 47.75 43 50 40.75 50 38 L 50 12 C 50 9.25 47.75 7 45 7 Z M 5 9 L 45 9 C 46.667969 9 48 10.332031 48 12 L 48 38 C 48 39.667969 46.667969 41 45 41 L 5 41 C 3.332031 41 2 39.667969 2 38 L 2 12 C 2 10.332031 3.332031 9 5 9 Z M 29.6875 19.40625 C 26.585938 19.40625 25 20.933594 25 22.875 C 25 26.386719 29.0625 25.914063 29.0625 27.71875 C 29.0625 28.023438 28.828125 28.75 27.125 28.75 C 25.417969 28.75 24.3125 28.09375 24.3125 28.09375 L 23.78125 30.46875 C 23.78125 30.46875 24.886719 31.09375 27 31.09375 C 29.113281 31.09375 32.03125 29.476563 32.03125 27.125 C 32.03125 24.296875 27.96875 24.074219 27.96875 22.8125 C 27.96875 22.167969 28.46875 21.6875 29.9375 21.6875 C 30.890625 21.6875 31.96875 22.40625 31.96875 22.40625 L 32.46875 19.96875 C 32.46875 19.96875 31.050781 19.40625 29.6875 19.40625 Z M 16.46875 19.625 L 13.78125 27.5625 C 13.78125 27.5625 13.597656 26.886719 13.53125 26.46875 C 11.996094 23.023438 9.5 21.75 9.5 21.75 L 11.875 30.75 L 15.125 30.75 L 19.625 19.625 Z M 20.78125 19.625 L 19.03125 30.75 L 22 30.75 L 23.78125 19.625 Z M 36.8125 19.625 L 31.96875 30.75 L 34.90625 30.75 L 35.5 29.15625 L 39.1875 29.15625 L 39.5 30.75 L 42.1875 30.75 L 39.90625 19.625 Z M 6.25 19.65625 C 6.25 19.65625 12.054688 21.453125 13.40625 25.8125 L 12.40625 20.75 C 12.40625 20.75 11.976563 19.65625 10.8125 19.65625 Z M 37.9375 22.84375 L 38.75 27.03125 L 36.3125 27.03125 Z"
    })),
    mastercard: /*#__PURE__*/React__default.createElement("svg", {
      className: "plc-w-12",
      fill: "#ffffff",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 50 50"
    }, /*#__PURE__*/React__default.createElement("path", {
      d: "M 5 7 C 2.25 7 0 9.25 0 12 L 0 38 C 0 40.75 2.25 43 5 43 L 45 43 C 47.75 43 50 40.75 50 38 L 50 12 C 50 9.25 47.75 7 45 7 Z M 5 9 L 45 9 C 46.667969 9 48 10.332031 48 12 L 48 38 C 48 39.667969 46.667969 41 45 41 L 5 41 C 3.332031 41 2 39.667969 2 38 L 2 12 C 2 10.332031 3.332031 9 5 9 Z M 17 13 C 10.382812 13 5 18.382812 5 25 C 5 31.617188 10.382812 37 17 37 C 20.078125 37 22.875 35.816406 25 33.90625 C 27.125 35.816406 29.925781 37 33 37 C 39.617188 37 45 31.617188 45 25 C 45 18.382812 39.617188 13 33 13 C 29.925781 13 27.125 14.183594 25 16.09375 C 22.875 14.183594 20.078125 13 17 13 Z M 33 15 C 38.535156 15 43 19.464844 43 25 C 43 30.535156 38.535156 35 33 35 C 30.449219 35 28.109375 34.066406 26.34375 32.5 C 27.996094 30.441406 29 27.839844 29 25 C 29 22.160156 27.996094 19.558594 26.34375 17.5 C 28.109375 15.933594 30.449219 15 33 15 Z M 33 15 "
    })),
    "american express": /*#__PURE__*/React__default.createElement("svg", {
      className: "plc-w-12",
      fill: "#ffffff",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 50 50"
    }, /*#__PURE__*/React__default.createElement("path", {
      d: "M 5 7 C 2.25 7 0 9.25 0 12 L 0 38 C 0 40.75 2.25 43 5 43 L 45 43 C 47.75 43 50 40.75 50 38 L 50 12 C 50 9.25 47.75 7 45 7 Z M 5 9 L 45 9 C 46.667969 9 48 10.332031 48 12 L 48 38 C 48 39.667969 46.667969 41 45 41 L 5 41 C 3.332031 41 2 39.667969 2 38 L 2 12 C 2 10.332031 3.332031 9 5 9 Z M 8.5625 19.90625 L 4.84375 28.40625 L 7.0625 28.40625 L 7.875 26.5 L 12.0625 26.5 L 12.875 28.40625 L 17.09375 28.40625 L 17.09375 22.09375 L 19.90625 28.40625 L 21.8125 28.40625 L 24.65625 22.1875 L 24.65625 28.40625 L 26.75 28.40625 L 26.75 19.90625 L 23.40625 19.90625 L 20.84375 25.625 L 18.28125 19.90625 L 15 19.90625 L 15 28.09375 L 11.34375 19.90625 Z M 29.5 19.90625 L 29.5 28.4375 L 37.5 28.4375 L 40 25.59375 L 42.46875 28.4375 L 45.125 28.4375 L 41.375 24.0625 L 45.125 19.90625 L 42.46875 19.90625 L 40.0625 22.5625 L 37.75 19.90625 Z M 9.90625 21.6875 L 11.21875 24.6875 L 8.65625 24.6875 Z M 31.5625 21.71875 L 36.65625 21.75 L 38.6875 24.0625 L 36.40625 26.625 L 31.5625 26.625 L 31.5625 24.9375 L 36.1875 24.9375 L 36.1875 23.3125 L 31.5625 23.3125 Z"
    })),
    amex: /*#__PURE__*/React__default.createElement("svg", {
      className: "plc-w-12",
      fill: "#ffffff",
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 50 50"
    }, /*#__PURE__*/React__default.createElement("path", {
      d: "M 5 7 C 2.25 7 0 9.25 0 12 L 0 38 C 0 40.75 2.25 43 5 43 L 45 43 C 47.75 43 50 40.75 50 38 L 50 12 C 50 9.25 47.75 7 45 7 Z M 5 9 L 45 9 C 46.667969 9 48 10.332031 48 12 L 48 38 C 48 39.667969 46.667969 41 45 41 L 5 41 C 3.332031 41 2 39.667969 2 38 L 2 12 C 2 10.332031 3.332031 9 5 9 Z M 8.5625 19.90625 L 4.84375 28.40625 L 7.0625 28.40625 L 7.875 26.5 L 12.0625 26.5 L 12.875 28.40625 L 17.09375 28.40625 L 17.09375 22.09375 L 19.90625 28.40625 L 21.8125 28.40625 L 24.65625 22.1875 L 24.65625 28.40625 L 26.75 28.40625 L 26.75 19.90625 L 23.40625 19.90625 L 20.84375 25.625 L 18.28125 19.90625 L 15 19.90625 L 15 28.09375 L 11.34375 19.90625 Z M 29.5 19.90625 L 29.5 28.4375 L 37.5 28.4375 L 40 25.59375 L 42.46875 28.4375 L 45.125 28.4375 L 41.375 24.0625 L 45.125 19.90625 L 42.46875 19.90625 L 40.0625 22.5625 L 37.75 19.90625 Z M 9.90625 21.6875 L 11.21875 24.6875 L 8.65625 24.6875 Z M 31.5625 21.71875 L 36.65625 21.75 L 38.6875 24.0625 L 36.40625 26.625 L 31.5625 26.625 L 31.5625 24.9375 L 36.1875 24.9375 L 36.1875 23.3125 L 31.5625 23.3125 Z"
    }))
  };
  return (_icons$name$toLowerCa = icons[name === null || name === void 0 ? void 0 : name.toLowerCase()]) !== null && _icons$name$toLowerCa !== void 0 ? _icons$name$toLowerCa : /*#__PURE__*/React__default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    className: "plc-w-12",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, /*#__PURE__*/React__default.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1",
    d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
  }));
};

var _path$h;
function _extends$h() { _extends$h = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$h.apply(this, arguments); }
function SvgChevronRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$h({
    className: "plc-w-6 plc-h-6",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$h || (_path$h = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 5l7 7-7 7"
  })));
}

const OrdersMenu = () => {
  const {
    t
  } = useTranslation("dashboard");
  const userOrders = window.Pelcro.user.read().orders;
  return /*#__PURE__*/React__default.createElement("table", {
    className: "plc-w-full plc-py-4 plc-table-fixed "
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "plc-text-xs plc-font-semibold plc-tracking-wider plc-text-gray-400 plc-uppercase "
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-4/12 plc-pl-2"
  }, t("labels.orders.total")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-5/12 "
  }, t("labels.orders.date")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-3/12"
  }, t("labels.orders.details")))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "plc-h-4"
  })), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(OrderItems, {
    orders: userOrders
  })), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "plc-h-4"
  })));
};
const OrderItems = _ref => {
  let {
    orders,
    activeMenu,
    toggleActiveMenu
  } = _ref;
  const getItemsAmount = orderId => {
    return orders === null || orders === void 0 ? void 0 : orders.find(order => order.id === orderId).items.reduce((amount, order) => amount + order.quantity, 0);
  };
  const {
    t
  } = useTranslation("dashboard");
  return !(orders !== null && orders !== void 0 && orders.length) ? /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: "3",
    className: "plc-text-center plc-text-gray-500"
  }, t("labels.orders.noOrders")))) : orders === null || orders === void 0 ? void 0 : orders.map(order => {
    const isActive = activeMenu === order.id;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: order.id
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
      onClick: () => toggleActiveMenu(order.id),
      key: "dashboard-order-" + order.id,
      className: `plc-w-full plc-text-gray-500 plc-align-middle plc-cursor-pointer accordion-header ${isActive ? "plc-bg-gray-100" : "hover:plc-bg-gray-50"}`
    }, /*#__PURE__*/React__default.createElement("td", {
      className: "plc-py-4 plc-pl-2"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "plc-text-xl plc-font-semibold "
    }, getFormattedPriceByLocal(order.amount, order.currency, getPageOrDefaultLanguage())), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
      className: "plc-text-xs plc-text-gray-400 plc-uppercase"
    }, t("labels.orders.itemsAmount", {
      count: getItemsAmount(order.id)
    }))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("p", {
      className: "plc-font-semibold "
    }, order.created)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
      className: `plc-flex plc-items-center plc-justify-center plc-transition-transform plc-ease-out plc-transform plc-rounded-full plc-w-7 plc-h-7 ${isActive ? "plc-flex plc-place-items-center plc-w-7 plc-h-7 plc-p-1 plc-bg-primary-400 plc-rounded-full" : "accordion-chevron"}`
    }, /*#__PURE__*/React__default.createElement("span", {
      className: `plc-transition plc-ease-out  ${isActive && "plc-text-white plc-transform plc-rotate-90"}`
    }, /*#__PURE__*/React__default.createElement(SvgChevronRight, null)))))), /*#__PURE__*/React__default.createElement("tbody", null, isActive && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, order.items.map(item => {
      const productSku = window.Pelcro.ecommerce.products.getBySkuId(item.product_sku_id);
      return /*#__PURE__*/React__default.createElement("tr", {
        key: item.id,
        className: "plc-text-lg plc-text-gray-500 pelcro-order-details-row "
      }, /*#__PURE__*/React__default.createElement("td", {
        colSpan: "2"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "plc-flex plc-items-center plc-py-2 plc-space-x-2 sm:plc-p-2"
      }, (productSku === null || productSku === void 0 ? void 0 : productSku.image) && /*#__PURE__*/React__default.createElement("img", {
        className: "plc-w-12 plc-h-12 pelcro-orders-product-image",
        alt: `image of ${item.product_sku_name}`,
        src: productSku === null || productSku === void 0 ? void 0 : productSku.image
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "plc-font-semibold"
      }, item.quantity, "\xD7", " "), /*#__PURE__*/React__default.createElement("span", {
        className: ""
      }, item.product_sku_name))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", {
        className: "plc-font-semibold"
      }, getFormattedPriceByLocal(item.amount, order.currency, getPageOrDefaultLanguage()))));
    }), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colSpan: "3"
    }, /*#__PURE__*/React__default.createElement("hr", {
      className: "plc-mt-4"
    }))))));
  });
};

const SavedItemsMenu = () => {
  const {
    t
  } = useTranslation("dashboard");
  const [userMetadata, setUserMetadata] = useState(window.Pelcro.user.read().metadata);
  const userSavedItems = userMetadata ? Object.entries(userMetadata)
  // only get metadata related to saved items
  .filter(_ref => {
    let [categoryTitle, value] = _ref;
    return categoryTitle.startsWith("metadata_saved_") && (value === null || value === void 0 ? void 0 : value.length);
  })
  // drop the "metadata_saved_" from the category title
  .map(_ref2 => {
    let [categoryTitle, value] = _ref2;
    return [categoryTitle.replace("metadata_saved_", ""), value];
  }) : null;
  return /*#__PURE__*/React__default.createElement("table", {
    className: "plc-w-full plc-py-4 plc-table-fixed "
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "plc-text-xs plc-font-semibold plc-tracking-wider plc-text-gray-400 plc-uppercase "
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-10/12 plc-pl-2"
  }, t("labels.savedItems.categories")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-2/12"
  }, t("labels.savedItems.details")))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "plc-h-4"
  })), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(SavedItems, {
    items: userSavedItems,
    setItems: setUserMetadata
  })), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "plc-h-4"
  })));
};
const SavedItems = _ref3 => {
  let {
    items,
    setItems,
    activeMenu,
    toggleActiveMenu
  } = _ref3;
  const {
    t
  } = useTranslation("dashboard");
  const [isLoading, setLoading] = useState(false);
  const {
    isAuthenticated
  } = usePelcro();
  const removeItemFromMetadata = (category, title) => {
    var _window, _window$Pelcro, _window$Pelcro$uiSett;
    const user = window.Pelcro.user.read();
    const oldValue = user.metadata[`metadata_saved_${category}`];
    const enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
    const newMetadataValue = oldValue.filter(metadata => !((metadata === null || metadata === void 0 ? void 0 : metadata.title) === title));
    if (isAuthenticated()) {
      setLoading(true);
      window.Pelcro.user.saveToMetaData({
        key: `saved_${category}`,
        value: newMetadataValue,
        auth_token: window.Pelcro.user.read().auth_token
      }, (error, response) => {
        var _response$data;
        setLoading(false);
        if (error) {
          return;
        }
        setItems(response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.metadata);
        if (enableReactGA4) {
          ReactGA4.event("Unsave/Unfollow", {
            event_label: title
          });
        } else {
          var _ReactGA$event;
          ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
            category: "ACTIONS",
            action: "Unsave/Unfollow",
            label: title
          });
        }
      });
    }
  };
  return !(items !== null && items !== void 0 && items.length) ? /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: "2",
    className: "plc-text-center plc-text-gray-500"
  }, t("labels.savedItems.noSavedItems")))) : items.map(_ref4 => {
    let [categoryTitle, item] = _ref4;
    const isActive = activeMenu === categoryTitle;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: categoryTitle
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
      onClick: () => toggleActiveMenu(categoryTitle),
      key: "dashboard-saved-category-" + categoryTitle,
      className: `plc-w-full plc-text-gray-500 plc-align-middle plc-cursor-pointer accordion-header ${isActive ? "plc-bg-gray-100" : "hover:plc-bg-gray-50"}`
    }, /*#__PURE__*/React__default.createElement("td", {
      className: "plc-py-4 plc-pl-2"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "plc-text-xl plc-font-semibold plc-uppercase "
    }, categoryTitle)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
      className: `plc-flex plc-items-center plc-justify-center plc-transition-transform plc-ease-out plc-transform plc-rounded-full plc-w-7 plc-h-7 ${isActive ? "plc-flex plc-place-items-center plc-w-7 plc-h-7 plc-p-1 plc-bg-primary-400 plc-rounded-full" : "accordion-chevron"}`
    }, /*#__PURE__*/React__default.createElement("span", {
      className: `plc-transition plc-ease-out  ${isActive && "plc-text-white plc-transform plc-rotate-90"}`
    }, /*#__PURE__*/React__default.createElement(SvgChevronRight, null)))))), /*#__PURE__*/React__default.createElement("tbody", null, isActive && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, item.map(item => {
      return /*#__PURE__*/React__default.createElement("tr", {
        key: item.title,
        className: "plc-text-lg plc-text-gray-500 pelcro-saved-items-details-row "
      }, /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Link, {
        className: "plc-text-gray-700 plc-no-underline",
        href: item.link,
        isButton: true,
        target: "_blank",
        rel: "noopener noreferrer"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "plc-flex plc-items-center plc-py-2 plc-space-x-2 sm:plc-p-2"
      }, (item === null || item === void 0 ? void 0 : item.image) && /*#__PURE__*/React__default.createElement("img", {
        className: "plc-w-12 plc-h-12 pelcro-saved-item-image",
        alt: `image of ${item.title}`,
        src: item === null || item === void 0 ? void 0 : item.image
      }), /*#__PURE__*/React__default.createElement("span", {
        className: "plc-font-semibold"
      }, item.title)))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Button, {
        variant: "ghost",
        className: "plc-text-red-500 plc-uppercase focus:plc-ring-red-500",
        disabled: isLoading,
        onClick: () => removeItemFromMetadata(categoryTitle, item.title)
      }, t("labels.savedItems.removeItem"))));
    }), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colSpan: "3"
    }, /*#__PURE__*/React__default.createElement("hr", {
      className: "plc-mt-4"
    }))))));
  });
};

var _path$g;
function _extends$g() { _extends$g = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$g.apply(this, arguments); }
function SvgRefresh(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$g({
    className: "plc-w-4 plc-h-4 plc-mr-1",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$g || (_path$g = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
  })));
}

var _path$f;
function _extends$f() { _extends$f = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$f.apply(this, arguments); }
function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$f({
    xmlns: "http://www.w3.org/2000/svg",
    className: "plc-h-4 plc-w-4 plc-mr-1",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path$f || (_path$f = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z",
    clipRule: "evenodd"
  })));
}

var _path$e;
function _extends$e() { _extends$e = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$e.apply(this, arguments); }
function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$e({
    className: "plc-w-5 plc-h-5",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$e || (_path$e = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M12 6v6m0 0v6m0-6h6m-6 0H6"
  })));
}

const SubscriptionsMenu = props => {
  const {
    t
  } = useTranslation("dashboard");
  return /*#__PURE__*/React__default.createElement("table", {
    className: "plc-w-full plc-table-fixed"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "plc-text-xs plc-font-semibold plc-tracking-wider plc-text-gray-400 plc-uppercase "
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-3/12 "
  }, t("labels.plan")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-4/12 "
  }, t("labels.status.title")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-3/12 "
  }, t("labels.actions")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-2/12 "
  }))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "plc-h-4"
  })), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(SubscriptionsItems, props)), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: "4",
    className: "plc-p-1"
  }, /*#__PURE__*/React__default.createElement(Button, {
    variant: "ghost",
    icon: /*#__PURE__*/React__default.createElement(SvgPlus, {
      className: "plc-w-4 plc-h-4 plc-mr-1"
    }),
    className: "plc-w-full plc-h-8 plc-font-semibold plc-tracking-wider plc-text-gray-900 plc-uppercase plc-rounded-none hover:plc-bg-gray-100",
    onClick: props.displayProductSelect
  }, t("labels.addSubscription")))), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
    colSpan: "4",
    className: "plc-p-1"
  }, /*#__PURE__*/React__default.createElement(Button, {
    variant: "ghost",
    icon: /*#__PURE__*/React__default.createElement(SvgGift, {
      className: "plc-w-4 plc-h-4 plc-mr-1"
    }),
    className: "plc-w-full plc-h-8 plc-font-semibold plc-tracking-wider plc-text-gray-900 plc-uppercase plc-rounded-none hover:plc-bg-gray-100",
    onClick: props.displayRedeem
  }, t("labels.redeemGift"))))));
};
const SubscriptionsItems = _ref => {
  let {
    onClose,
    cancelSubscription,
    unSuspendSubscription,
    reactivateSubscription,
    setProductAndPlan,
    setSubscriptionIdToRenew,
    setView,
    getSubscriptionStatus,
    disableSubmit,
    activeMenu,
    toggleActiveMenu
  } = _ref;
  const {
    t
  } = useTranslation("dashboard");
  const {
    switchView,
    setSubscriptionToCancel,
    setSubscriptionToSuspend,
    set
  } = usePelcro();
  const subs = getNonDonationSubs();
  if (subs.length === 0) return null;
  return subs.sort((a, b) => a.expires_at - b.expires_at).sort((a, b) => a.renews_at - b.renews_at).map(sub => {
    var _sub$plan;
    const isActive = activeMenu === sub.id;
    // Cancel button click handlers
    const onCancelClick = () => {
      const isImmediateCancelationEnabled = window.Pelcro.site.read().cancel_settings.status;
      if (isImmediateCancelationEnabled) {
        setSubscriptionToCancel(sub.id);
        return switchView("subscription-cancel");
      }
      if (userMustVerifyEmail()) {
        return switchView("email-verify");
      }
      onClose === null || onClose === void 0 ? void 0 : onClose();
      notify$1.confirm((onSuccess, onFailure) => {
        cancelSubscription(sub.id, onSuccess, onFailure);
      }, {
        confirmMessage: t("messages.subCancellation.isSureToCancel"),
        loadingMessage: t("messages.subCancellation.loading"),
        successMessage: t("messages.subCancellation.success"),
        errorMessage: t("messages.subCancellation.error")
      }, {
        closeButtonLabel: t("labels.subCancellation.goBack")
      });
    };

    // Reactivate button click handlers
    const onReactivateClick = () => {
      if (userMustVerifyEmail()) {
        return switchView("email-verify");
      }
      reactivateSubscription(sub.id);
    };

    // Renew click
    const onRenewClick = () => {
      const product_id = sub.plan.product.id;
      const plan_id = sub.plan.id;
      const product = window.Pelcro.product.getById(product_id);
      const plan = window.Pelcro.plan.getById(plan_id);
      setProductAndPlan(product, plan);
      setSubscriptionIdToRenew(sub.id);
      setView("plan-select");
    };

    // Manage members click
    const onManageMembersClick = () => {
      const subscriptionToManageMembers = sub;
      set({
        subscriptionToManageMembers
      });
      setView("manage-members");
    };

    // Suspend click
    const onSuspendClick = () => {
      if (userMustVerifyEmail()) {
        return switchView("email-verify");
      }
      setSubscriptionToSuspend(sub.id);
      return setView("subscription-suspend");
    };

    // UnSuspend click
    const onUnSuspendClick = () => {
      if (userMustVerifyEmail()) {
        return switchView("email-verify");
      }
      onClose === null || onClose === void 0 ? void 0 : onClose();
      notify$1.confirm((onSuccess, onFailure) => {
        unSuspendSubscription(sub.id, onSuccess, onFailure);
      }, {
        confirmMessage: t("messages.subUnSuspend.isSureToUnSuspend"),
        loadingMessage: t("messages.subUnSuspend.loading"),
        successMessage: t("messages.subUnSuspend.success"),
        errorMessage: t("messages.subUnSuspend.error")
      }, {
        closeButtonLabel: t("labels.subCancellation.goBack")
      });
    };
    const getPhases = () => {
      if (!sub.schedule) return [];
      const currentPhaseStartDate = sub.schedule.current_phase.start_date;
      const currentPhase = sub.schedule.phases.find(phase => {
        return phase.start_date === currentPhaseStartDate;
      });
      const futurePhases = sub.schedule.phases.filter(phase => {
        return phase.start_date > currentPhaseStartDate;
      });
      return [currentPhase, ...futurePhases];
    };
    const hasPhases = getPhases().length > 0;
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, {
      key: sub.id
    }, /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
      onClick: () => {
        if (hasPhases) toggleActiveMenu(sub.id);
      },
      key: sub.id,
      className: `plc-w-full plc-align-middle plc-cursor-pointer accordion-header ${isActive ? "plc-bg-gray-100" : "hover:plc-bg-gray-50"}`
    }, /*#__PURE__*/React__default.createElement("td", {
      className: "plc-truncate"
    }, sub.plan.nickname && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
      className: "plc-font-semibold plc-text-gray-500"
    }, sub.plan.nickname), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
      className: "plc-text-xs plc-text-gray-400"
    }, getFormattedPriceByLocal(sub.plan.amount, sub.plan.currency, getPageOrDefaultLanguage())))), /*#__PURE__*/React__default.createElement("td", {
      className: "plc-py-2"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: `plc-inline-flex plc-p-1 plc-text-xs plc-font-semibold ${getSubscriptionStatus(sub).bgColor} plc-uppercase ${getSubscriptionStatus(sub).textColor} plc-rounded-lg`
    }, getSubscriptionStatus(sub).icon, getSubscriptionStatus(sub).title), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-text-xs plc-text-gray-500"
    }, sub.status && /*#__PURE__*/React__default.createElement("span", {
      className: "plc-inline-block plc-mt-1 plc-underline"
    }, getSubscriptionStatus(sub).content), /*#__PURE__*/React__default.createElement("br", null), sub.shipments_remaining ? /*#__PURE__*/React__default.createElement("span", {
      className: "plc-inline-block plc-mt-1"
    }, sub.shipments_remaining, " ", t("labels.shipments")) : null)), /*#__PURE__*/React__default.createElement("td", null, sub.cancel_at_period_end === 1 && sub.plan.auto_renew && !sub.is_gift_recipient && /*#__PURE__*/React__default.createElement(Button, {
      variant: "ghost",
      className: "plc-text-green-400 focus:plc-ring-green-300 pelcro-dashboard-sub-reactivate-button",
      icon: /*#__PURE__*/React__default.createElement(SvgRefresh, null),
      onClick: onReactivateClick,
      disabled: disableSubmit,
      "data-key": sub.id
    }, t("labels.reactivate")), sub.cancel_at_period_end === 1 && sub.status !== "incomplete" && /*#__PURE__*/React__default.createElement(Button, {
      variant: "ghost",
      className: "plc-text-blue-400 pelcro-dashboard-sub-renew-button",
      icon: /*#__PURE__*/React__default.createElement(SvgRefresh, null),
      onClick: onRenewClick,
      disabled: disableSubmit,
      "data-key": sub.id
    }, t("labels.renew")), sub.shipments_suspended_until && isDateAfterToday(sub.shipments_suspended_until) && sub.shipments_remaining > 0 && /*#__PURE__*/React__default.createElement(Button, {
      variant: "ghost",
      className: "plc-text-blue-400 pelcro-dashboard-sub-suspend-button",
      icon: /*#__PURE__*/React__default.createElement(SvgXIconSolid, null),
      onClick: onUnSuspendClick,
      disabled: disableSubmit,
      "data-key": sub.id
    }, t("labels.unsuspend")), (!sub.shipments_suspended_until && sub.shipments_remaining > 0 || sub.shipments_suspended_until && !isDateAfterToday(sub.shipments_suspended_until)) && /*#__PURE__*/React__default.createElement(Button, {
      variant: "ghost",
      className: "plc-text-red-500 focus:plc-ring-red-500 pelcro-dashboard-sub-suspend-button",
      icon: /*#__PURE__*/React__default.createElement(SvgCalendar, null),
      onClick: onSuspendClick,
      disabled: disableSubmit,
      "data-key": sub.id
    }, t("labels.suspend")), !sub.plan.auto_renew || sub.plan.auto_renew && sub.cancel_at_period_end === 0 ? /*#__PURE__*/React__default.createElement(Button, {
      variant: "ghost",
      className: "plc-text-red-500 focus:plc-ring-red-500 pelcro-dashboard-sub-cancel-button",
      icon: /*#__PURE__*/React__default.createElement(SvgXIconSolid, null),
      onClick: onCancelClick,
      disabled: disableSubmit,
      "data-key": sub.id
    }, t("labels.unsubscribe")) : "", (sub === null || sub === void 0 ? void 0 : (_sub$plan = sub.plan) === null || _sub$plan === void 0 ? void 0 : _sub$plan.type) === 'membership' && /*#__PURE__*/React__default.createElement(Button, {
      variant: "ghost",
      className: "plc-text-blue-400 pelcro-dashboard-sub-manage-members-button",
      icon: /*#__PURE__*/React__default.createElement(SvgRefresh, null),
      onClick: onManageMembersClick,
      disabled: disableSubmit,
      "data-key": sub.id
    }, t("labels.manageMembers"))), /*#__PURE__*/React__default.createElement("td", null, hasPhases && /*#__PURE__*/React__default.createElement("div", {
      className: `plc-flex plc-items-center plc-justify-center plc-transition-transform plc-ease-out plc-transform plc-rounded-full plc-w-7 plc-h-7 ${isActive ? "plc-flex plc-place-items-center plc-w-7 plc-h-7 plc-p-1 plc-bg-primary-400 plc-rounded-full" : "accordion-chevron"}`
    }, /*#__PURE__*/React__default.createElement("span", {
      className: `plc-transition plc-ease-out  ${isActive && "plc-text-white plc-transform plc-rotate-90"}`
    }, /*#__PURE__*/React__default.createElement(SvgChevronRight, null)))))), /*#__PURE__*/React__default.createElement("tbody", null, isActive && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, getPhases().map((phase, i) => {
      var _phase$plans;
      const plan = (_phase$plans = phase.plans) === null || _phase$plans === void 0 ? void 0 : _phase$plans[0].plan;
      const isCurrentPhase = i === 0;
      const startDate = new Date(Number(`${phase.start_date}000`));
      const endDate = new Date(Number(`${phase.end_date}000`));
      const formattedStartDate = new Intl.DateTimeFormat("en-CA").format(startDate);
      const formattedEndDate = new Intl.DateTimeFormat("en-CA").format(endDate);
      const startDateString = `${t("labels.startsOn")} ${formattedStartDate}`;
      const endDateString = `${t("labels.expiresOn")} ${formattedEndDate}`;
      return /*#__PURE__*/React__default.createElement("tr", {
        key: `${phase.start_date}-${phase.end_date}`,
        className: "pelcro-sub-phase-row plc-w-full plc-align-middle"
      }, /*#__PURE__*/React__default.createElement("td", {
        className: "plc-truncate"
      }, plan.nickname && /*#__PURE__*/React__default.createElement("span", {
        className: "plc-font-semibold plc-text-gray-500"
      }, plan.nickname)), /*#__PURE__*/React__default.createElement("td", {
        className: "plc-py-2"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: `plc-inline-flex plc-p-1 plc-text-xs plc-font-semibold plc-uppercase plc-rounded-lg ${isCurrentPhase ? "plc-text-green-700 plc-bg-green-100" : "plc-text-blue-700 plc-bg-blue-100"}
                             `
      }, isCurrentPhase ? /*#__PURE__*/React__default.createElement(SvgCheckMark, null) : /*#__PURE__*/React__default.createElement(SvgCalendar, null), isCurrentPhase ? t("labels.status.active") : t("labels.status.scheduled")), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
        className: "plc-text-xs plc-text-gray-500"
      }, /*#__PURE__*/React__default.createElement("span", {
        className: "plc-inline-block plc-mt-1 plc-underline"
      }, isCurrentPhase ? endDateString : startDateString))));
    }), /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
      colSpan: "4"
    }, /*#__PURE__*/React__default.createElement("hr", {
      className: "plc-mt-4"
    }))))));
  });
};
function getNonDonationSubs() {
  var _window$Pelcro$subscr, _window$Pelcro$subscr2, _window$Pelcro$subscr3;
  return (_window$Pelcro$subscr = (_window$Pelcro$subscr2 = window.Pelcro.subscription) === null || _window$Pelcro$subscr2 === void 0 ? void 0 : (_window$Pelcro$subscr3 = _window$Pelcro$subscr2.list()) === null || _window$Pelcro$subscr3 === void 0 ? void 0 : _window$Pelcro$subscr3.filter(sub => !sub.plan.is_donation)) !== null && _window$Pelcro$subscr !== void 0 ? _window$Pelcro$subscr : [];
}
function isDateAfterToday(date) {
  const today = new Date().setHours(0, 0, 0, 0);
  const newDate = new Date(date).setHours(0, 0, 0, 0);
  return newDate === today ? true : newDate > today;
}

/**
 * @typedef {Object} AccordionPropsType
 * @property {string} initialActiveMenu the initial active menu
 */

/**
 * Accordion component
 * @param {AccordionPropsType} AccordionProps
 * @return {JSX}
 */
const Accordion = _ref => {
  let {
    children,
    initialActiveMenu = ""
  } = _ref;
  const [activeMenu, setActiveMenu] = useState(initialActiveMenu);
  const toggleActiveMenu = menuToToggle => {
    if (activeMenu === menuToToggle) {
      setActiveMenu("");
    } else {
      setActiveMenu(menuToToggle);
    }
  };
  return React__default.Children.map(children, (child, i) => {
    if (child.type === Accordion.item || child.type === OrderItems || child.type === SavedItems || child.type === SubscriptionsItems) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        activeMenu,
        toggleActiveMenu,
        key: i
      });
    } else {
      return child;
    }
  });
};

/**
 * @typedef {Object} AccordionItemPropsType
 * @property {boolean} [show=true] conditionally show the item, defaults to true
 * @property {string} name defined name for the item
 * @property {Element} icon icon element
 * @property {string} title item header title
 * @property {Element} content content element
 * @property {string} activeMenu active menu [PASSED IMPLICITLY BY ACCORDION]
 * @property {(name: string) => void} toggleActiveMenu active menu toggler [PASSED IMPLICITLY BY ACCORDION]
 */

/**
 * Accordion component
 * @param {AccordionItemPropsType} AccordionProps
 * @return {JSX}
 */
Accordion.item = function AccordionItem(_ref2) {
  let {
    show = true,
    name,
    icon,
    title,
    content,
    activeMenu,
    toggleActiveMenu
  } = _ref2;
  const isActive = activeMenu === name;
  return show ? /*#__PURE__*/React__default.createElement("div", {
    id: name,
    className: `plc-border-l-2 plc-border-transparent plc-border-solid plc-group
        ${isActive ? "plc-border-solid plc-bg-grey-200 plc-border-primary-400" : "hover:plc-bg-gray-100"}`
  }, /*#__PURE__*/React__default.createElement("header", {
    onClick: () => toggleActiveMenu(name),
    className: "plc-flex plc-items-center plc-justify-between plc-p-5 plc-px-4 plc-cursor-pointer plc-select-none sm:plc-px-8"
  }, /*#__PURE__*/React__default.createElement("span", {
    className: `plc-flex plc-text-lg plc-items-center ${isActive ? "plc-text-primary-400" : "plc-text-gray-500"}`
  }, icon, title), /*#__PURE__*/React__default.createElement("div", {
    className: `plc-flex plc-items-center plc-justify-center plc-transition-transform plc-ease-out plc-transform plc-rounded-full plc-w-7 plc-h-7 ${isActive ? "plc-flex plc-place-items-center plc-w-7 plc-h-7 plc-p-1 plc-bg-primary-400 plc-rounded-full" : "group-hover:plc-translate-x-1"}`
  }, /*#__PURE__*/React__default.createElement("span", {
    className: `plc-transition plc-ease-out  ${isActive ? "plc-text-white plc-transform plc-rotate-90" : "plc-text-gray-600  group-hover:plc-text-primary-400"}`
  }, /*#__PURE__*/React__default.createElement(SvgChevronRight, null)))), /*#__PURE__*/React__default.createElement("div", {
    className: `plc-ml-4 sm:plc-ml-8 plc-overflow-auto plc-transition-transform plc-origin-right plc-transform ${isActive ? "plc-max-h-80 plc-scale-x-100" : "plc-max-h-0 plc-scale-x-0"}`
  }, content)) : null;
};

var _path$d;
function _extends$d() { _extends$d = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$d.apply(this, arguments); }
function SvgExit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$d({
    className: "plc-w-6 plc-h-6",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$d || (_path$d = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
  })));
}

var _path$c;
function _extends$c() { _extends$c = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$c.apply(this, arguments); }
function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$c({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$c || (_path$c = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 7a4 4 0 11-8 0 4 4 0 018 0zm-4 7a7 7 0 00-7 7h14a7 7 0 00-7-7z"
  })));
}

var _path$b;
function _extends$b() { _extends$b = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$b.apply(this, arguments); }
function SvgNewsletter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$b({
    xmlns: "http://www.w3.org/2000/svg",
    className: "plc-h-5 plc-w-5",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$b || (_path$b = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z"
  })));
}

var _path$a;
function _extends$a() { _extends$a = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$a.apply(this, arguments); }
function SvgDocument(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$a({
    xmlns: "http://www.w3.org/2000/svg",
    className: "plc-h-6 plc-w-6 plc-mr-2",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$a || (_path$a = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
  })));
}

var _path$9;
function _extends$9() { _extends$9 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$9.apply(this, arguments); }
function SvgPaymentCard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$9({
    className: "plc-w-6 plc-h-6 plc-mr-2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$9 || (_path$9 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
  })));
}

var _path$8, _path2;
function _extends$8() { _extends$8 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$8.apply(this, arguments); }
function SvgLocationPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$8({
    className: "plc-w-6 plc-h-6 plc-mr-2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$8 || (_path$8 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15 11a3 3 0 11-6 0 3 3 0 016 0z"
  })));
}

var _path$7;
function _extends$7() { _extends$7 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$7.apply(this, arguments); }
function SvgShopping(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$7({
    className: "plc-w-6 plc-h-6 plc-mr-2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$7 || (_path$7 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"
  })));
}

var _path$6;
function _extends$6() { _extends$6 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$6.apply(this, arguments); }
function SvgBookmark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$6({
    className: "plc-w-6 plc-h-6 plc-mr-2",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path$6 || (_path$6 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M5 5a2 2 0 012-2h10a2 2 0 012 2v16l-7-3.5L5 21V5z"
  })));
}

var _path$5;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, props), _path$5 || (_path$5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z",
    clipRule: "evenodd"
  })));
}

var _path$4;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
function SvgDonate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    width: 24,
    height: 24,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M4 21h9.62a3.995 3.995 0 003.037-1.397l5.102-5.952a1 1 0 00-.442-1.6l-1.968-.656a3.043 3.043 0 00-2.823.503l-3.185 2.547-.617-1.235A3.98 3.98 0 009.146 11H4c-1.103 0-2 .897-2 2v6c0 1.103.897 2 2 2zm0-8h5.146c.763 0 1.448.423 1.789 1.105l.447.895H7v2h6.014a.996.996 0 00.442-.11l.003-.001.004-.002h.003l.002-.001h.004l.001-.001c.009.003.003-.001.003-.001.01 0 .002-.001.002-.001h.001l.002-.001.003-.001.002-.001.002-.001.003-.001.002-.001c.003 0 .001-.001.002-.001l.003-.002.002-.001.002-.001.003-.001.002-.001h.001l.002-.001h.001l.002-.001.002-.001c.009-.001.003-.001.003-.001l.002-.001a.915.915 0 00.11-.078l4.146-3.317c.262-.208.623-.273.94-.167l.557.186-4.133 4.823a2.029 2.029 0 01-1.52.688H4v-6zM16 2h-.017c-.163.002-1.006.039-1.983.705-.951-.648-1.774-.7-1.968-.704L12.002 2h-.004c-.801 0-1.555.313-2.119.878C9.313 3.445 9 4.198 9 5s.313 1.555.861 2.104l3.414 3.586a1.006 1.006 0 001.45-.001l3.396-3.568C18.688 6.555 19 5.802 19 5s-.313-1.555-.878-2.121A2.978 2.978 0 0016.002 2H16zm1 3c0 .267-.104.518-.311.725L14 8.55l-2.707-2.843C11.104 5.518 11 5.267 11 5s.104-.518.294-.708A.977.977 0 0111.979 4c.025.001.502.032 1.067.485.081.065.163.139.247.222l.707.707.707-.707c.084-.083.166-.157.247-.222.529-.425.976-.478 1.052-.484a.987.987 0 01.701.292c.189.189.293.44.293.707z"
  })));
}

var _path$3;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
function SvgMemberships(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    strokeWidth: 1.5,
    stroke: "currentColor",
    width: 24,
    height: 24
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15 9h3.75M15 12h3.75M15 15h3.75M4.5 19.5h15a2.25 2.25 0 002.25-2.25V6.75A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25v10.5A2.25 2.25 0 004.5 19.5zm6-10.125a1.875 1.875 0 11-3.75 0 1.875 1.875 0 013.75 0zm1.294 6.336a6.721 6.721 0 01-3.17.789 6.721 6.721 0 01-3.168-.789 3.376 3.376 0 016.338 0z"
  })));
}

var _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
function SvgQrcode(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    width: 682.667,
    height: 682.667,
    viewBox: "0 0 512 512"
  }, props), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5 62.4c-15.7 3.9-28 16.6-31.4 32.4-.7 3.3-1.1 17.2-1.1 36.4 0 29.1.1 31.4 2 35.3 5.3 11 21.2 11.1 26.4.1 1.4-2.9 1.6-7.9 1.6-34.6 0-34.4.1-35.3 6.3-39 3-1.9 5.2-2 34.5-2 26.9 0 31.9-.2 34.8-1.6 11-5.2 10.9-21.1-.1-26.4-3.9-1.9-6.1-2-36.1-1.9-21.8 0-33.5.5-36.9 1.3zM345.4 63c-10.9 5.4-10.9 21.2 0 26.4 2.9 1.4 7.9 1.6 34.8 1.6 29.3 0 31.5.1 34.5 2 6.2 3.7 6.3 4.6 6.3 39 0 26.7.2 31.7 1.6 34.6 5.2 11 21.1 10.9 26.4-.1 1.9-3.9 2-6.2 2-35.3 0-19.2-.4-33.1-1.1-36.4-3.5-16.2-16.5-29.2-32.7-32.7-3.3-.7-17.2-1.1-36.5-1.1-29.3 0-31.5.1-35.3 2zM146 128.9c-6.9 2.1-12.1 6.5-15.6 13.1-1.8 3.2-1.9 6.3-1.9 38.5 0 34.2 0 35.1 2.2 39.1 2.8 5.3 9.1 10.7 14.2 12.2 2.5.8 14.4 1.2 35.8 1.2 36.3 0 38.3-.3 45.2-7.2 6.8-6.9 7.1-8.9 7.1-45.1 0-22.2-.4-33.2-1.2-36.1-1.8-6-10-13.9-16-15.4-5.3-1.3-65.5-1.6-69.8-.3zm57 51.6V203h-45v-45h45v22.5zM297 128.9c-8 2.5-14.9 9.2-16.9 16.4-.9 2.9-1.1 14.3-.9 37.7.3 37.2.2 36.2 7.4 43.3 6.6 6.4 8.8 6.7 45 6.7 35.6 0 38-.3 44.2-6.3 1.9-1.8 4.3-5 5.5-7.2 2.1-3.9 2.2-5 2.2-39s-.1-35.1-2.2-39c-2.5-4.7-6.4-8.5-11.3-11.1-3.2-1.7-6.4-1.9-37-2.1-18.4-.1-34.6.2-36 .6zm57 51.6V203h-45v-45h45v22.5zM144.1 280.3c-4.8 1.8-10.8 7.2-13.4 12-2.2 4.1-2.2 4.9-2.2 39.2 0 34 .1 35.1 2.2 39 2.5 4.7 6.4 8.5 11.3 11.1 3.2 1.7 6.6 1.9 35.5 2.2 38.9.4 40.7.2 48-7.2 3.2-3.2 5.5-6.6 6.3-9.2.8-2.9 1.2-13.9 1.2-36.1 0-35.8-.4-38.3-6.6-44.7-7-7.2-6-7.1-44.4-7.3-25.4-.1-35.4.1-37.9 1zm58.9 51.2V354h-45v-45h45v22.5zM294.8 280.4c-6.8 2.4-12.9 8.9-14.8 15.7-1.5 5-1.3 66.2.2 71 1.5 5.1 6.9 11.4 12.2 14.2 4 2.2 4.9 2.2 39.1 2.2 32.2 0 35.3-.1 38.5-1.9 4.9-2.6 8.8-6.4 11.3-11.1 2.1-3.9 2.2-5 2.2-39s-.1-35.1-2.2-39c-3-5.6-8-10.1-13.2-12-5.9-2-67.5-2.2-73.3-.1zm59.2 51.1V354h-45v-45h45v22.5zM68.7 339.2c-2.2 1.3-4.5 3.8-5.7 6.3-1.9 3.9-2 6.2-2 35.3 0 19.2.4 33.1 1.1 36.4 3.4 16.1 16.6 29.3 32.7 32.7 3.3.7 17.2 1.1 36.4 1.1 29.1 0 31.4-.1 35.3-2 11-5.3 11.1-21.2.1-26.4-2.9-1.4-7.9-1.6-34.6-1.6-34.4 0-35.3-.1-39-6.3-1.9-3-2-5.2-2-34.5 0-26.9-.2-31.9-1.6-34.8-3.6-7.5-13.5-10.5-20.7-6.2zM429.2 338.7c-1.8.9-4.3 3-5.5 4.7-2.1 3-2.2 4-2.7 36.1-.5 35.8-.6 36.1-6.3 39.5-3 1.9-5.3 2-34.5 2-34.5 0-36.1.2-40.2 6-5.4 7.5-2.8 18 5.5 22 3.9 1.9 6.2 2 35.3 2 19.2 0 33.1-.4 36.4-1.1 16.2-3.5 29.2-16.5 32.7-32.7.7-3.3 1.1-17.2 1.1-36.4 0-29.1-.1-31.4-2-35.3-3.6-7.4-12.5-10.4-19.8-6.8z"
  })));
}

var _path$1;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
function SvgTrashCan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    className: "plc-w-6 plc-h-6",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    fill: "currentColor"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"
  })));
}

const DonationsMenu = _ref => {
  let {
    reactivateSubscription,
    disableSubmit,
    cancelSubscription
  } = _ref;
  const {
    t
  } = useTranslation("dashboard");
  const {
    switchView,
    setSubscriptionToCancel
  } = usePelcro();
  const subscriptions = getDonationSubs().sort((a, b) => a.expires_at - b.expires_at).sort((a, b) => a.renews_at - b.renews_at).map(sub => {
    // Cancel button click handlers
    const onCancelClick = () => {
      var _onClose;
      const isImmediateCancelationEnabled = window.Pelcro.site.read().cancel_settings.status;
      if (isImmediateCancelationEnabled) {
        setSubscriptionToCancel(sub.id);
        return switchView("subscription-cancel");
      }
      if (userMustVerifyEmail()) {
        return switchView("email-verify");
      }
      (_onClose = onClose) === null || _onClose === void 0 ? void 0 : _onClose();
      notify.confirm((onSuccess, onFailure) => {
        cancelSubscription(sub.id, onSuccess, onFailure);
      }, {
        confirmMessage: t("messages.subCancellation.isSureToCancel"),
        loadingMessage: t("messages.subCancellation.loading"),
        successMessage: t("messages.subCancellation.success"),
        errorMessage: t("messages.subCancellation.error")
      }, {
        closeButtonLabel: t("labels.subCancellation.goBack")
      });
    };

    // Reactivate button click handlers
    const onReactivateClick = () => {
      if (userMustVerifyEmail()) {
        return switchView("email-verify");
      }
      reactivateSubscription(sub.id);
    };
    return /*#__PURE__*/React__default.createElement("tr", {
      key: sub.id,
      className: "plc-w-full plc-align-top pelcro-donation-row"
    }, /*#__PURE__*/React__default.createElement("td", {
      className: "plc-truncate"
    }, sub.plan.nickname && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
      className: "plc-font-semibold plc-text-gray-500 pelcro-donation-plan"
    }, sub.plan.nickname), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
      className: "plc-text-xs plc-text-gray-400 pelcro-donation-price"
    }, getFormattedPriceByLocal(sub.plan.amount * sub.quantity, sub.plan.currency, getPageOrDefaultLanguage())))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-mb-4 plc-text-gray-500 pelcro-donation-date"
    }, sub.status && /*#__PURE__*/React__default.createElement("span", null, formatStartDate(sub.start)))), /*#__PURE__*/React__default.createElement("td", null, sub.cancel_at_period_end === 1 && sub.plan.auto_renew && !sub.is_gift_recipient && /*#__PURE__*/React__default.createElement(Button, {
      variant: "ghost",
      className: "plc-text-green-400 focus:plc-ring-green-300 pelcro-dashboard-sub-reactivate-button",
      icon: /*#__PURE__*/React__default.createElement(SvgRefresh, null),
      onClick: onReactivateClick,
      disabled: disableSubmit,
      "data-key": sub.id
    }, t("labels.reactivate")), !sub.plan.auto_renew || sub.plan.auto_renew && sub.cancel_at_period_end === 0 ? /*#__PURE__*/React__default.createElement(Button, {
      variant: "ghost",
      className: "plc-text-red-500 focus:plc-ring-red-500 pelcro-dashboard-sub-cancel-button",
      icon: /*#__PURE__*/React__default.createElement(SvgXIconSolid, null),
      onClick: onCancelClick,
      disabled: disableSubmit,
      "data-key": sub.id
    }, t("labels.unsubscribe")) : ""));
  });
  return /*#__PURE__*/React__default.createElement("table", {
    className: "plc-w-full plc-table-fixed pelcro-donations-table"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "plc-text-xs plc-font-semibold plc-tracking-wider plc-text-gray-400 plc-uppercase "
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-6/12 "
  }, t("labels.plan")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-6/12 "
  }, t("labels.startDate")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-3/12 "
  }, t("labels.actions")))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "plc-h-4"
  }), subscriptions));
};
function getDonationSubs() {
  var _window$Pelcro$subscr, _window$Pelcro$subscr2, _window$Pelcro$subscr3, _window$Pelcro$user$r, _window$Pelcro$user$r2;
  const donations = (_window$Pelcro$subscr = (_window$Pelcro$subscr2 = window.Pelcro.subscription) === null || _window$Pelcro$subscr2 === void 0 ? void 0 : (_window$Pelcro$subscr3 = _window$Pelcro$subscr2.list()) === null || _window$Pelcro$subscr3 === void 0 ? void 0 : _window$Pelcro$subscr3.filter(sub => sub.plan.is_donation && !sub.is_gift_donor)) !== null && _window$Pelcro$subscr !== void 0 ? _window$Pelcro$subscr : [];
  const canceledDonations = (_window$Pelcro$user$r = (_window$Pelcro$user$r2 = window.Pelcro.user.read().expired_subscriptions) === null || _window$Pelcro$user$r2 === void 0 ? void 0 : _window$Pelcro$user$r2.filter(sub => sub.plan.is_donation && !sub.is_gift_donor)) !== null && _window$Pelcro$user$r !== void 0 ? _window$Pelcro$user$r : [];
  return [...donations, ...canceledDonations];
}
function formatStartDate(date) {
  const startDate = new Date(date);
  return new Intl.DateTimeFormat("en-CA").format(startDate);
}

const InvoicesMenu = props => {
  const {
    t
  } = useTranslation("dashboard");
  return /*#__PURE__*/React__default.createElement("table", {
    className: "plc-w-full plc-table-fixed"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "plc-text-xs plc-font-semibold plc-tracking-wider plc-text-gray-400 plc-uppercase "
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-4/12 "
  }, t("labels.details")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-4/12 "
  }, t("labels.status.title")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-3/12 "
  }, t("labels.actions")))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "plc-h-4"
  }), /*#__PURE__*/React__default.createElement(InvoicesItems, props)));
};
const InvoicesItems = () => {
  var _window$Pelcro$invoic, _window$Pelcro$invoic2;
  const {
    t
  } = useTranslation("dashboard");
  const {
    setInvoice,
    switchView
  } = usePelcro();
  const invoices = (_window$Pelcro$invoic = (_window$Pelcro$invoic2 = window.Pelcro.invoice.list()) === null || _window$Pelcro$invoic2 === void 0 ? void 0 : _window$Pelcro$invoic2.filter(invoice => invoice.order_id || invoice.total > 0)) !== null && _window$Pelcro$invoic !== void 0 ? _window$Pelcro$invoic : [];
  const showInvoiceDetails = event => {
    if (setInvoice(event.target.dataset.id)) {
      switchView("invoice-details");
    }
  };
  if (invoices.length === 0) return null;
  return invoices.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime()).map(invoice => {
    const invoiceStatus = getInvoiceStatus(invoice);
    const formattedCreationDate = new Intl.DateTimeFormat("en-CA").format(new Date(invoice.created_at));
    return /*#__PURE__*/React__default.createElement("tr", {
      key: invoice.id,
      className: `plc-w-full plc-align-middle plc-cursor-pointer accordion-header hover:plc-bg-gray-50`
    }, /*#__PURE__*/React__default.createElement("td", {
      className: "plc-truncate"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: "plc-font-semibold plc-text-gray-500"
    }, `#${invoice.id}`), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
      className: "plc-text-sm plc-text-gray-500"
    }, getFormattedPriceByLocal(invoice.total, invoice.currency, getPageOrDefaultLanguage())), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
      className: "plc-text-sm plc-text-gray-500"
    }, formattedCreationDate)), /*#__PURE__*/React__default.createElement("td", {
      className: "plc-py-2"
    }, /*#__PURE__*/React__default.createElement("span", {
      className: `plc-inline-flex plc-p-1 plc-text-xs plc-font-semibold ${invoiceStatus.bgColor} plc-uppercase ${invoiceStatus.textColor} plc-rounded-lg`
    }, invoiceStatus.icon, invoiceStatus.title)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Button, {
      variant: "ghost",
      className: "plc-text-blue-400 focus:plc-ring-blue-400 pelcro-dashboard-view-invoice-button",
      icon: /*#__PURE__*/React__default.createElement(SvgDocument, {
        className: "plc-w-4 plc-h-4"
      }),
      onClick: showInvoiceDetails,
      "data-id": invoice.id
    }, t("labels.view"))));
  });
};
function getInvoiceStatus(invoice) {
  const translations = i18next.t("dashboard:labels", {
    returnObjects: true
  });
  switch (invoice.status) {
    case "paid":
      return {
        textColor: "plc-text-green-700",
        bgColor: "plc-bg-green-100",
        icon: /*#__PURE__*/React__default.createElement(SvgCheckMark, null),
        title: translations.paid
      };
    case "past_due":
      return {
        textColor: "plc-text-orange-700",
        bgColor: "plc-bg-orange-100",
        icon: /*#__PURE__*/React__default.createElement(SvgExclamation, null),
        title: translations.pastDue
      };
    case "open":
      return {
        textColor: "plc-text-yellow-700",
        bgColor: "plc-bg-yellow-100",
        icon: /*#__PURE__*/React__default.createElement(SvgExclamation, null),
        title: translations.open
      };
    case "draft":
      return {
        textColor: "plc-text-blue-700",
        bgColor: "plc-bg-blue-100",
        icon: /*#__PURE__*/React__default.createElement(SvgEdit, null),
        title: translations.draft
      };
    case "scheduled":
      return {
        textColor: "plc-text-blue-700",
        bgColor: "plc-bg-blue-100",
        icon: /*#__PURE__*/React__default.createElement(SvgCalendar, null),
        title: translations.scheduled
      };
    case "uncollectible":
      return {
        textColor: "plc-text-red-700",
        bgColor: "plc-bg-red-100",
        icon: /*#__PURE__*/React__default.createElement(SvgXIconSolid, null),
        title: translations.uncollectible
      };
    case "void":
      return {
        textColor: "plc-text-gray-700",
        bgColor: "plc-bg-gray-100",
        icon: /*#__PURE__*/React__default.createElement(SvgXIconSolid, null),
        title: translations.void
      };
  }
}

const MembershipsMenu = props => {
  const {
    t
  } = useTranslation("dashboard");
  return /*#__PURE__*/React__default.createElement("table", {
    className: "plc-w-full plc-table-fixed"
  }, /*#__PURE__*/React__default.createElement("thead", {
    className: "plc-text-xs plc-font-semibold plc-tracking-wider plc-text-gray-400 plc-uppercase "
  }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-5/12 "
  }, t("labels.plan")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-4/12 "
  }, t("labels.status.title")), /*#__PURE__*/React__default.createElement("th", {
    className: "plc-w-3/12 "
  }, t("labels.actions")))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
    className: "plc-h-4"
  })), /*#__PURE__*/React__default.createElement(MembershipsItems, props));
};
const MembershipsItems = () => {
  const {
    t
  } = useTranslation("dashboard");
  const {
    switchView,
    setSelectedMembership,
    switchToAddressView
  } = usePelcro();
  const memberships = getActiveMemberships();
  const onChangeAddressClick = membershipId => {
    if (userMustVerifyEmail()) {
      return switchView("email-verify");
    }
    if (setSelectedMembership(membershipId)) {
      return switchToAddressView();
    }
  };
  if (memberships.length === 0) return null;
  return memberships.sort((a, b) => a.created_at - b.created_at).map(membership => {
    return /*#__PURE__*/React__default.createElement("tr", {
      key: membership.id,
      className: `plc-w-full plc-align-top pelcro-membership-row`
    }, /*#__PURE__*/React__default.createElement("td", {
      className: "plc-truncate"
    }, membership.subscription.plan.nickname && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
      className: "plc-font-semibold plc-text-gray-500 pelcro-membership-plan"
    }, membership.subscription.plan.nickname))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", {
      className: `plc-inline-flex plc-p-1 plc-text-xs plc-font-semibold ${getMemberShipStatus(membership.status).bgColor} plc-uppercase ${getMemberShipStatus(membership.status).textColor} plc-rounded-lg`
    }, getMemberShipStatus(membership.status).icon, getMemberShipStatus(membership.status).title)), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Button, {
      variant: "ghost",
      icon: /*#__PURE__*/React__default.createElement(SvgEdit, {
        className: "plc-w-4 plc-h-4"
      }),
      className: "plc-text-blue-400 focus:plc-ring-blue-500 pelcro-dashboard-membership-address-button",
      onClick: () => onChangeAddressClick(membership.id)
    }, `${t("labels.editAddress")}`)));
  });
};
function getActiveMemberships() {
  var _window$Pelcro$user$r, _window$Pelcro$user$r2;
  const subsStatuses = ["active", "extended", "trialing"];
  return (_window$Pelcro$user$r = (_window$Pelcro$user$r2 = window.Pelcro.user.read().memberships) === null || _window$Pelcro$user$r2 === void 0 ? void 0 : _window$Pelcro$user$r2.filter(membership => membership.status === "active" && subsStatuses.includes(membership.subscription.status))) !== null && _window$Pelcro$user$r !== void 0 ? _window$Pelcro$user$r : [];
}
function getMemberShipStatus(status) {
  return {
    title: status,
    textColor: "plc-text-green-700",
    bgColor: "plc-bg-green-100",
    icon: /*#__PURE__*/React__default.createElement(SvgCheckMark, null)
  };
}

const SUB_MENUS = {
  PROFILE: "profile",
  SUBSCRIPTIONS: "subscriptions",
  DONATIONS: "donations",
  MEMBERSHIPS: "memberships",
  PAYMENT_CARDS: "payment-cards",
  ADDRESSES: "addresses",
  GIFTS: "gifts",
  ORDERS: "orders",
  INVOICES: "invoices",
  SAVED_ITEMS: "saved-items"
};

/**
 *
 */
function DashboardWithHook(props) {
  React__default.useEffect(() => {
    var _props$onDisplay;
    (_props$onDisplay = props.onDisplay) === null || _props$onDisplay === void 0 ? void 0 : _props$onDisplay.call(props);
  }, []);
  const {
    switchView,
    resetView,
    logout,
    set,
    setPaymentMethodToEdit,
    setPaymentMethodToDelete
  } = usePelcro();
  return /*#__PURE__*/React__default.createElement(DashboardWithTrans, {
    setAddress: addressIdToEdit => set({
      addressIdToEdit
    }),
    setSubscriptionIdToRenew: subscriptionIdToRenew => set({
      subscriptionIdToRenew
    }),
    setIsRenewingGift: isRenewingGift => set({
      isRenewingGift
    }),
    onClose: () => {
      var _props$onClose;
      (_props$onClose = props.onClose) === null || _props$onClose === void 0 ? void 0 : _props$onClose.call(props);
      resetView();
    },
    logout: logout,
    setView: switchView,
    setProductAndPlan: (product, plan, isGift) => set({
      product,
      plan,
      isGift
    }),
    setPaymentMethodToEdit: setPaymentMethodToEdit,
    setPaymentMethodToDelete: setPaymentMethodToDelete
  });
}
DashboardWithHook.viewId = "dashboard";
class Dashboard extends Component {
  constructor(props) {
    var _window$Pelcro$user$r, _window$Pelcro$user$r2, _window, _window$Pelcro, _window$Pelcro$uiSett;
    super(props);
    _defineProperty$3(this, "componentDidMount", () => {
      this.setState({
        isOpen: true
      });
      window.Pelcro.insight.track("Modal Displayed", {
        name: "dashboard"
      });
      if (this.enableReactGA4) {
        ReactGA4.event("Dashboard Modal Viewed", {
          nonInteraction: true
        });
      } else {
        var _ReactGA$event;
        ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event = ReactGA.event) === null || _ReactGA$event === void 0 ? void 0 : _ReactGA$event.call(ReactGA, {
          category: "VIEWS",
          action: "Dashboard Modal Viewed",
          nonInteraction: true
        });
      }
      window.Pelcro.paymentMethods.list({
        auth_token: window.Pelcro.user.read().auth_token
      }, (err, res) => {
        if (err) {
          return console.error(err);
        }
        if (res) {
          this.setState({
            sources: res.data
          });
        }
      });
      const {
        addresses
      } = window.Pelcro.user.read();
      if (addresses) this.setState({
        addresses: addresses
      });
    });
    _defineProperty$3(this, "componentWillUnmount", () => {
      document.removeEventListener("click", this.hideMenuIfClickedOutside);
    });
    _defineProperty$3(this, "initializeHideMenuHandler", () => {
      document.addEventListener("click", this.hideMenuIfClickedOutside);
    });
    _defineProperty$3(this, "hideMenuIfClickedOutside", event => {
      const didClickOutsideMenu = this.state.isOpen && this.menuRef.current && !this.menuRef.current.contains(event.target);
      if (didClickOutsideMenu) {
        this.setState({
          isOpen: false
        });
      }
    });
    _defineProperty$3(this, "cancelSubscription", (subscription_id, onSuccess, onFailure) => {
      // disable the Login button to prevent repeated clicks
      window.Pelcro.subscription.cancel({
        auth_token: window.Pelcro.user.read().auth_token,
        subscription_id: subscription_id
      }, (err, res) => {
        if (err) {
          return onFailure === null || onFailure === void 0 ? void 0 : onFailure(err);
        }
        if (this.enableReactGA4) {
          ReactGA4.event("Canceled", {
            nonInteraction: true
          });
        } else {
          var _ReactGA$event2;
          ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event2 = ReactGA.event) === null || _ReactGA$event2 === void 0 ? void 0 : _ReactGA$event2.call(ReactGA, {
            category: "ACTIONS",
            action: "Canceled",
            nonInteraction: true
          });
        }
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(res);
      });
    });
    _defineProperty$3(this, "unSuspendSubscription", (subscription_id, onSuccess, onFailure) => {
      window.Pelcro.subscription.update({
        auth_token: window.Pelcro.user.read().auth_token,
        subscription_id: subscription_id,
        suspend: 0
      }, (err, res) => {
        if (err) {
          return onFailure === null || onFailure === void 0 ? void 0 : onFailure(err);
        }
        if (this.enableReactGA4) {
          ReactGA4.event("UnSuspended", {
            nonInteraction: true
          });
        } else {
          var _ReactGA$event3;
          ReactGA === null || ReactGA === void 0 ? void 0 : (_ReactGA$event3 = ReactGA.event) === null || _ReactGA$event3 === void 0 ? void 0 : _ReactGA$event3.call(ReactGA, {
            category: "ACTIONS",
            action: "UnSuspended",
            nonInteraction: true
          });
        }
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(res);
      });
    });
    _defineProperty$3(this, "deletePaymentMethod", (paymentMethodId, onSuccess, onFailure) => {
      // disable the Login button to prevent repeated clicks
      window.Pelcro.paymentMethods.deletePaymentMethod({
        auth_token: window.Pelcro.user.read().auth_token,
        payment_method_id: paymentMethodId
      }, (err, res) => {
        if (err) {
          return onFailure === null || onFailure === void 0 ? void 0 : onFailure(err);
        }
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(res);
      });
    });
    _defineProperty$3(this, "onDeletePaymentMethodClick", source => {
      this.props.setPaymentMethodToDelete(source.id);
      return this.props.setView("payment-method-delete");
    });
    _defineProperty$3(this, "displayRedeem", () => {
      return this.props.setView("gift-redeem");
    });
    _defineProperty$3(this, "displaySourceCreate", () => {
      return this.props.setView("payment-method-create");
    });
    _defineProperty$3(this, "displaySourceEdit", e => {
      const source = e.currentTarget.dataset.key;
      this.props.setPaymentMethodToEdit(source);
      return this.props.setView("payment-method-update");
    });
    _defineProperty$3(this, "displayUserEdit", () => {
      return this.props.setView("user-edit");
    });
    _defineProperty$3(this, "displayChangePassword", () => {
      return this.props.setView("password-change");
    });
    _defineProperty$3(this, "displayNewsletterUpdate", () => {
      return this.props.setView("newsletter-update");
    });
    _defineProperty$3(this, "displayQRCode", () => {
      return this.props.setView("qrcode");
    });
    _defineProperty$3(this, "displayProductSelect", _ref => {
      let {
        isGift
      } = _ref;
      if (isGift) {
        this.props.setProductAndPlan(null, null, true);
      }
      return this.props.setView("plan-select");
    });
    _defineProperty$3(this, "displayAddressCreate", () => {
      return this.props.setView("address-create");
    });
    _defineProperty$3(this, "displayAddressEdit", e => {
      const address = e.currentTarget.dataset.key;
      this.props.setAddress(address);
      return this.props.setView("address-edit");
    });
    _defineProperty$3(this, "displayProfilePicChange", () => {
      return this.props.setView("profile-picture");
    });
    _defineProperty$3(this, "getSubscriptionStatusText", subscription => {
      if (subscription.status === "canceled") {
        const cancelDate = new Date(subscription.canceled_at);
        const formattedCancelDate = new Intl.DateTimeFormat("en-CA").format(cancelDate);
        return `${this.locale("labels.canceledOn")} ${formattedCancelDate}`;
      }
      if (subscription.status === "incomplete") {
        return `${this.locale("labels.status.incomplete")}`;
      }
      if (subscription.status === "extended") {
        // DateTime from BE is missing 3 zeros so we add them before instancing a date
        const expiryDate = new Date(Number(`${subscription.end_date}000`));
        const formattedExpiryDate = new Intl.DateTimeFormat("en-CA").format(expiryDate);
        return `${this.locale("labels.until")} ${formattedExpiryDate}`;
      }
      if (subscription.cancel_at_period_end) {
        // DateTime from BE is missing 3 zeros so we add them before instancing a date
        const expiryDate = new Date(Number(`${subscription.expires_at}000`));
        const formattedExpiryDate = new Intl.DateTimeFormat("en-CA").format(expiryDate);
        return `${this.locale("labels.expiresOn")} ${formattedExpiryDate}`;
      }
      const renewDate = new Date(Number(`${subscription.renews_at}000`));
      const formattedRenewDate = new Intl.DateTimeFormat("en-CA").format(renewDate);
      return `${this.locale("labels.renewsOn")} ${formattedRenewDate}`;
    });
    _defineProperty$3(this, "reactivateSubscription", subscription_id => {
      // disable the Login button to prevent repeated clicks
      this.setState({
        disableSubmit: true
      });
      window.Pelcro.subscription.reactivate({
        auth_token: window.Pelcro.user.read().auth_token,
        subscription_id: subscription_id
      }, (err, res) => {
        this.setState({
          disableSubmit: false
        });
        this.props.onClose();
        if (err) {
          return notify$1.error(this.locale("messages.subReactivation.error"));
        }
        return notify$1.success(this.locale("messages.subReactivation.success"));
      });
    });
    _defineProperty$3(this, "getSubscriptionStatus", sub => {
      const isSubscriptionEndingSoon = sub => {
        const weekFromNow = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
        const endingAt = new Date(sub.expires_at * 1000).getTime();
        return weekFromNow > endingAt && sub.cancel_at_period_end;
      };
      const isSubscriptionInTrial = sub => {
        if (!sub.trial_end) {
          return;
        }
        const now = new Date().getTime();
        const trialEndDate = new Date(sub.trial_end).getTime();
        return now < trialEndDate;
      };
      if (isSubscriptionEndingSoon(sub)) {
        return {
          title: this.locale("labels.status.endingSoon"),
          content: this.getSubscriptionStatusText(sub),
          textColor: "plc-text-orange-700",
          bgColor: "plc-bg-orange-100",
          icon: /*#__PURE__*/React__default.createElement(SvgExclamation, null)
        };
      }
      if (isSubscriptionInTrial(sub)) {
        return {
          title: this.locale("labels.status.inTrial"),
          content: this.getSubscriptionStatusText(sub),
          textColor: "plc-text-yellow-700",
          bgColor: "plc-bg-yellow-100",
          icon: /*#__PURE__*/React__default.createElement(SvgCheckMark, null)
        };
      }
      if (sub.status === "incomplete") {
        return {
          title: this.locale("labels.status.incomplete"),
          content: this.getSubscriptionStatusText(sub),
          textColor: "plc-text-orange-700",
          bgColor: "plc-bg-orange-100",
          icon: /*#__PURE__*/React__default.createElement(SvgExclamation, null)
        };
      }
      return {
        title: this.locale("labels.status.active"),
        content: this.getSubscriptionStatusText(sub),
        textColor: "plc-text-green-700",
        bgColor: "plc-bg-green-100",
        icon: /*#__PURE__*/React__default.createElement(SvgCheckMark, null)
      };
    });
    _defineProperty$3(this, "renderGiftRecipients", () => {
      var _giftRecipients$sort, _giftRecipients$sort$;
      const {
        giftRecipients
      } = this.state;
      const giftedSubscriptions = giftRecipients === null || giftRecipients === void 0 ? void 0 : (_giftRecipients$sort = giftRecipients.sort((a, b) => a.expires_at - b.expires_at)) === null || _giftRecipients$sort === void 0 ? void 0 : (_giftRecipients$sort$ = _giftRecipients$sort.sort((a, b) => a.renews_at - b.renews_at)) === null || _giftRecipients$sort$ === void 0 ? void 0 : _giftRecipients$sort$.map(recipient => {
        // Renew click
        const onRenewClick = () => {
          var _recipient$plan, _recipient$plan$produ, _recipient$plan2;
          const productId = (_recipient$plan = recipient.plan) === null || _recipient$plan === void 0 ? void 0 : (_recipient$plan$produ = _recipient$plan.product) === null || _recipient$plan$produ === void 0 ? void 0 : _recipient$plan$produ.id;
          const planId = (_recipient$plan2 = recipient.plan) === null || _recipient$plan2 === void 0 ? void 0 : _recipient$plan2.id;
          const product = window.Pelcro.product.getById(productId);
          const plan = window.Pelcro.plan.getById(planId);
          this.props.setProductAndPlan(product, plan);
          this.props.setSubscriptionIdToRenew(recipient.id);
          this.props.setIsRenewingGift(true);
          this.props.setView("plan-select");
        };
        return /*#__PURE__*/React__default.createElement("tr", {
          key: "dashboard-gift-recipients-" + recipient.id,
          className: "plc-align-top"
        }, /*#__PURE__*/React__default.createElement("td", {
          className: "plc-pr-2 plc-text-gray-500 plc-truncate",
          title: recipient.email
        }, (recipient.first_name || recipient.last_name) && /*#__PURE__*/React__default.createElement("span", {
          className: "plc-font-semibold"
        }, recipient.first_name, " ", recipient.last_name), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
          className: "plc-text-xs"
        }, recipient.email)), /*#__PURE__*/React__default.createElement("td", {
          className: "plc-truncate"
        }, recipient.plan.nickname && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("span", {
          className: "plc-font-semibold plc-text-gray-500"
        }, recipient.plan.nickname), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("span", {
          className: "plc-text-xs plc-text-gray-400"
        }, getFormattedPriceByLocal(recipient.plan.amount, recipient.plan.currency, getPageOrDefaultLanguage())))), recipient.status && /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement("span", {
          className: `plc-inline-flex plc-p-1 plc-text-xs plc-font-semibold ${this.getSubscriptionStatus(recipient).bgColor} plc-uppercase ${this.getSubscriptionStatus(recipient).textColor} plc-rounded-lg`
        }, this.getSubscriptionStatus(recipient).icon, this.getSubscriptionStatus(recipient).title), /*#__PURE__*/React__default.createElement("br", null), /*#__PURE__*/React__default.createElement("div", {
          className: "plc-mb-4 plc-text-xs plc-text-gray-500"
        }, recipient.status && /*#__PURE__*/React__default.createElement("span", {
          className: "plc-inline-block plc-mt-1 plc-underline"
        }, this.getSubscriptionStatus(recipient).content))), recipient.cancel_at_period_end === 1 && /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Button, {
          variant: "ghost",
          icon: /*#__PURE__*/React__default.createElement(SvgRefresh, {
            className: "plc-w-4 plc-h-4"
          }),
          className: "plc-text-blue-400",
          onClick: onRenewClick,
          disabled: this.state.disableSubmit,
          "data-key": recipient.id
        }, this.locale("labels.renew"))));
      });
      return /*#__PURE__*/React__default.createElement("table", {
        className: "plc-w-full plc-table-fixed"
      }, /*#__PURE__*/React__default.createElement("thead", {
        className: "plc-text-xs plc-font-semibold plc-tracking-wider plc-text-gray-400 plc-uppercase "
      }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
        className: "plc-w-4/12 "
      }, this.locale("labels.recipient")), /*#__PURE__*/React__default.createElement("th", {
        className: "plc-w-3/12 "
      }, this.locale("labels.plan")), /*#__PURE__*/React__default.createElement("th", {
        className: "plc-w-3/12 "
      }, this.locale("labels.status.title")), /*#__PURE__*/React__default.createElement("th", {
        className: "plc-w-2/12 "
      }, this.locale("labels.actions")))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
        className: "plc-h-4"
      }), giftedSubscriptions, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
        colSpan: "4",
        className: "plc-p-1"
      }, /*#__PURE__*/React__default.createElement(Button, {
        variant: "ghost",
        icon: /*#__PURE__*/React__default.createElement(SvgPlus, {
          className: "plc-w-4 plc-h-4 plc-mr-1"
        }),
        className: "plc-w-full plc-h-8 plc-font-semibold plc-tracking-wider plc-text-gray-900 plc-uppercase plc-rounded-none hover:plc-bg-gray-100",
        onClick: () => this.displayProductSelect({
          isGift: true
        })
      }, this.locale("labels.addGift"))))));
    });
    _defineProperty$3(this, "renderAddresses", () => {
      const addresses = this.state.addresses && this.state.addresses.map((address, index) => {
        return /*#__PURE__*/React__default.createElement("tr", {
          key: "dashboard-address-" + address.id
        }, /*#__PURE__*/React__default.createElement("td", {
          className: "plc-pr-2 plc-text-gray-400 plc-truncate"
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "plc-font-semibold plc-text-gray-600"
        }, address.city ? `${address.city},` : null, " ", address.country), " ", /*#__PURE__*/React__default.createElement("span", {
          title: address.line1
        }, address.line1), /*#__PURE__*/React__default.createElement("div", {
          className: "plc-flex plc-mb-2 plc-mt-1"
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "plc-rounded-full plc-bg-gray-200 plc-text-black plc-inline-flex plc-items-start plc-py-1 plc-px-4 plc-text-sm plc-capitalize"
        }, address.type === "shipping" ? this.locale("labels.shipping") : this.locale("labels.billing")), address.is_default && /*#__PURE__*/React__default.createElement("span", {
          className: "plc-rounded-full plc-bg-gray-800 plc-text-white plc-inline-flex plc-items-start plc-py-1 plc-px-4 plc-text-sm plc-ml-2"
        }, this.locale("labels.default")))), /*#__PURE__*/React__default.createElement("td", null, /*#__PURE__*/React__default.createElement(Button, {
          variant: "icon",
          className: "plc-text-gray-500",
          icon: /*#__PURE__*/React__default.createElement(SvgEdit, null),
          id: "pelcro-button-update-address-" + index,
          "data-key": address.id,
          onClick: this.displayAddressEdit
        })));
      });
      return /*#__PURE__*/React__default.createElement("table", {
        className: "plc-w-full plc-table-fixed"
      }, /*#__PURE__*/React__default.createElement("thead", {
        className: "plc-text-xs plc-font-semibold plc-tracking-wider plc-text-gray-400 plc-uppercase "
      }, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("th", {
        className: "plc-w-9/12"
      }, this.locale("labels.address")), /*#__PURE__*/React__default.createElement("th", {
        className: "plc-w-3/12"
      }, this.locale("labels.edit")))), /*#__PURE__*/React__default.createElement("tbody", null, /*#__PURE__*/React__default.createElement("tr", {
        className: "plc-h-4"
      }), addresses, /*#__PURE__*/React__default.createElement("tr", null, /*#__PURE__*/React__default.createElement("td", {
        colSpan: "2",
        className: "plc-p-1"
      }, /*#__PURE__*/React__default.createElement(Button, {
        variant: "ghost",
        icon: /*#__PURE__*/React__default.createElement(SvgPlus, {
          className: "plc-w-4 plc-mr-1"
        }),
        className: "plc-w-full plc-h-8 plc-font-semibold plc-tracking-wider plc-text-gray-900 plc-uppercase hover:plc-bg-gray-100",
        onClick: this.displayAddressCreate
      }, this.locale("labels.addAddress"))))));
    });
    _defineProperty$3(this, "renderSources", () => {
      const sources = this.state.sources && this.state.sources.sort((a, b) => a.is_default === b.is_default ? 0 : a.is_default ? -1 : 1).map((source, index) => {
        var _source$properties, _source$properties2;
        return /*#__PURE__*/React__default.createElement("div", {
          key: "dashboard-source-" + source.id,
          className: "plc-flex plc-flex-row plc-pr-6"
        }, /*#__PURE__*/React__default.createElement("div", {
          className: "plc-flex plc-flex-grow plc-items-center plc-justify-between plc-max-w-xs plc-p-4 plc-mb-2 plc-text-white plc-bg-gray-800 plc-rounded-md plc-h-14"
        }, /*#__PURE__*/React__default.createElement("span", null, getPaymentCardIcon(source === null || source === void 0 ? void 0 : (_source$properties = source.properties) === null || _source$properties === void 0 ? void 0 : _source$properties.brand)), /*#__PURE__*/React__default.createElement("span", {
          className: "plc-ml-1 plc-text-lg plc-tracking-widest plc-flex-grow plc-text-center"
        }, "\u2022\u2022\u2022\u2022 ", source === null || source === void 0 ? void 0 : (_source$properties2 = source.properties) === null || _source$properties2 === void 0 ? void 0 : _source$properties2.last4), /*#__PURE__*/React__default.createElement(Button, {
          id: "pelcro-button-update-source-" + index,
          variant: "icon",
          className: "plc-text-white",
          icon: /*#__PURE__*/React__default.createElement(SvgEdit, null),
          "data-key": source.id,
          onClick: this.displaySourceEdit,
          disabled: this.state.disableSubmit
        }), /*#__PURE__*/React__default.createElement(Button, {
          id: "pelcro-button-delete-source-" + index,
          variant: "icon",
          className: "plc-text-white",
          icon: /*#__PURE__*/React__default.createElement(SvgTrashCan, null),
          onClick: () => {
            this.onDeletePaymentMethodClick(source);
          },
          disabled: this.state.disableSubmit
        })), /*#__PURE__*/React__default.createElement("span", {
          className: "plc-flex-grow"
        }), source.is_default && /*#__PURE__*/React__default.createElement("span", {
          className: "plc-rounded-full plc-bg-gray-800 plc-text-white plc-inline-flex plc-h-7 plc-my-auto plc-items-start plc-py-1 plc-px-4 plc-text-sm plc-ml-2"
        }, this.locale("labels.default")));
      });
      return /*#__PURE__*/React__default.createElement("div", {
        className: "plc-pr-2"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "plc-overflow-y-scroll plc-max-h-52"
      }, sources), /*#__PURE__*/React__default.createElement(Button, {
        variant: "ghost",
        icon: /*#__PURE__*/React__default.createElement(SvgPlus, {
          className: "plc-w-4 plc-mr-1"
        }),
        className: "plc-w-full plc-h-8 plc-font-semibold plc-tracking-wider plc-text-gray-900 plc-uppercase hover:plc-bg-gray-100 plc-my-1 plc-ml-1",
        onClick: this.displaySourceCreate
      }, this.locale("labels.addPaymentSource")));
    });
    _defineProperty$3(this, "closeDashboard", () => {
      this.setState({
        isOpen: false
      });
    });
    this.state = {
      isOpen: false,
      subscriptions: window.Pelcro.subscription.list(),
      giftRecipients: (_window$Pelcro$user$r = (_window$Pelcro$user$r2 = window.Pelcro.user.read()) === null || _window$Pelcro$user$r2 === void 0 ? void 0 : _window$Pelcro$user$r2.gift_recipients) !== null && _window$Pelcro$user$r !== void 0 ? _window$Pelcro$user$r : [],
      disableSubmit: false,
      addresses: [],
      sources: []
    };
    this.site = window.Pelcro.site.read();
    this.locale = this.props.t;
    this.user = window.Pelcro.user.read();
    this.menuRef = /*#__PURE__*/React__default.createRef();
    this.enableReactGA4 = (_window = window) === null || _window === void 0 ? void 0 : (_window$Pelcro = _window.Pelcro) === null || _window$Pelcro === void 0 ? void 0 : (_window$Pelcro$uiSett = _window$Pelcro.uiSettings) === null || _window$Pelcro$uiSett === void 0 ? void 0 : _window$Pelcro$uiSett.enableReactGA4;
  }
  render() {
    var _window$Pelcro$user$r3, _window$Pelcro2, _window$Pelcro2$uiSet;
    const {
      isOpen
    } = this.state;
    const userHasName = this.user.first_name || this.user.last_name;
    const profilePicture = (_window$Pelcro$user$r3 = window.Pelcro.user.read().profile_photo) !== null && _window$Pelcro$user$r3 !== void 0 ? _window$Pelcro$user$r3 : userSolidIcon;
    const newsletters = (_window$Pelcro2 = window.Pelcro) === null || _window$Pelcro2 === void 0 ? void 0 : (_window$Pelcro2$uiSet = _window$Pelcro2.uiSettings) === null || _window$Pelcro2$uiSet === void 0 ? void 0 : _window$Pelcro2$uiSet.newsletters;
    const siteHasNewslettersDefined = Array.isArray(newsletters) && newsletters.length > 0;
    return /*#__PURE__*/React__default.createElement(Transition, {
      className: "plc-fixed plc-inset-y-0 plc-right-0 plc-h-full plc-max-w-xl plc-overflow-y-auto plc-text-left plc-bg-white plc-shadow-xl plc-z-max",
      show: isOpen,
      enter: "plc-transform plc-transition plc-duration-500",
      enterFrom: "plc-translate-x-full",
      enterTo: "plc-translate-x-0",
      afterEnter: this.initializeHideMenuHandler,
      leave: "plc-transform plc-transition plc-duration-500",
      leaveFrom: "plc-translate-x-0",
      leaveTo: "plc-translate-x-full",
      afterLeave: this.props.onClose
    }, /*#__PURE__*/React__default.createElement("div", {
      id: "pelcro-view-dashboard",
      ref: this.menuRef
    }, /*#__PURE__*/React__default.createElement("header", {
      className: "plc-flex plc-flex-col plc-p-4 plc-pl-2 plc-min-h-40 sm:plc-pr-8 plc-bg-primary-500"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-flex plc-flex-row-reverse"
    }, /*#__PURE__*/React__default.createElement(Button, {
      variant: "icon",
      className: "plc-text-gray-100 plc-w-7 plc-h-7",
      icon: /*#__PURE__*/React__default.createElement(SvgXIcon, {
        className: "plc-w-12 plc-h-12"
      }),
      onClick: this.closeDashboard
    })), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-flex plc-items-center"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-flex plc-justify-center plc-ml-3 sm:plc-ml-6 "
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "plc-relative plc-flex-shrink-0"
    }, /*#__PURE__*/React__default.createElement("img", {
      className: "plc-w-24 plc-h-24 plc-bg-gray-300 plc-border-2 plc-border-white plc-border-solid plc-rounded-full plc-cursor-pointer pelcro-user-profile-picture",
      src: profilePicture,
      alt: "profile picture",
      onClick: this.displayProfilePicChange
    }), /*#__PURE__*/React__default.createElement(Button, {
      variant: "icon",
      className: "plc-absolute plc-text-white plc-bg-gray-500 plc-w-7 plc-h-7 plc-top-16 plc--right-1 hover:plc-bg-gray-600 hover:plc-text-white",
      icon: /*#__PURE__*/React__default.createElement(SvgEdit, null),
      id: "pelcro-user-update-picture-button",
      onClick: this.displayProfilePicChange
    }))), /*#__PURE__*/React__default.createElement("div", {
      className: "plc-flex plc-flex-col plc-justify-between plc-flex-grow plc-w-56 plc-ml-4 plc-break-words sm:plc-w-auto"
    }, userHasName && /*#__PURE__*/React__default.createElement("p", {
      className: "plc-text-2xl plc-font-bold plc-text-white"
    }, this.user.first_name, " ", this.user.last_name), /*#__PURE__*/React__default.createElement("p", {
      className: `plc-m-0 plc-text-sm plc-text-white ${userHasName ? "plc-text-sm" : "plc-text-lg plc-font-bold plc-mt-auto"}`
    }, this.user.email)))), /*#__PURE__*/React__default.createElement("section", {
      className: "plc-mt-6 plc-shadow-sm"
    }, /*#__PURE__*/React__default.createElement("header", {
      className: "plc-pl-4 plc-mb-2 sm:plc-pl-8"
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "plc-text-xs plc-font-bold plc-tracking-widest plc-text-gray-500 plc-uppercase"
    }, this.locale("labels.account"))), /*#__PURE__*/React__default.createElement(Accordion, null, /*#__PURE__*/React__default.createElement(Accordion.item, {
      name: SUB_MENUS.PROFILE,
      icon: /*#__PURE__*/React__default.createElement(SvgUser, {
        className: "plc-w-6 plc-h-6 plc-mr-2"
      }),
      title: this.locale("labels.myProfile"),
      content: /*#__PURE__*/React__default.createElement("div", {
        className: "plc-flex plc-flex-col plc-my-2 plc-ml-2 plc-space-y-4"
      }, /*#__PURE__*/React__default.createElement(Button, {
        variant: "ghost",
        icon: /*#__PURE__*/React__default.createElement(SvgEdit, {
          className: "plc-w-5 plc-h-5 plc-mr-1"
        }),
        className: "plc-text-sm plc-text-gray-500 hover:plc-text-primary-700",
        onClick: this.displayUserEdit
      }, this.locale("labels.updateProfile")), /*#__PURE__*/React__default.createElement(Button, {
        variant: "ghost",
        icon: /*#__PURE__*/React__default.createElement(SvgKey, {
          className: "plc-w-5 plc-h-5 plc-mr-1"
        }),
        className: "plc-text-sm plc-text-gray-500 hover:plc-text-primary-700",
        onClick: this.displayChangePassword
      }, this.locale("labels.changePassword")), siteHasNewslettersDefined && /*#__PURE__*/React__default.createElement(Button, {
        variant: "ghost",
        icon: /*#__PURE__*/React__default.createElement(SvgNewsletter, {
          className: "plc-w-5 plc-h-5 plc-mr-1"
        }),
        className: "plc-text-sm plc-text-gray-500 hover:plc-text-primary-700",
        onClick: this.displayNewsletterUpdate
      }, this.locale("labels.editNewsletters")), /*#__PURE__*/React__default.createElement(Button, {
        variant: "ghost",
        icon: /*#__PURE__*/React__default.createElement(SvgQrcode, {
          className: "plc-w-5 plc-h-5 plc-mr-1"
        }),
        className: "plc-text-sm plc-text-gray-500 hover:plc-text-primary-700",
        onClick: this.displayQRCode
      }, this.locale("labels.myQRCode")))
    }), /*#__PURE__*/React__default.createElement(Accordion.item, {
      name: SUB_MENUS.PAYMENT_CARDS,
      icon: /*#__PURE__*/React__default.createElement(SvgPaymentCard, null),
      title: this.locale("labels.paymentSource"),
      content: this.renderSources()
    }), /*#__PURE__*/React__default.createElement(Accordion.item, {
      name: SUB_MENUS.ADDRESSES,
      icon: /*#__PURE__*/React__default.createElement(SvgLocationPin, null),
      title: this.locale("labels.addresses"),
      content: this.renderAddresses()
    }), /*#__PURE__*/React__default.createElement("header", {
      className: "plc-pl-4 plc-my-2 sm:plc-pl-8"
    }, /*#__PURE__*/React__default.createElement("p", {
      className: "plc-text-xs plc-font-bold plc-tracking-widest plc-text-gray-500 plc-uppercase"
    }, this.locale("labels.purchases"))), /*#__PURE__*/React__default.createElement(Accordion.item, {
      name: SUB_MENUS.SUBSCRIPTIONS,
      icon: /*#__PURE__*/React__default.createElement(SvgSubscription, {
        className: "plc-w-10 plc-h-10 plc-pt-2 plc-pr-1 plc--ml-2"
      }),
      title: this.locale("labels.subscriptions"),
      content: /*#__PURE__*/React__default.createElement(SubscriptionsMenu, {
        onClose: this.props.onClose,
        cancelSubscription: this.cancelSubscription,
        unSuspendSubscription: this.unSuspendSubscription,
        reactivateSubscription: this.reactivateSubscription,
        setProductAndPlan: this.props.setProductAndPlan,
        setSubscriptionIdToRenew: this.props.setSubscriptionIdToRenew,
        setView: this.props.setView,
        getSubscriptionStatus: this.getSubscriptionStatus,
        disableSubmit: this.state.disableSubmit,
        displayProductSelect: this.displayProductSelect,
        displayRedeem: this.displayRedeem
      })
    }), /*#__PURE__*/React__default.createElement(Accordion.item, {
      show: hasActiveMemberships(),
      name: SUB_MENUS.MEMBERSHIPS,
      icon: /*#__PURE__*/React__default.createElement(SvgMemberships, {
        className: "plc-transform plc-scale-120 plc-w-7 plc-h-8 plc-mr-1 plc-pt-1"
      }),
      title: this.locale("labels.memberships"),
      content: /*#__PURE__*/React__default.createElement(MembershipsMenu, null)
    }), /*#__PURE__*/React__default.createElement(Accordion.item, {
      show: hasDonationSubs(),
      name: SUB_MENUS.DONATIONS,
      icon: /*#__PURE__*/React__default.createElement(SvgDonate, {
        className: "plc-transform plc-scale-120 plc-w-7 plc-h-8 plc-mr-1 plc-pt-1"
      }),
      title: this.locale("labels.donations"),
      content: /*#__PURE__*/React__default.createElement(DonationsMenu, {
        reactivateSubscription: this.reactivateSubscription,
        disableSubmit: this.state.disableSubmit,
        cancelSubscription: this.cancelSubscription
      })
    }), /*#__PURE__*/React__default.createElement(Accordion.item, {
      name: SUB_MENUS.GIFTS,
      icon: /*#__PURE__*/React__default.createElement(SvgGift, null),
      title: this.locale("labels.gifts"),
      content: this.renderGiftRecipients()
    }), /*#__PURE__*/React__default.createElement(Accordion.item, {
      show: window.Pelcro.site.read().ecommerce_enabled,
      name: SUB_MENUS.ORDERS,
      icon: /*#__PURE__*/React__default.createElement(SvgShopping, null),
      title: this.locale("labels.orders.label"),
      content: /*#__PURE__*/React__default.createElement(OrdersMenu, null)
    }), /*#__PURE__*/React__default.createElement(Accordion.item, {
      show: hasInvoices(),
      name: SUB_MENUS.INVOICES,
      icon: /*#__PURE__*/React__default.createElement(SvgDocument, null),
      title: this.locale("labels.invoices"),
      content: /*#__PURE__*/React__default.createElement(InvoicesMenu, null)
    }), /*#__PURE__*/React__default.createElement(Accordion.item, {
      name: SUB_MENUS.SAVED_ITEMS,
      icon: /*#__PURE__*/React__default.createElement(SvgBookmark, null),
      title: this.locale("labels.savedItems.label"),
      content: /*#__PURE__*/React__default.createElement(SavedItemsMenu, null)
    }), /*#__PURE__*/React__default.createElement(Button, {
      variant: "outline",
      icon: /*#__PURE__*/React__default.createElement(SvgExit, null),
      className: "plc-flex plc-items-center plc-justify-start plc-w-full plc-p-5 plc-px-4 plc-text-lg plc-font-normal plc-text-gray-500 plc-capitalize plc-bg-transparent plc-border-0 plc-border-l-2 plc-border-transparent plc-rounded-none plc-cursor-pointer plc-select-none sm:plc-px-8 hover:plc-bg-gray-100 hover:plc-text-gray-500",
      onClick: this.props.logout
    }, this.locale("labels.logout"))))));
  }
}
function hasInvoices() {
  var _window$Pelcro$invoic, _window$Pelcro$invoic2;
  const invoices = (_window$Pelcro$invoic = (_window$Pelcro$invoic2 = window.Pelcro.invoice.list()) === null || _window$Pelcro$invoic2 === void 0 ? void 0 : _window$Pelcro$invoic2.filter(invoice => invoice.order_id || invoice.total > 0)) !== null && _window$Pelcro$invoic !== void 0 ? _window$Pelcro$invoic : [];
  return invoices.length > 0;
}
function hasDonationSubs() {
  var _window$Pelcro$subscr, _window$Pelcro$subscr2, _window$Pelcro$subscr3, _window$Pelcro$user$r4, _window$Pelcro$user$r5;
  const donations = (_window$Pelcro$subscr = (_window$Pelcro$subscr2 = window.Pelcro.subscription) === null || _window$Pelcro$subscr2 === void 0 ? void 0 : (_window$Pelcro$subscr3 = _window$Pelcro$subscr2.list()) === null || _window$Pelcro$subscr3 === void 0 ? void 0 : _window$Pelcro$subscr3.filter(sub => sub.plan.is_donation && !sub.is_gift_donor)) !== null && _window$Pelcro$subscr !== void 0 ? _window$Pelcro$subscr : [];
  const canceledDonations = (_window$Pelcro$user$r4 = (_window$Pelcro$user$r5 = window.Pelcro.user.read().expired_subscriptions) === null || _window$Pelcro$user$r5 === void 0 ? void 0 : _window$Pelcro$user$r5.filter(sub => sub.plan.is_donation && !sub.is_gift_donor)) !== null && _window$Pelcro$user$r4 !== void 0 ? _window$Pelcro$user$r4 : [];
  return donations.length > 0 || canceledDonations.length > 0;
}
function hasActiveMemberships() {
  var _window$Pelcro$user$r6, _window$Pelcro$user$r7;
  const subsStatuses = ["active", "extended", "trialing"];
  return (_window$Pelcro$user$r6 = (_window$Pelcro$user$r7 = window.Pelcro.user.read().memberships) === null || _window$Pelcro$user$r7 === void 0 ? void 0 : _window$Pelcro$user$r7.some(membership => membership.status === "active" && subsStatuses.includes(membership.subscription.status))) !== null && _window$Pelcro$user$r6 !== void 0 ? _window$Pelcro$user$r6 : false;
}
const DashboardWithTrans = withTranslation("dashboard")(Dashboard);

// The button in the lower right that shows the dashboard.
const DashboardOpenButton = () => {
  const {
    switchView
  } = usePelcro();
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-fixed plc-right-4 plc-bottom-4 pelcro-open-dashboard-btn"
  }, /*#__PURE__*/React__default.createElement("button", {
    className: "plc-bg-white plc-border-2 plc-rounded-full focus:plc-outline-none plc-border-primary-300 hover:plc-bg-white",
    name: "menu",
    id: "pelcro-view-menu",
    onClick: () => switchView("dashboard")
  }, /*#__PURE__*/React__default.createElement("svg", {
    className: "plc-w-10 plc-h-10 plc-text-primary-400 hover:plc-text-primary-500",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    d: "M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z",
    clipRule: "evenodd"
  }))));
};
DashboardOpenButton.viewId = "dashboard-open";

const initialState$3 = {
  imageSrc: null,
  crop: {
    x: 0,
    y: 0
  },
  zoom: 1,
  croppedAreaPixels: null,
  isSubmitting: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$3 = /*#__PURE__*/createContext(initialState$3);
const {
  Provider: Provider$3
} = store$3;
const ProfilePicChangeContainer = _ref => {
  let {
    style,
    className = "",
    onChangeSuccess = () => {},
    onChangeFailure = () => {},
    onRemoveSuccess = () => {},
    onRemoveFailure = () => {},
    children
  } = _ref;
  const {
    t
  } = useTranslation("userEdit");
  const handleUpdatePicture = async (_ref2, dispatch) => {
    let {
      imageSrc,
      croppedAreaPixels
    } = _ref2;
    try {
      const croppedImage = await getCroppedAndResizedImg(imageSrc, croppedAreaPixels);
      window.Pelcro.user.uploadProfilePicture({
        auth_token: window.Pelcro.user.read().auth_token,
        image: croppedImage
      }, (err, res) => {
        dispatch({
          type: LOADING,
          payload: false
        });
        if (err) {
          dispatch({
            type: SHOW_ALERT,
            payload: {
              type: "error",
              content: getErrorMessages(err)
            }
          });
          return onChangeFailure(err);
        }
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "success",
            content: t("messages.pictureUpdated")
          }
        });
        return onChangeSuccess();
      });
    } catch (e) {
      console.error(e);
    }
  };
  const handleRemovePicture = dispatch => {
    window.Pelcro.user.removeProfilePicture({
      auth_token: window.Pelcro.user.read().auth_token
    }, (err, res) => {
      dispatch({
        type: LOADING,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        return onRemoveFailure(err);
      }
      dispatch({
        type: SHOW_ALERT,
        payload: {
          type: "success",
          content: t("messages.pictureRemoved")
        }
      });
      return onRemoveSuccess();
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case CHANGE_IMAGE_FILE:
        return lib_4((state, dispatch) => handleFileChange(action.payload, dispatch));
      case SET_IMAGE_SRC:
        return lib_7({
          ...state,
          imageSrc: action.payload
        });
      case REMOVE_IMAGE:
        return lib_5({
          ...state,
          isSubmitting: true
        }, (state, dispatch) => handleRemovePicture(dispatch));
      case SET_ZOOM:
        return lib_7({
          ...state,
          zoom: action.payload
        });
      case SET_CROP:
        return lib_7({
          ...state,
          crop: action.payload
        });
      case CROP_COMPLETE:
        return lib_7({
          ...state,
          croppedAreaPixels: action.payload
        });
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case LOADING:
        return lib_7({
          ...state,
          isSubmitting: action.payload
        });
      case HANDLE_USER_UPDATE:
        return lib_5({
          ...state,
          isSubmitting: true
        }, (state, dispatch) => handleUpdatePicture(state, dispatch));
      default:
        return state;
    }
  }, initialState$3);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-profile-picture-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$3, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$3,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$3
  })));
};

/**
 * @param {File} imageSrc - Image File url
 * @param {Object} pixelCrop - pixelCrop Object provided by react-easy-crop
 */
const getCroppedAndResizedImg = async (imageSrc, pixelCrop) => {
  const image = await createImage(imageSrc);
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const IMAGE_DIMENSION_IN_PX = 320;
  canvas.width = IMAGE_DIMENSION_IN_PX;
  canvas.height = IMAGE_DIMENSION_IN_PX;
  ctx.drawImage(image, pixelCrop.x, pixelCrop.y, pixelCrop.width, pixelCrop.height, 0, 0, IMAGE_DIMENSION_IN_PX, IMAGE_DIMENSION_IN_PX);
  return new Promise(resolve => {
    canvas.toBlob(file => {
      resolve(file);
    }, "image/png");
  });
};
const createImage = url => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.addEventListener("load", () => resolve(image));
    image.addEventListener("error", error => reject(error));
    image.src = url;
  });
};
const handleFileChange = async (files, dispatch) => {
  if (files.length > 0) {
    const imgFile = files[0];
    const imageDataUrl = await readFile(imgFile);
    dispatch({
      type: SET_IMAGE_SRC,
      payload: imageDataUrl
    });
  }
};
const readFile = file => {
  return new Promise(resolve => {
    const reader = new FileReader();
    reader.addEventListener("load", () => resolve(reader.result), false);
    reader.readAsDataURL(file);
  });
};

const ProfilePicChangeButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    state: {
      isSubmitting
    },
    dispatch
  } = useContext(store$3);
  const {
    t
  } = useTranslation("userEdit");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_USER_UPDATE
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    isLoading: isSubmitting
  }, otherProps), name !== null && name !== void 0 ? name : t("labels.save"));
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

/**
 * Copyright 2004-present Facebook. All Rights Reserved.
 *
 * @providesModule UserAgent_DEPRECATED
 */

/**
 *  Provides entirely client-side User Agent and OS detection. You should prefer
 *  the non-deprecated UserAgent module when possible, which exposes our
 *  authoritative server-side PHP-based detection to the client.
 *
 *  Usage is straightforward:
 *
 *    if (UserAgent_DEPRECATED.ie()) {
 *      //  IE
 *    }
 *
 *  You can also do version checks:
 *
 *    if (UserAgent_DEPRECATED.ie() >= 7) {
 *      //  IE7 or better
 *    }
 *
 *  The browser functions will return NaN if the browser does not match, so
 *  you can also do version compares the other way:
 *
 *    if (UserAgent_DEPRECATED.ie() < 7) {
 *      //  IE6 or worse
 *    }
 *
 *  Note that the version is a float and may include a minor version number,
 *  so you should always use range operators to perform comparisons, not
 *  strict equality.
 *
 *  **Note:** You should **strongly** prefer capability detection to browser
 *  version detection where it's reasonable:
 *
 *    http://www.quirksmode.org/js/support.html
 *
 *  Further, we have a large number of mature wrapper functions and classes
 *  which abstract away many browser irregularities. Check the documentation,
 *  grep for things, or ask on javascript@lists.facebook.com before writing yet
 *  another copy of "event || window.event".
 *
 */

var _populated = false;

// Browsers
var _ie, _firefox, _opera, _webkit, _chrome;

// Actual IE browser for compatibility mode
var _ie_real_version;

// Platforms
var _osx, _windows, _linux, _android;

// Architectures
var _win64;

// Devices
var _iphone, _ipad, _native;

var _mobile;

function _populate() {
  if (_populated) {
    return;
  }

  _populated = true;

  // To work around buggy JS libraries that can't handle multi-digit
  // version numbers, Opera 10's user agent string claims it's Opera
  // 9, then later includes a Version/X.Y field:
  //
  // Opera/9.80 (foo) Presto/2.2.15 Version/10.10
  var uas = navigator.userAgent;
  var agent = /(?:MSIE.(\d+\.\d+))|(?:(?:Firefox|GranParadiso|Iceweasel).(\d+\.\d+))|(?:Opera(?:.+Version.|.)(\d+\.\d+))|(?:AppleWebKit.(\d+(?:\.\d+)?))|(?:Trident\/\d+\.\d+.*rv:(\d+\.\d+))/.exec(uas);
  var os    = /(Mac OS X)|(Windows)|(Linux)/.exec(uas);

  _iphone = /\b(iPhone|iP[ao]d)/.exec(uas);
  _ipad = /\b(iP[ao]d)/.exec(uas);
  _android = /Android/i.exec(uas);
  _native = /FBAN\/\w+;/i.exec(uas);
  _mobile = /Mobile/i.exec(uas);

  // Note that the IE team blog would have you believe you should be checking
  // for 'Win64; x64'.  But MSDN then reveals that you can actually be coming
  // from either x64 or ia64;  so ultimately, you should just check for Win64
  // as in indicator of whether you're in 64-bit IE.  32-bit IE on 64-bit
  // Windows will send 'WOW64' instead.
  _win64 = !!(/Win64/.exec(uas));

  if (agent) {
    _ie = agent[1] ? parseFloat(agent[1]) : (
          agent[5] ? parseFloat(agent[5]) : NaN);
    // IE compatibility mode
    if (_ie && document && document.documentMode) {
      _ie = document.documentMode;
    }
    // grab the "true" ie version from the trident token if available
    var trident = /(?:Trident\/(\d+.\d+))/.exec(uas);
    _ie_real_version = trident ? parseFloat(trident[1]) + 4 : _ie;

    _firefox = agent[2] ? parseFloat(agent[2]) : NaN;
    _opera   = agent[3] ? parseFloat(agent[3]) : NaN;
    _webkit  = agent[4] ? parseFloat(agent[4]) : NaN;
    if (_webkit) {
      // We do not add the regexp to the above test, because it will always
      // match 'safari' only since 'AppleWebKit' appears before 'Chrome' in
      // the userAgent string.
      agent = /(?:Chrome\/(\d+\.\d+))/.exec(uas);
      _chrome = agent && agent[1] ? parseFloat(agent[1]) : NaN;
    } else {
      _chrome = NaN;
    }
  } else {
    _ie = _firefox = _opera = _chrome = _webkit = NaN;
  }

  if (os) {
    if (os[1]) {
      // Detect OS X version.  If no version number matches, set _osx to true.
      // Version examples:  10, 10_6_1, 10.7
      // Parses version number as a float, taking only first two sets of
      // digits.  If only one set of digits is found, returns just the major
      // version number.
      var ver = /(?:Mac OS X (\d+(?:[._]\d+)?))/.exec(uas);

      _osx = ver ? parseFloat(ver[1].replace('_', '.')) : true;
    } else {
      _osx = false;
    }
    _windows = !!os[2];
    _linux   = !!os[3];
  } else {
    _osx = _windows = _linux = false;
  }
}

var UserAgent_DEPRECATED = {

  /**
   *  Check if the UA is Internet Explorer.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  ie: function() {
    return _populate() || _ie;
  },

  /**
   * Check if we're in Internet Explorer compatibility mode.
   *
   * @return bool true if in compatibility mode, false if
   * not compatibility mode or not ie
   */
  ieCompatibilityMode: function() {
    return _populate() || (_ie_real_version > _ie);
  },


  /**
   * Whether the browser is 64-bit IE.  Really, this is kind of weak sauce;  we
   * only need this because Skype can't handle 64-bit IE yet.  We need to remove
   * this when we don't need it -- tracked by #601957.
   */
  ie64: function() {
    return UserAgent_DEPRECATED.ie() && _win64;
  },

  /**
   *  Check if the UA is Firefox.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  firefox: function() {
    return _populate() || _firefox;
  },


  /**
   *  Check if the UA is Opera.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  opera: function() {
    return _populate() || _opera;
  },


  /**
   *  Check if the UA is WebKit.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  webkit: function() {
    return _populate() || _webkit;
  },

  /**
   *  For Push
   *  WILL BE REMOVED VERY SOON. Use UserAgent_DEPRECATED.webkit
   */
  safari: function() {
    return UserAgent_DEPRECATED.webkit();
  },

  /**
   *  Check if the UA is a Chrome browser.
   *
   *
   *  @return float|NaN Version number (if match) or NaN.
   */
  chrome : function() {
    return _populate() || _chrome;
  },


  /**
   *  Check if the user is running Windows.
   *
   *  @return bool `true' if the user's OS is Windows.
   */
  windows: function() {
    return _populate() || _windows;
  },


  /**
   *  Check if the user is running Mac OS X.
   *
   *  @return float|bool   Returns a float if a version number is detected,
   *                       otherwise true/false.
   */
  osx: function() {
    return _populate() || _osx;
  },

  /**
   * Check if the user is running Linux.
   *
   * @return bool `true' if the user's OS is some flavor of Linux.
   */
  linux: function() {
    return _populate() || _linux;
  },

  /**
   * Check if the user is running on an iPhone or iPod platform.
   *
   * @return bool `true' if the user is running some flavor of the
   *    iPhone OS.
   */
  iphone: function() {
    return _populate() || _iphone;
  },

  mobile: function() {
    return _populate() || (_iphone || _ipad || _android || _mobile);
  },

  nativeApp: function() {
    // webviews inside of the native apps
    return _populate() || _native;
  },

  android: function() {
    return _populate() || _android;
  },

  ipad: function() {
    return _populate() || _ipad;
  }
};

var UserAgent_DEPRECATED_1 = UserAgent_DEPRECATED;

/**
 * Copyright (c) 2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @providesModule ExecutionEnvironment
 */

var canUseDOM = !!(
  typeof window !== 'undefined' &&
  window.document &&
  window.document.createElement
);

/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */
var ExecutionEnvironment = {

  canUseDOM: canUseDOM,

  canUseWorkers: typeof Worker !== 'undefined',

  canUseEventListeners:
    canUseDOM && !!(window.addEventListener || window.attachEvent),

  canUseViewport: canUseDOM && !!window.screen,

  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};

var ExecutionEnvironment_1 = ExecutionEnvironment;

var useHasFeature;
if (ExecutionEnvironment_1.canUseDOM) {
  useHasFeature =
    document.implementation &&
    document.implementation.hasFeature &&
    // always returns true in newer browsers as per the standard.
    // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
    document.implementation.hasFeature('', '') !== true;
}

/**
 * Checks if an event is supported in the current execution environment.
 *
 * NOTE: This will not work correctly for non-generic events such as `change`,
 * `reset`, `load`, `error`, and `select`.
 *
 * Borrows from Modernizr.
 *
 * @param {string} eventNameSuffix Event name, e.g. "click".
 * @param {?boolean} capture Check if the capture phase is supported.
 * @return {boolean} True if the event is supported.
 * @internal
 * @license Modernizr 3.0.0pre (Custom Build) | MIT
 */
function isEventSupported(eventNameSuffix, capture) {
  if (!ExecutionEnvironment_1.canUseDOM ||
      capture && !('addEventListener' in document)) {
    return false;
  }

  var eventName = 'on' + eventNameSuffix;
  var isSupported = eventName in document;

  if (!isSupported) {
    var element = document.createElement('div');
    element.setAttribute(eventName, 'return;');
    isSupported = typeof element[eventName] === 'function';
  }

  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
    // This is the only way to test support for the `wheel` event in IE9+.
    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
  }

  return isSupported;
}

var isEventSupported_1 = isEventSupported;

// Reasonable defaults
var PIXEL_STEP  = 10;
var LINE_HEIGHT = 40;
var PAGE_HEIGHT = 800;

/**
 * Mouse wheel (and 2-finger trackpad) support on the web sucks.  It is
 * complicated, thus this doc is long and (hopefully) detailed enough to answer
 * your questions.
 *
 * If you need to react to the mouse wheel in a predictable way, this code is
 * like your bestest friend. * hugs *
 *
 * As of today, there are 4 DOM event types you can listen to:
 *
 *   'wheel'                -- Chrome(31+), FF(17+), IE(9+)
 *   'mousewheel'           -- Chrome, IE(6+), Opera, Safari
 *   'MozMousePixelScroll'  -- FF(3.5 only!) (2010-2013) -- don't bother!
 *   'DOMMouseScroll'       -- FF(0.9.7+) since 2003
 *
 * So what to do?  The is the best:
 *
 *   normalizeWheel.getEventType();
 *
 * In your event callback, use this code to get sane interpretation of the
 * deltas.  This code will return an object with properties:
 *
 *   spinX   -- normalized spin speed (use for zoom) - x plane
 *   spinY   -- " - y plane
 *   pixelX  -- normalized distance (to pixels) - x plane
 *   pixelY  -- " - y plane
 *
 * Wheel values are provided by the browser assuming you are using the wheel to
 * scroll a web page by a number of lines or pixels (or pages).  Values can vary
 * significantly on different platforms and browsers, forgetting that you can
 * scroll at different speeds.  Some devices (like trackpads) emit more events
 * at smaller increments with fine granularity, and some emit massive jumps with
 * linear speed or acceleration.
 *
 * This code does its best to normalize the deltas for you:
 *
 *   - spin is trying to normalize how far the wheel was spun (or trackpad
 *     dragged).  This is super useful for zoom support where you want to
 *     throw away the chunky scroll steps on the PC and make those equal to
 *     the slow and smooth tiny steps on the Mac. Key data: This code tries to
 *     resolve a single slow step on a wheel to 1.
 *
 *   - pixel is normalizing the desired scroll delta in pixel units.  You'll
 *     get the crazy differences between browsers, but at least it'll be in
 *     pixels!
 *
 *   - positive value indicates scrolling DOWN/RIGHT, negative UP/LEFT.  This
 *     should translate to positive value zooming IN, negative zooming OUT.
 *     This matches the newer 'wheel' event.
 *
 * Why are there spinX, spinY (or pixels)?
 *
 *   - spinX is a 2-finger side drag on the trackpad, and a shift + wheel turn
 *     with a mouse.  It results in side-scrolling in the browser by default.
 *
 *   - spinY is what you expect -- it's the classic axis of a mouse wheel.
 *
 *   - I dropped spinZ/pixelZ.  It is supported by the DOM 3 'wheel' event and
 *     probably is by browsers in conjunction with fancy 3D controllers .. but
 *     you know.
 *
 * Implementation info:
 *
 * Examples of 'wheel' event if you scroll slowly (down) by one step with an
 * average mouse:
 *
 *   OS X + Chrome  (mouse)     -    4   pixel delta  (wheelDelta -120)
 *   OS X + Safari  (mouse)     -  N/A   pixel delta  (wheelDelta  -12)
 *   OS X + Firefox (mouse)     -    0.1 line  delta  (wheelDelta  N/A)
 *   Win8 + Chrome  (mouse)     -  100   pixel delta  (wheelDelta -120)
 *   Win8 + Firefox (mouse)     -    3   line  delta  (wheelDelta -120)
 *
 * On the trackpad:
 *
 *   OS X + Chrome  (trackpad)  -    2   pixel delta  (wheelDelta   -6)
 *   OS X + Firefox (trackpad)  -    1   pixel delta  (wheelDelta  N/A)
 *
 * On other/older browsers.. it's more complicated as there can be multiple and
 * also missing delta values.
 *
 * The 'wheel' event is more standard:
 *
 * http://www.w3.org/TR/DOM-Level-3-Events/#events-wheelevents
 *
 * The basics is that it includes a unit, deltaMode (pixels, lines, pages), and
 * deltaX, deltaY and deltaZ.  Some browsers provide other values to maintain
 * backward compatibility with older events.  Those other values help us
 * better normalize spin speed.  Example of what the browsers provide:
 *
 *                          | event.wheelDelta | event.detail
 *        ------------------+------------------+--------------
 *          Safari v5/OS X  |       -120       |       0
 *          Safari v5/Win7  |       -120       |       0
 *         Chrome v17/OS X  |       -120       |       0
 *         Chrome v17/Win7  |       -120       |       0
 *                IE9/Win7  |       -120       |   undefined
 *         Firefox v4/OS X  |     undefined    |       1
 *         Firefox v4/Win7  |     undefined    |       3
 *
 */
function normalizeWheel$1(/*object*/ event) /*object*/ {
  var sX = 0, sY = 0,       // spinX, spinY
      pX = 0, pY = 0;       // pixelX, pixelY

  // Legacy
  if ('detail'      in event) { sY = event.detail; }
  if ('wheelDelta'  in event) { sY = -event.wheelDelta / 120; }
  if ('wheelDeltaY' in event) { sY = -event.wheelDeltaY / 120; }
  if ('wheelDeltaX' in event) { sX = -event.wheelDeltaX / 120; }

  // side scrolling on FF with DOMMouseScroll
  if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
    sX = sY;
    sY = 0;
  }

  pX = sX * PIXEL_STEP;
  pY = sY * PIXEL_STEP;

  if ('deltaY' in event) { pY = event.deltaY; }
  if ('deltaX' in event) { pX = event.deltaX; }

  if ((pX || pY) && event.deltaMode) {
    if (event.deltaMode == 1) {          // delta in LINE units
      pX *= LINE_HEIGHT;
      pY *= LINE_HEIGHT;
    } else {                             // delta in PAGE units
      pX *= PAGE_HEIGHT;
      pY *= PAGE_HEIGHT;
    }
  }

  // Fall-back if spin cannot be determined
  if (pX && !sX) { sX = (pX < 1) ? -1 : 1; }
  if (pY && !sY) { sY = (pY < 1) ? -1 : 1; }

  return { spinX  : sX,
           spinY  : sY,
           pixelX : pX,
           pixelY : pY };
}


/**
 * The best combination if you prefer spinX + spinY normalization.  It favors
 * the older DOMMouseScroll for Firefox, as FF does not include wheelDelta with
 * 'wheel' event, making spin speed determination impossible.
 */
normalizeWheel$1.getEventType = function() /*string*/ {
  return (UserAgent_DEPRECATED_1.firefox())
           ? 'DOMMouseScroll'
           : (isEventSupported_1('wheel'))
               ? 'wheel'
               : 'mousewheel';
};

var normalizeWheel_1 = normalizeWheel$1;

var normalizeWheel = normalizeWheel_1;

/**
 * Compute the dimension of the crop area based on media size,
 * aspect ratio and optionally rotation
 */

function getCropSize(mediaWidth, mediaHeight, containerWidth, containerHeight, aspect, rotation) {
  if (rotation === void 0) {
    rotation = 0;
  }

  var _a = translateSize(mediaWidth, mediaHeight, rotation),
      width = _a.width,
      height = _a.height;

  var fittingWidth = Math.min(width, containerWidth);
  var fittingHeight = Math.min(height, containerHeight);

  if (fittingWidth > fittingHeight * aspect) {
    return {
      width: fittingHeight * aspect,
      height: fittingHeight
    };
  }

  return {
    width: fittingWidth,
    height: fittingWidth / aspect
  };
}
/**
 * Ensure a new media position stays in the crop area.
 */

function restrictPosition(position, mediaSize, cropSize, zoom, rotation) {
  if (rotation === void 0) {
    rotation = 0;
  }

  var _a = translateSize(mediaSize.width, mediaSize.height, rotation),
      width = _a.width,
      height = _a.height;

  return {
    x: restrictPositionCoord(position.x, width, cropSize.width, zoom),
    y: restrictPositionCoord(position.y, height, cropSize.height, zoom)
  };
}

function restrictPositionCoord(position, mediaSize, cropSize, zoom) {
  var maxPosition = mediaSize * zoom / 2 - cropSize / 2;
  return Math.min(maxPosition, Math.max(position, -maxPosition));
}

function getDistanceBetweenPoints(pointA, pointB) {
  return Math.sqrt(Math.pow(pointA.y - pointB.y, 2) + Math.pow(pointA.x - pointB.x, 2));
}
function getRotationBetweenPoints(pointA, pointB) {
  return Math.atan2(pointB.y - pointA.y, pointB.x - pointA.x) * 180 / Math.PI;
}
/**
 * Compute the output cropped area of the media in percentages and pixels.
 * x/y are the top-left coordinates on the src media
 */

function computeCroppedArea(crop, mediaSize, cropSize, aspect, zoom, rotation, restrictPosition) {
  if (rotation === void 0) {
    rotation = 0;
  }

  if (restrictPosition === void 0) {
    restrictPosition = true;
  } // if the media is rotated by the user, we cannot limit the position anymore
  // as it might need to be negative.


  var limitAreaFn = restrictPosition && rotation === 0 ? limitArea : noOp;
  var croppedAreaPercentages = {
    x: limitAreaFn(100, ((mediaSize.width - cropSize.width / zoom) / 2 - crop.x / zoom) / mediaSize.width * 100),
    y: limitAreaFn(100, ((mediaSize.height - cropSize.height / zoom) / 2 - crop.y / zoom) / mediaSize.height * 100),
    width: limitAreaFn(100, cropSize.width / mediaSize.width * 100 / zoom),
    height: limitAreaFn(100, cropSize.height / mediaSize.height * 100 / zoom)
  }; // we compute the pixels size naively

  var widthInPixels = Math.round(limitAreaFn(mediaSize.naturalWidth, croppedAreaPercentages.width * mediaSize.naturalWidth / 100));
  var heightInPixels = Math.round(limitAreaFn(mediaSize.naturalHeight, croppedAreaPercentages.height * mediaSize.naturalHeight / 100));
  var isImgWiderThanHigh = mediaSize.naturalWidth >= mediaSize.naturalHeight * aspect; // then we ensure the width and height exactly match the aspect (to avoid rounding approximations)
  // if the media is wider than high, when zoom is 0, the crop height will be equals to iamge height
  // thus we want to compute the width from the height and aspect for accuracy.
  // Otherwise, we compute the height from width and aspect.

  var sizePixels = isImgWiderThanHigh ? {
    width: Math.round(heightInPixels * aspect),
    height: heightInPixels
  } : {
    width: widthInPixels,
    height: Math.round(widthInPixels / aspect)
  };

  var croppedAreaPixels = __assign(__assign({}, sizePixels), {
    x: Math.round(limitAreaFn(mediaSize.naturalWidth - sizePixels.width, croppedAreaPercentages.x * mediaSize.naturalWidth / 100)),
    y: Math.round(limitAreaFn(mediaSize.naturalHeight - sizePixels.height, croppedAreaPercentages.y * mediaSize.naturalHeight / 100))
  });

  return {
    croppedAreaPercentages: croppedAreaPercentages,
    croppedAreaPixels: croppedAreaPixels
  };
}
/**
 * Ensure the returned value is between 0 and max
 */

function limitArea(max, value) {
  return Math.min(max, Math.max(0, value));
}

function noOp(_max, value) {
  return value;
}
/**
 * Compute the crop and zoom from the croppedAreaPixels
 */


function getZoomFromCroppedAreaPixels(croppedAreaPixels, mediaSize, cropSize) {
  var mediaZoom = mediaSize.width / mediaSize.naturalWidth;

  if (cropSize) {
    var isHeightMaxSize_1 = cropSize.height > cropSize.width;
    return isHeightMaxSize_1 ? cropSize.height / mediaZoom / croppedAreaPixels.height : cropSize.width / mediaZoom / croppedAreaPixels.width;
  }

  var aspect = croppedAreaPixels.width / croppedAreaPixels.height;
  var isHeightMaxSize = mediaSize.naturalWidth >= mediaSize.naturalHeight * aspect;
  return isHeightMaxSize ? mediaSize.naturalHeight / croppedAreaPixels.height : mediaSize.naturalWidth / croppedAreaPixels.width;
}
/**
 * Compute the crop and zoom from the croppedAreaPixels
 */


function getInitialCropFromCroppedAreaPixels(croppedAreaPixels, mediaSize, cropSize) {
  var mediaZoom = mediaSize.width / mediaSize.naturalWidth;
  var zoom = getZoomFromCroppedAreaPixels(croppedAreaPixels, mediaSize, cropSize);
  var cropZoom = mediaZoom * zoom;
  var crop = {
    x: ((mediaSize.naturalWidth - croppedAreaPixels.width) / 2 - croppedAreaPixels.x) * cropZoom,
    y: ((mediaSize.naturalHeight - croppedAreaPixels.height) / 2 - croppedAreaPixels.y) * cropZoom
  };
  return {
    crop: crop,
    zoom: zoom
  };
}
/**
 * Return the point that is the center of point a and b
 */

function getCenter(a, b) {
  return {
    x: (b.x + a.x) / 2,
    y: (b.y + a.y) / 2
  };
}
/**
 *
 * Returns an x,y point once rotated around xMid,yMid
 */

function rotateAroundMidPoint(x, y, xMid, yMid, degrees) {
  var cos = Math.cos;
  var sin = Math.sin;
  var radian = degrees * Math.PI / 180; // Convert to radians
  // Subtract midpoints, so that midpoint is translated to origin
  // and add it in the end again

  var xr = (x - xMid) * cos(radian) - (y - yMid) * sin(radian) + xMid;
  var yr = (x - xMid) * sin(radian) + (y - yMid) * cos(radian) + yMid;
  return [xr, yr];
}
/**
 * Returns the new bounding area of a rotated rectangle.
 */

function translateSize(width, height, rotation) {
  var centerX = width / 2;
  var centerY = height / 2;
  var outerBounds = [rotateAroundMidPoint(0, 0, centerX, centerY, rotation), rotateAroundMidPoint(width, 0, centerX, centerY, rotation), rotateAroundMidPoint(width, height, centerX, centerY, rotation), rotateAroundMidPoint(0, height, centerX, centerY, rotation)];
  var minX = Math.min.apply(Math, outerBounds.map(function (p) {
    return p[0];
  }));
  var maxX = Math.max.apply(Math, outerBounds.map(function (p) {
    return p[0];
  }));
  var minY = Math.min.apply(Math, outerBounds.map(function (p) {
    return p[1];
  }));
  var maxY = Math.max.apply(Math, outerBounds.map(function (p) {
    return p[1];
  }));
  return {
    width: maxX - minX,
    height: maxY - minY
  };
}
/**
 * Combine multiple class names into a single string.
 */

function classNames() {
  var args = [];

  for (var _i = 0; _i < arguments.length; _i++) {
    args[_i] = arguments[_i];
  }

  return args.filter(function (value) {
    if (typeof value === 'string' && value.length > 0) {
      return true;
    }

    return false;
  }).join(' ').trim();
}

var css_248z = ".reactEasyCrop_Container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  overflow: hidden;\n  user-select: none;\n  touch-action: none;\n  cursor: move;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.reactEasyCrop_Image,\n.reactEasyCrop_Video {\n  will-change: transform; /* this improves performances and prevent painting issues on iOS Chrome */\n}\n\n.reactEasyCrop_Contain {\n  max-width: 100%;\n  max-height: 100%;\n  margin: auto;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n}\n.reactEasyCrop_Cover_Horizontal {\n  width: 100%;\n  height: auto;\n}\n.reactEasyCrop_Cover_Vertical {\n  width: auto;\n  height: 100%;\n}\n\n.reactEasyCrop_CropArea {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  box-sizing: border-box;\n  box-shadow: 0 0 0 9999em;\n  color: rgba(0, 0, 0, 0.5);\n  overflow: hidden;\n}\n\n.reactEasyCrop_CropAreaRound {\n  border-radius: 50%;\n}\n\n.reactEasyCrop_CropAreaGrid::before {\n  content: ' ';\n  box-sizing: border-box;\n  position: absolute;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  top: 0;\n  bottom: 0;\n  left: 33.33%;\n  right: 33.33%;\n  border-top: 0;\n  border-bottom: 0;\n}\n\n.reactEasyCrop_CropAreaGrid::after {\n  content: ' ';\n  box-sizing: border-box;\n  position: absolute;\n  border: 1px solid rgba(255, 255, 255, 0.5);\n  top: 33.33%;\n  bottom: 33.33%;\n  left: 0;\n  right: 0;\n  border-left: 0;\n  border-right: 0;\n}\n";

var MIN_ZOOM = 1;
var MAX_ZOOM = 3;

var Cropper =
/** @class */
function (_super) {
  __extends(Cropper, _super);

  function Cropper() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.imageRef = null;
    _this.videoRef = null;
    _this.containerRef = null;
    _this.styleRef = null;
    _this.containerRect = null;
    _this.mediaSize = {
      width: 0,
      height: 0,
      naturalWidth: 0,
      naturalHeight: 0
    };
    _this.dragStartPosition = {
      x: 0,
      y: 0
    };
    _this.dragStartCrop = {
      x: 0,
      y: 0
    };
    _this.lastPinchDistance = 0;
    _this.lastPinchRotation = 0;
    _this.rafDragTimeout = null;
    _this.rafPinchTimeout = null;
    _this.wheelTimer = null;
    _this.state = {
      cropSize: null,
      hasWheelJustStarted: false
    }; // this is to prevent Safari on iOS >= 10 to zoom the page

    _this.preventZoomSafari = function (e) {
      return e.preventDefault();
    };

    _this.cleanEvents = function () {
      document.removeEventListener('mousemove', _this.onMouseMove);
      document.removeEventListener('mouseup', _this.onDragStopped);
      document.removeEventListener('touchmove', _this.onTouchMove);
      document.removeEventListener('touchend', _this.onDragStopped);
    };

    _this.clearScrollEvent = function () {
      if (_this.containerRef) _this.containerRef.removeEventListener('wheel', _this.onWheel);

      if (_this.wheelTimer) {
        clearTimeout(_this.wheelTimer);
      }
    };

    _this.onMediaLoad = function () {
      _this.computeSizes();

      _this.emitCropData();

      _this.setInitialCrop();

      if (_this.props.onMediaLoaded) {
        _this.props.onMediaLoaded(_this.mediaSize);
      }
    };

    _this.setInitialCrop = function () {
      var _a = _this.props,
          initialCroppedAreaPixels = _a.initialCroppedAreaPixels,
          cropSize = _a.cropSize;

      if (!initialCroppedAreaPixels) {
        return;
      }

      var _b = getInitialCropFromCroppedAreaPixels(initialCroppedAreaPixels, _this.mediaSize, cropSize),
          crop = _b.crop,
          zoom = _b.zoom;

      _this.props.onCropChange(crop);

      _this.props.onZoomChange && _this.props.onZoomChange(zoom);
    };

    _this.computeSizes = function () {
      var _a, _b, _c, _d, _e, _f;

      var mediaRef = _this.imageRef || _this.videoRef;

      if (mediaRef && _this.containerRef) {
        _this.containerRect = _this.containerRef.getBoundingClientRect();
        _this.mediaSize = {
          width: mediaRef.offsetWidth,
          height: mediaRef.offsetHeight,
          naturalWidth: ((_a = _this.imageRef) === null || _a === void 0 ? void 0 : _a.naturalWidth) || ((_b = _this.videoRef) === null || _b === void 0 ? void 0 : _b.videoWidth) || 0,
          naturalHeight: ((_c = _this.imageRef) === null || _c === void 0 ? void 0 : _c.naturalHeight) || ((_d = _this.videoRef) === null || _d === void 0 ? void 0 : _d.videoHeight) || 0
        };
        var cropSize = _this.props.cropSize ? _this.props.cropSize : getCropSize(mediaRef.offsetWidth, mediaRef.offsetHeight, _this.containerRect.width, _this.containerRect.height, _this.props.aspect, _this.props.rotation);

        if (((_e = _this.state.cropSize) === null || _e === void 0 ? void 0 : _e.height) !== cropSize.height || ((_f = _this.state.cropSize) === null || _f === void 0 ? void 0 : _f.width) !== cropSize.width) {
          _this.props.onCropSizeChange && _this.props.onCropSizeChange(cropSize);
        }

        _this.setState({
          cropSize: cropSize
        }, _this.recomputeCropPosition);
      }
    };

    _this.onMouseDown = function (e) {
      e.preventDefault();
      document.addEventListener('mousemove', _this.onMouseMove);
      document.addEventListener('mouseup', _this.onDragStopped);

      _this.onDragStart(Cropper.getMousePoint(e));
    };

    _this.onMouseMove = function (e) {
      return _this.onDrag(Cropper.getMousePoint(e));
    };

    _this.onTouchStart = function (e) {
      e.preventDefault();
      document.addEventListener('touchmove', _this.onTouchMove, {
        passive: false
      }); // iOS 11 now defaults to passive: true

      document.addEventListener('touchend', _this.onDragStopped);

      if (e.touches.length === 2) {
        _this.onPinchStart(e);
      } else if (e.touches.length === 1) {
        _this.onDragStart(Cropper.getTouchPoint(e.touches[0]));
      }
    };

    _this.onTouchMove = function (e) {
      // Prevent whole page from scrolling on iOS.
      e.preventDefault();

      if (e.touches.length === 2) {
        _this.onPinchMove(e);
      } else if (e.touches.length === 1) {
        _this.onDrag(Cropper.getTouchPoint(e.touches[0]));
      }
    };

    _this.onDragStart = function (_a) {
      var _b, _c;

      var x = _a.x,
          y = _a.y;
      _this.dragStartPosition = {
        x: x,
        y: y
      };
      _this.dragStartCrop = __assign({}, _this.props.crop);
      (_c = (_b = _this.props).onInteractionStart) === null || _c === void 0 ? void 0 : _c.call(_b);
    };

    _this.onDrag = function (_a) {
      var x = _a.x,
          y = _a.y;
      if (_this.rafDragTimeout) window.cancelAnimationFrame(_this.rafDragTimeout);
      _this.rafDragTimeout = window.requestAnimationFrame(function () {
        if (!_this.state.cropSize) return;
        if (x === undefined || y === undefined) return;
        var offsetX = x - _this.dragStartPosition.x;
        var offsetY = y - _this.dragStartPosition.y;
        var requestedPosition = {
          x: _this.dragStartCrop.x + offsetX,
          y: _this.dragStartCrop.y + offsetY
        };
        var newPosition = _this.props.restrictPosition ? restrictPosition(requestedPosition, _this.mediaSize, _this.state.cropSize, _this.props.zoom, _this.props.rotation) : requestedPosition;

        _this.props.onCropChange(newPosition);
      });
    };

    _this.onDragStopped = function () {
      var _a, _b;

      _this.cleanEvents();

      _this.emitCropData();

      (_b = (_a = _this.props).onInteractionEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
    };

    _this.onWheel = function (e) {
      e.preventDefault();
      var point = Cropper.getMousePoint(e);
      var pixelY = normalizeWheel(e).pixelY;
      var newZoom = _this.props.zoom - pixelY * _this.props.zoomSpeed / 200;

      _this.setNewZoom(newZoom, point);

      if (!_this.state.hasWheelJustStarted) {
        _this.setState({
          hasWheelJustStarted: true
        }, function () {
          var _a, _b;

          return (_b = (_a = _this.props).onInteractionStart) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
      }

      if (_this.wheelTimer) {
        clearTimeout(_this.wheelTimer);
      }

      _this.wheelTimer = window.setTimeout(function () {
        return _this.setState({
          hasWheelJustStarted: false
        }, function () {
          var _a, _b;

          return (_b = (_a = _this.props).onInteractionEnd) === null || _b === void 0 ? void 0 : _b.call(_a);
        });
      }, 250);
    };

    _this.getPointOnContainer = function (_a) {
      var x = _a.x,
          y = _a.y;

      if (!_this.containerRect) {
        throw new Error('The Cropper is not mounted');
      }

      return {
        x: _this.containerRect.width / 2 - (x - _this.containerRect.left),
        y: _this.containerRect.height / 2 - (y - _this.containerRect.top)
      };
    };

    _this.getPointOnMedia = function (_a) {
      var x = _a.x,
          y = _a.y;
      var _b = _this.props,
          crop = _b.crop,
          zoom = _b.zoom;
      return {
        x: (x + crop.x) / zoom,
        y: (y + crop.y) / zoom
      };
    };

    _this.setNewZoom = function (zoom, point) {
      if (!_this.state.cropSize || !_this.props.onZoomChange) return;

      var zoomPoint = _this.getPointOnContainer(point);

      var zoomTarget = _this.getPointOnMedia(zoomPoint);

      var newZoom = Math.min(_this.props.maxZoom, Math.max(zoom, _this.props.minZoom));
      var requestedPosition = {
        x: zoomTarget.x * newZoom - zoomPoint.x,
        y: zoomTarget.y * newZoom - zoomPoint.y
      };
      var newPosition = _this.props.restrictPosition ? restrictPosition(requestedPosition, _this.mediaSize, _this.state.cropSize, newZoom, _this.props.rotation) : requestedPosition;

      _this.props.onCropChange(newPosition);

      _this.props.onZoomChange(newZoom);
    };

    _this.getCropData = function () {
      if (!_this.state.cropSize) {
        return null;
      } // this is to ensure the crop is correctly restricted after a zoom back (https://github.com/ricardo-ch/react-easy-crop/issues/6)


      var restrictedPosition = _this.props.restrictPosition ? restrictPosition(_this.props.crop, _this.mediaSize, _this.state.cropSize, _this.props.zoom, _this.props.rotation) : _this.props.crop;
      return computeCroppedArea(restrictedPosition, _this.mediaSize, _this.state.cropSize, _this.getAspect(), _this.props.zoom, _this.props.rotation, _this.props.restrictPosition);
    };

    _this.emitCropData = function () {
      var cropData = _this.getCropData();

      if (!cropData) return;
      var croppedAreaPercentages = cropData.croppedAreaPercentages,
          croppedAreaPixels = cropData.croppedAreaPixels;

      if (_this.props.onCropComplete) {
        _this.props.onCropComplete(croppedAreaPercentages, croppedAreaPixels);
      }

      if (_this.props.onCropAreaChange) {
        _this.props.onCropAreaChange(croppedAreaPercentages, croppedAreaPixels);
      }
    };

    _this.emitCropAreaChange = function () {
      var cropData = _this.getCropData();

      if (!cropData) return;
      var croppedAreaPercentages = cropData.croppedAreaPercentages,
          croppedAreaPixels = cropData.croppedAreaPixels;

      if (_this.props.onCropAreaChange) {
        _this.props.onCropAreaChange(croppedAreaPercentages, croppedAreaPixels);
      }
    };

    _this.recomputeCropPosition = function () {
      if (!_this.state.cropSize) return;
      var newPosition = _this.props.restrictPosition ? restrictPosition(_this.props.crop, _this.mediaSize, _this.state.cropSize, _this.props.zoom, _this.props.rotation) : _this.props.crop;

      _this.props.onCropChange(newPosition);

      _this.emitCropData();
    };

    return _this;
  }

  Cropper.prototype.componentDidMount = function () {
    window.addEventListener('resize', this.computeSizes);

    if (this.containerRef) {
      this.props.zoomWithScroll && this.containerRef.addEventListener('wheel', this.onWheel, {
        passive: false
      });
      this.containerRef.addEventListener('gesturestart', this.preventZoomSafari);
      this.containerRef.addEventListener('gesturechange', this.preventZoomSafari);
    }

    if (!this.props.disableAutomaticStylesInjection) {
      this.styleRef = document.createElement('style');
      this.styleRef.setAttribute('type', 'text/css');
      this.styleRef.innerHTML = css_248z;
      document.head.appendChild(this.styleRef);
    } // when rendered via SSR, the image can already be loaded and its onLoad callback will never be called


    if (this.imageRef && this.imageRef.complete) {
      this.onMediaLoad();
    }
  };

  Cropper.prototype.componentWillUnmount = function () {
    var _a;

    window.removeEventListener('resize', this.computeSizes);

    if (this.containerRef) {
      this.containerRef.removeEventListener('gesturestart', this.preventZoomSafari);
      this.containerRef.removeEventListener('gesturechange', this.preventZoomSafari);
    }

    if (this.styleRef) {
      (_a = this.styleRef.parentNode) === null || _a === void 0 ? void 0 : _a.removeChild(this.styleRef);
    }

    this.cleanEvents();
    this.props.zoomWithScroll && this.clearScrollEvent();
  };

  Cropper.prototype.componentDidUpdate = function (prevProps) {
    var _a, _b, _c, _d, _e, _f, _g, _h;

    if (prevProps.rotation !== this.props.rotation) {
      this.computeSizes();
      this.recomputeCropPosition();
    } else if (prevProps.aspect !== this.props.aspect) {
      this.computeSizes();
    } else if (prevProps.zoom !== this.props.zoom) {
      this.recomputeCropPosition();
    } else if (((_a = prevProps.cropSize) === null || _a === void 0 ? void 0 : _a.height) !== ((_b = this.props.cropSize) === null || _b === void 0 ? void 0 : _b.height) || ((_c = prevProps.cropSize) === null || _c === void 0 ? void 0 : _c.width) !== ((_d = this.props.cropSize) === null || _d === void 0 ? void 0 : _d.width)) {
      this.computeSizes();
    } else if (((_e = prevProps.crop) === null || _e === void 0 ? void 0 : _e.x) !== ((_f = this.props.crop) === null || _f === void 0 ? void 0 : _f.x) || ((_g = prevProps.crop) === null || _g === void 0 ? void 0 : _g.y) !== ((_h = this.props.crop) === null || _h === void 0 ? void 0 : _h.y)) {
      this.emitCropAreaChange();
    }

    if (prevProps.zoomWithScroll !== this.props.zoomWithScroll && this.containerRef) {
      this.props.zoomWithScroll ? this.containerRef.addEventListener('wheel', this.onWheel, {
        passive: false
      }) : this.clearScrollEvent();
    }
  };

  Cropper.prototype.getAspect = function () {
    var _a = this.props,
        cropSize = _a.cropSize,
        aspect = _a.aspect;

    if (cropSize) {
      return cropSize.width / cropSize.height;
    }

    return aspect;
  };

  Cropper.prototype.onPinchStart = function (e) {
    var pointA = Cropper.getTouchPoint(e.touches[0]);
    var pointB = Cropper.getTouchPoint(e.touches[1]);
    this.lastPinchDistance = getDistanceBetweenPoints(pointA, pointB);
    this.lastPinchRotation = getRotationBetweenPoints(pointA, pointB);
    this.onDragStart(getCenter(pointA, pointB));
  };

  Cropper.prototype.onPinchMove = function (e) {
    var _this = this;

    var pointA = Cropper.getTouchPoint(e.touches[0]);
    var pointB = Cropper.getTouchPoint(e.touches[1]);
    var center = getCenter(pointA, pointB);
    this.onDrag(center);
    if (this.rafPinchTimeout) window.cancelAnimationFrame(this.rafPinchTimeout);
    this.rafPinchTimeout = window.requestAnimationFrame(function () {
      var distance = getDistanceBetweenPoints(pointA, pointB);
      var newZoom = _this.props.zoom * (distance / _this.lastPinchDistance);

      _this.setNewZoom(newZoom, center);

      _this.lastPinchDistance = distance;
      var rotation = getRotationBetweenPoints(pointA, pointB);
      var newRotation = _this.props.rotation + (rotation - _this.lastPinchRotation);
      _this.props.onRotationChange && _this.props.onRotationChange(newRotation);
      _this.lastPinchRotation = rotation;
    });
  };

  Cropper.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        image = _a.image,
        video = _a.video,
        mediaProps = _a.mediaProps,
        transform = _a.transform,
        _b = _a.crop,
        x = _b.x,
        y = _b.y,
        rotation = _a.rotation,
        zoom = _a.zoom,
        cropShape = _a.cropShape,
        showGrid = _a.showGrid,
        _c = _a.style,
        containerStyle = _c.containerStyle,
        cropAreaStyle = _c.cropAreaStyle,
        mediaStyle = _c.mediaStyle,
        _d = _a.classes,
        containerClassName = _d.containerClassName,
        cropAreaClassName = _d.cropAreaClassName,
        mediaClassName = _d.mediaClassName,
        objectFit = _a.objectFit;
    return /*#__PURE__*/React__default.createElement("div", {
      onMouseDown: this.onMouseDown,
      onTouchStart: this.onTouchStart,
      ref: function ref(el) {
        return _this.containerRef = el;
      },
      "data-testid": "container",
      style: containerStyle,
      className: classNames('reactEasyCrop_Container', containerClassName)
    }, image ? /*#__PURE__*/React__default.createElement("img", __assign({
      alt: "",
      className: classNames('reactEasyCrop_Image', objectFit === 'contain' && 'reactEasyCrop_Contain', objectFit === 'horizontal-cover' && 'reactEasyCrop_Cover_Horizontal', objectFit === 'vertical-cover' && 'reactEasyCrop_Cover_Vertical', mediaClassName)
    }, mediaProps, {
      src: image,
      ref: function ref(el) {
        return _this.imageRef = el;
      },
      style: __assign(__assign({}, mediaStyle), {
        transform: transform || "translate(" + x + "px, " + y + "px) rotate(" + rotation + "deg) scale(" + zoom + ")"
      }),
      onLoad: this.onMediaLoad
    })) : video && /*#__PURE__*/React__default.createElement("video", __assign({
      autoPlay: true,
      loop: true,
      muted: true,
      className: classNames('reactEasyCrop_Video', objectFit === 'contain' && 'reactEasyCrop_Contain', objectFit === 'horizontal-cover' && 'reactEasyCrop_Cover_Horizontal', objectFit === 'vertical-cover' && 'reactEasyCrop_Cover_Vertical', mediaClassName)
    }, mediaProps, {
      ref: function ref(el) {
        return _this.videoRef = el;
      },
      onLoadedMetadata: this.onMediaLoad,
      style: __assign(__assign({}, mediaStyle), {
        transform: transform || "translate(" + x + "px, " + y + "px) rotate(" + rotation + "deg) scale(" + zoom + ")"
      }),
      controls: false
    }), (Array.isArray(video) ? video : [{
      src: video
    }]).map(function (item) {
      return /*#__PURE__*/React__default.createElement("source", __assign({
        key: item.src
      }, item));
    })), this.state.cropSize && /*#__PURE__*/React__default.createElement("div", {
      style: __assign(__assign({}, cropAreaStyle), {
        width: this.state.cropSize.width,
        height: this.state.cropSize.height
      }),
      "data-testid": "cropper",
      className: classNames('reactEasyCrop_CropArea', cropShape === 'round' && 'reactEasyCrop_CropAreaRound', showGrid && 'reactEasyCrop_CropAreaGrid', cropAreaClassName)
    }));
  };

  Cropper.defaultProps = {
    zoom: 1,
    rotation: 0,
    aspect: 4 / 3,
    maxZoom: MAX_ZOOM,
    minZoom: MIN_ZOOM,
    cropShape: 'rect',
    objectFit: 'contain',
    showGrid: true,
    style: {},
    classes: {},
    mediaProps: {},
    zoomSpeed: 1,
    restrictPosition: true,
    zoomWithScroll: true
  };

  Cropper.getMousePoint = function (e) {
    return {
      x: Number(e.clientX),
      y: Number(e.clientY)
    };
  };

  Cropper.getTouchPoint = function (touch) {
    return {
      x: Number(touch.clientX),
      y: Number(touch.clientY)
    };
  };

  return Cropper;
}(React__default.Component);

const ProfilePicChangeCropper = _ref => {
  let {
    className = "",
    ...otherProps
  } = _ref;
  const {
    state: {
      imageSrc,
      crop,
      zoom
    },
    dispatch
  } = useContext(store$3);
  return /*#__PURE__*/React__default.createElement("div", {
    className: `plc-relative plc-w-full plc-h-52 sm:plc-h-96 ${className}`
  }, /*#__PURE__*/React__default.createElement(Cropper, Object.assign({
    image: imageSrc,
    crop: crop,
    zoom: zoom,
    maxZoom: 4,
    aspect: 1,
    onCropChange: location => dispatch({
      type: SET_CROP,
      payload: location
    }),
    onCropComplete: (croppedArea, croppedAreaPixels) => dispatch({
      type: CROP_COMPLETE,
      payload: croppedAreaPixels
    }),
    onZoomChange: zoom => dispatch({
      type: SET_ZOOM,
      payload: zoom
    }),
    zoomSpeed: 0.5,
    showGrid: false,
    cropShape: "round",
    disableAutomaticStylesInjection: true,
    classes: {
      containerClassName: "pelcro-cropper-container",
      mediaClassName: "pelcro-cropper-image",
      cropAreaClassName: "pelcro-cropper-area"
    }
  }, otherProps)));
};

const ProfilePicChangeZoom = _ref => {
  let {
    className = "",
    ...otherProps
  } = _ref;
  const {
    state: {
      zoom
    },
    dispatch
  } = useContext(store$3);
  const {
    t
  } = useTranslation("userEdit");
  return /*#__PURE__*/React__default.createElement("div", {
    className: `plc-flex plc-flex-col plc-items-center ${className}`
  }, /*#__PURE__*/React__default.createElement("label", {
    htmlFor: "pelcro-picture-zoom-input",
    className: "plc-text-gray-900"
  }, t("labels.zoom")), /*#__PURE__*/React__default.createElement("input", Object.assign({
    type: "range",
    id: "pelcro-picture-zoom-input",
    min: "1",
    max: "4",
    step: "0.1",
    value: zoom,
    onChange: e => dispatch({
      type: SET_ZOOM,
      payload: Number(e.target.value)
    })
  }, otherProps)));
};

var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgPhotograph(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "plc-h-6 plc-w-6",
    fill: "none",
    viewBox: "0 0 24 24",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
  })));
}

const ProfilePicChangeSelectButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      isSubmitting
    }
  } = useContext(store$3);
  const {
    t
  } = useTranslation("userEdit");
  const browseFiles = () => {
    const fileInput = document.getElementById("pelcro-profile-picture-selector");
    if (fileInput) {
      fileInput.click();
      onClick === null || onClick === void 0 ? void 0 : onClick();
    }
  };
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Button, Object.assign({
    icon: /*#__PURE__*/React__default.createElement(SvgPhotograph, null),
    disabled: isSubmitting,
    onClick: browseFiles,
    "aria-controls": "fileupload"
  }, otherProps), name !== null && name !== void 0 ? name : t("labels.selectImage")), /*#__PURE__*/React__default.createElement("input", {
    id: "pelcro-profile-picture-selector",
    type: "file",
    onChange: e => dispatch({
      type: CHANGE_IMAGE_FILE,
      payload: e.target.files
    }),
    accept: "image/*",
    "aria-hidden": true,
    className: "plc-hidden"
  }));
};

const ProfilePicChangeRemoveButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      isSubmitting
    }
  } = useContext(store$3);
  const {
    t
  } = useTranslation("userEdit");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    icon: /*#__PURE__*/React__default.createElement(SvgXIcon, {
      className: "plc-h-6 plc-w-6"
    }),
    isLoading: isSubmitting,
    onClick: () => {
      dispatch({
        type: REMOVE_IMAGE
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    }
  }, otherProps), name !== null && name !== void 0 ? name : t("labels.removeImage"));
};

const ProfilePicChangeWrapper = () => {
  const {
    state: {
      imageSrc
    }
  } = useContext(store$3);
  const {
    t
  } = useTranslation("userEdit");
  const currentProfilePicture = window.Pelcro.user.read().profile_photo;
  return imageSrc ? /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(ProfilePicChangeCropper, null), /*#__PURE__*/React__default.createElement(ProfilePicChangeZoom, {
    className: "plc-mt-2"
  }), /*#__PURE__*/React__default.createElement(ProfilePicChangeButton, {
    role: "submit",
    className: "plc-mt-2 plc-w-full",
    name: t("labels.save"),
    id: "pelcro-submit"
  })) : /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-flex-col plc-justify-center plc-items-center"
  }, currentProfilePicture && /*#__PURE__*/React__default.createElement("img", {
    className: "plc-border-white plc-border-2 plc-border-solid plc-rounded-full plc-w-36 plc-h-36 plc-bg-gray-300 pelcro-profile-picture-preview",
    src: currentProfilePicture,
    alt: "profile picture"
  }), /*#__PURE__*/React__default.createElement(ProfilePicChangeSelectButton, {
    className: "plc-mt-2 plc-w-full",
    name: t("labels.selectImage"),
    id: "pelcro-profile-picture-select"
  }), currentProfilePicture && /*#__PURE__*/React__default.createElement(ProfilePicChangeRemoveButton, {
    className: "plc-mt-1 plc-w-full plc-bg-gray-600 hover:plc-bg-gray-900 disabled:plc-bg-gray-400",
    name: t("labels.removeImage"),
    id: "pelcro-profile-picture-remove"
  }));
};

const ProfilePicChangeView = props => {
  const {
    t
  } = useTranslation("userEdit");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-profile-picture-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("labels.cropperTitle")), /*#__PURE__*/React__default.createElement("p", null, t("labels.cropperSubtitle"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(ProfilePicChangeContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement(ProfilePicChangeWrapper, null))));
};

/**
 *
 */
function ProfilePicChangeModal(_ref) {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-profile-picture-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(ProfilePicChangeView, otherProps)), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
}
ProfilePicChangeModal.viewId = "profile-picture";

const initialState$2 = {
  isSubmitting: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$2 = /*#__PURE__*/createContext(initialState$2);
const {
  Provider: Provider$2
} = store$2;
const EmailVerifyContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation("verifyEmail");
  const submit = () => {
    window.Pelcro.user.resendEmailVerification((err, res) => {
      dispatch({
        type: LOADING,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        return onFailure(err);
      }
      dispatch({
        type: SHOW_ALERT,
        payload: {
          type: "success",
          content: t("messages.resent")
        }
      });
      return onSuccess(res);
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case LOADING:
        return lib_7({
          ...state,
          isSubmitting: action.payload
        });
      case HANDLE_SUBMIT:
        return lib_5({
          ...state,
          isSubmitting: true
        }, (state, dispatch) => submit());
      default:
        return state;
    }
  }, initialState$2);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-email-verify-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$2, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store: store$2,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$2
  })));
};

const EmailVerifyResendButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    dispatch,
    state: {
      isSubmitting
    }
  } = useContext(store$2);
  const {
    t
  } = useTranslation("verifyEmail");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    },
    isLoading: isSubmitting
  }, otherProps), name !== null && name !== void 0 ? name : t("labels.resend"));
};

const EmailVerifyView = props => {
  var _window$Pelcro$user$r;
  const {
    t
  } = useTranslation("verifyEmail");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-email-verify-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("labels.title"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(EmailVerifyContainer, props, /*#__PURE__*/React__default.createElement(AlertWithContext, null), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-flex-col plc-items-center plc-justify-center plc-mt-4"
  }, /*#__PURE__*/React__default.createElement(SvgEmailVerify, {
    className: "plc-w-32 plc-h-32"
  }), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-mb-1 plc-text-gray-900 plc-text-center plc-whitespace-pre-line"
  }, t("labels.instructions"), " ", /*#__PURE__*/React__default.createElement("span", {
    className: "plc-font-bold"
  }, (_window$Pelcro$user$r = window.Pelcro.user.read()) === null || _window$Pelcro$user$r === void 0 ? void 0 : _window$Pelcro$user$r.email))), /*#__PURE__*/React__default.createElement(EmailVerifyResendButton, {
    role: "submit",
    className: "plc-mt-4 plc-w-full",
    name: t("labels.resend"),
    id: "pelcro-submit"
  }))));
};

const EmailVerifyModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  const {
    product,
    plan,
    switchToAddressView,
    switchToPaymentView
  } = usePelcro();
  const onSuccess = res => {
    var _otherProps$onSuccess;
    (_otherProps$onSuccess = otherProps.onSuccess) === null || _otherProps$onSuccess === void 0 ? void 0 : _otherProps$onSuccess.call(otherProps, res);
    if (product && plan) {
      if (product.address_required) {
        return switchToAddressView();
      } else {
        return switchToPaymentView();
      }
    }
    if (product && !plan) {
      return switchView("plan-select");
    }
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    onDisplay: onDisplay,
    onClose: onClose,
    id: "pelcro-email-verify-modal"
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(EmailVerifyView, Object.assign({
    onSuccess: onSuccess
  }, otherProps))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
EmailVerifyModal.viewId = "email-verify";

const initialState$1 = {
  isLoading: true,
  isTokenValid: false,
  alert: {
    type: "error",
    content: ""
  }
};
const store$1 = /*#__PURE__*/createContext(initialState$1);
const {
  Provider: Provider$1
} = store$1;
const VerifyLinkTokenContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    onFailure = () => {},
    children
  } = _ref;
  const handleVerifyLinkToken = (_ref2, dispatch) => {
    const token = window.Pelcro.helpers.getURLParameter("token");
    window.Pelcro.user.verifyLoginToken({
      token
    }, (err, res) => {
      dispatch({
        type: LOADING,
        payload: false
      });
      if (err) {
        dispatch({
          type: SHOW_ALERT,
          payload: {
            type: "error",
            content: getErrorMessages(err)
          }
        });
        onFailure(err);
      } else {
        onSuccess(res);
      }
    });
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case SHOW_ALERT:
        return lib_7({
          ...state,
          alert: action.payload
        });
      case LOADING:
        return lib_7({
          ...state,
          isLoading: action.payload
        });
      case LINK_TOKEN_VERIFY:
        return lib_5({
          ...state,
          isLoading: true
        }, (state, dispatch) => handleVerifyLinkToken(state, dispatch));
      default:
        return state;
    }
  }, initialState$1);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-login-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider$1, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => {
    if (child) {
      return /*#__PURE__*/React__default.cloneElement(child, {
        store: store$1,
        key: i
      });
    }
  }) : /*#__PURE__*/React__default.cloneElement(children, {
    store: store$1
  })));
};

const VerifyLinkTokenLoader = () => {
  useEffect(() => {
    dispatch({
      type: LINK_TOKEN_VERIFY
    });
  }, []);
  const {
    dispatch,
    state: {
      isLoading
    }
  } = useContext(store$1);
  if (isLoading) {
    return /*#__PURE__*/React__default.createElement(Loader, {
      width: 60,
      height: 100
    });
  }
  return /*#__PURE__*/React__default.createElement("div", {
    className: "plc-max-h-80 plc-overflow-y-auto pelcro-newsletters-wrapper"
  });
};

/**
 *
 */
function VerifyLinkTokenView(props) {
  const {
    t
  } = useTranslation("verifyLinkToken");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-login-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-2xl plc-font-semibold plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", null, t("labels.title"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(VerifyLinkTokenContainer, props, /*#__PURE__*/React__default.createElement(VerifyLinkTokenLoader, null), /*#__PURE__*/React__default.createElement(AlertWithContext, null))));
}

/**
 *
 */
function VerifyLinkTokenModal(_ref) {
  let {
    onDisplay,
    onClose,
    ...props
  } = _ref;
  const {
    t
  } = useTranslation("verifyLinkToken");
  const {
    resetView
  } = usePelcro();
  const onSuccess = res => {
    var _props$onSuccess;
    (_props$onSuccess = props.onSuccess) === null || _props$onSuccess === void 0 ? void 0 : _props$onSuccess.call(props, res);
    resetView();
    notify$1.success(t("messages.success"));
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-login-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(VerifyLinkTokenView, Object.assign({}, props, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
}
VerifyLinkTokenModal.viewId = "passwordless-login";

const InvoicePaymentContainer = props => /*#__PURE__*/React__default.createElement(PaymentMethodContainer, Object.assign({
  type: "invoicePayment",
  className: "pelcro-invoice-payment-container"
}, props));

const InvoicePaymentView = props => {
  const {
    t
  } = useTranslation("payment");
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-invoice-payment-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-2xl plc-font-semibold plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", null, t("labels.checkout.title"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(PaymentMethodView, Object.assign({
    type: "invoicePayment",
    showCoupon: false,
    showExternalPaymentMethods: true,
    showApplePayButton: true
  }, props))));
};

const InvoicePaymentModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  const {
    switchView
  } = usePelcro();
  const onSuccess = () => {
    var _otherProps$onSuccess;
    (_otherProps$onSuccess = otherProps.onSuccess) === null || _otherProps$onSuccess === void 0 ? void 0 : _otherProps$onSuccess.call(otherProps);
    return switchView("subscription-success");
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-invoice-payment-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(InvoicePaymentView, Object.assign({}, otherProps, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
InvoicePaymentModal.viewId = "invoice-payment";

const invoicePaymentSubmitButton = props => {
  return /*#__PURE__*/React__default.createElement(SubmitPaymentMethod, props);
};

const initialState = {};
const store = /*#__PURE__*/createContext(initialState);
const {
  Provider
} = store;
const InvoiceDetailsContainer = _ref => {
  let {
    style,
    className = "",
    onSuccess = () => {},
    children,
    ...props
  } = _ref;
  const onPayButtonClick = () => {
    return onSuccess();
  };
  const [state, dispatch] = useReducerWithSideEffects((state, action) => {
    switch (action.type) {
      case HANDLE_SUBMIT:
        return lib_4((state, dispatch) => onPayButtonClick());
      default:
        return state;
    }
  }, initialState);
  return /*#__PURE__*/React__default.createElement("div", {
    style: {
      ...style
    },
    className: `pelcro-container pelcro-invoice-details-container ${className}`
  }, /*#__PURE__*/React__default.createElement(Provider, {
    value: {
      state,
      dispatch
    }
  }, children.length ? children.map((child, i) => /*#__PURE__*/React__default.cloneElement(child, {
    store,
    key: i
  })) : /*#__PURE__*/React__default.cloneElement(children, {
    store
  })));
};

const InvoiceDetailsDownloadButton = _ref => {
  let {
    name,
    url,
    className,
    ...otherProps
  } = _ref;
  const {
    t
  } = useTranslation("invoiceDetails");
  const {
    invoice
  } = usePelcro();
  return /*#__PURE__*/React__default.createElement(Link, Object.assign({
    className: `plc-px-6 plc-py-2 plc-uppercase plc-bg-transparent plc-text-primary-500 plc-border plc-border-primary-500 plc-rounded focus:plc-outline-none focus:plc-ring-2 focus:plc-ring-primary-300 plc-tracking-wider hover:plc-bg-primary-600 focus:plc-bg-primary-600 hover:plc-text-white focus:plc-text-white hover:plc-shadow-none plc-no-underline ${className}`,
    id: "pelcro-download-invoice-link",
    href: url !== null && url !== void 0 ? url : invoice === null || invoice === void 0 ? void 0 : invoice.invoice_pdf,
    target: "_blank",
    rel: "noopener noreferrer"
  }, otherProps), name !== null && name !== void 0 ? name : t("buttons.download"));
};

const InvoiceDetailsPayButton = _ref => {
  let {
    name,
    onClick,
    ...otherProps
  } = _ref;
  const {
    dispatch
  } = useContext(store);
  const {
    t
  } = useTranslation("invoiceDetails");
  return /*#__PURE__*/React__default.createElement(Button, Object.assign({
    onClick: () => {
      dispatch({
        type: HANDLE_SUBMIT
      });
      onClick === null || onClick === void 0 ? void 0 : onClick();
    }
  }, otherProps), name !== null && name !== void 0 ? name : t("buttons.pay"));
};

const InvoiceDetailsView = props => {
  const {
    t
  } = useTranslation("invoiceDetails");
  const {
    invoice
  } = usePelcro();
  const showPayButton = canPayInvoice(invoice);
  const showDownloadButton = Boolean(invoice === null || invoice === void 0 ? void 0 : invoice.invoice_pdf);
  const hasPlanDetails = Boolean(invoice.plan);
  const creationDate = new Date(invoice === null || invoice === void 0 ? void 0 : invoice.created_at);
  const formattedCreationDate = new Intl.DateTimeFormat("en-CA").format(creationDate);
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-invoice-details-view"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mb-6 plc-text-center plc-text-gray-900 pelcro-title-wrapper"
  }, /*#__PURE__*/React__default.createElement("h4", {
    className: "plc-text-2xl plc-font-semibold"
  }, t("title"))), /*#__PURE__*/React__default.createElement("form", {
    action: "javascript:void(0);",
    className: "plc-mt-2 pelcro-form"
  }, /*#__PURE__*/React__default.createElement(InvoiceDetailsContainer, props, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mt-5 pelcro-invoice-summary-wrapper"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "plc-font-bold pelcro-invoice-summary-title"
  }, t("labels.summary")), invoice && /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("p", {
    className: "plc-mr-2 pelcro-invoice-creation-date"
  }, `${t("labels.creationDate")} ${formattedCreationDate}`), hasPlanDetails && /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-pt-2 plc-mt-2 plc-border-t plc-border-gray-400 plc-min-h-12 plc-justify-between pelcro-invoice-plan-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-break-words pelcro-invoice-plan-name"
  }, invoice.plan.nickname), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-text-center pelcro-invoice-summary-price"
  }, calcAndFormatItemsTotal([invoice.plan], invoice.currency))), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-justify-end plc-pt-2 plc-mt-2 plc-font-bold plc-border-t plc-border-gray-400 pelcro-invoice-total-wrapper"
  }, /*#__PURE__*/React__default.createElement("div", {
    className: "plc-mr-2 plc-flex plc-flex-col"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "pelcro-invoice-total-text"
  }, t("labels.total")), /*#__PURE__*/React__default.createElement("p", {
    className: "pelcro-invoice-total-text"
  }, t("labels.amountPaid")), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-font-semibold pelcro-invoice-total-text"
  }, t("labels.amountDue"))), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-flex-col plc-items-end"
  }, /*#__PURE__*/React__default.createElement("p", {
    className: "pelcro-invoice-total"
  }, getFormattedPriceByLocal(invoice.total, invoice.currency, getPageOrDefaultLanguage())), /*#__PURE__*/React__default.createElement("p", {
    className: "pelcro-invoice-total"
  }, invoice.paid && invoice.amount_paid === 0 ? getFormattedPriceByLocal(invoice.total, invoice.currency, getPageOrDefaultLanguage()) : getFormattedPriceByLocal(invoice.amount_paid, invoice.currency, getPageOrDefaultLanguage())), /*#__PURE__*/React__default.createElement("p", {
    className: "plc-font-semibold pelcro-invoice-total"
  }, invoice.paid ? getFormattedPriceByLocal(0, invoice.currency, getPageOrDefaultLanguage()) : getFormattedPriceByLocal(invoice.amount_remaining, invoice.currency, getPageOrDefaultLanguage())))))), /*#__PURE__*/React__default.createElement("div", {
    className: "plc-flex plc-items-center plc-justify-center plc-mt-4"
  }, showDownloadButton && /*#__PURE__*/React__default.createElement(InvoiceDetailsDownloadButton, {
    url: invoice === null || invoice === void 0 ? void 0 : invoice.invoice_pdf,
    className: "plc-w-full plc-text-center"
  }), showPayButton && /*#__PURE__*/React__default.createElement(InvoiceDetailsPayButton, {
    role: "submit",
    className: "plc-ml-4 plc-w-full",
    id: "pelcro-submit"
  })))));
};
function canPayInvoice(invoice) {
  return (invoice === null || invoice === void 0 ? void 0 : invoice.status) === "open" || (invoice === null || invoice === void 0 ? void 0 : invoice.status) === "past_due";
}

const InvoiceDetailsModal = _ref => {
  let {
    onDisplay,
    onClose,
    ...otherProps
  } = _ref;
  const {
    switchToPaymentView
  } = usePelcro();
  const onSuccess = () => {
    var _otherProps$onSuccess;
    (_otherProps$onSuccess = otherProps.onSuccess) === null || _otherProps$onSuccess === void 0 ? void 0 : _otherProps$onSuccess.call(otherProps);
    switchToPaymentView();
  };
  return /*#__PURE__*/React__default.createElement(Modal, {
    onDisplay: onDisplay,
    onClose: onClose,
    id: "pelcro-invoice-details-modal"
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(InvoiceDetailsView, Object.assign({}, otherProps, {
    onSuccess: onSuccess
  }))), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
InvoiceDetailsModal.viewId = "invoice-details";

var mode = {
	MODE_NUMBER :		1 << 0,
	MODE_ALPHA_NUM : 	1 << 1,
	MODE_8BIT_BYTE : 	1 << 2,
	MODE_KANJI :		1 << 3
};

function QR8bitByte(data) {
	this.mode = mode.MODE_8BIT_BYTE;
	this.data = data;
}

QR8bitByte.prototype = {

	getLength : function(buffer) {
		return this.data.length;
	},
	
	write : function(buffer) {
		for (var i = 0; i < this.data.length; i++) {
			// not JIS ...
			buffer.put(this.data.charCodeAt(i), 8);
		}
	}
};

var _8BitByte = QR8bitByte;

var ErrorCorrectLevel = {
	L : 1,
	M : 0,
	Q : 3,
	H : 2
};
ErrorCorrectLevel.L;
ErrorCorrectLevel.M;
ErrorCorrectLevel.Q;
ErrorCorrectLevel.H;

// ErrorCorrectLevel


function QRRSBlock(totalCount, dataCount) {
	this.totalCount = totalCount;
	this.dataCount  = dataCount;
}

QRRSBlock.RS_BLOCK_TABLE = [

	// L
	// M
	// Q
	// H

	// 1
	[1, 26, 19],
	[1, 26, 16],
	[1, 26, 13],
	[1, 26, 9],
	
	// 2
	[1, 44, 34],
	[1, 44, 28],
	[1, 44, 22],
	[1, 44, 16],

	// 3
	[1, 70, 55],
	[1, 70, 44],
	[2, 35, 17],
	[2, 35, 13],

	// 4		
	[1, 100, 80],
	[2, 50, 32],
	[2, 50, 24],
	[4, 25, 9],
	
	// 5
	[1, 134, 108],
	[2, 67, 43],
	[2, 33, 15, 2, 34, 16],
	[2, 33, 11, 2, 34, 12],
	
	// 6
	[2, 86, 68],
	[4, 43, 27],
	[4, 43, 19],
	[4, 43, 15],
	
	// 7		
	[2, 98, 78],
	[4, 49, 31],
	[2, 32, 14, 4, 33, 15],
	[4, 39, 13, 1, 40, 14],
	
	// 8
	[2, 121, 97],
	[2, 60, 38, 2, 61, 39],
	[4, 40, 18, 2, 41, 19],
	[4, 40, 14, 2, 41, 15],
	
	// 9
	[2, 146, 116],
	[3, 58, 36, 2, 59, 37],
	[4, 36, 16, 4, 37, 17],
	[4, 36, 12, 4, 37, 13],
	
	// 10		
	[2, 86, 68, 2, 87, 69],
	[4, 69, 43, 1, 70, 44],
	[6, 43, 19, 2, 44, 20],
	[6, 43, 15, 2, 44, 16],

	// 11
	[4, 101, 81],
	[1, 80, 50, 4, 81, 51],
	[4, 50, 22, 4, 51, 23],
	[3, 36, 12, 8, 37, 13],

	// 12
	[2, 116, 92, 2, 117, 93],
	[6, 58, 36, 2, 59, 37],
	[4, 46, 20, 6, 47, 21],
	[7, 42, 14, 4, 43, 15],

	// 13
	[4, 133, 107],
	[8, 59, 37, 1, 60, 38],
	[8, 44, 20, 4, 45, 21],
	[12, 33, 11, 4, 34, 12],

	// 14
	[3, 145, 115, 1, 146, 116],
	[4, 64, 40, 5, 65, 41],
	[11, 36, 16, 5, 37, 17],
	[11, 36, 12, 5, 37, 13],

	// 15
	[5, 109, 87, 1, 110, 88],
	[5, 65, 41, 5, 66, 42],
	[5, 54, 24, 7, 55, 25],
	[11, 36, 12],

	// 16
	[5, 122, 98, 1, 123, 99],
	[7, 73, 45, 3, 74, 46],
	[15, 43, 19, 2, 44, 20],
	[3, 45, 15, 13, 46, 16],

	// 17
	[1, 135, 107, 5, 136, 108],
	[10, 74, 46, 1, 75, 47],
	[1, 50, 22, 15, 51, 23],
	[2, 42, 14, 17, 43, 15],

	// 18
	[5, 150, 120, 1, 151, 121],
	[9, 69, 43, 4, 70, 44],
	[17, 50, 22, 1, 51, 23],
	[2, 42, 14, 19, 43, 15],

	// 19
	[3, 141, 113, 4, 142, 114],
	[3, 70, 44, 11, 71, 45],
	[17, 47, 21, 4, 48, 22],
	[9, 39, 13, 16, 40, 14],

	// 20
	[3, 135, 107, 5, 136, 108],
	[3, 67, 41, 13, 68, 42],
	[15, 54, 24, 5, 55, 25],
	[15, 43, 15, 10, 44, 16],

	// 21
	[4, 144, 116, 4, 145, 117],
	[17, 68, 42],
	[17, 50, 22, 6, 51, 23],
	[19, 46, 16, 6, 47, 17],

	// 22
	[2, 139, 111, 7, 140, 112],
	[17, 74, 46],
	[7, 54, 24, 16, 55, 25],
	[34, 37, 13],

	// 23
	[4, 151, 121, 5, 152, 122],
	[4, 75, 47, 14, 76, 48],
	[11, 54, 24, 14, 55, 25],
	[16, 45, 15, 14, 46, 16],

	// 24
	[6, 147, 117, 4, 148, 118],
	[6, 73, 45, 14, 74, 46],
	[11, 54, 24, 16, 55, 25],
	[30, 46, 16, 2, 47, 17],

	// 25
	[8, 132, 106, 4, 133, 107],
	[8, 75, 47, 13, 76, 48],
	[7, 54, 24, 22, 55, 25],
	[22, 45, 15, 13, 46, 16],

	// 26
	[10, 142, 114, 2, 143, 115],
	[19, 74, 46, 4, 75, 47],
	[28, 50, 22, 6, 51, 23],
	[33, 46, 16, 4, 47, 17],

	// 27
	[8, 152, 122, 4, 153, 123],
	[22, 73, 45, 3, 74, 46],
	[8, 53, 23, 26, 54, 24],
	[12, 45, 15, 28, 46, 16],

	// 28
	[3, 147, 117, 10, 148, 118],
	[3, 73, 45, 23, 74, 46],
	[4, 54, 24, 31, 55, 25],
	[11, 45, 15, 31, 46, 16],

	// 29
	[7, 146, 116, 7, 147, 117],
	[21, 73, 45, 7, 74, 46],
	[1, 53, 23, 37, 54, 24],
	[19, 45, 15, 26, 46, 16],

	// 30
	[5, 145, 115, 10, 146, 116],
	[19, 75, 47, 10, 76, 48],
	[15, 54, 24, 25, 55, 25],
	[23, 45, 15, 25, 46, 16],

	// 31
	[13, 145, 115, 3, 146, 116],
	[2, 74, 46, 29, 75, 47],
	[42, 54, 24, 1, 55, 25],
	[23, 45, 15, 28, 46, 16],

	// 32
	[17, 145, 115],
	[10, 74, 46, 23, 75, 47],
	[10, 54, 24, 35, 55, 25],
	[19, 45, 15, 35, 46, 16],

	// 33
	[17, 145, 115, 1, 146, 116],
	[14, 74, 46, 21, 75, 47],
	[29, 54, 24, 19, 55, 25],
	[11, 45, 15, 46, 46, 16],

	// 34
	[13, 145, 115, 6, 146, 116],
	[14, 74, 46, 23, 75, 47],
	[44, 54, 24, 7, 55, 25],
	[59, 46, 16, 1, 47, 17],

	// 35
	[12, 151, 121, 7, 152, 122],
	[12, 75, 47, 26, 76, 48],
	[39, 54, 24, 14, 55, 25],
	[22, 45, 15, 41, 46, 16],

	// 36
	[6, 151, 121, 14, 152, 122],
	[6, 75, 47, 34, 76, 48],
	[46, 54, 24, 10, 55, 25],
	[2, 45, 15, 64, 46, 16],

	// 37
	[17, 152, 122, 4, 153, 123],
	[29, 74, 46, 14, 75, 47],
	[49, 54, 24, 10, 55, 25],
	[24, 45, 15, 46, 46, 16],

	// 38
	[4, 152, 122, 18, 153, 123],
	[13, 74, 46, 32, 75, 47],
	[48, 54, 24, 14, 55, 25],
	[42, 45, 15, 32, 46, 16],

	// 39
	[20, 147, 117, 4, 148, 118],
	[40, 75, 47, 7, 76, 48],
	[43, 54, 24, 22, 55, 25],
	[10, 45, 15, 67, 46, 16],

	// 40
	[19, 148, 118, 6, 149, 119],
	[18, 75, 47, 31, 76, 48],
	[34, 54, 24, 34, 55, 25],
	[20, 45, 15, 61, 46, 16]
];

QRRSBlock.getRSBlocks = function(typeNumber, errorCorrectLevel) {
	
	var rsBlock = QRRSBlock.getRsBlockTable(typeNumber, errorCorrectLevel);
	
	if (rsBlock == undefined) {
		throw new Error("bad rs block @ typeNumber:" + typeNumber + "/errorCorrectLevel:" + errorCorrectLevel);
	}

	var length = rsBlock.length / 3;
	
	var list = new Array();
	
	for (var i = 0; i < length; i++) {

		var count = rsBlock[i * 3 + 0];
		var totalCount = rsBlock[i * 3 + 1];
		var dataCount  = rsBlock[i * 3 + 2];

		for (var j = 0; j < count; j++) {
			list.push(new QRRSBlock(totalCount, dataCount) );	
		}
	}
	
	return list;
};

QRRSBlock.getRsBlockTable = function(typeNumber, errorCorrectLevel) {

	switch(errorCorrectLevel) {
	case ErrorCorrectLevel.L :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 0];
	case ErrorCorrectLevel.M :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 1];
	case ErrorCorrectLevel.Q :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 2];
	case ErrorCorrectLevel.H :
		return QRRSBlock.RS_BLOCK_TABLE[(typeNumber - 1) * 4 + 3];
	default :
		return undefined;
	}
};

var RSBlock = QRRSBlock;

function QRBitBuffer() {
	this.buffer = new Array();
	this.length = 0;
}

QRBitBuffer.prototype = {

	get : function(index) {
		var bufIndex = Math.floor(index / 8);
		return ( (this.buffer[bufIndex] >>> (7 - index % 8) ) & 1) == 1;
	},
	
	put : function(num, length) {
		for (var i = 0; i < length; i++) {
			this.putBit( ( (num >>> (length - i - 1) ) & 1) == 1);
		}
	},
	
	getLengthInBits : function() {
		return this.length;
	},
	
	putBit : function(bit) {
	
		var bufIndex = Math.floor(this.length / 8);
		if (this.buffer.length <= bufIndex) {
			this.buffer.push(0);
		}
	
		if (bit) {
			this.buffer[bufIndex] |= (0x80 >>> (this.length % 8) );
		}
	
		this.length++;
	}
};

var BitBuffer = QRBitBuffer;

var QRMath = {

	glog : function(n) {
	
		if (n < 1) {
			throw new Error("glog(" + n + ")");
		}
		
		return QRMath.LOG_TABLE[n];
	},
	
	gexp : function(n) {
	
		while (n < 0) {
			n += 255;
		}
	
		while (n >= 256) {
			n -= 255;
		}
	
		return QRMath.EXP_TABLE[n];
	},
	
	EXP_TABLE : new Array(256),
	
	LOG_TABLE : new Array(256)

};
	
for (var i = 0; i < 8; i++) {
	QRMath.EXP_TABLE[i] = 1 << i;
}
for (var i = 8; i < 256; i++) {
	QRMath.EXP_TABLE[i] = QRMath.EXP_TABLE[i - 4]
		^ QRMath.EXP_TABLE[i - 5]
		^ QRMath.EXP_TABLE[i - 6]
		^ QRMath.EXP_TABLE[i - 8];
}
for (var i = 0; i < 255; i++) {
	QRMath.LOG_TABLE[QRMath.EXP_TABLE[i] ] = i;
}

var math = QRMath;

function QRPolynomial(num, shift) {

	if (num.length == undefined) {
		throw new Error(num.length + "/" + shift);
	}

	var offset = 0;

	while (offset < num.length && num[offset] == 0) {
		offset++;
	}

	this.num = new Array(num.length - offset + shift);
	for (var i = 0; i < num.length - offset; i++) {
		this.num[i] = num[i + offset];
	}
}

QRPolynomial.prototype = {

	get : function(index) {
		return this.num[index];
	},
	
	getLength : function() {
		return this.num.length;
	},
	
	multiply : function(e) {
	
		var num = new Array(this.getLength() + e.getLength() - 1);
	
		for (var i = 0; i < this.getLength(); i++) {
			for (var j = 0; j < e.getLength(); j++) {
				num[i + j] ^= math.gexp(math.glog(this.get(i) ) + math.glog(e.get(j) ) );
			}
		}
	
		return new QRPolynomial(num, 0);
	},
	
	mod : function(e) {
	
		if (this.getLength() - e.getLength() < 0) {
			return this;
		}
	
		var ratio = math.glog(this.get(0) ) - math.glog(e.get(0) );
	
		var num = new Array(this.getLength() );
		
		for (var i = 0; i < this.getLength(); i++) {
			num[i] = this.get(i);
		}
		
		for (var i = 0; i < e.getLength(); i++) {
			num[i] ^= math.gexp(math.glog(e.get(i) ) + ratio);
		}
	
		// recursive call
		return new QRPolynomial(num, 0).mod(e);
	}
};

var Polynomial = QRPolynomial;

var QRMaskPattern = {
	PATTERN000 : 0,
	PATTERN001 : 1,
	PATTERN010 : 2,
	PATTERN011 : 3,
	PATTERN100 : 4,
	PATTERN101 : 5,
	PATTERN110 : 6,
	PATTERN111 : 7
};

var QRUtil = {

    PATTERN_POSITION_TABLE : [
	    [],
	    [6, 18],
	    [6, 22],
	    [6, 26],
	    [6, 30],
	    [6, 34],
	    [6, 22, 38],
	    [6, 24, 42],
	    [6, 26, 46],
	    [6, 28, 50],
	    [6, 30, 54],		
	    [6, 32, 58],
	    [6, 34, 62],
	    [6, 26, 46, 66],
	    [6, 26, 48, 70],
	    [6, 26, 50, 74],
	    [6, 30, 54, 78],
	    [6, 30, 56, 82],
	    [6, 30, 58, 86],
	    [6, 34, 62, 90],
	    [6, 28, 50, 72, 94],
	    [6, 26, 50, 74, 98],
	    [6, 30, 54, 78, 102],
	    [6, 28, 54, 80, 106],
	    [6, 32, 58, 84, 110],
	    [6, 30, 58, 86, 114],
	    [6, 34, 62, 90, 118],
	    [6, 26, 50, 74, 98, 122],
	    [6, 30, 54, 78, 102, 126],
	    [6, 26, 52, 78, 104, 130],
	    [6, 30, 56, 82, 108, 134],
	    [6, 34, 60, 86, 112, 138],
	    [6, 30, 58, 86, 114, 142],
	    [6, 34, 62, 90, 118, 146],
	    [6, 30, 54, 78, 102, 126, 150],
	    [6, 24, 50, 76, 102, 128, 154],
	    [6, 28, 54, 80, 106, 132, 158],
	    [6, 32, 58, 84, 110, 136, 162],
	    [6, 26, 54, 82, 110, 138, 166],
	    [6, 30, 58, 86, 114, 142, 170]
    ],

    G15 : (1 << 10) | (1 << 8) | (1 << 5) | (1 << 4) | (1 << 2) | (1 << 1) | (1 << 0),
    G18 : (1 << 12) | (1 << 11) | (1 << 10) | (1 << 9) | (1 << 8) | (1 << 5) | (1 << 2) | (1 << 0),
    G15_MASK : (1 << 14) | (1 << 12) | (1 << 10)	| (1 << 4) | (1 << 1),

    getBCHTypeInfo : function(data) {
	    var d = data << 10;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) >= 0) {
		    d ^= (QRUtil.G15 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G15) ) ); 	
	    }
	    return ( (data << 10) | d) ^ QRUtil.G15_MASK;
    },

    getBCHTypeNumber : function(data) {
	    var d = data << 12;
	    while (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) >= 0) {
		    d ^= (QRUtil.G18 << (QRUtil.getBCHDigit(d) - QRUtil.getBCHDigit(QRUtil.G18) ) ); 	
	    }
	    return (data << 12) | d;
    },

    getBCHDigit : function(data) {

	    var digit = 0;

	    while (data != 0) {
		    digit++;
		    data >>>= 1;
	    }

	    return digit;
    },

    getPatternPosition : function(typeNumber) {
	    return QRUtil.PATTERN_POSITION_TABLE[typeNumber - 1];
    },

    getMask : function(maskPattern, i, j) {
	    
	    switch (maskPattern) {
		    
	    case QRMaskPattern.PATTERN000 : return (i + j) % 2 == 0;
	    case QRMaskPattern.PATTERN001 : return i % 2 == 0;
	    case QRMaskPattern.PATTERN010 : return j % 3 == 0;
	    case QRMaskPattern.PATTERN011 : return (i + j) % 3 == 0;
	    case QRMaskPattern.PATTERN100 : return (Math.floor(i / 2) + Math.floor(j / 3) ) % 2 == 0;
	    case QRMaskPattern.PATTERN101 : return (i * j) % 2 + (i * j) % 3 == 0;
	    case QRMaskPattern.PATTERN110 : return ( (i * j) % 2 + (i * j) % 3) % 2 == 0;
	    case QRMaskPattern.PATTERN111 : return ( (i * j) % 3 + (i + j) % 2) % 2 == 0;

	    default :
		    throw new Error("bad maskPattern:" + maskPattern);
	    }
    },

    getErrorCorrectPolynomial : function(errorCorrectLength) {

	    var a = new Polynomial([1], 0);

	    for (var i = 0; i < errorCorrectLength; i++) {
		    a = a.multiply(new Polynomial([1, math.gexp(i)], 0) );
	    }

	    return a;
    },

    getLengthInBits : function(mode$1, type) {

	    if (1 <= type && type < 10) {

		    // 1 - 9

		    switch(mode$1) {
		    case mode.MODE_NUMBER 	: return 10;
		    case mode.MODE_ALPHA_NUM 	: return 9;
		    case mode.MODE_8BIT_BYTE	: return 8;
		    case mode.MODE_KANJI  	: return 8;
		    default :
			    throw new Error("mode:" + mode$1);
		    }

	    } else if (type < 27) {

		    // 10 - 26

		    switch(mode$1) {
		    case mode.MODE_NUMBER 	: return 12;
		    case mode.MODE_ALPHA_NUM 	: return 11;
		    case mode.MODE_8BIT_BYTE	: return 16;
		    case mode.MODE_KANJI  	: return 10;
		    default :
			    throw new Error("mode:" + mode$1);
		    }

	    } else if (type < 41) {

		    // 27 - 40

		    switch(mode$1) {
		    case mode.MODE_NUMBER 	: return 14;
		    case mode.MODE_ALPHA_NUM	: return 13;
		    case mode.MODE_8BIT_BYTE	: return 16;
		    case mode.MODE_KANJI  	: return 12;
		    default :
			    throw new Error("mode:" + mode$1);
		    }

	    } else {
		    throw new Error("type:" + type);
	    }
    },

    getLostPoint : function(qrCode) {
	    
	    var moduleCount = qrCode.getModuleCount();
	    
	    var lostPoint = 0;
	    
	    // LEVEL1
	    
	    for (var row = 0; row < moduleCount; row++) {

		    for (var col = 0; col < moduleCount; col++) {

			    var sameCount = 0;
			    var dark = qrCode.isDark(row, col);

				for (var r = -1; r <= 1; r++) {

				    if (row + r < 0 || moduleCount <= row + r) {
					    continue;
				    }

				    for (var c = -1; c <= 1; c++) {

					    if (col + c < 0 || moduleCount <= col + c) {
						    continue;
					    }

					    if (r == 0 && c == 0) {
						    continue;
					    }

					    if (dark == qrCode.isDark(row + r, col + c) ) {
						    sameCount++;
					    }
				    }
			    }

			    if (sameCount > 5) {
				    lostPoint += (3 + sameCount - 5);
			    }
		    }
	    }

	    // LEVEL2

	    for (var row = 0; row < moduleCount - 1; row++) {
		    for (var col = 0; col < moduleCount - 1; col++) {
			    var count = 0;
			    if (qrCode.isDark(row,     col    ) ) count++;
			    if (qrCode.isDark(row + 1, col    ) ) count++;
			    if (qrCode.isDark(row,     col + 1) ) count++;
			    if (qrCode.isDark(row + 1, col + 1) ) count++;
			    if (count == 0 || count == 4) {
				    lostPoint += 3;
			    }
		    }
	    }

	    // LEVEL3

	    for (var row = 0; row < moduleCount; row++) {
		    for (var col = 0; col < moduleCount - 6; col++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row, col + 1)
					    &&  qrCode.isDark(row, col + 2)
					    &&  qrCode.isDark(row, col + 3)
					    &&  qrCode.isDark(row, col + 4)
					    && !qrCode.isDark(row, col + 5)
					    &&  qrCode.isDark(row, col + 6) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount - 6; row++) {
			    if (qrCode.isDark(row, col)
					    && !qrCode.isDark(row + 1, col)
					    &&  qrCode.isDark(row + 2, col)
					    &&  qrCode.isDark(row + 3, col)
					    &&  qrCode.isDark(row + 4, col)
					    && !qrCode.isDark(row + 5, col)
					    &&  qrCode.isDark(row + 6, col) ) {
				    lostPoint += 40;
			    }
		    }
	    }

	    // LEVEL4
	    
	    var darkCount = 0;

	    for (var col = 0; col < moduleCount; col++) {
		    for (var row = 0; row < moduleCount; row++) {
			    if (qrCode.isDark(row, col) ) {
				    darkCount++;
			    }
		    }
	    }
	    
	    var ratio = Math.abs(100 * darkCount / moduleCount / moduleCount - 50) / 5;
	    lostPoint += ratio * 10;

	    return lostPoint;		
    }
};

var util = QRUtil;

function QRCode$1(typeNumber, errorCorrectLevel) {
	this.typeNumber = typeNumber;
	this.errorCorrectLevel = errorCorrectLevel;
	this.modules = null;
	this.moduleCount = 0;
	this.dataCache = null;
	this.dataList = [];
}

// for client side minification
var proto = QRCode$1.prototype;

proto.addData = function(data) {
	var newData = new _8BitByte(data);
	this.dataList.push(newData);
	this.dataCache = null;
};

proto.isDark = function(row, col) {
	if (row < 0 || this.moduleCount <= row || col < 0 || this.moduleCount <= col) {
		throw new Error(row + "," + col);
	}
	return this.modules[row][col];
};

proto.getModuleCount = function() {
	return this.moduleCount;
};

proto.make = function() {
	// Calculate automatically typeNumber if provided is < 1
	if (this.typeNumber < 1 ){
		var typeNumber = 1;
		for (typeNumber = 1; typeNumber < 40; typeNumber++) {
			var rsBlocks = RSBlock.getRSBlocks(typeNumber, this.errorCorrectLevel);

			var buffer = new BitBuffer();
			var totalDataCount = 0;
			for (var i = 0; i < rsBlocks.length; i++) {
				totalDataCount += rsBlocks[i].dataCount;
			}

			for (var i = 0; i < this.dataList.length; i++) {
				var data = this.dataList[i];
				buffer.put(data.mode, 4);
				buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
				data.write(buffer);
			}
			if (buffer.getLengthInBits() <= totalDataCount * 8)
				break;
		}
		this.typeNumber = typeNumber;
	}
	this.makeImpl(false, this.getBestMaskPattern() );
};

proto.makeImpl = function(test, maskPattern) {
	
	this.moduleCount = this.typeNumber * 4 + 17;
	this.modules = new Array(this.moduleCount);
	
	for (var row = 0; row < this.moduleCount; row++) {
		
		this.modules[row] = new Array(this.moduleCount);
		
		for (var col = 0; col < this.moduleCount; col++) {
			this.modules[row][col] = null;//(col + row) % 3;
		}
	}

	this.setupPositionProbePattern(0, 0);
	this.setupPositionProbePattern(this.moduleCount - 7, 0);
	this.setupPositionProbePattern(0, this.moduleCount - 7);
	this.setupPositionAdjustPattern();
	this.setupTimingPattern();
	this.setupTypeInfo(test, maskPattern);
	
	if (this.typeNumber >= 7) {
		this.setupTypeNumber(test);
	}

	if (this.dataCache == null) {
		this.dataCache = QRCode$1.createData(this.typeNumber, this.errorCorrectLevel, this.dataList);
	}

	this.mapData(this.dataCache, maskPattern);
};

proto.setupPositionProbePattern = function(row, col)  {
	
	for (var r = -1; r <= 7; r++) {
		
		if (row + r <= -1 || this.moduleCount <= row + r) continue;
		
		for (var c = -1; c <= 7; c++) {
			
			if (col + c <= -1 || this.moduleCount <= col + c) continue;
			
			if ( (0 <= r && r <= 6 && (c == 0 || c == 6) )
					|| (0 <= c && c <= 6 && (r == 0 || r == 6) )
					|| (2 <= r && r <= 4 && 2 <= c && c <= 4) ) {
				this.modules[row + r][col + c] = true;
			} else {
				this.modules[row + r][col + c] = false;
			}
		}		
	}		
};

proto.getBestMaskPattern = function() {

	var minLostPoint = 0;
	var pattern = 0;

	for (var i = 0; i < 8; i++) {
		
		this.makeImpl(true, i);

		var lostPoint = util.getLostPoint(this);

		if (i == 0 || minLostPoint >  lostPoint) {
			minLostPoint = lostPoint;
			pattern = i;
		}
	}

	return pattern;
};

proto.createMovieClip = function(target_mc, instance_name, depth) {

	var qr_mc = target_mc.createEmptyMovieClip(instance_name, depth);
	var cs = 1;

	this.make();

	for (var row = 0; row < this.modules.length; row++) {
		
		var y = row * cs;
		
		for (var col = 0; col < this.modules[row].length; col++) {

			var x = col * cs;
			var dark = this.modules[row][col];
		
			if (dark) {
				qr_mc.beginFill(0, 100);
				qr_mc.moveTo(x, y);
				qr_mc.lineTo(x + cs, y);
				qr_mc.lineTo(x + cs, y + cs);
				qr_mc.lineTo(x, y + cs);
				qr_mc.endFill();
			}
		}
	}
	
	return qr_mc;
};

proto.setupTimingPattern = function() {
	
	for (var r = 8; r < this.moduleCount - 8; r++) {
		if (this.modules[r][6] != null) {
			continue;
		}
		this.modules[r][6] = (r % 2 == 0);
	}

	for (var c = 8; c < this.moduleCount - 8; c++) {
		if (this.modules[6][c] != null) {
			continue;
		}
		this.modules[6][c] = (c % 2 == 0);
	}
};

proto.setupPositionAdjustPattern = function() {

	var pos = util.getPatternPosition(this.typeNumber);
	
	for (var i = 0; i < pos.length; i++) {
	
		for (var j = 0; j < pos.length; j++) {
		
			var row = pos[i];
			var col = pos[j];
			
			if (this.modules[row][col] != null) {
				continue;
			}
			
			for (var r = -2; r <= 2; r++) {
			
				for (var c = -2; c <= 2; c++) {
				
					if (r == -2 || r == 2 || c == -2 || c == 2
							|| (r == 0 && c == 0) ) {
						this.modules[row + r][col + c] = true;
					} else {
						this.modules[row + r][col + c] = false;
					}
				}
			}
		}
	}
};

proto.setupTypeNumber = function(test) {

	var bits = util.getBCHTypeNumber(this.typeNumber);

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[Math.floor(i / 3)][i % 3 + this.moduleCount - 8 - 3] = mod;
	}

	for (var i = 0; i < 18; i++) {
		var mod = (!test && ( (bits >> i) & 1) == 1);
		this.modules[i % 3 + this.moduleCount - 8 - 3][Math.floor(i / 3)] = mod;
	}
};

proto.setupTypeInfo = function(test, maskPattern) {

	var data = (this.errorCorrectLevel << 3) | maskPattern;
	var bits = util.getBCHTypeInfo(data);

	// vertical		
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);

		if (i < 6) {
			this.modules[i][8] = mod;
		} else if (i < 8) {
			this.modules[i + 1][8] = mod;
		} else {
			this.modules[this.moduleCount - 15 + i][8] = mod;
		}
	}

	// horizontal
	for (var i = 0; i < 15; i++) {

		var mod = (!test && ( (bits >> i) & 1) == 1);
		
		if (i < 8) {
			this.modules[8][this.moduleCount - i - 1] = mod;
		} else if (i < 9) {
			this.modules[8][15 - i - 1 + 1] = mod;
		} else {
			this.modules[8][15 - i - 1] = mod;
		}
	}

	// fixed module
	this.modules[this.moduleCount - 8][8] = (!test);
};

proto.mapData = function(data, maskPattern) {
	
	var inc = -1;
	var row = this.moduleCount - 1;
	var bitIndex = 7;
	var byteIndex = 0;
	
	for (var col = this.moduleCount - 1; col > 0; col -= 2) {

		if (col == 6) col--;

		while (true) {

			for (var c = 0; c < 2; c++) {
				
				if (this.modules[row][col - c] == null) {
					
					var dark = false;

					if (byteIndex < data.length) {
						dark = ( ( (data[byteIndex] >>> bitIndex) & 1) == 1);
					}

					var mask = util.getMask(maskPattern, row, col - c);

					if (mask) {
						dark = !dark;
					}
					
					this.modules[row][col - c] = dark;
					bitIndex--;

					if (bitIndex == -1) {
						byteIndex++;
						bitIndex = 7;
					}
				}
			}
							
			row += inc;

			if (row < 0 || this.moduleCount <= row) {
				row -= inc;
				inc = -inc;
				break;
			}
		}
	}
};

QRCode$1.PAD0 = 0xEC;
QRCode$1.PAD1 = 0x11;

QRCode$1.createData = function(typeNumber, errorCorrectLevel, dataList) {
	
	var rsBlocks = RSBlock.getRSBlocks(typeNumber, errorCorrectLevel);
	
	var buffer = new BitBuffer();
	
	for (var i = 0; i < dataList.length; i++) {
		var data = dataList[i];
		buffer.put(data.mode, 4);
		buffer.put(data.getLength(), util.getLengthInBits(data.mode, typeNumber) );
		data.write(buffer);
	}

	// calc num max data.
	var totalDataCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalDataCount += rsBlocks[i].dataCount;
	}

	if (buffer.getLengthInBits() > totalDataCount * 8) {
		throw new Error("code length overflow. ("
			+ buffer.getLengthInBits()
			+ ">"
			+  totalDataCount * 8
			+ ")");
	}

	// end code
	if (buffer.getLengthInBits() + 4 <= totalDataCount * 8) {
		buffer.put(0, 4);
	}

	// padding
	while (buffer.getLengthInBits() % 8 != 0) {
		buffer.putBit(false);
	}

	// padding
	while (true) {
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode$1.PAD0, 8);
		
		if (buffer.getLengthInBits() >= totalDataCount * 8) {
			break;
		}
		buffer.put(QRCode$1.PAD1, 8);
	}

	return QRCode$1.createBytes(buffer, rsBlocks);
};

QRCode$1.createBytes = function(buffer, rsBlocks) {

	var offset = 0;
	
	var maxDcCount = 0;
	var maxEcCount = 0;
	
	var dcdata = new Array(rsBlocks.length);
	var ecdata = new Array(rsBlocks.length);
	
	for (var r = 0; r < rsBlocks.length; r++) {

		var dcCount = rsBlocks[r].dataCount;
		var ecCount = rsBlocks[r].totalCount - dcCount;

		maxDcCount = Math.max(maxDcCount, dcCount);
		maxEcCount = Math.max(maxEcCount, ecCount);
		
		dcdata[r] = new Array(dcCount);
		
		for (var i = 0; i < dcdata[r].length; i++) {
			dcdata[r][i] = 0xff & buffer.buffer[i + offset];
		}
		offset += dcCount;
		
		var rsPoly = util.getErrorCorrectPolynomial(ecCount);
		var rawPoly = new Polynomial(dcdata[r], rsPoly.getLength() - 1);

		var modPoly = rawPoly.mod(rsPoly);
		ecdata[r] = new Array(rsPoly.getLength() - 1);
		for (var i = 0; i < ecdata[r].length; i++) {
            var modIndex = i + modPoly.getLength() - ecdata[r].length;
			ecdata[r][i] = (modIndex >= 0)? modPoly.get(modIndex) : 0;
		}

	}
	
	var totalCodeCount = 0;
	for (var i = 0; i < rsBlocks.length; i++) {
		totalCodeCount += rsBlocks[i].totalCount;
	}

	var data = new Array(totalCodeCount);
	var index = 0;

	for (var i = 0; i < maxDcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < dcdata[r].length) {
				data[index++] = dcdata[r][i];
			}
		}
	}

	for (var i = 0; i < maxEcCount; i++) {
		for (var r = 0; r < rsBlocks.length; r++) {
			if (i < ecdata[r].length) {
				data[index++] = ecdata[r][i];
			}
		}
	}

	return data;
};

var QRCode_1 = QRCode$1;

var QRCodeCell_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});



var _propTypes2 = _interopRequireDefault(PropTypes);



var _react2 = _interopRequireDefault(React__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  d: _propTypes2.default.string.isRequired,
  fill: _propTypes2.default.string.isRequired,
  transformX: _propTypes2.default.number.isRequired,
  transformY: _propTypes2.default.number.isRequired
};

var defaultProps = {};

var QRCodeCell = function QRCodeCell(_ref) {
  var d = _ref.d,
      fill = _ref.fill,
      transformX = _ref.transformX,
      transformY = _ref.transformY;
  return _react2.default.createElement("path", { d: d, fill: fill, transform: "matrix(" + [1, 0, 0, 1, transformX, transformY] + ")" });
};

QRCodeCell.propTypes = propTypes;
QRCodeCell.defaultProps = defaultProps;

exports.default = QRCodeCell;
});

unwrapExports(QRCodeCell_1);

var QRCodeSurface_1 = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _propTypes2 = _interopRequireDefault(PropTypes);



var _react2 = _interopRequireDefault(React__default);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var propTypes = {
  children: _propTypes2.default.array.isRequired,
  size: _propTypes2.default.number.isRequired,
  title: _propTypes2.default.string,
  xmlns: _propTypes2.default.string
};

var defaultProps = {
  title: undefined,
  xmlns: "http://www.w3.org/2000/svg"
};

var QRCodeSurface = function QRCodeSurface(_ref) {
  var children = _ref.children,
      size = _ref.size,
      title = _ref.title,
      xmlns = _ref.xmlns,
      props = _objectWithoutProperties(_ref, ["children", "size", "title", "xmlns"]);

  return _react2.default.createElement(
    "svg",
    _extends({}, props, { height: size, width: size, xmlns: xmlns }),
    title ? _react2.default.createElement(
      "title",
      null,
      title
    ) : null,
    children
  );
};

QRCodeSurface.propTypes = propTypes;
QRCodeSurface.defaultProps = defaultProps;

exports.default = QRCodeSurface;
});

unwrapExports(QRCodeSurface_1);

var lib = createCommonjsModule(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var _QRCode2 = _interopRequireDefault(QRCode_1);



var _ErrorCorrectLevel2 = _interopRequireDefault(ErrorCorrectLevel);



var _propTypes2 = _interopRequireDefault(PropTypes);



var _react2 = _interopRequireDefault(React__default);



var _QRCodeCell2 = _interopRequireDefault(QRCodeCell_1);



var _QRCodeSurface2 = _interopRequireDefault(QRCodeSurface_1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // A `qr.js` doesn't handle error level of zero (M) so we need to do it right, thus the deep require.


var propTypes = {
  bgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  fgColor: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
  level: _propTypes2.default.oneOf(["L", "M", "Q", "H"]),
  size: _propTypes2.default.number,
  value: _propTypes2.default.string.isRequired
};

var defaultProps = {
  bgColor: "#FFFFFF",
  fgColor: "#000000",
  level: "L",
  size: 256
};

var QRCode = function QRCode(_ref) {
  var bgColor = _ref.bgColor,
      fgColor = _ref.fgColor,
      level = _ref.level,
      size = _ref.size,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, ["bgColor", "fgColor", "level", "size", "value"]);

  // We'll use type === -1 to force QRCode to automatically pick the best type.
  var qrcode = new _QRCode2.default(-1, _ErrorCorrectLevel2.default[level]);
  qrcode.addData(value);
  qrcode.make();
  var cells = qrcode.modules;
  var tileSize = size / cells.length;
  return _react2.default.createElement(
    _QRCodeSurface2.default,
    _extends({}, props, { size: size }),
    cells.map(function (row, rowIndex) {
      return row.map(function (cell, cellIndex) {
        var transformX = Math.round(cellIndex * tileSize);
        var transformY = Math.round(rowIndex * tileSize);
        var qrItemWidth = Math.round((cellIndex + 1) * tileSize) - transformX;
        var qrItemHeight = Math.round((rowIndex + 1) * tileSize) - transformY;
        return _react2.default.createElement(_QRCodeCell2.default
        /* eslint-disable react/no-array-index-key */
        , { key: "rectangle-" + rowIndex + "-" + cellIndex
          /* eslint-enable react/no-array-index-key */
          , d: "M 0 0 L " + qrItemWidth + " 0 L " + qrItemWidth + " " + qrItemHeight + " L 0 " + qrItemHeight + " Z",
          fill: cell ? fgColor : bgColor,
          transformX: transformX,
          transformY: transformY
        });
      });
    })
  );
};

QRCode.propTypes = propTypes;
QRCode.defaultProps = defaultProps;

exports.default = (0, React__default.memo)(QRCode);
});

var QRCode = unwrapExports(lib);

function QrCodeView() {
  const value = window.Pelcro.user.read().id ? `${window.Pelcro.environment.domain}/admin/${window.Pelcro.siteid}/customers/${window.Pelcro.user.read().id}` : `${window.Pelcro.environment.domain}/admin/${window.Pelcro.siteid}/customers`;
  return /*#__PURE__*/React__default.createElement("div", {
    id: "pelcro-qrcode-view"
  }, /*#__PURE__*/React__default.createElement(QRCode, {
    style: {
      margin: "auto"
    },
    value: value
  }));
}

const QrCodeModal = _ref => {
  let {
    onDisplay,
    onClose
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Modal, {
    id: "pelcro-qrcode-create-modal",
    onDisplay: onDisplay,
    onClose: onClose
  }, /*#__PURE__*/React__default.createElement(ModalBody, null, /*#__PURE__*/React__default.createElement(QrCodeView, null)), /*#__PURE__*/React__default.createElement(ModalFooter, null, /*#__PURE__*/React__default.createElement(Authorship, null)));
};
QrCodeModal.viewId = "qrcode";

export { AddressCreateCity, AddressCreateContainer, AddressCreateCountrySelect, AddressCreateFirstName, AddressCreateLastName, AddressCreateLine1, AddressCreateLine2, AddressCreateModal, AddressCreatePostalCode, AddressCreateSetDefault, AddressCreateStateSelect, AddressCreateSubmit, AddressCreateTextInput, AddressCreateView, AddressSelectContainer, AddressSelectList, AddressSelectModal, AddressSelectSubmit, AddressSelectView, AddressUpdateCity, AddressUpdateContainer, AddressUpdateCountrySelect, AddressUpdateFirstName, AddressUpdateLastName, AddressUpdateLine1, AddressUpdateLine2, AddressUpdateModal, AddressUpdatePostalCode, AddressUpdateSetDefault, AddressUpdateStateSelect, AddressUpdateSubmit, AddressUpdateTextInput, AddressUpdateView, AlertWithContext as Alert, Alert as AlertElement, ApplePayButton, ApplyCouponButton, Auth0LoginButton, Badge, BankAuthenticationSuccess, BankRedirection, Button, CartContainer, CartModal, CartRemoveItemButton, CartSubmit, CartTotalPrice, CartView, Checkbox, CheckoutForm, ConfirmPassword, CouponCode, CouponCodeField, DashboardWithHook as Dashboard, DashboardOpenButton, DatePicker, DiscountedPrice, Email, EmailVerifyContainer, EmailVerifyModal, EmailVerifyResendButton, EmailVerifyView, FacebookLoginButton, GiftCreateContainer, GiftCreateEmail, GiftCreateFirstName, GiftCreateLastName, GiftCreateMessage, GiftCreateModal, GiftCreateStartDate, GiftCreateSubmitButton, GiftCreateView, GiftRedeemCode, GiftRedeemContainer, GiftRedeemModal, GiftRedeemSubmitButton, GiftRedeemView, GoogleLoginButton, IncludeFirstName, IncludeLastName, IncludePhone, Input, InvoiceDetailsContainer, InvoiceDetailsDownloadButton, InvoiceDetailsModal, InvoiceDetailsPayButton, InvoiceDetailsView, InvoicePaymentContainer, InvoicePaymentModal, InvoicePaymentView, Link, LoginButton, LoginContainer, LoginEmail, LoginModal, LoginPassword, LoginRequestLoginToken, LoginUsername, LoginView, Logout, MeterModal, MeterView, Modal, ModalBody, ModalFooter, NewsletterWithHook as NewsLetter, NewsletterUpdateButton, NewsletterUpdateContainer, NewsletterUpdateList, NewsletterUpdateModal, NewsletterUpdateView, Notification, OrderConfirmModal, OrderCreateContainer, OrderCreateFreeButton, OrderCreateModal, OrderCreateSubmitButton, OrderCreateView, Password, PasswordChangeButton, PasswordChangeConfirmNewPassword, PasswordChangeContainer, PasswordChangeCurrentPassword, PasswordChangeModal, PasswordChangeNewPassword, PasswordChangeView, PasswordForgotButton, PasswordForgotContainer, PasswordForgotEmail, PasswordForgotModal, PasswordForgotView, PasswordResetButton, PasswordResetConfirmPassword, PasswordResetContainer, PasswordResetEmail, PasswordResetModal, PasswordResetPassword, PasswordResetView, PasswordlessRequestContainer, PasswordlessRequestEmail, PasswordlessRequestModal, PasswordlessRequestView, PasswordlessRequestViewButton, PaymentCreateContainer, PaymentCreateView, PaymentMethodContainer, PaymentMethodCreateContainer, PaymentMethodCreateModal, PaymentMethodCreateView, PaymentMethodDeleteContainer, PaymentMethodDeleteList, PaymentMethodDeleteModal, PaymentMethodDeleteSubmit, PaymentMethodDeleteView, PaymentMethodSelectContainer, PaymentMethodSelectList, PaymentMethodSelectModal, PaymentMethodSelectSubmit, PaymentMethodSelectView, PaymentMethodUpdateContainer, PaymentMethodUpdateModal, PaymentMethodUpdateSetDefault, PaymentMethodUpdateView, PaymentMethodView, PaymentSuccessModal, PaymentSuccessView, PaypalSubscribeButton, PelcroCardCVC, PelcroCardExpiry, PelcroCardNumber, PelcroModalController, PelcroPaymentRequestButton, ProfilePicChangeButton, ProfilePicChangeContainer, ProfilePicChangeCropper, ProfilePicChangeModal, ProfilePicChangeRemoveButton, ProfilePicChangeSelectButton, ProfilePicChangeView, ProfilePicChangeZoom, QrCodeModal, QrCodeView, Radio, RegisterButton, RegisterCompany, RegisterContainer, RegisterEmail, RegisterFirstName, RegisterJobTitle, RegisterLastName, RegisterModal, RegisterPassword, RegisterView, Select, SelectModalWithHook as SelectModal, SelectedPaymentMethod, ShopPurchaseButton, ShopSelectProductButton, ShopView, SubmitPaymentMethod, SubscriptionCancelModal, SubscriptionCreateContainer, SubscriptionCreateFreePlanButton, SubscriptionCreateModal, SubscriptionCreateView, SubscriptionManageMembersButton, SubscriptionManageMembersContainer, SubscriptionManageMembersEmails, SubscriptionManageMembersList, SubscriptionManageMembersModal, SubscriptionManageMembersView, SubscriptionRenewContainer, SubscriptionRenewModal, SubscriptionRenewView, SubscriptionSuspendContainer, SubscriptionSuspendModal, SubscriptionSuspendView, TaxAmount, TextArea, Tooltip, UserNameInput, UserUpdateButton, UserUpdateContainer, UserUpdateDisplayName, UserUpdateEmail, UserUpdateFirstName, UserUpdateLastName, UserUpdateModal, UserUpdatePhone, UserUpdateProfilePic, UserUpdateTextInput, UserUpdateTin, UserUpdateUsername, UserUpdateView, VerifyLinkTokenContainer, VerifyLinkTokenLoader, VerifyLinkTokenModal, VerifyLinkTokenView, authenticatedButtons, i18next as i18n, init$1 as initButtons, init as initContentEntitlement, invoicePaymentSubmitButton, notify$1 as notify, unauthenticatedButtons, usePelcro };
